require("./main.css");
var $lR8r2$react = require("react");
var $lR8r2$materialuilabLocalizationProvider = require("@material-ui/lab/LocalizationProvider");
var $lR8r2$materialuilabAdapterMoment = require("@material-ui/lab/AdapterMoment");
var $lR8r2$materialuixgrid = require("@material-ui/x-grid");
var $lR8r2$styledcomponents = require("styled-components");
var $lR8r2$materialuicore = require("@material-ui/core");
var $lR8r2$aggridenterprise = require("ag-grid-enterprise");
var $lR8r2$gojs = require("gojs");
var $lR8r2$filesaver = require("file-saver");
var $lR8r2$axios = require("axios");
var $lR8r2$reactpapaparse = require("react-papaparse");
require("lodash");
var $lR8r2$pako = require("pako");
var $lR8r2$lodashfp = require("lodash/fp");
var $lR8r2$events = require("events");
var $lR8r2$materialuicoreRadio = require("@material-ui/core/Radio");
var $lR8r2$materialuicoreRadioGroup = require("@material-ui/core/RadioGroup");
var $lR8r2$materialuicoreFormControlLabel = require("@material-ui/core/FormControlLabel");
var $lR8r2$materialuicoreCheckbox = require("@material-ui/core/Checkbox");
var $lR8r2$materialuicoreListItemIcon = require("@material-ui/core/ListItemIcon");
var $lR8r2$materialuicoreListItemText = require("@material-ui/core/ListItemText");
var $lR8r2$materialuicoreMenuItem = require("@material-ui/core/MenuItem");
require("@material-ui/core/InputLabel");
var $lR8r2$materialuicoreFormControl = require("@material-ui/core/FormControl");
var $lR8r2$materialuicoreSelect = require("@material-ui/core/Select");
var $lR8r2$materialuistyles = require("@material-ui/styles");
var $lR8r2$aggridreact = require("ag-grid-react");
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community");
var $lR8r2$highchartsreactofficial = require("highcharts-react-official");
var $lR8r2$highchartshighstock = require("highcharts/highstock");
var $lR8r2$highchartsmodulesexporting = require("highcharts/modules/exporting");
var $lR8r2$highchartsmodulesexportdata = require("highcharts/modules/export-data");
var $lR8r2$highcharts = require("highcharts");
var $lR8r2$highchartsmoduleshistogrambellcurve = require("highcharts/modules/histogram-bellcurve");
var $lR8r2$highchartsmodulesnodatatodisplay = require("highcharts/modules/no-data-to-display");
var $lR8r2$materialuiicons = require("@material-ui/icons");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
var $lR8r2$moment = require("moment");
var $lR8r2$materialuilab = require("@material-ui/lab");
var $lR8r2$tinycolor2 = require("tinycolor2");
var $lR8r2$materialuicoreBox = require("@material-ui/core/Box");
var $lR8r2$materialuicoreStepper = require("@material-ui/core/Stepper");
var $lR8r2$materialuicoreStep = require("@material-ui/core/Step");
var $lR8r2$materialuicoreStepLabel = require("@material-ui/core/StepLabel");
var $lR8r2$materialuicoreButton = require("@material-ui/core/Button");
var $lR8r2$materialuicoreTextareaAutosize = require("@material-ui/core/TextareaAutosize");
var $lR8r2$materialuicoreTextField = require("@material-ui/core/TextField");
var $lR8r2$buffer = require("buffer");
var $lR8r2$uuid = require("uuid");
var $lR8r2$materialuicoreAutocomplete = require("@material-ui/core/Autocomplete");
var $lR8r2$reactsplit = require("react-split");
var $lR8r2$reacticons = require("react-icons");
var $lR8r2$materialuicoreFab = require("@material-ui/core/Fab");
var $lR8r2$reacticonsmd = require("react-icons/md");
var $lR8r2$materialuicoreTooltip = require("@material-ui/core/Tooltip");
var $lR8r2$materialuicoreCircularProgress = require("@material-ui/core/CircularProgress");
var $lR8r2$materialuicoreTypography = require("@material-ui/core/Typography");
var $lR8r2$reactcolorlibcomponentscommon = require("react-color/lib/components/common");
var $lR8r2$reactspinnersGridLoader = require("react-spinners/GridLoader");
var $lR8r2$materialuicoreIconButton = require("@material-ui/core/IconButton");
var $lR8r2$reacticonsbs = require("react-icons/bs");
var $lR8r2$reacticonsri = require("react-icons/ri");
var $lR8r2$reacticonsgi = require("react-icons/gi");

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "MetricusContainer", () => $0e4df6cdcd965f9e$export$58d85c1084ae5c46);






const $d18c0fc16613166e$export$bca14c5b3b88a9c9 = {
    colors: {
        blue: "#187bcd",
        lightBlue: "#2a9df4",
        lightestBlue: "#89c5f1",
        green: "#4CAF50",
        lightGreen: "#8BC34A",
        lightestGreen: "#c8e6c9",
        gray: "#9E9E9E",
        grayWithOpacity: "rgba(158,158,158,0.5)",
        lightGray: "#e0e0e0",
        lightestGray: "#eeeeee",
        red: "#F44336",
        brown: "#795548",
        lightAmber: "#F2E0C8",
        topBar: "#F4F4F4",
        white: "#FFFFFF",
        darkerWhite: "#FBFBFB",
        black: "#000000",
        scrollBar: "#A4A4A4",
        darkGray: "#979797",
        borderColor: "#E9ECEF",
        darkFontColor: "#212529",
        lightBorderColor: "#BECAD6",
        inputTextColor: "#495057",
        lightFontColor: "#5a6169",
        // BELOW COLORS ARE USED TO MODIFY GOOGLE CHARTS
        gridline: "#8d9aa9",
        bar: "#0679f6",
        chartLabel: "#a4a4a4"
    },
    fontWeight: {
        normal: 400,
        bold: 700
    },
    fontFamily: {
        helvetica: "Helvetica",
        lato: "Lato, sans-serif"
    },
    fontSize: {
        tiny: "9px",
        smallest: "10px",
        tablecell: "11px",
        smaller: "12px",
        small: "14px",
        normal: "16px",
        big: "18px"
    },
    lineHeight: {
        smaller: "11px",
        small: "17px",
        normal: "24px"
    },
    letterSpacing: {
        sliderLabel: "-0.09px",
        input: "-0.28px",
        small: "0",
        normal: "0.15px"
    },
    shadows: {
        panel: "0px 6px 14px 8px rgba(0, 0, 0, 0.07)",
        pane: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        rail: "inset 0 1px 2px 0 rgba(90,97,105,0.1)",
        thumb: "0 2px 3px 0 rgba(90,97,105,0.2),0 3px 15px 0 rgba(90,97,105,0.1)",
        hover: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
        slider: "0 0 1px 0 rgba(0,0,0,0.5)",
        menu: "0 2px 4px 0 rgba(0,0,0,0.1)",
        tooltip: "0px 0px 14px rgba(0,0,0,0.29)",
        tab: "5px 0 5px 0 rgba(0, 0, 0, 0.07)"
    },
    zIndex: {
        topBar: 2,
        diagram: 1,
        panel: 6,
        contextMenu: 50,
        modal: 100,
        tab: 5,
        activeTab: 7
    },
    height: {
        topBar: 85,
        colorPicker: 293,
        timelineChart: "70vh",
        contextMenuOption: 24
    },
    width: {
        colorPicker: 220,
        tab: 50
    }
};
const $d18c0fc16613166e$export$8992ead9d60b4095 = (namespace)=>(key)=>({ theme: providedTheme  })=>providedTheme[namespace][key];
const $d18c0fc16613166e$export$5551a2d24ff40153 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("colors")(key);
const $d18c0fc16613166e$export$c4930fc256cef44f = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("fontFamily")(key);
const $d18c0fc16613166e$export$16eeca46eca75f64 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("fontWeight")(key);
const $d18c0fc16613166e$export$7d055c252aebca58 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("fontSize")(key);
const $d18c0fc16613166e$export$56204a27a2958a55 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("lineHeight")(key);
const $d18c0fc16613166e$export$56328feeb2119780 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("letterSpacing")(key);
const $d18c0fc16613166e$export$db93b77dbb14f011 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("shadows")(key);
const $d18c0fc16613166e$export$9b544f58430fc883 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("zIndex")(key);
const $d18c0fc16613166e$export$c08559766941f856 = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("height")(key);
const $d18c0fc16613166e$export$3c49c185de0c2bfc = (key)=>$d18c0fc16613166e$export$8992ead9d60b4095("width")(key);



const $ff0a9db95266b69c$export$59987a00ce8ae969 = (0, $lR8r2$styledcomponents.createGlobalStyle)`

    .ag-theme-balham .ag-row-selected {
        background-color: #F7D569;
    }

    .ag-theme-balham .ag-header-cell {
        background-color: #197BCD;
        color: white;
    }

    .ag-theme-balham .ag-row {
        border-width: 0.1px !important;
    }

    .ag-theme-balham .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
        background-color: #F7D569;
    }

    .ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
        border-left-color: #F7D569;
    }

    .ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
        border-right-color: #F7D569;
    }

    .ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
        border-top-color: #F7D569;
    }

    .ag-theme-balham .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
        border-bottom-color: #F7D569;
    }

    .ag-header-cell-text {
        white-space: normal;
    }
   
    img  {
        max-width: 100%;
        height: auto;
    }

`;


const $f0bb0c8f14b77164$var$GlobalStyles = (0, $lR8r2$styledcomponents.createGlobalStyle)`
    @keyframes spinner-line-fade-more {
        0%, 100% {
            opacity: 0; /* minimum opacity */
        }
        1% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-fade-quick {
        0%, 39%, 100% {
            opacity: 0.25; /* minimum opacity */
        }
        40% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-fade-default {
        0%, 100% {
            opacity: 0.22; /* minimum opacity */
        }
        1% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-shrink {
        0%, 25%, 100% {
            /* minimum scale and opacity */
            transform: scale(0.5);
            opacity: 0.25;
        }
        26% {
            transform: scale(1);
            opacity: 1;
        }
    }

    * {
        box-sizing: border-box;

        scrollbar-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 8px;
            height: 6px;
            margin-left: 5px;
            background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
            border-radius: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("scrollBar")};
            border-radius: 6px;
        }
    }

    html {
        height: 100%;
    }

    body {
        margin: 0;
        overflow: hidden;
    }

    .google-visualization-tooltip {
        display: none;
    }

    .google-visualization-tooltip-portal {
        position: absolute;
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        z-index: 999;
    }

    .google-visualization-tooltip, .google-visualization-tooltip-portal {
        border-radius: 8px !important;
        box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("tooltip")} !important;
        border: none !important;
        padding: 5px !important;
        height: auto !important;
        pointer-events: none;

        & p {
            margin: 5px 0;
            font-size: 11px;
        }
    }

    .hide-rects rect {
        fill: transparent !important;
    }

    [role="button"]:focus {
        outline: none !important;
    }
`;
const $f0bb0c8f14b77164$export$d8964aec282183a3 = ({ children: children  })=>/*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$styledcomponents.ThemeProvider), {
        theme: (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9)
    }, /*#__PURE__*/ $lR8r2$react.createElement($f0bb0c8f14b77164$var$GlobalStyles, null), /*#__PURE__*/ $lR8r2$react.createElement((0, $ff0a9db95266b69c$export$59987a00ce8ae969), null), children);




const $975fb6aa99889f1d$var$theme = (0, $lR8r2$materialuicore.createTheme)({
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true
            }
        }
    }
});
const $975fb6aa99889f1d$export$ec1233a4138aa651 = ({ children: children  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.ThemeProvider), {
        theme: $975fb6aa99889f1d$var$theme
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.StyledEngineProvider), {
        injectFirst: true
    }, children));



const $d86a247d67d6d1e1$export$cfac98503b32f6d6 = /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createContext(null);
const $d86a247d67d6d1e1$export$a64bcbaadc0edfa9 = ({ children: children  })=>{
    const [props, setProps] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        show: false,
        color: "#ffffff",
        x: 0,
        y: 0,
        id: ""
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d86a247d67d6d1e1$export$cfac98503b32f6d6.Provider, {
        value: {
            props: props,
            setProps: setProps
        }
    }, children);
};



const $5613d3e2f55e099d$export$6084d5b08fe90059 = /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createContext(null);
const $5613d3e2f55e099d$export$8b8375aa394c2d86 = ({ children: children  })=>{
    const [props, setProps] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        functionToLoad: null
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5613d3e2f55e099d$export$6084d5b08fe90059.Provider, {
        value: {
            props: props,
            setProps: setProps
        }
    }, children);
};






const $697e7e8f9c39c44e$export$bab68a8260c0354 = (diagram, { color: color , leader: leader  })=>{
    const prevSkips = diagram.skipsUndoManager;
    const prevIsOngoing = diagram.layout.isOngoing;
    diagram.skipsUndoManager = true;
    diagram.layout.isOngoing = false;
    diagram.model.addNodeDataCollection([
        {
            category: "token",
            at: 0,
            frac: 0.0,
            color: color,
            leader: leader
        }, 
    ]);
    diagram.skipsUndoManager = prevSkips;
    diagram.layout.isOngoing = prevIsOngoing;
};
const $697e7e8f9c39c44e$export$4f1f8da95a8f66ea = (diagram, part)=>{
    const prevIsOngoing = diagram.layout.isOngoing;
    diagram.layout.isOngoing = false;
    diagram.remove(part);
    diagram.layout.isOngoing = prevIsOngoing;
};





const $d9c1e38a17aaf685$export$67e8a86e59c99895 = (diagram, link)=>{
    const from = diagram.findNodeForKey(link.from);
    const to = diagram.findNodeForKey(link.to);
    return from.findLinksTo(to).first();
};


const $2e1a2e43b677f74f$export$1417a8a50d3849fe = 8;
const $2e1a2e43b677f74f$export$1c3961428093720b = 2;
const $2e1a2e43b677f74f$export$205ea73fe329ae80 = 20;


const $e7252d61553222a3$export$322e59c09498f812 = (newTokensShowingPoints, links, diagram, color)=>{
    const prevSkips = diagram.skipsUndoManager;
    diagram.skipsUndoManager = true;
    diagram.parts.each((part)=>{
        const newData = $lR8r2$lodashfp.cloneDeep(part.data);
        if (part.category !== "token") return;
        if (newData.at === links.length) {
            (0, $697e7e8f9c39c44e$export$bab68a8260c0354)(diagram, {
                color: color,
                leader: newData.leader
            });
            (0, $697e7e8f9c39c44e$export$4f1f8da95a8f66ea)(diagram, part);
            return;
        }
        const link = (0, $d9c1e38a17aaf685$export$67e8a86e59c99895)(diagram, links[newData.at]);
        part.location = link.path.getDocumentPoint(link.path.geometry.getPointAlongPath(newData.frac, new $lR8r2$gojs.Point()));
        const step = (0, $2e1a2e43b677f74f$export$1c3961428093720b) * (1 / links[newData.at].length);
        newData.at = newData.frac >= 1.0 ? newData.at + 1 : newData.at;
        newData.frac = newData.frac >= 1.0 ? 0 : Math.min(1.0, newData.frac + step);
        if (part.data.leader) {
            const passedPoint = $lR8r2$lodashfp.some(({ frac: frac  })=>frac < newData.at + newData.frac && frac > part.data.at + part.data.frac)(newTokensShowingPoints);
            if (passedPoint) (0, $697e7e8f9c39c44e$export$bab68a8260c0354)(diagram, {
                color: color,
                leader: false
            });
        }
        part.data = newData;
    });
    diagram.skipsUndoManager = prevSkips;
};




const $2b903f5087d8153b$export$908c131bb03d5a3 = (links)=>{
    const pathLength = $lR8r2$lodashfp.sumBy("length")(links);
    const breaks = Math.max(pathLength / (0, $2e1a2e43b677f74f$export$1417a8a50d3849fe), (0, $2e1a2e43b677f74f$export$205ea73fe329ae80));
    let newPoints = [
        {
            distance: 0,
            frac: 0
        }
    ];
    links.map(({ length: length  })=>length).reduce((sum, newLength, idx)=>{
        if (sum + newLength >= $lR8r2$lodashfp.last(newPoints).distance) {
            const pointsToCreate = Math.floor((sum + newLength) / breaks) - newPoints.length + 1;
            $lR8r2$lodashfp.forEach(()=>{
                const lastPoint = $lR8r2$lodashfp.last(newPoints);
                newPoints = [
                    ...newPoints,
                    {
                        frac: idx + (lastPoint.distance + breaks - sum) / newLength,
                        distance: lastPoint.distance + breaks
                    }, 
                ];
            })($lR8r2$lodashfp.range(0, pointsToCreate));
        }
        return sum + newLength;
    }, 0);
    return $lR8r2$lodashfp.initial($lR8r2$lodashfp.tail(newPoints));
};




const $d5fcec83b5588ce7$export$21d62360a3cd9ef7 = $lR8r2$lodashfp.curry((diagram, links)=>$lR8r2$lodashfp.map((link)=>{
        const gojsLink = (0, $d9c1e38a17aaf685$export$67e8a86e59c99895)(diagram, link);
        const pathElement = document.createElementNS("http://www.w3.org/2000/svg", "path");
        pathElement.setAttribute("d", gojsLink.path.geometryString);
        return {
            ...link,
            length: pathElement.getTotalLength()
        };
    })(links));


let $3a3e0c61bb1fdb8e$var$newTokensShowingPoints = [];
let $3a3e0c61bb1fdb8e$var$linksWithLength = [];
let $3a3e0c61bb1fdb8e$var$request;
const $3a3e0c61bb1fdb8e$export$40092911b12b82d6 = (diagram)=>{
    window.cancelAnimationFrame($3a3e0c61bb1fdb8e$var$request);
    $3a3e0c61bb1fdb8e$var$newTokensShowingPoints = [];
    $3a3e0c61bb1fdb8e$var$linksWithLength = [];
    diagram.parts.each((part)=>{
        if (part.category === "token") (0, $697e7e8f9c39c44e$export$4f1f8da95a8f66ea)(diagram, part);
    });
};
const $3a3e0c61bb1fdb8e$var$loop = (diagram, color)=>{
    (0, $e7252d61553222a3$export$322e59c09498f812)($3a3e0c61bb1fdb8e$var$newTokensShowingPoints, $3a3e0c61bb1fdb8e$var$linksWithLength, diagram, color);
    $3a3e0c61bb1fdb8e$var$request = window.requestAnimationFrame(()=>$3a3e0c61bb1fdb8e$var$loop(diagram, color));
};
const $3a3e0c61bb1fdb8e$export$35046beef9a65b5f = (linksArray, diagram, color)=>{
    (0, $697e7e8f9c39c44e$export$bab68a8260c0354)(diagram, {
        color: color,
        leader: true
    });
    $3a3e0c61bb1fdb8e$var$request = window.requestAnimationFrame(()=>{
        $3a3e0c61bb1fdb8e$var$linksWithLength = (0, $d5fcec83b5588ce7$export$21d62360a3cd9ef7)(diagram, linksArray);
        $3a3e0c61bb1fdb8e$var$newTokensShowingPoints = (0, $2b903f5087d8153b$export$908c131bb03d5a3)($3a3e0c61bb1fdb8e$var$linksWithLength);
        $3a3e0c61bb1fdb8e$var$loop(diagram, color);
    });
};



const $48e9aeeeef1ff0fd$export$4925121cdc737410 = ({ highlightLoops: highlightLoops , highlightNonCompliance: highlightNonCompliance , highlightAutomation: highlightAutomation , stepColourVolume: stepColourVolume , stepColourDuration: stepColourDuration , stepColourStdDeviation: stepColourStdDeviation , stepColourCost: stepColourCost  })=>{
    (0, $57e66c5a34f265b4$export$582db8b37b8d76e2)({
        highlightLoops: highlightLoops,
        highlightNonCompliance: highlightNonCompliance,
        highlightAutomation: highlightAutomation,
        stepColourVolume: stepColourVolume,
        stepColourDuration: stepColourDuration,
        stepColourStdDeviation: stepColourStdDeviation,
        stepColourCost: stepColourCost
    });
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("updateDiagramHighlight");
};
const $48e9aeeeef1ff0fd$export$fc8f758be6991169 = ()=>(0, $57e66c5a34f265b4$export$6276205a8eb27fa9)();


let $4700b7448b206a95$export$d61e24a684f9e51;
(function(Event) {
    Event["updateGaugeMetrics"] = "updateGaugeMetrics";
    Event["updateDurationColumns"] = "updateDurationColumns";
    Event["updateVariantsGrid"] = "updateVariantsGrid";
    Event["updateStepSlicerVariantChart"] = "updateStepSlicerVariantChart";
    Event["updatePathSlicerVariantChart"] = "updatePathSlicerVariantChart";
    Event["updateVariantSlicerVariantChart"] = "updateVariantSlicerVariantChart";
    Event["updateActivitySlicerVariantChart"] = "updateActivitySlicerVariantChart";
    Event["StepVisualGridUpdate"] = "StepVisualGridUpdate";
    Event["VariantVisualGridUpdate"] = "VariantVisualGridUpdate";
    Event["ActivitiesVisualGridUpdate"] = "ActivitiesVisualGridUpdate";
    Event["updateDataTransformation"] = "updateDataTransformation";
    Event["openSettings"] = "openSettings";
    Event["openAnalytics"] = "openAnalytics";
    Event["setActionBar_DecompositionTree"] = "setActionBar_DecompositionTree";
    Event["setActionBar_ProcessVisualizer"] = "setActionBar_ProcessVisualizer";
    Event["setActionBar_Insights"] = "setActionBar_Insights";
    Event["setActionBar_InfluenceAnalysis"] = "setActionBar_InfluenceAnalysis";
    Event["setActionBar_Detail"] = "setActionBar_Detail";
    Event["setActionBar_PerformanceAnalytics"] = "setActionBar_PerformanceAnalytics";
    Event["setActionBar_CostRules"] = "setActionBar_CostRules";
    Event["setActionBar_ProcessRules"] = "setActionBar_ProcessRules";
    Event["setActionBar_VariantLifeCycle"] = "setActionBar_VariantLifeCycle";
    Event["setActionBar_TaskLifeCycle"] = "setActionBar_TaskLifeCycle";
    Event["setActionBar_Histogram"] = "setActionBar_Histogram";
    Event["setDiagramWidth"] = "setDiagramWidth";
    Event["complianceDialogAlert"] = "complianceDialogAlert";
    Event["updateVariantLifecycle"] = "updateVariantLifecycle";
    Event["updateTaskLifeCycle"] = "updateTaskLifeCycle";
    Event["updateTaskHistogram"] = "updateTaskHistogram";
    Event["updateTasksSlicerVariablesLimits"] = "updateTasksSlicerVariablesLimits";
    Event["resetTasksFilter"] = "resetTasksFilter";
    Event["resetTimeFilter"] = "resetTimeFilter";
    Event["resetAttributeFilter"] = "resetAttributeFilter";
    Event["visualizerSettingsAlert"] = "visualizerSettingsAlert";
    Event["loadVisualizerSettings"] = "loadVisualizerSettings";
    Event["resetVisualizerSettings"] = "resetVisualizerSettings";
    Event["applySlicer"] = "applySlicer";
    Event["applySlicerContext"] = "applySlicerContext";
    Event["applyFilter"] = "applyFilter";
    Event["filterIconActive"] = "filterIconActive";
    Event["sliceIconActive"] = "sliceIconActive";
    Event["resetIcons"] = "resetIcons";
    Event["resetEventLog"] = "resetEventLog";
    Event["resetSlicer"] = "resetSlicer";
    Event["resetFilter"] = "resetFilter";
    Event["updateCompliance"] = "updateCompliance";
    Event["saveCompliance"] = "saveCompliance";
    Event["resetComments"] = "resetComments";
    Event["updateComments"] = "updateComments";
    Event["updateCost"] = "updateCost";
    Event["updatePerformance"] = "updatePerformance";
    Event["updateAutomation"] = "updateAutomation";
    Event["saveCost"] = "saveCost";
    Event["updateTasks"] = "updateTasks";
    Event["updateEvents"] = "updateEvents";
    Event["updateFilterAttributes"] = "updateFilterAttributes";
    Event["updateEventDetail"] = "updateEventDetail";
    Event["updateTaskDetail"] = "updateTaskDetail";
    Event["setDetailTab"] = "setDetailTab";
    Event["setPerformanceAnalyticsTab"] = "setPerformanceAnalyticsTab";
    Event["updateDetailVisuals"] = "updateDetailVisuals";
    Event["showContextMenu"] = "showContextMenu";
    Event["hideContextMenu"] = "hideContextMenu";
    Event["openActivityCostModal"] = "openActivityCostModal";
    Event["openStepCostModal"] = "openStepCostModal";
    Event["openStepComplianceModal"] = "openStepComplianceModal";
    Event["openStepPerformanceModal"] = "openStepPerformanceModal";
    Event["openStepAutomationModal"] = "openStepAutomationModal";
    Event["openStepCommentsModal"] = "openStepCommentsModal";
    Event["openActivityComplianceModal"] = "openActivityComplianceModal";
    Event["openActivityAutomationModal"] = "openActivityAutomationModal";
    Event["openActivityCommentsModal"] = "openActivityCommentsModal";
    Event["openActivityStepAnalysisModal"] = "openActivityStepAnalysisModal";
    Event["changeActivePane"] = "changeActivePane";
    Event["resizeSidebar"] = "resizeSidebar";
    Event["updateTaskAttributes"] = "updateTaskAttributes";
    Event["updateEventAttributes"] = "updateEventAttributes";
    Event["updateCurrentFilters"] = "updateCurrentFilters";
    Event["automationRulesAlert"] = "automationRulesAlert";
    Event["performanceRulesAlert"] = "performanceRulesAlert";
    Event["costRulesAlert"] = "costRulesAlert";
    Event["complianceRulesAlert"] = "complianceRulesAlert";
    Event["variantSlicerAlert"] = "variantSlicerAlert";
    Event["pathSlicerAlert"] = "pathSlicerAlert";
    Event["stepSlicerAlert"] = "stepSlicerAlert";
    Event["activitySlicerAlert"] = "activitySlicerAlert";
    Event["updateMetricSettings"] = "updateMetricSettings";
    Event["dataImportComplete"] = "dataImportComplete";
    Event["importRules"] = "importRules";
    Event["uploadFileAlert"] = "uploadFileAlert";
    Event["changeVisualizerBackgroundColor"] = "changeVisualizerBackgroundColor";
    Event["changeAnalyticsMode"] = "changeAnalyticsMode";
    Event["setSlicerExpanded"] = "setSlicerExpanded";
    Event["setFilterExpanded"] = "setFilterExpanded";
    Event["setVariantPane"] = "SetVariantPane";
    Event["displayProcessVisualizer"] = "displayProcessVisualizer";
    Event["applyInsightsMetricFilter"] = "applyInsightsMetricFilter";
    Event["applyDecompositionTreeMetricFilter"] = "applyDecompositionTreeMetricFilter";
    Event["applyInfluenceAnalysisMetricFilter"] = "applyInfluenceAnalysisMetricFilter";
    Event["setDiagramDecompositionTree"] = "setDiagramDecompositionTree";
    Event["setDiagramInfluenceAnalysis"] = "setDiagramInfluenceAnalysis";
    Event["setDiagramInsights"] = "setDiagramInsights";
    Event["changeHighlight"] = "changeHighlight";
    Event["changeStepColour"] = "changeStepColour";
    Event["updateGaugeCompliance"] = "updateGaugeCompliance";
    Event["updateGaugeAutomation"] = "updateGaugeAutomation";
    Event["updateGaugePerformance"] = "updateGaugePerformance";
    Event["updateGaugeCost"] = "updateGaugeCost";
    Event["updateHistogram"] = "updateHistogram";
    Event["updateLoadingStatus"] = "updateLoadingStatus";
})($4700b7448b206a95$export$d61e24a684f9e51 || ($4700b7448b206a95$export$d61e24a684f9e51 = {}));


const $aecab291b608cebe$export$24e90a7f4e401128 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
};




const $00c859d90ab8eb90$export$72b11836dae7a069 = ({ pane: pane , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$eaaa0335bea12670)(pane); // updates the condition array used to display active slicers
    (0, $57e66c5a34f265b4$export$dd3986409eddbcdc)(pane); // updates gVariantArray, removing variants that do not meet slicer condition
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer) // updates variant grid
    ;
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).sliceIconActive);
};



const $8d0feb082b641fa1$export$7e15445a09500fa0 = ({ eventEmitter: eventEmitter , activePane: activePane  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail);
};



const $b70023f2441d4f07$export$33d15ee0e1e0ff27 = ({ eventEmitter: eventEmitter , activePane: activePane  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail);
};




const $8b3a953f334c1c39$export$88d9d129a5d66a46 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance);
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};




const $25932cd9e0940c69$export$4ca2e78d5d0601b1 = ({ eventEmitter: eventEmitter  })=>{
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};




const $1b359944329d2411$export$c53eb01533dfe42d = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost);
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};



const $ee9d85e7e6e93318$export$c2ca0ce95834e88b = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateLoadingStatus);
};




const $27da566ba975f5d5$export$d9025152d14cd3b = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updatePerformance);
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};



const $8d2dbf50e6cfba57$export$2f7e4fbf4e0dafbf = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateComments);
};




const $99061afdb4accbec$export$77472d31d2b1bbaf = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation);
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};



const $991b261412ea11a7$export$492241ebb0cf08ee = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};



const $1caefedac34ca9dc$export$c0abe4076afdf7bd = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};



const $73069f16c491914f$export$88a8e14f5b48311 = ({ message: message , severity: severity , showAlert: showAlert , timeOutActive: timeOutActive , component: component , eventEmitter: eventEmitter  })=>{
    if (component === "automation_rules") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).automationRulesAlert, message, severity, showAlert, timeOutActive);
    if (component === "cost_rules") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).costRulesAlert, message, severity, showAlert, timeOutActive);
    if (component === "compliance_rules") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).complianceRulesAlert, message, severity, showAlert, timeOutActive);
    if (component === "variant_slicer") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).variantSlicerAlert, message, severity, showAlert, timeOutActive);
    if (component === "settings_visualizer") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).visualizerSettingsAlert, message, severity, showAlert, timeOutActive);
    if (component === "upload_file") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).uploadFileAlert, message, severity, showAlert, timeOutActive);
};


const $73396f25d03f3d4e$export$68b36b6fd6d0f5b2 = ({ eventEmitter: eventEmitter  })=>{
/*
    resetFiltersDiagram('reset Filters API - DataImportComplete'); // resets the filter active variables
    const values = resetTimeFilterDefaults();
    const resetValues = resetTaskFilterDefaults();
    eventEmitter.emit(Event.resetSlicer);
    eventEmitter.emit(Event.resetFilter);
    eventEmitter.emit(Event.resetTimeFilter, values);
    eventEmitter.emit(Event.resetTasksFilter, resetValues);
    eventEmitter.emit(Event.applySlicer);
    */ };



const $d2f53bbeaa179f7b$export$75243dbf83fd9c73 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
};



const $1b66a047d967ee84$export$8a2275d15ee60ada = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).sliceIconActive);
};


const $023544c78e6edd5b$export$354780eb60e1ec23 = (diagram, handler, afterComplete = false)=>{
    const prevCanStart = diagram.animationManager.canStart;
    diagram.animationManager.canStart = (reason)=>reason !== "Layout";
    afterComplete || handler();
    const callback = ()=>{
        afterComplete && handler();
        diagram.animationManager.canStart = prevCanStart;
    };
    const eventHandler = ()=>{
        callback();
        diagram.removeDiagramListener("LayoutCompleted", eventHandler);
    };
    diagram.addDiagramListener("LayoutCompleted", eventHandler);
};



let $f199f4f4b1b09c24$export$5b90c5799027cc4e;
(function(SidebarTab) {
    SidebarTab["variantsTab"] = "Variants";
    SidebarTab["slicersTab"] = "Slicers";
    SidebarTab["filtersTab"] = "Filters";
    SidebarTab["detailTab"] = "Detail";
    SidebarTab["modelTab"] = "Model";
    SidebarTab["eventLogTab"] = "EventLog";
    SidebarTab["settingsTab"] = "Settings";
})($f199f4f4b1b09c24$export$5b90c5799027cc4e || ($f199f4f4b1b09c24$export$5b90c5799027cc4e = {}));
const $f199f4f4b1b09c24$export$f2701d7fe1f1d354 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$5b90c5799027cc4e);
let $f199f4f4b1b09c24$export$47a0b59d2868122d;
(function(ActivityTableLabel) {
    ActivityTableLabel["Activity"] = "Activity";
})($f199f4f4b1b09c24$export$47a0b59d2868122d || ($f199f4f4b1b09c24$export$47a0b59d2868122d = {}));
const $f199f4f4b1b09c24$export$59689a65254fe3f1 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$47a0b59d2868122d);
let $f199f4f4b1b09c24$export$a84f8b424190b1ea;
(function(ShowLabel) {
    ShowLabel["loops"] = "Loops";
    ShowLabel["compliant"] = "Compliant";
})($f199f4f4b1b09c24$export$a84f8b424190b1ea || ($f199f4f4b1b09c24$export$a84f8b424190b1ea = {}));
const $f199f4f4b1b09c24$export$9e8b2d9b99340fc9 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$a84f8b424190b1ea);
let $f199f4f4b1b09c24$export$5156f2d43448301a;
(function(TableLabel) {
    TableLabel["from_activity"] = "From Activity";
    TableLabel["to_activity"] = "To Activity";
    TableLabel["tasks"] = "Tasks";
    TableLabel["avg_duration"] = "Avg Duration";
    TableLabel["std_deviation"] = "Std Deviation";
    TableLabel["loop"] = "Loop";
    TableLabel["compliant"] = "Compliant";
})($f199f4f4b1b09c24$export$5156f2d43448301a || ($f199f4f4b1b09c24$export$5156f2d43448301a = {}));
const $f199f4f4b1b09c24$export$553e0848d93d1284 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$5156f2d43448301a);
let $f199f4f4b1b09c24$export$e1a8c8d1403e2830;
(function(AttributeTableLabel) {
    AttributeTableLabel["value"] = "Value";
    AttributeTableLabel["tasks"] = "Tasks";
    AttributeTableLabel["perc_total"] = "% Total";
})($f199f4f4b1b09c24$export$e1a8c8d1403e2830 || ($f199f4f4b1b09c24$export$e1a8c8d1403e2830 = {}));
const $f199f4f4b1b09c24$export$8789ad195557dcca = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$e1a8c8d1403e2830);
let $f199f4f4b1b09c24$export$7f57ba2f83aebee6;
(function(ResourceTableLabel) {
    ResourceTableLabel["resource"] = "Resource";
    ResourceTableLabel["tasks"] = "Tasks";
    ResourceTableLabel["avgDuration"] = "Avg Duration";
})($f199f4f4b1b09c24$export$7f57ba2f83aebee6 || ($f199f4f4b1b09c24$export$7f57ba2f83aebee6 = {}));
const $f199f4f4b1b09c24$export$bc655cdb83d74413 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$7f57ba2f83aebee6);
let $f199f4f4b1b09c24$export$d7beb028f985d3b0;
(function(SpGaugeLabel) {
    SpGaugeLabel["step"] = "Step";
    SpGaugeLabel["task"] = "Task";
    SpGaugeLabel["variant"] = "Variant";
})($f199f4f4b1b09c24$export$d7beb028f985d3b0 || ($f199f4f4b1b09c24$export$d7beb028f985d3b0 = {}));
const $f199f4f4b1b09c24$export$439eb3f2589937d7 = $lR8r2$lodashfp.values($f199f4f4b1b09c24$export$d7beb028f985d3b0);




const $a88d26ee1331adae$export$565dd6bf3240914a = ({ eventEmitter: eventEmitter , x: x , y: y , options: options  })=>{
    if (!eventEmitter) eventEmitter = (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)();
     // seems to be a bug with passing the eventemitter from context menus?
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).showContextMenu, {
        x: x,
        y: y,
        options: options
    });
};
const $a88d26ee1331adae$export$a70b79ee19e88cfe = ({ eventEmitter: eventEmitter  })=>{
    if (!eventEmitter) eventEmitter = (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).hideContextMenu);
};




const $b66f0c13307de446$export$5d3a507e32e0a59b = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepCostModal, {
        data: data
    });
};




const $d2cffb3e3e561271$export$b8eacc044a97fdf9 = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepAutomationModal, {
        data: data
    });
};




const $2e988fe81abc0213$export$26b82a75aae6bfed = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepComplianceModal, {
        data: data
    });
};




const $1200978695fc35a8$export$9c10e13e2df2501e = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepPerformanceModal, {
        data: data
    });
};




const $36137601356fae9a$export$47f0c77b95671aeb = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openActivityCommentsModal, {
        data: data
    });
};




const $3963ce130f59481d$export$22b641de72ccf547 = ({ data: data  })=>{
    let eventEmitter = (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openActivityStepAnalysisModal, {
        data: data
    });
};




const $3c999e7965156ff8$export$c30d13083a8bce5d = ({ data: data  })=>{
    (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)().emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepCommentsModal, {
        data: data
    });
};




const $2943124c9da1a68a$export$27ecb0c54ca94007 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("decomposition_tree");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_DecompositionTree);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramWidth);
};




const $6618f47ab26c0e61$export$4410bdeeb8d80944 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("insights");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Insights);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramWidth);
};




const $298c7561664e4490$export$ade6891da9d6ea5c = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("influence_analysis");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_InfluenceAnalysis);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramWidth);
};




const $4418db1243d61fd1$export$17b3808e0ffc259c = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("process_visualizer");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessVisualizer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramWidth);
};




const $7a9d81ef95270803$export$2c7243b488bf9a8f = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("task_lifecycle");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_TaskLifeCycle);
};




const $d3bbc7b58d319491$export$4be85c05a5dbddd8 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)("histogram");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Histogram);
};



class $4d109d655b676189$export$1e91461216c4f1a2 extends $lR8r2$gojs.LinkReshapingTool {
    constructor(){
        super(...arguments);
        this._originalCurviness = NaN;
    }
    /**
     * @hidden @internal
     */ makeAdornment(pathshape) {
        const link = pathshape.part;
        if (link !== null && link.curve === $lR8r2$gojs.Link.Bezier && (link.pointsCount - 1) % 3 === 0) {
            const adornment = new $lR8r2$gojs.Adornment();
            adornment.type = $lR8r2$gojs.Panel.Link;
            const h = this.makeHandle(pathshape, 0);
            this.setReshapingBehavior(h, $lR8r2$gojs.LinkReshapingTool.All);
            h.cursor = "move";
            adornment.add(h);
            adornment.category = this.name;
            adornment.adornedObject = pathshape;
            return adornment;
        } else return super.makeAdornment(pathshape);
    }
    /**
     * Start reshaping, if {@link #findToolHandleAt} finds a reshape handle at the mouse down point.
     *
     * If successful this sets {@link #handle} to be the reshape handle that it finds
     * and {@link #adornedLink} to be the {@link Link} being routed.
     * It also remembers the original link route (a list of Points) and curviness in case this tool is cancelled.
     * And it starts a transaction.
     */ doActivate() {
        super.doActivate();
        if (this.adornedLink !== null) this._originalCurviness = this.adornedLink.curviness;
    }
    /**
     * Restore the link route to be the original points and curviness and stop this tool.
     */ doCancel() {
        if (this.adornedLink !== null) this.adornedLink.curviness = this._originalCurviness;
        super.doCancel();
    }
    /**
     * Change the route of the {@link #adornedLink} by moving the point corresponding to the current
     * {@link #handle} to be at the given {@link Point}.
     * This is called by {@link #doMouseMove} and {@link #doMouseUp} with the result of calling
     * {@link #computeReshape} to constrain the input point.
     * @param {Point} newpt the value of the call to {@link #computeReshape}.
     */ reshape(newpt) {
        const link = this.adornedLink;
        if (link !== null && link.curve === $lR8r2$gojs.Link.Bezier && (link.pointsCount - 1) % 3 === 0) {
            const start = link.getPoint(0);
            const end = link.getPoint(3);
            const ang = start.directionPoint(end);
            const mid = new $lR8r2$gojs.Point((start.x + end.x) / 2, (start.y + end.y) / 2);
            const a = new $lR8r2$gojs.Point(9999, 0).rotate(ang + 90).add(mid);
            const b = new $lR8r2$gojs.Point(9999, 0).rotate(ang - 90).add(mid);
            const q = newpt.copy().projectOntoLineSegmentPoint(a, b);
            let curviness = Math.sqrt(mid.distanceSquaredPoint(q));
            const port = link.fromPort;
            if (port === link.toPort) {
                if (newpt.y < port.getDocumentPoint($lR8r2$gojs.Spot.Center).y) curviness = -curviness;
            } else {
                const diff = mid.directionPoint(q) - ang;
                if (diff > 0 && diff < 180 || diff < -180) curviness = -curviness;
            }
            link.curviness = curviness;
            link.fromSpot = $lR8r2$gojs.Spot.Default;
            link.toSpot = $lR8r2$gojs.Spot.Default;
            link.adjusting = $lR8r2$gojs.Link.None;
            return q;
        } else super.reshape(newpt);
    }
}



class $06fecfcf76190321$export$c7a86018194a5999 {
    /**
     * Constructs a ZoomSlider and sets up properties based on the options provided.
     * Also sets up change listeners on the Diagram so the ZoomSlider stays up-to-date.
     * @param {Diagram} diagram a reference to a GoJS Diagram
     * @param {Object=} options an optional JS Object describing options for the slider
     */ constructor(diagram, options){
        // Slider options defaults:
        this._size = 125;
        this._buttonSize = 25;
        this._alignment = $lR8r2$gojs.Spot.BottomRight;
        this._alignmentFocus = $lR8r2$gojs.Spot.BottomRight;
        this._orientation = "vertical";
        this._opacity = .75;
        this._diagram = diagram;
        this._initialScale = diagram.scale;
        this._diagramDiv = diagram.div;
        this._sliderDiv = null;
        this._zoomSliderOut = null;
        this._zoomSliderIn = null;
        this._zoomSliderRange = null;
        this._zoomSliderRangeCtn = null;
        // Set properties based on options
        if (options !== undefined) {
            if (options.size !== undefined) this._size = options.size;
            if (options.buttonSize !== undefined) this._buttonSize = options.buttonSize;
            if (options.alignment !== undefined) this._alignment = options.alignment;
            if (options.alignmentFocus !== undefined) this._alignmentFocus = options.alignmentFocus;
            if (options.orientation !== undefined) this._orientation = options.orientation;
            if (options.opacity !== undefined) this._opacity = options.opacity;
        }
        // Prepare change listeners
        const self = this;
        this.updateOnViewportBoundsChanged = (e)=>{
            self.scaleToValue();
        };
        const observer = new MutationObserver(()=>{
            const COLLAPSED_CANVAS_HEIGHT = 1;
            const diagramDisplayValue = getComputedStyle(self._diagramDiv, null).display;
            const canvasHeight = self._diagramDiv.getElementsByTagName("canvas")[0].style.height;
            if (diagramDisplayValue !== "none" && parseInt(canvasHeight) > COLLAPSED_CANVAS_HEIGHT) self._sliderDiv.style.display = "flex";
            else self._sliderDiv.style.display = "none";
        });
        observer.observe(self._diagramDiv, {
            attributes: true,
            childList: false
        });
        this.init();
    }
    /**
     * This read-only property returns the diagram for which the slider is handling zoom.
     */ get diagram() {
        return this._diagram;
    }
    /**
     * Gets or sets the overall length, in pixels, that the slider will occupy.
     * The default value is 125.
     */ get size() {
        return this._size;
    }
    set size(val) {
        const old = this._size;
        if (old !== val) {
            this._size = val;
            this.resize();
        }
    }
    /**
     * Gets or sets the height/width of the buttons at each end of the slider.
     * The default value is 25.
     */ get buttonSize() {
        return this._buttonSize;
    }
    set buttonSize(val) {
        const old = this._buttonSize;
        if (old !== val) {
            this._buttonSize = val;
            this.resize();
        }
    }
    /**
     * Gets or sets the alignment Spot of this slider to determine where it should be placed relative to the diagram.
     * The default value is Spot.BottomRight.
     */ get alignment() {
        return this._alignment;
    }
    set alignment(val) {
        const old = this._alignment;
        if (old !== val) {
            this._alignment = val;
            this.realign();
        }
    }
    /**
     * Gets or sets the Spot on this slider to be used as the alignment point when placing it relative to the diagram.
     * The default value is Spot.BottomRight.
     */ get alignmentFocus() {
        return this._alignmentFocus;
    }
    set alignmentFocus(val) {
        const old = this._alignmentFocus;
        if (old !== val) {
            this._alignmentFocus = val;
            this.realign();
        }
    }
    /**
     * Gets or sets whether the slider is oriented vertically or horizontally.
     * Must be either "horizontal" or "vertical" and is case-sensitive.
     * The default value is `"vertical"`.
     */ get orientation() {
        return this._orientation;
    }
    set orientation(val) {
        if (val !== "horizontal" && val !== "vertical") throw new Error('Orientation must be "horizontal" or "vertical"');
        const old = this._orientation;
        if (old !== val) {
            this._orientation = val;
            this.resize(true);
        }
    }
    /**
     * Gets or sets the opacity of the slider.
     * The default value is 0.75.
     */ get opacity() {
        return this._opacity;
    }
    set opacity(val) {
        const old = this._opacity;
        if (old !== val) {
            this._opacity = val;
            if (this._sliderDiv !== null) this._sliderDiv.style.opacity = val.toString();
        }
    }
    /**
     * @ignore
     * Initialize the slider.
     */ init() {
        // Sets up the slider div and inner div's basic attributes and ids
        this.sliderDivSetup();
        this.resize(true);
        // Set up the runtime code
        this.sliderListenerSetup();
    }
    /**
     * @ignore
     * Create the necessary divs for the slider and add the slider as a sibling of the diagram.
     */ sliderDivSetup() {
        this._sliderDiv = document.createElement("div");
        this._sliderDiv.className = "zoomSlider";
        // Initialize buttons and range input
        const zoomOutBtn = document.createElement("button");
        this._zoomSliderOut = zoomOutBtn;
        zoomOutBtn.className = "zoomButton";
        zoomOutBtn.innerHTML = "-";
        this._sliderDiv.appendChild(zoomOutBtn);
        const zoomRangeContainer = document.createElement("div");
        this._zoomSliderRangeCtn = zoomRangeContainer;
        zoomRangeContainer.className = "zoomRangeContainer";
        this._sliderDiv.appendChild(zoomRangeContainer);
        const zoomRangeInput = document.createElement("input");
        this._zoomSliderRange = zoomRangeInput;
        zoomRangeInput.className = "zoomRangeInput";
        zoomRangeInput.type = "range";
        zoomRangeInput.min = "-50";
        zoomRangeInput.max = "100";
        zoomRangeContainer.appendChild(zoomRangeInput);
        const zoomInBtn = document.createElement("button");
        this._zoomSliderIn = zoomInBtn;
        zoomInBtn.className = "zoomButton";
        zoomInBtn.innerHTML = "+";
        this._sliderDiv.appendChild(zoomInBtn);
        // Custom styling
        this._sliderDiv.style.display = "flex";
        this._sliderDiv.style.position = "absolute";
        this._sliderDiv.style.zIndex = 8;
        // Adds the slider as a sibling of the diagram
        // IMPORTANT: the diagram div's parent element should use position: relative
        if (this._diagramDiv !== null) {
            const diagramParent = this._diagramDiv.parentElement;
            if (diagramParent !== null) diagramParent.appendChild(this._sliderDiv);
        }
    }
    /**
     * @ignore
     * Add listeners to the buttons and range input.
     * Add a diagram listener.
     */ sliderListenerSetup() {
        const zoomOutBtn = this._zoomSliderOut;
        const zoomInBtn = this._zoomSliderIn;
        const zoomRangeInput = this._zoomSliderRange;
        if (zoomOutBtn === null || zoomInBtn === null || zoomRangeInput === null) return;
        // Set up diagram listener so the slider can be kept in sync with the diagram's scale
        this.diagram.addDiagramListener("ViewportBoundsChanged", this.updateOnViewportBoundsChanged);
        // Set up event handlers for buttons and input range slider
        const self = this;
        zoomOutBtn.onclick = function() {
            zoomRangeInput.stepDown();
            self.valueToScale();
        };
        zoomInBtn.onclick = function() {
            zoomRangeInput.stepUp();
            self.valueToScale();
        };
        const valChanged = function() {
            self.valueToScale();
        };
        zoomRangeInput.oninput = valChanged;
        zoomRangeInput.onchange = valChanged;
    }
    /**
     * @ignore
     * Resize the slider.
     * @param {boolean=} reorient whether or not to reorient the slider/buttons
     */ resize(reorient) {
        let sliderWidth = 0;
        let sliderHeight = 0;
        const zoomOutBtn = this._zoomSliderOut;
        const zoomInBtn = this._zoomSliderIn;
        const zoomRangeContainer = this._zoomSliderRangeCtn;
        const zoomRangeInput = this._zoomSliderRange;
        if (this._sliderDiv === null || zoomOutBtn === null || zoomInBtn === null || zoomRangeContainer === null || zoomRangeInput === null) return;
        if (this.orientation === "horizontal") {
            sliderWidth = this.size;
            sliderHeight = this.buttonSize;
            const rangeWidth = sliderWidth - sliderHeight * 2;
            zoomOutBtn.style.width = sliderHeight + "px";
            zoomOutBtn.style.height = sliderHeight + "px";
            zoomRangeContainer.style.width = rangeWidth + "px";
            zoomRangeContainer.style.height = sliderHeight + "px";
            zoomRangeInput.style.width = rangeWidth + "px";
            zoomRangeInput.style.height = sliderHeight + "px";
            zoomRangeInput.style.transformOrigin = "";
            zoomInBtn.style.width = sliderHeight + "px";
            zoomInBtn.style.height = sliderHeight + "px";
        } else {
            sliderHeight = this.size;
            sliderWidth = this.buttonSize;
            const rangeHeight = sliderHeight - sliderWidth * 2;
            zoomInBtn.style.width = sliderWidth + "px";
            zoomInBtn.style.height = sliderWidth + "px";
            zoomRangeContainer.style.width = sliderWidth + "px";
            zoomRangeContainer.style.height = rangeHeight + "px";
            zoomRangeInput.style.width = rangeHeight + "px";
            zoomRangeInput.style.height = sliderWidth + "px";
            zoomRangeInput.style.transformOrigin = rangeHeight / 2 + "px " + rangeHeight / 2 + "px";
            zoomOutBtn.style.width = sliderWidth + "px";
            zoomOutBtn.style.height = sliderWidth + "px";
        }
        this._sliderDiv.style.width = sliderWidth + "px";
        this._sliderDiv.style.height = sliderHeight + "px";
        // Reorient the slider, if necessary
        if (reorient) this.reorient();
        // Realign based on new size
        this.realign();
    }
    /**
     * @ignore
     * Reorient the slider, changing the transform and the order of the buttons within the div.
     */ reorient() {
        const zoomOutBtn = this._zoomSliderOut;
        const zoomInBtn = this._zoomSliderIn;
        const zoomRangeInput = this._zoomSliderRange;
        if (this._sliderDiv === null || zoomOutBtn === null || zoomInBtn === null || zoomRangeInput === null) return;
        // Need to set the transform of the range input and move the buttons to the correct sides
        if (this.orientation === "horizontal") {
            zoomRangeInput.style.transform = "";
            this._sliderDiv.insertBefore(zoomOutBtn, this._sliderDiv.firstChild);
            this._sliderDiv.appendChild(zoomInBtn);
        } else {
            zoomRangeInput.style.transform = "rotate(-90deg)";
            this._sliderDiv.insertBefore(zoomInBtn, this._sliderDiv.firstChild);
            this._sliderDiv.appendChild(zoomOutBtn);
        }
    }
    /**
     * @ignore
     * Realigns to slider relative to the diagram.
     */ realign() {
        if (this._diagramDiv === null || this._sliderDiv === null) return;
        let sliderWidth = 0;
        let sliderHeight = 0;
        if (this.orientation === "horizontal") {
            sliderWidth = this.size;
            sliderHeight = this.buttonSize;
        } else {
            sliderHeight = this.size;
            sliderWidth = this.buttonSize;
        }
        // Finds the diagram and diagram's parent in the page
        const diagramParent = this._diagramDiv.parentElement;
        const diagramLoc = this._diagramDiv.getBoundingClientRect();
        if (diagramParent !== null) {
            const parentLoc = diagramParent.getBoundingClientRect();
            const top = diagramLoc.top - parentLoc.top + this.alignment.y * this._diagramDiv.clientHeight + this.alignment.offsetY - this.alignmentFocus.y * sliderHeight + this.alignmentFocus.offsetY;
            const left = diagramLoc.left - parentLoc.left + this.alignment.x * this._diagramDiv.clientWidth + this.alignment.offsetX - this.alignmentFocus.x * sliderWidth + this.alignmentFocus.offsetX;
            this._sliderDiv.style.top = top + 50 + "px";
            this._sliderDiv.style.left = left + 100 + "px";
        }
    }
    /**
     * @ignore
     * Update the value of the slider input to match the diagram's scale.
     */ scaleToValue() {
        const slider = this._zoomSliderRange;
        if (slider === null) return;
        const diagram = this.diagram;
        const A = this._initialScale;
        const B = diagram.commandHandler.zoomFactor;
        const y1 = diagram.scale;
        slider.value = Math.round(Math.log(y1 / A) / Math.log(B)).toString();
    }
    /**
     * @ignore
     * Update the diagram's scale to match the value of the slider input.
     */ valueToScale() {
        const slider = this._zoomSliderRange;
        if (slider === null) return;
        const diagram = this.diagram;
        const x = parseFloat(slider.value);
        const A = this._initialScale;
        const B = diagram.commandHandler.zoomFactor;
        diagram.scale = A * Math.pow(B, x);
    }
    /**
     * Remove the slider from the page.
     */ remove() {
        // Remove the listener attached to diagram
        this.diagram.removeDiagramListener("ViewportBoundsChanged", this.updateOnViewportBoundsChanged);
        if (this._sliderDiv !== null) {
            this._sliderDiv.innerHTML = "";
            if (this._sliderDiv.parentElement) this._sliderDiv.parentElement.removeChild(this._sliderDiv);
            this._sliderDiv = null;
        }
    }
}






const $57e66c5a34f265b4$var$queryString = window.location.search;
let $57e66c5a34f265b4$var$urlHost = window.location.protocol + "//" + window.location.host;
const $57e66c5a34f265b4$var$urlParams = new URLSearchParams($57e66c5a34f265b4$var$queryString);
let $57e66c5a34f265b4$var$ctr = 0;
let $57e66c5a34f265b4$var$gDev = false;
let $57e66c5a34f265b4$var$gEnvironment = "SaaS";
console.log("Version 2022-12-31");
if ($57e66c5a34f265b4$var$urlHost.includes("localhost") === true) $57e66c5a34f265b4$var$gDev = true;
let $57e66c5a34f265b4$var$modelID = "";
let $57e66c5a34f265b4$var$gEntityUpper = "Task";
let $57e66c5a34f265b4$var$gEntityLower = "task";
let $57e66c5a34f265b4$var$gTaskTable = "";
let $57e66c5a34f265b4$var$gEventLogID = "";
let $57e66c5a34f265b4$var$gEventLogName = "";
let $57e66c5a34f265b4$var$gUpdateEventLog = false;
let $57e66c5a34f265b4$var$gImportEventLogArray = [];
let $57e66c5a34f265b4$var$gTaskAttributes = [];
let $57e66c5a34f265b4$var$gEventAttributes = [];
let $57e66c5a34f265b4$var$gUploadFileArray = [];
let $57e66c5a34f265b4$var$gUploadFileHeader = [];
let $57e66c5a34f265b4$var$gTransformation = [];
let $57e66c5a34f265b4$var$activePane = (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).eventLogTab;
let $57e66c5a34f265b4$var$previousPane = (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).eventLogTab;
let $57e66c5a34f265b4$var$gActiveAction = "process_visualizer";
let $57e66c5a34f265b4$var$gLoadingStatus = "";
let $57e66c5a34f265b4$var$gActivityArray = [];
let $57e66c5a34f265b4$var$gActivityIndexArray = [];
let $57e66c5a34f265b4$var$gStepArray = [];
let $57e66c5a34f265b4$var$gEventLogArray = [];
let $57e66c5a34f265b4$var$gVariantArray = [];
let $57e66c5a34f265b4$var$gTaskArray = [];
let $57e66c5a34f265b4$var$gMetricArray = [];
let $57e66c5a34f265b4$var$gAnalyticsTaskArray = [];
let $57e66c5a34f265b4$var$gTaskSlicedArray = [];
let $57e66c5a34f265b4$var$gAnalyticsEventArray = [];
let $57e66c5a34f265b4$var$gModelFileName = $57e66c5a34f265b4$var$gEntityUpper + "s";
let $57e66c5a34f265b4$var$gDefaultVariantsSelected = 10;
let $57e66c5a34f265b4$var$gCSV = [];
let $57e66c5a34f265b4$var$gASALinks = [];
let $57e66c5a34f265b4$var$gASANodes = [];
let $57e66c5a34f265b4$var$gHistogramSeries = [];
let $57e66c5a34f265b4$var$gHistogramCategory = [];
let $57e66c5a34f265b4$var$gDataLoadType = "";
let $57e66c5a34f265b4$var$gPlanTier = "";
let $57e66c5a34f265b4$var$gSample = "N";
let $57e66c5a34f265b4$var$gInsightsAttributeArray = [];
let $57e66c5a34f265b4$var$gTaskStr = "";
let $57e66c5a34f265b4$var$gInsightsAttributes = [];
let $57e66c5a34f265b4$var$gInsightsValueType = "high";
let $57e66c5a34f265b4$var$gInsightsMinMetric = 0;
let $57e66c5a34f265b4$var$gInsightsMaxMetric = 999999999;
let $57e66c5a34f265b4$var$gInsightsMinTasks = 10;
let $57e66c5a34f265b4$var$gInsightsMaxTasks = 999999999;
let $57e66c5a34f265b4$var$gInsightsRows = 10;
let $57e66c5a34f265b4$var$gDecompositionTreeTaskArray = [];
let $57e66c5a34f265b4$var$gDecompositionTreeValueType = "high";
let $57e66c5a34f265b4$var$gDecompositionTreeMinTasks = 10;
let $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks = 999999999;
let $57e66c5a34f265b4$var$gDecompositionTreeMinMetric = 0;
let $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric = 999999999;
let $57e66c5a34f265b4$var$gDecompositionTreeAttribute = "";
let $57e66c5a34f265b4$var$gDecompositionTreeMetric = 1;
let $57e66c5a34f265b4$var$gRCDescription = "";
let $57e66c5a34f265b4$var$gHistogramDescription = "";
let $57e66c5a34f265b4$var$gHistogramTotal = "";
let $57e66c5a34f265b4$var$gHistogramType = "";
let $57e66c5a34f265b4$var$gInfluenceAnalysisAttributes = [];
let $57e66c5a34f265b4$var$gInfluenceAnalysisMetric = 3;
let $57e66c5a34f265b4$var$gInfluenceAnalysisInfluence = "increase";
let $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric = 0;
let $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric = 999999999;
let $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks = 10;
let $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks = 999999999;
let $57e66c5a34f265b4$var$gMinDiagramWidth = 400;
let $57e66c5a34f265b4$var$gTaskDetailExtract = "summary";
let $57e66c5a34f265b4$var$gEventDetailExtract = "summary";
let $57e66c5a34f265b4$var$gInsightsMetric = 1;
let $57e66c5a34f265b4$var$gSaveFilteredOnly = false;
let $57e66c5a34f265b4$var$gInitialLoad = true;
let $57e66c5a34f265b4$var$gRebuildCtr = 0;
let $57e66c5a34f265b4$var$gStepGridColumns;
let $57e66c5a34f265b4$var$userSessionToken;
let $57e66c5a34f265b4$var$gSlicedMetrics = false;
let $57e66c5a34f265b4$var$gVariantSlicerGridState;
let $57e66c5a34f265b4$var$gStepSlicerGridState;
let $57e66c5a34f265b4$var$gActivitySlicerGridState;
let $57e66c5a34f265b4$var$gTaskSlicerGridState;
let $57e66c5a34f265b4$var$gTaskAttributeFilterGridState;
let $57e66c5a34f265b4$var$gEventAttributeFilterGridState;
let $57e66c5a34f265b4$var$gProcessRulesGridState;
let $57e66c5a34f265b4$var$gCostRulesGridState;
// default performance and task filters
let $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
let $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
let $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
let $57e66c5a34f265b4$var$gFromTime = new Date();
let $57e66c5a34f265b4$var$gToTime = new Date(1900, 1);
let $57e66c5a34f265b4$var$gMinVariantTasks = -1;
let $57e66c5a34f265b4$var$gMaxVariantTasks = -1;
let $57e66c5a34f265b4$var$gTaskActivitiesFrom = -1;
let $57e66c5a34f265b4$var$gTaskActivitiesTo = -1;
let $57e66c5a34f265b4$var$gTaskDurationFrom = -1;
let $57e66c5a34f265b4$var$gTaskDurationTo = -1;
let $57e66c5a34f265b4$var$gMetricFilter;
let $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
let $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
let $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
let $57e66c5a34f265b4$var$gAutomatedVariants = 0;
let $57e66c5a34f265b4$var$gAutomatedTasks = 0;
let $57e66c5a34f265b4$var$gAutomatedEvents = 0;
let $57e66c5a34f265b4$var$gGaugePercEvents = false;
let $57e66c5a34f265b4$var$gGaugePercTasks = false;
let $57e66c5a34f265b4$var$gGaugeXofYVariants = false;
let $57e66c5a34f265b4$var$gGaugeXofYSteps = false;
let $57e66c5a34f265b4$var$gGaugeXofYActivities = false;
let $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = false;
let $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = false;
let $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = false;
let $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = false;
let $57e66c5a34f265b4$var$gGaugePercTasksCompliant = false;
let $57e66c5a34f265b4$var$gGaugePercEventsCompliant = false;
let $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = false;
let $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = false;
let $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = false;
let $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = false;
let $57e66c5a34f265b4$var$gGaugePercTasksAutomated = false;
let $57e66c5a34f265b4$var$gGaugePercEventsAutomated = false;
let $57e66c5a34f265b4$var$gGaugePercCostSaving = false;
let $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = false;
let $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = false;
let $57e66c5a34f265b4$var$gGaugeCostSaving = false;
let $57e66c5a34f265b4$var$gGaugeActualCost = false;
let $57e66c5a34f265b4$var$gGaugeForecastCost = false;
let $57e66c5a34f265b4$var$gForecastCost = 0;
let $57e66c5a34f265b4$var$gCostSaving = 0;
let $57e66c5a34f265b4$var$gActualCost = 0;
let $57e66c5a34f265b4$var$gEventsAll = 0;
let $57e66c5a34f265b4$var$gTasksAll = 0;
let $57e66c5a34f265b4$var$gVariantsAll = 0;
let $57e66c5a34f265b4$var$gActivitiesAll = 0;
let $57e66c5a34f265b4$var$gStepsAll = 0;
let $57e66c5a34f265b4$var$gEventsFiltered = 0;
let $57e66c5a34f265b4$var$gTasksFiltered = 0;
let $57e66c5a34f265b4$var$gVariantsFiltered = 0;
let $57e66c5a34f265b4$var$gActivitiesFiltered = 0;
let $57e66c5a34f265b4$var$gStepsFiltered = 0;
let $57e66c5a34f265b4$var$gRuleSelectedRow = [];
let $57e66c5a34f265b4$var$gFilterSelectedRow = 0;
let $57e66c5a34f265b4$var$gCommentSelectedRow;
// working arrays
let $57e66c5a34f265b4$var$gLinkArray = [];
let $57e66c5a34f265b4$var$gAttributeArray = [];
let $57e66c5a34f265b4$var$gComments = [];
let $57e66c5a34f265b4$var$gCostRules = [];
let $57e66c5a34f265b4$var$gPerformanceRules = [];
let $57e66c5a34f265b4$var$gComplianceRules = [];
let $57e66c5a34f265b4$var$gAutomationRules = [];
let $57e66c5a34f265b4$var$gFilterConditions = [];
let $57e66c5a34f265b4$var$gFilters = [];
let $57e66c5a34f265b4$var$gFilterSets = 0;
let $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
let $57e66c5a34f265b4$var$gTaskFilterActivities = [];
let $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
let $57e66c5a34f265b4$var$gTaskFilterTime = [];
let $57e66c5a34f265b4$var$gTaskFilterTasks = [];
let $57e66c5a34f265b4$var$gSlicerConditions = [];
let $57e66c5a34f265b4$var$gSlicerSelectedActivities = [];
let $57e66c5a34f265b4$var$gFilterSelectedActivities = [];
let $57e66c5a34f265b4$var$gSlicerSelectedSteps = [];
let $57e66c5a34f265b4$var$gSlicerSelectedTasks = [];
let $57e66c5a34f265b4$var$gDetailTaskVariantsSelected = [];
let $57e66c5a34f265b4$var$gDetailTaskTasksSelected = [];
let $57e66c5a34f265b4$var$gDetailTaskSummaryAttribute = "";
let $57e66c5a34f265b4$var$gDetailEventSummaryAttribute = "";
let $57e66c5a34f265b4$var$gTaskID = "";
let $57e66c5a34f265b4$var$gSelectedTransformationMapping = "";
let $57e66c5a34f265b4$var$gSelectedAttributes;
let $57e66c5a34f265b4$var$gAttribute = "";
let $57e66c5a34f265b4$var$gAttributeType = "";
let $57e66c5a34f265b4$var$gPathFrom = [];
let $57e66c5a34f265b4$var$gPathTo = [];
let $57e66c5a34f265b4$var$gPathAttribute = "";
let $57e66c5a34f265b4$var$gVariants = 0;
let $57e66c5a34f265b4$var$gIncludeStart = false;
//variables used by detail grids
let $57e66c5a34f265b4$var$gDetailSource = "";
let $57e66c5a34f265b4$var$gDetailVariant = null;
let $57e66c5a34f265b4$var$gDetailActivity = null;
let $57e66c5a34f265b4$var$gDetailNodeFrom = null;
let $57e66c5a34f265b4$var$gDetailNodeTo = null;
let $57e66c5a34f265b4$var$gDetailDescription = "";
let $57e66c5a34f265b4$var$gASAType = null;
let $57e66c5a34f265b4$var$gSaveSlicers = true;
// visualizer settings - start
let $57e66c5a34f265b4$var$gProcessFlowDirection = 90;
let $57e66c5a34f265b4$var$gShowLinkTasks = true;
let $57e66c5a34f265b4$var$gShowLinkAvgDuration = true;
let $57e66c5a34f265b4$var$gShowLinkMedDuration = false;
let $57e66c5a34f265b4$var$gShowLinkMinDuration = false;
let $57e66c5a34f265b4$var$gShowLinkMaxDuration = false;
let $57e66c5a34f265b4$var$gShowLinkAvgCost = false;
let $57e66c5a34f265b4$var$gShowLinkPercTotal = true;
let $57e66c5a34f265b4$var$gShowLinkDeviation = false;
let $57e66c5a34f265b4$var$gShowLinkPercCompliant = false;
let $57e66c5a34f265b4$var$gShowLinkPercAutomated = false;
let $57e66c5a34f265b4$var$gZoomToFit = false;
let $57e66c5a34f265b4$var$gShowStartLabel = true;
let $57e66c5a34f265b4$var$gShowEndLabel = false;
let $57e66c5a34f265b4$var$gShowStartNode = true;
let $57e66c5a34f265b4$var$gShowEndNode = true;
let $57e66c5a34f265b4$var$gStepLabelFontSize = "6pt";
let $57e66c5a34f265b4$var$gShowNodeTasks = true;
let $57e66c5a34f265b4$var$gShowNodePercTotal = false;
let $57e66c5a34f265b4$var$gNodeLabelFontSize = "7pt";
let $57e66c5a34f265b4$var$gShowDurationDays = true;
let $57e66c5a34f265b4$var$gShowDurationHours = true;
let $57e66c5a34f265b4$var$gShowDurationMinutes = true;
let $57e66c5a34f265b4$var$gShowDurationSeconds = false;
let $57e66c5a34f265b4$var$gStepWidthTasks = false;
let $57e66c5a34f265b4$var$gStepWidthDuration = true;
let $57e66c5a34f265b4$var$gStepWidthStdDeviation = false;
let $57e66c5a34f265b4$var$gHighlightLoops = false;
let $57e66c5a34f265b4$var$gHighlightNonCompliance = false;
let $57e66c5a34f265b4$var$gHighlightAutomation = false;
let $57e66c5a34f265b4$var$gStepColourVolume = false;
let $57e66c5a34f265b4$var$gStepColourCost = false;
let $57e66c5a34f265b4$var$gStepColourDuration = true;
let $57e66c5a34f265b4$var$gStepColourStdDeviation = false;
let $57e66c5a34f265b4$var$gAnalyticsModeFiltered = false;
let $57e66c5a34f265b4$var$gAnalyticsModeSliced = true;
let $57e66c5a34f265b4$var$gAnalyticsModeSelected = false;
let $57e66c5a34f265b4$var$gAnalyticsTaskAttribute = "";
let $57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric = 1;
let $57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric = 1;
let $57e66c5a34f265b4$var$gAnalyticsEventAttribute = "";
let $57e66c5a34f265b4$var$gActivityShape = "RoundedRectangle";
let $57e66c5a34f265b4$var$gColorStartNode = "#A09E9E";
let $57e66c5a34f265b4$var$gColorEndNode = "#A09E9E";
let $57e66c5a34f265b4$var$gColorActivityText = "#FFFFFF";
let $57e66c5a34f265b4$var$gColorActivityFill = "#187BCD";
let $57e66c5a34f265b4$var$gColorActivitySelect = "#727171";
let $57e66c5a34f265b4$var$gColorLink = "#FDC819";
let $57e66c5a34f265b4$var$gColorLinkSelect = "#727171";
let $57e66c5a34f265b4$var$gAnimateColor = "#0053B8";
let $57e66c5a34f265b4$var$gLoopColor = "#0C78F6";
let $57e66c5a34f265b4$var$gNonCompliantColor = "#FF4848";
let $57e66c5a34f265b4$var$gPartialNonCompliantColor = "#FD6B6B";
let $57e66c5a34f265b4$var$gAutomationColor = "#417505";
let $57e66c5a34f265b4$var$gPartialAutomationColor = "#7ED321";
let $57e66c5a34f265b4$var$gVisualizerBackgroundColor = "#E7E7E7";
let $57e66c5a34f265b4$var$gSpacingColumn = 40;
let $57e66c5a34f265b4$var$gSpacingLayer = 30;
let $57e66c5a34f265b4$var$gASAMinTasks = 1;
// visualizer settings - end
let $57e66c5a34f265b4$var$gDurationLabel = "hrs";
let $57e66c5a34f265b4$var$gStepSelectRetention = "include";
let $57e66c5a34f265b4$var$gActivitySelectRetention = "include";
let $57e66c5a34f265b4$var$gPathSelectRetention = "include";
let $57e66c5a34f265b4$var$gStepSelectOperator = "or";
let $57e66c5a34f265b4$var$gActivitySelectOperator = "or";
let $57e66c5a34f265b4$var$gPathSelectOperator = "or";
let $57e66c5a34f265b4$var$gLoopDashes = false;
let $57e66c5a34f265b4$var$gDiagramPV = null;
let $57e66c5a34f265b4$var$gDiagramDecompositionTree = null;
let $57e66c5a34f265b4$var$gDiagramInsights = null;
let $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis = null;
let $57e66c5a34f265b4$var$gDiagramASA = null;
let $57e66c5a34f265b4$var$gCurrentDiagram;
let $57e66c5a34f265b4$var$gIsolateVariant = 0;
let $57e66c5a34f265b4$var$gAnimateVariant = 0;
let $57e66c5a34f265b4$var$gLifecycleVariant = 0;
let $57e66c5a34f265b4$var$gVariantLoops = null;
let $57e66c5a34f265b4$var$gVariantCompliant = null;
let $57e66c5a34f265b4$var$gVariantAutomate = null;
let $57e66c5a34f265b4$var$gStepPaneVariants = [];
let $57e66c5a34f265b4$var$gPathPaneVariants = [];
let $57e66c5a34f265b4$var$gVariantPaneVariants = [];
let $57e66c5a34f265b4$var$gActivityPaneVariants = [];
let $57e66c5a34f265b4$var$gTaskPaneVariants = [];
let $57e66c5a34f265b4$var$gVariantTasksSliced = 0;
let $57e66c5a34f265b4$var$gVariantsSliced = 0;
let $57e66c5a34f265b4$var$gVariantEventsSliced = 0;
let $57e66c5a34f265b4$var$gVariantStepsSliced = 0;
let $57e66c5a34f265b4$var$gVariantActivitiesSliced = 0;
let $57e66c5a34f265b4$var$gDiagramPVVariants = 0;
let $57e66c5a34f265b4$var$gDiagramPVSteps = 0;
let $57e66c5a34f265b4$var$gDiagramPVTasks = 0;
let $57e66c5a34f265b4$var$gDiagramPVEvents = 0;
let $57e66c5a34f265b4$var$gDiagramPVActivities = 0;
let $57e66c5a34f265b4$var$gDiagramPVLoops = 0;
let $57e66c5a34f265b4$var$gPercCostSaving = 0;
let $57e66c5a34f265b4$var$gDiagramPVTaskLoops = 0;
let $57e66c5a34f265b4$var$gSelectedProcessSteps = [];
let $57e66c5a34f265b4$var$gVariantIsolate = false;
let $57e66c5a34f265b4$var$gVariantAnimate = true;
let $57e66c5a34f265b4$var$gVariantLifecycle = false;
let $57e66c5a34f265b4$var$gEventEmitter;
let $57e66c5a34f265b4$var$gZoomSlider;
let $57e66c5a34f265b4$var$gStepSlicerSelection = [];
let $57e66c5a34f265b4$var$gTaskSlicerSelection = [];
let $57e66c5a34f265b4$var$gActivitieSlicerSelection = [];
let $57e66c5a34f265b4$var$gActivitiesFilterSelection = [];
let $57e66c5a34f265b4$var$gVariantsVisualizationGraphType = 1;
let $57e66c5a34f265b4$var$gVariantsVisualizationMetric = 1;
let $57e66c5a34f265b4$var$gTasksVisualizationGraphType = 1;
let $57e66c5a34f265b4$var$gTasksVisualizationFilter = 0;
let $57e66c5a34f265b4$var$gTasksVisualizationNumTasks = 50;
let $57e66c5a34f265b4$var$gTasksVisualizationMetric = 1;
let $57e66c5a34f265b4$var$gTasksVisualizationSort = 0;
let $57e66c5a34f265b4$var$gHistogramArray = [];
let $57e66c5a34f265b4$var$gTasksVisualizationSource = "";
let $57e66c5a34f265b4$var$currentTime = new Date().getTime();
$57e66c5a34f265b4$var$modelID = $57e66c5a34f265b4$var$urlParams.get("model");
$57e66c5a34f265b4$var$userSessionToken = $57e66c5a34f265b4$var$urlParams.get("session");
$57e66c5a34f265b4$var$gTaskTable = $57e66c5a34f265b4$var$urlParams.get("table");
$57e66c5a34f265b4$var$gModelFileName = $57e66c5a34f265b4$var$urlParams.get("name");
const $57e66c5a34f265b4$var$urlTaskAttributes = $57e66c5a34f265b4$var$urlParams.getAll("task_attribute");
for(let i = 0; i < $57e66c5a34f265b4$var$urlTaskAttributes.length; i++){
    let vtpURL = {};
    vtpURL["id"] = "ta" + i;
    vtpURL["field"] = $57e66c5a34f265b4$var$urlTaskAttributes[i];
    $57e66c5a34f265b4$var$gTaskAttributes.push(vtpURL);
}
const $57e66c5a34f265b4$var$urlMetrics = $57e66c5a34f265b4$var$urlParams.getAll("metric");
for(let i1 = 0; i1 < $57e66c5a34f265b4$var$urlMetrics.length; i1++){
    const metric = $57e66c5a34f265b4$var$urlMetrics[i1].substring(0, $57e66c5a34f265b4$var$urlMetrics[i1].indexOf("^"));
    const metricType = $57e66c5a34f265b4$var$urlMetrics[i1].substring($57e66c5a34f265b4$var$urlMetrics[i1].indexOf("^") + 1);
    let vtpURLM = {};
    vtpURLM["id"] = i1;
    vtpURLM["m"] = metric;
    vtpURLM["t"] = metricType;
    $57e66c5a34f265b4$var$gMetricArray.push(vtpURLM);
}
function $57e66c5a34f265b4$export$4785aefe9f2fd046(planTier) {
    $57e66c5a34f265b4$var$gPlanTier = planTier;
}
function $57e66c5a34f265b4$export$bd6a338554715444(taskID) {
    $57e66c5a34f265b4$var$gTaskID = taskID.taskID;
    $57e66c5a34f265b4$var$gDetailSource = "task";
}
function $57e66c5a34f265b4$export$4e7e6a46e1c0c8ad(entity, entities) {
    if (entity.initial === true && $57e66c5a34f265b4$var$gEntityUpper != "") return;
    $57e66c5a34f265b4$var$gEntityUpper = entity.entity;
    $57e66c5a34f265b4$var$gEntityLower = $57e66c5a34f265b4$var$gEntityUpper.toLowerCase();
}
function $57e66c5a34f265b4$export$7bca99abddcf9a72() {
    return $57e66c5a34f265b4$var$gEntityUpper;
}
function $57e66c5a34f265b4$export$a166054545426636() {
    return $57e66c5a34f265b4$var$gEntityLower;
}
function $57e66c5a34f265b4$export$278bb844373faf01(eventLogID) {
    $57e66c5a34f265b4$var$gEventLogID = eventLogID;
}
function $57e66c5a34f265b4$export$347ff2119a6127ca() {
    return $57e66c5a34f265b4$var$gPlanTier;
}
function $57e66c5a34f265b4$export$872b200e9298d34(sample) {
    $57e66c5a34f265b4$var$gSample = sample;
}
function $57e66c5a34f265b4$export$29ff4b1920b337e7() {
    return $57e66c5a34f265b4$var$gEventLogName;
}
function $57e66c5a34f265b4$export$f666a8ccd1a91163() {
    $57e66c5a34f265b4$var$gUpdateEventLog = true;
}
function $57e66c5a34f265b4$export$24e59b9226009be5() {
    return Promise.all([
        $57e66c5a34f265b4$export$2ae80658c4c02420()
    ]);
}

async function $57e66c5a34f265b4$export$e665410dcc0a290(eventLogID) {
    $57e66c5a34f265b4$var$gLoadingStatus = "Loading event log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    const values = await $57e66c5a34f265b4$var$retrievePMEventLog(eventLogID);
    $57e66c5a34f265b4$var$gEventLogName = values.data.data.eventLog[0].name;
    $57e66c5a34f265b4$var$gEntityUpper = values.data.data.eventLog[0].entity;
    $57e66c5a34f265b4$var$gEntityLower = $57e66c5a34f265b4$var$gEntityUpper.toLowerCase();
    $57e66c5a34f265b4$var$gTransformation = JSON.parse(values.data.data.eventLog[0].data_transformation);
    const pako = $lR8r2$pako;
    $57e66c5a34f265b4$var$gCSV = (0, $lR8r2$reactpapaparse.readString)(pako.inflate($57e66c5a34f265b4$var$_base64ToArrayBuffer(values.data.data.eventLog[0].event_log), {
        to: "string"
    }));
    $57e66c5a34f265b4$var$gUploadFileHeader = [];
    let valueToPush = {};
    let numFields = 0;
    for(let i = 0; i <= 200; i++){
        if ($57e66c5a34f265b4$var$gCSV.data[0][i] == null) break;
        numFields++;
        valueToPush = {};
        valueToPush["headerName"] = $57e66c5a34f265b4$var$gCSV.data[0][i];
        valueToPush["field"] = $57e66c5a34f265b4$var$gCSV.data[0][i];
        valueToPush["dataType"] = "text";
        valueToPush["mapping"] = "";
        $57e66c5a34f265b4$var$gUploadFileHeader.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gUploadFileArray = [];
    valueToPush = {};
    for(let i1 = 1; i1 < $57e66c5a34f265b4$var$gCSV.data.length - 1; i1++){
        valueToPush = {};
        for(let j = 0; j < numFields; j++)valueToPush[$57e66c5a34f265b4$var$gUploadFileHeader[j].field] = $57e66c5a34f265b4$var$gCSV.data[i1][j];
        $57e66c5a34f265b4$var$gUploadFileArray.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gModelFileName = values.data.data.eventLog[0].name;
    $57e66c5a34f265b4$var$gDataLoadType = "DB";
    $57e66c5a34f265b4$var$gEventLogID = eventLogID;
    $57e66c5a34f265b4$var$gLoadingStatus = "Processing event log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    $57e66c5a34f265b4$export$2ae80658c4c02420(); // note: in uploadEventLog_File, this is executed by 'Generate Analytics
}
async function $57e66c5a34f265b4$export$11749c0dfe75f29d(modelID) {
    $57e66c5a34f265b4$var$gLoadingStatus = "Loading event log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    const values = await $57e66c5a34f265b4$var$retrievePMModel(modelID);
    const cost_rules = JSON.parse(values.data.data.model[0].cost_rules);
    if (cost_rules.length > 0) {
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing cost rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.data.data.model[0].cost_rules, "cost", "model_import");
    }
    const performance_rules = JSON.parse(values.data.data.model[0].performance_rules);
    if (performance_rules.length > 0) {
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing performance rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.data.data.model[0].performance_rules, "performance", "model_import");
    }
    const compliance_rules = JSON.parse(values.data.data.model[0].compliance_rules);
    if (compliance_rules.length > 0) {
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing compliance rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.data.data.model[0].compliance_rules, "compliance", "model_import");
    }
    const automation_rules = JSON.parse(values.data.data.model[0].automation_rules);
    if (automation_rules.length > 0) {
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing automation rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.data.data.model[0].automation_rules, "automation", "model_import");
    }
    const filters = JSON.parse(values.data.data.model[0].filters);
    if (filters.length > 0) $57e66c5a34f265b4$export$4283b00eae4a6956(values.data.data.model[0].filters);
    $57e66c5a34f265b4$var$gLoadingStatus = "Processing visualizations";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    $57e66c5a34f265b4$export$59798dda46c3d2b5(false, false, "uploadModel");
    const slicers = JSON.parse(values.data.data.model[0].slicers);
    if (slicers.length > 0) $57e66c5a34f265b4$export$318ec447bc49311f(values.data.data.model[0].slicers);
    const visualizer_settings = JSON.parse(values.data.data.model[0].visualizer_settings);
    if (visualizer_settings.length > 0) $57e66c5a34f265b4$export$a23812855239994f(values.data.data.model[0].visualizer_settings);
    const gauges = JSON.parse(values.data.data.model[0].gauges);
    if (gauges.length > 0) $57e66c5a34f265b4$export$a05e78e48e0598a5(values.data.data.model[0].gauges);
    const comments = JSON.parse(values.data.data.model[0].comments);
    if (comments.length > 0) $57e66c5a34f265b4$var$gComments = JSON.parse(values.data.data.model[0].comments);
    $57e66c5a34f265b4$var$gLoadingStatus = "Processing metrics";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    $57e66c5a34f265b4$var$updateForecastCost();
    $57e66c5a34f265b4$var$updateCostMetrics("uploadModel_DB");
    $57e66c5a34f265b4$var$updateComplianceMetrics();
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
    $57e66c5a34f265b4$export$29e7d345ec013547();
    $57e66c5a34f265b4$var$updateAttributes();
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$var$retrievePMModel(modelID) {
    return new Promise((resolve)=>{
        const url = "/api/model/retrieve/" + modelID;
        const result = (0, ($parcel$interopDefault($lR8r2$axios))).get(url);
        resolve(result);
    });
}
function $57e66c5a34f265b4$export$84b3bd6959e2b5c4(csv, filename) {
    // called when event log CSV is dropped into papaparse object in import stepper
    $57e66c5a34f265b4$var$gDataLoadType = "File";
    $57e66c5a34f265b4$var$gCSV = csv;
    $57e66c5a34f265b4$var$gModelFileName = filename.substring(0, filename.lastIndexOf("."));
    $57e66c5a34f265b4$export$f178bc9f64f29a9b();
}
function $57e66c5a34f265b4$export$f178bc9f64f29a9b() {
    if ($57e66c5a34f265b4$var$gCSV.length === 0) return;
    $57e66c5a34f265b4$var$gTransformation = [];
    $57e66c5a34f265b4$var$gUploadFileHeader = [];
    let valueToPush = {};
    let numFields = 0;
    for(let i = 0; i <= 200; i++){
        if ($57e66c5a34f265b4$var$gCSV[0].data[i] == null) break;
        numFields++;
        valueToPush = {};
        valueToPush["headerName"] = $57e66c5a34f265b4$var$gCSV[0].data[i];
        valueToPush["field"] = $57e66c5a34f265b4$var$gCSV[0].data[i];
        valueToPush["dataType"] = "text";
        valueToPush["mapping"] = "";
        $57e66c5a34f265b4$var$gUploadFileHeader.push(valueToPush);
    }
    let taskExists = false;
    let activityExists = false;
    let timeStampExists = false;
    let resourceExists = false;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gUploadFileHeader.length; i1++){
        valueToPush = {};
        const headerName = $57e66c5a34f265b4$var$gUploadFileHeader[i1].headerName;
        for(let j = 0; j < $57e66c5a34f265b4$var$gTransformation.length; j++){
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping == $57e66c5a34f265b4$var$gEntityUpper + " ID") taskExists = true;
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping == "Activity") activityExists = true;
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping == "Timestamp") timeStampExists = true;
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping == "Resource") resourceExists = true;
        }
        if ((headerName.includes("Activity") || headerName.includes("activity")) && activityExists == false) {
            valueToPush["field"] = headerName;
            valueToPush["mapping"] = "Activity";
            valueToPush["dataType"] = "Text";
            valueToPush["status"] = true;
            valueToPush["issue"] = "";
            $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
            activityExists = true;
        }
        if ((headerName.includes($57e66c5a34f265b4$var$gEntityLower) || headerName.includes($57e66c5a34f265b4$var$gEntityUpper)) && taskExists == false) {
            valueToPush["field"] = headerName;
            valueToPush["mapping"] = $57e66c5a34f265b4$var$gEntityUpper + " ID";
            valueToPush["dataType"] = "Text";
            valueToPush["status"] = true;
            valueToPush["issue"] = "";
            $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
            taskExists = true;
        }
        if ((headerName.includes("Timestamp") || headerName.includes("timestamp")) && timeStampExists == false) {
            valueToPush["field"] = headerName;
            valueToPush["mapping"] = "Timestamp";
            valueToPush["dataType"] = "DateTime";
            valueToPush["status"] = true;
            valueToPush["issue"] = "";
            $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
            timeStampExists = false;
        }
        if ((headerName.includes("Resource") || headerName.includes("resource")) && resourceExists == false) {
            valueToPush["field"] = headerName;
            valueToPush["mapping"] = "Resource";
            valueToPush["dataType"] = "Text";
            valueToPush["status"] = true;
            valueToPush["issue"] = "";
            $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
        }
    }
    if (taskExists === false) {
        valueToPush = {};
        valueToPush["field"] = "";
        valueToPush["mapping"] = $57e66c5a34f265b4$var$gEntityUpper + " ID";
        valueToPush["dataType"] = "Text";
        valueToPush["status"] = false;
        valueToPush["issue"] = "Please select the " + $57e66c5a34f265b4$var$gEntityUpper + " ID column";
        $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
    }
    if (activityExists === false) {
        valueToPush = {};
        valueToPush["field"] = "";
        valueToPush["mapping"] = "Activity";
        valueToPush["dataType"] = "Text";
        valueToPush["status"] = false;
        valueToPush["issue"] = "Please select the Activity column";
        $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
    }
    if (timeStampExists === false) {
        valueToPush = {};
        valueToPush["field"] = "";
        valueToPush["mapping"] = "Timestamp";
        valueToPush["dataType"] = "Datetime";
        valueToPush["status"] = false;
        valueToPush["issue"] = "Please select the Timestamp column";
        $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gUploadFileArray = [];
    valueToPush = {};
    for(let i2 = 1; i2 < $57e66c5a34f265b4$var$gCSV.length - 1; i2++){
        valueToPush = {};
        for(let j1 = 0; j1 < numFields; j1++)valueToPush[$57e66c5a34f265b4$var$gUploadFileHeader[j1].field] = $57e66c5a34f265b4$var$gCSV[i2].data[j1];
        $57e66c5a34f265b4$var$gUploadFileArray.push(valueToPush);
    }
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $991b261412ea11a7$export$492241ebb0cf08ee)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$var$_base64ToArrayBuffer(base64) {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for(let i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
    return bytes.buffer;
}
function $57e66c5a34f265b4$var$retrievePMEventLog(eventLogID) {
    return new Promise((resolve)=>{
        let startTime = Date.now();
        const url = "/api/eventlog/retrieve_eventlog/" + eventLogID;
        const result = (0, ($parcel$interopDefault($lR8r2$axios))).get(url);
        resolve(result);
    });
}
function $57e66c5a34f265b4$export$15d7fa8f2890fc1a() {
    return $57e66c5a34f265b4$var$gUploadFileArray;
}
function $57e66c5a34f265b4$export$e31d351d197e2f2b() {
    return $57e66c5a34f265b4$var$gUploadFileHeader;
}
function $57e66c5a34f265b4$var$wait() {
    return new Promise((x)=>setTimeout(()=>x()));
}
async function $57e66c5a34f265b4$export$413807ec4362a462() {
    $57e66c5a34f265b4$var$gLoadingStatus = "Loading event log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    const values = await $57e66c5a34f265b4$var$retrieveSNOWArray();
    $57e66c5a34f265b4$var$loadSNOW($57e66c5a34f265b4$var$processData(values.array));
}
async function $57e66c5a34f265b4$export$c21b59e6401e02a4() {
    $57e66c5a34f265b4$var$gLoadingStatus = "Loading model";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    const values = await $57e66c5a34f265b4$var$retrieveSNOWModel();
    let modelExists = false;
    if (values.cost_rules != "") {
        const cost_rules = JSON.parse(values.cost_rules);
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing cost rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        if (cost_rules.length > 0) {
            $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.cost_rules, "cost", "model_import");
            modelExists = true;
        }
    }
    if (values.performance_rules != "") {
        const performance_rules = JSON.parse(values.performance_rules);
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing performance rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        if (performance_rules.length > 0) {
            $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.performance_rules, "performance", "model_import");
            modelExists = true;
        }
    }
    if (values.compliant_rules != "") {
        const compliance_rules = JSON.parse(values.compliant_rules);
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing compliance rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        if (compliance_rules.length > 0) {
            $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.compliant_rules, "compliance", "model_import");
            modelExists = true;
        }
    }
    if (values.automation_rules != "") {
        const automation_rules = JSON.parse(values.automation_rules);
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing automation rules";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        if (automation_rules.length > 0) {
            $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(values.automation_rules, "automation", "model_import");
            modelExists = true;
        }
    }
    $57e66c5a34f265b4$var$gLoadingStatus = "Processing automation rules";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    $57e66c5a34f265b4$var$gLoadingStatus = "Processing visualizations";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    await $57e66c5a34f265b4$var$wait();
    if (values.filters != "") {
        const filters = JSON.parse(values.filters);
        if (filters.length > 0) {
            $57e66c5a34f265b4$export$4283b00eae4a6956(values.filters);
            modelExists = true;
        }
    }
    if (modelExists === true) $57e66c5a34f265b4$export$59798dda46c3d2b5(false, false, "uploadModel");
    if (values.slicers != "") {
        const slicers = JSON.parse(values.slicers);
        if (slicers.length > 0) {
            $57e66c5a34f265b4$export$318ec447bc49311f(values.slicers);
            modelExists = true;
        }
    }
    if (values.settings != "") {
        const visualizer_settings = JSON.parse(values.settings);
        if (visualizer_settings.length > 0) {
            $57e66c5a34f265b4$export$a23812855239994f(values.settings);
            modelExists = true;
        }
    }
    if (values.gauges != "") {
        const gauges = JSON.parse(values.gauges);
        if (gauges.length > 0) {
            $57e66c5a34f265b4$export$a05e78e48e0598a5(values.gauges);
            modelExists = true;
        }
    }
    if (values.comments != "") {
        const comments = JSON.parse(values.comments);
        if (comments.length > 0) $57e66c5a34f265b4$var$gComments = JSON.parse(values.comments);
    }
    if (modelExists === true) {
        $57e66c5a34f265b4$var$gLoadingStatus = "Processing metrics";
        (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        await $57e66c5a34f265b4$var$wait();
        $57e66c5a34f265b4$var$updateForecastCost();
        $57e66c5a34f265b4$var$updateCostMetrics("loadSNOWModel");
        $57e66c5a34f265b4$var$updateComplianceMetrics();
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$updateAttributes();
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
}
function $57e66c5a34f265b4$var$retrieveSNOWArray() {
    return new Promise((resolve)=>{
        //let modelID = '18019b181bb23450f6fea608624bcb55'
        let requestBody = "";
        let client = new XMLHttpRequest();
        if ($57e66c5a34f265b4$var$gDev === true) $57e66c5a34f265b4$var$urlHost = "https://metricus.service-now.com";
        const url = $57e66c5a34f265b4$var$urlHost + "/api/now/table/x_metl3_pme_model_array?sysparm_query=type%3Devent_log%5Emodel%3D" + $57e66c5a34f265b4$var$modelID + "&sysparm_fields=array&sysparm_limit=1";
        client.open("get", url, false);
        client.setRequestHeader("Accept", "application/json");
        client.setRequestHeader("Content-Type", "application/json");
        if ($57e66c5a34f265b4$var$gDev === true) client.setRequestHeader("Authorization", "Basic " + btoa("admin:Titliest123!@#"));
        else client.setRequestHeader("X-UserToken", $57e66c5a34f265b4$var$userSessionToken);
        client.onreadystatechange = function() {
            if (this.readyState == this.DONE) {
                const obj = JSON.parse(this.response).result[0];
                resolve(obj);
            }
        };
        client.send(requestBody);
    });
}
function $57e66c5a34f265b4$var$retrieveSNOWModel() {
    return new Promise((resolve)=>{
        //let modelID = '18019b181bb23450f6fea608624bcb55'
        let requestBody = "";
        let client = new XMLHttpRequest();
        if ($57e66c5a34f265b4$var$gDev === true) $57e66c5a34f265b4$var$urlHost = "https://metricus.service-now.com";
        const url = $57e66c5a34f265b4$var$urlHost + "/api/now/table/x_metl3_pme_model?sysparm_query=sys_id%3D" + $57e66c5a34f265b4$var$modelID + "&sysparm_fields=settings%2Cslicers%2Cgauges%2Cfilters%2Cfilter%2Cperformance_rules%2Cautomation_rules%2Ccomments%2Ccompliant_rules%2Ccost_rules&sysparm_limit=1";
        client.open("get", url, false);
        client.setRequestHeader("Accept", "application/json");
        client.setRequestHeader("Content-Type", "application/json");
        if ($57e66c5a34f265b4$var$gDev === true) client.setRequestHeader("Authorization", "Basic " + btoa("admin:Titliest123!@#"));
        else client.setRequestHeader("X-UserToken", $57e66c5a34f265b4$var$userSessionToken);
        client.onreadystatechange = function() {
            if (this.readyState == this.DONE) {
                const obj = JSON.parse(this.response).result[0];
                resolve(obj);
            }
        };
        client.send(requestBody);
    });
}
function $57e66c5a34f265b4$var$processData(allText) {
    let lines = [];
    let tarr = [];
    let allTextLines = allText.split(/\r\n|\n/);
    for(let j = 0; j < allTextLines.length; j++){
        allTextLines[j] = allTextLines[j].replaceAll('","', "^^");
        allTextLines[j] = allTextLines[j].replaceAll('"', "");
    }
    let headers = allTextLines[0].split("^^");
    for(let j1 = 0; j1 < headers.length; j1++)tarr.push(headers[j1]);
    for(let i = 1; i < allTextLines.length; i++){
        let data = allTextLines[i].split("^^");
        if (data.length == headers.length) {
            tarr = [];
            for(let j2 = 0; j2 < headers.length; j2++)tarr.push(data[j2]);
            lines.push(tarr);
        }
    }
    return lines;
}
function $57e66c5a34f265b4$export$2ae80658c4c02420() {
    let startTime = Date.now();
    $57e66c5a34f265b4$var$gImportEventLogArray = [];
    let key;
    let vtp = {};
    $57e66c5a34f265b4$var$gTaskAttributes = [];
    $57e66c5a34f265b4$var$gEventAttributes = [];
    $57e66c5a34f265b4$var$gMetricArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gUploadFileArray.length; i++){
        if ($57e66c5a34f265b4$var$gPlanTier == "free" && $57e66c5a34f265b4$var$gSample == null && i >= 5000 && $57e66c5a34f265b4$var$urlHost != "http://localhost:3000") {
            alert("A maximum of 5000 events can be loaded during a free trial");
            break;
        }
        if ($57e66c5a34f265b4$var$gPlanTier != "free" && $57e66c5a34f265b4$var$gSample == null && i >= 500000) {
            alert("A maximum of 500K events are supported in this version of the Metricus Process Miner");
            break;
        }
        let valueToPush = {};
        let taskAttributes = 0;
        let eventAttributes = 0;
        let metrics = 0;
        for(let j = 0; j < $57e66c5a34f265b4$var$gTransformation.length; j++){
            key = $57e66c5a34f265b4$var$gTransformation[j].field;
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === $57e66c5a34f265b4$var$gEntityUpper + " ID") valueToPush["task"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Activity") valueToPush["activity"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Timestamp") valueToPush["timestamp"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === $57e66c5a34f265b4$var$gEntityUpper + " Create Time") valueToPush["create_time"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === $57e66c5a34f265b4$var$gEntityUpper + " Close Time") valueToPush["close_time"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Resource") {
                if (i == 0) {
                    vtp = [];
                    vtp["id"] = "ea" + eventAttributes.toString();
                    vtp["field"] = key;
                    $57e66c5a34f265b4$var$gEventAttributes.push(vtp);
                }
                valueToPush["resource"] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                eventAttributes++;
            }
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === $57e66c5a34f265b4$var$gEntityUpper + " Attribute") {
                if (taskAttributes < 20) {
                    if (i == 0) {
                        vtp = {};
                        vtp["id"] = "ta" + taskAttributes.toString();
                        vtp["field"] = key;
                        $57e66c5a34f265b4$var$gTaskAttributes.push(vtp);
                    }
                    valueToPush["ta" + taskAttributes] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                    taskAttributes++;
                }
            }
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Event Attribute") {
                if (eventAttributes < 20) {
                    if (i == 0) {
                        vtp = {};
                        vtp["id"] = "ea" + eventAttributes.toString();
                        vtp["field"] = key;
                        $57e66c5a34f265b4$var$gEventAttributes.push(vtp);
                    }
                    valueToPush["ea" + eventAttributes] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                    eventAttributes++;
                }
            }
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Metric - True/False") {
                if (i == 0) {
                    vtp = {};
                    vtp["m"] = key;
                    vtp["t"] = "true_false";
                    vtp["du"] = null;
                    vtp["id"] = metrics;
                    $57e66c5a34f265b4$var$gMetricArray.push(vtp);
                }
                valueToPush["m" + metrics] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                metrics++;
            }
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Metric - Duration") {
                if (i == 0) {
                    vtp = {};
                    vtp["m"] = key;
                    vtp["t"] = "duration";
                    vtp["du"] = null;
                    vtp["id"] = metrics;
                    $57e66c5a34f265b4$var$gMetricArray.push(vtp);
                }
                valueToPush["m" + metrics] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                metrics++;
            }
            if ($57e66c5a34f265b4$var$gTransformation[j].mapping === "Metric - Amount") {
                if (i == 0) {
                    vtp = {};
                    vtp["m"] = key;
                    vtp["t"] = "amount";
                    vtp["du"] = null;
                    vtp["id"] = metrics;
                    $57e66c5a34f265b4$var$gMetricArray.push(vtp);
                }
                valueToPush["m" + metrics] = $57e66c5a34f265b4$var$gUploadFileArray[i][key];
                metrics++;
            }
        }
        $57e66c5a34f265b4$var$gUploadFileArray[i].id = i;
        valueToPush["ufa_id"] = i;
        $57e66c5a34f265b4$var$gImportEventLogArray.push(valueToPush);
    }
    $57e66c5a34f265b4$var$processEventLog();
}
function $57e66c5a34f265b4$var$loadSNOW(csv) {
    let vtp = [];
    vtp["id"] = "ea0";
    vtp["field"] = "Resource";
    $57e66c5a34f265b4$var$gEventAttributes.push(vtp);
    $57e66c5a34f265b4$var$gImportEventLogArray = [];
    for(let i = 0; i < csv.length; i++){
        let valueToPush = {};
        valueToPush["task"] = csv[i][0];
        valueToPush["activity"] = csv[i][1];
        valueToPush["timestamp"] = csv[i][2];
        valueToPush["resource"] = csv[i][3];
        valueToPush["create_time"] = csv[i][5];
        valueToPush["close_time"] = csv[i][6];
        for(let j = 0; j < $57e66c5a34f265b4$var$gTaskAttributes.length; j++)valueToPush["ta" + j] = csv[i][j + 7];
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gMetricArray.length; j1++)valueToPush["m" + j1] = csv[i][j1 + 7 + $57e66c5a34f265b4$var$gTaskAttributes.length];
        $57e66c5a34f265b4$var$gImportEventLogArray.push(valueToPush);
    }
    $57e66c5a34f265b4$var$processEventLog();
}
function $57e66c5a34f265b4$var$processEventLog() {
    $57e66c5a34f265b4$var$gLoadingStatus = "Transform Event Log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    let startTime = Date.now();
    $57e66c5a34f265b4$var$gImportEventLogArray.sort((a, b)=>a.task.localeCompare(b.task) || a.timestamp.localeCompare(b.timestamp));
    let taskArray = [];
    let eventLogArray = [];
    let activityArray = [];
    let activityIndexArray = [];
    let stepArray = [];
    let stepArrayIndex = [];
    let variantArray = [];
    let variantArrayIndex = [];
    let taskEventsArray = [];
    let temp = [];
    let startLabel = "Start";
    let endLabel = "End";
    let activity_separator = " -> ";
    let obj = $57e66c5a34f265b4$var$importArrayActivityID(activityArray, activityIndexArray, startLabel, true, false);
    activityArray = obj[0];
    let activityIDStart = obj[1];
    activityIndexArray = obj[2];
    obj = $57e66c5a34f265b4$var$importArrayActivityID(activityArray, activityIndexArray, endLabel, false, true);
    activityArray = obj[0];
    let activityIDEnd = obj[1];
    activityIndexArray = obj[2];
    let previousTask = "";
    let previousActivityID = "";
    let currentActivityID = "";
    let variant = "";
    let currentTimestamp = "";
    let previousTimestamp = "";
    let variantID = "";
    let variantIndex = 0;
    let eventVariantArray = [];
    let min_time = "3000"; // year :-)
    let max_time = "1000";
    let sequence = 0;
    let duration_seconds = 0;
    let startEventIndex;
    let finishEventIndex;
    let valueToPush = {};
    let steps = 0;
    let stepID = "";
    let firstTask = true;
    let loop = false;
    let loops = 0;
    let taskID = 0;
    let i = 0;
    for(i = 0; i < $57e66c5a34f265b4$var$gImportEventLogArray.length; i++){
        if (variantArray.length >= 5000) {
            alert("A maximum of 5000 variants is supported");
            break;
        }
        if ($57e66c5a34f265b4$var$gPlanTier != "free" && $57e66c5a34f265b4$var$gSample == null && i >= 500000) {
            alert("A maximum of 500K events are supported in this version of the Metricus Process Miner");
            break;
        }
        if ($57e66c5a34f265b4$var$gImportEventLogArray[i].task != previousTask) {
            if (i > 1) {
                loops = 0;
                for(let x = 0; x < taskEventsArray.length; x++){
                    for(let y = 0; y < x; y++)if (taskEventsArray[x].t == taskEventsArray[y].t) loops++;
                }
                let obj1 = $57e66c5a34f265b4$var$arrayVariantID(variantArray, variantArrayIndex, variant, loops, taskEventsArray.length);
                variantArray = obj1[0];
                variantID = obj1[1];
                variantIndex = obj1[2];
                variantArrayIndex = obj1[3];
                for(let x1 = 0; x1 < taskEventsArray.length; x1++){
                    if (x1 == 0) startEventIndex = taskEventsArray[x1].i;
                    if (x1 == taskEventsArray.length - 1) finishEventIndex = taskEventsArray[x1].i;
                    valueToPush = {};
                    valueToPush["i"] = taskEventsArray[x1].i;
                    valueToPush["v"] = variantID;
                    valueToPush["vid"] = variantIndex;
                    eventVariantArray.push(valueToPush);
                }
                valueToPush = {};
                valueToPush["i"] = finishEventIndex + 1;
                valueToPush["v"] = variantID;
                valueToPush["vid"] = variantIndex;
                eventVariantArray.push(valueToPush);
                sequence++;
                obj1 = stepArray = $57e66c5a34f265b4$var$importArrayStepUpdate(stepArray, stepArrayIndex, previousActivityID, currentActivityID);
                stepArray = obj1[0];
                stepArrayIndex = obj1[2];
                valueToPush = {};
                valueToPush["f"] = previousActivityID;
                valueToPush["t"] = activityIDEnd;
                valueToPush["v"] = variantID;
                valueToPush["s"] = sequence;
                if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].resource != null) valueToPush["u"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].resource;
                else valueToPush["u"] = "n/a";
                valueToPush["d"] = 0;
                valueToPush["ac"] = 0;
                valueToPush["cc"] = 0;
                valueToPush["pc"] = 0;
                valueToPush["pd"] = 0; // pd
                valueToPush["rules"] = [];
                valueToPush["k"] = previousTask;
                valueToPush["ts"] = previousTimestamp; // ma timestamp for task
                valueToPush["tid"] = taskID;
                valueToPush["vid"] = -1;
                valueToPush["ufa_id"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].ufa_id;
                valueToPush["elid"] = eventLogArray.length;
                valueToPush["actual_cost"] = 0;
                valueToPush["forecast_cost"] = 0;
                for(let j = 0; j < $57e66c5a34f265b4$var$gTaskAttributes.length; j++){
                    let key = "ta" + j;
                    valueToPush["ta" + j] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key];
                }
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gEventAttributes.length; j1++){
                    let key1 = "";
                    if ($57e66c5a34f265b4$var$gEventAttributes[j1].field === "Resource") key1 = "resource";
                    else key1 = "ea" + j1;
                    valueToPush["ea" + j1] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key1];
                }
                eventLogArray.push(valueToPush);
                if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time != "" && $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time != null) min_time = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time;
                if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time != "" && $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time != null) max_time = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time;
                valueToPush = {};
                valueToPush["k"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].task;
                valueToPush["t1"] = min_time;
                valueToPush["t2"] = max_time;
                let date1 = new Date(min_time);
                let date2 = new Date(max_time);
                duration_seconds = (date2 - date1) / 1000;
                valueToPush["d"] = duration_seconds;
                valueToPush["a"] = sequence - 1;
                valueToPush["v"] = variantID;
                for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gTaskAttributes.length; j2++){
                    let key2 = "ta" + j2;
                    valueToPush["ta" + j2] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key2];
                }
                for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gMetricArray.length; j3++){
                    let key3 = "m" + j3;
                    valueToPush["m" + j3] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key3];
                }
                valueToPush["si"] = startEventIndex;
                valueToPush["fi"] = finishEventIndex + 1;
                valueToPush["vid"] = variantIndex;
                valueToPush["id"] = taskID;
                taskArray.push(valueToPush);
                firstTask = false;
                taskID++;
                taskEventsArray = [];
            }
            previousActivityID = activityIDStart;
            previousTimestamp = "";
            sequence = 0;
            variant = "";
            min_time = "3000";
            max_time = "1000";
            loops = 0;
        }
        sequence++;
        duration_seconds = 0;
        currentTimestamp = $57e66c5a34f265b4$var$gImportEventLogArray[i].timestamp.replace("T", " ");
        // remove a T is present in the timestamp
        if (previousTimestamp != "") {
            let date11 = new Date(previousTimestamp);
            let date21 = new Date(currentTimestamp);
            duration_seconds = (date21 - date11) / 1000;
        }
        if ($57e66c5a34f265b4$var$gImportEventLogArray[i].create_time == "" || $57e66c5a34f265b4$var$gImportEventLogArray[i].create_time == null) {
            if (currentTimestamp < min_time) min_time = currentTimestamp;
        }
        if ($57e66c5a34f265b4$var$gImportEventLogArray[i].close_time == "" || $57e66c5a34f265b4$var$gImportEventLogArray[i].close_time == null) {
            if (currentTimestamp > max_time) max_time = currentTimestamp;
        }
        let obj2 = $57e66c5a34f265b4$var$importArrayActivityID(activityArray, activityIndexArray, $57e66c5a34f265b4$var$gImportEventLogArray[i].activity, false, false);
        activityArray = obj2[0];
        currentActivityID = obj2[1];
        activityIndexArray = obj2[2];
        obj2 = $57e66c5a34f265b4$var$importArrayStepUpdate(stepArray, stepArrayIndex, previousActivityID, currentActivityID);
        stepArray = obj2[0];
        stepID = obj2[1];
        stepArrayIndex = obj2[2];
        valueToPush = {};
        valueToPush["f"] = previousActivityID;
        valueToPush["t"] = currentActivityID;
        valueToPush["s"] = sequence;
        if ($57e66c5a34f265b4$var$gImportEventLogArray[i].resource != null) valueToPush["u"] = $57e66c5a34f265b4$var$gImportEventLogArray[i].resource;
        else valueToPush["u"] = "n/a";
        valueToPush["d"] = duration_seconds;
        valueToPush["ac"] = 0;
        valueToPush["cc"] = 0;
        valueToPush["pc"] = 0;
        valueToPush["pd"] = 0;
        valueToPush["rules"] = [];
        valueToPush["k"] = $57e66c5a34f265b4$var$gImportEventLogArray[i].task;
        valueToPush["ts"] = currentTimestamp;
        valueToPush["v"] = -1;
        valueToPush["tid"] = taskID;
        valueToPush["vid"] = -1;
        valueToPush["ufa_id"] = $57e66c5a34f265b4$var$gImportEventLogArray[i].ufa_id;
        valueToPush["elid"] = eventLogArray.length;
        valueToPush["actual_cost"] = 0;
        valueToPush["forecast_cost"] = 0;
        for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gTaskAttributes.length; j4++){
            let key4 = "ta" + j4;
            valueToPush["ta" + j4] = $57e66c5a34f265b4$var$gImportEventLogArray[i][key4];
        }
        for(let j5 = 0; j5 < $57e66c5a34f265b4$var$gEventAttributes.length; j5++){
            let key5 = "";
            if ($57e66c5a34f265b4$var$gEventAttributes[j5].field === "Resource") key5 = "resource";
            else key5 = "ea" + j5;
            valueToPush["ea" + j5] = $57e66c5a34f265b4$var$gImportEventLogArray[i][key5];
        }
        eventLogArray.push(valueToPush);
        valueToPush = {};
        valueToPush["i"] = eventLogArray.length - 1;
        valueToPush["f"] = previousActivityID;
        valueToPush["t"] = currentActivityID;
        taskEventsArray.push(valueToPush);
        temp.push(valueToPush);
        if (variant != "") variant = variant + activity_separator;
        variant = variant + $57e66c5a34f265b4$var$gImportEventLogArray[i].activity;
        previousTask = $57e66c5a34f265b4$var$gImportEventLogArray[i].task;
        previousTimestamp = currentTimestamp;
        previousActivityID = currentActivityID;
    }
    // start of insert last record
    obj = $57e66c5a34f265b4$var$arrayVariantID(variantArray, variantArrayIndex, variant, steps, taskEventsArray.length);
    variantArray = obj[0];
    variantID = obj[1];
    variantIndex = obj[2];
    variantArrayIndex = obj[3];
    for(let x2 = 0; x2 < taskEventsArray.length; x2++){
        if (x2 == 0) startEventIndex = taskEventsArray[x2].i;
        if (x2 == taskEventsArray.length - 1) finishEventIndex = taskEventsArray[x2].i;
        let valueToPush1 = {};
        valueToPush1["i"] = taskEventsArray[x2].i;
        valueToPush1["v"] = variantID;
        valueToPush1["vid"] = variantIndex;
        eventVariantArray.push(valueToPush1);
    }
    valueToPush = {};
    valueToPush["i"] = finishEventIndex + 1;
    valueToPush["v"] = variantID;
    valueToPush["vid"] = variantIndex;
    eventVariantArray.push(valueToPush);
    sequence++;
    obj = stepArray = $57e66c5a34f265b4$var$importArrayStepUpdate(stepArray, stepArrayIndex, previousActivityID, currentActivityID);
    stepArray = obj[0];
    stepArrayIndex = obj[2];
    valueToPush = {};
    valueToPush["f"] = previousActivityID;
    valueToPush["t"] = activityIDEnd;
    valueToPush["v"] = -1;
    valueToPush["s"] = sequence;
    if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].resource != null) valueToPush["u"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].resource;
    else valueToPush["u"] = "n/a";
    valueToPush["d"] = 0;
    valueToPush["ac"] = 0;
    valueToPush["cc"] = 0;
    valueToPush["pc"] = 0;
    valueToPush["pd"] = 0;
    valueToPush["rules"] = [];
    valueToPush["k"] = previousTask;
    valueToPush["ts"] = previousTimestamp; // max timestamp for task
    valueToPush["tid"] = taskID;
    valueToPush["vid"] = -1;
    valueToPush["ufa_id"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].ufa_id;
    valueToPush["elid"] = eventLogArray.length;
    valueToPush["actual_cost"] = 0;
    valueToPush["forecast_cost"] = 0;
    for(let j6 = 0; j6 < $57e66c5a34f265b4$var$gTaskAttributes.length; j6++){
        let key6 = "ta" + j6;
        valueToPush["ta" + j6] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key6];
    }
    for(let j7 = 0; j7 < $57e66c5a34f265b4$var$gEventAttributes.length; j7++){
        let key7 = "";
        if ($57e66c5a34f265b4$var$gEventAttributes[j7].field === "Resource") key7 = "resource";
        else key7 = "ea" + j7;
        valueToPush["ea" + j7] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key7];
    }
    eventLogArray.push(valueToPush);
    if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time != "" && $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time != null) min_time = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].create_time;
    if ($57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time != "" && $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time != null) max_time = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].close_time;
    valueToPush = {};
    valueToPush["k"] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1].task;
    valueToPush["t1"] = min_time;
    valueToPush["t2"] = max_time;
    let date12 = new Date(min_time);
    let date22 = new Date(max_time);
    duration_seconds = (date22 - date12) / 1000;
    valueToPush["d"] = duration_seconds;
    valueToPush["a"] = sequence - 1;
    valueToPush["v"] = variantID;
    valueToPush["si"] = startEventIndex;
    valueToPush["fi"] = finishEventIndex + 1;
    valueToPush["vid"] = variantIndex;
    valueToPush["id"] = taskID;
    for(let j8 = 0; j8 < $57e66c5a34f265b4$var$gTaskAttributes.length; j8++){
        let key8 = "ta" + j8;
        valueToPush["ta" + j8] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key8];
    }
    for(let j9 = 0; j9 < $57e66c5a34f265b4$var$gMetricArray.length; j9++){
        let key9 = "m" + j9;
        valueToPush["m" + j9] = $57e66c5a34f265b4$var$gImportEventLogArray[i - 1][key9];
    }
    taskArray.push(valueToPush);
    // end of insert last record
    for(let x3 = 0; x3 < eventVariantArray.length; x3++){
        eventLogArray[eventVariantArray[x3].i].v = eventVariantArray[x3].v;
        eventLogArray[eventVariantArray[x3].i].vid = eventVariantArray[x3].vid;
    }
    for(let i1 = 0; i1 < variantArray.length; i1++){
        variantArray[i1].compliant_events = variantArray[i1].e;
        variantArray[i1].automated_events = 0;
        variantArray[i1].compliant_tasks = variantArray[i1].t;
        variantArray[i1].automated_tasks = 0;
    }
    $57e66c5a34f265b4$var$gActivityArray = [];
    $57e66c5a34f265b4$var$gActivityIndexArray = [];
    $57e66c5a34f265b4$var$gStepArray = [];
    $57e66c5a34f265b4$var$gVariantArray = [];
    $57e66c5a34f265b4$var$gTaskArray = [];
    $57e66c5a34f265b4$var$gEventLogArray = [];
    $57e66c5a34f265b4$var$gActivityArray = activityArray;
    $57e66c5a34f265b4$var$gActivityIndexArray = activityIndexArray;
    $57e66c5a34f265b4$var$gStepArray = stepArray;
    $57e66c5a34f265b4$var$gVariantArray = variantArray;
    $57e66c5a34f265b4$var$gTaskArray = taskArray;
    $57e66c5a34f265b4$var$gEventLogArray = eventLogArray;
    $57e66c5a34f265b4$var$gInsightsMinTasks = 10;
    $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks = 10;
    $57e66c5a34f265b4$var$gDecompositionTreeMinTasks = 10;
    if ($57e66c5a34f265b4$var$gTaskArray.length < 1000) {
        $57e66c5a34f265b4$var$gInsightsMinTasks = 0;
        $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks = 0;
        $57e66c5a34f265b4$var$gDecompositionTreeMinTasks = 0;
    }
    $57e66c5a34f265b4$var$gInsightsMaxTasks = $57e66c5a34f265b4$var$gTaskArray.length;
    $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks = $57e66c5a34f265b4$var$gTaskArray.length;
    $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks = $57e66c5a34f265b4$var$gTaskArray.length;
    //console.log('processEventLog: ' + (Date.now() - startTime) / 1000);
    $57e66c5a34f265b4$var$finaliseEventLog();
}
function $57e66c5a34f265b4$var$finaliseEventLog() {
    $57e66c5a34f265b4$var$gLoadingStatus = "Finalising Event Log";
    (0, $ee9d85e7e6e93318$export$c2ca0ce95834e88b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    let startTime = Date.now();
    if ($57e66c5a34f265b4$var$gUpdateEventLog == false) {
        $57e66c5a34f265b4$var$gComments = [];
        $57e66c5a34f265b4$var$gAutomationRules = [];
        $57e66c5a34f265b4$var$gCostRules = [];
        $57e66c5a34f265b4$var$gComplianceRules = [];
        $57e66c5a34f265b4$var$gPerformanceRules = [];
    }
    $57e66c5a34f265b4$var$gFilterConditions = [];
    $57e66c5a34f265b4$var$gFilters = [];
    $57e66c5a34f265b4$var$gFilterSets = 0;
    $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
    $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
    $57e66c5a34f265b4$var$gTaskFilterTime = [];
    $57e66c5a34f265b4$var$gTaskFilterTasks = [];
    $57e66c5a34f265b4$var$gSlicerConditions = [];
    $57e66c5a34f265b4$var$gSelectedTransformationMapping = "";
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gGaugePercEvents = true;
    $57e66c5a34f265b4$var$gGaugePercTasks = true;
    $57e66c5a34f265b4$var$gGaugeXofYVariants = true;
    $57e66c5a34f265b4$var$gGaugeXofYSteps = true;
    $57e66c5a34f265b4$var$gGaugeXofYActivities = true;
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = true;
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = true;
    $57e66c5a34f265b4$var$gGaugePercCostSaving = true;
    $57e66c5a34f265b4$var$updateEventLogArray();
    $57e66c5a34f265b4$var$loadGridColumns();
    $57e66c5a34f265b4$export$c7aee54378586699();
    if ($57e66c5a34f265b4$var$gUpdateEventLog == true) {
        if ($57e66c5a34f265b4$var$gAutomationRules.length > 0) $57e66c5a34f265b4$export$66bfaa30e4f0b4d8($57e66c5a34f265b4$var$gAutomationRules, "automation", "update_eventlog");
        if ($57e66c5a34f265b4$var$gComplianceRules.length > 0) $57e66c5a34f265b4$export$66bfaa30e4f0b4d8($57e66c5a34f265b4$var$gComplianceRules, "compliance", "update_eventlog");
        if ($57e66c5a34f265b4$var$gCostRules.length > 0) $57e66c5a34f265b4$export$66bfaa30e4f0b4d8($57e66c5a34f265b4$var$gCostRules, "cost", "update_eventlog");
        if ($57e66c5a34f265b4$var$gPerformanceRules.length > 0) $57e66c5a34f265b4$export$66bfaa30e4f0b4d8($57e66c5a34f265b4$var$gPerformanceRules, "performance", "update_eventlog");
        $57e66c5a34f265b4$var$gFilters.length;
        $57e66c5a34f265b4$var$gSlicerConditions.length;
        $57e66c5a34f265b4$var$gUpdateEventLog = false;
    } else $57e66c5a34f265b4$export$59798dda46c3d2b5(false, true, "initial load");
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $73396f25d03f3d4e$export$68b36b6fd6d0f5b2)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
//console.log('finaliseEventLog: ' + (Date.now() - startTime) / 1000);
}
function $57e66c5a34f265b4$export$77c5dcb67398492b() {
    $57e66c5a34f265b4$var$gEventLogID = "";
    $57e66c5a34f265b4$var$gComments = [];
    $57e66c5a34f265b4$var$gAutomationRules = [];
    $57e66c5a34f265b4$var$gCostRules = [];
    $57e66c5a34f265b4$var$gComplianceRules = [];
    $57e66c5a34f265b4$var$gFilterConditions = [];
    $57e66c5a34f265b4$var$gFilters = [];
    $57e66c5a34f265b4$var$gFilterSets = 0;
    $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
    $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
    $57e66c5a34f265b4$var$gTaskFilterTime = [];
    $57e66c5a34f265b4$var$gTaskFilterTasks = [];
    $57e66c5a34f265b4$var$gSlicerConditions = [];
    $57e66c5a34f265b4$var$gSelectedTransformationMapping = "";
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gGaugePercEvents = false;
    $57e66c5a34f265b4$var$gGaugePercTasks = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariants = false;
    $57e66c5a34f265b4$var$gGaugeXofYSteps = false;
    $57e66c5a34f265b4$var$gGaugeXofYActivities = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercCostSaving = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = false;
    $57e66c5a34f265b4$var$gGaugeCostSaving = false;
    $57e66c5a34f265b4$var$gGaugeActualCost = false;
    $57e66c5a34f265b4$var$gGaugeForecastCost = false;
    $57e66c5a34f265b4$var$gImportEventLogArray = [];
    $57e66c5a34f265b4$var$gTaskAttributes = [];
    $57e66c5a34f265b4$var$gEventAttributes = [];
    $57e66c5a34f265b4$var$gActivityArray = [];
    $57e66c5a34f265b4$var$gActivityIndexArray = [];
    $57e66c5a34f265b4$var$gStepArray = [];
    $57e66c5a34f265b4$var$gEventLogArray = [];
    $57e66c5a34f265b4$var$gVariantArray = [];
    $57e66c5a34f265b4$var$gTaskArray = [];
    $57e66c5a34f265b4$var$gMetricArray = [];
    $57e66c5a34f265b4$var$gAnalyticsTaskArray = [];
    $57e66c5a34f265b4$var$gAnalyticsEventArray = [];
    $57e66c5a34f265b4$export$2ff5de46d769d306("resetEventLog");
}
function $57e66c5a34f265b4$export$8834b66a455822a0() {
    $57e66c5a34f265b4$var$gComments = [];
    $57e66c5a34f265b4$var$gAutomationRules = [];
    $57e66c5a34f265b4$var$gCostRules = [];
    $57e66c5a34f265b4$var$gComplianceRules = [];
    $57e66c5a34f265b4$var$gPerformanceRules = [];
    $57e66c5a34f265b4$var$gFilterConditions = [];
    $57e66c5a34f265b4$var$gFilters = [];
    $57e66c5a34f265b4$var$gFilterSets = 0;
    $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
    $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
    $57e66c5a34f265b4$var$gTaskFilterTime = [];
    $57e66c5a34f265b4$var$gTaskFilterTasks = [];
    $57e66c5a34f265b4$var$gSlicerConditions = [];
    $57e66c5a34f265b4$var$gSelectedTransformationMapping = "";
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gGaugePercEvents = false;
    $57e66c5a34f265b4$var$gGaugePercTasks = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariants = false;
    $57e66c5a34f265b4$var$gGaugeXofYSteps = false;
    $57e66c5a34f265b4$var$gGaugeXofYActivities = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercCostSaving = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = false;
    $57e66c5a34f265b4$var$gGaugeCostSaving = false;
    $57e66c5a34f265b4$var$gGaugeActualCost = false;
    $57e66c5a34f265b4$var$gGaugeForecastCost = false;
    $57e66c5a34f265b4$export$1d0c870d910fd1d0();
    $57e66c5a34f265b4$var$processEventLog();
}
function $57e66c5a34f265b4$var$loadGridColumns() {
    $57e66c5a34f265b4$var$gStepGridColumns = [];
    let valueToPush = {};
    valueToPush["colId"] = "from_activity";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 120;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "to_activity";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 120;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "step";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 180;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "events";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "desc";
    valueToPush["width"] = 95;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "perc_total_events";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 98;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "loop";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 78;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "compliant";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 95;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "automated";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 95;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "avg_duration";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "event_cost_savings";
    valueToPush["visible"] = true;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "min_duration";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "max_duration";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "std_deviation";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "std_deviation";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "avg_duration_days";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "avg_duration_days";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "std_deviation_days";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "avg_duration_hrs";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "std_deviation_hrs";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 100;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "event_actual_cost";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "event_forecast_cost";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "step_actual_cost";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "step_forecast_cost";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "perc_events_compliant";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "perc_events_automated";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 110;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "events_compliant";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 90;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
    valueToPush = {};
    valueToPush["colId"] = "events_automated";
    valueToPush["visible"] = false;
    valueToPush["sort"] = "";
    valueToPush["width"] = 90;
    $57e66c5a34f265b4$var$gStepGridColumns.push(valueToPush);
}
function $57e66c5a34f265b4$var$arrayVariantID(variantArray, variantArrayIndex, variant, loops, steps) {
    if (variant == "" || variant == null) return;
    let variantID;
    let variantIndex;
    let variants = variantArray.length - 1;
    let index = variantArrayIndex.indexOf(variant, 0);
    if (index != -1) {
        variantID = variantArray[index].v;
        variantIndex = variantArray[index].id;
    } else {
        variants = variants + 1;
        let valueToPush = {};
        valueToPush["n"] = variant;
        valueToPush["v"] = variants;
        valueToPush["s"] = valueToPush["v"];
        valueToPush["t"] = 0;
        if (loops > 0) valueToPush["l"] = true;
        else valueToPush["l"] = false;
        valueToPush["d"] = false;
        valueToPush["id"] = variantArray.length;
        valueToPush["steps"] = steps - 1;
        variantArray.push(valueToPush);
        variantID = valueToPush["v"];
        variantIndex = valueToPush["id"];
        variantArrayIndex.push(variant);
    }
    return [
        variantArray,
        variantID,
        variantIndex,
        variantArrayIndex
    ];
}
function $57e66c5a34f265b4$var$importArrayStepUpdate(stepArray, stepArrayIndex, activity_source, activity_target) {
    //zzzz
    let stepID;
    let steps = stepArray.length - 1;
    let step = activity_source + "-" + activity_target;
    let index = stepArrayIndex.indexOf(step, 0);
    if (index != -1) stepID = stepArray[index].step;
    else {
        let valueToPush = {};
        valueToPush["f"] = activity_source;
        valueToPush["t"] = activity_target;
        valueToPush["l"] = false;
        valueToPush["d"] = false;
        valueToPush["c"] = true;
        valueToPush["s"] = steps;
        valueToPush["step"] = step;
        stepArray.push(valueToPush);
        stepID = steps;
        stepArrayIndex.push(step);
    }
    return [
        stepArray,
        stepID,
        stepArrayIndex
    ];
}
function $57e66c5a34f265b4$var$importArrayActivityID(activityArray, activityIndexArray, activity, start_node, end_node) {
    // zzzz
    if (activity == "" || activity == null) return;
    let activityID;
    let activities = activityArray.length - 1;
    let index = activityIndexArray.indexOf(activity, 0);
    if (index != -1) activityID = activityArray[index].id;
    else {
        let figure;
        if (start_node == true || end_node == true) figure = "Circle";
        else figure = "Border";
        activities = activities + 1;
        let valueToPush = {};
        valueToPush["activity"] = activity;
        valueToPush["id"] = activities;
        valueToPush["start_node"] = start_node;
        valueToPush["end_node"] = end_node;
        valueToPush["v"] = true;
        valueToPush["selected_tasks"] = 0;
        valueToPush["sliced_tasks"] = 0;
        valueToPush["tasks"] = 0;
        valueToPush["f"] = figure;
        activityArray.push(valueToPush);
        activityID = activities;
        activityIndexArray.push(activity);
    }
    return [
        activityArray,
        activityID,
        activityIndexArray
    ];
}
function $57e66c5a34f265b4$export$3f66ecfa32892985() {
    let tArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskAttributes.length; i++){
        let valueToPush = {};
        valueToPush["value"] = $57e66c5a34f265b4$var$gTaskAttributes[i].field;
        valueToPush["label"] = $57e66c5a34f265b4$var$gTaskAttributes[i].field;
        tArray.push(valueToPush);
    }
    return tArray;
}
function $57e66c5a34f265b4$export$b05f54e556e2eadb() {
    let tArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventAttributes.length; i++){
        let valueToPush = {};
        valueToPush["value"] = $57e66c5a34f265b4$var$gEventAttributes[i].field;
        valueToPush["label"] = $57e66c5a34f265b4$var$gEventAttributes[i].field;
        tArray.push(valueToPush);
    }
    return tArray;
}
function $57e66c5a34f265b4$export$ecf224330435bd6e() {
    let tArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskAttributes.length; i++){
        let valueToPush = {};
        valueToPush["value"] = $57e66c5a34f265b4$var$gTaskAttributes[i].field;
        valueToPush["label"] = $57e66c5a34f265b4$var$gTaskAttributes[i].field;
        tArray.push(valueToPush);
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventAttributes.length; i1++){
        let valueToPush1 = {};
        valueToPush1["value"] = $57e66c5a34f265b4$var$gEventAttributes[i1].field;
        valueToPush1["label"] = $57e66c5a34f265b4$var$gEventAttributes[i1].field;
        tArray.push(valueToPush1);
    }
    return tArray;
}
function $57e66c5a34f265b4$export$affefed35765a709(eventEmitter) {
    $57e66c5a34f265b4$var$gEventEmitter = eventEmitter;
}
function $57e66c5a34f265b4$export$42e0d87b3bb491d0() {
    return $57e66c5a34f265b4$var$gEventEmitter;
}
function $57e66c5a34f265b4$export$2cd8252107eb640b() {
    $57e66c5a34f265b4$var$gInitialLoad = true;
    $57e66c5a34f265b4$var$gRebuildCtr = 0;
    $57e66c5a34f265b4$var$gVariantSlicerGridState = null;
    $57e66c5a34f265b4$var$gStepSlicerGridState = null;
    $57e66c5a34f265b4$var$gActivitySlicerGridState = null;
    $57e66c5a34f265b4$var$gTaskSlicerGridState = null;
    $57e66c5a34f265b4$var$gTaskAttributeFilterGridState = null;
    $57e66c5a34f265b4$var$gEventAttributeFilterGridState = null;
    $57e66c5a34f265b4$var$gProcessRulesGridState = null;
    $57e66c5a34f265b4$var$gCostRulesGridState = null;
    $57e66c5a34f265b4$var$gIsolateVariant = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = 0;
    $57e66c5a34f265b4$var$gLifecycleVariant = 0;
    $57e66c5a34f265b4$var$gInsightsAttributeArray = [];
    $57e66c5a34f265b4$var$gInsightsAttributes = [];
    $57e66c5a34f265b4$var$gInsightsValueType = "high";
    $57e66c5a34f265b4$var$gInsightsMinMetric = 0;
    $57e66c5a34f265b4$var$gInsightsMaxMetric = 999999999;
    $57e66c5a34f265b4$var$gInsightsRows = 10;
    $57e66c5a34f265b4$var$gTaskID = "";
    $57e66c5a34f265b4$var$gDecompositionTreeTaskArray = [];
    $57e66c5a34f265b4$var$gDecompositionTreeValueType = "high";
    $57e66c5a34f265b4$var$gDecompositionTreeMinMetric = 0;
    $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric = 999999999;
    $57e66c5a34f265b4$var$gDecompositionTreeAttribute = "";
    $57e66c5a34f265b4$var$gDecompositionTreeMetric = 1;
    $57e66c5a34f265b4$var$gRCDescription = "";
    $57e66c5a34f265b4$var$gHistogramDescription = "";
    $57e66c5a34f265b4$var$gInfluenceAnalysisAttributes = [];
    $57e66c5a34f265b4$var$gInfluenceAnalysisMetric = 3;
    $57e66c5a34f265b4$var$gInfluenceAnalysisInfluence = "increase";
    $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric = 0;
    $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric = 999999999;
    $57e66c5a34f265b4$var$gShowDurationDays = true;
    $57e66c5a34f265b4$var$gShowDurationHours = true;
    $57e66c5a34f265b4$var$gShowDurationMinutes = true;
    $57e66c5a34f265b4$var$gShowDurationSeconds = false;
    $57e66c5a34f265b4$var$gStepWidthTasks = false;
    $57e66c5a34f265b4$var$gStepWidthDuration = true;
    $57e66c5a34f265b4$var$gStepWidthStdDeviation = false;
    $57e66c5a34f265b4$var$gHighlightLoops = false;
    $57e66c5a34f265b4$var$gHighlightNonCompliance = false;
    $57e66c5a34f265b4$var$gHighlightAutomation = false;
    $57e66c5a34f265b4$var$gStepColourVolume = false;
    $57e66c5a34f265b4$var$gStepColourCost = false;
    $57e66c5a34f265b4$var$gStepColourDuration = true;
    $57e66c5a34f265b4$var$gStepColourStdDeviation = false;
    $57e66c5a34f265b4$var$gAnalyticsModeFiltered = false;
    $57e66c5a34f265b4$var$gAnalyticsModeSliced = true;
    $57e66c5a34f265b4$var$gAnalyticsModeSelected = false;
    $57e66c5a34f265b4$var$gDurationLabel = "hrs";
    $57e66c5a34f265b4$var$gActiveAction = "process_visualizer";
    $57e66c5a34f265b4$var$gVariantsVisualizationGraphType = 1;
    $57e66c5a34f265b4$var$gVariantsVisualizationMetric = 1;
    $57e66c5a34f265b4$var$gTasksVisualizationGraphType = 1;
    $57e66c5a34f265b4$var$gTasksVisualizationMetric = 1;
    $57e66c5a34f265b4$var$gTasksVisualizationFilter = 0;
    $57e66c5a34f265b4$var$gTasksVisualizationNumTasks = 50;
    $57e66c5a34f265b4$var$gTasksVisualizationSource = "";
    $57e66c5a34f265b4$var$gTasksVisualizationSort = 0;
    if ($57e66c5a34f265b4$var$gEnvironment === "ServiceNow") $lR8r2$gojs.Diagram.licenseKey = "2bf840e7ba6558c511d35a25403e7efb0eab2d66cf814ef4590017f0ed5c3a1c27cce17d54da8995d2fe49fb187cd2c9dbc739219745526eb331d0d943b28ff8b7607ae6110f438ca40b21919af27aa8f87826f2c0bd71a28f78d9f5eea993ce4ef8f58118cc0ee979791421557fac4aa8f8c678fc";
    if ($57e66c5a34f265b4$var$gEnvironment === "SaaS") $lR8r2$gojs.Diagram.licenseKey = "2bf840e7ba6558c511d35a25403e7efb0fa52d66cf874ef0590017f0ec5c601223cce17155d28d94c0e848fe4a75c0d08a903d299449056bee30d68b4ab683feb63573ba135a4486f40a22c3cefa28a9fa7824f297b272a38a2a9ee2edfd939a5cbaa3d55ada0dba2a7b1936497d";
    $57e66c5a34f265b4$var$loadDiagramDecompositionTree();
    $57e66c5a34f265b4$var$loadDiagramInsights();
    $57e66c5a34f265b4$var$loadDiagramInfluenceAnalysis();
    let $ = $lR8r2$gojs.GraphObject.make;
    // process visualizer diagram
    const getDiagramContextMenuOptions = ()=>{
        return [
            {
                text: "Analyze",
                subMenuOptions: [
                    {
                        text: "Decompose",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("diagram", true, 0, 0, 0, 0, 0);
                            $57e66c5a34f265b4$export$e72c0f9a78feacad("diagram");
                            let data = $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.nodeDataArray[0];
                            $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.set(data, "value", $57e66c5a34f265b4$var$gTaskSlicedArray.length);
                        }
                    },
                    {
                        text: "Insights",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("diagram", true, 0, 0, 0, 0, 0);
                            $57e66c5a34f265b4$export$a5b1f71afbc1817b("diagram");
                        }
                    },
                    {
                        text: "Influencers",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("diagram", true, 0, 0, 0, 0, 0);
                            $57e66c5a34f265b4$export$af63db901586cc00("diagram");
                        }
                    }, 
                ]
            },
            {
                text: "Histogram",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("diagram-tasks", true, 0, 0, 0, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("diagram-events", true, 0, 0, 0, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "diagram";
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "diagram";
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Zoom to fit",
                event: ()=>{
                    $57e66c5a34f265b4$var$gDiagramPV.zoomToFit();
                }
            }, 
        ];
    };
    const contextMenuPEDiagram = $($lR8r2$gojs.HTMLInfo, {
        show: (obj, diagram)=>{
            const { x: x , y: y  } = diagram.lastInput.viewPoint;
            const options = getDiagramContextMenuOptions;
            if (options) (0, $a88d26ee1331adae$export$565dd6bf3240914a)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                x: x,
                y: y,
                options: options
            });
        },
        hide: (diagram)=>{
            (0, $a88d26ee1331adae$export$a70b79ee19e88cfe)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter
            });
        }
    });
    $57e66c5a34f265b4$var$gDiagramPV = $($lR8r2$gojs.Diagram, {
        defaultScale: 2,
        contextMenu: contextMenuPEDiagram,
        defaultScale: 2,
        initialAutoScale: $lR8r2$gojs.Diagram.Uniform,
        layout: $($lR8r2$gojs.LayeredDigraphLayout, {
            direction: 90
        }),
        scrollMode: $lR8r2$gojs.Diagram.InfiniteScroll,
        contentAlignment: $lR8r2$gojs.Spot.Center,
        linkReshapingTool: new (0, $4d109d655b676189$export$1e91461216c4f1a2)(),
        "undoManager.isEnabled": true
    });
    $57e66c5a34f265b4$var$gDiagramPV.div = "gDiagramDivPV";
    $57e66c5a34f265b4$var$gCurrentDiagram = $57e66c5a34f265b4$var$gDiagramPV;
    $57e66c5a34f265b4$var$gDiagramPV.toolManager.mouseWheelBehavior = $lR8r2$gojs.ToolManager.WheelZoom;
    $57e66c5a34f265b4$var$gDiagramPV.toolManager.hoverDelay = 500;
    $57e66c5a34f265b4$var$gDiagramPV.toolManager.toolTipDuration = 10000;
    $57e66c5a34f265b4$var$gDiagramPV.addDiagramListener("ViewportBoundsChanged", function(e) {
        e.diagram.commit(function(dia) {
            dia.parts.each(function(part) {
                if (part._viewPosition) {
                    part.position = dia.transformViewToDoc(part._viewPosition);
                    part.scale = 1 / dia.scale;
                }
            });
        }, "fix Parts");
    });
    const getNodeContextMenuOptions = ({ data: { key: key , activity: activity  }  })=>{
        if (key < 2) return;
        return [
            {
                text: "Analyze",
                subMenuOptions: [
                    {
                        text: "Decompose",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("activity", true, 0, key, 0, 0, 0);
                            $57e66c5a34f265b4$export$e72c0f9a78feacad("activity");
                            let data = $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.nodeDataArray[0];
                            $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.set(data, "value", $57e66c5a34f265b4$var$gTaskSlicedArray.length);
                        }
                    },
                    {
                        text: "Insights",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("activity", true, 0, key, 0, 0, 0);
                            $57e66c5a34f265b4$export$a5b1f71afbc1817b("activity");
                        }
                    },
                    {
                        text: "Influencers",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("activity", true, 0, key, 0, 0, 0);
                            $57e66c5a34f265b4$export$af63db901586cc00("activity");
                        }
                    },
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + " Lifecycle",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("activity", true, 0, key, 0, 0, 0);
                            $57e66c5a34f265b4$var$gTasksVisualizationSource = "activity";
                            $57e66c5a34f265b4$export$63db7e18015c9f49();
                            (0, $7a9d81ef95270803$export$2c7243b488bf9a8f)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Histogram",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("activity-tasks", true, 0, key, 0, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("activity-events", true, 0, key, 0, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Slicer",
                subMenuOptions: [
                    {
                        text: "Include",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            let tempArray = [];
                            let valueToPush = {};
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) valueToPush["activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                            tempArray.push(valueToPush);
                            $57e66c5a34f265b4$var$gActivitySelectRetention = "include";
                            $57e66c5a34f265b4$export$f1b23d69b077eb32(tempArray);
                            $57e66c5a34f265b4$export$f39f7d9ecc34d6d6("ActivitiesDiagram");
                            (0, $00c859d90ab8eb90$export$72b11836dae7a069)({
                                pane: "ActivitiesDiagram",
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            (0, $25932cd9e0940c69$export$4ca2e78d5d0601b1)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            $57e66c5a34f265b4$export$2ff5de46d769d306();
                        }
                    },
                    {
                        text: "Exclude",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            let tempArray = [];
                            let valueToPush = {};
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) valueToPush["activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                            tempArray.push(valueToPush);
                            $57e66c5a34f265b4$var$gActivitySelectRetention = "exclude";
                            $57e66c5a34f265b4$export$f1b23d69b077eb32(tempArray);
                            $57e66c5a34f265b4$export$f39f7d9ecc34d6d6("ActivitiesDiagram");
                            (0, $00c859d90ab8eb90$export$72b11836dae7a069)({
                                pane: "ActivitiesDiagram",
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            (0, $25932cd9e0940c69$export$4ca2e78d5d0601b1)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            $57e66c5a34f265b4$export$2ff5de46d769d306();
                        }
                    }, 
                ]
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gDetailSource = "activity";
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gDetailSource = "activity";
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Comments...",
                event: ()=>{
                    (0, $36137601356fae9a$export$47f0c77b95671aeb)({
                        data: {
                            activity: key
                        }
                    });
                }
            },
            {
                text: "Inbound Steps",
                subMenuOptions: [
                    {
                        text: "All Variants",
                        event: ()=>{
                            // check if the div has a diagram associated with it (or create new one?)
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Inbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].tasks / $57e66c5a34f265b4$var$gTasksFiltered, 1) + " of " + $57e66c5a34f265b4$var$gEntityLower + "s";
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_inbound_all");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_inbound_all");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " came from " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Inbound",
                                    title: "Activity Inbound Step Analysis - All Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    },
                    {
                        text: "Sliced Variants",
                        event: ()=>{
                            // check if the div has a diagram associated with it (or create new one?)
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Inbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].tasks / $57e66c5a34f265b4$var$gVariantTasksSliced, 1) + " of " + $57e66c5a34f265b4$var$gEntityLower + "s";
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_inbound_sliced");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_inbound_sliced");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " came from " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Inbound",
                                    title: "Activity Inbound Step Analysis - Sliced Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    },
                    {
                        text: "Selected Variants",
                        event: ()=>{
                            // check if the div has a diagram associated with it (or create new one?)
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Inbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].selected_tasks / $57e66c5a34f265b4$var$gDiagramPVTasks, 1) + " of " + $57e66c5a34f265b4$var$gEntityLower + "s";
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_inbound_selected");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_inbound_selected");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " came from " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Inbound",
                                    title: "Activity Inbound Step Analysis - Selected Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Outbound Steps",
                subMenuOptions: [
                    {
                        text: "All Variants",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Outbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].tasks / $57e66c5a34f265b4$var$gTasksFiltered, 1) + " of tasks";
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_outbound_all");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_outbound_all");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " go to " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Outbound",
                                    title: "Activity Outbound Step Analysis - All Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    },
                    {
                        text: "Sliced Variants",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Outbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].tasks / $57e66c5a34f265b4$var$gVariantTasksSliced), $57e66c5a34f265b4$var$gEntityLower;
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_outbound_sliced");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_outbound_sliced");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " go to " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Outbound",
                                    title: "Activity Outbound Step Analysis - Sliced Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    },
                    {
                        text: "Selected Variants",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailActivity = key;
                            $57e66c5a34f265b4$var$gASAType = "Outbound";
                            let activity = "";
                            let percOccurrence = "";
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == key) {
                                activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                percOccurrence = "Occurs in " + $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gActivityArray[j].selected_tasks / $57e66c5a34f265b4$var$gDiagramPVTasks, 1) + " of " + $57e66c5a34f265b4$var$gEntityLower + "s";
                            }
                            $57e66c5a34f265b4$var$gASALinks = $57e66c5a34f265b4$var$generateLinks("activity_outbound_selected");
                            $57e66c5a34f265b4$var$gASANodes = $57e66c5a34f265b4$var$generateNodes("activity_outbound_selected");
                            let maxActivityTasks = "";
                            let maxTasks = 0;
                            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASANodes.length; j1++)if ($57e66c5a34f265b4$var$gASANodes[j1].tasks > maxTasks && activity != $57e66c5a34f265b4$var$gASANodes[j1].activity) {
                                maxActivityTasks = $57e66c5a34f265b4$export$3e1eee59f5dc52be($57e66c5a34f265b4$var$gASANodes[j1].tasks / $57e66c5a34f265b4$var$gASANodes[j1].detailActivityTasks, 1) + " go to " + $57e66c5a34f265b4$var$gASANodes[j1].activity;
                                maxTasks = $57e66c5a34f265b4$var$gASANodes[j1].tasks;
                            }
                            (0, $3963ce130f59481d$export$22b641de72ccf547)({
                                data: {
                                    type: "Outbound",
                                    title: "Activity Outbound Step Analysis - Selected Variants",
                                    activity: activity,
                                    occurrence: percOccurrence,
                                    max_activity_tasks: maxActivityTasks
                                }
                            });
                        }
                    }, 
                ]
            }, 
        ];
    };
    const getLinkContextMenuOptions = ({ data: { from: from , to: to , min_duration: min_duration , max_duration: max_duration , end_node: end_node , start_node: start_node , from_label: from_label , to_label: to_label  }  })=>{
        if (end_node) return;
        return [
            {
                text: "Analyze",
                subMenuOptions: [
                    {
                        text: "Decompose",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("step", true, 0, 0, from, to, 0);
                            $57e66c5a34f265b4$export$e72c0f9a78feacad("step");
                            let data = $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.nodeDataArray[0];
                            $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.set(data, "value", $57e66c5a34f265b4$var$gTaskSlicedArray.length);
                        }
                    },
                    {
                        text: "Insights",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("step", true, 0, 0, from, to, 0);
                            $57e66c5a34f265b4$export$a5b1f71afbc1817b("step");
                        }
                    },
                    {
                        text: "Influencers",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("step", true, 0, 0, from, to, 0);
                            $57e66c5a34f265b4$export$af63db901586cc00("step");
                        }
                    },
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + " Lifecycle",
                        event: ()=>{
                            $57e66c5a34f265b4$export$361dfb4e2f54323d("step", true, 0, 0, from, to, 0);
                            $57e66c5a34f265b4$var$gTasksVisualizationSource = "step";
                            $57e66c5a34f265b4$export$63db7e18015c9f49();
                            (0, $7a9d81ef95270803$export$2c7243b488bf9a8f)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Histogram",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("step-tasks", true, 0, 0, from, to, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    },
                    {
                        text: " Events",
                        event: ()=>{
                            $57e66c5a34f265b4$export$70569108c74b0b00("step-events", true, 0, 0, from, to, 0);
                            (0, $d3bbc7b58d319491$export$4be85c05a5dbddd8)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Slicer",
                subMenuOptions: [
                    {
                        text: "Include",
                        event: ()=>{
                            let tempArray = [];
                            let valueToPush = {};
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
                                if ($57e66c5a34f265b4$var$gActivityArray[j].id == from) valueToPush["from_activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                if ($57e66c5a34f265b4$var$gActivityArray[j].id == to) valueToPush["to_activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                            }
                            tempArray.push(valueToPush);
                            $57e66c5a34f265b4$var$gStepSelectRetention = "include";
                            $57e66c5a34f265b4$export$abce13b877a5437d(tempArray);
                            $57e66c5a34f265b4$export$f39f7d9ecc34d6d6("StepsDiagram");
                            (0, $00c859d90ab8eb90$export$72b11836dae7a069)({
                                pane: "StepsDiagram",
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            (0, $25932cd9e0940c69$export$4ca2e78d5d0601b1)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            $57e66c5a34f265b4$export$2ff5de46d769d306();
                        }
                    },
                    {
                        text: "Exclude",
                        event: ()=>{
                            let tempArray = [];
                            let valueToPush = {};
                            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
                                if ($57e66c5a34f265b4$var$gActivityArray[j].id == from) valueToPush["from_activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                                if ($57e66c5a34f265b4$var$gActivityArray[j].id == to) valueToPush["to_activity"] = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                            }
                            tempArray.push(valueToPush);
                            $57e66c5a34f265b4$var$gStepSelectRetention = "exclude";
                            $57e66c5a34f265b4$export$abce13b877a5437d(tempArray);
                            $57e66c5a34f265b4$export$f39f7d9ecc34d6d6("StepsDiagram");
                            (0, $00c859d90ab8eb90$export$72b11836dae7a069)({
                                pane: "StepsDiagram",
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            (0, $25932cd9e0940c69$export$4ca2e78d5d0601b1)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                            });
                            $57e66c5a34f265b4$export$2ff5de46d769d306();
                        }
                    }, 
                ]
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailNodeFrom = from;
                            $57e66c5a34f265b4$var$gDetailNodeTo = to;
                            $57e66c5a34f265b4$var$gDetailSource = "step";
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailNodeFrom = from;
                            $57e66c5a34f265b4$var$gDetailNodeTo = to;
                            $57e66c5a34f265b4$var$gDetailSource = "step";
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Comments...",
                event: ()=>{
                    (0, $3c999e7965156ff8$export$c30d13083a8bce5d)({
                        data: {
                            fromNode: from,
                            toNode: to
                        }
                    });
                }
            },
            {
                text: "Process Rules",
                subMenuOptions: [
                    {
                        text: "Compliance...",
                        event: ()=>{
                            let rule = "Non compliant: " + from_label + " -> " + to_label;
                            let variantType = "all_variants";
                            let taskType = "all_tasks";
                            let durationOperator = "N/A";
                            let durationActualFrom = 0;
                            let durationActualTo = 0;
                            let durationValue = "hrs";
                            let calculateCostImpact = false;
                            if ($57e66c5a34f265b4$var$gFilterConditions.length > 0) taskType = "filtered_tasks";
                            let mode = "new";
                            (0, $2e988fe81abc0213$export$26b82a75aae6bfed)({
                                data: {
                                    rule: rule,
                                    fromNode: from,
                                    toNode: to,
                                    fromNodeStr: from_label,
                                    toNodeStr: to_label,
                                    filterLoops: false,
                                    calculateCostImpact: calculateCostImpact,
                                    variantType: variantType,
                                    taskType: taskType,
                                    durationOperator: durationOperator,
                                    durationActualFrom: durationActualFrom,
                                    durationActualTo: durationActualTo,
                                    durationValue: durationValue,
                                    mode: mode
                                }
                            });
                        }
                    },
                    {
                        text: "Automation...",
                        event: ()=>{
                            let rule = "Automation: " + from_label + " -> " + to_label;
                            let variantType = "all_variants";
                            let taskType = "all_tasks";
                            let durationOperator = "N/A";
                            let durationActualFrom = 0;
                            let durationActualTo = 0;
                            let durationValue = "hrs";
                            let calculateCostImpact = false;
                            if ($57e66c5a34f265b4$var$gFilterConditions.length > 0) taskType = "filtered_tasks";
                            let mode = "new";
                            (0, $d2cffb3e3e561271$export$b8eacc044a97fdf9)({
                                data: {
                                    rule: rule,
                                    fromNode: from,
                                    toNode: to,
                                    fromNodeStr: from_label,
                                    toNodeStr: to_label,
                                    calculateCostImpact: calculateCostImpact,
                                    variantType: variantType,
                                    taskType: taskType,
                                    durationOperator: durationOperator,
                                    durationActualFrom: durationActualFrom,
                                    durationActualTo: durationActualTo,
                                    durationValue: durationValue,
                                    mode: mode
                                }
                            });
                        }
                    },
                    {
                        text: "Performance...",
                        event: ()=>{
                            let rule = "Performance: " + from_label + " -> " + to_label;
                            let variantType = "all_variants";
                            let taskType = "all_tasks";
                            let durationOperator = "N/A";
                            let durationActualFrom = 0;
                            let durationActualTo = 0;
                            let durationValue = "hrs";
                            let durationReductionType = "N/A";
                            let durationReductionPercentage = 100;
                            let durationReductionActual = 0;
                            let durationReductionValue = "hrs";
                            let calculateCostImpact = false;
                            if ($57e66c5a34f265b4$var$gFilterConditions.length > 0) taskType = "filtered_tasks";
                            let mode = "new";
                            (0, $1200978695fc35a8$export$9c10e13e2df2501e)({
                                data: {
                                    rule: rule,
                                    fromNode: from,
                                    toNode: to,
                                    fromNodeStr: from_label,
                                    toNodeStr: to_label,
                                    filterLoops: false,
                                    calculateCostImpact: calculateCostImpact,
                                    variantType: variantType,
                                    taskType: taskType,
                                    durationOperator: durationOperator,
                                    durationActualFrom: durationActualFrom,
                                    durationActualTo: durationActualTo,
                                    durationValue: durationValue,
                                    durationReductionType: durationReductionType,
                                    durationReductionActual: durationReductionActual,
                                    durationReductionPercentage: durationReductionPercentage,
                                    durationReductionValue: durationReductionValue,
                                    mode: mode
                                }
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Cost Rules...",
                event: ()=>{
                    let rule = "Cost: " + from_label + " -> " + to_label;
                    let costType = "total";
                    let variantType = "all_variants";
                    let taskType = "all_tasks";
                    if ($57e66c5a34f265b4$var$gFilterConditions.length > 0) taskType = "filtered_tasks";
                    let actualCost = 0;
                    let attribute = "";
                    let mode = "new";
                    (0, $b66f0c13307de446$export$5d3a507e32e0a59b)({
                        data: {
                            rule: rule,
                            fromNode: from,
                            toNode: to,
                            fromNodeStr: from_label,
                            toNodeStr: to_label,
                            actualCost: actualCost,
                            attribute: attribute,
                            costType: costType,
                            variantType: variantType,
                            taskType: taskType,
                            mode: mode
                        }
                    });
                }
            }, 
        ];
    };
    let contextMenuObj = null;
    const contextMenuPE = $($lR8r2$gojs.HTMLInfo, {
        show: (obj, diagram)=>{
            const { x: x , y: y  } = diagram.lastInput.viewPoint;
            const options = obj.part instanceof $lR8r2$gojs.Link ? getLinkContextMenuOptions(obj) : getNodeContextMenuOptions(obj);
            diagram.toolManager.hideToolTip();
            contextMenuObj && diagram.model.set(contextMenuObj.part.data, "disableTooltip", false);
            contextMenuObj = obj;
            diagram.model.set(obj.part.data, "disableTooltip", true);
            if (options) (0, $a88d26ee1331adae$export$565dd6bf3240914a)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                x: x,
                y: y,
                options: options
            });
        },
        hide: (diagram)=>{
            diagram.model.set(contextMenuObj.part.data, "disableTooltip", false);
            contextMenuObj = null;
            (0, $a88d26ee1331adae$export$a70b79ee19e88cfe)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter
            });
        }
    });
    $57e66c5a34f265b4$var$gDiagramPV.nodeTemplate = $($lR8r2$gojs.Node, "Auto", {
        locationSpot: $lR8r2$gojs.Spot.Center,
        isShadowed: true,
        contextMenu: contextMenuPE
    }, $($lR8r2$gojs.Shape, new $lR8r2$gojs.Binding("figure", "figure"), {
        stroke: "lightgray"
    }, new $lR8r2$gojs.Binding("fill", "fill_color"), new $lR8r2$gojs.Binding("border", "text_color")), {
        toolTip: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: "white",
            stroke: "gray",
            strokeWidth: 1
        }), $($lR8r2$gojs.TextBlock, {
            margin: 4,
            font: "9pt helvetica, arial, sans-serif"
        }, new $lR8r2$gojs.Binding("text", "tooltip")), new $lR8r2$gojs.Binding("visible", "disableTooltip", (disableTooltip)=>!disableTooltip))
    }, $($lR8r2$gojs.TextBlock, new $lR8r2$gojs.Binding("font", "font"), {
        textAlign: "center",
        margin: 3
    }, new $lR8r2$gojs.Binding("text"), new $lR8r2$gojs.Binding("stroke", "text_color"), new $lR8r2$gojs.Binding("visible", "visible")), {
        selectionAdornmentTemplate: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: null
        }, new $lR8r2$gojs.Binding("stroke", "highlight_color"), new $lR8r2$gojs.Binding("strokeWidth", "highlight_width")), $($lR8r2$gojs.Placeholder))
    });
    $57e66c5a34f265b4$var$gDiagramPV.nodeTemplateMap.add("token", $($lR8r2$gojs.Part, {
        locationSpot: $lR8r2$gojs.Spot.Center,
        layerName: "Foreground"
    }, $($lR8r2$gojs.Shape, "Circle", {
        width: 10,
        height: 10,
        strokeWidth: 0
    }, new $lR8r2$gojs.Binding("fill", "color"))));
    $57e66c5a34f265b4$var$gDiagramPV.linkTemplate = $($lR8r2$gojs.Link, {
        curve: $lR8r2$gojs.Link.Bezier,
        reshapable: true,
        adjusting: $lR8r2$gojs.Link.Stretch,
        contextMenu: contextMenuPE
    }, $($lR8r2$gojs.Shape, new $lR8r2$gojs.Binding("stroke", "link_color"), new $lR8r2$gojs.Binding("strokeWidth", "width"), new $lR8r2$gojs.Binding("visible", "visible"), new $lR8r2$gojs.Binding("strokeDashArray", "dashes", function(l) {
        return l ? [
            3,
            2
        ] : null;
    })), $($lR8r2$gojs.Shape, {
        toArrow: "standard",
        strokeWidth: 0
    }, new $lR8r2$gojs.Binding("fill", "link_color")), {
        toolTip: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: "white",
            stroke: "gray",
            strokeWidth: 1
        }), $($lR8r2$gojs.TextBlock, {
            margin: 4,
            font: "9pt helvetica, arial, sans-serif"
        }, new $lR8r2$gojs.Binding("text", "tooltip")), new $lR8r2$gojs.Binding("visible", "disableTooltip", (disableTooltip)=>!disableTooltip))
    }, {
        selectionAdornmentTemplate: $($lR8r2$gojs.Adornment, $($lR8r2$gojs.Shape, {
            isPanelMain: true
        }, new $lR8r2$gojs.Binding("stroke", "highlight_color"), new $lR8r2$gojs.Binding("strokeWidth", "width")))
    }, $($lR8r2$gojs.Panel, "Auto", $($lR8r2$gojs.Shape, {
        fill: $($lR8r2$gojs.Brush, "Radial", {
            0: "rgb(240, 240, 240)",
            0.3: "rgb(240, 240, 240)",
            1: "rgba(240, 240, 240, 0)"
        }),
        stroke: null
    }), $($lR8r2$gojs.TextBlock, {
        textAlign: "center",
        margin: 8
    }, new $lR8r2$gojs.Binding("font", "font"), new $lR8r2$gojs.Binding("visible", "label_visible"), new $lR8r2$gojs.Binding("text", "link_label"))));
    $57e66c5a34f265b4$export$31b8020222843e64();
    $57e66c5a34f265b4$export$2ff5de46d769d306("init");
    if ($57e66c5a34f265b4$var$gAutomationRules.length > 0) {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $99061afdb4accbec$export$77472d31d2b1bbaf)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if ($57e66c5a34f265b4$var$gComplianceRules.length > 0) {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8b3a953f334c1c39$export$88d9d129a5d66a46)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if ($57e66c5a34f265b4$var$gCostRules.length > 0) {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if ($57e66c5a34f265b4$var$gFilters.length > 0) {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $d2f53bbeaa179f7b$export$75243dbf83fd9c73)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if ($57e66c5a34f265b4$var$gSlicerConditions.length > 0) {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b66a047d967ee84$export$8a2275d15ee60ada)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    return {
        diagram: $57e66c5a34f265b4$var$gDiagramPV
    };
}
function $57e66c5a34f265b4$export$e72c0f9a78feacad(source) {
    if (source != "step" && source != "activity" && source != "variant" && source != "diagram" && source != "rule") $57e66c5a34f265b4$export$361dfb4e2f54323d("dt", false);
    $57e66c5a34f265b4$var$gMinDiagramWidth = 880;
    (0, $2943124c9da1a68a$export$27ecb0c54ca94007)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    $57e66c5a34f265b4$export$35652a5bbda27ca0();
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.model = new $lR8r2$gojs.TreeModel([
        {
            key: 1,
            label: $57e66c5a34f265b4$var$gEntityUpper + "s",
            value: $57e66c5a34f265b4$var$gTaskSlicedArray.length,
            perc: "100%",
            tooltip: "",
            attribute: "parentNode",
            everExpanded: false,
            width: 185,
            rootdistance: 0
        }, 
    ]);
    $57e66c5a34f265b4$var$gCurrentDiagram = $57e66c5a34f265b4$var$gDiagramDecompositionTree;
}
function $57e66c5a34f265b4$export$a5b1f71afbc1817b(source) {
    if (source != "step" && source != "activity" && source != "variant" && source != "diagram" && source != "rule") $57e66c5a34f265b4$export$361dfb4e2f54323d("is", false);
    $57e66c5a34f265b4$var$gMinDiagramWidth = 880;
    (0, $6618f47ab26c0e61$export$4410bdeeb8d80944)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    $57e66c5a34f265b4$export$e22f012476996d14();
    $57e66c5a34f265b4$var$gCurrentDiagram = $57e66c5a34f265b4$var$gDiagramInsights;
}
function $57e66c5a34f265b4$export$af63db901586cc00(source) {
    if (source != "step" && source != "activity" && source != "variant" && source != "diagram" && source != "rule") $57e66c5a34f265b4$export$361dfb4e2f54323d("ia", false);
    $57e66c5a34f265b4$var$gMinDiagramWidth = 880;
    (0, $298c7561664e4490$export$ade6891da9d6ea5c)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    $57e66c5a34f265b4$export$b693c597fa907dbc();
    $57e66c5a34f265b4$var$gCurrentDiagram = $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis;
}
function $57e66c5a34f265b4$export$eaf358d737cb394b() {
    $57e66c5a34f265b4$var$gMinDiagramWidth = 400;
    (0, $4418db1243d61fd1$export$17b3808e0ffc259c)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    $57e66c5a34f265b4$export$2ff5de46d769d306("setDiagramProcessVisualizer");
    $57e66c5a34f265b4$var$gCurrentDiagram = $57e66c5a34f265b4$var$gDiagramPV;
}
function $57e66c5a34f265b4$var$conditionsArray(ruleType, ruleArray, variantType, taskType, fromActivity, toActivity) {
    //xxxx
    let valueToPush = {};
    let conditions = [];
    valueToPush = {};
    valueToPush["header"] = 1;
    valueToPush["text"] = "Step:";
    conditions.push(valueToPush);
    valueToPush = {};
    valueToPush["header"] = 0;
    valueToPush["text"] = fromActivity + " -> " + toActivity;
    conditions.push(valueToPush);
    $57e66c5a34f265b4$var$gVariantPaneVariants.sort((a, b)=>a.s - b.s);
    if (variantType == "selected_variants") {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "Selected variants:";
        conditions.push(valueToPush);
        for(let k = 0; k < $57e66c5a34f265b4$var$gVariantPaneVariants.length; k++){
            valueToPush = {};
            valueToPush["header"] = 0;
            valueToPush["text"] = $57e66c5a34f265b4$var$gVariantPaneVariants[k].s + ": " + $57e66c5a34f265b4$var$gVariantPaneVariants[k].n;
            conditions.push(valueToPush);
        }
    }
    if (variantType == "sliced_variants") {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "Sliced variants:";
        conditions.push(valueToPush);
        for(let k1 = 0; k1 < $57e66c5a34f265b4$var$gSlicerConditions.length; k1++){
            valueToPush = {};
            valueToPush["header"] = 0;
            valueToPush["text"] = $57e66c5a34f265b4$var$gSlicerConditions[k1].description;
            conditions.push(valueToPush);
        }
    }
    if (variantType == "all_variants") {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "All variants";
        conditions.push(valueToPush);
    }
    // task attributes
    if (taskType == "filtered_tasks") {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "Filtered tasks:";
        conditions.push(valueToPush);
        for(let k2 = 0; k2 < $57e66c5a34f265b4$var$gFilterConditions.length; k2++){
            valueToPush = {};
            valueToPush["header"] = 0;
            valueToPush["text"] = $57e66c5a34f265b4$var$gFilterConditions[k2].description;
            conditions.push(valueToPush);
        }
    } else {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "All tasks";
        conditions.push(valueToPush);
    }
    if (ruleType != "cost") {
        if (ruleArray.durationOperator != "N/A") {
            valueToPush = {};
            valueToPush["header"] = 1;
            valueToPush["text"] = "Duration:";
            conditions.push(valueToPush);
            if (ruleArray.durationOperator === "between" || ruleArray.durationOperator === "between or is" || ruleArray.durationOperator === "outside" || ruleArray.durationOperator === "outside or is") {
                valueToPush = {};
                valueToPush["header"] = 0;
                valueToPush["text"] = "Duration " + ruleArray.durationOperator + " " + ruleArray.durationActualFrom + " and " + ruleArray.durationActualTo + " " + ruleArray.durationValue;
                conditions.push(valueToPush);
            } else {
                valueToPush = {};
                valueToPush["header"] = 0;
                valueToPush["text"] = "Duration " + ruleArray.durationOperator + " " + ruleArray.durationActualFrom + " " + ruleArray.durationValue;
                conditions.push(valueToPush);
            }
        } else {
            valueToPush = {};
            valueToPush["header"] = 0;
            valueToPush["text"] = "Any duration";
            conditions.push(valueToPush);
        }
    }
    if (ruleType === "performance" && ruleArray.durationReductionType !== "N/A") {
        valueToPush = {};
        valueToPush["header"] = 1;
        valueToPush["text"] = "Reduction:";
        conditions.push(valueToPush);
        valueToPush = {};
        valueToPush["header"] = 0;
        if (ruleArray.durationReductionType === "actual") valueToPush["text"] = "Reduce duration by " + ruleArray.durationReductionActual + " " + ruleArray.durationReductionValue;
        if (ruleArray.durationReductionType === "percentage") valueToPush["text"] = ruleArray.durationReductionPercentage + "% of event duration";
        conditions.push(valueToPush);
    }
    return conditions;
}
function $57e66c5a34f265b4$export$70a78b5e857e75e5() {
    let rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilterConditions.length; i++)rows.push({
        type: $57e66c5a34f265b4$var$gFilterConditions[i].type,
        filter: $57e66c5a34f265b4$var$gFilterConditions[i].description
    });
    return rows;
}
function $57e66c5a34f265b4$export$13e559b3ccbff946() {
    let rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gSlicerConditions.length; i++)rows.push({
        type: $57e66c5a34f265b4$var$gSlicerConditions[i].type,
        slicer: $57e66c5a34f265b4$var$gSlicerConditions[i].description
    });
    return rows;
}
function $57e66c5a34f265b4$export$a9dc28b9b3f2f426() {
    $57e66c5a34f265b4$var$gGaugePercEvents = true;
    $57e66c5a34f265b4$var$gGaugePercTasks = true;
    $57e66c5a34f265b4$var$gGaugeXofYVariants = true;
    $57e66c5a34f265b4$var$gGaugeXofYSteps = true;
    $57e66c5a34f265b4$var$gGaugeXofYActivities = true;
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = true;
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = true;
    $57e66c5a34f265b4$var$gGaugePercCostSaving = true;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercTasksCompliant = false;
    $57e66c5a34f265b4$var$gGaugePercEventsCompliant = false;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = false;
    $57e66c5a34f265b4$var$gGaugePercTasksAutomated = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = false;
    $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = false;
    $57e66c5a34f265b4$var$gGaugeCostSaving = false;
    $57e66c5a34f265b4$var$gGaugeActualCost = false;
    $57e66c5a34f265b4$var$gGaugeForecastCost = false;
}
function $57e66c5a34f265b4$export$f1644080c10d57a5() {
    $57e66c5a34f265b4$var$gAutomationRules = [];
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        $57e66c5a34f265b4$var$gVariantArray[i].automated = false;
        $57e66c5a34f265b4$var$gVariantArray[i].tasks_automated = 0;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gStepArray.length; i1++){
        $57e66c5a34f265b4$var$gStepArray[i1].automated = 0;
        $57e66c5a34f265b4$var$gStepArray[i1].tasks_automated = 0;
    }
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gActivityArray.length; i2++){
        $57e66c5a34f265b4$var$gActivityArray[i2].automated = 0;
        $57e66c5a34f265b4$var$gActivityArray[i2].tasks_automated = 0;
    }
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gTaskArray.length; i3++)$57e66c5a34f265b4$var$gTaskArray[i3].automated = false;
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gEventLogArray.length; i4++){
        $57e66c5a34f265b4$var$gEventLogArray[i4].automated = false;
        $57e66c5a34f265b4$var$gEventLogArray[i4].ac = 0;
    }
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gLinkArray.length; i5++)$57e66c5a34f265b4$var$gLinkArray[i5].automated = 0;
    $57e66c5a34f265b4$var$generateEventAnalyticsArray("resetAutomationRules");
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $99061afdb4accbec$export$77472d31d2b1bbaf)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$b97fb76230c722e3() {
    $57e66c5a34f265b4$var$gComplianceRules = [];
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gRuleSelectedRow.length; i++)if ($57e66c5a34f265b4$var$gRuleSelectedRow[i].type == "compliance") {
        $57e66c5a34f265b4$var$gRuleSelectedRow.splice(i, 1);
        break;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++)$57e66c5a34f265b4$var$gTaskArray[i1].compliant = true;
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gStepArray.length; i2++){
        $57e66c5a34f265b4$var$gStepArray[i2].compliant = true;
        $57e66c5a34f265b4$var$gStepArray[i2].events_compliant = $57e66c5a34f265b4$var$gStepArray[i2].events;
    }
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gVariantArray.length; i3++){
        $57e66c5a34f265b4$var$gVariantArray[i3].compliant = true;
        $57e66c5a34f265b4$var$gVariantArray[i3].tasks_compliant = $57e66c5a34f265b4$var$gVariantArray[i3].t;
        $57e66c5a34f265b4$var$gVariantArray[i3].events_compliant = $57e66c5a34f265b4$var$gVariantArray[i3].e;
    }
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gActivityArray.length; i4++){
        $57e66c5a34f265b4$var$gActivityArray[i4].compliant = false;
        $57e66c5a34f265b4$var$gActivityArray[i4].events_compliant = 0;
        $57e66c5a34f265b4$var$gActivityArray[i4].tasks_compliant = 0;
    }
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gEventLogArray.length; i5++){
        $57e66c5a34f265b4$var$gEventLogArray[i5].compliant = true;
        $57e66c5a34f265b4$var$gEventLogArray[i5].cc = 0;
    }
    for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gLinkArray.length; i6++)$57e66c5a34f265b4$var$gLinkArray[i6].compliant = $57e66c5a34f265b4$var$gLinkArray[i6].tasks;
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8b3a953f334c1c39$export$88d9d129a5d66a46)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$91febe14d2b24dfb() {
    $57e66c5a34f265b4$var$gCostRules = [];
    $57e66c5a34f265b4$var$gPercCostSaving = 0;
    $57e66c5a34f265b4$var$gActualCost = 0;
    $57e66c5a34f265b4$var$gForecastCost = 0;
    $57e66c5a34f265b4$var$gCostSaving = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gRuleSelectedRow.length; i++)if ($57e66c5a34f265b4$var$gRuleSelectedRow[i].type == "cost") {
        $57e66c5a34f265b4$var$gRuleSelectedRow.splice(i, 1);
        break;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        $57e66c5a34f265b4$var$gVariantArray[i1].actual_cost = 0;
        $57e66c5a34f265b4$var$gVariantArray[i1].forecast_cost = 0;
    }
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gStepArray.length; i2++){
        $57e66c5a34f265b4$var$gStepArray[i2].actual_cost = 0;
        $57e66c5a34f265b4$var$gStepArray[i2].forecast_cost = 0;
    }
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gActivityArray.length; i3++){
        $57e66c5a34f265b4$var$gActivityArray[i3].actual_cost = 0;
        $57e66c5a34f265b4$var$gActivityArray[i3].forecast_cost = 0;
    }
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gEventLogArray.length; i4++){
        $57e66c5a34f265b4$var$gEventLogArray[i4].actual_cost = 0;
        $57e66c5a34f265b4$var$gEventLogArray[i4].forecast_cost = 0;
    }
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gTaskArray.length; i5++){
        $57e66c5a34f265b4$var$gTaskArray[i5].actual_cost = 0;
        $57e66c5a34f265b4$var$gTaskArray[i5].forecast_cost = 0;
    }
    for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gLinkArray.length; i6++){
        $57e66c5a34f265b4$var$gLinkArray[i6].actual_cost = 0;
        $57e66c5a34f265b4$var$gLinkArray[i6].forecast_cost = 0;
    }
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray("resetCostRules");
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$1d0c870d910fd1d0() {
    $57e66c5a34f265b4$var$gPerformanceRules = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gRuleSelectedRow.length; i++)if ($57e66c5a34f265b4$var$gRuleSelectedRow[i].type == "performance") {
        $57e66c5a34f265b4$var$gRuleSelectedRow.splice(i, 1);
        break;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
        $57e66c5a34f265b4$var$gEventLogArray[i1].pr = 0;
        $57e66c5a34f265b4$var$gEventLogArray[i1].pd = 0;
    }
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $27da566ba975f5d5$export$d9025152d14cd3b)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$49e15f373ab56525(cost) {
    let costArray = [];
    let valueToPush = [];
    let fromActivityStr = "";
    let toActivityStr = "";
    if (cost.mode == "new" || cost.mode == "edit") {
        valueToPush = [];
        if (cost.type == "step") {
            let vtp = [];
            vtp["fromActivity"] = parseInt(cost.fromNode);
            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(cost.fromNode)) {
                fromActivityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
                break;
            }
            vtp["toActivity"] = parseInt(cost.toNode);
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == parseInt(cost.toNode)) {
                toActivityStr = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
                break;
            }
        }
    }
    if (cost.mode == "edit") {
        valueToPush = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gCostRules.length; i++)if ($57e66c5a34f265b4$var$gCostRules[i].ruleID === parseInt(cost.ruleID)) {
            valueToPush["rule"] = $57e66c5a34f265b4$var$gCostRules[i].rule;
            valueToPush["ruleID"] = $57e66c5a34f265b4$var$gCostRules[i].ruleID;
            valueToPush["variantType"] = $57e66c5a34f265b4$var$gCostRules[i].variantType;
            valueToPush["taskType"] = $57e66c5a34f265b4$var$gCostRules[i].taskType;
            valueToPush["mode"] = $57e66c5a34f265b4$var$gCostRules[i].mode;
            valueToPush["type"] = $57e66c5a34f265b4$var$gCostRules[i].type;
            valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gCostRules[i].fromActivity;
            valueToPush["fromActivityStr"] = $57e66c5a34f265b4$var$gCostRules[i].fromActivityStr;
            valueToPush["toActivity"] = $57e66c5a34f265b4$var$gCostRules[i].toActivity;
            valueToPush["toActivityStr"] = $57e66c5a34f265b4$var$gCostRules[i].toActivityStr;
            valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gCostRules[i].filter_task_attributes;
            valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gCostRules[i].filter_task_metrics;
            valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gCostRules[i].filter_task_time;
            valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gCostRules[i].filter_task_tasks;
            valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gCostRules[i].conditionsArray;
            valueToPush["costType"] = $57e66c5a34f265b4$var$gCostRules[i].costType;
            valueToPush["actualCost"] = $57e66c5a34f265b4$var$gCostRules[i].actualCost;
            valueToPush["attribute"] = $57e66c5a34f265b4$var$gCostRules[i].attribute;
        }
        costArray.push(valueToPush);
        $57e66c5a34f265b4$export$12c04bc852ab53(costArray, "delete", false, "updateStepCost");
    }
    costArray = [];
    valueToPush = [];
    if (cost.mode == "edit" || cost.mode == "new") {
        valueToPush["rule"] = cost.rule.trim();
        valueToPush["variantType"] = cost.variantType;
        valueToPush["taskType"] = cost.taskType;
        valueToPush["mode"] = cost.mode;
        valueToPush["type"] = cost.type;
        valueToPush["fromActivity"] = cost.fromNode;
        valueToPush["fromActivityStr"] = fromActivityStr;
        valueToPush["toActivity"] = cost.toNode;
        valueToPush["toActivityStr"] = toActivityStr;
        valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gTaskFilterAttributes;
        valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gTaskFilterMetrics;
        valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gTaskFilterTime;
        valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gTaskFilterTasks;
        valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gFilterConditions;
        valueToPush["costType"] = cost.costType;
        valueToPush["actualCost"] = cost.actualCost;
        valueToPush["attribute"] = cost.attribute;
        costArray.push(valueToPush);
        $57e66c5a34f265b4$export$12c04bc852ab53(costArray, "new", false, "updateStepCost");
    }
    if (cost.mode == "delete") {
        valueToPush["ruleID"] = cost.ruleID;
        valueToPush["fromActivity"] = cost.fromActivity;
        valueToPush["fromActivityStr"] = cost.fromActivityStr;
        valueToPush["toActivity"] = cost.toActivity;
        valueToPush["toActivityStr"] = cost.toActivityStr;
        costArray.push(valueToPush);
        $57e66c5a34f265b4$export$12c04bc852ab53(costArray, "delete", false, "updateStepCost");
    }
    (0, $73069f16c491914f$export$88a8e14f5b48311)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
        message: "Cost rule processed",
        severity: "success",
        showAlert: true,
        timeOutActive: true,
        component: "cost_rules"
    });
}
function $57e66c5a34f265b4$export$12c04bc852ab53(cost, mode, applyFilter, source) {
    let x = 0;
    let gSlicedVariants = [];
    let valueToPush = [];
    let events = 0;
    let tasks = 0;
    let selectedVariants = [];
    let ruleID = 0;
    let key = "";
    ruleID = 0;
    if (!cost[x].ruleID) {
        for(let j = 0; j < $57e66c5a34f265b4$var$gCostRules.length; j++)if ($57e66c5a34f265b4$var$gCostRules[j].ruleID > ruleID) ruleID = $57e66c5a34f265b4$var$gCostRules[j].ruleID;
        ruleID = ruleID + 100;
    } else ruleID = cost[x].ruleID;
    key = "$r-" + ruleID;
    if (mode == "new") {
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
        $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        // determine valid variants
        let validVariants = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
            let validVariant = true;
            if (cost[x].variantType == "selected_variants") {
                validVariant = false;
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validVariant = true;
                    break;
                }
            }
            if (cost[x].variantType == "sliced_variants") {
                validVariant = false;
                if ($57e66c5a34f265b4$var$gVariantArray[i].sliced === true) {
                    validVariant = true;
                    let vtp = [];
                    vtp["id"] = $57e66c5a34f265b4$var$gVariantArray[i].id;
                    vtp["n"] = $57e66c5a34f265b4$var$gVariantArray[i].n;
                    vtp["s"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    vtp["v"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    gSlicedVariants.push(vtp);
                }
            }
            if (validVariant == true) {
                valueToPush = [];
                valueToPush["v"] = parseInt($57e66c5a34f265b4$var$gVariantArray[i].v);
                validVariants.push(valueToPush);
            }
        }
        if (cost[x].variantType === "selected_variants") selectedVariants = [
            ...$57e66c5a34f265b4$var$gVariantPaneVariants
        ];
        if (cost[x].variantType === "sliced_variants") selectedVariants = [
            ...gSlicedVariants
        ];
        let task = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
            $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i1].filtered == 1 && cost[x].taskType == "filtered_tasks") break;
            let validEvent = false;
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].f) == parseInt(cost[x].fromActivity) && parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].t) == parseInt(cost[x].toActivity)) validEvent = true;
            if (validEvent == true) {
                validEvent = false;
                for(let j2 = 0; j2 < validVariants.length; j2++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].v == validVariants[j2].v) {
                    validEvent = true;
                    break;
                }
                if (validEvent == true) {
                    events++;
                    if (task != $57e66c5a34f265b4$var$gEventLogArray[i1].k) tasks++;
                    $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 1;
                    let actualCost = 0;
                    if (cost[x].costType === "total") actualCost = cost[x].actualCost;
                    if (cost[x].costType === "perday") actualCost = cost[x].actualCost * ($57e66c5a34f265b4$var$gEventLogArray[i1].d / 86400);
                    if (cost[x].costType === "perhour") actualCost = cost[x].actualCost * ($57e66c5a34f265b4$var$gEventLogArray[i1].d / 3600);
                    if (cost[x].costType === "permin") actualCost = cost[x].actualCost * ($57e66c5a34f265b4$var$gEventLogArray[i1].d / 60);
                    let rules = $57e66c5a34f265b4$var$gEventLogArray[i1].rules;
                    let vtp1 = [];
                    vtp1["ruleID"] = key;
                    vtp1["actualCost"] = actualCost;
                    rules.push(vtp1);
                    // calculate total actual cost from rules
                    actualCost = 0;
                    for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gEventLogArray[i1].rules.length; j3++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].rules[j3].ruleID.startsWith("$") === true) actualCost = actualCost + $57e66c5a34f265b4$var$gEventLogArray[i1].rules[j3].actualCost;
                    $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost = actualCost;
                    task = $57e66c5a34f265b4$var$gEventLogArray[i1].k;
                }
            }
        }
    }
    if (mode == "delete") {
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++)if ($57e66c5a34f265b4$var$gEventLogArray[i2][key] === 1) {
            $57e66c5a34f265b4$var$gEventLogArray[i2][key] = 0;
            for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gEventLogArray[i2].rules.length; j4++)if ($57e66c5a34f265b4$var$gEventLogArray[i2].rules[j4].ruleID === key) {
                $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost - $57e66c5a34f265b4$var$gEventLogArray[i2].rules[j4].actualCost;
                $57e66c5a34f265b4$var$gEventLogArray[i2].rules.splice(j4, 1);
                break;
            }
        }
        for(let k = 0; k < $57e66c5a34f265b4$var$gCostRules.length; k++)if ($57e66c5a34f265b4$var$gCostRules[k].ruleID === cost[x].ruleID) {
            $57e66c5a34f265b4$var$gCostRules.splice(k, 1);
            break;
        }
    }
    if (mode == "new") {
        valueToPush = {};
        valueToPush["fromActivity"] = cost[x].fromActivity;
        valueToPush["fromActivityStr"] = cost[x].fromActivityStr;
        valueToPush["toActivity"] = cost[x].toActivity;
        valueToPush["toActivityStr"] = cost[x].toActivityStr;
        valueToPush["variantType"] = cost[x].variantType;
        valueToPush["taskType"] = cost[x].taskType;
        valueToPush["rule"] = cost[x].rule;
        valueToPush["costStatus"] = cost[x].costStatus;
        if (cost[x].taskType != "all_tasks") {
            valueToPush["filter_task_attributes"] = cost[x].filter_task_attributes;
            valueToPush["filter_task_metrics"] = cost[x].filter_task_metrics;
            valueToPush["filter_task_time"] = cost[x].filter_task_time;
            valueToPush["filter_task_tasks"] = cost[x].filter_task_tasks;
        } else {
            valueToPush["filter_task_attributes"] = [];
            valueToPush["filter_task_metrics"] = [];
            valueToPush["filter_task_time"] = [];
            valueToPush["filter_task_tasks"] = [];
        }
        valueToPush["selected_variants"] = selectedVariants;
        if (source === "model_import" || source === "file_import") valueToPush["conditionsArray"] = cost[x].conditionsArray;
        else valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$conditionsArray("cost", cost[x], cost[x].variantType, cost[x].taskType, cost[x].fromActivityStr, cost[x].toActivityStr);
        valueToPush["actualCost"] = cost[x].actualCost;
        valueToPush["costType"] = cost[x].costType;
        valueToPush["attribute"] = cost[x].attribute;
        valueToPush["ruleID"] = ruleID;
        valueToPush["key"] = key;
        valueToPush["mode"] = cost[x].mode;
        valueToPush["type"] = cost[x].type;
        valueToPush["events"] = events;
        valueToPush["tasks"] = tasks;
        valueToPush["category"] = "cost";
        $57e66c5a34f265b4$var$gCostRules.push(valueToPush);
    }
    // check performance rules
    let tRules = [
        ...$57e66c5a34f265b4$var$gPerformanceRules
    ];
    for(let i3 = 0; i3 < tRules.length; i3++)if (parseInt(tRules[i3].fromActivity) === parseInt(cost[x].fromActivity) && parseInt(tRules[i3].toActivity) === parseInt(cost[x].toActivity) && tRules[i3].calculateCostImpact === true) {
        let valueToPush1 = [];
        let performanceArray = [];
        valueToPush1["rule"] = tRules[i3].rule;
        valueToPush1["ruleID"] = tRules[i3].ruleID;
        valueToPush1["variantType"] = tRules[i3].variantType;
        valueToPush1["taskType"] = tRules[i3].taskType;
        valueToPush1["filterLoops"] = tRules[i3].filterLoops;
        valueToPush1["calculateCostImpact"] = tRules[i3].calculateCostImpact;
        valueToPush1["mode"] = tRules[i3].mode;
        valueToPush1["type"] = tRules[i3].type;
        valueToPush1["fromActivity"] = tRules[i3].fromActivity;
        valueToPush1["fromActivityStr"] = tRules[i3].fromActivityStr;
        valueToPush1["toActivity"] = tRules[i3].toActivity;
        valueToPush1["toActivityStr"] = tRules[i3].toActivityStr;
        valueToPush1["filter_task_attributes"] = tRules[i3].filter_task_attributes;
        valueToPush1["filter_task_metrics"] = tRules[i3].filter_task_metrics;
        valueToPush1["filter_task_time"] = tRules[i3].filter_task_time;
        valueToPush1["filter_task_tasks"] = tRules[i3].filter_task_tasks;
        valueToPush1["conditionsArray"] = tRules[i3].conditionsArray;
        valueToPush1["durationOperator"] = tRules[i3].durationOperator;
        valueToPush1["durationActualFrom"] = tRules[i3].durationActualFrom;
        valueToPush1["durationActualTo"] = tRules[i3].durationActualTo;
        valueToPush1["durationValue"] = tRules[i3].durationValue;
        valueToPush1["durationReductionType"] = tRules[i3].durationReductionType;
        valueToPush1["durationReductionPercentage"] = tRules[i3].durationReductionPercentage;
        valueToPush1["durationReductionActual"] = tRules[i3].durationReductionActual;
        valueToPush1["durationReductionValue"] = tRules[i3].durationReductionValue;
        performanceArray.push(valueToPush1);
        if (tRules[i3].calculateCostImpact === true) $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, "update_cost", false, "processCost");
    }
    // check compliance rules
    tRules = [
        ...$57e66c5a34f265b4$var$gComplianceRules
    ];
    for(let i4 = 0; i4 < tRules.length; i4++)if (parseInt(tRules[i4].fromActivity) === parseInt(cost[x].fromActivity) && parseInt(tRules[i4].toActivity) === parseInt(cost[x].toActivity)) {
        let valueToPush2 = [];
        let complianceArray = [];
        valueToPush2["rule"] = tRules[i4].rule;
        valueToPush2["ruleID"] = tRules[i4].ruleID;
        valueToPush2["variantType"] = tRules[i4].variantType;
        valueToPush2["taskType"] = tRules[i4].taskType;
        valueToPush2["filterLoops"] = tRules[i4].filterLoops;
        valueToPush2["calculateCostImpact"] = tRules[i4].calculateCostImpact;
        valueToPush2["mode"] = tRules[i4].mode;
        valueToPush2["type"] = tRules[i4].type;
        valueToPush2["fromActivity"] = tRules[i4].fromActivity;
        valueToPush2["fromActivityStr"] = tRules[i4].fromActivityStr;
        valueToPush2["toActivity"] = tRules[i4].toActivity;
        valueToPush2["toActivityStr"] = tRules[i4].toActivityStr;
        valueToPush2["filter_task_attributes"] = tRules[i4].filter_task_attributes;
        valueToPush2["filter_task_metrics"] = tRules[i4].filter_task_metrics;
        valueToPush2["filter_task_time"] = tRules[i4].filter_task_time;
        valueToPush2["filter_task_tasks"] = tRules[i4].filter_task_tasks;
        valueToPush2["conditionsArray"] = tRules[i4].conditionsArray;
        valueToPush2["durationOperator"] = tRules[i4].durationOperator;
        valueToPush2["durationActualFrom"] = tRules[i4].durationActualFrom;
        valueToPush2["durationActualTo"] = tRules[i4].durationActualTo;
        valueToPush2["durationValue"] = tRules[i4].durationValue;
        complianceArray.push(valueToPush2);
        if (tRules[i4].calculateCostImpact === true) $57e66c5a34f265b4$export$ed156e5e6c311db5(complianceArray, "update_cost", false, "processCost");
    }
    // check automation rules
    tRules = [
        ...$57e66c5a34f265b4$var$gAutomationRules
    ];
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gAutomationRules.length; i5++)if (parseInt(tRules[i5].fromActivity) === parseInt(cost[x].fromActivity) && parseInt(tRules[i5].toActivity) === parseInt(cost[x].toActivity)) {
        let valueToPush3 = [];
        let automationArray = [];
        valueToPush3["rule"] = tRules[i5].rule;
        valueToPush3["ruleID"] = tRules[i5].ruleID;
        valueToPush3["variantType"] = tRules[i5].variantType;
        valueToPush3["taskType"] = tRules[i5].taskType;
        valueToPush3["filterLoops"] = tRules[i5].filterLoops;
        valueToPush3["calculateCostImpact"] = tRules[i5].calculateCostImpact;
        valueToPush3["mode"] = tRules[i5].mode;
        valueToPush3["type"] = tRules[i5].type;
        valueToPush3["fromActivity"] = tRules[i5].fromActivity;
        valueToPush3["fromActivityStr"] = tRules[i5].fromActivityStr;
        valueToPush3["toActivity"] = tRules[i5].toActivity;
        valueToPush3["toActivityStr"] = tRules[i5].toActivityStr;
        valueToPush3["filter_task_attributes"] = tRules[i5].filter_task_attributes;
        valueToPush3["filter_task_metrics"] = tRules[i5].filter_task_metrics;
        valueToPush3["filter_task_time"] = tRules[i5].filter_task_time;
        valueToPush3["filter_task_tasks"] = tRules[i5].filter_task_tasks;
        valueToPush3["conditionsArray"] = tRules[i5].conditionsArray;
        valueToPush3["durationOperator"] = tRules[i5].durationOperator;
        valueToPush3["durationActualFrom"] = tRules[i5].durationActualFrom;
        valueToPush3["durationActualTo"] = tRules[i5].durationActualTo;
        valueToPush3["durationValue"] = tRules[i5].durationValue;
        automationArray.push(valueToPush3);
        if (tRules[i5].calculateCostImpact === true) $57e66c5a34f265b4$export$7a674125acf4456d(automationArray, "update_cost", false, "processCost");
    }
    if (mode === "delete" && cost[x].mode === "edit") return;
    if (source === "modal") $57e66c5a34f265b4$export$59798dda46c3d2b5(applyFilter, false, "process cost");
    else if (applyFilter == true) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("processAutomation");
    if (source != "model_import") {
        $57e66c5a34f265b4$var$updateForecastCost();
        $57e66c5a34f265b4$var$updateCostMetrics("processCost");
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$updateAttributes();
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        $57e66c5a34f265b4$export$2ff5de46d769d306("processCost");
    }
}
function $57e66c5a34f265b4$var$updateCostMetrics(source) {
    // update variant cost
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        $57e66c5a34f265b4$var$gVariantArray[i].actual_cost = 0;
        $57e66c5a34f265b4$var$gVariantArray[i].forecast_cost = 0;
    }
    let variant = "";
    let variantActualCost = 0;
    let variantForecastCost = 0;
    // update event_log total forecast cost from rules
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
        let forecastCost = 0;
        let ruleExists = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gEventLogArray[i1].rules.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].rules[j].calculateCostImpact === true) {
            ruleExists = true;
            forecastCost = forecastCost + $57e66c5a34f265b4$var$gEventLogArray[i1].rules[j].forecastCost;
        }
        if (ruleExists === true) $57e66c5a34f265b4$var$gEventLogArray[i1].forecast_cost = forecastCost;
    }
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    // update variant cost
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if (i2 > 0 && variant != $57e66c5a34f265b4$var$gEventLogArray[i2].v) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].actual_cost = variantActualCost;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].forecast_cost = variantForecastCost;
            variantActualCost = 0;
            variantForecastCost = 0;
        }
        variantActualCost = variantActualCost + $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost;
        variantForecastCost = variantForecastCost + $57e66c5a34f265b4$var$gEventLogArray[i2].forecast_cost;
        variant = $57e66c5a34f265b4$var$gEventLogArray[i2].v;
    }
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].vid].actual_cost;
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].vid].forecast_cost;
    // update task cost
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gTaskArray.length; i3++){
        $57e66c5a34f265b4$var$gTaskArray[i3].actual_cost = 0;
        $57e66c5a34f265b4$var$gTaskArray[i3].forecast_cost = 0;
    }
    let task = "";
    let taskActualCost = 0;
    let taskForecastCost = 0;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gEventLogArray.length; i4++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i4].filtered == 1) break;
        if (i4 > 0 && task != $57e66c5a34f265b4$var$gEventLogArray[i4].k) {
            $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4 - 1].tid].actual_cost = taskActualCost;
            $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4 - 1].tid].forecast_cost = taskForecastCost;
            taskActualCost = 0;
            taskForecastCost = 0;
        }
        taskActualCost = taskActualCost + $57e66c5a34f265b4$var$gEventLogArray[i4].actual_cost;
        taskForecastCost = taskForecastCost + $57e66c5a34f265b4$var$gEventLogArray[i4].forecast_cost;
        task = $57e66c5a34f265b4$var$gEventLogArray[i4].k;
    }
    $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].tid].actual_cost;
    $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].tid].forecast_cost;
    $57e66c5a34f265b4$var$gActualCost = 0;
    $57e66c5a34f265b4$var$gForecastCost = 0;
    for(let k = 0; k < $57e66c5a34f265b4$var$gVariantArray.length; k++){
        $57e66c5a34f265b4$var$gActualCost = $57e66c5a34f265b4$var$gActualCost + $57e66c5a34f265b4$var$gVariantArray[k].actual_cost;
        $57e66c5a34f265b4$var$gForecastCost = $57e66c5a34f265b4$var$gForecastCost + $57e66c5a34f265b4$var$gVariantArray[k].forecast_cost;
    }
    $57e66c5a34f265b4$var$gPercCostSaving = 0;
    $57e66c5a34f265b4$var$gCostSaving = 0;
    if ($57e66c5a34f265b4$var$gActualCost != 0 && $57e66c5a34f265b4$var$gForecastCost != 0) {
        $57e66c5a34f265b4$var$gPercCostSaving = ($57e66c5a34f265b4$var$gActualCost - $57e66c5a34f265b4$var$gForecastCost) / $57e66c5a34f265b4$var$gActualCost * 100;
        $57e66c5a34f265b4$var$gCostSaving = $57e66c5a34f265b4$var$gActualCost - $57e66c5a34f265b4$var$gForecastCost;
    }
}
function $57e66c5a34f265b4$export$66bfaa30e4f0b4d8(importedRules, ruleType, source) {
    // reset existing rules if importing from a file
    if (source != "model_import") {
        if (ruleType == "cost") $57e66c5a34f265b4$export$91febe14d2b24dfb();
        if (ruleType == "compliance") $57e66c5a34f265b4$export$b97fb76230c722e3();
        if (ruleType == "automation") $57e66c5a34f265b4$export$f1644080c10d57a5();
        if (ruleType == "performance") $57e66c5a34f265b4$export$1d0c870d910fd1d0();
    }
    if (source != "model_import" && $57e66c5a34f265b4$var$gUpdateEventLog != true) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("processCost");
    let tempArray = {};
    if ($57e66c5a34f265b4$var$gUpdateEventLog == false) try {
        tempArray = JSON.parse(importedRules);
    } catch (e) {
        if (ruleType == "cost") (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid rules file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "cost_rules"
        });
        if (ruleType == "compliance") (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid rules file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "compliance_rules"
        });
        if (ruleType == "automation") (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid rules file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "automation_rules"
        });
        if (ruleType == "performance") (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid rules file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "performance_rules"
        });
        return;
    }
    else tempArray = importedRules;
    for(let i = 0; i < tempArray.length; i++){
        if (tempArray[i].variantType != "all_variants") {
            $57e66c5a34f265b4$var$gVariantPaneVariants = [];
            for(let k = 0; k < tempArray[i].selected_variants.length; k++){
                for(let j = 0; j < $57e66c5a34f265b4$var$gVariantArray.length; j++)if ($57e66c5a34f265b4$var$gVariantArray[j].n == tempArray[i].selected_variants[k].n) $57e66c5a34f265b4$var$gVariantPaneVariants.push($57e66c5a34f265b4$var$gVariantArray[j]);
            }
        }
        let applyFilter = false;
        if (tempArray[i].taskType != "all_tasks") {
            $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
            $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
            $57e66c5a34f265b4$var$gTaskFilterTime = [];
            $57e66c5a34f265b4$var$gTaskFilterTasks = [];
            $57e66c5a34f265b4$var$gFilterConditions = [];
            $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
            if (tempArray[i].filter_task_attributes.length > 0) {
                let temp = Object.values({
                    ...tempArray[i].filter_task_attributes
                });
                $57e66c5a34f265b4$var$gAttributeType = temp[0].attributeType;
                $57e66c5a34f265b4$var$gAttribute = temp[0].attribute;
                $57e66c5a34f265b4$var$gSelectedAttributes = [];
                for(let j1 = 0; j1 < temp[0].values.length; j1++){
                    let valueToPush = {};
                    valueToPush["value"] = temp[0].values[j1].value;
                    $57e66c5a34f265b4$var$gSelectedAttributes.push(valueToPush);
                }
                applyFilter = true;
                $57e66c5a34f265b4$export$3067f357aa66b5c2($57e66c5a34f265b4$var$gAttribute, $57e66c5a34f265b4$var$gAttributeType);
            }
            if (tempArray[i].filter_task_metrics.length > 0) {
                $57e66c5a34f265b4$var$gTaskFilterMetrics = Object.values({
                    ...tempArray[i].filter_task_metrics
                });
                $57e66c5a34f265b4$var$gMetricFilter = [];
                $57e66c5a34f265b4$var$gMetricFilter.metric = $57e66c5a34f265b4$var$gTaskFilterMetrics[0].metric;
                $57e66c5a34f265b4$var$gMetricFilter.checkboxValue = $57e66c5a34f265b4$var$gTaskFilterMetrics[0].checkbox_value;
                $57e66c5a34f265b4$var$gMetricFilter.numberValue = $57e66c5a34f265b4$var$gTaskFilterMetrics[0].number_value;
                $57e66c5a34f265b4$var$gMetricFilter.time_unit = $57e66c5a34f265b4$var$gTaskFilterMetrics[0].timeUnit;
                $57e66c5a34f265b4$var$gMetricFilter.operator = $57e66c5a34f265b4$var$gTaskFilterMetrics[0].operator;
                applyFilter = true;
                $57e66c5a34f265b4$export$1968c4d10f8059c8();
            }
            if (tempArray[i].filter_task_time.length > 0) {
                $57e66c5a34f265b4$var$gTaskFilterTime = Object.values({
                    ...tempArray[i].filter_task_time
                });
                $57e66c5a34f265b4$var$gFromTime = new Date($57e66c5a34f265b4$var$gTaskFilterTime[0].from);
                $57e66c5a34f265b4$var$gToTime = new Date($57e66c5a34f265b4$var$gTaskFilterTime[0].to);
                applyFilter = true;
                $57e66c5a34f265b4$export$d7af1f47ccac45e4($57e66c5a34f265b4$var$gFromTime, $57e66c5a34f265b4$var$gToTime);
            }
            if (tempArray[i].filter_task_tasks.length > 0) {
                $57e66c5a34f265b4$var$gTaskFilterTasks = Object.values({
                    ...tempArray[i].filter_task_tasks
                });
                if ($57e66c5a34f265b4$var$gTaskFilterTasks[0].type == "task_variants") {
                    $57e66c5a34f265b4$var$gMinVariantTasks = $57e66c5a34f265b4$var$gTaskFilterTasks[0].min;
                    $57e66c5a34f265b4$var$gMaxVariantTasks = $57e66c5a34f265b4$var$gTaskFilterTasks[0].max;
                    $57e66c5a34f265b4$var$gTasksFilterActive_NTV = true;
                }
                if ($57e66c5a34f265b4$var$gTaskFilterTasks[0].type == "task_activities") {
                    $57e66c5a34f265b4$var$gTaskActivitiesFrom = $57e66c5a34f265b4$var$gTaskFilterTasks[0].from;
                    $57e66c5a34f265b4$var$gTaskActivitiesTo = $57e66c5a34f265b4$var$gTaskFilterTasks[0].to;
                    $57e66c5a34f265b4$var$gTasksFilterActive_NAT = true;
                }
                if ($57e66c5a34f265b4$var$gTaskFilterTasks[0].type == "task_duration") {
                    $57e66c5a34f265b4$var$gTaskDurationFrom = $57e66c5a34f265b4$var$gTaskFilterTasks[0].from;
                    $57e66c5a34f265b4$var$gTaskDurationTo = $57e66c5a34f265b4$var$gTaskFilterTasks[0].to;
                    $57e66c5a34f265b4$var$gTasksFilterActive_TD = true;
                }
                applyFilter = true;
                $57e66c5a34f265b4$export$e5dbdcbe8d57d390();
            }
        }
        if (ruleType == "cost") {
            let costArray = [];
            let valueToPush1 = [];
            valueToPush1["rule"] = tempArray[i].rule;
            valueToPush1["ruleID"] = tempArray[i].ruleID;
            valueToPush1["fromActivity"] = tempArray[i].fromActivity;
            valueToPush1["fromActivityStr"] = tempArray[i].fromActivityStr;
            valueToPush1["toActivity"] = tempArray[i].toActivity;
            valueToPush1["toActivityStr"] = tempArray[i].toActivityStr;
            valueToPush1["variantType"] = tempArray[i].variantType;
            valueToPush1["costType"] = tempArray[i].costType;
            valueToPush1["taskType"] = tempArray[i].taskType;
            valueToPush1["attribute"] = tempArray[i].attribute;
            valueToPush1["mode"] = tempArray[i].mode;
            valueToPush1["actualCost"] = tempArray[i].actualCost;
            if (tempArray[i].activity != null) valueToPush1["type"] = "activity";
            else valueToPush1["type"] = "step";
            valueToPush1["filter_task_attributes"] = tempArray[i].filter_task_attributes;
            valueToPush1["filter_task_metrics"] = tempArray[i].filter_task_metrics;
            valueToPush1["filter_task_time"] = tempArray[i].filter_task_time;
            valueToPush1["filter_task_tasks"] = tempArray[i].filter_task_tasks;
            valueToPush1["conditionsArray"] = tempArray[i].conditionsArray;
            valueToPush1["selected_variants"] = tempArray[i].selected_variants;
            valueToPush1["type"] = tempArray[i].type;
            valueToPush1["category"] = tempArray[i].category;
            costArray.push(valueToPush1);
            $57e66c5a34f265b4$export$12c04bc852ab53(costArray, "new", applyFilter, source);
        }
        if (ruleType == "compliance") {
            let complianceArray = [];
            let valueToPush2 = {};
            valueToPush2["rule"] = tempArray[i].rule;
            valueToPush2["ruleID"] = tempArray[i].ruleID;
            valueToPush2["fromActivity"] = tempArray[i].fromActivity;
            valueToPush2["fromActivityStr"] = tempArray[i].fromActivityStr;
            valueToPush2["toActivity"] = tempArray[i].toActivity;
            valueToPush2["toActivityStr"] = tempArray[i].toActivityStr;
            valueToPush2["variantType"] = tempArray[i].variantType;
            valueToPush2["taskType"] = tempArray[i].taskType;
            valueToPush2["filterLoops"] = tempArray[i].filterLoops;
            valueToPush2["calculateCostImpact"] = tempArray[i].calculateCostImpact;
            valueToPush2["mode"] = tempArray[i].mode;
            valueToPush2["filter_task_attributes"] = tempArray[i].filter_task_attributes;
            valueToPush2["filter_task_metrics"] = tempArray[i].filter_task_metrics;
            valueToPush2["filter_task_time"] = tempArray[i].filter_task_time;
            valueToPush2["filter_task_tasks"] = tempArray[i].filter_task_tasks;
            valueToPush2["conditionsArray"] = tempArray[i].conditionsArray;
            valueToPush2["selected_variants"] = tempArray[i].selected_variants;
            valueToPush2["type"] = tempArray[i].type;
            valueToPush2["category"] = tempArray[i].category;
            valueToPush2["durationOperator"] = tempArray[i].durationOperator;
            valueToPush2["durationActualFrom"] = tempArray[i].durationActualFrom;
            valueToPush2["durationActualTo"] = tempArray[i].durationActualTo;
            valueToPush2["durationValue"] = tempArray[i].durationValue;
            complianceArray.push(valueToPush2);
            $57e66c5a34f265b4$export$ed156e5e6c311db5(complianceArray, "new", applyFilter, source);
        }
        if (ruleType == "automation") {
            let automationArray = [];
            let valueToPush3 = [];
            valueToPush3["rule"] = tempArray[i].rule;
            valueToPush3["ruleID"] = tempArray[i].ruleID;
            valueToPush3["fromActivity"] = tempArray[i].fromActivity;
            valueToPush3["fromActivityStr"] = tempArray[i].fromActivityStr;
            valueToPush3["toActivity"] = tempArray[i].toActivity;
            valueToPush3["toActivityStr"] = tempArray[i].toActivityStr;
            valueToPush3["variantType"] = tempArray[i].variantType;
            valueToPush3["taskType"] = tempArray[i].taskType;
            valueToPush3["calculateCostImpact"] = tempArray[i].calculateCostImpact;
            valueToPush3["mode"] = tempArray[i].mode;
            valueToPush3["filter_task_attributes"] = tempArray[i].filter_task_attributes;
            valueToPush3["filter_task_metrics"] = tempArray[i].filter_task_metrics;
            valueToPush3["filter_task_time"] = tempArray[i].filter_task_time;
            valueToPush3["filter_task_tasks"] = tempArray[i].filter_task_tasks;
            valueToPush3["conditionsArray"] = tempArray[i].conditionsArray;
            valueToPush3["selected_variants"] = tempArray[i].selected_variants;
            valueToPush3["type"] = tempArray[i].type;
            valueToPush3["category"] = tempArray[i].category;
            valueToPush3["durationOperator"] = tempArray[i].durationOperator;
            valueToPush3["durationActualFrom"] = tempArray[i].durationActualFrom;
            valueToPush3["durationActualTo"] = tempArray[i].durationActualTo;
            valueToPush3["durationValue"] = tempArray[i].durationValue;
            automationArray.push(valueToPush3);
            $57e66c5a34f265b4$export$7a674125acf4456d(automationArray, "new", applyFilter, source);
        }
        if (ruleType == "performance") {
            let performanceArray = [];
            let valueToPush4 = [];
            valueToPush4["rule"] = tempArray[i].rule;
            valueToPush4["ruleID"] = tempArray[i].ruleID;
            valueToPush4["fromActivity"] = tempArray[i].fromActivity;
            valueToPush4["fromActivityStr"] = tempArray[i].fromActivityStr;
            valueToPush4["toActivity"] = tempArray[i].toActivity;
            valueToPush4["toActivityStr"] = tempArray[i].toActivityStr;
            valueToPush4["variantType"] = tempArray[i].variantType;
            valueToPush4["taskType"] = tempArray[i].taskType;
            valueToPush4["mode"] = tempArray[i].mode;
            valueToPush4["filterLoops"] = tempArray[i].filterLoops;
            valueToPush4["calculateCostImpact"] = tempArray[i].calculateCostImpact;
            valueToPush4["filter_task_attributes"] = tempArray[i].filter_task_attributes;
            valueToPush4["filter_task_metrics"] = tempArray[i].filter_task_metrics;
            valueToPush4["filter_task_time"] = tempArray[i].filter_task_time;
            valueToPush4["filter_task_tasks"] = tempArray[i].filter_task_tasks;
            valueToPush4["conditionsArray"] = tempArray[i].conditionsArray;
            valueToPush4["selected_variants"] = tempArray[i].selected_variants;
            valueToPush4["type"] = tempArray[i].type;
            valueToPush4["category"] = tempArray[i].category;
            valueToPush4["durationOperator"] = tempArray[i].durationOperator;
            valueToPush4["durationActualFrom"] = tempArray[i].durationActualFrom;
            valueToPush4["durationActualTo"] = tempArray[i].durationActualTo;
            valueToPush4["durationValue"] = tempArray[i].durationValue;
            valueToPush4["durationReductionType"] = tempArray[i].durationReductionType;
            valueToPush4["durationReductionPercentage"] = tempArray[i].durationReductionPercentage;
            valueToPush4["durationReductionActual"] = tempArray[i].durationReductionActual;
            valueToPush4["durationReductionValue"] = tempArray[i].durationReductionValue;
            performanceArray.push(valueToPush4);
            $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, "new", applyFilter, source);
        }
    }
    if (ruleType == "cost") {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1b359944329d2411$export$c53eb01533dfe42d)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if (ruleType == "compliance") {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8b3a953f334c1c39$export$88d9d129a5d66a46)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if (ruleType == "automation") {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $99061afdb4accbec$export$77472d31d2b1bbaf)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if (ruleType == "performance") {
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $27da566ba975f5d5$export$d9025152d14cd3b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
    }
    if (source != "model_import") {
        (0, $73396f25d03f3d4e$export$68b36b6fd6d0f5b2)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Rules file processed",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "variant_slicer"
        });
    }
}
function $57e66c5a34f265b4$export$57519af9bc3c1880() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gSlicerConditions);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_slicers.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$3a8d4ca9f8e52c91() {
    let tempArray = $57e66c5a34f265b4$var$gFilterConditions;
    const jsonContent = JSON.stringify(tempArray);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_filters.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$88d3f0779ca58a46() {
    let tempArray = $57e66c5a34f265b4$var$gTransformation;
    const jsonContent = JSON.stringify(tempArray);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_transformation.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$4d9a5ecb83767618() {
    let tempArray = [];
    let valueToPush = {};
    valueToPush["ProcessFlowDirection"] = $57e66c5a34f265b4$var$gProcessFlowDirection;
    valueToPush["ShowLinkTasks"] = $57e66c5a34f265b4$var$gShowLinkTasks;
    valueToPush["ShowLinkAvgDuration"] = $57e66c5a34f265b4$var$gShowLinkAvgDuration;
    valueToPush["ShowLinkMedDuration"] = $57e66c5a34f265b4$var$gShowLinkMedDuration;
    valueToPush["ShowLinkMinDuration"] = $57e66c5a34f265b4$var$gShowLinkMinDuration;
    valueToPush["ShowLinkMaxDuration"] = $57e66c5a34f265b4$var$gShowLinkMaxDuration;
    valueToPush["ShowLinkAvgCost"] = $57e66c5a34f265b4$var$gShowLinkAvgCost;
    valueToPush["ShowLinkPercTotal"] = $57e66c5a34f265b4$var$gShowLinkPercTotal;
    valueToPush["ShowLinkDeviation"] = $57e66c5a34f265b4$var$gShowLinkDeviation;
    valueToPush["ShowLinkPercCompliant"] = $57e66c5a34f265b4$var$gShowLinkPercCompliant;
    valueToPush["ShowLinkPercAutomated"] = $57e66c5a34f265b4$var$gShowLinkPercAutomated;
    valueToPush["ShowStartLabel"] = $57e66c5a34f265b4$var$gShowStartLabel;
    valueToPush["ShowEndLabel"] = $57e66c5a34f265b4$var$gShowEndLabel;
    valueToPush["ShowStartNode"] = $57e66c5a34f265b4$var$gShowStartNode;
    valueToPush["ShowEndNode"] = $57e66c5a34f265b4$var$gShowEndNode;
    valueToPush["StepLabelFontSize"] = $57e66c5a34f265b4$var$gStepLabelFontSize;
    valueToPush["ShowNodeTasks"] = $57e66c5a34f265b4$var$gShowNodeTasks;
    valueToPush["ShowNodePercTotal"] = $57e66c5a34f265b4$var$gShowNodePercTotal;
    valueToPush["NodeLabelFontSize"] = $57e66c5a34f265b4$var$gNodeLabelFontSize;
    valueToPush["ShowDurationDays"] = $57e66c5a34f265b4$var$gShowDurationDays;
    valueToPush["ShowDurationHours"] = $57e66c5a34f265b4$var$gShowDurationHours;
    valueToPush["ShowDurationMinutes"] = $57e66c5a34f265b4$var$gShowDurationMinutes;
    valueToPush["ShowDurationSeconds"] = $57e66c5a34f265b4$var$gShowDurationSeconds;
    valueToPush["StepWidthTasks"] = $57e66c5a34f265b4$var$gStepWidthTasks;
    valueToPush["StepWidthDuration"] = $57e66c5a34f265b4$var$gStepWidthDuration;
    valueToPush["StepWidthStdDeviation"] = $57e66c5a34f265b4$var$gStepWidthStdDeviation;
    valueToPush["ActivityShape"] = $57e66c5a34f265b4$var$gActivityShape;
    valueToPush["ColorStartNode"] = $57e66c5a34f265b4$var$gColorStartNode;
    valueToPush["ColorEndNode"] = $57e66c5a34f265b4$var$gColorEndNode;
    valueToPush["ColorActivityText"] = $57e66c5a34f265b4$var$gColorActivityText;
    valueToPush["ColorActivityFill"] = $57e66c5a34f265b4$var$gColorActivityFill;
    valueToPush["ColorActivitySelect"] = $57e66c5a34f265b4$var$gColorActivitySelect;
    valueToPush["ColorLink"] = $57e66c5a34f265b4$var$gColorLink;
    valueToPush["ColorLinkSelect"] = $57e66c5a34f265b4$var$gColorLinkSelect;
    valueToPush["AnimateColor"] = $57e66c5a34f265b4$var$gAnimateColor;
    valueToPush["LoopColor"] = $57e66c5a34f265b4$var$gLoopColor;
    valueToPush["NonCompliantColor"] = $57e66c5a34f265b4$var$gNonCompliantColor;
    valueToPush["PartialNonCompliantColor"] = $57e66c5a34f265b4$var$gPartialNonCompliantColor;
    valueToPush["AutomationColor"] = $57e66c5a34f265b4$var$gAutomationColor;
    valueToPush["PartialAutomationColor"] = $57e66c5a34f265b4$var$gPartialAutomationColor;
    valueToPush["VisualizerBackgroundColor"] = $57e66c5a34f265b4$var$gVisualizerBackgroundColor;
    valueToPush["SpacingColumn"] = $57e66c5a34f265b4$var$gSpacingColumn;
    valueToPush["SpacingLayer"] = $57e66c5a34f265b4$var$gSpacingLayer;
    valueToPush["ZoomToFit"] = $57e66c5a34f265b4$var$gZoomToFit;
    tempArray.push(valueToPush);
    const jsonContent = JSON.stringify(tempArray);
    let fileName = "VisualizerSettings.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$a23812855239994f(importedSettings) {
    let tempArray;
    try {
        tempArray = JSON.parse(importedSettings);
    } catch (e) {
        (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid visualizer settings file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "settings_visualizer"
        });
        return;
    }
    $57e66c5a34f265b4$var$gProcessFlowDirection = tempArray[0].ProcessFlowDirection;
    $57e66c5a34f265b4$var$gShowLinkTasks = tempArray[0].ShowLinkTasks;
    $57e66c5a34f265b4$var$gShowLinkAvgDuration = tempArray[0].ShowLinkAvgDuration;
    $57e66c5a34f265b4$var$gShowLinkMedDuration = tempArray[0].ShowLinkMedDuration;
    $57e66c5a34f265b4$var$gShowLinkMinDuration = tempArray[0].ShowLinkMinDuration;
    $57e66c5a34f265b4$var$gShowLinkMaxDuration = tempArray[0].ShowLinkMaxDuration;
    $57e66c5a34f265b4$var$gShowLinkAvgCost = tempArray[0].ShowLinkAvgCost;
    $57e66c5a34f265b4$var$gShowLinkPercTotal = tempArray[0].ShowLinkPercTotal;
    $57e66c5a34f265b4$var$gShowLinkDeviation = tempArray[0].ShowLinkDeviation;
    $57e66c5a34f265b4$var$gShowLinkPercCompliant = tempArray[0].ShowLinkPercCompliant;
    $57e66c5a34f265b4$var$gShowLinkPercAutomated = tempArray[0].ShowLinkPercAutomated;
    $57e66c5a34f265b4$var$gShowStartLabel = tempArray[0].ShowStartLabel;
    $57e66c5a34f265b4$var$gShowEndLabel = tempArray[0].ShowEndLabel;
    $57e66c5a34f265b4$var$gShowStartNode = tempArray[0].ShowStartNode;
    $57e66c5a34f265b4$var$gShowEndNode = tempArray[0].ShowEndNode;
    $57e66c5a34f265b4$var$gStepLabelFontSize = tempArray[0].StepLabelFontSize;
    $57e66c5a34f265b4$var$gShowNodeTasks = tempArray[0].ShowNodeTasks;
    $57e66c5a34f265b4$var$gShowNodePercTotal = tempArray[0].ShowNodePercTotal;
    $57e66c5a34f265b4$var$gNodeLabelFontSize = tempArray[0].NodeLabelFontSize;
    $57e66c5a34f265b4$var$gShowDurationDays = tempArray[0].ShowDurationDays;
    $57e66c5a34f265b4$var$gShowDurationHours = tempArray[0].ShowDurationHours;
    $57e66c5a34f265b4$var$gShowDurationMinutes = tempArray[0].ShowDurationMinutes;
    $57e66c5a34f265b4$var$gStepWidthTasks = tempArray[0].StepWidthTasks;
    $57e66c5a34f265b4$var$gStepWidthDuration = tempArray[0].StepWidthDuration;
    $57e66c5a34f265b4$var$gStepWidthStdDeviation = tempArray[0].StepWidthStdDeviation;
    $57e66c5a34f265b4$var$gActivityShape = tempArray[0].ActivityShape;
    $57e66c5a34f265b4$var$gColorStartNode = tempArray[0].ColorStartNode;
    $57e66c5a34f265b4$var$gColorEndNode = tempArray[0].ColorEndNode;
    $57e66c5a34f265b4$var$gColorActivityFill = tempArray[0].ColorActivityFill;
    $57e66c5a34f265b4$var$gColorActivitySelect = tempArray[0].ColorActivitySelect;
    $57e66c5a34f265b4$var$gColorLink = tempArray[0].ColorLink;
    $57e66c5a34f265b4$var$gColorLinkSelect = tempArray[0].ColorLinkSelect;
    $57e66c5a34f265b4$var$gAnimateColor = tempArray[0].AnimateColor;
    $57e66c5a34f265b4$var$gLoopColor = tempArray[0].LoopColor;
    $57e66c5a34f265b4$var$gNonCompliantColor = tempArray[0].NonCompliantColor;
    $57e66c5a34f265b4$var$gPartialNonCompliantColor = tempArray[0].PartialNonCompliantColor;
    $57e66c5a34f265b4$var$gAutomationColor = tempArray[0].AutomationColor;
    $57e66c5a34f265b4$var$gPartialAutomationColor = tempArray[0].PartialAutomationColor;
    $57e66c5a34f265b4$var$gVisualizerBackgroundColor = tempArray[0].VisualizerBackgroundColor;
    $57e66c5a34f265b4$var$gSpacingColumn = tempArray[0].SpacingColumn;
    $57e66c5a34f265b4$var$gSpacingLayer = tempArray[0].SpacingLayer;
    $57e66c5a34f265b4$var$gZoomToFit = tempArray[0].ZoomToFit;
}
function $57e66c5a34f265b4$export$a05e78e48e0598a5(importedSettings) {
    let tempArray;
    try {
        tempArray = JSON.parse(importedSettings);
    } catch (e) {
        (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid gauges file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "settings_visualizer"
        });
        return;
    }
    $57e66c5a34f265b4$var$gGaugePercTasks = tempArray[0].gaugePercTasks;
    $57e66c5a34f265b4$var$gGaugePercEvents = tempArray[0].gaugePercEvents;
    $57e66c5a34f265b4$var$gGaugeXofYVariants = tempArray[0].gaugeXofYVariants;
    $57e66c5a34f265b4$var$gGaugeXofYSteps = tempArray[0].gaugeXofYSteps;
    $57e66c5a34f265b4$var$gGaugeXofYActivities = tempArray[0].gaugeXofYActivities;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = tempArray[0].gaugeXofYVariantsCompliant;
    $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = tempArray[0].gaugeXofYTasksCompliant;
    $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = tempArray[0].gaugeXofYEventsCompliant;
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = tempArray[0].gaugePercVariantsCompliant;
    $57e66c5a34f265b4$var$gGaugePercTasksCompliant = tempArray[0].gaugePercTasksCompliant;
    $57e66c5a34f265b4$var$gGaugePercEventsCompliant = tempArray[0].gaugePercEventsCompliant;
    $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = tempArray[0].gaugeXofYVariantsAutomated;
    $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = tempArray[0].gaugeXofYTasksAutomated;
    $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = tempArray[0].gaugeXofYEventsAutomated;
    $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = tempArray[0].gaugePercVariantsAutomated;
    $57e66c5a34f265b4$var$gGaugePercTasksAutomated = tempArray[0].gaugePercTasksAutomated;
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = tempArray[0].gaugePercEventsAutomated;
    $57e66c5a34f265b4$var$gGaugePercCostSaving = tempArray[0].gaugePercCostSaving;
    $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = tempArray[0].gaugeAvgCostSavingPerTask;
    $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = tempArray[0].gaugeAvgCostPerTask;
    $57e66c5a34f265b4$var$gGaugeCostSaving = tempArray[0].gaugeCostSaving;
    $57e66c5a34f265b4$var$gGaugeActualCost = tempArray[0].gaugeActualCost;
    $57e66c5a34f265b4$var$gGaugeForecastCost = tempArray[0].gaugeForecastCost;
}
function $57e66c5a34f265b4$export$435ccb6e63ccfec4(performance) {
    let performanceArray = [];
    let valueToPush = [];
    let fromActivityStr = "";
    let toActivityStr = "";
    if (performance.mode == "new" || performance.mode == "edit") {
        valueToPush = [];
        let vtp = [];
        vtp["fromActivity"] = parseInt(performance.fromNode);
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(performance.fromNode)) {
            fromActivityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            break;
        }
        vtp["toActivity"] = parseInt(performance.toNode);
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == parseInt(performance.toNode)) {
            toActivityStr = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
            break;
        }
    }
    if (performance.mode == "edit") {
        valueToPush = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gPerformanceRules.length; i++)if ($57e66c5a34f265b4$var$gPerformanceRules[i].ruleID === parseInt(performance.ruleID)) {
            valueToPush["rule"] = $57e66c5a34f265b4$var$gPerformanceRules[i].rule;
            valueToPush["ruleID"] = $57e66c5a34f265b4$var$gPerformanceRules[i].ruleID;
            valueToPush["variantType"] = $57e66c5a34f265b4$var$gPerformanceRules[i].variantType;
            valueToPush["taskType"] = $57e66c5a34f265b4$var$gPerformanceRules[i].taskType;
            valueToPush["filterLoops"] = $57e66c5a34f265b4$var$gPerformanceRules[i].filterLoops;
            valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gPerformanceRules[i].calculateCostImpact;
            valueToPush["mode"] = $57e66c5a34f265b4$var$gPerformanceRules[i].mode;
            valueToPush["type"] = $57e66c5a34f265b4$var$gPerformanceRules[i].type;
            valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gPerformanceRules[i].fromActivity;
            valueToPush["fromActivityStr"] = $57e66c5a34f265b4$var$gPerformanceRules[i].fromActivityStr;
            valueToPush["toActivity"] = $57e66c5a34f265b4$var$gPerformanceRules[i].toActivity;
            valueToPush["toActivityStr"] = $57e66c5a34f265b4$var$gPerformanceRules[i].toActivityStr;
            valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gPerformanceRules[i].filter_task_attributes;
            valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gPerformanceRules[i].filter_task_metrics;
            valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gPerformanceRules[i].filter_task_time;
            valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gPerformanceRules[i].filter_task_tasks;
            valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gPerformanceRules[i].conditionsArray;
            valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationOperator;
            valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationActualFrom;
            valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationActualTo;
            valueToPush["durationValue"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationValue;
            valueToPush["durationReductionType"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationReductionType;
            valueToPush["durationReductionPercentage"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationReductionPercentage;
            valueToPush["durationReductionActual"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationReductionActual;
            valueToPush["durationReductionValue"] = $57e66c5a34f265b4$var$gPerformanceRules[i].durationReductionValue;
        }
        performanceArray.push(valueToPush);
        $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, "delete", false, "modal");
    }
    performanceArray = [];
    valueToPush = [];
    if (performance.mode == "edit" || performance.mode == "new") {
        valueToPush["rule"] = performance.rule.trim();
        valueToPush["ruleID"] = performance.ruleID;
        valueToPush["variantType"] = performance.variantType;
        valueToPush["taskType"] = performance.taskType;
        valueToPush["filterLoops"] = performance.filterLoops;
        valueToPush["calculateCostImpact"] = performance.calculateCostImpact;
        valueToPush["mode"] = performance.mode;
        valueToPush["type"] = performance.type;
        valueToPush["fromActivity"] = performance.fromNode;
        valueToPush["fromActivityStr"] = fromActivityStr;
        valueToPush["toActivity"] = performance.toNode;
        valueToPush["toActivityStr"] = toActivityStr;
        valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gTaskFilterAttributes;
        valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gTaskFilterMetrics;
        valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gTaskFilterTime;
        valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gTaskFilterTasks;
        valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gFilterConditions;
        valueToPush["durationOperator"] = performance.durationOperator;
        valueToPush["durationActualFrom"] = performance.durationActualFrom;
        valueToPush["durationActualTo"] = performance.durationActualTo;
        valueToPush["durationValue"] = performance.durationValue;
        valueToPush["durationReductionType"] = performance.durationReductionType;
        valueToPush["durationReductionPercentage"] = performance.durationReductionPercentage;
        valueToPush["durationReductionActual"] = performance.durationReductionActual;
        valueToPush["durationReductionValue"] = performance.durationReductionValue;
        performanceArray.push(valueToPush);
        $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, "new", false, "modal");
    }
    if (performance.mode == "delete") {
        valueToPush["ruleID"] = performance.ruleID;
        valueToPush["fromActivity"] = performance.fromNode;
        valueToPush["fromActivityStr"] = fromActivityStr;
        valueToPush["toActivity"] = performance.toNode;
        valueToPush["toActivityStr"] = toActivityStr;
        performanceArray.push(valueToPush);
        $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, "delete", false, "modal");
    }
    $57e66c5a34f265b4$export$5ab172c29019f18a(performanceArray, false);
    (0, $73069f16c491914f$export$88a8e14f5b48311)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
        message: "Performance rule processed",
        severity: "success",
        showAlert: true,
        timeOutActive: true,
        component: "performance_rules"
    });
}
function $57e66c5a34f265b4$export$5ab172c29019f18a(performance, mode, applyFilter, source) {
    let x = 0;
    let gSlicedVariants = [];
    let valueToPush = [];
    let events = 0;
    let tasks = 0;
    let selectedVariants = [];
    let totalActualCost = 0;
    let totalForecastCost = 0;
    let totalImpactDuration = 0;
    let ruleID = 0;
    if (!performance[x].ruleID) {
        for(let j = 0; j < $57e66c5a34f265b4$var$gPerformanceRules.length; j++)if ($57e66c5a34f265b4$var$gPerformanceRules[j].ruleID > ruleID) ruleID = $57e66c5a34f265b4$var$gPerformanceRules[j].ruleID;
        ruleID = ruleID + 100;
    } else ruleID = performance[x].ruleID;
    let key = "pr-" + ruleID;
    if (mode == "new") {
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
        // determine valid variants
        let validVariants = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
            let validVariant = true;
            if (performance[x].variantType == "selected_variants") {
                validVariant = false;
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validVariant = true;
                    break;
                }
            }
            if (performance[x].variantType == "sliced_variants") {
                validVariant = false;
                if ($57e66c5a34f265b4$var$gVariantArray[i].sliced === true) {
                    validVariant = true;
                    let vtp = [];
                    vtp["id"] = $57e66c5a34f265b4$var$gVariantArray[i].id;
                    vtp["n"] = $57e66c5a34f265b4$var$gVariantArray[i].n;
                    vtp["s"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    vtp["v"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    gSlicedVariants.push(vtp);
                }
            }
            if (validVariant == true) {
                valueToPush = [];
                valueToPush["v"] = parseInt($57e66c5a34f265b4$var$gVariantArray[i].v);
                validVariants.push(valueToPush);
            }
        }
        if (performance[x].variantType === "selected_variants") selectedVariants = [
            ...$57e66c5a34f265b4$var$gVariantPaneVariants
        ];
        if (performance[x].variantType === "sliced_variants") selectedVariants = [
            ...gSlicedVariants
        ];
        let task = "";
        let durationReductionActual = performance[0].durationReductionActual;
        if (performance[0].durationReductionValue === "mins") durationReductionActual = performance[0].durationReductionActual * 60;
        if (performance[0].durationReductionValue === "hrs") durationReductionActual = performance[0].durationReductionActual * 3600;
        if (performance[0].durationReductionValue === "days") durationReductionActual = performance[0].durationReductionActual * 86400;
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
            $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i1].filtered == 1 && performance[x].taskType == "filtered_tasks") break;
            let validEvent = false;
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].f) == parseInt(performance[x].fromActivity) && parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].t) == parseInt(performance[x].toActivity)) validEvent = true;
            if (validEvent == true) {
                validEvent = false;
                for(let j2 = 0; j2 < validVariants.length; j2++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].v == validVariants[j2].v) {
                    validEvent = true;
                    break;
                }
                if (validEvent == true) {
                    validEvent = false;
                    if (performance[x].durationOperator !== "N/A") validEvent = $57e66c5a34f265b4$var$checkStepDuration(performance[x].durationOperator, performance[x].durationActualFrom, performance[x].durationActualTo, performance[x].durationValue, $57e66c5a34f265b4$var$gEventLogArray[i1].d);
                    else validEvent = true;
                    if (validEvent == true) {
                        events++;
                        if (task != $57e66c5a34f265b4$var$gEventLogArray[i1].k) tasks++;
                        $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 1;
                        let vtp1 = [];
                        let rules = $57e66c5a34f265b4$var$gEventLogArray[i1].rules;
                        vtp1["ruleID"] = key;
                        let forecastCost = null;
                        let duration = 0;
                        if (performance[0].durationReductionType === "actual") {
                            duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d - durationReductionActual;
                            if (duration < 0) duration = 0;
                        }
                        if (performance[0].durationReductionType === "percentage" && $57e66c5a34f265b4$var$gEventLogArray[i1].d != 0) duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d * ((100 - parseFloat(performance[0].durationReductionPercentage)) / 100);
                        if (performance[x].calculateCostImpact == true) {
                            if ($57e66c5a34f265b4$var$gEventLogArray[i1].d > 0) {
                                forecastCost = duration / $57e66c5a34f265b4$var$gEventLogArray[i1].d * $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
                                totalForecastCost = totalForecastCost + forecastCost;
                            }
                            vtp1["calculateCostImpact"] = true;
                        } else vtp1["calculateCostImpact"] = false;
                        vtp1["forecastCost"] = forecastCost;
                        rules.push(vtp1);
                        $57e66c5a34f265b4$var$gEventLogArray[i1].rules = rules;
                        totalImpactDuration = totalImpactDuration + $57e66c5a34f265b4$var$gEventLogArray[i1].d;
                        totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
                        task = $57e66c5a34f265b4$var$gEventLogArray[i1].k;
                    }
                }
            }
        }
    }
    if (mode == "delete") {
        let key1 = "pr-" + performance[x].ruleID;
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++)if ($57e66c5a34f265b4$var$gEventLogArray[i2][key1] === 1) {
            $57e66c5a34f265b4$var$gEventLogArray[i2][key1] = 0;
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gEventLogArray[i2].rules.length; j3++)if ($57e66c5a34f265b4$var$gEventLogArray[i2].rules[j3].ruleID === key1) {
                $57e66c5a34f265b4$var$gEventLogArray[i2].rules.splice(j3, 1);
                break;
            }
        }
        for(let k = 0; k < $57e66c5a34f265b4$var$gPerformanceRules.length; k++)if ($57e66c5a34f265b4$var$gPerformanceRules[k].ruleID === performance[x].ruleID) {
            $57e66c5a34f265b4$var$gPerformanceRules.splice(k, 1);
            break;
        }
    }
    if (mode == "update_cost") {
        let key2 = "pr-" + performance[x].ruleID;
        let durationReductionActual1 = performance[0].durationReductionActual;
        if (performance[0].durationReductionValue === "mins") durationReductionActual1 = performance[0].durationReductionActual * 60;
        if (performance[0].durationReductionValue === "hrs") durationReductionActual1 = performance[0].durationReductionActual * 3600;
        if (performance[0].durationReductionValue === "days") durationReductionActual1 = performance[0].durationReductionActual * 86400;
        totalActualCost = 0;
        totalForecastCost = 0;
        let d = 0;
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gEventLogArray.length; i3++)if ($57e66c5a34f265b4$var$gEventLogArray[i3][key2] === 1) {
            let forecastCost1 = null;
            // recaulate the forecast cost if calculate cost impact == true
            if (performance[x].calculateCostImpact == true) {
                let duration1 = 0;
                if (performance[0].durationReductionType === "actual") {
                    duration1 = $57e66c5a34f265b4$var$gEventLogArray[i3].d - durationReductionActual1;
                    if (duration1 < 0) duration1 = 0;
                }
                if (performance[0].durationReductionType === "percentage" && $57e66c5a34f265b4$var$gEventLogArray[i3].d != 0) duration1 = $57e66c5a34f265b4$var$gEventLogArray[i3].d * ((100 - parseFloat(performance[0].durationReductionPercentage)) / 100);
                if ($57e66c5a34f265b4$var$gEventLogArray[i3].d > 0) {
                    forecastCost1 = duration1 / $57e66c5a34f265b4$var$gEventLogArray[i3].d * $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                    totalForecastCost = totalForecastCost + forecastCost1;
                }
            }
            for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gEventLogArray[i3].rules.length; j4++)if ($57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].ruleID === key2) {
                // we have the record to update the actual_cost for
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].actualCost = $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].forecastCost = forecastCost1;
                totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                break;
            }
        }
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gPerformanceRules.length; i4++)if ($57e66c5a34f265b4$var$gPerformanceRules[i4].ruleID === performance[x].ruleID) {
            $57e66c5a34f265b4$var$gPerformanceRules[i4].actualCost = totalActualCost;
            $57e66c5a34f265b4$var$gPerformanceRules[i4].forecastCost = totalForecastCost;
        }
    }
    if (mode == "new") {
        valueToPush = {};
        valueToPush["fromActivity"] = performance[x].fromActivity;
        valueToPush["fromActivityStr"] = performance[x].fromActivityStr;
        valueToPush["toActivity"] = performance[x].toActivity;
        valueToPush["toActivityStr"] = performance[x].toActivityStr;
        valueToPush["variantType"] = performance[x].variantType;
        valueToPush["taskType"] = performance[x].taskType;
        valueToPush["rule"] = performance[x].rule;
        valueToPush["durationOperator"] = performance[x].durationOperator;
        valueToPush["durationActualFrom"] = performance[x].durationActualFrom;
        valueToPush["durationActualTo"] = performance[x].durationActualTo;
        valueToPush["durationValue"] = performance[x].durationValue;
        valueToPush["durationReductionType"] = performance[x].durationReductionType;
        valueToPush["durationReductionPercentage"] = performance[x].durationReductionPercentage;
        valueToPush["durationReductionActual"] = performance[x].durationReductionActual;
        valueToPush["durationReductionValue"] = performance[x].durationReductionValue;
        if (performance[x].taskType != "all_tasks") {
            valueToPush["filter_task_attributes"] = performance[x].filter_task_attributes;
            valueToPush["filter_task_metrics"] = performance[x].filter_task_metrics;
            valueToPush["filter_task_time"] = performance[x].filter_task_time;
            valueToPush["filter_task_tasks"] = performance[x].filter_task_tasks;
        } else {
            valueToPush["filter_task_attributes"] = [];
            valueToPush["filter_task_metrics"] = [];
            valueToPush["filter_task_time"] = [];
            valueToPush["filter_task_tasks"] = [];
        }
        valueToPush["selected_variants"] = selectedVariants;
        if (source === "model_import" || source === "file_import") valueToPush["conditionsArray"] = performance[x].conditionsArray;
        else valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$conditionsArray("performance", performance[x], performance[x].variantType, performance[x].taskType, performance[x].fromActivityStr, performance[x].toActivityStr);
        valueToPush["calculateCostImpact"] = performance[x].calculateCostImpact;
        if (valueToPush["calculateCostImpact"] == true) {
            valueToPush["actualCost"] = totalActualCost;
            valueToPush["forecastCost"] = totalForecastCost;
        } else {
            valueToPush["actualCost"] = null;
            valueToPush["forecastCost"] = null;
        }
        valueToPush["impactDuration"] = totalImpactDuration;
        valueToPush["ruleID"] = ruleID;
        valueToPush["key"] = key;
        valueToPush["mode"] = performance[x].mode;
        valueToPush["type"] = performance[x].type;
        valueToPush["events"] = events;
        valueToPush["tasks"] = tasks;
        valueToPush["category"] = "performance";
        $57e66c5a34f265b4$var$gPerformanceRules.push(valueToPush);
    }
    if (source != "file_import" && source != "model_import") $57e66c5a34f265b4$export$59798dda46c3d2b5(applyFilter, false, "process performance");
    else if (applyFilter == true) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("processPerformance");
    if (mode === "delete" && performance[x].mode === "edit") return;
    if (source != "model_import") {
        $57e66c5a34f265b4$var$updateForecastCost();
        $57e66c5a34f265b4$var$updateCostMetrics("processPerformance");
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$updateAttributes();
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $27da566ba975f5d5$export$d9025152d14cd3b)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        $57e66c5a34f265b4$export$2ff5de46d769d306("processPerformance");
    }
}
function $57e66c5a34f265b4$var$updateForecastCost() {
    // obtain the max forecast cost
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        let forecastCost = 999999999;
        for(let j = 0; j < $57e66c5a34f265b4$var$gEventLogArray[i].rules.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].rules[j].forecastCost < forecastCost && $57e66c5a34f265b4$var$gEventLogArray[i].rules[j].calculateCostImpact == true) forecastCost = $57e66c5a34f265b4$var$gEventLogArray[i].rules[j].forecastCost;
        if (forecastCost >= $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost || forecastCost === 999999999) forecastCost = $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost;
        $57e66c5a34f265b4$var$gEventLogArray[i].forecast_cost = forecastCost;
    }
}
function $57e66c5a34f265b4$export$46a207868612a8fe(compliance) {
    let complianceArray = [];
    let valueToPush = [];
    let fromActivityStr = "";
    let toActivityStr = "";
    if (compliance.mode == "new" || compliance.mode == "edit") {
        valueToPush = [];
        let vtp = [];
        vtp["fromActivity"] = parseInt(compliance.fromNode);
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(compliance.fromNode)) {
            fromActivityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            break;
        }
        vtp["toActivity"] = parseInt(compliance.toNode);
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == parseInt(compliance.toNode)) {
            toActivityStr = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
            break;
        }
    }
    if (compliance.mode == "edit") {
        valueToPush = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gComplianceRules.length; i++)if ($57e66c5a34f265b4$var$gComplianceRules[i].ruleID === parseInt(compliance.ruleID)) {
            valueToPush["rule"] = $57e66c5a34f265b4$var$gComplianceRules[i].rule;
            valueToPush["ruleID"] = $57e66c5a34f265b4$var$gComplianceRules[i].ruleID;
            valueToPush["variantType"] = $57e66c5a34f265b4$var$gComplianceRules[i].variantType;
            valueToPush["taskType"] = $57e66c5a34f265b4$var$gComplianceRules[i].taskType;
            valueToPush["filterLoops"] = $57e66c5a34f265b4$var$gComplianceRules[i].filterLoops;
            valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gComplianceRules[i].calculateCostImpact;
            valueToPush["mode"] = $57e66c5a34f265b4$var$gComplianceRules[i].mode;
            valueToPush["type"] = $57e66c5a34f265b4$var$gComplianceRules[i].type;
            valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gComplianceRules[i].fromActivity;
            valueToPush["fromActivityStr"] = $57e66c5a34f265b4$var$gComplianceRules[i].fromActivityStr;
            valueToPush["toActivity"] = $57e66c5a34f265b4$var$gComplianceRules[i].toActivity;
            valueToPush["toActivityStr"] = $57e66c5a34f265b4$var$gComplianceRules[i].toActivityStr;
            valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gComplianceRules[i].filter_task_attributes;
            valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gComplianceRules[i].filter_task_metrics;
            valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gComplianceRules[i].filter_task_time;
            valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gComplianceRules[i].filter_task_tasks;
            valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gComplianceRules[i].conditionsArray;
            valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationOperator;
            valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualFrom;
            valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualTo;
            valueToPush["durationValue"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationValue;
        }
        complianceArray.push(valueToPush);
        $57e66c5a34f265b4$export$ed156e5e6c311db5(complianceArray, "delete", false, "modal");
    }
    complianceArray = [];
    valueToPush = [];
    if (compliance.mode == "edit" || compliance.mode == "new") {
        valueToPush["rule"] = compliance.rule.trim();
        valueToPush["ruleID"] = compliance.ruleID;
        valueToPush["variantType"] = compliance.variantType;
        valueToPush["taskType"] = compliance.taskType;
        valueToPush["filterLoops"] = compliance.filterLoops;
        valueToPush["calculateCostImpact"] = compliance.calculateCostImpact;
        valueToPush["mode"] = compliance.mode;
        valueToPush["type"] = compliance.type;
        valueToPush["fromActivity"] = compliance.fromNode;
        valueToPush["fromActivityStr"] = fromActivityStr;
        valueToPush["toActivity"] = compliance.toNode;
        valueToPush["toActivityStr"] = toActivityStr;
        valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gTaskFilterAttributes;
        valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gTaskFilterMetrics;
        valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gTaskFilterTime;
        valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gTaskFilterTasks;
        valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gFilterConditions;
        valueToPush["durationOperator"] = compliance.durationOperator;
        valueToPush["durationActualFrom"] = compliance.durationActualFrom;
        valueToPush["durationActualTo"] = compliance.durationActualTo;
        valueToPush["durationValue"] = compliance.durationValue;
        complianceArray.push(valueToPush);
        $57e66c5a34f265b4$export$ed156e5e6c311db5(complianceArray, "new", false, "modal");
    }
    if (compliance.mode == "delete") {
        valueToPush["ruleID"] = compliance.ruleID;
        complianceArray.push(valueToPush);
        $57e66c5a34f265b4$export$ed156e5e6c311db5(complianceArray, "delete", false, "modal");
    }
    (0, $73069f16c491914f$export$88a8e14f5b48311)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
        message: "Compliance rule processed",
        severity: "success",
        showAlert: true,
        timeOutActive: true,
        component: "compliance_rules"
    });
}
function $57e66c5a34f265b4$export$ed156e5e6c311db5(compliance, mode, applyFilter, source) {
    let x = 0;
    let gSlicedVariants = [];
    let valueToPush = [];
    let events = 0;
    let tasks = 0;
    let totalActualCost = 0;
    let totalForecastCost = 0;
    let totalImpactDuration = 0;
    let selectedVariants = [];
    let ruleID = 0;
    if (!compliance[x].ruleID) {
        for(let j = 0; j < $57e66c5a34f265b4$var$gComplianceRules.length; j++)if ($57e66c5a34f265b4$var$gComplianceRules[j].ruleID > ruleID) ruleID = $57e66c5a34f265b4$var$gComplianceRules[j].ruleID;
        ruleID = ruleID + 100;
    } else ruleID = compliance[x].ruleID;
    let key = "cr-" + ruleID;
    if (mode == "new") {
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
        $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        // determine valid variants
        let validVariants = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
            let validVariant = true;
            if (compliance[x].variantType == "selected_variants") {
                validVariant = false;
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validVariant = true;
                    break;
                }
            }
            if (compliance[x].variantType == "sliced_variants") {
                validVariant = false;
                if ($57e66c5a34f265b4$var$gVariantArray[i].sliced === true) {
                    validVariant = true;
                    let vtp = [];
                    vtp["id"] = $57e66c5a34f265b4$var$gVariantArray[i].id;
                    vtp["n"] = $57e66c5a34f265b4$var$gVariantArray[i].n;
                    vtp["s"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    vtp["v"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    gSlicedVariants.push(vtp);
                }
            }
            if (validVariant == true) {
                valueToPush = [];
                valueToPush["v"] = parseInt($57e66c5a34f265b4$var$gVariantArray[i].v);
                validVariants.push(valueToPush);
            }
        }
        if (compliance[x].variantType === "selected_variants") selectedVariants = [
            ...$57e66c5a34f265b4$var$gVariantPaneVariants
        ];
        if (compliance[x].variantType === "sliced_variants") selectedVariants = [
            ...gSlicedVariants
        ];
        let task = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
            $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i1].filtered == 1 && compliance[x].taskType == "filtered_tasks") break;
            let validEvent = false;
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].f) == parseInt(compliance[x].fromActivity) && parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].t) == parseInt(compliance[x].toActivity)) validEvent = true;
            if (validEvent == true) {
                validEvent = false;
                if (compliance[x].durationOperator !== "N/A") validEvent = $57e66c5a34f265b4$var$checkStepDuration(compliance[x].durationOperator, compliance[x].durationActualFrom, compliance[x].durationActualTo, compliance[x].durationValue, $57e66c5a34f265b4$var$gEventLogArray[i1].d);
                else validEvent = true;
                if (validEvent === true) {
                    validEvent = false;
                    for(let j2 = 0; j2 < validVariants.length; j2++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].v == validVariants[j2].v) {
                        validEvent = true;
                        break;
                    }
                    if (validEvent == true) {
                        $57e66c5a34f265b4$var$gEventLogArray[i1].compliant = false;
                        $57e66c5a34f265b4$var$gEventLogArray[i1].cc++;
                        events++;
                        if (task != $57e66c5a34f265b4$var$gEventLogArray[i1].k) tasks++;
                        $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 1;
                        let vtp1 = [];
                        let rules = $57e66c5a34f265b4$var$gEventLogArray[i1].rules;
                        vtp1["ruleID"] = key;
                        let forecastCost = null;
                        if (compliance[x].calculateCostImpact == true) {
                            forecastCost = 0;
                            vtp1["calculateCostImpact"] = true;
                        } else vtp1["calculateCostImpact"] = false;
                        vtp1["forecastCost"] = forecastCost;
                        rules.push(vtp1);
                        $57e66c5a34f265b4$var$gEventLogArray[i1].rules = rules;
                        totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost; // set by cost rules
                        totalImpactDuration = totalImpactDuration + $57e66c5a34f265b4$var$gEventLogArray[i1].d;
                        task = $57e66c5a34f265b4$var$gEventLogArray[i1].k;
                    }
                }
            }
        }
    }
    if (mode == "delete") {
        let key1 = "cr-" + compliance[x].ruleID;
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++)if ($57e66c5a34f265b4$var$gEventLogArray[i2][key1] === 1) {
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].cc > 0) $57e66c5a34f265b4$var$gEventLogArray[i2].cc--;
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].cc === 0) $57e66c5a34f265b4$var$gEventLogArray[i2].compliant = true;
            $57e66c5a34f265b4$var$gEventLogArray[i2][key1] = 0;
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gEventLogArray[i2].rules.length; j3++)if ($57e66c5a34f265b4$var$gEventLogArray[i2].rules[j3].ruleID === key1) {
                $57e66c5a34f265b4$var$gEventLogArray[i2].rules.splice(j3, 1);
                break;
            }
        }
        for(let k = 0; k < $57e66c5a34f265b4$var$gComplianceRules.length; k++)if ($57e66c5a34f265b4$var$gComplianceRules[k].ruleID === compliance[x].ruleID) {
            $57e66c5a34f265b4$var$gComplianceRules.splice(k, 1);
            break;
        }
    }
    if (mode == "update_cost") {
        totalActualCost = 0;
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gEventLogArray.length; i3++)if ($57e66c5a34f265b4$var$gEventLogArray[i3][key] === 1) {
            for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gEventLogArray[i3].rules.length; j4++)if ($57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].ruleID === key) {
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].actualCost = $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].forecastCost = 0;
                totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                break;
            }
        }
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gAutomationRules.length; i4++)if ($57e66c5a34f265b4$var$gComplianceRules[i4].ruleID === automation[x].ruleID) {
            $57e66c5a34f265b4$var$gComplianceRules[i4].actualCost = totalActualCost;
            $57e66c5a34f265b4$var$gComplianceRules[i4].forecastCost = 0;
        }
    }
    if (mode == "new") {
        valueToPush = {};
        valueToPush["fromActivity"] = compliance[x].fromActivity;
        valueToPush["fromActivityStr"] = compliance[x].fromActivityStr;
        valueToPush["toActivity"] = compliance[x].toActivity;
        valueToPush["toActivityStr"] = compliance[x].toActivityStr;
        valueToPush["variantType"] = compliance[x].variantType;
        valueToPush["taskType"] = compliance[x].taskType;
        valueToPush["rule"] = compliance[x].rule;
        if (compliance[x].taskType != "all_tasks") {
            valueToPush["filter_task_attributes"] = compliance[x].filter_task_attributes;
            valueToPush["filter_task_metrics"] = compliance[x].filter_task_metrics;
            valueToPush["filter_task_time"] = compliance[x].filter_task_time;
            valueToPush["filter_task_tasks"] = compliance[x].filter_task_tasks;
        } else {
            valueToPush["filter_task_attributes"] = [];
            valueToPush["filter_task_metrics"] = [];
            valueToPush["filter_task_time"] = [];
            valueToPush["filter_task_tasks"] = [];
        }
        valueToPush["selected_variants"] = selectedVariants;
        if (source === "model_import" || source === "file_import") valueToPush["conditionsArray"] = compliance[x].conditionsArray;
        else valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$conditionsArray("compliance", compliance[x], compliance[x].variantType, compliance[x].taskType, compliance[x].fromActivityStr, compliance[x].toActivityStr);
        valueToPush["calculateCostImpact"] = compliance[x].calculateCostImpact;
        if (valueToPush["calculateCostImpact"] == true) {
            valueToPush["actualCost"] = totalActualCost;
            valueToPush["forecastCost"] = 0;
        } else {
            valueToPush["actualCost"] = null;
            valueToPush["forecastCost"] = null;
        }
        valueToPush["impactDuration"] = totalImpactDuration;
        valueToPush["durationOperator"] = compliance[x].durationOperator;
        valueToPush["durationActualFrom"] = compliance[x].durationActualFrom;
        valueToPush["durationActualTo"] = compliance[x].durationActualTo;
        valueToPush["durationValue"] = compliance[x].durationValue;
        valueToPush["ruleID"] = ruleID;
        valueToPush["key"] = key;
        valueToPush["mode"] = compliance[x].mode;
        valueToPush["type"] = compliance[x].type;
        valueToPush["events"] = events;
        valueToPush["tasks"] = tasks;
        valueToPush["category"] = "compliance";
        $57e66c5a34f265b4$var$gComplianceRules.push(valueToPush);
    }
    if (source != "file_import" && source != "model_import") $57e66c5a34f265b4$export$59798dda46c3d2b5(applyFilter, false, "process compliance");
    else if (applyFilter == true) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("processCompliance");
    if (mode === "delete" && compliance[x].mode === "edit") return;
    if (source != "model_import") {
        $57e66c5a34f265b4$var$updateForecastCost();
        $57e66c5a34f265b4$var$updateCostMetrics("processCompliance");
        $57e66c5a34f265b4$var$updateComplianceMetrics();
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$var$updateAttributes();
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8b3a953f334c1c39$export$88d9d129a5d66a46)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        $57e66c5a34f265b4$export$2ff5de46d769d306("processCompliance");
    }
}
function $57e66c5a34f265b4$var$updateComplianceMetrics() {
    // gStepArray has already been updated in GenerateArrays
    // update task array
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskArray.length; i++)$57e66c5a34f265b4$var$gTaskArray[i].compliant = true;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        $57e66c5a34f265b4$var$gVariantArray[i1].compliant = true;
        $57e66c5a34f265b4$var$gVariantArray[i1].compliant_tasks = $57e66c5a34f265b4$var$gVariantArray[i1].t;
        $57e66c5a34f265b4$var$gVariantArray[i1].compliant_events = $57e66c5a34f265b4$var$gVariantArray[i1].e;
    }
    let variant = "";
    let variantCompliant = true;
    let variantNonCompliantTasks = 0;
    let variantNonCompliantEvents = 0;
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    // update variant compliance #1  (events compliant and variance compliance)
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    let i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if (i2 > 0 && variant != $57e66c5a34f265b4$var$gEventLogArray[i2].v) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].compliant_events = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].e - variantNonCompliantEvents;
            if (variantCompliant == false) {
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].compliant = false;
                $57e66c5a34f265b4$var$gNonCompliantVariants++;
            }
            variantCompliant = true;
            variantNonCompliantEvents = 0;
        }
        variant = $57e66c5a34f265b4$var$gEventLogArray[i2].v;
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == false) {
            variantCompliant = false;
            variantNonCompliantEvents++;
            $57e66c5a34f265b4$var$gNonCompliantEvents++;
        }
    }
    if (i2 > 0) {
        $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].compliant_events = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].e - variantNonCompliantEvents;
        if (variantCompliant == false) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].compliant;
            $57e66c5a34f265b4$var$gNonCompliantVariants++;
        }
    }
    // update task compliance
    let task = "";
    let taskCompliant = true;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if (i2 > 0 && task != $57e66c5a34f265b4$var$gEventLogArray[i2].k) {
            if (taskCompliant == false) {
                $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].tid].compliant = false;
                $57e66c5a34f265b4$var$gNonCompliantTasks++;
            } else $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].tid].compliant = true;
            taskCompliant = true;
        }
        task = $57e66c5a34f265b4$var$gEventLogArray[i2].k;
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == false) taskCompliant = false;
    }
    if (taskCompliant == false) {
        $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].tid].compliant = false;
        $57e66c5a34f265b4$var$gNonCompliantTasks++;
    }
    // update variant with tasks compliant
    task = "";
    variantNonCompliantTasks = 0;
    variant = "";
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.v - b.v || a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gTaskArray.length; i2++){
        if (i2 > 0 && variant != $57e66c5a34f265b4$var$gTaskArray[i2].v) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].compliant_tasks = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].t - variantNonCompliantTasks;
            variantNonCompliantTasks = 0;
        }
        variant = $57e66c5a34f265b4$var$gTaskArray[i2].v;
        if ($57e66c5a34f265b4$var$gTaskArray[i2].compliant == false) variantNonCompliantTasks++;
    }
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].compliant_tasks = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].t - variantNonCompliantTasks;
}
function $57e66c5a34f265b4$export$f0220684fd55607b() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gComplianceRules);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_compliance.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$771482f4149f9211() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gAutomationRules);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_automation.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$916e6628548e4bef() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gPerformanceRules);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_performance.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$4b0dd0642d0d11f1() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gCostRules);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_cost.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$451049238f8e339c(automation1) {
    let automationArray = [];
    let valueToPush = [];
    let fromActivityStr = "";
    let toActivityStr = "";
    if (automation1.mode == "new" || automation1.mode == "edit") {
        valueToPush = [];
        let vtp = [];
        vtp["fromActivity"] = parseInt(automation1.fromNode);
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(automation1.fromNode)) {
            fromActivityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            break;
        }
        vtp["toActivity"] = parseInt(automation1.toNode);
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == parseInt(automation1.toNode)) {
            toActivityStr = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
            break;
        }
    }
    if (automation1.mode == "edit") {
        valueToPush = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gAutomationRules.length; i++)if ($57e66c5a34f265b4$var$gAutomationRules[i].ruleID === parseInt(automation1.ruleID)) {
            valueToPush["rule"] = $57e66c5a34f265b4$var$gAutomationRules[i].rule;
            valueToPush["ruleID"] = $57e66c5a34f265b4$var$gAutomationRules[i].ruleID;
            valueToPush["variantType"] = $57e66c5a34f265b4$var$gAutomationRules[i].variantType;
            valueToPush["taskType"] = $57e66c5a34f265b4$var$gAutomationRules[i].taskType;
            valueToPush["filterLoops"] = $57e66c5a34f265b4$var$gAutomationRules[i].filterLoops;
            valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gAutomationRules[i].calculateCostImpact;
            valueToPush["mode"] = $57e66c5a34f265b4$var$gAutomationRules[i].mode;
            valueToPush["type"] = $57e66c5a34f265b4$var$gAutomationRules[i].type;
            valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gAutomationRules[i].fromActivity;
            valueToPush["fromActivityStr"] = $57e66c5a34f265b4$var$gAutomationRules[i].fromActivityStr;
            valueToPush["toActivity"] = $57e66c5a34f265b4$var$gAutomationRules[i].toActivity;
            valueToPush["toActivityStr"] = $57e66c5a34f265b4$var$gAutomationRules[i].toActivityStr;
            valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gAutomationRules[i].filter_task_attributes;
            valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gAutomationRules[i].filter_task_metrics;
            valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gAutomationRules[i].filter_task_time;
            valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gAutomationRules[i].filter_task_tasks;
            valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gAutomationRules[i].conditionsArray;
            valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gAutomationRules[i].durationOperator;
            valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gAutomationRules[i].durationActualFrom;
            valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gAutomationRules[i].durationActualTo;
            valueToPush["durationValue"] = $57e66c5a34f265b4$var$gAutomationRules[i].durationValue;
        }
        automationArray.push(valueToPush);
        $57e66c5a34f265b4$export$7a674125acf4456d(automationArray, "delete", false, "modal");
    }
    automationArray = [];
    valueToPush = [];
    if (automation1.mode == "edit" || automation1.mode == "new") {
        valueToPush["rule"] = automation1.rule.trim();
        valueToPush["ruleID"] = automation1.ruleID;
        valueToPush["variantType"] = automation1.variantType;
        valueToPush["taskType"] = automation1.taskType;
        valueToPush["filterLoops"] = automation1.filterLoops;
        valueToPush["calculateCostImpact"] = automation1.calculateCostImpact;
        valueToPush["mode"] = automation1.mode;
        valueToPush["type"] = automation1.type;
        valueToPush["fromActivity"] = automation1.fromNode;
        valueToPush["fromActivityStr"] = fromActivityStr;
        valueToPush["toActivity"] = automation1.toNode;
        valueToPush["toActivityStr"] = toActivityStr;
        valueToPush["filter_task_attributes"] = $57e66c5a34f265b4$var$gTaskFilterAttributes;
        valueToPush["filter_task_metrics"] = $57e66c5a34f265b4$var$gTaskFilterMetrics;
        valueToPush["filter_task_time"] = $57e66c5a34f265b4$var$gTaskFilterTime;
        valueToPush["filter_task_tasks"] = $57e66c5a34f265b4$var$gTaskFilterTasks;
        valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$gFilterConditions;
        valueToPush["durationOperator"] = automation1.durationOperator;
        valueToPush["durationActualFrom"] = automation1.durationActualFrom;
        valueToPush["durationActualTo"] = automation1.durationActualTo;
        valueToPush["durationValue"] = automation1.durationValue;
        automationArray.push(valueToPush);
        $57e66c5a34f265b4$export$7a674125acf4456d(automationArray, "new", false, "modal");
    }
    if (automation1.mode == "delete") {
        valueToPush["ruleID"] = automation1.ruleID;
        automationArray.push(valueToPush);
        $57e66c5a34f265b4$export$7a674125acf4456d(automationArray, "delete", false, "modal");
    }
    (0, $73069f16c491914f$export$88a8e14f5b48311)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
        message: "Automation rule processed",
        severity: "success",
        showAlert: true,
        timeOutActive: true,
        component: "automation_rules"
    });
}
function $57e66c5a34f265b4$export$7a674125acf4456d(automation1, mode, applyFilter, source) {
    let x = 0;
    let gSlicedVariants = [];
    let valueToPush = [];
    let events = 0;
    let tasks = 0;
    let selectedVariants = [];
    let totalActualCost = 0;
    let totalForecastCost = 0;
    let totalImpactDuration = 0;
    let ruleID = 0;
    if (!automation1[x].ruleID) {
        for(let j = 0; j < $57e66c5a34f265b4$var$gAutomationRules.length; j++)if ($57e66c5a34f265b4$var$gAutomationRules[j].ruleID > ruleID) ruleID = $57e66c5a34f265b4$var$gAutomationRules[j].ruleID;
        ruleID = ruleID + 100;
    } else ruleID = automation1[x].ruleID;
    let key = "ar-" + ruleID;
    if (mode == "new") {
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.k.localeCompare(b.k));
        $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        // determine valid variants
        let validVariants = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
            let validVariant = true;
            if (automation1[x].variantType == "selected_variants") {
                validVariant = false;
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validVariant = true;
                    break;
                }
            }
            if (automation1[x].variantType == "sliced_variants") {
                validVariant = false;
                if ($57e66c5a34f265b4$var$gVariantArray[i].sliced === true) {
                    validVariant = true;
                    let vtp = [];
                    vtp["id"] = $57e66c5a34f265b4$var$gVariantArray[i].id;
                    vtp["n"] = $57e66c5a34f265b4$var$gVariantArray[i].n;
                    vtp["s"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    vtp["v"] = $57e66c5a34f265b4$var$gVariantArray[i].s;
                    gSlicedVariants.push(vtp);
                }
            }
            if (validVariant == true) {
                valueToPush = [];
                valueToPush["v"] = parseInt($57e66c5a34f265b4$var$gVariantArray[i].v);
                validVariants.push(valueToPush);
            }
        }
        if (automation1[x].variantType === "selected_variants") selectedVariants = [
            ...$57e66c5a34f265b4$var$gVariantPaneVariants
        ];
        if (automation1[x].variantType === "sliced_variants") selectedVariants = [
            ...gSlicedVariants
        ];
        let task = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
            $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i1].filtered == 1 && automation1[x].taskType == "filtered_tasks") break;
            let validEvent = false;
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].f) == parseInt(automation1[x].fromActivity) && parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].t) == parseInt(automation1[x].toActivity)) validEvent = true;
            if (validEvent == true) {
                validEvent = false;
                for(let j2 = 0; j2 < validVariants.length; j2++)if ($57e66c5a34f265b4$var$gEventLogArray[i1].v == validVariants[j2].v) {
                    validEvent = true;
                    break;
                }
                if (validEvent == true) {
                    validEvent = false;
                    if (automation1[x].durationOperator !== "N/A") validEvent = $57e66c5a34f265b4$var$checkStepDuration(automation1[x].durationOperator, automation1[x].durationActualFrom, automation1[x].durationActualTo, automation1[x].durationValue, $57e66c5a34f265b4$var$gEventLogArray[i1].d);
                    else validEvent = true;
                    if (validEvent == true) {
                        $57e66c5a34f265b4$var$gEventLogArray[i1].automated = true;
                        $57e66c5a34f265b4$var$gEventLogArray[i1].ac++;
                        events++;
                        if (task != $57e66c5a34f265b4$var$gEventLogArray[i1].k) tasks++;
                        $57e66c5a34f265b4$var$gEventLogArray[i1][key] = 1;
                        let rules = $57e66c5a34f265b4$var$gEventLogArray[i1].rules;
                        let vtp1 = [];
                        vtp1["ruleID"] = key;
                        let forecastCost = null;
                        if (automation1[x].calculateCostImpact == true) {
                            forecastCost = 0;
                            vtp1["calculateCostImpact"] = true;
                        } else vtp1["calculateCostImpact"] = false;
                        vtp1["forecastCost"] = forecastCost;
                        rules.push(vtp1);
                        $57e66c5a34f265b4$var$gEventLogArray[i1].rules = rules;
                        totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
                        totalImpactDuration = totalImpactDuration + $57e66c5a34f265b4$var$gEventLogArray[i1].d;
                        task = $57e66c5a34f265b4$var$gEventLogArray[i1].k;
                    }
                }
            }
        }
    }
    if (mode == "delete") {
        let key1 = "ar-" + automation1[x].ruleID;
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++)if ($57e66c5a34f265b4$var$gEventLogArray[i2][key1] === 1) {
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].ac > 0) $57e66c5a34f265b4$var$gEventLogArray[i2].ac--;
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].ac === 0) $57e66c5a34f265b4$var$gEventLogArray[i2].automated = false;
            $57e66c5a34f265b4$var$gEventLogArray[i2][key1] = 0;
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gEventLogArray[i2].rules.length; j3++)if ($57e66c5a34f265b4$var$gEventLogArray[i2].rules[j3].ruleID === key1) {
                $57e66c5a34f265b4$var$gEventLogArray[i2].rules.splice(j3, 1);
                break;
            }
        }
        for(let k = 0; k < $57e66c5a34f265b4$var$gAutomationRules.length; k++)if ($57e66c5a34f265b4$var$gAutomationRules[k].ruleID === automation1[x].ruleID) {
            $57e66c5a34f265b4$var$gAutomationRules.splice(k, 1);
            break;
        }
    }
    if (mode == "update_cost") {
        totalActualCost = 0;
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gEventLogArray.length; i3++)if ($57e66c5a34f265b4$var$gEventLogArray[i3][key] === 1) {
            for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gEventLogArray[i3].rules.length; j4++)if ($57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].ruleID === key) {
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].actualCost = $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                $57e66c5a34f265b4$var$gEventLogArray[i3].rules[j4].forecastCost = 0;
                totalActualCost = totalActualCost + $57e66c5a34f265b4$var$gEventLogArray[i3].actual_cost;
                break;
            }
        }
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gAutomationRules.length; i4++)if ($57e66c5a34f265b4$var$gAutomationRules[i4].ruleID === automation1[x].ruleID) {
            $57e66c5a34f265b4$var$gAutomationRules[i4].actualCost = totalActualCost;
            $57e66c5a34f265b4$var$gAutomationRules[i4].forecastCost = 0;
        }
    }
    if (mode == "new") {
        valueToPush = {};
        valueToPush["fromActivity"] = automation1[x].fromActivity;
        valueToPush["fromActivityStr"] = automation1[x].fromActivityStr;
        valueToPush["toActivity"] = automation1[x].toActivity;
        valueToPush["toActivityStr"] = automation1[x].toActivityStr;
        valueToPush["variantType"] = automation1[x].variantType;
        valueToPush["taskType"] = automation1[x].taskType;
        valueToPush["rule"] = automation1[x].rule;
        if (automation1[x].taskType != "all_tasks") {
            valueToPush["filter_task_attributes"] = automation1[x].filter_task_attributes;
            valueToPush["filter_task_metrics"] = automation1[x].filter_task_metrics;
            valueToPush["filter_task_time"] = automation1[x].filter_task_time;
            valueToPush["filter_task_tasks"] = automation1[x].filter_task_tasks;
        } else {
            valueToPush["filter_task_attributes"] = [];
            valueToPush["filter_task_metrics"] = [];
            valueToPush["filter_task_time"] = [];
            valueToPush["filter_task_tasks"] = [];
        }
        valueToPush["selected_variants"] = selectedVariants;
        if (source === "model_import" || source === "file_import") valueToPush["conditionsArray"] = automation1[x].conditionsArray;
        else valueToPush["conditionsArray"] = $57e66c5a34f265b4$var$conditionsArray("automation", automation1[x], automation1[x].variantType, automation1[x].taskType, automation1[x].fromActivityStr, automation1[x].toActivityStr);
        valueToPush["calculateCostImpact"] = automation1[x].calculateCostImpact;
        if (valueToPush["calculateCostImpact"] == true) {
            valueToPush["actualCost"] = totalActualCost;
            valueToPush["forecastCost"] = 0;
        } else {
            valueToPush["actualCost"] = null;
            valueToPush["forecastCost"] = null;
        }
        valueToPush["impactDuration"] = totalImpactDuration;
        valueToPush["ruleID"] = ruleID;
        valueToPush["key"] = key;
        valueToPush["mode"] = automation1[x].mode;
        valueToPush["type"] = automation1[x].type;
        valueToPush["events"] = events;
        valueToPush["tasks"] = tasks;
        valueToPush["category"] = "automation";
        valueToPush["durationOperator"] = automation1[x].durationOperator;
        valueToPush["durationActualFrom"] = automation1[x].durationActualFrom;
        valueToPush["durationActualTo"] = automation1[x].durationActualTo;
        valueToPush["durationValue"] = automation1[x].durationValue;
        $57e66c5a34f265b4$var$gAutomationRules.push(valueToPush);
    }
    if (mode === "delete" && automation1[x].mode === "edit") return;
    if (source != "file_import" && source != "model_import") $57e66c5a34f265b4$export$59798dda46c3d2b5(applyFilter, false, "process automation");
    else if (applyFilter == true) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("processAutomation");
    if (source != "model_import") {
        $57e66c5a34f265b4$var$updateForecastCost();
        $57e66c5a34f265b4$var$updateCostMetrics("processAutomation");
        $57e66c5a34f265b4$var$updateAutomationMetrics();
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$var$updateAttributes();
        if ($57e66c5a34f265b4$var$gEventEmitter) (0, $99061afdb4accbec$export$77472d31d2b1bbaf)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
        });
        $57e66c5a34f265b4$export$2ff5de46d769d306("processAutomation");
    }
}
function $57e66c5a34f265b4$var$updateAutomationMetrics() {
    let startNode = 0;
    let endNode = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].start_node == true) startNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
        if ($57e66c5a34f265b4$var$gActivityArray[j].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
    }
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskArray.length; i++)$57e66c5a34f265b4$var$gTaskArray[i].automated = false;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        $57e66c5a34f265b4$var$gVariantArray[i1].automated = false;
        $57e66c5a34f265b4$var$gVariantArray[i1].automated_tasks = 0;
        $57e66c5a34f265b4$var$gVariantArray[i1].automated_events = 0;
    }
    let variant = "";
    let variantAutomatedTasks = 0;
    let variantAutomatedEvents = 0;
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    // update variant automation
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    let i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if (i2 > 0 && variant != $57e66c5a34f265b4$var$gEventLogArray[i2].v) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated_events = variantAutomatedEvents;
            if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated_events == $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].e) {
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated = true;
                $57e66c5a34f265b4$var$gAutomatedVariants++;
            }
            variantAutomatedEvents = 0;
        }
        variant = $57e66c5a34f265b4$var$gEventLogArray[i2].v;
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true && $57e66c5a34f265b4$var$gEventLogArray[i2].f != startNode && $57e66c5a34f265b4$var$gEventLogArray[i2].t != endNode) {
            variantAutomatedEvents++;
            $57e66c5a34f265b4$var$gAutomatedEvents++;
        }
    }
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated_events = variantAutomatedEvents;
    if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated_events == $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].e) {
        $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].vid].automated = true;
        $57e66c5a34f265b4$var$gAutomatedVariants++;
    }
    // update task automation
    let task = "";
    let taskAutomated = true;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if (i2 > 0 && task != $57e66c5a34f265b4$var$gEventLogArray[i2].k) {
            if (taskAutomated == true) {
                $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2 - 1].tid].automated = true;
                $57e66c5a34f265b4$var$gAutomatedTasks++;
            }
            taskAutomated = true;
        }
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == false && $57e66c5a34f265b4$var$gEventLogArray[i2].t != endNode) taskAutomated = false;
        task = $57e66c5a34f265b4$var$gEventLogArray[i2].k;
    }
    if (taskAutomated == true) {
        if ($57e66c5a34f265b4$var$gEventLogArray[i2 - 1].t != endNode) {
            $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].tid].automated = true;
            $57e66c5a34f265b4$var$gAutomatedTasks++;
        }
    }
    // update variant with tasks automated
    task = "";
    variantAutomatedTasks = 0;
    variant = "";
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.v - b.v || a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gTaskArray.length; i2++){
        if (i2 > 0 && variant != $57e66c5a34f265b4$var$gTaskArray[i2].v) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].automated_tasks = variantAutomatedTasks;
            variantAutomatedTasks = 0;
        }
        variant = $57e66c5a34f265b4$var$gTaskArray[i2].v;
        if ($57e66c5a34f265b4$var$gTaskArray[i2].automated == true) variantAutomatedTasks++;
    }
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i2 - 1].vid].automated_tasks = variantAutomatedTasks;
}
function $57e66c5a34f265b4$export$daa57dff65460f7c() {
    gNonCompliantArray = [];
    $57e66c5a34f265b4$var$updateAttributes();
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8b3a953f334c1c39$export$88d9d129a5d66a46)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
    $57e66c5a34f265b4$export$2ff5de46d769d306("resetCompliance");
}
function $57e66c5a34f265b4$export$fd2a260f23757750() {
    $57e66c5a34f265b4$var$gDiagramPV.startTransaction("rebuildPVDiagram");
    $57e66c5a34f265b4$var$gDiagramPV.nodes.each(function(node) {
        if (node.visible && !node.findLinksConnected().any(function(l) {
            return l.isVisible();
        })) node.visible = false;
    });
    $57e66c5a34f265b4$var$layout();
    $57e66c5a34f265b4$var$gDiagramPV.commitTransaction("rebuildPVDiagram");
    $57e66c5a34f265b4$var$gDiagramPV.requestUpdate();
    $57e66c5a34f265b4$var$gDiagramPV.layout.layerSpacing = $57e66c5a34f265b4$var$gSpacingLayer;
    $57e66c5a34f265b4$var$gDiagramPV.layout.columnSpacing = $57e66c5a34f265b4$var$gSpacingColumn;
    $57e66c5a34f265b4$var$gDiagramPV.zoomToFit();
}
function $57e66c5a34f265b4$export$2ff5de46d769d306(source) {
    $57e66c5a34f265b4$var$gDiagramPV.startTransaction("rebuildPVDiagram");
    $57e66c5a34f265b4$var$gDiagramPV.model.linkDataArray = $57e66c5a34f265b4$var$generateLinks("variants");
    $57e66c5a34f265b4$var$gDiagramPV.model.nodeDataArray = $57e66c5a34f265b4$var$generateNodes("variants");
    $57e66c5a34f265b4$var$gDiagramPV.nodes.each(function(node) {
        if (node.visible && !node.findLinksConnected().any(function(l) {
            return l.isVisible();
        })) node.visible = false;
    });
    $57e66c5a34f265b4$var$layout();
    if ($57e66c5a34f265b4$var$gAnimateVariant != 0 && $57e66c5a34f265b4$var$activePane === (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab) $57e66c5a34f265b4$var$animateVariant();
    (0, $3a3e0c61bb1fdb8e$export$40092911b12b82d6)($57e66c5a34f265b4$var$gDiagramPV);
    if ($57e66c5a34f265b4$var$gLifecycleVariant != 0 && $57e66c5a34f265b4$var$activePane === (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab) (0, $3a3e0c61bb1fdb8e$export$35046beef9a65b5f)($57e66c5a34f265b4$var$generateLifeCycleArray(), $57e66c5a34f265b4$var$gDiagramPV, $57e66c5a34f265b4$var$gAnimateColor);
    $57e66c5a34f265b4$var$gDiagramPV.commitTransaction("rebuildPVDiagram");
    $57e66c5a34f265b4$var$gDiagramPV.requestUpdate();
    $57e66c5a34f265b4$var$gDiagramPV.layout.layerSpacing = $57e66c5a34f265b4$var$gSpacingLayer;
    $57e66c5a34f265b4$var$gDiagramPV.layout.columnSpacing = $57e66c5a34f265b4$var$gSpacingColumn;
    if ($57e66c5a34f265b4$var$gRebuildCtr >= 1) $57e66c5a34f265b4$var$gInitialLoad = false;
    if ($57e66c5a34f265b4$var$gRebuildCtr <= 1) $57e66c5a34f265b4$var$gDiagramPV.zoomToFit();
    else if ($57e66c5a34f265b4$var$gZoomToFit === true) $57e66c5a34f265b4$var$gDiagramPV.zoomToFit();
    $57e66c5a34f265b4$var$gRebuildCtr++;
}
function $57e66c5a34f265b4$export$35652a5bbda27ca0() {
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.startTransaction("rebuildDecompositionTreeDiagram");
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.nodeDataArray = [];
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.model.linkDataArray = [];
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.commitTransaction("rebuildDecompositionTreeDiagram");
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.requestUpdate();
}
const $57e66c5a34f265b4$export$31b8020222843e64 = ()=>{
    if ($57e66c5a34f265b4$var$gZoomSlider) $57e66c5a34f265b4$var$gZoomSlider.remove();
    $57e66c5a34f265b4$var$gZoomSlider = new (0, $06fecfcf76190321$export$c7a86018194a5999)($57e66c5a34f265b4$var$gDiagramPV, {
        alignment: $lR8r2$gojs.Spot.BottomLeft,
        alignmentFocus: $lR8r2$gojs.Spot.BottomLeft,
        size: 150,
        buttonSize: 25,
        orientation: "horizontal"
    });
};
function $57e66c5a34f265b4$var$animateVariant() {
    // Animate the flow in the pipes
    let animation = new $lR8r2$gojs.Animation();
    animation.easing = $lR8r2$gojs.Animation.EaseLinear;
    $57e66c5a34f265b4$var$gDiagramPV.links.each(function(link) {
        if (link.data.animate == true) animation.add(link.path, "strokeDashOffset", 15, 1);
    });
    // Run indefinitely
    animation.runCount = Infinity;
    animation.start();
}
const $57e66c5a34f265b4$export$fbbbb5ea899679e = ({ activityTextColor: activityTextColor , activityFillColor: activityFillColor , linkColor: linkColor , selectActivityColor: selectActivityColor , selectLinkColor: selectLinkColor , animateColor: animateColor , loopColor: loopColor , nonCompliantColor: nonCompliantColor , partialNonCompliantColor: partialNonCompliantColor , automationColor: automationColor , partialAutomationColor: partialAutomationColor , visualizerBackgroundColor: visualizerBackgroundColor , startNodeColor: startNodeColor , endNodeColor: endNodeColor ,  })=>{
    $57e66c5a34f265b4$var$gColorActivityText = activityTextColor || $57e66c5a34f265b4$var$gColorActivityText;
    $57e66c5a34f265b4$var$gColorStartNode = startNodeColor || $57e66c5a34f265b4$var$gColorStartNode;
    $57e66c5a34f265b4$var$gColorEndNode = endNodeColor || $57e66c5a34f265b4$var$gColorEndNode;
    $57e66c5a34f265b4$var$gColorActivityFill = activityFillColor || $57e66c5a34f265b4$var$gColorActivityFill;
    $57e66c5a34f265b4$var$gColorLink = linkColor || $57e66c5a34f265b4$var$gColorLink;
    $57e66c5a34f265b4$var$gColorActivitySelect = selectActivityColor || $57e66c5a34f265b4$var$gColorActivitySelect;
    $57e66c5a34f265b4$var$gColorLinkSelect = selectLinkColor || $57e66c5a34f265b4$var$gColorLinkSelect;
    $57e66c5a34f265b4$var$gAnimateColor = animateColor || $57e66c5a34f265b4$var$gAnimateColor;
    $57e66c5a34f265b4$var$gLoopColor = loopColor || $57e66c5a34f265b4$var$gLoopColor;
    $57e66c5a34f265b4$var$gNonCompliantColor = nonCompliantColor || $57e66c5a34f265b4$var$gNonCompliantColor;
    $57e66c5a34f265b4$var$gPartialNonCompliantColor = partialNonCompliantColor || $57e66c5a34f265b4$var$gPartialNonCompliantColor;
    $57e66c5a34f265b4$var$gAutomationColor = automationColor || $57e66c5a34f265b4$var$gAutomationColor;
    $57e66c5a34f265b4$var$gPartialAutomationColor = partialAutomationColor || $57e66c5a34f265b4$var$gPartialAutomationColor;
    $57e66c5a34f265b4$var$gVisualizerBackgroundColor = visualizerBackgroundColor || $57e66c5a34f265b4$var$gVisualizerBackgroundColor;
};
const $57e66c5a34f265b4$export$ac6d06e7706e3b10 = ()=>{
    $57e66c5a34f265b4$export$c7aee54378586699();
    return {
        min_time: $57e66c5a34f265b4$var$gFromTime,
        max_time: $57e66c5a34f265b4$var$gToTime
    };
};
const $57e66c5a34f265b4$export$8b362cc2cfd64eb3 = ()=>{
    $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
    $57e66c5a34f265b4$var$gMinVariantTasks = -1;
    $57e66c5a34f265b4$var$gMaxVariantTasks = -1;
    $57e66c5a34f265b4$var$gTaskActivitiesFrom = -1;
    $57e66c5a34f265b4$var$gTaskActivitiesTo = -1;
    $57e66c5a34f265b4$var$gTaskDurationFrom = 1;
    $57e66c5a34f265b4$var$gTaskDurationTo = -1;
    let lmaxVariantTasks = $57e66c5a34f265b4$export$cf491150aa61915d("NumTasksVariant");
    let taskActivitiesTo = $57e66c5a34f265b4$export$cf491150aa61915d("NumActivitesTask");
    let taskDurationTo = $57e66c5a34f265b4$export$cf491150aa61915d("TaskDuration");
    return {
        minVariantTasks: 1,
        maxVariantTasks: lmaxVariantTasks,
        taskActivitiesFrom: 1,
        taskActivitiesTo: taskActivitiesTo,
        taskDurationFrom: 0,
        taskDurationTo: taskDurationTo
    };
};
const $57e66c5a34f265b4$export$8da0d8f55c4b51d0 = (source)=>{
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++)$57e66c5a34f265b4$var$gVariantArray[i].filtered = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++)$57e66c5a34f265b4$var$gEventLogArray[i1].filtered = 0;
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gTaskArray.length; i2++)$57e66c5a34f265b4$var$gTaskArray[i2].filtered = 0;
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gLinkArray.length; i3++)$57e66c5a34f265b4$var$gLinkArray[i3].filtered = 0;
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gActivityArray.length; i4++)$57e66c5a34f265b4$var$gActivityArray[i4].filtered = 0;
    $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
    $57e66c5a34f265b4$var$gAttribute = "";
    $57e66c5a34f265b4$var$gAttributeType = "";
    $57e66c5a34f265b4$var$gEventsFiltered = $57e66c5a34f265b4$var$gEventsAll;
    $57e66c5a34f265b4$var$gTasksFiltered = $57e66c5a34f265b4$var$gTasksAll;
    $57e66c5a34f265b4$var$gVariantsFiltered = $57e66c5a34f265b4$var$gVariantsAll;
    $57e66c5a34f265b4$var$gStepsFiltered = $57e66c5a34f265b4$var$gStepsAll;
    $57e66c5a34f265b4$var$gActivitiesFiltered = $57e66c5a34f265b4$var$gActivitiesAll;
    $57e66c5a34f265b4$var$gFilters = [];
    $57e66c5a34f265b4$var$gFilterSets = 0;
    $57e66c5a34f265b4$var$gTaskFilterAttributes = [];
    $57e66c5a34f265b4$var$gTaskFilterMetrics = [];
    $57e66c5a34f265b4$var$gTaskFilterTime = [];
    $57e66c5a34f265b4$var$gTaskFilterTasks = [];
    $57e66c5a34f265b4$var$gFilterConditions = [];
    $57e66c5a34f265b4$var$gVariantPaneVariants = [];
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "resetFilters");
    $57e66c5a34f265b4$export$75fdae28716ade6d();
};
const $57e66c5a34f265b4$export$a3af08e85d4cf2c6 = ()=>{
    $57e66c5a34f265b4$export$c7aee54378586699();
    return [
        $57e66c5a34f265b4$var$gFromTime,
        $57e66c5a34f265b4$var$gToTime
    ];
};
const $57e66c5a34f265b4$export$1417083d8f7520f9 = (type, min, max)=>{
    if (type == "NumTasksVariant") {
        $57e66c5a34f265b4$var$gMinVariantTasks = min;
        $57e66c5a34f265b4$var$gMaxVariantTasks = max;
        $57e66c5a34f265b4$var$gTasksFilterActive_NTV = true;
    }
    if (type == "NumActivitesTask") {
        $57e66c5a34f265b4$var$gTaskActivitiesFrom = min;
        $57e66c5a34f265b4$var$gTaskActivitiesTo = max;
        $57e66c5a34f265b4$var$gTasksFilterActive_NAT = true;
    }
    if (type == "TaskDuration") {
        $57e66c5a34f265b4$var$gTaskDurationFrom = min;
        $57e66c5a34f265b4$var$gTaskDurationTo = max;
        $57e66c5a34f265b4$var$gTasksFilterActive_TD = true;
    }
};
const $57e66c5a34f265b4$export$4e88a88b150e6235 = (selectedAttributes)=>{
    $57e66c5a34f265b4$var$gSelectedAttributes = selectedAttributes;
};
function $57e66c5a34f265b4$var$filterConditions(type) {
    let valueArrayPush = {};
    let valueToPush = {};
    if (type == "activity") {
        valueToPush = {};
        let activityStr = "";
        let valueArray = [];
        for(let i = 0; i < $57e66c5a34f265b4$var$gFilterSelectedActivities.length; i++){
            valueArrayPush = {};
            valueArrayPush["value"] = $57e66c5a34f265b4$var$gFilterSelectedActivities[i].activity;
            valueArray.push(valueArrayPush);
            activityStr = activityStr + $57e66c5a34f265b4$var$gFilterSelectedActivities[i].activity_name + ", ";
        }
        valueToPush["values"] = valueArray;
        $57e66c5a34f265b4$var$gTaskFilterActivities.push(valueToPush);
        valueToPush = {};
        valueToPush["type"] = "activity";
        valueToPush["description"] = "Activities: " + activityStr;
        valueToPush["selected_activities"] = $57e66c5a34f265b4$var$gFilterSelectedActivities;
        valueToPush["task_filter_attributes"] = $57e66c5a34f265b4$var$gTaskFilterActivities;
        $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
    }
    if (type == "attributes") {
        valueToPush = {};
        valueToPush["attribute"] = $57e66c5a34f265b4$var$gAttribute;
        valueToPush["attributeType"] = $57e66c5a34f265b4$var$gAttributeType;
        let valueArray1 = [];
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gSelectedAttributes.length; i1++){
            valueArrayPush = {};
            valueArrayPush["value"] = $57e66c5a34f265b4$var$gSelectedAttributes[i1].value;
            valueArray1.push(valueArrayPush);
        }
        valueToPush["values"] = valueArray1;
        $57e66c5a34f265b4$var$gTaskFilterAttributes.push(valueToPush);
        let attributeStr = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gTaskFilterAttributes[$57e66c5a34f265b4$var$gTaskFilterAttributes.length - 1].values.length; j++){
            if (j > 0) attributeStr = attributeStr + ", ";
            attributeStr = attributeStr + $57e66c5a34f265b4$var$gTaskFilterAttributes[$57e66c5a34f265b4$var$gTaskFilterAttributes.length - 1].values[j].value;
        }
        valueToPush = {};
        valueToPush["type"] = "attributes";
        valueToPush["description"] = $57e66c5a34f265b4$var$gTaskFilterAttributes[$57e66c5a34f265b4$var$gTaskFilterAttributes.length - 1].attributeType + " - " + $57e66c5a34f265b4$var$gTaskFilterAttributes[$57e66c5a34f265b4$var$gTaskFilterAttributes.length - 1].attribute + ": " + attributeStr;
        valueToPush["attribute"] = $57e66c5a34f265b4$var$gAttribute;
        valueToPush["attribute_type"] = $57e66c5a34f265b4$var$gAttributeType;
        valueToPush["selected_attributes"] = $57e66c5a34f265b4$var$gSelectedAttributes;
        valueToPush["task_filter_attributes"] = $57e66c5a34f265b4$var$gTaskFilterAttributes;
        $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
    }
    if (type == "metrics") {
        let metricType;
        for (const each of $57e66c5a34f265b4$var$gMetricArray)if (each.m === $57e66c5a34f265b4$var$gMetricFilter.metric) metricType = each.t;
        valueToPush = {};
        valueToPush["metric"] = $57e66c5a34f265b4$var$gMetricFilter.metric;
        valueToPush["metric_type"] = metricType;
        valueToPush["operator"] = $57e66c5a34f265b4$var$gMetricFilter.operator;
        valueToPush["checkbox_value"] = $57e66c5a34f265b4$var$gMetricFilter.checkboxValue;
        valueToPush["number_value"] = $57e66c5a34f265b4$var$gMetricFilter.numberValue;
        valueToPush["time_unit"] = $57e66c5a34f265b4$var$gMetricFilter.timeUnit;
        $57e66c5a34f265b4$var$gTaskFilterMetrics.push(valueToPush);
        // amount, true_false, duration
        let metricStr = "";
        metricStr = $57e66c5a34f265b4$var$gMetricFilter.metric + " " + $57e66c5a34f265b4$var$gMetricFilter.operator;
        if (metricType == "true_false") metricStr = metricStr + " " + $57e66c5a34f265b4$var$gMetricFilter.checkboxValue;
        if (metricType == "amount") metricStr = metricStr + " " + $57e66c5a34f265b4$var$gMetricFilter.numberValue;
        if (metricType == "duration") metricStr = metricStr + " " + $57e66c5a34f265b4$var$gMetricFilter.numberValue + " " + $57e66c5a34f265b4$var$gMetricFilter.timeUnit;
        valueToPush = {};
        valueToPush["type"] = "metric";
        valueToPush["description"] = metricStr;
        valueToPush["metric_filter"] = $57e66c5a34f265b4$var$gMetricFilter;
        valueToPush["metric_array"] = $57e66c5a34f265b4$var$gMetricArray;
        $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
    }
    if (type == "tasks") {
        if ($57e66c5a34f265b4$var$gTasksFilterActive_NTV == true) {
            valueToPush = {};
            valueToPush["type"] = "task_variants";
            valueToPush["description"] = "# of " + $57e66c5a34f265b4$var$gEntityLower + "s in a variant between " + $57e66c5a34f265b4$var$gMinVariantTasks + " and " + $57e66c5a34f265b4$var$gMaxVariantTasks;
            valueToPush["min_variants"] = $57e66c5a34f265b4$var$gMinVariantTasks;
            valueToPush["max_variants"] = $57e66c5a34f265b4$var$gMaxVariantTasks;
            $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
            valueToPush = {};
            valueToPush["type"] = "task_variants";
            valueToPush["min"] = $57e66c5a34f265b4$var$gMinVariantTasks;
            valueToPush["max"] = $57e66c5a34f265b4$var$gMaxVariantTasks;
            $57e66c5a34f265b4$var$gTaskFilterTasks.push(valueToPush);
        }
        if ($57e66c5a34f265b4$var$gTasksFilterActive_NAT == true) {
            valueToPush = {};
            valueToPush["type"] = "task_activities";
            valueToPush["description"] = "# activities in a " + $57e66c5a34f265b4$var$gEntityLower + " between " + $57e66c5a34f265b4$var$gTaskActivitiesFrom + " and " + $57e66c5a34f265b4$var$gTaskActivitiesTo;
            valueToPush["activities_from"] = $57e66c5a34f265b4$var$gTaskActivitiesFrom;
            valueToPush["activities_to"] = $57e66c5a34f265b4$var$gTaskActivitiesTo;
            $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
            valueToPush = {};
            valueToPush["type"] = "task_activities";
            valueToPush["from"] = $57e66c5a34f265b4$var$gTaskActivitiesFrom;
            valueToPush["to"] = $57e66c5a34f265b4$var$gTaskActivitiesTo;
            $57e66c5a34f265b4$var$gTaskFilterTasks.push(valueToPush);
        }
        if ($57e66c5a34f265b4$var$gTasksFilterActive_TD == true) {
            valueToPush = {};
            valueToPush["type"] = "task_duration";
            valueToPush["description"] = "Duration of a " + $57e66c5a34f265b4$var$gEntityLower + " between " + $57e66c5a34f265b4$var$gTaskDurationFrom + " (mins) and " + $57e66c5a34f265b4$var$gTaskDurationTo + " (mins)";
            valueToPush["duration_from"] = $57e66c5a34f265b4$var$gTaskDurationFrom;
            valueToPush["duration_to"] = $57e66c5a34f265b4$var$gTaskDurationTo;
            $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
            valueToPush = {};
            valueToPush["type"] = "task_variants";
            valueToPush["from"] = $57e66c5a34f265b4$var$gTaskDurationFrom;
            valueToPush["to"] = $57e66c5a34f265b4$var$gTaskDurationTo;
            $57e66c5a34f265b4$var$gTaskFilterTasks.push(valueToPush);
        }
    }
    if (type == "time") {
        valueToPush = {};
        valueToPush["type"] = "time";
        $57e66c5a34f265b4$var$gFromTime = new Date($57e66c5a34f265b4$var$gFromTime);
        $57e66c5a34f265b4$var$gToTime = new Date($57e66c5a34f265b4$var$gToTime);
        valueToPush["description"] = $57e66c5a34f265b4$var$gEntityUpper + " create time between " + $57e66c5a34f265b4$var$formatDate($57e66c5a34f265b4$var$gFromTime) + " and " + $57e66c5a34f265b4$var$formatDate($57e66c5a34f265b4$var$gToTime);
        valueToPush["from_time"] = $57e66c5a34f265b4$var$gFromTime;
        valueToPush["to_time"] = $57e66c5a34f265b4$var$gToTime;
        $57e66c5a34f265b4$var$gFilterConditions.push(valueToPush);
        valueToPush = {};
        valueToPush["type"] = "time";
        valueToPush["from"] = $57e66c5a34f265b4$var$gFromTime;
        valueToPush["to"] = $57e66c5a34f265b4$var$gToTime;
        $57e66c5a34f265b4$var$gTaskFilterTime.push(valueToPush);
    }
}
function $57e66c5a34f265b4$var$formatDate(date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (day < 10) day = "0" + day;
    if (month < 10) month = "0" + month;
    let formattedDate = day + "-" + month + "-" + year;
    return formattedDate;
}
const $57e66c5a34f265b4$export$318ec447bc49311f = (importedSlicers)=>{
    $57e66c5a34f265b4$export$75fdae28716ade6d();
    let tempSlicers = JSON.parse(importedSlicers);
    for(let i = 0; i < tempSlicers.length; i++){
        if (tempSlicers[i].type === "Steps") {
            $57e66c5a34f265b4$var$gStepSelectOperator = tempSlicers[i].operator;
            $57e66c5a34f265b4$var$gStepSelectRetention = tempSlicers[i].retention;
            $57e66c5a34f265b4$var$gSlicerSelectedSteps = tempSlicers[i].steps;
            $57e66c5a34f265b4$var$gStepPaneVariants = tempSlicers[i].variants;
            $57e66c5a34f265b4$export$eaaa0335bea12670("Steps");
            $57e66c5a34f265b4$export$dd3986409eddbcdc("Steps");
        }
        if (tempSlicers[i].type === "Activities") {
            $57e66c5a34f265b4$var$gActivitySelectOperator = tempSlicers[i].operator;
            $57e66c5a34f265b4$var$gActivitySelectRetention = tempSlicers[i].retention;
            $57e66c5a34f265b4$var$gSlicerSelectedActivities = tempSlicers[i].activities;
            $57e66c5a34f265b4$var$gActivityPaneVariants = tempSlicers[i].variants;
            $57e66c5a34f265b4$export$eaaa0335bea12670("Activities");
            $57e66c5a34f265b4$export$dd3986409eddbcdc("Activities");
        }
        if (tempSlicers[i].type === "Path") {
            $57e66c5a34f265b4$var$gPathSelectRetention = tempSlicers[i].retention;
            $57e66c5a34f265b4$var$gPathAttribute = tempSlicers[i].predicate;
            $57e66c5a34f265b4$var$gPathFrom = tempSlicers[i].path_from;
            $57e66c5a34f265b4$var$gPathTo = tempSlicers[i].path_to;
            $57e66c5a34f265b4$var$gPathPaneVariants = tempSlicers[i].variants;
            $57e66c5a34f265b4$export$eaaa0335bea12670("Path");
            $57e66c5a34f265b4$export$dd3986409eddbcdc("Path");
        }
        if (tempSlicers[i].type === "Tasks") {
            $57e66c5a34f265b4$var$gSlicerSelectedTasks = tempSlicers[i].tasks;
            $57e66c5a34f265b4$var$gTaskPaneVariants = tempSlicers[i].variants;
            $57e66c5a34f265b4$export$eaaa0335bea12670("Tasks");
            $57e66c5a34f265b4$export$dd3986409eddbcdc("Tasks");
        }
    }
};
const $57e66c5a34f265b4$export$4283b00eae4a6956 = (importedFilters)=>{
    $57e66c5a34f265b4$export$8da0d8f55c4b51d0("importFilters");
    let tempFilter = JSON.parse(importedFilters);
    for(let i = 0; i < tempFilter.length; i++){
        if (tempFilter[i].type == "attributes") {
            $57e66c5a34f265b4$var$gAttribute = tempFilter[i].attribute;
            $57e66c5a34f265b4$var$gAttributeType = tempFilter[i].attribute_type;
            $57e66c5a34f265b4$var$gSelectedAttributes = tempFilter[i].selected_attributes;
            $57e66c5a34f265b4$var$gTaskFilterAttributes = tempFilter[i].task_filter_attributes;
            $57e66c5a34f265b4$export$3067f357aa66b5c2($57e66c5a34f265b4$var$gAttribute, $57e66c5a34f265b4$var$gAttributeType);
        }
        if (tempFilter[i].type == "metric") {
            $57e66c5a34f265b4$var$gMetricFilter = tempFilter[i].metric_filter;
            $57e66c5a34f265b4$var$gMetricArray = tempFilter[i].metric_array;
            $57e66c5a34f265b4$export$1968c4d10f8059c8(tempFilter[i].metric_filter);
        }
        if (tempFilter[i].type == "time") {
            $57e66c5a34f265b4$var$gFromTime = tempFilter[i].from_time;
            $57e66c5a34f265b4$var$gToTime = tempFilter[i].to_time;
            $57e66c5a34f265b4$export$d7af1f47ccac45e4($57e66c5a34f265b4$var$gFromTime, $57e66c5a34f265b4$var$gToTime);
        }
        if (tempFilter[i].type == "task_variants") {
            $57e66c5a34f265b4$var$gMinVariantTasks = tempFilter[i].min_variants;
            $57e66c5a34f265b4$var$gMaxVariantTasks = tempFilter[i].max_variants;
            $57e66c5a34f265b4$var$gTasksFilterActive_NTV = true;
            $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
            $57e66c5a34f265b4$export$e5dbdcbe8d57d390();
        }
        if (tempFilter[i].type == "task_activities") {
            $57e66c5a34f265b4$var$gTaskActivitiesFrom = tempFilter[i].activities_from;
            $57e66c5a34f265b4$var$gTaskActivitiesTo = tempFilter[i].activities_to;
            $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_NAT = true;
            $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
            $57e66c5a34f265b4$export$e5dbdcbe8d57d390();
        }
        if (tempFilter[i].type == "task_duration") {
            $57e66c5a34f265b4$var$gTaskDurationFrom = tempFilter[i].duration_from;
            $57e66c5a34f265b4$var$gTaskDurationTo = tempFilter[i].duration_to;
            $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
            $57e66c5a34f265b4$var$gTasksFilterActive_TD = true;
            $57e66c5a34f265b4$export$e5dbdcbe8d57d390();
        }
    }
};
const $57e66c5a34f265b4$export$e5dbdcbe8d57d390 = ()=>{
    // need to update parameters
    if ($57e66c5a34f265b4$var$gTasksFilterActive_NTV == true) $57e66c5a34f265b4$var$filterTasks_NTV();
    if ($57e66c5a34f265b4$var$gTasksFilterActive_NAT == true) $57e66c5a34f265b4$var$filterTasks_NAT();
    if ($57e66c5a34f265b4$var$gTasksFilterActive_TD == true) $57e66c5a34f265b4$var$filterTasks_TD();
    $57e66c5a34f265b4$var$filterConditions("tasks");
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "apply tasks filter");
    $57e66c5a34f265b4$export$6e4c85e15f853f95();
};
const $57e66c5a34f265b4$export$3067f357aa66b5c2 = (attribute, attributeType)=>{
    $57e66c5a34f265b4$var$gAttribute = attribute;
    $57e66c5a34f265b4$var$gAttributeType = attributeType;
    if ($57e66c5a34f265b4$var$gAttributeType == "Task") $57e66c5a34f265b4$var$filterAttributesTasks();
    if ($57e66c5a34f265b4$var$gAttributeType == "Event") $57e66c5a34f265b4$var$filterAttributesEvents();
    $57e66c5a34f265b4$var$filterConditions("attributes");
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "applyAttributesFilter");
    $57e66c5a34f265b4$export$6e4c85e15f853f95();
};
const $57e66c5a34f265b4$export$1968c4d10f8059c8 = (metricFilter)=>{
    $57e66c5a34f265b4$var$gMetricFilter = metricFilter;
    $57e66c5a34f265b4$var$filterConditions("metrics");
    $57e66c5a34f265b4$var$filterMetrics();
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "applyMetricFilter");
    $57e66c5a34f265b4$export$6e4c85e15f853f95();
};
const $57e66c5a34f265b4$export$d7af1f47ccac45e4 = (fromTime, toTime)=>{
    $57e66c5a34f265b4$var$gFromTime = fromTime;
    $57e66c5a34f265b4$var$gToTime = toTime;
    $57e66c5a34f265b4$var$filterConditions("time");
    $57e66c5a34f265b4$var$filterTime();
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "applyTimeFilter");
    $57e66c5a34f265b4$export$6e4c85e15f853f95();
};
const $57e66c5a34f265b4$export$a4d0cd2e1e326d4a = ()=>({
        activityTextColor: $57e66c5a34f265b4$var$gColorActivityText,
        activityFillColor: $57e66c5a34f265b4$var$gColorActivityFill,
        linkColor: $57e66c5a34f265b4$var$gColorLink,
        startNodeColor: $57e66c5a34f265b4$var$gColorStartNode,
        endNodeColor: $57e66c5a34f265b4$var$gColorEndNode,
        selectActivityColor: $57e66c5a34f265b4$var$gColorActivitySelect,
        selectLinkColor: $57e66c5a34f265b4$var$gColorLinkSelect,
        animateColor: $57e66c5a34f265b4$var$gAnimateColor,
        loopColor: $57e66c5a34f265b4$var$gLoopColor,
        nonCompliantColor: $57e66c5a34f265b4$var$gNonCompliantColor,
        partialNonCompliantColor: $57e66c5a34f265b4$var$gPartialNonCompliantColor,
        automationColor: $57e66c5a34f265b4$var$gAutomationColor,
        partialAutomationColor: $57e66c5a34f265b4$var$gPartialAutomationColor,
        visualizerBackgroundColor: $57e66c5a34f265b4$var$gVisualizerBackgroundColor
    });
const $57e66c5a34f265b4$export$fe9b305965c7267e = ({ days: days , hours: hours , minutes: minutes , seconds: seconds  })=>{
    $57e66c5a34f265b4$var$gShowDurationDays = days ?? $57e66c5a34f265b4$var$gShowDurationDays;
    $57e66c5a34f265b4$var$gShowDurationHours = hours ?? $57e66c5a34f265b4$var$gShowDurationHours;
    $57e66c5a34f265b4$var$gShowDurationMinutes = minutes ?? $57e66c5a34f265b4$var$gShowDurationMinutes;
    $57e66c5a34f265b4$var$gShowDurationSeconds = seconds ?? $57e66c5a34f265b4$var$gShowDurationSeconds;
};
const $57e66c5a34f265b4$export$5dda410f8d16b60 = ()=>({
        days: $57e66c5a34f265b4$var$gShowDurationDays,
        hours: $57e66c5a34f265b4$var$gShowDurationHours,
        minutes: $57e66c5a34f265b4$var$gShowDurationMinutes,
        seconds: $57e66c5a34f265b4$var$gShowDurationSeconds
    });
const $57e66c5a34f265b4$export$4d02125160691cb6 = ({ tasks: tasks , avg_duration: avg_duration , med_duration: med_duration , min_duration: min_duration , max_duration: max_duration , avg_cost: avg_cost , total: total , deviation: deviation , compliant: compliant , automated: automated ,  })=>{
    $57e66c5a34f265b4$var$gShowLinkTasks = tasks ?? $57e66c5a34f265b4$var$gShowLinkTasks;
    $57e66c5a34f265b4$var$gShowLinkAvgDuration = avg_duration ?? $57e66c5a34f265b4$var$gShowLinkAvgDuration;
    $57e66c5a34f265b4$var$gShowLinkMedDuration = med_duration ?? $57e66c5a34f265b4$var$gShowLinkMedDuration;
    $57e66c5a34f265b4$var$gShowLinkMinDuration = min_duration ?? $57e66c5a34f265b4$var$gShowLinkMinDuration;
    $57e66c5a34f265b4$var$gShowLinkMaxDuration = max_duration ?? $57e66c5a34f265b4$var$gShowLinkMaxDuration;
    $57e66c5a34f265b4$var$gShowLinkAvgCost = avg_cost ?? $57e66c5a34f265b4$var$gShowLinkAvgCost;
    $57e66c5a34f265b4$var$gShowLinkPercTotal = total ?? $57e66c5a34f265b4$var$gShowLinkPercTotal;
    $57e66c5a34f265b4$var$gShowLinkDeviation = deviation ?? $57e66c5a34f265b4$var$gShowLinkDeviation;
    $57e66c5a34f265b4$var$gShowLinkPercCompliant = compliant ?? $57e66c5a34f265b4$var$gShowLinkPercCompliant;
    $57e66c5a34f265b4$var$gShowLinkPercAutomated = automated ?? $57e66c5a34f265b4$var$gShowLinkPercAutomated;
};
const $57e66c5a34f265b4$export$1bfd0b0186011b14 = ()=>({
        tasks: $57e66c5a34f265b4$var$gShowLinkTasks,
        avg_duration: $57e66c5a34f265b4$var$gShowLinkAvgDuration,
        med_duration: $57e66c5a34f265b4$var$gShowLinkMedDuration,
        min_duration: $57e66c5a34f265b4$var$gShowLinkMinDuration,
        max_duration: $57e66c5a34f265b4$var$gShowLinkMaxDuration,
        avg_cost: $57e66c5a34f265b4$var$gShowLinkAvgCost,
        total: $57e66c5a34f265b4$var$gShowLinkPercTotal,
        deviation: $57e66c5a34f265b4$var$gShowLinkDeviation,
        compliant: $57e66c5a34f265b4$var$gShowLinkPercCompliant,
        automated: $57e66c5a34f265b4$var$gShowLinkPercAutomated
    });
const $57e66c5a34f265b4$export$bc15c77749bbb18f = ({ duration: duration  })=>{
    $57e66c5a34f265b4$var$gDurationLabel = duration ?? $57e66c5a34f265b4$var$gDurationLabel;
};
const $57e66c5a34f265b4$export$bdef90392239c746 = ()=>({
        duration: $57e66c5a34f265b4$var$gDurationLabel
    });
const $57e66c5a34f265b4$export$4ead7e3c9375adc6 = ({ tasks: tasks , perc_total: perc_total  })=>{
    $57e66c5a34f265b4$var$gShowNodeTasks = tasks ?? $57e66c5a34f265b4$var$gShowNodeTasks;
    $57e66c5a34f265b4$var$gShowNodePercTotal = perc_total ?? $57e66c5a34f265b4$var$gShowNodePercTotal;
};
const $57e66c5a34f265b4$export$5c565cad4215a4e4 = ({ from: from , to: to  })=>{
    $57e66c5a34f265b4$var$gDetailNodeFrom = from ?? $57e66c5a34f265b4$var$gDetailNodeFrom;
    $57e66c5a34f265b4$var$gDetailNodeTo = to ?? $57e66c5a34f265b4$var$gDetailNodeTo;
    $57e66c5a34f265b4$var$gDetailSource = "stepgrid";
};
const $57e66c5a34f265b4$export$15f660b5dd618e63 = ({ activity: activity  })=>{
    $57e66c5a34f265b4$var$gDetailActivity = activity ?? $57e66c5a34f265b4$var$gDetailActivity;
    $57e66c5a34f265b4$var$gDetailSource = "activitygrid";
};
const $57e66c5a34f265b4$export$ddb305b908ec73e7 = ({ variant: variant  })=>{
    $57e66c5a34f265b4$var$gDetailVariant = variant ?? $57e66c5a34f265b4$var$gDetailVariant;
    $57e66c5a34f265b4$var$gDetailSource = "variantgrid";
};
const $57e66c5a34f265b4$export$bc1920fcc182c42a = ({ visible: visible  })=>{
    $57e66c5a34f265b4$var$gShowStartLabel = visible ?? $57e66c5a34f265b4$var$gShowStartLabel;
};
const $57e66c5a34f265b4$export$66c5add88d363b49 = ({ node_shape: node_shape  })=>{
    $57e66c5a34f265b4$var$gActivityShape = node_shape ?? $57e66c5a34f265b4$var$gActivityShape;
};
const $57e66c5a34f265b4$export$1976c9b4d38be365 = ({ sliced_metrics: sliced_metrics  })=>{
    $57e66c5a34f265b4$var$gSlicedMetrics = sliced_metrics ?? $57e66c5a34f265b4$var$gSlicedMetrics;
    $57e66c5a34f265b4$var$updateAttributes();
};
const $57e66c5a34f265b4$export$bd90d4da7b5fc617 = ({ visible: visible  })=>{
    $57e66c5a34f265b4$var$gZoomToFit = visible ?? $57e66c5a34f265b4$var$gZoomToFit;
};
const $57e66c5a34f265b4$export$6377d97db4c4732f = ({ filteredOnly: filteredOnly  })=>{
    $57e66c5a34f265b4$var$gSaveFilteredOnly = filteredOnly ?? $57e66c5a34f265b4$var$gSaveFilteredOnly;
};
const $57e66c5a34f265b4$export$4c54b99a8d9b7d34 = ({ includeStart: includeStart  })=>{
    $57e66c5a34f265b4$var$gIncludeStart = includeStart ?? $57e66c5a34f265b4$var$gIncludeStart;
};
const $57e66c5a34f265b4$export$d18aebd3caa51ec = ({ visible: visible  })=>{
    $57e66c5a34f265b4$var$gShowEndLabel = visible ?? $57e66c5a34f265b4$var$gShowEndLabel;
};
const $57e66c5a34f265b4$export$eced9bc8d6c4c244 = ({ direction: direction  })=>{
    $57e66c5a34f265b4$var$gProcessFlowDirection = direction ?? $57e66c5a34f265b4$var$gProcessFlowDirection;
};
const $57e66c5a34f265b4$export$3725d6261377d1c2 = ({ layer: layer , column: column  })=>{
    $57e66c5a34f265b4$var$gSpacingLayer = layer ?? $57e66c5a34f265b4$var$gSpacingLayer;
    $57e66c5a34f265b4$var$gSpacingColumn = column ?? $57e66c5a34f265b4$var$gSpacingColumn;
};
const $57e66c5a34f265b4$export$b2f4e09a8320117f = ()=>({
        layer: $57e66c5a34f265b4$var$gSpacingLayer,
        column: $57e66c5a34f265b4$var$gSpacingColumn
    });
const $57e66c5a34f265b4$export$4ebf054df69593a9 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercEvents = gauge ?? $57e66c5a34f265b4$var$gGaugePercEvents;
};
const $57e66c5a34f265b4$export$aed76e416d275a7b = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercEvents
    });
const $57e66c5a34f265b4$export$744d5287a7b86f4b = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercTasks = gauge ?? $57e66c5a34f265b4$var$gGaugePercTasks;
};
const $57e66c5a34f265b4$export$aeb424a503795d7e = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercTasks
    });
const $57e66c5a34f265b4$export$3a2fa35f695d3a04 = ()=>({
        direction: $57e66c5a34f265b4$var$gProcessFlowDirection
    });
const $57e66c5a34f265b4$export$c6e9fb4ee86660de = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYVariants = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYVariants;
};
const $57e66c5a34f265b4$export$f3a08f846c274f14 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYVariants
    });
const $57e66c5a34f265b4$export$e3e3d4ca4e184ba4 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYSteps = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYSteps;
};
const $57e66c5a34f265b4$export$785dab341e0b3b61 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYSteps
    });
const $57e66c5a34f265b4$export$5261a7bc1fb52020 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYActivities = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYActivities;
};
const $57e66c5a34f265b4$export$d5525fb7331ba621 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYActivities
    });
const $57e66c5a34f265b4$export$370b3580166d392 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant;
};
const $57e66c5a34f265b4$export$fc055efb78bb4cec = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant
    });
const $57e66c5a34f265b4$export$f3d6e8f9a6d1c2b5 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant;
};
const $57e66c5a34f265b4$export$f700bd9aba24c550 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant
    });
const $57e66c5a34f265b4$export$3fe6d12fd3f1fb25 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant;
};
const $57e66c5a34f265b4$export$57c71e5bf336392c = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant
    });
const $57e66c5a34f265b4$export$df595889fe2175c3 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercVariantsCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugePercVariantsCompliant;
};
const $57e66c5a34f265b4$export$2a6f911dd09fbd3e = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercVariantsCompliant
    });
const $57e66c5a34f265b4$export$70748fea90c726da = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercTasksCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugePercTasksCompliant;
};
const $57e66c5a34f265b4$export$ec06c676c7f3243a = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercTasksCompliant
    });
const $57e66c5a34f265b4$export$b9492d4a384d05f9 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercEventsCompliant = gauge ?? $57e66c5a34f265b4$var$gGaugePercEventsCompliant;
};
const $57e66c5a34f265b4$export$acff22db679860b1 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercEventsCompliant
    });
const $57e66c5a34f265b4$export$f688feab8ae9a655 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated;
};
const $57e66c5a34f265b4$export$8a9bd9de3fed2c65 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated
    });
const $57e66c5a34f265b4$export$7f256c279294fab0 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated;
};
const $57e66c5a34f265b4$export$db41e9afcc8a0036 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated
    });
const $57e66c5a34f265b4$export$b624022150958216 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated;
};
const $57e66c5a34f265b4$export$d9b86491a57ac02 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated
    });
const $57e66c5a34f265b4$export$f96f453b3f88a603 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercVariantsAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugePercVariantsAutomated;
};
const $57e66c5a34f265b4$export$f7b852e8db4c293e = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercVariantsAutomated
    });
const $57e66c5a34f265b4$export$7609d6994e133280 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercTasksAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugePercTasksAutomated;
};
const $57e66c5a34f265b4$export$73e99b5ac58bcc1f = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercTasksAutomated
    });
const $57e66c5a34f265b4$export$f586fd861aa7782d = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercEventsAutomated = gauge ?? $57e66c5a34f265b4$var$gGaugePercEventsAutomated;
};
const $57e66c5a34f265b4$export$86fb353a83664a15 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercEventsAutomated
    });
const $57e66c5a34f265b4$export$16b8233068ca20dd = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugePercCostSaving = gauge ?? $57e66c5a34f265b4$var$gGaugePercCostSaving;
};
const $57e66c5a34f265b4$export$8860da07045d3683 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugePercCostSaving
    });
const $57e66c5a34f265b4$export$bdc1bf8100519c0a = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeActualCost = gauge ?? $57e66c5a34f265b4$var$gGaugeActualCost;
};
const $57e66c5a34f265b4$export$c97ae5ed47187ebb = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeActualCost
    });
const $57e66c5a34f265b4$export$eb2e8b181070f7f8 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeForecastCost = gauge ?? $57e66c5a34f265b4$var$gGaugeForecastCost;
};
const $57e66c5a34f265b4$export$3afff736166cdd82 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeForecastCost
    });
const $57e66c5a34f265b4$export$ab6360033d00c31a = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeCostSaving = gauge ?? $57e66c5a34f265b4$var$gGaugeCostSaving;
};
const $57e66c5a34f265b4$export$f2ef5f0d17195c29 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeCostSaving
    });
const $57e66c5a34f265b4$export$5c241b790e8d035d = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask
    });
const $57e66c5a34f265b4$export$db714c7de7057486 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask = gauge ?? $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask;
};
const $57e66c5a34f265b4$export$3538b5b4f12d08d3 = ()=>({
        font_size: $57e66c5a34f265b4$var$gStepLabelFontSize
    });
const $57e66c5a34f265b4$export$1eef6df022485250 = ({ font_size: font_size  })=>{
    $57e66c5a34f265b4$var$gStepLabelFontSize = font_size ?? $57e66c5a34f265b4$var$gStepLabelFontSize;
};
const $57e66c5a34f265b4$export$4523324998d71e10 = ()=>({
        font_size: $57e66c5a34f265b4$var$gNodeLabelFontSize
    });
const $57e66c5a34f265b4$export$c88cdda728134614 = ({ font_size: font_size  })=>{
    $57e66c5a34f265b4$var$gNodeLabelFontSize = font_size ?? $57e66c5a34f265b4$var$gNodeLabelFontSize;
};
const $57e66c5a34f265b4$export$4b901973f3f68186 = ()=>({
        gauge: $57e66c5a34f265b4$var$gGaugeAvgCostPerTask
    });
const $57e66c5a34f265b4$export$9f76759309ebe595 = ({ gauge: gauge  })=>{
    $57e66c5a34f265b4$var$gGaugeAvgCostPerTask = gauge ?? $57e66c5a34f265b4$var$gGaugeAvgCostPerTask;
};
const $57e66c5a34f265b4$export$ca4ff241d7524911 = ()=>({
        attribute: $57e66c5a34f265b4$var$gDetailEventSummaryAttribute
    });
const $57e66c5a34f265b4$export$311ade8512c0085d = ({ attribute: attribute  })=>{
    $57e66c5a34f265b4$var$gDetailEventSummaryAttribute = attribute ?? $57e66c5a34f265b4$var$gDetailEventSummaryAttribute;
};
const $57e66c5a34f265b4$export$792658a286bad179 = ()=>({
        attribute: $57e66c5a34f265b4$var$gDetailTaskSummaryAttribute
    });
const $57e66c5a34f265b4$export$d24f3fa9f662da0b = ({ attribute: attribute  })=>{
    $57e66c5a34f265b4$var$gDetailTaskSummaryAttribute = attribute ?? $57e66c5a34f265b4$var$gDetailTaskSummaryAttribute;
};
const $57e66c5a34f265b4$export$a61946b7bc04cb6c = ()=>({
        attribute: $57e66c5a34f265b4$var$gAnalyticsTaskAttribute
    });
const $57e66c5a34f265b4$export$d85a3e7a1562bc36 = ()=>({
        metric: $57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric
    });
const $57e66c5a34f265b4$export$64c62229ad9721a1 = ({ metric: metric  })=>{
    $57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric = metric ?? $57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric;
};
const $57e66c5a34f265b4$export$b7aa2fef3714f316 = ()=>({
        metric: $57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric
    });
const $57e66c5a34f265b4$export$e4379db2f2834a75 = ({ metric: metric  })=>{
    $57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric = metric ?? $57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric;
};
const $57e66c5a34f265b4$export$2b9a1516268aa73c = ({ attribute: attribute  })=>{
    $57e66c5a34f265b4$var$gAnalyticsTaskAttribute = attribute ?? $57e66c5a34f265b4$var$gAnalyticsTaskAttribute;
};
const $57e66c5a34f265b4$export$767ef34006ed97d4 = ({ attribute: attribute  })=>{
    $57e66c5a34f265b4$var$gAnalyticsEventAttribute = attribute ?? $57e66c5a34f265b4$var$gAnalyticsEventAttribute;
};
const $57e66c5a34f265b4$export$456f29721d57a025 = ()=>({
        tasks: $57e66c5a34f265b4$var$gShowNodeTasks,
        perc_total: $57e66c5a34f265b4$var$gShowNodePercTotal
    });
const $57e66c5a34f265b4$export$5a006a3542673c67 = ()=>({
        visible: $57e66c5a34f265b4$var$gShowStartLabel
    });
const $57e66c5a34f265b4$export$a828337504705d1a = ()=>({
        node_shape: $57e66c5a34f265b4$var$gActivityShape
    });
const $57e66c5a34f265b4$export$dafa60d37bf5af3c = ()=>({
        sliced_metrics: $57e66c5a34f265b4$var$gSlicedMetrics
    });
const $57e66c5a34f265b4$export$7d3de2c8b90bf180 = ()=>({
        visible: $57e66c5a34f265b4$var$gZoomToFit
    });
const $57e66c5a34f265b4$export$2bd545cb1b8cf814 = ()=>({
        visible: $57e66c5a34f265b4$var$gShowEndLabel
    });
const $57e66c5a34f265b4$export$41331b6fe80e0b4 = ({ tasks: tasks , duration: duration , std_deviation: std_deviation  })=>{
    $57e66c5a34f265b4$var$gStepWidthTasks = tasks ?? $57e66c5a34f265b4$var$gStepWidthTasks;
    $57e66c5a34f265b4$var$gStepWidthDuration = duration ?? $57e66c5a34f265b4$var$gStepWidthDuration;
    $57e66c5a34f265b4$var$gStepWidthStdDeviation = std_deviation ?? $57e66c5a34f265b4$var$gStepWidthStdDeviation;
};
function $57e66c5a34f265b4$export$62dae538e2c74504(filtered, sliced1, selected) {
    $57e66c5a34f265b4$var$gAnalyticsModeFiltered = filtered;
    $57e66c5a34f265b4$var$gAnalyticsModeSliced = sliced1;
    $57e66c5a34f265b4$var$gAnalyticsModeSelected = selected;
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
    $57e66c5a34f265b4$var$generateEventAnalyticsArray();
}
const $57e66c5a34f265b4$export$544fcebf2fe4d2f8 = ({ type: type  })=>{
    $57e66c5a34f265b4$var$gTaskDetailExtract = type ?? $57e66c5a34f265b4$var$gTaskDetailExtract;
};
const $57e66c5a34f265b4$export$f5a3a372e085fbca = ({ type: type  })=>{
    $57e66c5a34f265b4$var$gEventDetailExtract = type ?? $57e66c5a34f265b4$var$gEventDetailExtract;
};
const $57e66c5a34f265b4$export$535c8022bada01af = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gStepSelectRetention = mode ?? $57e66c5a34f265b4$var$gStepSelectRetention;
};
const $57e66c5a34f265b4$export$dfcd6d810b937c1b = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gPathSelectRetention = mode ?? $57e66c5a34f265b4$var$gPathSelectRetention;
};
const $57e66c5a34f265b4$export$f3be45955df991b7 = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gActivitySelectRetention = mode ?? $57e66c5a34f265b4$var$gActivitySelectRetention;
};
const $57e66c5a34f265b4$export$cdac68c0cdb4145c = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gStepSelectOperator = mode ?? $57e66c5a34f265b4$var$gStepSelectOperator;
};
const $57e66c5a34f265b4$export$609412ee29f27d56 = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gPathSelectOperator = mode ?? $57e66c5a34f265b4$var$gPathSelectOperator;
};
const $57e66c5a34f265b4$export$69e6f0dddeefe4e9 = ({ mode: mode  })=>{
    $57e66c5a34f265b4$var$gActivitySelectOperator = mode ?? $57e66c5a34f265b4$var$gActivitySelectOperator;
};
const $57e66c5a34f265b4$export$e556b7713d767210 = ()=>({
        tasks: $57e66c5a34f265b4$var$gStepWidthTasks,
        duration: $57e66c5a34f265b4$var$gStepWidthDuration,
        std_deviation: $57e66c5a34f265b4$var$gStepWidthStdDeviation
    });
const $57e66c5a34f265b4$export$8a7cbcf486e12eab = ()=>({
        filtered: $57e66c5a34f265b4$var$gAnalyticsModeFiltered,
        sliced: $57e66c5a34f265b4$var$gAnalyticsModeSliced,
        selected: $57e66c5a34f265b4$var$gAnalyticsModeSelected
    });
const $57e66c5a34f265b4$export$582db8b37b8d76e2 = ({ highlightLoops: highlightLoops , highlightNonCompliance: highlightNonCompliance , highlightAutomation: highlightAutomation , stepColourVolume: stepColourVolume , stepColourDuration: stepColourDuration , stepColourStdDeviation: stepColourStdDeviation , stepColourCost: stepColourCost ,  })=>{
    $57e66c5a34f265b4$var$gHighlightLoops = highlightLoops ?? $57e66c5a34f265b4$var$gHighlightLoops;
    $57e66c5a34f265b4$var$gHighlightNonCompliance = highlightNonCompliance ?? $57e66c5a34f265b4$var$gHighlightNonCompliance;
    $57e66c5a34f265b4$var$gHighlightAutomation = highlightAutomation ?? $57e66c5a34f265b4$var$gHighlightAutomation;
    $57e66c5a34f265b4$var$gStepColourVolume = stepColourVolume ?? $57e66c5a34f265b4$var$gStepColourVolume;
    $57e66c5a34f265b4$var$gStepColourDuration = stepColourDuration ?? $57e66c5a34f265b4$var$gStepColourDuration;
    $57e66c5a34f265b4$var$gStepColourStdDeviation = stepColourStdDeviation ?? $57e66c5a34f265b4$var$gStepColourStdDeviation;
    $57e66c5a34f265b4$var$gStepColourCost = stepColourCost ?? $57e66c5a34f265b4$var$gStepColourCost;
};
const $57e66c5a34f265b4$export$6276205a8eb27fa9 = ()=>({
        highlightLoops: $57e66c5a34f265b4$var$gHighlightLoops,
        highlightNonCompliance: $57e66c5a34f265b4$var$gHighlightNonCompliance,
        highlightAutomation: $57e66c5a34f265b4$var$gHighlightAutomation,
        stepColourVolume: $57e66c5a34f265b4$var$gStepColourVolume,
        stepColourCost: $57e66c5a34f265b4$var$gStepColourCost,
        stepColourDuration: $57e66c5a34f265b4$var$gStepColourDuration,
        stepColourStdDeviation: $57e66c5a34f265b4$var$gStepColourStdDeviation
    });
const $57e66c5a34f265b4$export$7f0f8748b5d9c08d = ({ start: start , end: end  })=>{
    $57e66c5a34f265b4$var$gShowStartNode = start ?? $57e66c5a34f265b4$var$gShowStartNode;
    $57e66c5a34f265b4$var$gShowEndNode = end ?? $57e66c5a34f265b4$var$gShowEndNode;
};
const $57e66c5a34f265b4$export$4392c525644d42a8 = ()=>({
        start: $57e66c5a34f265b4$var$gShowStartNode,
        end: $57e66c5a34f265b4$var$gShowEndNode
    });
const $57e66c5a34f265b4$export$c2681d0c0637e2a6 = ({ loopDashes: loopDashes  })=>{
    $57e66c5a34f265b4$var$gLoopDashes = loopDashes ?? $57e66c5a34f265b4$var$gLoopDashes;
};
const $57e66c5a34f265b4$export$1131d48184b05f96 = ({ visualizerBackgroundColor: visualizerBackgroundColor  })=>{
    $57e66c5a34f265b4$var$gVisualizerBackgroundColor = visualizerBackgroundColor ?? $57e66c5a34f265b4$var$gVisualizerBackgroundColor;
};
const $57e66c5a34f265b4$export$db20b0d2e19d5655 = ()=>({
        loopDashes: $57e66c5a34f265b4$var$gLoopDashes
    });
function $57e66c5a34f265b4$export$e00e1f0170bc1f06() {
    return $57e66c5a34f265b4$var$gVisualizerBackgroundColor;
}
function $57e66c5a34f265b4$export$179cb5aa0c08ab1b() {
    return $57e66c5a34f265b4$var$gDetailSource;
}
const $57e66c5a34f265b4$export$147fb9713d1eb4f7 = ()=>({
        taskTable: $57e66c5a34f265b4$var$gTaskTable
    });
function $57e66c5a34f265b4$export$110f12dbda7147dc(pane) {
    $57e66c5a34f265b4$var$previousPane = $57e66c5a34f265b4$var$activePane;
    $57e66c5a34f265b4$var$activePane = pane;
}
function $57e66c5a34f265b4$export$99a20415dbcb29df() {
    return $57e66c5a34f265b4$var$activePane;
}
const $57e66c5a34f265b4$export$c81a9e74e00bb8e6 = ({ isolate: isolate , animate: animate , lifecycle: lifecycle  })=>{
    $57e66c5a34f265b4$var$gVariantIsolate = isolate ?? $57e66c5a34f265b4$var$gVariantIsolate;
    $57e66c5a34f265b4$var$gVariantAnimate = animate ?? $57e66c5a34f265b4$var$gVariantAnimate;
    $57e66c5a34f265b4$var$gVariantLifecycle = lifecycle ?? $57e66c5a34f265b4$var$gVariantLifecycle;
    if ($57e66c5a34f265b4$var$gVariantIsolate == false) $57e66c5a34f265b4$var$gIsolateVariant = 0;
    if ($57e66c5a34f265b4$var$gVariantAnimate == false) $57e66c5a34f265b4$var$gAnimateVariant = 0;
    if ($57e66c5a34f265b4$var$gVariantLifecycle == false) $57e66c5a34f265b4$var$gLifecycleVariant = 0;
};
const $57e66c5a34f265b4$export$a4bbb6b3b39ca5bb = ()=>({
        isolate: $57e66c5a34f265b4$var$gVariantIsolate,
        animate: $57e66c5a34f265b4$var$gVariantAnimate,
        lifecycle: $57e66c5a34f265b4$var$gVariantLifecycle
    });
const $57e66c5a34f265b4$export$4ad6a18860f0a250 = ()=>$57e66c5a34f265b4$var$gVariantArray.filter(sliced == true);
function $57e66c5a34f265b4$export$f18a29131e55bbd0(readOnly, checked, indeterminate) {
    $57e66c5a34f265b4$var$gVariantCompliant = null;
    if (checked == true && indeterminate == false) $57e66c5a34f265b4$var$gVariantCompliant = false;
    if (checked == false && indeterminate == true) $57e66c5a34f265b4$var$gVariantCompliant = true;
}
function $57e66c5a34f265b4$export$292af01450da17dd(readOnly, checked, indeterminate) {
    $57e66c5a34f265b4$var$gVariantLoops = null;
    if (checked == true && indeterminate == false) $57e66c5a34f265b4$var$gVariantLoops = false;
    if (checked == false && indeterminate == true) $57e66c5a34f265b4$var$gVariantLoops = true;
}
function $57e66c5a34f265b4$export$55a2cec46aa3249f(readOnly, checked, indeterminate) {
    $57e66c5a34f265b4$var$gVariantAutomate = null;
    if (checked == true && indeterminate == false) $57e66c5a34f265b4$var$gVariantAutomate = false;
    if (checked == false && indeterminate == true) $57e66c5a34f265b4$var$gVariantAutomate = true;
}
function $57e66c5a34f265b4$export$75fdae28716ade6d() {
    $57e66c5a34f265b4$var$gVariantPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gStepPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gPathPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gActivityPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gTaskPaneVariants.length = 0;
    for(let member in $57e66c5a34f265b4$var$gTaskPaneVariants)delete $57e66c5a34f265b4$var$gTaskPaneVariants[member];
    $57e66c5a34f265b4$var$gSlicerSelectedSteps.length = 0;
    $57e66c5a34f265b4$var$gSlicerSelectedActivities.length = 0;
    $57e66c5a34f265b4$var$gSlicerSelectedSteps.length = 0;
    $57e66c5a34f265b4$var$gSlicerSelectedTasks.length = 0;
    $57e66c5a34f265b4$var$gVariantTasksSliced = $57e66c5a34f265b4$var$gTasksFiltered;
    $57e66c5a34f265b4$var$gVariantActivitiesSliced = $57e66c5a34f265b4$var$gActivitiesFiltered;
    $57e66c5a34f265b4$var$gVariantStepsSliced = $57e66c5a34f265b4$var$gStepsFiltered;
    $57e66c5a34f265b4$var$gVariantEventsSliced = $57e66c5a34f265b4$var$gEventsFiltered;
    $57e66c5a34f265b4$var$gStepSlicerSelection = [];
    $57e66c5a34f265b4$var$gActivitieSlicerSelection = [];
    $57e66c5a34f265b4$var$gTaskSlicerSelection = [];
    $57e66c5a34f265b4$var$gSlicerConditions = [];
    $57e66c5a34f265b4$var$gVariantAutomate = null;
    $57e66c5a34f265b4$var$gVariantLoops = null;
    $57e66c5a34f265b4$var$gVariantCompliant = null;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>b.t - a.t);
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        $57e66c5a34f265b4$var$gVariantArray[i].sliced = true;
        if (i < $57e66c5a34f265b4$var$gDefaultVariantsSelected) $57e66c5a34f265b4$var$gVariantArray[i].selected = 1;
        else $57e66c5a34f265b4$var$gVariantArray[i].selected = 0;
    }
    $57e66c5a34f265b4$export$29e7d345ec013547();
    $57e66c5a34f265b4$var$gInitialLoad = true;
}
function $57e66c5a34f265b4$var$generateLifeCycleArray() {
    let lifeCycleVariant = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++)if ($57e66c5a34f265b4$var$gVariantArray[i].s == $57e66c5a34f265b4$var$gLifecycleVariant) lifeCycleVariant = $57e66c5a34f265b4$var$gVariantArray[i].v;
    let tArray = [];
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gLinkArray.length; i1++)if ($57e66c5a34f265b4$var$gLinkArray[i1].variant == lifeCycleVariant && $57e66c5a34f265b4$var$gLinkArray[i1].duplicate === false) {
        let linkOK = true;
        if ($57e66c5a34f265b4$var$gLinkArray[i1].to_label === "End" && $57e66c5a34f265b4$var$gShowEndLabel === false || $57e66c5a34f265b4$var$gLinkArray[i1].to_label === "Start" && $57e66c5a34f265b4$var$gShowStartLabel === false) linkOK = false;
        if (linkOK === true) tArray.push($57e66c5a34f265b4$var$gLinkArray[i1]);
    }
    return tArray.sort((a, b)=>a.sort_key - b.sort_key);
}
function $57e66c5a34f265b4$var$layout() {
    $57e66c5a34f265b4$var$gDiagramPV.startTransaction("layout");
    let lay = $57e66c5a34f265b4$var$gDiagramPV.layout;
    lay.layeringOption = $lR8r2$gojs.LayeredDigraphLayout.LayerOptimalLinkLength;
    lay.initializeOption = $lR8r2$gojs.LayeredDigraphLayout.InitDepthFirstIn;
    lay.aggressiveOption = $lR8r2$gojs.LayeredDigraphLayout.AggressiveMore;
    lay.packOption = 2;
    $57e66c5a34f265b4$var$gDiagramPV.commitTransaction("layout");
}
function $57e66c5a34f265b4$var$generateNodes(nodeType) {
    let detailActivityTasks = 0;
    if (nodeType != "variants") {
        if (nodeType == "activity_inbound_all" || nodeType == "activity_outbound_all") {
            for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++)if (parseInt($57e66c5a34f265b4$var$gActivityArray[i].id) == parseInt($57e66c5a34f265b4$var$gDetailActivity)) detailActivityTasks = $57e66c5a34f265b4$var$gActivityArray[i].tasks;
        }
        if (nodeType == "activity_inbound_sliced") {
            for(let j = 0; j < $57e66c5a34f265b4$var$gLinkArray.length; j++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j].to) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j].loop === false && $57e66c5a34f265b4$var$gLinkArray[j].duplicate === false) {
                let sliced1 = false;
                for(let l = 0; l < $57e66c5a34f265b4$var$gVariantArray.length; l++)if ($57e66c5a34f265b4$var$gVariantArray[l].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j].variant) && $57e66c5a34f265b4$var$gVariantArray[l].sliced === true) sliced1 = true;
                if (sliced1 === true) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j].tasks;
            }
        }
        if (nodeType == "activity_outbound_sliced") {
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gLinkArray.length; j1++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j1].from) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j1].loop === false && $57e66c5a34f265b4$var$gLinkArray[j1].duplicate === false) {
                let sliced2 = false;
                for(let l1 = 0; l1 < $57e66c5a34f265b4$var$gVariantArray.length; l1++)if ($57e66c5a34f265b4$var$gVariantArray[l1].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j1].variant) && $57e66c5a34f265b4$var$gVariantArray[l1].sliced === true) sliced2 = true;
                if (sliced2 === true) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j1].tasks;
            }
        }
        if (nodeType == "activity_inbound_selected") {
            for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gLinkArray.length; j2++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j2].to) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j2].loop === false && $57e66c5a34f265b4$var$gLinkArray[j2].duplicate === false) {
                for(let l2 = 0; l2 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l2++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l2].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j2].variant)) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j2].tasks;
            }
        }
        if (nodeType == "activity_outbound_selected") {
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gLinkArray.length; j3++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j3].from) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j3].loop === false && $57e66c5a34f265b4$var$gLinkArray[j3].duplicate === false) {
                for(let l3 = 0; l3 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l3++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l3].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j3].variant)) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j3].tasks;
            }
        }
    }
    let nodeArray = [
        {
            key: "",
            text: "",
            start_node: false,
            end_node: false,
            figure: "Border",
            visible: true,
            font: "bold 7pt helvetica, arial, sans-serif"
        }, 
    ];
    nodeArray.length = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gActivityArray.length; i1++){
        let visible = $57e66c5a34f265b4$var$gActivityArray[i1].v;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].start_node == true && $57e66c5a34f265b4$var$gShowStartNode == false) visible = false;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].end_node == true && $57e66c5a34f265b4$var$gShowEndNode == false) visible = false;
        let valueToPush = {};
        valueToPush["key"] = $57e66c5a34f265b4$var$gActivityArray[i1].id.toString();
        let text = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity != "Start" && $57e66c5a34f265b4$var$gActivityArray[i1].activity != "End") {
            if (nodeType != "variants") {
                let stepTasks = 0;
                if (nodeType == "activity_inbound_all") {
                    for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gLinkArray.length; j4++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j4].to) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j4].duplicate === false && parseInt($57e66c5a34f265b4$var$gLinkArray[j4].from) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id)) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j4].tasks;
                }
                if (nodeType == "activity_outbound_all") {
                    for(let j5 = 0; j5 < $57e66c5a34f265b4$var$gLinkArray.length; j5++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j5].to) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) && parseInt($57e66c5a34f265b4$var$gLinkArray[j5].from) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j5].duplicate === false && $57e66c5a34f265b4$var$gLinkArray[j5].end_node == false) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j5].tasks;
                }
                if (nodeType == "activity_inbound_sliced") {
                    for(let j6 = 0; j6 < $57e66c5a34f265b4$var$gLinkArray.length; j6++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j6].to) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && parseInt($57e66c5a34f265b4$var$gLinkArray[j6].from) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) && $57e66c5a34f265b4$var$gLinkArray[j6].duplicate === false) {
                        let sliced3 = false;
                        for(let l4 = 0; l4 < $57e66c5a34f265b4$var$gVariantArray.length; l4++)if ($57e66c5a34f265b4$var$gVariantArray[l4].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j6].variant) && $57e66c5a34f265b4$var$gVariantArray[l4].sliced === true) sliced3 = true;
                        if (sliced3 === true) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j6].tasks;
                    }
                }
                if (nodeType == "activity_outbound_sliced") {
                    for(let j7 = 0; j7 < $57e66c5a34f265b4$var$gLinkArray.length; j7++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j7].from) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && parseInt($57e66c5a34f265b4$var$gLinkArray[j7].to) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) && $57e66c5a34f265b4$var$gLinkArray[i1].duplicate === false) {
                        let sliced4 = false;
                        for(let l5 = 0; l5 < $57e66c5a34f265b4$var$gVariantArray.length; l5++)if ($57e66c5a34f265b4$var$gVariantArray[l5].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j7].variant) && $57e66c5a34f265b4$var$gVariantArray[l5].sliced === true) sliced4 = true;
                        if (sliced4 === true) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j7].tasks;
                    }
                }
                if (nodeType == "activity_inbound_selected") {
                    for(let j8 = 0; j8 < $57e66c5a34f265b4$var$gLinkArray.length; j8++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j8].to) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && parseInt($57e66c5a34f265b4$var$gLinkArray[j8].from) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) && $57e66c5a34f265b4$var$gLinkArray[j8].duplicate === false) {
                        for(let l6 = 0; l6 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l6++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l6].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j8].variant)) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j8].tasks;
                    }
                }
                if (nodeType == "activity_outbound_selected") {
                    for(let j9 = 0; j9 < $57e66c5a34f265b4$var$gLinkArray.length; j9++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j9].from) == parseInt($57e66c5a34f265b4$var$gDetailActivity) && parseInt($57e66c5a34f265b4$var$gLinkArray[j9].to) == parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) && $57e66c5a34f265b4$var$gLinkArray[j9].duplicate === false) {
                        for(let l7 = 0; l7 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l7++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l7].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j9].variant)) stepTasks = stepTasks + $57e66c5a34f265b4$var$gLinkArray[j9].tasks;
                    }
                }
                if ($57e66c5a34f265b4$var$gActivityArray[i1].id == $57e66c5a34f265b4$var$gDetailActivity) {
                    text = text + "\r\n" + $57e66c5a34f265b4$export$a2db1876938cd11d(detailActivityTasks);
                    valueToPush["tooltip"] = "Activity: " + $57e66c5a34f265b4$var$gActivityArray[i1].activity + "\r\n" + $57e66c5a34f265b4$var$gEntityUpper + "s: " + $57e66c5a34f265b4$export$a2db1876938cd11d(detailActivityTasks);
                    valueToPush["selected_activity"] = true;
                    valueToPush["tasks"] = detailActivityTasks;
                } else {
                    text = text + "\r\n" + $57e66c5a34f265b4$export$a2db1876938cd11d(stepTasks);
                    text = text + "\r\n" + parseFloat(stepTasks / detailActivityTasks * 100).toFixed(1) + "%";
                    valueToPush["tooltip"] = "Activity: " + $57e66c5a34f265b4$var$gActivityArray[i1].activity + "\r\n" + $57e66c5a34f265b4$var$gEntityUpper + "s: " + $57e66c5a34f265b4$export$a2db1876938cd11d(stepTasks) + "\r\n" + " % Total: " + parseFloat(stepTasks / detailActivityTasks * 100).toFixed(1) + "%";
                    valueToPush["selected_activity"] = false;
                    valueToPush["tasks"] = stepTasks;
                }
                valueToPush["activity"] = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
                valueToPush["detailActivityTasks"] = detailActivityTasks;
                valueToPush["perc_total"] = (stepTasks / detailActivityTasks * 100).toFixed(2);
            }
            if (nodeType == "variants") {
                if ($57e66c5a34f265b4$var$gShowNodeTasks == true) text = text + "\r\n" + $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gActivityArray[i1].selected_tasks);
                if ($57e66c5a34f265b4$var$gShowNodePercTotal == true) text = text + "\r\n" + parseFloat($57e66c5a34f265b4$var$gActivityArray[i1].selected_tasks / $57e66c5a34f265b4$var$gDiagramPVTasks * 100).toFixed(1) + "%";
                valueToPush["tooltip"] = "Activity: " + $57e66c5a34f265b4$var$gActivityArray[i1].activity + "\r\n" + $57e66c5a34f265b4$var$gEntityUpper + "s: " + $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gActivityArray[i1].selected_tasks) + "\r\n" + " % Total: " + parseFloat($57e66c5a34f265b4$var$gActivityArray[i1].selected_tasks / $57e66c5a34f265b4$var$gDiagramPVTasks * 100).toFixed(1) + "%";
            }
        }
        valueToPush["text"] = text;
        valueToPush["activity"] = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        valueToPush["start_node"] = $57e66c5a34f265b4$var$gActivityArray[i1].start_node;
        valueToPush["end_node"] = $57e66c5a34f265b4$var$gActivityArray[i1].end_node;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity == "Start") valueToPush["figure"] = "Circle";
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity == "End") valueToPush["figure"] = "Circle";
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity != "Start" && $57e66c5a34f265b4$var$gActivityArray[i1].activity != "End") valueToPush["figure"] = $57e66c5a34f265b4$var$gActivityShape;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity == "Start" || $57e66c5a34f265b4$var$gActivityArray[i1].activity == "End") valueToPush["font"] = "6pt helvetica, arial, sans-serif";
        else valueToPush["font"] = $57e66c5a34f265b4$var$gNodeLabelFontSize + " helvetica, arial, sans-serif";
        valueToPush["text_color"] = $57e66c5a34f265b4$var$gColorActivityText;
        valueToPush["visible"] = visible;
        valueToPush["highlight_color"] = $57e66c5a34f265b4$var$gColorActivitySelect;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity == "Start") valueToPush["fill_color"] = $57e66c5a34f265b4$var$gColorStartNode;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity == "End") valueToPush["fill_color"] = $57e66c5a34f265b4$var$gColorEndNode;
        if ($57e66c5a34f265b4$var$gActivityArray[i1].activity != "Start" && $57e66c5a34f265b4$var$gActivityArray[i1].activity != "End") valueToPush["fill_color"] = $57e66c5a34f265b4$var$gColorActivityFill;
        valueToPush["highlight_width"] = 3;
        nodeArray.push(valueToPush);
    }
    return nodeArray;
}
function $57e66c5a34f265b4$var$generateLinks(linkType) {
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant - b.variant || a.sort_key - b.sort_key);
    let sdArray = [];
    let linkArray = [];
    let selectedVariants = [
        {
            variant: 0,
            sequence: 0
        }
    ];
    selectedVariants.length = 0;
    // these are used to determine the width of a link, based on the metric defined as the width
    let minTasksDiagram = 1000000;
    let maxTasksDiagram = 0;
    let minDurationDiagram = 1000000000000;
    let maxDurationDiagram = 0;
    let minStdDeviationDiagram = 1000000000000;
    let maxStdDeviationDiagram = 0;
    let minAvgCostDiagram = 1000000000000;
    let maxAvgCostDiagram = 0;
    let avgLinkDuration = 0;
    let minLinkDuration = 0;
    let maxLinkDuration = 0;
    let linkTasks = 0;
    let linkAutomated = 0;
    let linkCompliant = 0;
    let linkDuration = 0;
    let linkForecastCost = 0;
    let linkActualCost = 0;
    let loop = false;
    let j = 0;
    let animateVariant = null;
    let lifecycleVariant = null;
    let isolateVariant = null;
    if (linkType === "variants") {
        if ($57e66c5a34f265b4$var$gAnimateVariant != 0) {
            for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++)if ($57e66c5a34f265b4$var$gVariantArray[i].s == $57e66c5a34f265b4$var$gAnimateVariant) animateVariant = $57e66c5a34f265b4$var$gVariantArray[i].v;
        }
        if ($57e66c5a34f265b4$var$gLifecycleVariant != 0) {
            for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++)if ($57e66c5a34f265b4$var$gVariantArray[i1].s == $57e66c5a34f265b4$var$gLifecycleVariant) lifecycleVariant = $57e66c5a34f265b4$var$gVariantArray[i1].v;
        }
        if ($57e66c5a34f265b4$var$gIsolateVariant != 0) {
            for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)if ($57e66c5a34f265b4$var$gVariantArray[i2].s == $57e66c5a34f265b4$var$gIsolateVariant) isolateVariant = $57e66c5a34f265b4$var$gVariantArray[i2].v;
        }
    }
    let i3 = 0;
    for(i3 = 0; i3 < $57e66c5a34f265b4$var$gLinkArray.length; i3++)if ($57e66c5a34f265b4$var$gLinkArray[i3].duplicate === false) {
        let validLink = false;
        if (linkType === "variants") {
            let variant = parseInt($57e66c5a34f265b4$var$gLinkArray[i3].variant);
            let validVariant = false;
            if (isolateVariant == null) {
                for(j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if (variant == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                    validVariant = true;
                    break;
                }
            }
            if (isolateVariant != null && variant == isolateVariant) validVariant = true;
            if (validVariant == true) {
                validLink = true;
                for(let l = 0; l < $57e66c5a34f265b4$var$gVariantArray.length; l++)if ($57e66c5a34f265b4$var$gVariantArray[l].v == variant) {
                    if ($57e66c5a34f265b4$var$gVariantLoops == true && $57e66c5a34f265b4$var$gVariantArray[l].l == false) validLink = false;
                    if ($57e66c5a34f265b4$var$gVariantCompliant == true && $57e66c5a34f265b4$var$gVariantArray[l].compliant == false) validLink = false;
                    if ($57e66c5a34f265b4$var$gVariantAutomate == true && $57e66c5a34f265b4$var$gVariantArray[l].automated == false) validLink = false;
                    if ($57e66c5a34f265b4$var$gVariantLoops == false && $57e66c5a34f265b4$var$gVariantArray[l].l == true) validLink = false;
                    if ($57e66c5a34f265b4$var$gVariantCompliant == false && $57e66c5a34f265b4$var$gVariantArray[l].compliant == true) validLink = false;
                    if ($57e66c5a34f265b4$var$gVariantAutomate == false && $57e66c5a34f265b4$var$gVariantArray[l].automated == true) validLink = false;
                    if (validLink == false) break;
                }
                if ($57e66c5a34f265b4$var$gShowStartNode == false && $57e66c5a34f265b4$var$gLinkArray[i3].start_node == true) validLink = false;
                if ($57e66c5a34f265b4$var$gShowEndNode == false && $57e66c5a34f265b4$var$gLinkArray[i3].end_node == true) validLink = false;
            }
        }
        if (linkType === "activity_inbound_all") {
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].to)) validLink = true;
        }
        if (linkType === "activity_inbound_sliced") {
            let variant1 = parseInt($57e66c5a34f265b4$var$gLinkArray[i3].variant);
            let sliced1 = false;
            for(let l1 = 0; l1 < $57e66c5a34f265b4$var$gVariantArray.length; l1++)if ($57e66c5a34f265b4$var$gVariantArray[l1].v === variant1 && $57e66c5a34f265b4$var$gVariantArray[l1].sliced === true) sliced1 = true;
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].to) && sliced1 === true) validLink = true;
        }
        if (linkType === "activity_inbound_selected") {
            let variant2 = parseInt($57e66c5a34f265b4$var$gLinkArray[i3].variant);
            let sliced2 = false;
            for(let l2 = 0; l2 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l2++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l2].v === variant2) sliced2 = true;
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].to) && sliced2 === true) validLink = true;
        }
        if (linkType === "activity_outbound_all" && $57e66c5a34f265b4$var$gLinkArray[i3].end_node != true) {
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].from)) validLink = true;
        }
        if (linkType === "activity_outbound_sliced" && $57e66c5a34f265b4$var$gLinkArray[i3].end_node != true) {
            let variant3 = parseInt($57e66c5a34f265b4$var$gLinkArray[i3].variant);
            let sliced3 = false;
            for(let l3 = 0; l3 < $57e66c5a34f265b4$var$gVariantArray.length; l3++)if ($57e66c5a34f265b4$var$gVariantArray[l3].v == variant3 && $57e66c5a34f265b4$var$gVariantArray[l3].sliced === true) sliced3 = true;
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].from) && sliced3 === true) validLink = true;
        }
        if (linkType === "activity_outbound_selected") {
            let variant4 = parseInt($57e66c5a34f265b4$var$gLinkArray[i3].variant);
            let sliced4 = false;
            for(let l4 = 0; l4 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l4++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l4].v === variant4) sliced4 = true;
            if (parseInt($57e66c5a34f265b4$var$gDetailActivity) === parseInt($57e66c5a34f265b4$var$gLinkArray[i3].from) && sliced4 === true) validLink = true;
        }
        if (validLink == true) {
            let exists = false;
            minLinkDuration = 0;
            maxLinkDuration = 0;
            let z = 0;
            for(let k = 0; k < linkArray.length; k++){
                if ($57e66c5a34f265b4$var$gLinkArray[i3].from == linkArray[k].from) {
                    if ($57e66c5a34f265b4$var$gLinkArray[i3].to == linkArray[k].to) {
                        linkTasks = $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                        linkDuration = $57e66c5a34f265b4$var$gLinkArray[i3].duration;
                        linkAutomated = $57e66c5a34f265b4$var$gLinkArray[i3].automated;
                        linkCompliant = $57e66c5a34f265b4$var$gLinkArray[i3].compliant;
                        linkActualCost = $57e66c5a34f265b4$var$gLinkArray[i3].actual_cost;
                        linkForecastCost = $57e66c5a34f265b4$var$gLinkArray[i3].forecast_cost;
                        loop = $57e66c5a34f265b4$var$gLinkArray[i3].loop;
                        sdArray = $57e66c5a34f265b4$var$gLinkArray[i3].sd_array;
                        exists = true;
                        z = k;
                        break;
                    }
                }
            }
            if (exists == true) {
                linkArray[z].tasks = linkArray[z].tasks + linkTasks;
                if ($57e66c5a34f265b4$var$gLinkArray[i3].loop == false) linkArray[z].distinct_tasks = linkArray[z].distinct_tasks + linkTasks;
                linkArray[z].duration = linkArray[z].duration + linkDuration;
                linkArray[z].avg_duration = linkArray[z].duration / linkArray[z].tasks;
                linkArray[z].sd_array = linkArray[z].sd_array.concat(sdArray);
                linkArray[z].actual_cost = linkArray[z].actual_cost + linkActualCost;
                linkArray[z].forecast_cost = linkArray[z].forecast_cost + linkForecastCost;
                linkArray[z].loop = loop;
                linkArray[z].automated = linkArray[z].automated + linkAutomated;
                linkArray[z].compliant = linkArray[z].compliant + linkCompliant;
                if (minLinkDuration > linkArray[z].min_duration) minLinkDuration = linkArray[z].min_duration;
                if (maxLinkDuration < linkArray[z].max_duration) maxLinkDuration = linkArray[z].max_duration;
                if (minTasksDiagram > linkArray[z].tasks) minTasksDiagram = linkArray[z].tasks;
                if (maxTasksDiagram < linkArray[z].tasks) maxTasksDiagram = linkArray[z].tasks;
                if ($57e66c5a34f265b4$var$gLinkArray[i3].start_node === false && $57e66c5a34f265b4$var$gLinkArray[i3].end_node === false) {
                    if (minDurationDiagram > linkArray[z].avg_duration) minDurationDiagram = linkArray[z].avg_duration;
                    if (maxDurationDiagram < linkArray[z].avg_duration) maxDurationDiagram = linkArray[z].avg_duration;
                }
                if (minStdDeviationDiagram > $57e66c5a34f265b4$var$getStandardDeviation(linkArray[z].sd_array)) minStdDeviationDiagram = $57e66c5a34f265b4$var$getStandardDeviation(linkArray[z].sd_array);
                if (maxStdDeviationDiagram < $57e66c5a34f265b4$var$getStandardDeviation(linkArray[z].sd_array)) maxStdDeviationDiagram = $57e66c5a34f265b4$var$getStandardDeviation(linkArray[z].sd_array);
                if (minAvgCostDiagram > linkArray[z].actual_cost / linkArray[z].tasks) minAvgCostDiagram = linkArray[z].actual_cost / linkArray[z].tasks;
                if (maxAvgCostDiagram < linkArray[z].actual_cost / linkArray[z].tasks) maxAvgCostDiagram = linkArray[z].actual_cost / linkArray[z].tasks;
            } else {
                avgLinkDuration = $57e66c5a34f265b4$var$gLinkArray[i3].duration / $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                minLinkDuration = $57e66c5a34f265b4$var$gLinkArray[i3].min_duration;
                maxLinkDuration = $57e66c5a34f265b4$var$gLinkArray[i3].max_duration;
                if (minTasksDiagram > $57e66c5a34f265b4$var$gLinkArray[i3].tasks) minTasksDiagram = $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                if (maxTasksDiagram < $57e66c5a34f265b4$var$gLinkArray[i3].tasks) maxTasksDiagram = $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                if ($57e66c5a34f265b4$var$gLinkArray[i3].start_node === false && $57e66c5a34f265b4$var$gLinkArray[i3].end_node === false) {
                    if (minDurationDiagram > avgLinkDuration) minDurationDiagram = avgLinkDuration;
                    if (maxDurationDiagram < avgLinkDuration) maxDurationDiagram = avgLinkDuration;
                }
                if (minStdDeviationDiagram > $57e66c5a34f265b4$var$getStandardDeviation($57e66c5a34f265b4$var$gLinkArray[i3].sd_array)) minStdDeviationDiagram = $57e66c5a34f265b4$var$getStandardDeviation($57e66c5a34f265b4$var$gLinkArray[i3].sd_array);
                if (maxStdDeviationDiagram < $57e66c5a34f265b4$var$getStandardDeviation($57e66c5a34f265b4$var$gLinkArray[i3].sd_array)) maxStdDeviationDiagram = $57e66c5a34f265b4$var$getStandardDeviation($57e66c5a34f265b4$var$gLinkArray[i3].sd_array);
                if (minAvgCostDiagram > $57e66c5a34f265b4$var$gLinkArray[z].actual_cost / $57e66c5a34f265b4$var$gLinkArray[z].tasks) minAvgCostDiagram = $57e66c5a34f265b4$var$gLinkArray[z].actual_cost / $57e66c5a34f265b4$var$gLinkArray[z].tasks;
                if (maxAvgCostDiagram < $57e66c5a34f265b4$var$gLinkArray[z].actual_cost / $57e66c5a34f265b4$var$gLinkArray[z].tasks) maxAvgCostDiagram = $57e66c5a34f265b4$var$gLinkArray[z].actual_cost / $57e66c5a34f265b4$var$gLinkArray[z].tasks;
                let valueToPush = {};
                valueToPush["from"] = $57e66c5a34f265b4$var$gLinkArray[i3].from.toString();
                valueToPush["to"] = $57e66c5a34f265b4$var$gLinkArray[i3].to.toString();
                valueToPush["from_label"] = $57e66c5a34f265b4$var$gLinkArray[i3].from_label;
                valueToPush["to_label"] = $57e66c5a34f265b4$var$gLinkArray[i3].to_label;
                valueToPush["variant"] = $57e66c5a34f265b4$var$gLinkArray[i3].variant;
                valueToPush["width"] = 1;
                valueToPush["start_node"] = $57e66c5a34f265b4$var$gLinkArray[i3].start_node;
                valueToPush["end_node"] = $57e66c5a34f265b4$var$gLinkArray[i3].end_node;
                valueToPush["visible"] = true;
                valueToPush["label_visible"] = true;
                if ($57e66c5a34f265b4$var$gLinkArray[i3].start_node == true || $57e66c5a34f265b4$var$gLinkArray[i3].end_node == true) valueToPush["dashes"] = true;
                else valueToPush["dashes"] = false;
                valueToPush["loop"] = $57e66c5a34f265b4$var$gLinkArray[i3].loop;
                valueToPush["animate"] = false;
                valueToPush["font"] = $57e66c5a34f265b4$var$gStepLabelFontSize + " helvetica, arial, sans-serif";
                valueToPush["tasks"] = $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                if (valueToPush["loop"] == false) valueToPush["distinct_tasks"] = $57e66c5a34f265b4$var$gLinkArray[i3].tasks;
                else valueToPush["distinct_tasks"] = 0;
                valueToPush["duration"] = $57e66c5a34f265b4$var$gLinkArray[i3].duration;
                valueToPush["min_duration"] = minLinkDuration;
                valueToPush["max_duration"] = maxLinkDuration;
                valueToPush["avg_duration"] = avgLinkDuration;
                valueToPush["compliant"] = $57e66c5a34f265b4$var$gLinkArray[i3].compliant;
                valueToPush["automated"] = $57e66c5a34f265b4$var$gLinkArray[i3].automated;
                valueToPush["actual_cost"] = $57e66c5a34f265b4$var$gLinkArray[i3].actual_cost;
                valueToPush["forecast_cost"] = $57e66c5a34f265b4$var$gLinkArray[i3].forecast_cost;
                valueToPush["sd_array"] = $57e66c5a34f265b4$var$gLinkArray[i3].sd_array;
                linkArray.push(valueToPush);
                j++;
            }
        }
    }
    let widths_num = 9;
    let width_increments = 0.5;
    let width_min = 1;
    let gap = 0;
    if ($57e66c5a34f265b4$var$gStepWidthTasks == true) gap = Math.ceil((maxTasksDiagram - minTasksDiagram) / widths_num);
    if ($57e66c5a34f265b4$var$gStepWidthDuration == true) gap = Math.ceil((maxDurationDiagram - minDurationDiagram) / widths_num);
    if ($57e66c5a34f265b4$var$gStepWidthStdDeviation == true) gap = Math.ceil((maxStdDeviationDiagram - minStdDeviationDiagram) / widths_num);
    $57e66c5a34f265b4$var$gDiagramPVSteps = 0;
    $57e66c5a34f265b4$var$gDiagramPVLoops = 0;
    $57e66c5a34f265b4$var$gDiagramPVTaskLoops = 0;
    let tempActivities = [];
    let detailActivityTasks = 0;
    if (linkType != "variants") {
        if (linkType == "activity_inbound_all" || linkType == "activity_outbound_all") {
            for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gActivityArray.length; i4++)if (parseInt($57e66c5a34f265b4$var$gActivityArray[i4].id) == parseInt($57e66c5a34f265b4$var$gDetailActivity)) detailActivityTasks = $57e66c5a34f265b4$var$gActivityArray[i4].tasks;
        }
        if (linkType == "activity_inbound_sliced") {
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gLinkArray.length; j1++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j1].to) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j1].loop === false && $57e66c5a34f265b4$var$gLinkArray[j1].duplicate === false) {
                let sliced5 = false;
                for(let l5 = 0; l5 < $57e66c5a34f265b4$var$gVariantArray.length; l5++)if ($57e66c5a34f265b4$var$gVariantArray[l5].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j1].variant) && $57e66c5a34f265b4$var$gVariantArray[l5].sliced === true) sliced5 = true;
                if (sliced5 === true) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j1].tasks;
            }
        }
        if (linkType == "activity_outbound_sliced") {
            for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gLinkArray.length; j2++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j2].from) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j2].loop === false && $57e66c5a34f265b4$var$gLinkArray[j2].duplicate === false) {
                let sliced6 = false;
                for(let l6 = 0; l6 < $57e66c5a34f265b4$var$gVariantArray.length; l6++)if ($57e66c5a34f265b4$var$gVariantArray[l6].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j2].variant) && $57e66c5a34f265b4$var$gVariantArray[l6].sliced === true) sliced6 = true;
                if (sliced6 === true) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j2].tasks;
            }
        }
        if (linkType == "activity_inbound_selected") {
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gLinkArray.length; j3++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j3].to) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j3].loop === false && $57e66c5a34f265b4$var$gLinkArray[j3].duplicate === false) {
                for(let l7 = 0; l7 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l7++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l7].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j3].variant)) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j3].tasks;
            }
        }
        if (linkType == "activity_outbound_selected") {
            for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gLinkArray.length; j4++)if (parseInt($57e66c5a34f265b4$var$gLinkArray[j4].from) === parseInt($57e66c5a34f265b4$var$gDetailActivity) && $57e66c5a34f265b4$var$gLinkArray[j4].loop === false && $57e66c5a34f265b4$var$gLinkArray[j4].duplicate === false) {
                for(let l8 = 0; l8 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; l8++)if ($57e66c5a34f265b4$var$gVariantPaneVariants[l8].v == parseInt($57e66c5a34f265b4$var$gLinkArray[j4].variant)) detailActivityTasks = detailActivityTasks + $57e66c5a34f265b4$var$gLinkArray[j4].tasks;
            }
        }
    }
    let colorArr = [
        "#198C00",
        "#4BA500",
        "#7DBF00",
        "#AED700",
        "#EBF500",
        "#FFE800",
        "#FFB401",
        "#FF8100",
        "#FF4F00",
        "#FF1A00"
    ];
    let durationColourGap = Math.ceil((maxDurationDiagram - minDurationDiagram) / 9);
    let tasksColourGap = Math.ceil((maxTasksDiagram - minTasksDiagram) / 9);
    let stdDeviationColourGap = Math.ceil((maxStdDeviationDiagram - minStdDeviationDiagram) / 9);
    let costColourGap = Math.ceil((maxAvgCostDiagram - minAvgCostDiagram) / 9);
    for(let i5 = 0; i5 < linkArray.length; i5++){
        linkArray[i5].std_deviation = $57e66c5a34f265b4$var$getStandardDeviation(linkArray[i5].sd_array);
        linkArray[i5].med_duration = $57e66c5a34f265b4$var$getMedianDuration(linkArray[i5].sd_array);
        if (linkArray[i5].end_node == false) $57e66c5a34f265b4$var$gDiagramPVSteps++;
        let tasks = linkArray[i5].tasks;
        if ($57e66c5a34f265b4$var$gStepWidthTasks == true) {
            for(j = 1; j <= widths_num; j++)if (tasks <= minTasksDiagram + j * gap) {
                linkArray[i5].width = width_min - width_increments + j * width_increments;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gStepWidthDuration == true) {
            for(j = 1; j <= widths_num; j++)if (linkArray[i5].avg_duration <= minDurationDiagram + j * gap) {
                linkArray[i5].width = width_min - width_increments + j * width_increments;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gStepWidthStdDeviation == true) {
            for(j = 1; j <= widths_num; j++)if (linkArray[i5].std_deviation <= minStdDeviationDiagram + j * gap) {
                linkArray[i5].width = width_min - width_increments + j * width_increments;
                break;
            }
        }
        if (linkType != "variants") linkArray[i5].perc_total = parseFloat(linkArray[i5].tasks / detailActivityTasks * 100).toFixed(1) + "%";
        if (linkType == "variants") linkArray[i5].perc_total = parseFloat(linkArray[i5].tasks / $57e66c5a34f265b4$var$gDiagramPVTasks * 100).toFixed(1) + "%";
        linkArray[i5].perc_compliant = parseFloat(linkArray[i5].compliant / linkArray[i5].tasks * 100).toFixed(1) + "%";
        linkArray[i5].perc_automated = parseFloat(linkArray[i5].automated / linkArray[i5].tasks * 100).toFixed(1) + "%";
        linkArray[i5].avg_cost = $57e66c5a34f265b4$export$bdd804b47f20d359(linkArray[i5].actual_cost / linkArray[i5].tasks);
        linkArray[i5].link_label = "";
        if (linkArray[i5].start_node == false && linkArray[i5].end_node == false) {
            if ($57e66c5a34f265b4$var$gShowLinkTasks == true && linkType == "variants") {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$a2db1876938cd11d(linkArray[i5].tasks);
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercTotal == true && linkType == "variants") {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_total;
            }
            if ($57e66c5a34f265b4$var$gShowLinkAvgDuration == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].avg_duration);
            }
            if ($57e66c5a34f265b4$var$gShowLinkMedDuration == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].med_duration);
            }
            if ($57e66c5a34f265b4$var$gShowLinkMinDuration == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].min_duration);
            }
            if ($57e66c5a34f265b4$var$gShowLinkMaxDuration == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].max_duration);
            }
            if ($57e66c5a34f265b4$var$gShowLinkAvgCost == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].avg_cost;
            }
            if ($57e66c5a34f265b4$var$gShowLinkDeviation == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].std_deviation);
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercCompliant == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_compliant;
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercAutomated == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_automated;
            }
        }
        if (linkArray[i5].start_node == true && $57e66c5a34f265b4$var$gShowStartLabel == true && $57e66c5a34f265b4$var$gShowStartNode == true || linkArray[i5].end_node == true && $57e66c5a34f265b4$var$gShowEndLabel == true && $57e66c5a34f265b4$var$gShowEndNode == true) {
            if ($57e66c5a34f265b4$var$gShowLinkTasks == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + $57e66c5a34f265b4$export$a2db1876938cd11d(linkArray[i5].tasks);
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercTotal == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_total;
            }
            if ($57e66c5a34f265b4$var$gShowLinkAvgCost == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].avg_cost;
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercCompliant == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_compliant;
            }
            if ($57e66c5a34f265b4$var$gShowLinkPercAutomated == true) {
                if (linkArray[i5].link_label.length >= 1) linkArray[i5].link_label = linkArray[i5].link_label + "\r\n";
                linkArray[i5].link_label = linkArray[i5].link_label + linkArray[i5].perc_automated;
            }
        }
        linkArray[i5].link_color = $57e66c5a34f265b4$var$gColorLink;
        if (linkArray[i5].start_node == true && $57e66c5a34f265b4$var$gShowStartLabel == false) linkArray[i5].label_visible = false;
        if (linkArray[i5].end_node == true && $57e66c5a34f265b4$var$gShowEndLabel == false) linkArray[i5].label_visible = false;
        if (animateVariant == 0) {
            if ($57e66c5a34f265b4$var$gLoopDashes == true && linkArray[i5].loop == true) {
                linkArray[i5].dashes = true;
                linkArray[i5].animate = true;
            } else linkArray[i5].dashes = false;
        }
        if (lifecycleVariant == 0) {
            if ($57e66c5a34f265b4$var$gLoopDashes == true && linkArray[i5].loop == true) linkArray[i5].lifecycle = true;
            else linkArray[i5].lifecycle = false;
        }
        if (linkArray[i5].loop == true) $57e66c5a34f265b4$var$gDiagramPVLoops++;
        if (linkArray[i5].loop == true && $57e66c5a34f265b4$var$gHighlightLoops == true) linkArray[i5].link_color = $57e66c5a34f265b4$var$gLoopColor;
        if (linkType == "variants") {
            // compliance colors
            if (linkArray[i5].compliant > 0 && linkArray[i5].compliant != linkArray[i5].tasks && $57e66c5a34f265b4$var$gHighlightNonCompliance == true) linkArray[i5].link_color = $57e66c5a34f265b4$var$gPartialNonCompliantColor;
            if (linkArray[i5].compliant == 0 && $57e66c5a34f265b4$var$gHighlightNonCompliance == true) linkArray[i5].link_color = $57e66c5a34f265b4$var$gNonCompliantColor;
            // automation colors
            if (linkArray[i5].automated == linkArray[i5].tasks && $57e66c5a34f265b4$var$gHighlightAutomation == true) linkArray[i5].link_color = $57e66c5a34f265b4$var$gAutomationColor;
            if (linkArray[i5].automated > 0 && linkArray[i5].automated != linkArray[i5].tasks && $57e66c5a34f265b4$var$gHighlightAutomation == true) linkArray[i5].link_color = $57e66c5a34f265b4$var$gPartialAutomationColor;
            linkArray[i5].highlight_color = $57e66c5a34f265b4$var$gColorLinkSelect;
        }
        linkArray[i5].visible = true;
        if ($57e66c5a34f265b4$var$gStepColourVolume === true) {
            if (linkArray[i5].start_node === true || linkArray[i5].end_node === true) linkArray[i5].link_color = "#9B9B9B";
            else {
                for(let j5 = 0; j5 < 10; j5++)if (linkArray[i5].tasks <= minTasksDiagram + j5 * tasksColourGap) {
                    linkArray[i5].link_color = colorArr[j5];
                    break;
                }
            }
        }
        if ($57e66c5a34f265b4$var$gStepColourCost === true) {
            let avgCost = parseInt(linkArray[i5].avg_cost.replace("$", ""));
            if (linkArray[i5].start_node === true || linkArray[i5].end_node === true) linkArray[i5].link_color = "#9B9B9B";
            else {
                for(let j6 = 0; j6 < 10; j6++)if (avgCost <= minAvgCostDiagram + j6 * costColourGap) {
                    linkArray[i5].link_color = colorArr[j6];
                    break;
                }
            }
        }
        if ($57e66c5a34f265b4$var$gStepColourDuration === true) {
            if (linkArray[i5].start_node === true || linkArray[i5].end_node === true) linkArray[i5].link_color = "#9B9B9B";
            else {
                for(let j7 = 0; j7 < 10; j7++)if (linkArray[i5].avg_duration <= minDurationDiagram + j7 * durationColourGap) {
                    linkArray[i5].link_color = colorArr[j7];
                    break;
                }
            }
        }
        if ($57e66c5a34f265b4$var$gStepColourStdDeviation === true) {
            if (linkArray[i5].start_node === true || linkArray[i5].end_node === true) linkArray[i5].link_color = "#9B9B9B";
            else {
                for(let j8 = 0; j8 < 10; j8++)if (linkArray[i5].std_deviation <= minStdDeviationDiagram + j8 * stdDeviationColourGap) {
                    linkArray[i5].link_color = colorArr[j8];
                    break;
                }
            }
        }
        if (linkArray[i5].start_node == true && $57e66c5a34f265b4$var$gShowStartNode == false) {
            linkArray[i5].visible = false;
            linkArray[i5].link_color = "white";
        }
        if (linkArray[i5].end_node == true && $57e66c5a34f265b4$var$gShowEndNode == false) {
            linkArray[i5].visible = false;
            linkArray[i5].link_color = "white";
        }
        linkArray[i5].tooltip = "From: " + linkArray[i5].from_label + "\r\n" + "To: " + linkArray[i5].to_label + "\r\n" + $57e66c5a34f265b4$var$gEntityUpper + "s: " + linkArray[i5].tasks + "\r\n" + "% Total: " + linkArray[i5].perc_total;
        if (linkArray[i5].start_node != true && linkArray[i5].end_node != true) linkArray[i5].tooltip = linkArray[i5].tooltip + "\r\n" + "Avg Duration: " + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].avg_duration) + "\r\n" + "Std Deviation: " + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].std_deviation) + "\r\n" + "Max Duration: " + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].max_duration) + "\r\n" + "Min Duration: " + $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(linkArray[i5].min_duration);
        if (linkArray[i5].end_node != true) linkArray[i5].tooltip = linkArray[i5].tooltip + "\r\n" + "% Automated: " + linkArray[i5].perc_automated + "\r\n" + "% Compliant: " + linkArray[i5].perc_compliant + "\r\n" + "Avg cost: " + linkArray[i5].avg_cost;
        let activityExists = false;
        for(let j9 = 0; j9 < tempActivities.length; j9++)if (tempActivities[j9].a == linkArray[i5].from) {
            activityExists = true;
            break;
        }
        if (activityExists == false) {
            let valueToPush1 = {};
            valueToPush1["a"] = linkArray[i5].from;
            tempActivities.push(valueToPush1);
        }
        activityExists = false;
        for(let j10 = 0; j10 < tempActivities.length; j10++)if (tempActivities[j10].a == linkArray[i5].to) {
            activityExists = true;
            break;
        }
        if (activityExists == false) {
            let valueToPush2 = {};
            valueToPush2["a"] = linkArray[i5].to;
            tempActivities.push(valueToPush2);
        }
    }
    if (linkType === "variants") {
        $57e66c5a34f265b4$var$gDiagramPVActivities = tempActivities.length - 2;
        if (animateVariant != null) {
            for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gLinkArray.length; i6++)if ($57e66c5a34f265b4$var$gLinkArray[i6].variant == animateVariant && $57e66c5a34f265b4$var$gLinkArray[i6].duplicate === false) {
                for(j = 0; j < linkArray.length; j++)if (linkArray[j].from == $57e66c5a34f265b4$var$gLinkArray[i6].from && linkArray[j].to == $57e66c5a34f265b4$var$gLinkArray[i6].to) {
                    linkArray[j].width = 4;
                    linkArray[j].link_color = $57e66c5a34f265b4$var$gAnimateColor;
                    linkArray[j].animate = true;
                    linkArray[j].dashes = true;
                }
            }
        }
        if (lifecycleVariant != null) {
            for(let i7 = 0; i7 < $57e66c5a34f265b4$var$gLinkArray.length; i7++)if ($57e66c5a34f265b4$var$gLinkArray[i7].variant == lifecycleVariant && $57e66c5a34f265b4$var$gLinkArray[i7].duplicate === false) {
                for(j = 0; j < linkArray.length; j++)if (linkArray[j].from == $57e66c5a34f265b4$var$gLinkArray[i7].from && linkArray[j].to == $57e66c5a34f265b4$var$gLinkArray[i7].to) linkArray[j].lifecycle = true;
            }
        }
    }
    if (linkArray.length > 0) {
        let tempArray = [];
        for(let i8 = 0; i8 < linkArray.length; i8++){
            let valueToPush3 = {};
            valueToPush3["a"] = linkArray[i8].to;
            valueToPush3["t"] = linkArray[i8].distinct_tasks;
            tempArray.push(valueToPush3);
        }
        tempArray.sort((a, b)=>a.a - b.a);
        let tasks1 = 0;
        for(let i9 = 0; i9 < tempArray.length; i9++){
            if (i9 > 0 && tempArray[i9 - 1].a != tempArray[i9].a) {
                for(let j11 = 0; j11 < $57e66c5a34f265b4$var$gActivityArray.length; j11++)if ($57e66c5a34f265b4$var$gActivityArray[j11].id == tempArray[i9 - 1].a) {
                    $57e66c5a34f265b4$var$gActivityArray[j11].selected_tasks = tasks1;
                    break;
                }
                tasks1 = 0;
            }
            tasks1 = tempArray[i9].t + tasks1;
        }
        for(let j12 = 0; j12 < $57e66c5a34f265b4$var$gActivityArray.length; j12++)if ($57e66c5a34f265b4$var$gActivityArray[j12].id == tempArray[tempArray.length - 1].a) {
            $57e66c5a34f265b4$var$gActivityArray[j12].selected_tasks = tasks1;
            break;
        }
    }
    return linkArray;
}
function $57e66c5a34f265b4$export$a2db1876938cd11d(x) {
    return Number(x).toLocaleString();
}
function $57e66c5a34f265b4$export$845857f28dc08744(x, y) {
    return $57e66c5a34f265b4$export$a2db1876938cd11d(x.toFixed(y));
}
function $57e66c5a34f265b4$export$3e1eee59f5dc52be(x, decimals) {
    return (x * 100).toFixed(decimals) + "%";
}
function $57e66c5a34f265b4$export$e370a7ddaa2f579a(x) {
    return "$" + $57e66c5a34f265b4$export$a2db1876938cd11d(x.toFixed(0));
}
function $57e66c5a34f265b4$export$bdd804b47f20d359(x) {
    return "$" + $57e66c5a34f265b4$export$a2db1876938cd11d(x.toFixed(2));
}
function $57e66c5a34f265b4$export$bc733b0c5cbb3e8a(totalSeconds) {
    // if days not selected, add days * 24 to hours
    let days = Math.floor(totalSeconds / 86400);
    totalSeconds %= 86400;
    let hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    let minutes = Math.floor(totalSeconds / 60);
    totalSeconds %= 60;
    let seconds = Math.floor(totalSeconds);
    let duration_str = "";
    if (days >= 1 && $57e66c5a34f265b4$var$gShowDurationDays == true) duration_str = duration_str + days + "d ";
    if (hours >= 1 && $57e66c5a34f265b4$var$gShowDurationHours == true) {
        if ($57e66c5a34f265b4$var$gShowDurationDays == false && days >= 1) hours = hours + days * 24;
        duration_str = duration_str + hours + "h ";
    }
    if (minutes >= 1 && $57e66c5a34f265b4$var$gShowDurationMinutes == true) {
        if ($57e66c5a34f265b4$var$gShowDurationHours == false && hours >= 1) minutes = minutes + hours * 60;
        duration_str = duration_str + minutes + "m ";
    }
    if (seconds >= 1 && $57e66c5a34f265b4$var$gShowDurationSeconds == true) duration_str = duration_str + seconds + "s ";
    if (duration_str.includes("Na")) duration_str = "";
    if (duration_str == "" && $57e66c5a34f265b4$var$gShowDurationDays == true) duration_str = "0d ";
    if (duration_str == "0d " && $57e66c5a34f265b4$var$gShowDurationHours == true) duration_str = "0h ";
    if (duration_str == "0h " && $57e66c5a34f265b4$var$gShowDurationMinutes == true) duration_str = "0m ";
    if (duration_str == "0m " && $57e66c5a34f265b4$var$gShowDurationSeconds == true) duration_str = "0s ";
    return duration_str;
}
function $57e66c5a34f265b4$export$ba3cd16e91ec14da(totalMinutes) {
    let days = Math.floor(totalMinutes / 1440);
    totalMinutes %= 1440;
    let hours = Math.floor(totalMinutes / 60);
    totalMinutes %= 60;
    let minutes = Math.floor(totalMinutes);
    let duration_str = "";
    if (days >= 1) duration_str = days + "d " + hours + "h " + minutes + "m ";
    else duration_str = hours + "h " + minutes + "m ";
    if (duration_str.includes("Na")) duration_str = "";
    return duration_str;
}
function $57e66c5a34f265b4$export$17c1ae3dc9ebba7a(seconds) {
    let days = Math.floor(seconds / 86400);
    seconds %= 86400;
    let hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    let duration_str = "";
    if (days >= 1) duration_str = duration_str + days + "d ";
    if (hours >= 1) {
        if ($57e66c5a34f265b4$var$gShowDurationDays == false && days >= 1) hours = hours + days * 24;
        duration_str = duration_str + hours + "h ";
    }
    return duration_str;
}
function $57e66c5a34f265b4$export$ccb89cea349286f3(selectedVariant) {
    if ($57e66c5a34f265b4$var$gAnimateVariant == selectedVariant) $57e66c5a34f265b4$var$gAnimateVariant = 0;
    else if ($57e66c5a34f265b4$var$gVariantAnimate) $57e66c5a34f265b4$var$gAnimateVariant = selectedVariant;
    if ($57e66c5a34f265b4$var$gIsolateVariant == selectedVariant) $57e66c5a34f265b4$var$gIsolateVariant = 0;
    else if ($57e66c5a34f265b4$var$gVariantIsolate) $57e66c5a34f265b4$var$gIsolateVariant = selectedVariant;
    if ($57e66c5a34f265b4$var$gLifecycleVariant == selectedVariant) $57e66c5a34f265b4$var$gLifecycleVariant = 0;
    else if ($57e66c5a34f265b4$var$gVariantLifecycle) $57e66c5a34f265b4$var$gLifecycleVariant = selectedVariant;
    (0, $023544c78e6edd5b$export$354780eb60e1ec23)($57e66c5a34f265b4$var$gDiagramPV, $57e66c5a34f265b4$export$2ff5de46d769d306);
}
const $57e66c5a34f265b4$export$df65445ae8ae4fa7 = (max)=>{
    gMaxStepVariants = max;
};
function $57e66c5a34f265b4$export$bc98d6fbac005943(attribute, attributeType, source) {
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gAttributeArray.length; i++)if ($57e66c5a34f265b4$var$gAttributeArray[i].type == attributeType && $57e66c5a34f265b4$var$gAttributeArray[i].field == attribute) rows.push({
        value: $57e66c5a34f265b4$var$gAttributeArray[i].value,
        tasks: $57e66c5a34f265b4$var$gAttributeArray[i].tasks,
        events: $57e66c5a34f265b4$var$gAttributeArray[i].events,
        perc_total_tasks: $57e66c5a34f265b4$var$gAttributeArray[i].perc_total_tasks,
        perc_total_events: $57e66c5a34f265b4$var$gAttributeArray[i].perc_total_events,
        perc_compliant_tasks: $57e66c5a34f265b4$var$gAttributeArray[i].perc_compliant_tasks,
        perc_compliant_events: $57e66c5a34f265b4$var$gAttributeArray[i].perc_compliant_events,
        perc_automated_tasks: $57e66c5a34f265b4$var$gAttributeArray[i].perc_automated_tasks,
        perc_automated_events: $57e66c5a34f265b4$var$gAttributeArray[i].perc_automated_events,
        avg_duration: $57e66c5a34f265b4$var$gAttributeArray[i].avg_duration,
        std_deviation: $57e66c5a34f265b4$var$gAttributeArray[i].std_deviation,
        selected: $57e66c5a34f265b4$var$gAttributeArray[i].selected,
        perc_cost_savings: $57e66c5a34f265b4$var$gAttributeArray[i].perc_cost_savings,
        avg_task_cost: $57e66c5a34f265b4$var$gAttributeArray[i].avg_task_cost
    });
    return rows;
}
function $57e66c5a34f265b4$export$480663dacd820796() {
    let totalEvents = $57e66c5a34f265b4$var$gEventsFiltered;
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gStepArray.length; i++)if ($57e66c5a34f265b4$var$gStepArray[i].filtered == 0) {
        let from_activity = "";
        let to_activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gStepArray[i].from) from_activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gStepArray[i].to) to_activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
        }
        if (to_activity != "End") rows.push({
            from_activity: from_activity,
            to_activity: to_activity,
            from_activity_id: $57e66c5a34f265b4$var$gStepArray[i].from,
            to_activity_id: $57e66c5a34f265b4$var$gStepArray[i].to,
            step: from_activity + " - " + to_activity,
            events: $57e66c5a34f265b4$var$gStepArray[i].events,
            tasks: $57e66c5a34f265b4$var$gStepArray[i].tasks,
            avg_duration: $57e66c5a34f265b4$var$gStepArray[i].avg_duration,
            std_deviation: $57e66c5a34f265b4$var$gStepArray[i].std_deviation,
            avg_duration_days: (Math.round($57e66c5a34f265b4$var$gStepArray[i].avg_duration / 86400 * 100) / 100).toFixed(2),
            avg_duration_hrs: (Math.round($57e66c5a34f265b4$var$gStepArray[i].avg_duration / 3600 * 100) / 100).toFixed(2),
            std_deviation_days: (Math.round($57e66c5a34f265b4$var$gStepArray[i].std_deviation / 86400 * 100) / 100).toFixed(2),
            std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$gStepArray[i].std_deviation / 3600 * 100) / 100).toFixed(2),
            min_duration: $57e66c5a34f265b4$var$gStepArray[i].min_duration,
            max_duration: $57e66c5a34f265b4$var$gStepArray[i].max_duration,
            loop: $57e66c5a34f265b4$var$gStepArray[i].loop,
            perc_total_events: $57e66c5a34f265b4$var$gStepArray[i].events / totalEvents,
            event_actual_cost: $57e66c5a34f265b4$var$gStepArray[i].actual_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            event_forecast_cost: $57e66c5a34f265b4$var$gStepArray[i].forecast_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            event_cost_savings: $57e66c5a34f265b4$var$gStepArray[i].actual_cost / $57e66c5a34f265b4$var$gStepArray[i].events - $57e66c5a34f265b4$var$gStepArray[i].forecast_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            step_actual_cost: $57e66c5a34f265b4$var$gStepArray[i].actual_cost,
            step_forecast_cost: $57e66c5a34f265b4$var$gStepArray[i].forecast_cost,
            step_cost_savings: $57e66c5a34f265b4$var$gStepArray[i].actual_cost - $57e66c5a34f265b4$var$gStepArray[i].forecast_cost,
            compliant: $57e66c5a34f265b4$var$gStepArray[i].compliant,
            automated: $57e66c5a34f265b4$var$gStepArray[i].automated,
            events_compliant: $57e66c5a34f265b4$var$gStepArray[i].events_compliant,
            events_automated: $57e66c5a34f265b4$var$gStepArray[i].events_automated,
            perc_events_compliant: $57e66c5a34f265b4$var$gStepArray[i].events_compliant / $57e66c5a34f265b4$var$gStepArray[i].events,
            perc_events_automated: $57e66c5a34f265b4$var$gStepArray[i].events_automated / $57e66c5a34f265b4$var$gStepArray[i].events
        });
    }
    rows.sort((a, b)=>b.tasks > a.tasks ? 1 : -1);
    return rows;
}
function $57e66c5a34f265b4$export$c6150266ad4a5635() {
    let totalEvents = $57e66c5a34f265b4$var$gEventsFiltered;
    let totalTasks = $57e66c5a34f265b4$var$gTasksFiltered;
    const rows = [];
    for(let i = 0; i < 10; i++)if ($57e66c5a34f265b4$var$gStepArray[i].filtered == 0) {
        let from_activity = "";
        let to_activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gStepArray[i].from) from_activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gStepArray[i].to) to_activity = $57e66c5a34f265b4$var$gActivityArray[j].activity;
        }
        if (to_activity != "End") rows.push({
            from_activity: from_activity,
            to_activity: to_activity,
            step: from_activity + " - " + to_activity,
            events: $57e66c5a34f265b4$var$gStepArray[i].events,
            avg_duration: $57e66c5a34f265b4$var$gStepArray[i].avg_duration,
            std_deviation: $57e66c5a34f265b4$var$gStepArray[i].std_deviation,
            avg_duration_days: (Math.round($57e66c5a34f265b4$var$gStepArray[i].avg_duration / 86400 * 100) / 100).toFixed(2),
            avg_duration_hrs: (Math.round($57e66c5a34f265b4$var$gStepArray[i].avg_duration / 3600 * 100) / 100).toFixed(2),
            std_deviation_days: (Math.round($57e66c5a34f265b4$var$gStepArray[i].std_deviation / 86400 * 100) / 100).toFixed(2),
            std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$gStepArray[i].std_deviation / 3600 * 100) / 100).toFixed(2),
            min_duration: $57e66c5a34f265b4$var$gStepArray[i].min_duration,
            max_duration: $57e66c5a34f265b4$var$gStepArray[i].max_duration,
            loop: $57e66c5a34f265b4$var$gStepArray[i].loop,
            perc_total_events: $57e66c5a34f265b4$var$gStepArray[i].events / totalEvents,
            event_actual_cost: $57e66c5a34f265b4$var$gStepArray[i].actual_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            event_forecast_cost: $57e66c5a34f265b4$var$gStepArray[i].forecast_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            event_cost_savings: $57e66c5a34f265b4$var$gStepArray[i].actual_cost / $57e66c5a34f265b4$var$gStepArray[i].events - $57e66c5a34f265b4$var$gStepArray[i].forecast_cost / $57e66c5a34f265b4$var$gStepArray[i].events,
            step_actual_cost: $57e66c5a34f265b4$var$gStepArray[i].actual_cost,
            step_forecast_cost: $57e66c5a34f265b4$var$gStepArray[i].forecast_cost,
            step_cost_savings: $57e66c5a34f265b4$var$gStepArray[i].actual_cost - $57e66c5a34f265b4$var$gStepArray[i].forecast_cost,
            compliant: $57e66c5a34f265b4$var$gStepArray[i].compliant,
            automated: $57e66c5a34f265b4$var$gStepArray[i].automated,
            events_compliant: $57e66c5a34f265b4$var$gStepArray[i].events_compliant,
            events_automated: $57e66c5a34f265b4$var$gStepArray[i].events_automated,
            perc_events_compliant: $57e66c5a34f265b4$var$gStepArray[i].events_compliant / $57e66c5a34f265b4$var$gStepArray[i].events,
            perc_events_automated: $57e66c5a34f265b4$var$gStepArray[i].events_automated / $57e66c5a34f265b4$var$gStepArray[i].events
        });
    }
    rows.sort((a, b)=>b.tasks > a.tasks ? 1 : -1);
    return rows;
}
function $57e66c5a34f265b4$export$a9290b2001080ed9() {
    return $57e66c5a34f265b4$var$gInitialLoad;
}
function $57e66c5a34f265b4$export$6e4c85e15f853f95() {
    let totalEvents = 0;
    let totalTasks = 0;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.filtered - b.filtered);
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        if ($57e66c5a34f265b4$var$gVariantArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gVariantArray[i].sliced == true) {
            totalTasks = totalTasks + $57e66c5a34f265b4$var$gVariantArray[i].t;
            totalEvents = totalEvents + $57e66c5a34f265b4$var$gVariantArray[i].e;
        }
    }
    const rows = [];
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        if ($57e66c5a34f265b4$var$gVariantArray[i1].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gVariantArray[i1].sliced == true) rows.push({
            variant: $57e66c5a34f265b4$var$gVariantArray[i1].n,
            sequence: $57e66c5a34f265b4$var$gVariantArray[i1].s,
            tasks: $57e66c5a34f265b4$var$gVariantArray[i1].t,
            avg_duration: $57e66c5a34f265b4$var$gVariantArray[i1].ad,
            min_duration: $57e66c5a34f265b4$var$gVariantArray[i1].min_duration,
            max_duration: $57e66c5a34f265b4$var$gVariantArray[i1].max_duration,
            std_deviation: $57e66c5a34f265b4$var$gVariantArray[i1].sd,
            avg_duration_days: (Math.round($57e66c5a34f265b4$var$gVariantArray[i1].ad / 86400 * 100) / 100).toFixed(2),
            avg_duration_hrs: (Math.round($57e66c5a34f265b4$var$gVariantArray[i1].ad / 3600 * 100) / 100).toFixed(2),
            std_deviation_days: (Math.round($57e66c5a34f265b4$var$gVariantArray[i1].sd / 86400 * 100) / 100).toFixed(2),
            std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$gVariantArray[i1].sd / 3600 * 100) / 100).toFixed(2),
            task_actual_cost: $57e66c5a34f265b4$var$gVariantArray[i1].actual_cost / $57e66c5a34f265b4$var$gVariantArray[i1].t,
            task_forecast_cost: $57e66c5a34f265b4$var$gVariantArray[i1].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[i1].t,
            task_cost_savings: $57e66c5a34f265b4$var$gVariantArray[i1].actual_cost / $57e66c5a34f265b4$var$gVariantArray[i1].t - $57e66c5a34f265b4$var$gVariantArray[i1].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[i1].t,
            variant_actual_cost: $57e66c5a34f265b4$var$gVariantArray[i1].actual_cost,
            variant_forecast_cost: $57e66c5a34f265b4$var$gVariantArray[i1].forecast_cost,
            variant_cost_savings: $57e66c5a34f265b4$var$gVariantArray[i1].actual_cost - $57e66c5a34f265b4$var$gVariantArray[i1].forecast_cost,
            loop: $57e66c5a34f265b4$var$gVariantArray[i1].l,
            compliant: $57e66c5a34f265b4$var$gVariantArray[i1].compliant,
            automated: $57e66c5a34f265b4$var$gVariantArray[i1].automated,
            events: $57e66c5a34f265b4$var$gVariantArray[i1].e,
            variant_id: $57e66c5a34f265b4$var$gVariantArray[i1].v,
            selected: $57e66c5a34f265b4$var$gVariantArray[i1].selected,
            perc_total_tasks: $57e66c5a34f265b4$var$gVariantArray[i1].t / totalTasks,
            perc_total_events: $57e66c5a34f265b4$var$gVariantArray[i1].e / totalEvents,
            steps: $57e66c5a34f265b4$var$gVariantArray[i1].steps,
            tasks_compliant: $57e66c5a34f265b4$var$gVariantArray[i1].compliant_tasks,
            tasks_automated: $57e66c5a34f265b4$var$gVariantArray[i1].automated_tasks,
            events_compliant: $57e66c5a34f265b4$var$gVariantArray[i1].compliant_events,
            events_automated: $57e66c5a34f265b4$var$gVariantArray[i1].automated_events,
            perc_tasks_compliant: $57e66c5a34f265b4$var$gVariantArray[i1].compliant_tasks / $57e66c5a34f265b4$var$gVariantArray[i1].t,
            perc_tasks_automated: $57e66c5a34f265b4$var$gVariantArray[i1].automated_tasks / $57e66c5a34f265b4$var$gVariantArray[i1].t,
            perc_events_compliant: $57e66c5a34f265b4$var$gVariantArray[i1].compliant_events / $57e66c5a34f265b4$var$gVariantArray[i1].e,
            perc_events_automated: $57e66c5a34f265b4$var$gVariantArray[i1].automated_events / $57e66c5a34f265b4$var$gVariantArray[i1].e
        });
    }
    rows.sort((a, b)=>b.t > a.t ? 1 : -1);
    $57e66c5a34f265b4$var$gVariants = rows.length;
    return rows;
}
function $57e66c5a34f265b4$export$2399ecb8bbf4c658() {
    let totalTasks = $57e66c5a34f265b4$var$gTasksFiltered;
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++)if ($57e66c5a34f265b4$var$gActivityArray[i].activity != "End" && $57e66c5a34f265b4$var$gActivityArray[i].activity != "Start" && $57e66c5a34f265b4$var$gActivityArray[i].filtered == 0) rows.push({
        activity: $57e66c5a34f265b4$var$gActivityArray[i].activity,
        activity_id: $57e66c5a34f265b4$var$gActivityArray[i].id,
        tasks: $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        perc_total: $57e66c5a34f265b4$var$gActivityArray[i].tasks / totalTasks,
        compliant: $57e66c5a34f265b4$var$gActivityArray[i].compliant,
        automated: $57e66c5a34f265b4$var$gActivityArray[i].automated,
        perc_tasks_compliant: $57e66c5a34f265b4$var$gActivityArray[i].compliant / $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        perc_tasks_automated: $57e66c5a34f265b4$var$gActivityArray[i].automated / $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        task_actual_cost: $57e66c5a34f265b4$var$gActivityArray[i].actual_cost / $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        task_forecast_cost: $57e66c5a34f265b4$var$gActivityArray[i].forecast_cost / $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        task_cost_savings: $57e66c5a34f265b4$var$gActivityArray[i].actual_cost / $57e66c5a34f265b4$var$gActivityArray[i].tasks - $57e66c5a34f265b4$var$gActivityArray[i].forecast_cost / $57e66c5a34f265b4$var$gActivityArray[i].tasks,
        activity_actual_cost: $57e66c5a34f265b4$var$gActivityArray[i].actual_cost,
        activity_target_cost: $57e66c5a34f265b4$var$gActivityArray[i].forecast_cost,
        activity_cost_savings: $57e66c5a34f265b4$var$gActivityArray[i].actual_cost - $57e66c5a34f265b4$var$gActivityArray[i].forecast_cost
    });
    if ($57e66c5a34f265b4$var$gIncludeStart == false) rows.sort((a, b)=>b.tasks > a.tasks ? 1 : -1);
    else rows.sort((a, b)=>a.activity.localeCompare(b.activity));
    return rows;
}
function $57e66c5a34f265b4$export$6fc0a7275b17948c() {
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskArray.length; i++)if ($57e66c5a34f265b4$var$gTaskArray[i].filtered == 0) rows.push({
        task: $57e66c5a34f265b4$var$gTaskArray[i].k,
        duration: $57e66c5a34f265b4$var$gTaskArray[i].d,
        actual_cost: $57e66c5a34f265b4$var$gTaskArray[i].actual_cost,
        forecast_cost: $57e66c5a34f265b4$var$gTaskArray[i].forecast_cost,
        automated: $57e66c5a34f265b4$var$gTaskArray[i].automated,
        compliant: $57e66c5a34f265b4$var$gTaskArray[i].compliant,
        duration_days: (Math.round($57e66c5a34f265b4$var$gTaskArray[i].d / 86400 * 100) / 100).toFixed(2),
        duration_hrs: (Math.round($57e66c5a34f265b4$var$gTaskArray[i].d / 3600 * 100) / 100).toFixed(2),
        variant_id: $57e66c5a34f265b4$var$gTaskArray[i].vid
    });
    return rows;
}
function $57e66c5a34f265b4$export$7558155638e6d8a1() {
    if ($57e66c5a34f265b4$var$gEventAttributes.length == 0) return [];
    $57e66c5a34f265b4$var$gDetailDescription = "";
    if ($57e66c5a34f265b4$var$gDetailSource === "step" || $57e66c5a34f265b4$var$gDetailSource === "stepgrid") {
        let fromStr = "";
        let toStr = "";
        for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++){
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom)) fromStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) toStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
        }
        $57e66c5a34f265b4$var$gDetailDescription = "Step: " + fromStr + " - " + toStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "activity" || $57e66c5a34f265b4$var$gDetailSource === "activitygrid") {
        let activityStr = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gActivityArray.length; i1++)if ($57e66c5a34f265b4$var$gActivityArray[i1].id === parseInt($57e66c5a34f265b4$var$gDetailActivity)) activityStr = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        $57e66c5a34f265b4$var$gDetailDescription = "Activity: " + activityStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "variantgrid") {
        let variantStr = "";
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)if ($57e66c5a34f265b4$var$gVariantArray[i2].v === $57e66c5a34f265b4$var$gDetailVariant) variantStr = $57e66c5a34f265b4$var$gVariantArray[i2].n;
        $57e66c5a34f265b4$var$gDetailDescription = "Variant: " + variantStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "diagram") $57e66c5a34f265b4$var$gDetailDescription = "Current variants in visualizer";
    if ($57e66c5a34f265b4$var$gDetailSource === "dt_node") $57e66c5a34f265b4$var$gDetailDescription = "Decomposition Tree";
    if ($57e66c5a34f265b4$var$gDetailSource === "ia_node") $57e66c5a34f265b4$var$gDetailDescription = "Influence Analysis";
    if ($57e66c5a34f265b4$var$gDetailSource === "is_node") $57e66c5a34f265b4$var$gDetailDescription = "Insights";
    if ($57e66c5a34f265b4$var$gDetailSource === "task") $57e66c5a34f265b4$var$gDetailDescription = $57e66c5a34f265b4$export$7bca99abddcf9a72() + ": " + $57e66c5a34f265b4$var$gTaskID;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered);
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    let detailTaskArray1 = [];
    let detailTaskArray2 = [];
    if ($57e66c5a34f265b4$var$gDetailSource === "dt_node") detailTaskArray1 = $57e66c5a34f265b4$var$gDecompositionTreeTaskArray;
    if ($57e66c5a34f265b4$var$gDetailSource === "is_node" || $57e66c5a34f265b4$var$gDetailSource === "ia_node") {
        let tempArray = $57e66c5a34f265b4$var$gTaskStr.split("^");
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        for(let i3 = 0; i3 < tempArray.length; i3++)detailTaskArray1.push($57e66c5a34f265b4$var$gTaskArray[parseInt(tempArray[i3])]);
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "step" || $57e66c5a34f265b4$var$gDetailSource === "activity" || $57e66c5a34f265b4$var$gDetailSource === "diagram" || $57e66c5a34f265b4$var$gDetailSource === "task" || $57e66c5a34f265b4$var$gDetailSource === "stepgrid" || $57e66c5a34f265b4$var$gDetailSource === "activitygrid" || $57e66c5a34f265b4$var$gDetailSource === "variantgrid") detailTaskArray1 = $57e66c5a34f265b4$var$gTaskArray;
    for(let i4 = 0; i4 < detailTaskArray1.length; i4++){
        if (detailTaskArray1[i4].filtered === 1) break;
        let validTask = true;
        if ($57e66c5a34f265b4$var$gDetailSource === "step") {
            validTask = false;
            for(let f = detailTaskArray1[i4].si; f < detailTaskArray1[i4].fi + 1; f++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f].f) === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom) && parseInt($57e66c5a34f265b4$var$gEventLogArray[f].t) === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) {
                for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "stepgrid") {
            validTask = false;
            for(let f1 = detailTaskArray1[i4].si; f1 < detailTaskArray1[i4].fi + 1; f1++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f1].f) === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom) && parseInt($57e66c5a34f265b4$var$gEventLogArray[f1].t) === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) {
                validTask = true;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "activity") {
            validTask = false;
            for(let f2 = detailTaskArray1[i4].si; f2 < detailTaskArray1[i4].fi + 1; f2++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f2].t) === parseInt($57e66c5a34f265b4$var$gDetailActivity)) {
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "task") {
            validTask = false;
            if (detailTaskArray1[i4].k === $57e66c5a34f265b4$var$gTaskID) validTask = true;
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "activitygrid") {
            validTask = false;
            for(let f3 = detailTaskArray1[i4].si; f3 < detailTaskArray1[i4].fi + 1; f3++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f3].t) === parseInt($57e66c5a34f265b4$var$gDetailActivity)) {
                validTask = true;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "diagram") {
            validTask = false;
            for(let f4 = detailTaskArray1[i4].si; f4 < detailTaskArray1[i4].fi + 1; f4++){
                for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j2++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j2].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "variantgrid") {
            validTask = false;
            if (detailTaskArray1[i4].v === $57e66c5a34f265b4$var$gDetailVariant) validTask = true;
        }
        if (validTask === true) detailTaskArray2.push(detailTaskArray1[i4]);
    }
    let endNode = 0;
    for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gActivityArray.length; j3++)if ($57e66c5a34f265b4$var$gActivityArray[j3].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j3].id;
    let eventArray = [];
    for(let i5 = 0; i5 < detailTaskArray2.length; i5++){
        // extract events based on detailTaskArray2
        if ($57e66c5a34f265b4$var$gDetailSource === "step" || $57e66c5a34f265b4$var$gDetailSource === "stepgrid") {
            for(let f5 = detailTaskArray2[i5].si; f5 < detailTaskArray2[i5].fi; f5++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f5].f) === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom) && parseInt($57e66c5a34f265b4$var$gEventLogArray[f5].t) === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) {
                eventArray.push($57e66c5a34f265b4$var$gEventLogArray[f5]);
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "activity" || $57e66c5a34f265b4$var$gDetailSource === "activitygrid") {
            for(let f6 = detailTaskArray2[i5].si; f6 < detailTaskArray2[i5].fi; f6++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f6].t) === parseInt($57e66c5a34f265b4$var$gDetailActivity)) {
                eventArray.push($57e66c5a34f265b4$var$gEventLogArray[f6]);
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "diagram" || $57e66c5a34f265b4$var$gDetailSource === "variantgrid" || $57e66c5a34f265b4$var$gDetailSource === "task" || $57e66c5a34f265b4$var$gDetailSource === "is_node" || $57e66c5a34f265b4$var$gDetailSource === "ia_node" || $57e66c5a34f265b4$var$gDetailSource === "dt_node") for(let f7 = detailTaskArray2[i5].si; f7 < detailTaskArray2[i5].fi; f7++)eventArray.push($57e66c5a34f265b4$var$gEventLogArray[f7]);
    }
    const rows = [];
    if ($57e66c5a34f265b4$var$gEventDetailExtract === "summary") {
        let eventAttribute = "";
        if ($57e66c5a34f265b4$var$gDetailEventSummaryAttribute == "") eventAttribute = "u"; // resource
        else if ($57e66c5a34f265b4$var$gDetailEventSummaryAttribute == "Resource") eventAttribute = "u";
        else {
            for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gEventAttributes.length; i6++)if ($57e66c5a34f265b4$var$gEventAttributes[i6].field == $57e66c5a34f265b4$var$gDetailEventSummaryAttribute) eventAttribute = $57e66c5a34f265b4$var$gEventAttributes[i6].id;
        }
        eventArray.sort((a, b)=>a[eventAttribute].localeCompare(b[eventAttribute]));
        let totalEvents = eventArray.length;
        let events = 0;
        let duration = 0;
        let min_duration = 999999999999;
        let max_duration = 0;
        let actual_cost = 0;
        let forecast_cost = 0;
        let compliant = 0;
        let automated = 0;
        let sdArray = [];
        let sd_seconds = 0;
        let attributeValue = "";
        let i7 = 0;
        for(i7 = 0; i7 < eventArray.length; i7++){
            if (i7 > 0 && eventArray[i7][eventAttribute] != attributeValue) {
                rows.push({
                    attribute: attributeValue,
                    events: events,
                    avg_duration: duration / events,
                    min_duration: min_duration,
                    max_duration: max_duration,
                    avg_duration_days: (Math.round(duration / events / 86400 * 100) / 100).toFixed(2),
                    avg_duration_hrs: (Math.round(duration / events / 3600 * 100) / 100).toFixed(2),
                    event_actual_cost: actual_cost / events,
                    event_forecast_cost: forecast_cost / events,
                    event_cost_savings: actual_cost / events - forecast_cost / events,
                    compliant: compliant,
                    automated: automated,
                    perc_events_compliant: compliant / events,
                    perc_events_automated: automated / events,
                    std_deviation: $57e66c5a34f265b4$var$getStandardDeviation(sdArray),
                    std_deviation_days: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 86400 * 100) / 100).toFixed(2),
                    std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 3600 * 100) / 100).toFixed(2),
                    perc_total_events: events / totalEvents
                });
                events = 0;
                duration = 0;
                min_duration = 999999999999;
                max_duration = 0;
                actual_cost = 0;
                forecast_cost = 0;
                compliant = 0;
                automated = 0;
                sdArray = [];
                sd_seconds = 0;
            }
            attributeValue = eventArray[i7][eventAttribute];
            events++;
            duration = duration + eventArray[i7].d;
            if (eventArray[i7].d < min_duration) min_duration = eventArray[i7].d;
            if (eventArray[i7].d > max_duration) max_duration = eventArray[i7].d;
            actual_cost = actual_cost + eventArray[i7].actual_cost;
            forecast_cost = forecast_cost + eventArray[i7].forecast_cost;
            compliant = compliant + eventArray[i7].compliant;
            automated = automated + eventArray[i7].automated;
            sdArray.push(parseInt(eventArray[i7].d));
        }
        if (i7 > 0) rows.push({
            attribute: attributeValue,
            events: events,
            avg_duration: duration / events,
            min_duration: min_duration,
            max_duration: max_duration,
            avg_duration_days: (Math.round(duration / events / 86400 * 100) / 100).toFixed(2),
            avg_duration_hrs: (Math.round(duration / events / 3600 * 100) / 100).toFixed(2),
            event_actual_cost: actual_cost / events,
            event_forecast_cost: forecast_cost / events,
            event_cost_savings: actual_cost / events - forecast_cost / events,
            compliant: compliant,
            automated: automated,
            perc_events_compliant: compliant / events,
            perc_events_automated: automated / events,
            std_deviation: $57e66c5a34f265b4$var$getStandardDeviation(sdArray),
            std_deviation_days: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 86400 * 100) / 100).toFixed(2),
            std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 3600 * 100) / 100).toFixed(2),
            perc_total_events: events / totalEvents
        });
        rows.sort((a, b)=>b.events > a.events ? 1 : -1);
    } else for(let i8 = 0; i8 < eventArray.length; i8++){
        let fromActivity = "";
        let toActivity = "";
        for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gActivityArray.length; j4++){
            if ($57e66c5a34f265b4$var$gActivityArray[j4].id == eventArray[i8].f) fromActivity = $57e66c5a34f265b4$var$gActivityArray[j4].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j4].id == eventArray[i8].t) toActivity = $57e66c5a34f265b4$var$gActivityArray[j4].activity;
        }
        let vtp = {};
        vtp[$57e66c5a34f265b4$var$gEntityUpper + " #"] = eventArray[i8].k;
        vtp["From Activity"] = fromActivity;
        vtp["To Activity"] = toActivity;
        vtp["Duration"] = eventArray[i8].d / 60;
        vtp["Timestamp"] = eventArray[i8].ts;
        vtp["Actual Cost"] = eventArray[i8].actual_cost;
        vtp["Forecast Cost"] = eventArray[i8].forecast_cost;
        vtp["Automated"] = eventArray[i8].automated;
        vtp["Compliant"] = eventArray[i8].compliant;
        for(let j5 = 0; j5 < $57e66c5a34f265b4$var$gEventAttributes.length; j5++)if ($57e66c5a34f265b4$var$gEventAttributes[j5].field == "Resource") vtp[$57e66c5a34f265b4$var$gEventAttributes[j5].field] = eventArray[i8].u;
        else vtp[$57e66c5a34f265b4$var$gEventAttributes[j5].field] = eventArray[i8][$57e66c5a34f265b4$var$gEventAttributes[j5].id];
        rows.push(vtp);
    }
    return rows;
}
function $57e66c5a34f265b4$export$51b3a147a1d97c17() {
    $57e66c5a34f265b4$var$gTaskSlicedArray = [];
    if ($57e66c5a34f265b4$var$gTasksVisualizationSource === "dt_node") $57e66c5a34f265b4$var$gTaskSlicedArray = $57e66c5a34f265b4$var$gDecompositionTreeTaskArray;
    if ($57e66c5a34f265b4$var$gTasksVisualizationSource === "is_node" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "ia_node") {
        let tempArray = $57e66c5a34f265b4$var$gTaskStr.split("^");
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        for(let i = 0; i < tempArray.length; i++)$57e66c5a34f265b4$var$gTaskSlicedArray.push($57e66c5a34f265b4$var$gTaskArray[parseInt(tempArray[i])]);
    }
}
function $57e66c5a34f265b4$export$a26c3f1d60196b1a() {
    if ($57e66c5a34f265b4$var$gTaskAttributes.length == 0) return [];
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    $57e66c5a34f265b4$var$gDetailDescription = "";
    if ($57e66c5a34f265b4$var$gDetailSource === "step" || $57e66c5a34f265b4$var$gDetailSource === "stepgrid") {
        let fromStr = "";
        let toStr = "";
        for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++){
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom)) fromStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) toStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
        }
        $57e66c5a34f265b4$var$gDetailDescription = "Step: " + fromStr + " - " + toStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "activity" || $57e66c5a34f265b4$var$gDetailSource === "activitygrid") {
        let activityStr = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gActivityArray.length; i1++)if ($57e66c5a34f265b4$var$gActivityArray[i1].id === parseInt($57e66c5a34f265b4$var$gDetailActivity)) activityStr = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        $57e66c5a34f265b4$var$gDetailDescription = "Activity: " + activityStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "variantgrid") {
        let variantStr = "";
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)if ($57e66c5a34f265b4$var$gVariantArray[i2].v === $57e66c5a34f265b4$var$gDetailVariant) variantStr = $57e66c5a34f265b4$var$gVariantArray[i2].n;
        $57e66c5a34f265b4$var$gDetailDescription = "Variant: " + variantStr;
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "diagram") $57e66c5a34f265b4$var$gDetailDescription = "Current variants in visualizer";
    if ($57e66c5a34f265b4$var$gDetailSource === "dt_node") $57e66c5a34f265b4$var$gDetailDescription = "Decomposition Tree";
    if ($57e66c5a34f265b4$var$gDetailSource === "ia_node") $57e66c5a34f265b4$var$gDetailDescription = "Influence Analysis";
    if ($57e66c5a34f265b4$var$gDetailSource === "is_node") $57e66c5a34f265b4$var$gDetailDescription = "Insights";
    let detailTaskArray1 = [];
    let detailTaskArray2 = [];
    if ($57e66c5a34f265b4$var$gDetailSource === "dt_node") detailTaskArray1 = $57e66c5a34f265b4$var$gDecompositionTreeTaskArray;
    if ($57e66c5a34f265b4$var$gDetailSource === "is_node" || $57e66c5a34f265b4$var$gDetailSource === "ia_node") {
        let tempArray = $57e66c5a34f265b4$var$gTaskStr.split("^");
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        for(let i3 = 0; i3 < tempArray.length; i3++)detailTaskArray1.push($57e66c5a34f265b4$var$gTaskArray[parseInt(tempArray[i3])]);
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "step" || $57e66c5a34f265b4$var$gDetailSource === "activity" || $57e66c5a34f265b4$var$gDetailSource === "diagram" || $57e66c5a34f265b4$var$gDetailSource === "stepgrid" || $57e66c5a34f265b4$var$gDetailSource === "activitygrid" || $57e66c5a34f265b4$var$gDetailSource === "variantgrid") detailTaskArray1 = $57e66c5a34f265b4$var$gTaskArray;
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered);
    for(let i4 = 0; i4 < detailTaskArray1.length; i4++){
        if (detailTaskArray1[i4].filtered === 1) break;
        let validTask = true;
        if ($57e66c5a34f265b4$var$gDetailSource === "step") {
            validTask = false;
            for(let f = detailTaskArray1[i4].si; f < detailTaskArray1[i4].fi + 1; f++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f].f) === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom) && parseInt($57e66c5a34f265b4$var$gEventLogArray[f].t) === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) {
                for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "stepgrid") {
            validTask = false;
            for(let f1 = detailTaskArray1[i4].si; f1 < detailTaskArray1[i4].fi + 1; f1++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f1].f) === parseInt($57e66c5a34f265b4$var$gDetailNodeFrom) && parseInt($57e66c5a34f265b4$var$gEventLogArray[f1].t) === parseInt($57e66c5a34f265b4$var$gDetailNodeTo)) {
                validTask = true;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "activity") {
            validTask = false;
            for(let f2 = detailTaskArray1[i4].si; f2 < detailTaskArray1[i4].fi + 1; f2++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f2].t) === parseInt($57e66c5a34f265b4$var$gDetailActivity)) {
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "activitygrid") {
            validTask = false;
            for(let f3 = detailTaskArray1[i4].si; f3 < detailTaskArray1[i4].fi + 1; f3++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[f3].t) === parseInt($57e66c5a34f265b4$var$gDetailActivity)) {
                validTask = true;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "diagram") {
            validTask = false;
            for(let f4 = detailTaskArray1[i4].si; f4 < detailTaskArray1[i4].fi + 1; f4++){
                for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j2++)if (detailTaskArray1[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j2].v) {
                    validTask = true;
                    break;
                }
                if (validTask == true) break;
            }
        }
        if ($57e66c5a34f265b4$var$gDetailSource === "variantgrid") {
            validTask = false;
            if (detailTaskArray1[i4].v === $57e66c5a34f265b4$var$gDetailVariant) validTask = true;
        }
        if (validTask === true) detailTaskArray2.push(detailTaskArray1[i4]);
    }
    const rows = [];
    if ($57e66c5a34f265b4$var$gTaskDetailExtract === "summary") {
        let taskAttribute = "";
        if ($57e66c5a34f265b4$var$gDetailTaskSummaryAttribute == "") taskAttribute = $57e66c5a34f265b4$var$gTaskAttributes[0].id;
        else {
            for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gTaskAttributes.length; i5++)if ($57e66c5a34f265b4$var$gTaskAttributes[i5].field == $57e66c5a34f265b4$var$gDetailTaskSummaryAttribute) taskAttribute = $57e66c5a34f265b4$var$gTaskAttributes[i5].id;
        }
        detailTaskArray2.sort((a, b)=>a[taskAttribute].localeCompare(b[taskAttribute]));
        let totalTasks = detailTaskArray2.length;
        let tasks = 0;
        let duration = 0;
        let min_duration = 999999999999;
        let max_duration = 0;
        let actual_cost = 0;
        let forecast_cost = 0;
        let compliant = 0;
        let automated = 0;
        let sdArray = [];
        let sd_seconds = 0;
        let attributeValue = "";
        let i6 = 0;
        for(i6 = 0; i6 < detailTaskArray2.length; i6++){
            if (i6 > 0 && detailTaskArray2[i6][taskAttribute] != attributeValue) {
                rows.push({
                    attribute: attributeValue,
                    tasks: tasks,
                    avg_duration: duration / tasks,
                    min_duration: min_duration,
                    max_duration: max_duration,
                    avg_duration_days: (Math.round(duration / tasks / 86400 * 100) / 100).toFixed(2),
                    avg_duration_hrs: (Math.round(duration / tasks / 3600 * 100) / 100).toFixed(2),
                    task_actual_cost: actual_cost / tasks,
                    task_forecast_cost: forecast_cost / tasks,
                    task_cost_savings: actual_cost / tasks - forecast_cost / tasks,
                    compliant: compliant,
                    automated: automated,
                    perc_tasks_compliant: compliant / tasks,
                    perc_tasks_automated: automated / tasks,
                    std_deviation: $57e66c5a34f265b4$var$getStandardDeviation(sdArray),
                    std_deviation_days: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 86400 * 100) / 100).toFixed(2),
                    std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 3600 * 100) / 100).toFixed(2),
                    perc_total_tasks: tasks / totalTasks
                });
                tasks = 0;
                duration = 0;
                min_duration = 999999999999;
                max_duration = 0;
                actual_cost = 0;
                forecast_cost = 0;
                compliant = 0;
                automated = 0;
                sdArray = [];
                sd_seconds = 0;
            }
            attributeValue = detailTaskArray2[i6][taskAttribute];
            tasks++;
            duration = duration + detailTaskArray2[i6].d;
            if (detailTaskArray2[i6].d < min_duration) min_duration = detailTaskArray2[i6].d;
            if (detailTaskArray2[i6].d > max_duration) max_duration = detailTaskArray2[i6].d;
            actual_cost = actual_cost + detailTaskArray2[i6].actual_cost;
            forecast_cost = forecast_cost + detailTaskArray2[i6].forecast_cost;
            compliant = compliant + detailTaskArray2[i6].compliant;
            automated = automated + detailTaskArray2[i6].automated;
            sdArray.push(parseInt(detailTaskArray2[i6].d));
        }
        if (i6 > 0) rows.push({
            attribute: attributeValue,
            tasks: tasks,
            min_duration: min_duration,
            max_duration: max_duration,
            perc_total_tasks: tasks / totalTasks,
            avg_duration: duration / tasks,
            avg_duration_days: (Math.round(duration / tasks / 86400 * 100) / 100).toFixed(2),
            avg_duration_hrs: (Math.round(duration / tasks / 3600 * 100) / 100).toFixed(2),
            task_actual_cost: actual_cost / tasks,
            task_forecast_cost: forecast_cost / tasks,
            task_cost_savings: actual_cost / tasks - forecast_cost / tasks,
            compliant: compliant,
            automated: automated,
            perc_tasks_compliant: compliant / tasks,
            perc_tasks_automated: automated / tasks,
            std_deviation_days: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 86400 * 100) / 100).toFixed(2),
            std_deviation_hrs: (Math.round($57e66c5a34f265b4$var$getStandardDeviation(sdArray) / 3600 * 100) / 100).toFixed(2),
            std_deviation: $57e66c5a34f265b4$var$getStandardDeviation(sdArray)
        });
        rows.sort((a, b)=>b.tasks > a.tasks ? 1 : -1);
    } else for(let i7 = 0; i7 < detailTaskArray2.length; i7++){
        let vtp = {};
        vtp[$57e66c5a34f265b4$var$gEntityUpper + " #"] = detailTaskArray2[i7].k;
        vtp["Create Time"] = detailTaskArray2[i7].t1;
        vtp["Close Time"] = detailTaskArray2[i7].t2;
        vtp["Duration"] = detailTaskArray2[i7].d / 60;
        vtp["Actual Cost"] = detailTaskArray2[i7].actual_cost;
        vtp["Forecast Cost"] = detailTaskArray2[i7].forecast_cost;
        vtp["Automated"] = detailTaskArray2[i7].automated;
        vtp["Compliant"] = detailTaskArray2[i7].compliant;
        for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gTaskAttributes.length; j3++)vtp[$57e66c5a34f265b4$var$gTaskAttributes[j3].field] = detailTaskArray2[i7][$57e66c5a34f265b4$var$gTaskAttributes[j3].id];
        vtp["vid"] = detailTaskArray2[i7].vid;
        vtp["id"] = detailTaskArray2[i7].id;
        vtp["k"] = detailTaskArray2[i7].k;
        rows.push(vtp);
    }
    return rows;
}
function $57e66c5a34f265b4$export$bb8cd829555465cc() {
    // populates Visuals -> Activities -> Variants
    let totalEvents = 0;
    let totalTasks = 0;
    let variants = [];
    if ($57e66c5a34f265b4$var$gDetailSource === "activity") {
        for(let i = 0; i < $57e66c5a34f265b4$var$gLinkArray.length; i++)if ($57e66c5a34f265b4$var$gDetailActivity == $57e66c5a34f265b4$var$gLinkArray[i].to && $57e66c5a34f265b4$var$gLinkArray[i].duplicate === false) {
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gLinkArray[i].variant == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                let variantExists = false;
                for(let k = 0; k < variants.length; k++)if (variants[k] == $57e66c5a34f265b4$var$gLinkArray[i].variant) {
                    variantExists = true;
                    break;
                }
                if (variantExists == false) variants.push($57e66c5a34f265b4$var$gLinkArray[i].variant);
            }
        }
    }
    if ($57e66c5a34f265b4$var$gDetailSource === "step") {
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gLinkArray.length; i1++)if ($57e66c5a34f265b4$var$gDetailNodeFrom == $57e66c5a34f265b4$var$gLinkArray[i1].from && $57e66c5a34f265b4$var$gDetailNodeTo == $57e66c5a34f265b4$var$gLinkArray[i1].to && $57e66c5a34f265b4$var$gLinkArray[i1].duplicate === false) {
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gLinkArray[i1].variant == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                let variantExists1 = false;
                for(let k1 = 0; k1 < variants.length; k1++)if (variants[k1] == $57e66c5a34f265b4$var$gLinkArray[i1].variant) {
                    variantExists1 = true;
                    break;
                }
                if (variantExists1 == false) variants.push($57e66c5a34f265b4$var$gLinkArray[i1].variant);
            }
        }
    }
    let variantArray = [];
    for(let i2 = 0; i2 < variants.length; i2++){
        for(let h = 0; h < $57e66c5a34f265b4$var$gVariantArray.length; h++)if ($57e66c5a34f265b4$var$gVariantArray[h].v == variants[i2] && $57e66c5a34f265b4$var$gVariantArray[h].sliced == true) {
            const valueToPush = {};
            valueToPush["variant_id"] = $57e66c5a34f265b4$var$gVariantArray[h].v;
            valueToPush["variant"] = $57e66c5a34f265b4$var$gVariantArray[h].n;
            valueToPush["sequence"] = $57e66c5a34f265b4$var$gVariantArray[h].s;
            valueToPush["tasks"] = $57e66c5a34f265b4$var$gVariantArray[h].t;
            valueToPush["avg_duration"] = $57e66c5a34f265b4$var$gVariantArray[h].ad;
            valueToPush["std_deviation"] = $57e66c5a34f265b4$var$gVariantArray[h].sd;
            valueToPush["min_duration"] = $57e66c5a34f265b4$var$gVariantArray[h].updateVariantMetrics;
            valueToPush["max_duration"] = $57e66c5a34f265b4$var$gVariantArray[h].max_duration;
            valueToPush["avg_duration_days"] = (Math.round($57e66c5a34f265b4$var$gVariantArray[h].ad / 86400 * 100) / 100).toFixed(2);
            valueToPush["avg_duration_hrs"] = (Math.round($57e66c5a34f265b4$var$gVariantArray[h].ad / 3600 * 100) / 100).toFixed(2);
            valueToPush["std_deviation_days"] = (Math.round($57e66c5a34f265b4$var$gVariantArray[h].sd / 86400 * 100) / 100).toFixed(2);
            valueToPush["std_deviation_hrs"] = (Math.round($57e66c5a34f265b4$var$gVariantArray[h].sd / 3600 * 100) / 100).toFixed(2);
            valueToPush["actual_cost"] = $57e66c5a34f265b4$var$gVariantArray[h].actual_cost / $57e66c5a34f265b4$var$gVariantArray[h].t;
            valueToPush["forecast_cost"] = $57e66c5a34f265b4$var$gVariantArray[h].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[h].t;
            valueToPush["loop"] = $57e66c5a34f265b4$var$gVariantArray[h].l;
            valueToPush["compliant"] = $57e66c5a34f265b4$var$gVariantArray[h].compliant;
            valueToPush["automated"] = $57e66c5a34f265b4$var$gVariantArray[h].automated;
            valueToPush["events"] = $57e66c5a34f265b4$var$gVariantArray[h].e;
            valueToPush["variant_id"] = $57e66c5a34f265b4$var$gVariantArray[h].v;
            valueToPush["steps"] = $57e66c5a34f265b4$var$gVariantArray[i2].steps, valueToPush["tasks_compliant"] = $57e66c5a34f265b4$var$gVariantArray[i2].compliant_tasks, valueToPush["tasks_automated"] = $57e66c5a34f265b4$var$gVariantArray[i2].automated_tasks, valueToPush["events_compliant"] = $57e66c5a34f265b4$var$gVariantArray[i2].compliant_events, valueToPush["events_automated"] = $57e66c5a34f265b4$var$gVariantArray[i2].automated_events, valueToPush["perc_tasks_compliant"] = $57e66c5a34f265b4$var$gVariantArray[i2].compliant_tasks / $57e66c5a34f265b4$var$gVariantArray[i2].t, valueToPush["perc_tasks_automated"] = $57e66c5a34f265b4$var$gVariantArray[i2].automated_tasks / $57e66c5a34f265b4$var$gVariantArray[i2].t, valueToPush["perc_events_compliant"] = $57e66c5a34f265b4$var$gVariantArray[i2].compliant_events / $57e66c5a34f265b4$var$gVariantArray[i2].e, valueToPush["perc_events_automated"] = $57e66c5a34f265b4$var$gVariantArray[i2].automated_events / $57e66c5a34f265b4$var$gVariantArray[i2].e, valueToPush["task_actual_cost"] = $57e66c5a34f265b4$var$gVariantArray[i2].actual_cost / $57e66c5a34f265b4$var$gVariantArray[i2].t, valueToPush["task_forecast_cost"] = $57e66c5a34f265b4$var$gVariantArray[i2].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[i2].t, valueToPush["task_cost_savings"] = $57e66c5a34f265b4$var$gVariantArray[i2].actual_cost / $57e66c5a34f265b4$var$gVariantArray[i2].t - $57e66c5a34f265b4$var$gVariantArray[i2].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[i2].t, valueToPush["variant_actual_cost"] = $57e66c5a34f265b4$var$gVariantArray[i2].actual_cost, valueToPush["variant_forecast_cost"] = $57e66c5a34f265b4$var$gVariantArray[i2].forecast_cost, valueToPush["variant_cost_savings"] = $57e66c5a34f265b4$var$gVariantArray[i2].actual_cost - $57e66c5a34f265b4$var$gVariantArray[i2].forecast_cost, variantArray.push(valueToPush);
            totalTasks = totalTasks + $57e66c5a34f265b4$var$gVariantArray[h].t;
            totalEvents = totalEvents + $57e66c5a34f265b4$var$gVariantArray[h].e;
            break;
        }
    }
    const rows = [];
    for(let i3 = 0; i3 < variantArray.length; i3++)rows.push({
        sequence: variantArray[i3].sequence,
        variant: variantArray[i3].variant,
        tasks: variantArray[i3].tasks,
        events: variantArray[i3].events,
        steps: variantArray[i3].steps,
        perc_total_tasks: variantArray[i3].tasks / totalTasks,
        avg_duration: variantArray[i3].avg_duration,
        min_duration: variantArray[i3].min_duration,
        max_duration: variantArray[i3].max_duration,
        std_deviation: variantArray[i3].std_deviation,
        loop: variantArray[i3].l,
        compliant: variantArray[i3].compliant,
        automated: variantArray[i3].automated,
        task_actual_cost: variantArray[i3].task_actual_cost,
        task_forecast_cost: variantArray[i3].task_forecast_cost,
        task_cost_savings: variantArray[i3].task_cost_savings,
        variant_actual_cost: variantArray[i3].variant_actual_cost,
        variant_forecast_cost: variantArray[i3].variant_forecast_cost,
        variant_cost_savings: variantArray[i3].variant_cost_savings,
        perc_total_events: variantArray[i3].events / totalEvents,
        avg_duration_days: variantArray[i3].avg_duration_days,
        std_deviation_days: variantArray[i3].std_deviation_days,
        avg_duration_hrs: variantArray[i3].avg_duration_hrs,
        std_deviation_hrs: variantArray[i3].std_deviation_hrs,
        variant_id: variantArray[i3].variant_id,
        perc_tasks_compliant: variantArray[i3].perc_tasks_automated,
        perc_tasks_automated: variantArray[i3].perc_tasks_compliant,
        perc_events_compliant: variantArray[i3].perc_events_compliant,
        perc_events_automated: variantArray[i3].perc_events_automated,
        events_compliant: variantArray[i3].events_compliant,
        tasks_compliant: variantArray[i3].tasks_compliant,
        events_automated: variantArray[i3].events_automated,
        tasks_automated: variantArray[i3].tasks_automated,
        actual_cost: variantArray[i3].actual_cost,
        forecast_cost: variantArray[i3].forecast_cost
    });
    return rows;
}
function $57e66c5a34f265b4$export$21918ebac693e83e() {
    let resourceArray = [];
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.f - b.f || a.t - b.t || a.v - b.v);
    let tEventLogArray = [];
    // filter eventlog array
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].t == gActivity) {
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) tEventLogArray.push($57e66c5a34f265b4$var$gEventLogArray[i]);
        }
    }
    tEventLogArray.sort((a, b)=>a.u.localeCompare(b.u) || a.k.localeCompare(b.k));
    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let duration_seconds = 0;
    let sd_seconds = 0;
    let from = "";
    let to = "";
    let resource = "";
    let min_duration = 1000000000;
    let max_duration = 0;
    for(let i1 = 0; i1 < tEventLogArray.length; i1++){
        if (i1 == 0) {
            tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i1].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i1].d));
        } else if (tEventLogArray[i1 - 1].u != tEventLogArray[i1].u) {
            let valueToPush = {};
            valueToPush["resource"] = tEventLogArray[i1 - 1].u.toString();
            valueToPush["tasks"] = tasks;
            sd_seconds = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
            valueToPush["duration"] = duration_seconds;
            valueToPush["avg_duration"] = duration_seconds / tasks;
            valueToPush["min_duration"] = min_duration;
            valueToPush["max_duration"] = max_duration;
            valueToPush["std_deviation"] = sd_seconds;
            valueToPush["avg_duration_days"] = (Math.round(duration_seconds / 86400 / tasks * 100) / 100).toFixed(2);
            valueToPush["std_deviation_days"] = (Math.round(sd_seconds / 86400 * 100) / 100).toFixed(2);
            valueToPush["avg_duration_hrs"] = (Math.round(duration_seconds / 3600 / tasks * 100) / 100).toFixed(2);
            valueToPush["std_deviation_hrs"] = (Math.round(sd_seconds / 3600 * 100) / 100).toFixed(2);
            resourceArray.push(valueToPush);
            tasks = 1;
            sdArray = [];
            sdArray.length = 0;
            sdArray.push(parseInt(tEventLogArray[i1].d));
            duration_seconds = parseInt(tEventLogArray[i1].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
        } else {
            if (tEventLogArray[i1 - 1].k != tEventLogArray[i1].k) tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i1].d);
            if (duration_seconds < min_duration) min_duration = duration_seconds;
            if (duration_seconds > max_duration) max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i1].d));
        }
        if (i1 == tEventLogArray.length - 1) {
            from = tEventLogArray[i1].f;
            to = tEventLogArray[i1].t;
            resource = tEventLogArray[i1].u;
        }
    }
    if (resource != "") {
        let valueToPush1 = {};
        valueToPush1["resource"] = resource;
        valueToPush1["tasks"] = tasks;
        sd_seconds = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
        valueToPush1["avg_duration"] = duration_seconds / tasks;
        valueToPush1["min_duration"] = min_duration;
        valueToPush1["max_duration"] = max_duration;
        valueToPush1["std_deviation"] = sd_seconds;
        valueToPush1["avg_duration_days"] = (Math.round(duration_seconds / 86400 / tasks * 100) / 100).toFixed(2);
        valueToPush1["std_deviation_days"] = (Math.round(sd_seconds / 86400 * 100) / 100).toFixed(2);
        valueToPush1["avg_duration_hrs"] = (Math.round(duration_seconds / 3600 / tasks * 100) / 100).toFixed(2);
        valueToPush1["std_deviation_hrs"] = (Math.round(sd_seconds / 3600 * 100) / 100).toFixed(2);
        resourceArray.push(valueToPush1);
    }
    const rows = [];
    for(let i2 = 0; i2 < resourceArray.length; i2++)if (resourceArray[i2].resource != "") rows.push({
        resource: resourceArray[i2].resource,
        tasks: resourceArray[i2].tasks,
        avg_duration: resourceArray[i2].avg_duration,
        min_duration: resourceArray[i2].min_duration,
        max_duration: resourceArray[i2].max_duration,
        std_deviation: resourceArray[i2].std_deviation,
        avg_duration_days: resourceArray[i2].avg_duration_days,
        std_deviation_days: resourceArray[i2].std_deviation_days,
        avg_duration_hrs: resourceArray[i2].avg_duration_hrs,
        std_deviation_hrs: resourceArray[i2].std_deviation_hrs
    });
    return rows;
}
function $57e66c5a34f265b4$export$4b36481b9a609630() {
    let rows = [];
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered);
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].t == gActivity) {
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                // variant activity combination exists
                // custom attributes
                const valueToPush = {};
                valueToPush["Resource"] = $57e66c5a34f265b4$var$gEventLogArray[i].u;
                valueToPush["Task"] = $57e66c5a34f265b4$var$gEventLogArray[i].k;
                valueToPush["Timestamp"] = $57e66c5a34f265b4$var$gEventLogArray[i].ts;
                for(let z = 0; z < $57e66c5a34f265b4$var$gTaskAttributes.length; z++){
                    let key = "ta" + z;
                    valueToPush[$57e66c5a34f265b4$var$gTaskAttributes[z].field] = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i].tid][key];
                }
                valueToPush["Duration"] = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i].tid].d / 60;
                valueToPush["Variant"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i].vid].n;
                valueToPush["Events"] = 1;
                rows.push(valueToPush);
            }
        }
    }
    rows.sort((a, b)=>b.t > a.t);
    return rows;
}
function $57e66c5a34f265b4$export$708b4eb9f2d5b387() {
    let rows = [];
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered);
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].f == $57e66c5a34f265b4$var$gDetailNodeFrom && $57e66c5a34f265b4$var$gEventLogArray[i].t == $57e66c5a34f265b4$var$gDetailNodeTo) {
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                const valueToPush = {};
                valueToPush["Resource"] = $57e66c5a34f265b4$var$gEventLogArray[i].u;
                valueToPush["Task"] = $57e66c5a34f265b4$var$gEventLogArray[i].k;
                valueToPush["Timestamp"] = $57e66c5a34f265b4$var$gEventLogArray[i].ts;
                for(let z = 0; z < $57e66c5a34f265b4$var$gActivityArray.length; z++)if ($57e66c5a34f265b4$var$gEventLogArray[i].t == $57e66c5a34f265b4$var$gActivityArray[z].a) {
                    valueToPush["Activity"] = $57e66c5a34f265b4$var$gActivityArray[z].activity;
                    break;
                }
                for(let z1 = 0; z1 < $57e66c5a34f265b4$var$gTaskAttributes.length; z1++){
                    let key = "ta" + z1;
                    valueToPush[$57e66c5a34f265b4$var$gTaskAttributes[z1].field] = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i].tid][key];
                }
                valueToPush["Duration"] = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i].tid].d / 60;
                valueToPush["Variant"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i].vid].n;
                valueToPush["Events"] = 1;
                rows.push(valueToPush);
            }
        }
    }
    rows.sort((a, b)=>b.t > a.t);
    return rows;
}
function $57e66c5a34f265b4$export$6ecb20fefc654519() {
    let resourceArray = [];
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.v - b.v);
    let tEventLogArray = [];
    // filter eventlog array
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].f == $57e66c5a34f265b4$var$gDetailNodeFrom && $57e66c5a34f265b4$var$gEventLogArray[i].t == $57e66c5a34f265b4$var$gDetailNodeTo) {
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) tEventLogArray.push($57e66c5a34f265b4$var$gEventLogArray[i]);
        }
    }
    tEventLogArray.sort((a, b)=>a.u.localeCompare(b.u) || a.k.localeCompare(b.k));
    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let duration_seconds = 0;
    let sd_seconds = 0;
    let from = "";
    let to = "";
    let resource = "";
    let min_duration = 1000000000;
    let max_duration = 0;
    for(let i1 = 0; i1 < tEventLogArray.length; i1++){
        if (i1 == 0) {
            tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i1].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i1].d));
        } else if (tEventLogArray[i1 - 1].u != tEventLogArray[i1].u) {
            let valueToPush = {};
            valueToPush["resource"] = tEventLogArray[i1 - 1].u.toString();
            valueToPush["tasks"] = tasks;
            sd_seconds = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
            valueToPush["avg_duration"] = duration_seconds / tasks;
            valueToPush["min_duration"] = min_duration;
            valueToPush["max_duration"] = max_duration;
            valueToPush["std_deviation"] = sd_seconds;
            valueToPush["avg_duration_days"] = (Math.round(duration_seconds / 86400 / tasks * 100) / 100).toFixed(2);
            valueToPush["std_deviation_days"] = (Math.round(sd_seconds / 86400 * 100) / 100).toFixed(2);
            valueToPush["avg_duration_hrs"] = (Math.round(duration_seconds / 3600 / tasks * 100) / 100).toFixed(2);
            valueToPush["std_deviation_hrs"] = (Math.round(sd_seconds / 3600 * 100) / 100).toFixed(2);
            resourceArray.push(valueToPush);
            tasks = 1;
            sdArray = [];
            sdArray.length = 0;
            sdArray.push(parseInt(tEventLogArray[i1].d));
            duration_seconds = parseInt(tEventLogArray[i1].d);
            min_duration = duration_seconds;
            max_duration = duration_seconds;
        } else {
            if (tEventLogArray[i1 - 1].k != tEventLogArray[i1].k) tasks++;
            duration_seconds = duration_seconds + parseInt(tEventLogArray[i1].d);
            if (duration_seconds < min_duration) min_duration = duration_seconds;
            if (duration_seconds > max_duration) max_duration = duration_seconds;
            sdArray.push(parseInt(tEventLogArray[i1].d));
        }
        if (i1 == tEventLogArray.length - 1) {
            from = tEventLogArray[i1].f;
            to = tEventLogArray[i1].t;
            resource = tEventLogArray[i1].u;
        }
    }
    if (resource != "") {
        let valueToPush1 = {};
        valueToPush1["resource"] = resource;
        valueToPush1["tasks"] = tasks;
        sd_seconds = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
        valueToPush1["avg_duration"] = duration_seconds / tasks;
        valueToPush1["min_duration"] = min_duration;
        valueToPush1["max_duration"] = max_duration;
        valueToPush1["std_deviation"] = sd_seconds;
        valueToPush1["avg_duration_days"] = (Math.round(duration_seconds / 86400 / tasks * 100) / 100).toFixed(2);
        valueToPush1["std_deviation_days"] = (Math.round(sd_seconds / 86400 * 100) / 100).toFixed(2);
        valueToPush1["avg_duration_hrs"] = (Math.round(duration_seconds / 3600 / tasks * 100) / 100).toFixed(2);
        valueToPush1["std_deviation_hrs"] = (Math.round(sd_seconds / 3600 * 100) / 100).toFixed(2);
        resourceArray.push(valueToPush1);
    }
    const rows = [];
    for(let i2 = 0; i2 < resourceArray.length; i2++)if (resourceArray[i2].resource != "") rows.push({
        resource: resourceArray[i2].resource,
        tasks: resourceArray[i2].tasks,
        avg_duration: resourceArray[i2].avg_duration,
        min_duration: resourceArray[i2].min_duration,
        max_duration: resourceArray[i2].max_duration,
        std_deviation: resourceArray[i2].std_deviation,
        avg_duration_days: resourceArray[i2].avg_duration_days,
        std_deviation_days: resourceArray[i2].std_deviation_days,
        avg_duration_hrs: resourceArray[i2].avg_duration_hrs,
        std_deviation_hrs: resourceArray[i2].std_deviation_hrs
    });
    return rows;
}
function $57e66c5a34f265b4$export$57dfa740d03fd9ef() {
    let variantArray = [];
    let gVariantsTasksSelected = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantPaneVariants.length; i++){
        for(let j = 0; j < $57e66c5a34f265b4$var$gVariantArray.length; j++)if ($57e66c5a34f265b4$var$gVariantArray[j].v == $57e66c5a34f265b4$var$gVariantPaneVariants[i].v && $57e66c5a34f265b4$var$gVariantArray[j].sliced == true) {
            gVariantsTasksSelected = gVariantsTasksSelected + $57e66c5a34f265b4$var$gVariantArray[j].t;
            variantArray.push($57e66c5a34f265b4$var$gVariantArray[j]);
        }
    }
    variantArray.sort((a, b)=>b.t > a.t ? 1 : -1);
    return variantArray;
}
const $57e66c5a34f265b4$export$90ea4ab1b8b43ea5 = (selection)=>{
    $57e66c5a34f265b4$var$gVariantPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gIsolateVariant = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = 0;
    $57e66c5a34f265b4$var$gLifecycleVariant = 0;
    $57e66c5a34f265b4$var$gDiagramPVTasks = 0;
    $57e66c5a34f265b4$var$gDiagramPVEvents = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = "";
    let variantID;
    let variant = "";
    let variantSequence = "";
    let variantIndex = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gVariantArray.length; j++)$57e66c5a34f265b4$var$gVariantArray[j].selected = 0;
    for(let i = 0; i < selection.length; i++){
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantArray.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[j1].s == selection[i].sequence && $57e66c5a34f265b4$var$gVariantArray[j1].sliced == true) {
            $57e66c5a34f265b4$var$gVariantArray[j1].selected = 1;
            variantID = $57e66c5a34f265b4$var$gVariantArray[j1].v;
            variant = $57e66c5a34f265b4$var$gVariantArray[j1].n;
            variantSequence = $57e66c5a34f265b4$var$gVariantArray[j1].s;
            variantIndex = $57e66c5a34f265b4$var$gVariantArray[j1].id;
            $57e66c5a34f265b4$var$gDiagramPVTasks = $57e66c5a34f265b4$var$gDiagramPVTasks + $57e66c5a34f265b4$var$gVariantArray[j1].t;
            $57e66c5a34f265b4$var$gDiagramPVEvents = $57e66c5a34f265b4$var$gDiagramPVEvents + $57e66c5a34f265b4$var$gVariantArray[j1].e;
            break;
        }
        const valueToPush = {};
        valueToPush["v"] = variantID;
        valueToPush["n"] = variant;
        valueToPush["s"] = variantSequence;
        valueToPush["id"] = variantIndex;
        $57e66c5a34f265b4$var$gVariantPaneVariants.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gDiagramPVVariants = $57e66c5a34f265b4$var$gVariantPaneVariants.length;
};
const $57e66c5a34f265b4$export$a5d14cad26556b17 = ()=>{
    $57e66c5a34f265b4$var$gVariantPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gIsolateVariant = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = 0;
    $57e66c5a34f265b4$var$gLifecycleVariant = 0;
    $57e66c5a34f265b4$var$gDiagramPVTasks = 0;
    $57e66c5a34f265b4$var$gDiagramPVEvents = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = "";
    let variantID;
    let variant = "";
    let variantSequence = "";
    let variantIndex = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gVariantArray.length; j++)$57e66c5a34f265b4$var$gVariantArray[j].selected = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gDetailTaskVariantsSelected.length; i++){
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantArray.length; j1++)if ($57e66c5a34f265b4$var$gVariantArray[j1].id == $57e66c5a34f265b4$var$gDetailTaskVariantsSelected[i].vid && $57e66c5a34f265b4$var$gVariantArray[j1].sliced == true) {
            $57e66c5a34f265b4$var$gVariantArray[j1].selected = 1;
            variantID = $57e66c5a34f265b4$var$gVariantArray[j1].v;
            variant = $57e66c5a34f265b4$var$gVariantArray[j1].n;
            variantSequence = $57e66c5a34f265b4$var$gVariantArray[j1].s;
            variantIndex = $57e66c5a34f265b4$var$gVariantArray[j1].id;
            $57e66c5a34f265b4$var$gDiagramPVTasks = $57e66c5a34f265b4$var$gDiagramPVTasks + $57e66c5a34f265b4$var$gVariantArray[j1].t;
            $57e66c5a34f265b4$var$gDiagramPVEvents = $57e66c5a34f265b4$var$gDiagramPVEvents + $57e66c5a34f265b4$var$gVariantArray[j1].e;
            break;
        }
        const valueToPush = {};
        valueToPush["v"] = variantID;
        valueToPush["n"] = variant;
        valueToPush["s"] = variantSequence;
        valueToPush["id"] = variantIndex;
        $57e66c5a34f265b4$var$gVariantPaneVariants.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gDiagramPVVariants = $57e66c5a34f265b4$var$gVariantPaneVariants.length;
};
const $57e66c5a34f265b4$export$f39f7d9ecc34d6d6 = (pane)=>{
    $57e66c5a34f265b4$var$gVariantPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gIsolateVariant = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = 0;
    $57e66c5a34f265b4$var$gLifecycleVariant = 0;
    $57e66c5a34f265b4$var$gDiagramPVTasks = 0;
    $57e66c5a34f265b4$var$gDiagramPVEvents = 0;
    $57e66c5a34f265b4$var$gAnimateVariant = "";
    let variantID;
    let variant = "";
    let variantSequence = "";
    let variantIndex = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gVariantArray.length; j++)$57e66c5a34f265b4$var$gVariantArray[j].selected = 0;
    let selected = 0;
    for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantArray.length; j1++){
        let validVariant = false;
        if (pane == "Steps" || pane == "StepsDiagram") {
            for(let k = 0; k < $57e66c5a34f265b4$var$gStepPaneVariants.length; k++)if ($57e66c5a34f265b4$var$gStepPaneVariants[k].v === $57e66c5a34f265b4$var$gVariantArray[j1].v) {
                validVariant = true;
                break;
            }
        }
        if (pane == "Activities" || pane === "ActivitiesDiagram") {
            for(let k1 = 0; k1 < $57e66c5a34f265b4$var$gActivityPaneVariants.length; k1++)if ($57e66c5a34f265b4$var$gActivityPaneVariants[k1].v === $57e66c5a34f265b4$var$gVariantArray[j1].v) {
                validVariant = true;
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gVariantArray[j1].sliced == true && validVariant === true) {
            $57e66c5a34f265b4$var$gVariantArray[j1].selected = 1;
            variantID = $57e66c5a34f265b4$var$gVariantArray[j1].v;
            variant = $57e66c5a34f265b4$var$gVariantArray[j1].n;
            variantSequence = $57e66c5a34f265b4$var$gVariantArray[j1].s;
            variantIndex = $57e66c5a34f265b4$var$gVariantArray[j1].id;
            $57e66c5a34f265b4$var$gDiagramPVTasks = $57e66c5a34f265b4$var$gDiagramPVTasks + $57e66c5a34f265b4$var$gVariantArray[j1].t;
            $57e66c5a34f265b4$var$gDiagramPVEvents = $57e66c5a34f265b4$var$gDiagramPVEvents + $57e66c5a34f265b4$var$gVariantArray[j1].e;
            const valueToPush = {};
            valueToPush["v"] = variantID;
            valueToPush["n"] = variant;
            valueToPush["s"] = variantSequence;
            valueToPush["id"] = variantIndex;
            $57e66c5a34f265b4$var$gVariantPaneVariants.push(valueToPush);
            selected++;
        }
        if (selected >= $57e66c5a34f265b4$var$gDefaultVariantsSelected) break;
    }
    $57e66c5a34f265b4$var$gDiagramPVVariants = $57e66c5a34f265b4$var$gVariantPaneVariants.length;
};
function $57e66c5a34f265b4$export$aa53ae1ab6407f1e() {
    let tasks;
    let tasksTotal;
    let events;
    let eventsTotal;
    let variants;
    let variantsTotal;
    let steps;
    let stepsTotal;
    let activities;
    let activitiesTotal;
    let nonCompliantVariants;
    let nonCompliantTasks;
    let nonCompliantEvents;
    let automatedVariants;
    let automatedTasks;
    let automatedEvents;
    let percCostSaving;
    let costSavings;
    let actualCost;
    let forecastCost;
    let gaugePercTasks;
    let gaugePercEvents;
    let gaugeXofYVariants;
    let gaugeXofYSteps;
    let gaugeXofYActivities;
    let gaugeXofYVariantsCompliant;
    let gaugeXofYTasksCompliant;
    let gaugeXofYEventsCompliant;
    let gaugePercVariantsCompliant;
    let gaugePercTasksCompliant;
    let gaugePercEventsCompliant;
    let gaugeXofYVariantsAutomated;
    let gaugeXofYTasksAutomated;
    let gaugeXofYEventsAutomated;
    let gaugePercVariantsAutomated;
    let gaugePercTasksAutomated;
    let gaugePercEventsAutomated;
    let gaugePercCostSaving;
    let gaugeAvgCostSavingPerTask;
    let gaugeAvgCostPerTask;
    let gaugeCostSaving;
    let gaugeActualCost;
    let gaugeForecastCost;
    events = $57e66c5a34f265b4$var$gDiagramPVEvents;
    eventsTotal = $57e66c5a34f265b4$var$gVariantEventsSliced;
    tasks = $57e66c5a34f265b4$var$gDiagramPVTasks;
    tasksTotal = $57e66c5a34f265b4$var$gVariantTasksSliced;
    variants = $57e66c5a34f265b4$var$gDiagramPVVariants;
    variantsTotal = $57e66c5a34f265b4$var$gVariants;
    steps = $57e66c5a34f265b4$var$gDiagramPVSteps;
    stepsTotal = $57e66c5a34f265b4$var$gVariantStepsSliced;
    activities = $57e66c5a34f265b4$var$gDiagramPVActivities;
    activitiesTotal = $57e66c5a34f265b4$var$gVariantActivitiesSliced;
    nonCompliantVariants = $57e66c5a34f265b4$var$gNonCompliantVariants;
    nonCompliantTasks = $57e66c5a34f265b4$var$gNonCompliantTasks;
    nonCompliantEvents = $57e66c5a34f265b4$var$gNonCompliantEvents;
    automatedVariants = $57e66c5a34f265b4$var$gAutomatedVariants;
    automatedTasks = $57e66c5a34f265b4$var$gAutomatedTasks;
    automatedEvents = $57e66c5a34f265b4$var$gAutomatedEvents;
    percCostSaving = $57e66c5a34f265b4$var$gPercCostSaving;
    costSavings = $57e66c5a34f265b4$var$gCostSaving;
    actualCost = $57e66c5a34f265b4$var$gActualCost;
    forecastCost = $57e66c5a34f265b4$var$gForecastCost;
    gaugePercTasks = $57e66c5a34f265b4$var$gGaugePercTasks;
    gaugePercEvents = $57e66c5a34f265b4$var$gGaugePercEvents;
    gaugeXofYVariants = $57e66c5a34f265b4$var$gGaugeXofYVariants;
    gaugeXofYSteps = $57e66c5a34f265b4$var$gGaugeXofYSteps;
    gaugeXofYActivities = $57e66c5a34f265b4$var$gGaugeXofYActivities;
    gaugeXofYVariantsCompliant = $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant;
    gaugeXofYTasksCompliant = $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant;
    gaugeXofYEventsCompliant = $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant;
    gaugePercVariantsCompliant = $57e66c5a34f265b4$var$gGaugePercVariantsCompliant;
    gaugePercTasksCompliant = $57e66c5a34f265b4$var$gGaugePercTasksCompliant;
    gaugePercEventsCompliant = $57e66c5a34f265b4$var$gGaugePercEventsCompliant;
    gaugeXofYVariantsAutomated = $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated;
    gaugeXofYTasksAutomated = $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated;
    gaugeXofYEventsAutomated = $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated;
    gaugePercVariantsAutomated = $57e66c5a34f265b4$var$gGaugePercVariantsAutomated;
    gaugePercTasksAutomated = $57e66c5a34f265b4$var$gGaugePercTasksAutomated;
    gaugePercEventsAutomated = $57e66c5a34f265b4$var$gGaugePercEventsAutomated;
    gaugePercCostSaving = $57e66c5a34f265b4$var$gGaugePercCostSaving;
    gaugeAvgCostSavingPerTask = $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask;
    gaugeAvgCostPerTask = $57e66c5a34f265b4$var$gGaugeAvgCostPerTask;
    gaugeCostSaving = $57e66c5a34f265b4$var$gGaugeCostSaving;
    gaugeActualCost = $57e66c5a34f265b4$var$gGaugeActualCost;
    gaugeForecastCost = $57e66c5a34f265b4$var$gGaugeForecastCost;
    return {
        events: events,
        eventsTotal: eventsTotal,
        tasks: tasks,
        tasksTotal: tasksTotal,
        variants: variants,
        variantsTotal: variantsTotal,
        steps: steps,
        stepsTotal: stepsTotal,
        activities: activities,
        activitiesTotal: activitiesTotal,
        nonCompliantVariants: nonCompliantVariants,
        nonCompliantTasks: nonCompliantTasks,
        nonCompliantEvents: nonCompliantEvents,
        automatedVariants: automatedVariants,
        automatedTasks: automatedTasks,
        automatedEvents: automatedEvents,
        percCostSaving: percCostSaving,
        costSavings: costSavings,
        actualCost: actualCost,
        forecastCost: forecastCost,
        gaugePercTasks: gaugePercTasks,
        gaugePercEvents: gaugePercEvents,
        gaugeXofYVariants: gaugeXofYVariants,
        gaugeXofYSteps: gaugeXofYSteps,
        gaugeXofYActivities: gaugeXofYActivities,
        gaugeXofYVariantsCompliant: gaugeXofYVariantsCompliant,
        gaugeXofYTasksCompliant: gaugeXofYTasksCompliant,
        gaugeXofYEventsCompliant: gaugeXofYEventsCompliant,
        gaugePercVariantsCompliant: gaugePercVariantsCompliant,
        gaugePercTasksCompliant: gaugePercTasksCompliant,
        gaugePercEventsCompliant: gaugePercEventsCompliant,
        gaugeXofYVariantsAutomated: gaugeXofYVariantsAutomated,
        gaugeXofYTasksAutomated: gaugeXofYTasksAutomated,
        gaugeXofYEventsAutomated: gaugeXofYEventsAutomated,
        gaugePercVariantsAutomated: gaugePercVariantsAutomated,
        gaugePercTasksAutomated: gaugePercTasksAutomated,
        gaugePercEventsAutomated: gaugePercEventsAutomated,
        gaugePercCostSaving: gaugePercCostSaving,
        gaugeAvgCostSavingPerTask: gaugeAvgCostSavingPerTask,
        gaugeAvgCostPerTask: gaugeAvgCostPerTask,
        gaugeCostSaving: gaugeCostSaving,
        gaugeActualCost: gaugeActualCost,
        gaugeForecastCost: gaugeForecastCost
    };
}
function $57e66c5a34f265b4$export$8eb7811c9b2b6f81() {
    let tempArray = [];
    let valueToPush = {};
    valueToPush["gaugePercTasks"] = $57e66c5a34f265b4$var$gGaugePercTasks;
    valueToPush["gaugePercEvents"] = $57e66c5a34f265b4$var$gGaugePercEvents;
    valueToPush["gaugeXofYVariants"] = $57e66c5a34f265b4$var$gGaugeXofYVariants;
    valueToPush["gaugeXofYSteps"] = $57e66c5a34f265b4$var$gGaugeXofYSteps;
    valueToPush["gaugeXofYActivities"] = $57e66c5a34f265b4$var$gGaugeXofYActivities;
    valueToPush["gaugeXofYVariantsCompliant"] = $57e66c5a34f265b4$var$gGaugeXofYVariantsCompliant;
    valueToPush["gaugeXofYTasksCompliant"] = $57e66c5a34f265b4$var$gGaugeXofYTasksCompliant;
    valueToPush["gaugeXofYEventsCompliant"] = $57e66c5a34f265b4$var$gGaugeXofYEventsCompliant;
    valueToPush["gaugePercVariantsCompliant"] = $57e66c5a34f265b4$var$gGaugePercVariantsCompliant;
    valueToPush["gaugePercTasksCompliant"] = $57e66c5a34f265b4$var$gGaugePercTasksCompliant;
    valueToPush["gaugePercEventsCompliant"] = $57e66c5a34f265b4$var$gGaugePercEventsCompliant;
    valueToPush["gaugeXofYVariantsAutomated"] = $57e66c5a34f265b4$var$gGaugeXofYVariantsAutomated;
    valueToPush["gaugeXofYTasksAutomated"] = $57e66c5a34f265b4$var$gGaugeXofYTasksAutomated;
    valueToPush["gaugeXofYEventsAutomated"] = $57e66c5a34f265b4$var$gGaugeXofYEventsAutomated;
    valueToPush["gaugePercVariantsAutomated"] = $57e66c5a34f265b4$var$gGaugePercVariantsAutomated;
    valueToPush["gaugePercTasksAutomated"] = $57e66c5a34f265b4$var$gGaugePercTasksAutomated;
    valueToPush["gaugePercEventsAutomated"] = $57e66c5a34f265b4$var$gGaugePercEventsAutomated;
    valueToPush["gaugePercCostSaving"] = $57e66c5a34f265b4$var$gGaugePercCostSaving;
    valueToPush["gaugeAvgCostSavingPerTask"] = $57e66c5a34f265b4$var$gGaugeAvgCostSavingPerTask;
    valueToPush["gaugeAvgCostPerTask"] = $57e66c5a34f265b4$var$gGaugeAvgCostPerTask;
    valueToPush["gaugeCostSaving"] = $57e66c5a34f265b4$var$gGaugeCostSaving;
    valueToPush["gaugeActualCost"] = $57e66c5a34f265b4$var$gGaugeActualCost;
    valueToPush["gaugeForecastCost"] = $57e66c5a34f265b4$var$gGaugeForecastCost;
    tempArray.push(valueToPush);
    return tempArray;
}
function $57e66c5a34f265b4$export$3e8f7c388b06760b() {
    const rows = [];
    rows.push({
        events: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gEventsAll),
        tasks: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gTasksAll),
        variants: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantsAll),
        activities: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gActivitiesAll),
        steps: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gStepsAll)
    });
    rows.push({
        events: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gEventsFiltered),
        tasks: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gTasksFiltered),
        variants: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantsFiltered),
        activities: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gActivitiesFiltered),
        steps: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gStepsFiltered)
    });
    rows.push({
        events: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantEventsSliced),
        tasks: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantTasksSliced),
        variants: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantsSliced),
        activities: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantActivitiesSliced),
        steps: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gVariantStepsSliced)
    });
    rows.push({
        events: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gDiagramPVEvents),
        tasks: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gDiagramPVTasks),
        variants: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gDiagramPVVariants),
        activities: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gDiagramPVActivities),
        steps: $57e66c5a34f265b4$export$a2db1876938cd11d($57e66c5a34f265b4$var$gDiagramPVSteps)
    });
    return rows;
}
const $57e66c5a34f265b4$export$6c7d33759b17fb35 = (selection)=>{
    $57e66c5a34f265b4$var$gSelectedProcessSteps.length = 0;
    if (selection.length == 0) return;
    for(let i = 0; i < selection.length; i++){
        let from_activity = "";
        let to_activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].from_activity) from_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].to_activity) to_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
        }
        const valueToPush = {};
        valueToPush["from_activity"] = from_activity;
        valueToPush["to_activity"] = to_activity;
        $57e66c5a34f265b4$var$gSelectedProcessSteps.push(valueToPush);
    }
};
const $57e66c5a34f265b4$export$9345c9210e8d8347 = (selection)=>{
    $57e66c5a34f265b4$var$gSelectedProcessSteps.length = 0;
    if (selection.length == 0) return;
    for(let i = 0; i < selection.length; i++){
        let from_activity = "";
        let to_activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].from_activity) from_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].to_activity) to_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
        }
        const valueToPush = {};
        valueToPush["from_activity"] = from_activity;
        valueToPush["to_activity"] = to_activity;
        $57e66c5a34f265b4$var$gSelectedProcessSteps.push(valueToPush);
    }
};
function $57e66c5a34f265b4$var$filterTasks_NTV() {
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilters.length; i++)if ($57e66c5a34f265b4$var$gFilters[i].type == "ntv") $57e66c5a34f265b4$var$gFilters.splice(i, 1);
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        if (parseInt($57e66c5a34f265b4$var$gVariantArray[i1].t) >= parseInt($57e66c5a34f265b4$var$gMinVariantTasks) && parseInt($57e66c5a34f265b4$var$gVariantArray[i1].t) <= parseInt($57e66c5a34f265b4$var$gMaxVariantTasks) && $57e66c5a34f265b4$var$gVariantArray[i1].filtered != 1) for(let t = 0; t < $57e66c5a34f265b4$var$gTaskArray.length; t++){
            if ($57e66c5a34f265b4$var$gTaskArray[t].vid == $57e66c5a34f265b4$var$gVariantArray[i1].id) for(let f = $57e66c5a34f265b4$var$gTaskArray[t].si; f < $57e66c5a34f265b4$var$gTaskArray[t].fi + 1; f++){
                let valueToPush = {};
                valueToPush["type"] = "variants_tasks";
                valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
                valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[f].elid;
                $57e66c5a34f265b4$var$gFilters.push(valueToPush);
            }
        }
    }
}
function $57e66c5a34f265b4$var$filterTasks_NAT() {
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilters.length; i++)if ($57e66c5a34f265b4$var$gFilters[i].type == "nat") $57e66c5a34f265b4$var$gFilters.splice(i, 1);
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        if (parseInt($57e66c5a34f265b4$var$gTaskArray[i1].a) >= parseInt($57e66c5a34f265b4$var$gTaskActivitiesFrom) && parseInt($57e66c5a34f265b4$var$gTaskArray[i1].a) <= parseInt($57e66c5a34f265b4$var$gTaskActivitiesTo) && $57e66c5a34f265b4$var$gTaskArray[i1].filtered != 1) for(let j = $57e66c5a34f265b4$var$gTaskArray[i1].si; j < $57e66c5a34f265b4$var$gTaskArray[i1].fi + 1; j++){
            let valueToPush = {};
            valueToPush["type"] = "task_activities";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[j].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$filterTasks_TD() {
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilters.length; i++)if ($57e66c5a34f265b4$var$gFilters[i].type == "td") $57e66c5a34f265b4$var$gFilters.splice(i, 1);
    let duration = 0.0;
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        duration = $57e66c5a34f265b4$var$gTaskArray[i1].d / 60.0;
        if (parseInt(duration) >= parseInt($57e66c5a34f265b4$var$gTaskDurationFrom) && parseInt(duration) <= parseInt($57e66c5a34f265b4$var$gTaskDurationTo) && $57e66c5a34f265b4$var$gTaskArray[i1].filtered != 1) for(let j = $57e66c5a34f265b4$var$gTaskArray[i1].si; j < $57e66c5a34f265b4$var$gTaskArray[i1].fi + 1; j++){
            let valueToPush = {};
            valueToPush["type"] = "task_duration";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[j].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$filterTime() {
    // remove existing
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilters.length; i++)if ($57e66c5a34f265b4$var$gFilters[i].type == "task_time") $57e66c5a34f265b4$var$gFilters.splice(i, 1);
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        let year = $57e66c5a34f265b4$var$gTaskArray[i1].t1.substr(0, 4);
        let month = parseInt($57e66c5a34f265b4$var$gTaskArray[i1].t1.substr(5, 2)) - 1;
        let day = $57e66c5a34f265b4$var$gTaskArray[i1].t1.substr(8, 2);
        let tempDate = new Date(year, month, day);
        let validRec = true;
        if ($57e66c5a34f265b4$var$gFromTime > tempDate) validRec = false;
        if ($57e66c5a34f265b4$var$gToTime < tempDate) validRec = false;
        if (validRec == true) for(let j = $57e66c5a34f265b4$var$gTaskArray[i1].si; j < $57e66c5a34f265b4$var$gTaskArray[i1].fi + 1; j++){
            let valueToPush = {};
            valueToPush["type"] = "task_time";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[j].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$filterAttributesTasks() {
    let id = "";
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskAttributes.length; i++)if ($57e66c5a34f265b4$var$gTaskAttributes[i].field == $57e66c5a34f265b4$var$gAttribute) id = $57e66c5a34f265b4$var$gTaskAttributes[i].id;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gFilters.length; i1++)if ($57e66c5a34f265b4$var$gFilters[i1].type == "task_attribute" && $57e66c5a34f265b4$var$gFilters[i1].attribute == id) $57e66c5a34f265b4$var$gFilters.splice(i1, 1);
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gTaskArray.length; i2++){
        let validRec = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gSelectedAttributes.length; j++)if ($57e66c5a34f265b4$var$gTaskArray[i2][id] == $57e66c5a34f265b4$var$gSelectedAttributes[j].value) {
            validRec = true;
            break;
        }
        if (validRec == true) for(let j1 = $57e66c5a34f265b4$var$gTaskArray[i2].si; j1 <= $57e66c5a34f265b4$var$gTaskArray[i2].fi; j1++){
            let valueToPush = {};
            valueToPush["type"] = "task_attribute";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["attribute"] = id;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[j1].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$filterAttributesEvents() {
    let id = "";
    if ($57e66c5a34f265b4$var$gAttribute == "Resource") id = "u";
    else {
        for(let i = 0; i < $57e66c5a34f265b4$var$gEventAttributes.length; i++)if ($57e66c5a34f265b4$var$gEventAttributes[i].field == $57e66c5a34f265b4$var$gAttribute) id = $57e66c5a34f265b4$var$gEventAttributes[i].id;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gFilters.length; i1++)if ($57e66c5a34f265b4$var$gFilters[i1].type == "event_attribute" && $57e66c5a34f265b4$var$gFilters[i1].attribute == id) $57e66c5a34f265b4$var$gFilters.splice(i1, 1);
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        let validRec = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gSelectedAttributes.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i2][id] == $57e66c5a34f265b4$var$gSelectedAttributes[j].value) {
            validRec = true;
            break;
        }
        if (validRec == true) {
            let valueToPush = {};
            valueToPush["type"] = "event_attribute";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["attribute"] = id;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[i2].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$filterMetrics() {
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilters.length; i++)if ($57e66c5a34f265b4$var$gFilters[i].type == "metric") $57e66c5a34f265b4$var$gFilters.splice(i, 1);
    let metricType;
    let metricKey;
    let id = "";
    for (const each of $57e66c5a34f265b4$var$gMetricArray)if (each.m === $57e66c5a34f265b4$var$gMetricFilter.metric) {
        metricType = each.t;
        metricKey = "m" + each.id;
        id = each.id;
    }
    // true_false, amount, duration
    $57e66c5a34f265b4$var$gFilterSets++;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    let tTaskMetricArray = [];
    tTaskMetricArray.length = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        let validRec = false;
        let value = Number($57e66c5a34f265b4$var$gTaskArray[i1][metricKey]);
        if (metricType == "true_false") {
            if (value == 1 && $57e66c5a34f265b4$var$gMetricFilter.checkboxValue == true) validRec = true;
            if (value == 0 && $57e66c5a34f265b4$var$gMetricFilter.checkboxValue == false) validRec = true;
        }
        if (metricType == "amount") {
            if (value > $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "greater than") validRec = true;
            if (value >= $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "greater than or is") validRec = true;
            if (value < $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "less than") validRec = true;
            if (value <= $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "less than or is") validRec = true;
            if (value == $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "is") validRec = true;
            if (value != $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "is not") validRec = true;
        }
        if (metricType == "duration") {
            if ($57e66c5a34f265b4$var$gMetricFilter.timeUnit == "minutes") value = value / 60;
            if ($57e66c5a34f265b4$var$gMetricFilter.timeUnit == "hours") value = value / 3600;
            if ($57e66c5a34f265b4$var$gMetricFilter.timeUnit == "days") value = value / 86400;
            if (value > $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "greater than") validRec = true;
            if (value >= $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "greater than or is") validRec = true;
            if (value < $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "less than") validRec = true;
            if (value <= $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "less than or is") validRec = true;
            if (value == $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "is") validRec = true;
            if (value != $57e66c5a34f265b4$var$gMetricFilter.numberValue && $57e66c5a34f265b4$var$gMetricFilter.operator == "is not") validRec = true;
        }
        if (validRec == true) for(let j = $57e66c5a34f265b4$var$gTaskArray[i1].si; j <= $57e66c5a34f265b4$var$gTaskArray[i1].fi; j++){
            let valueToPush = {};
            valueToPush["type"] = "task_metric";
            valueToPush["filter_number"] = $57e66c5a34f265b4$var$gFilterSets;
            valueToPush["attribute"] = metricKey;
            valueToPush["id"] = $57e66c5a34f265b4$var$gEventLogArray[j].elid;
            $57e66c5a34f265b4$var$gFilters.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$var$updateVariantMetrics() {
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v || a.k.localeCompare(b.k) || a.s - b.s);
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        $57e66c5a34f265b4$var$gVariantArray[i].filtered = 1;
        $57e66c5a34f265b4$var$gVariantArray[i].s = i + 1;
    }
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    let sdArray = [];
    sdArray.length = 0;
    let tasks = 0;
    let events = 0;
    let duration = 0;
    let variant = "";
    let i1 = 0;
    for(i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        if ($57e66c5a34f265b4$var$gTaskArray[i1].filtered == 1) break;
        $57e66c5a34f265b4$var$gTaskArray[i1].compliant = true;
        $57e66c5a34f265b4$var$gTaskArray[i1].automated = false;
        $57e66c5a34f265b4$var$gTaskArray[i1].filtered = 0;
        $57e66c5a34f265b4$var$gTaskArray[i1].actual_cost = 0;
        $57e66c5a34f265b4$var$gTaskArray[i1].forecast_cost = 0;
        if (i1 == 0) {
            tasks++;
            events = $57e66c5a34f265b4$var$gTaskArray[i1].fi - $57e66c5a34f265b4$var$gTaskArray[i1].si;
            duration = parseInt($57e66c5a34f265b4$var$gTaskArray[i1].d);
            sdArray.push(parseInt($57e66c5a34f265b4$var$gTaskArray[i1].d));
            variant = $57e66c5a34f265b4$var$gTaskArray[i1].v;
        } else {
            if ($57e66c5a34f265b4$var$gTaskArray[i1 - 1].v != $57e66c5a34f265b4$var$gTaskArray[i1].v) {
                let ad = duration / tasks;
                let sd = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].ad = ad;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].sd = sd;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].t = tasks;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].e = events;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].filtered = 0;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant = true;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated = false;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant_tasks = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].t;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant_events = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].e;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated_tasks = 0;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated_events = 0;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].actual_cost = 0;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].forecast_cost = 0;
                $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].sliced = true;
                tasks = 0;
                events = 0;
                sdArray.length = 0;
                duration = 0;
                variant = $57e66c5a34f265b4$var$gTaskArray[i1].v;
            }
            tasks++;
            events = events + (events = $57e66c5a34f265b4$var$gTaskArray[i1].fi - $57e66c5a34f265b4$var$gTaskArray[i1].si);
            duration = duration + parseInt($57e66c5a34f265b4$var$gTaskArray[i1].d);
            sdArray.push(parseInt($57e66c5a34f265b4$var$gTaskArray[i1].d));
        }
    }
    if (i1 > 0) {
        if ($57e66c5a34f265b4$var$gTaskArray[i1 - 1].filtered == 0) {
            let ad1 = duration / tasks;
            let sd1 = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].ad = ad1;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].sd = sd1;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].t = tasks;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].e = events;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].filtered = 0;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant = true;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated = false;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant_tasks = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].t;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].compliant_events = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].e;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated_tasks = 0;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].automated_events = 0;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].actual_cost = 0;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].forecast_cost = 0;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].sliced = true;
        }
    }
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>b.t - a.t);
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)$57e66c5a34f265b4$var$gVariantArray[i2].s = i2 + 1;
}
function $57e66c5a34f265b4$var$filterArrays() {
    let endNode = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].end_node == true) {
        endNode = parseInt($57e66c5a34f265b4$var$gActivityArray[j].id);
        break;
    }
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    // figure out how many filter sets an event is in
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++)$57e66c5a34f265b4$var$gEventLogArray[i].filtered = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++)$57e66c5a34f265b4$var$gTaskArray[i1].filtered = 1;
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gFilters.length; i2++)if (parseInt($57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gFilters[i2].id].t) != endNode) $57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gFilters[i2].id].filtered++;
    // has to be in all filter sets to survive, else filtered = 1
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gEventLogArray.length; i3++)if ($57e66c5a34f265b4$var$gEventLogArray[i3].filtered == $57e66c5a34f265b4$var$gFilterSets) $57e66c5a34f265b4$var$gEventLogArray[i3].filtered = 0;
    else $57e66c5a34f265b4$var$gEventLogArray[i3].filtered = 1;
    // if any event for a task not filtered, then the task is set to not filtered
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gTaskArray.length; i4++){
        for(let k = parseInt($57e66c5a34f265b4$var$gTaskArray[i4].si); k <= parseInt($57e66c5a34f265b4$var$gTaskArray[i4].fi - 1); k++)if ($57e66c5a34f265b4$var$gEventLogArray[k].filtered == 0) {
            $57e66c5a34f265b4$var$gTaskArray[i4].filtered = 0;
            break;
        }
        if ($57e66c5a34f265b4$var$gAttributeType == "Event") {
            if ($57e66c5a34f265b4$var$gTaskArray[i4].filtered == 0) for(let k1 = parseInt($57e66c5a34f265b4$var$gTaskArray[i4].si); k1 <= parseInt($57e66c5a34f265b4$var$gTaskArray[i4].fi - 1); k1++)$57e66c5a34f265b4$var$gEventLogArray[k1].filtered = 0;
        }
    }
    // reset filter globals
    $57e66c5a34f265b4$var$gTasksFilterActive_NTV = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_NAT = false;
    $57e66c5a34f265b4$var$gTasksFilterActive_TD = false;
    $57e66c5a34f265b4$var$gFromTime = new Date();
    $57e66c5a34f265b4$var$gToTime = new Date(1900, 1);
    $57e66c5a34f265b4$var$gAttribute = "";
    $57e66c5a34f265b4$var$gAttributeType = "";
    $57e66c5a34f265b4$var$gMetricFilter = "";
}
const $57e66c5a34f265b4$export$c7e705c07d100697 = ()=>{
    $57e66c5a34f265b4$export$59798dda46c3d2b5(false, false, "regenerate");
};
function $57e66c5a34f265b4$export$59798dda46c3d2b5(applyFilters, firstBuild, source) {
    let startTime = Date.now();
    if (firstBuild == true) $57e66c5a34f265b4$var$updateVariantMetrics();
    if (applyFilters == true) {
        $57e66c5a34f265b4$var$filterArrays();
        $57e66c5a34f265b4$var$updateVariantMetrics();
        if ($57e66c5a34f265b4$var$gCostRules.length > 0) $57e66c5a34f265b4$var$updateCostMetrics("generateArrays");
        if ($57e66c5a34f265b4$var$gComplianceRules.length > 0) $57e66c5a34f265b4$var$updateComplianceMetrics();
        if ($57e66c5a34f265b4$var$gAutomationRules.length > 0) $57e66c5a34f265b4$var$updateAutomationMetrics();
    }
    $57e66c5a34f265b4$var$gLinkArray.length = 0;
    let variant_id = 0;
    let variant_sequence = 0;
    let tasks = 0;
    let duration = 0;
    let variant = "";
    let from_activity = "";
    let to_activity = "";
    let start = false;
    let end = false;
    let validRec = true;
    let compliant = 0;
    let automated = 0;
    let loops = 0;
    let min_duration = 1000000000;
    let max_duration = 0;
    let startNode = 0;
    let endNode = 0;
    let fromNodeLabel = "";
    let toNodeLabel = "";
    let sdArray = [];
    let actual_cost = 0;
    let forecast_cost = 0;
    sdArray.length = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].start_node == true) startNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
        if ($57e66c5a34f265b4$var$gActivityArray[j].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
    }
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v || a.s - b.s);
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length + 1; i++){
        if (i < $57e66c5a34f265b4$var$gEventLogArray.length && $57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if (i == 0) {
            tasks = 1;
            compliant = 0;
            automated = 0;
            actual_cost = 0;
            forecast_cost = 0;
            min_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            max_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d));
            duration = duration + parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            loops = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i].loop == true) loops++;
            if ($57e66c5a34f265b4$var$gEventLogArray[i].duplicate == false) {
                if ($57e66c5a34f265b4$var$gEventLogArray[i].compliant == true) compliant++;
                if ($57e66c5a34f265b4$var$gEventLogArray[i].automated == true) automated++;
            }
        } else if (i < $57e66c5a34f265b4$var$gEventLogArray.length && ($57e66c5a34f265b4$var$gEventLogArray[i - 1].s != $57e66c5a34f265b4$var$gEventLogArray[i].s || $57e66c5a34f265b4$var$gEventLogArray[i - 1].v != $57e66c5a34f265b4$var$gEventLogArray[i].v) || i == $57e66c5a34f265b4$var$gEventLogArray.length) {
            /*
                // optimise:  store labels in gEventLogArray
                for (let j = 0; j < gActivityArray.length; j++) {
                    if (gActivityArray[j].id == gEventLogArray[i - 1].f) {fromNodeLabel = gActivityIndexArray[j].activity; break;}
                }
                for (let j = 0; j < gActivityArray.length; j++) {
                    if (gActivityArray[j].id == gEventLogArray[i - 1].t) {toNodeLabel = gActivityArray[j].activity; break;}
                }

                */ fromNodeLabel = $57e66c5a34f265b4$var$gActivityArray[$57e66c5a34f265b4$var$gEventLogArray[i - 1].f].activity;
            toNodeLabel = $57e66c5a34f265b4$var$gActivityArray[$57e66c5a34f265b4$var$gEventLogArray[i - 1].t].activity;
            start = false;
            end = false;
            if ($57e66c5a34f265b4$var$gEventLogArray[i - 1].f == startNode) start = true;
            if ($57e66c5a34f265b4$var$gEventLogArray[i - 1].t == endNode) end = true;
            let valueToPush = {};
            valueToPush["from"] = $57e66c5a34f265b4$var$gEventLogArray[i - 1].f;
            valueToPush["to"] = $57e66c5a34f265b4$var$gEventLogArray[i - 1].t;
            valueToPush["from_label"] = fromNodeLabel;
            valueToPush["to_label"] = toNodeLabel;
            valueToPush["variant"] = $57e66c5a34f265b4$var$gEventLogArray[i - 1].v;
            valueToPush["start_node"] = start;
            valueToPush["end_node"] = end;
            valueToPush["sort_key"] = $57e66c5a34f265b4$var$gEventLogArray[i - 1].s;
            valueToPush["variant_id"] = $57e66c5a34f265b4$var$gEventLogArray[i - 1].vid;
            valueToPush["variant_sequence"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i - 1].vid].s;
            if (loops > 0) valueToPush["loop"] = true;
            else valueToPush["loop"] = false;
            valueToPush["tasks"] = tasks;
            valueToPush["compliant"] = compliant;
            valueToPush["automated"] = automated;
            valueToPush["actual_cost"] = actual_cost;
            valueToPush["forecast_cost"] = forecast_cost;
            valueToPush["duration"] = duration;
            if (min_duration < 0) min_duration = 0;
            valueToPush["min_duration"] = min_duration;
            valueToPush["max_duration"] = max_duration;
            valueToPush["width"] = 1;
            valueToPush["dashes"] = false;
            valueToPush["cost"] = 0;
            valueToPush["sd_array"] = sdArray;
            if ($57e66c5a34f265b4$var$gEventLogArray[i - 1].duplicate === false) {
                valueToPush["visible"] = true;
                valueToPush["duplicate"] = false;
            } else {
                valueToPush["visible"] = false;
                valueToPush["duplicate"] = true;
            }
            $57e66c5a34f265b4$var$gLinkArray.push(valueToPush);
            if (i < $57e66c5a34f265b4$var$gEventLogArray.length) {
                tasks = 0;
                compliant = 0;
                automated = 0;
                sdArray = [];
                sdArray.length = 0;
                min_duration = 1000000000;
                max_duration = 0;
                loops = 0;
                if ($57e66c5a34f265b4$var$gEventLogArray[i].loop == true) loops++;
                tasks++;
                duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
                sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d));
                if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d) < min_duration) min_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
                if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d) > max_duration) max_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
                if ($57e66c5a34f265b4$var$gEventLogArray[i].compliant == true) compliant++;
                if ($57e66c5a34f265b4$var$gEventLogArray[i].automated == true) automated++;
                actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost;
                forecast_cost = $57e66c5a34f265b4$var$gEventLogArray[i].forecast_cost;
            }
        } else {
            tasks++;
            duration = duration + parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d));
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d) < min_duration) min_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d) > max_duration) max_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].d);
            if ($57e66c5a34f265b4$var$gEventLogArray[i].compliant == true) compliant++;
            if ($57e66c5a34f265b4$var$gEventLogArray[i].automated == true) automated++;
            actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost + actual_cost;
            forecast_cost = $57e66c5a34f265b4$var$gEventLogArray[i].forecast_cost + forecast_cost;
            if ($57e66c5a34f265b4$var$gEventLogArray[i].loop == true) loops++;
            from_activity = $57e66c5a34f265b4$var$gEventLogArray[i].f;
            to_activity = $57e66c5a34f265b4$var$gEventLogArray[i].t;
            variant = $57e66c5a34f265b4$var$gEventLogArray[i].v;
            variant_id = $57e66c5a34f265b4$var$gEventLogArray[i].vid;
            variant_sequence = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i].vid].s;
        }
    }
    if (validRec == true) {
        // will never be a duplicate
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == from_activity) {
            fromNodeLabel = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
            break;
        }
        for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gActivityArray.length; j2++)if ($57e66c5a34f265b4$var$gActivityArray[j2].id == to_activity) {
            toNodeLabel = $57e66c5a34f265b4$var$gActivityArray[j2].activity;
            break;
        }
        let valueToPush1 = {};
        valueToPush1["from"] = from_activity;
        valueToPush1["to"] = to_activity;
        valueToPush1["from_label"] = fromNodeLabel;
        valueToPush1["to_label"] = toNodeLabel;
        valueToPush1["variant"] = variant;
        valueToPush1["width"] = 1;
        valueToPush1["start_node"] = start;
        valueToPush1["end_node"] = end;
        valueToPush1["compliant"] = compliant;
        valueToPush1["visible"] = true;
        valueToPush1["cost"] = 0;
        valueToPush1["dashes"] = false;
        valueToPush1["tasks"] = tasks;
        valueToPush1["compliant"] = compliant;
        valueToPush1["automated"] = automated;
        valueToPush1["actual_cost"] = actual_cost;
        valueToPush1["forecast_cost"] = forecast_cost;
        valueToPush1["duration"] = duration;
        valueToPush1["min_duration"] = min_duration;
        valueToPush1["max_duration"] = max_duration;
        valueToPush1["sd_array"] = sdArray;
        valueToPush1["variant_id"] = variant_id;
        valueToPush1["variant_sequence"] = variant_sequence;
        if (loops > 0) valueToPush1["loop"] = true;
        else valueToPush1["loop"] = false;
        $57e66c5a34f265b4$var$gLinkArray.push(valueToPush1);
    }
    // update variant array with min/max duration
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered || a.vid - b.vid);
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    variant_id = -1;
    min_duration = 1000000000000;
    max_duration = 0;
    let i1 = 0;
    for(i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
        if ($57e66c5a34f265b4$var$gTaskArray[i1].filtered == 1) break;
        if (i1 > 0 && variant_id != $57e66c5a34f265b4$var$gTaskArray[i1].vid) {
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].min_duration = min_duration;
            $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1 - 1].vid].max_duration = max_duration;
            min_duration = 1000000000000;
            max_duration = 0;
        }
        if ($57e66c5a34f265b4$var$gTaskArray[i1].d < min_duration) min_duration = $57e66c5a34f265b4$var$gTaskArray[i1].d;
        if ($57e66c5a34f265b4$var$gTaskArray[i1].d > max_duration) max_duration = $57e66c5a34f265b4$var$gTaskArray[i1].d;
        variant_id = $57e66c5a34f265b4$var$gTaskArray[i1].vid;
    }
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gTaskArray.length - 1].vid].min_duration = min_duration;
    $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gTaskArray.length - 1].vid].max_duration = max_duration;
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.f - b.f || a.t - b.t || a.k.localeCompare(b.k));
    $57e66c5a34f265b4$var$gStepArray = [];
    sdArray.length = 0;
    let events = 1;
    tasks = 0;
    duration = 0;
    min_duration = 1000000000;
    max_duration = 0;
    end = false;
    compliant = false;
    let from = "";
    let to = "";
    let events_compliant = 0;
    let events_automated = 0;
    compliant = 0;
    actual_cost = 0;
    forecast_cost = 0;
    i1 = 0;
    for(i1 = 0; i1 < $57e66c5a34f265b4$var$gEventLogArray.length; i1++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i1].filtered == 1) break;
        if (i1 == 0) {
            duration = duration + parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d);
            sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d));
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d) < min_duration) min_duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d;
            if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d) > max_duration) max_duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d;
            loops = 0;
            from = $57e66c5a34f265b4$var$gEventLogArray[i1].f;
            to = $57e66c5a34f265b4$var$gEventLogArray[i1].t;
            actual_cost = actual_cost + $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
            forecast_cost = forecast_cost + $57e66c5a34f265b4$var$gEventLogArray[i1].forecast_cost;
            events_automated = $57e66c5a34f265b4$var$gEventLogArray[i1].automated;
            events_compliant = $57e66c5a34f265b4$var$gEventLogArray[i1].compliant;
        } else {
            if ($57e66c5a34f265b4$var$gEventLogArray[i1 - 1].f != $57e66c5a34f265b4$var$gEventLogArray[i1].f || $57e66c5a34f265b4$var$gEventLogArray[i1 - 1].t != $57e66c5a34f265b4$var$gEventLogArray[i1].t || $57e66c5a34f265b4$var$gEventLogArray[i1 - 1].k != $57e66c5a34f265b4$var$gEventLogArray[i1].k) tasks++;
            if ($57e66c5a34f265b4$var$gEventLogArray[i1 - 1].f != $57e66c5a34f265b4$var$gEventLogArray[i1].f || $57e66c5a34f265b4$var$gEventLogArray[i1 - 1].t != $57e66c5a34f265b4$var$gEventLogArray[i1].t) {
                let valueToPush2 = {};
                valueToPush2["from"] = $57e66c5a34f265b4$var$gEventLogArray[i1 - 1].f.toString();
                valueToPush2["to"] = $57e66c5a34f265b4$var$gEventLogArray[i1 - 1].t.toString();
                valueToPush2["events"] = events;
                valueToPush2["tasks"] = tasks;
                valueToPush2["duration"] = duration;
                valueToPush2["avg_duration"] = duration / events;
                valueToPush2["min_duration"] = min_duration;
                valueToPush2["max_duration"] = max_duration;
                valueToPush2["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
                if (events_compliant != events) valueToPush2["compliant"] = false;
                else valueToPush2["compliant"] = true;
                if (events_automated != events) valueToPush2["automated"] = false;
                else valueToPush2["automated"] = true;
                valueToPush2["events_compliant"] = events_compliant;
                valueToPush2["events_automated"] = events_automated;
                valueToPush2["actual_cost"] = actual_cost;
                valueToPush2["forecast_cost"] = forecast_cost;
                if ($57e66c5a34f265b4$var$gEventLogArray[i1 - 1].filtered == 1) valueToPush2["filtered"] = 1;
                else valueToPush2["filtered"] = 0;
                if (loops > 0) valueToPush2["loop"] = true;
                else valueToPush2["loop"] = false;
                $57e66c5a34f265b4$var$gStepArray.push(valueToPush2);
                events = 1;
                tasks = 0;
                events_automated = $57e66c5a34f265b4$var$gEventLogArray[i1].automated;
                events_compliant = $57e66c5a34f265b4$var$gEventLogArray[i1].compliant;
                sdArray.length = 0;
                sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d));
                duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d);
                min_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d);
                max_duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d);
                actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
                forecast_cost = $57e66c5a34f265b4$var$gEventLogArray[i1].forecast_cost;
                loops = 0;
                if ($57e66c5a34f265b4$var$gEventLogArray[i1].loop == true) loops++;
            } else {
                events_automated = events_automated + $57e66c5a34f265b4$var$gEventLogArray[i1].automated;
                events_compliant = events_compliant + $57e66c5a34f265b4$var$gEventLogArray[i1].compliant;
                actual_cost = actual_cost + $57e66c5a34f265b4$var$gEventLogArray[i1].actual_cost;
                forecast_cost = forecast_cost + $57e66c5a34f265b4$var$gEventLogArray[i1].forecast_cost;
                events++;
                duration = duration + parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d);
                sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d));
                if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d) < min_duration) min_duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d;
                if (parseInt($57e66c5a34f265b4$var$gEventLogArray[i1].d) > max_duration) max_duration = $57e66c5a34f265b4$var$gEventLogArray[i1].d;
                if ($57e66c5a34f265b4$var$gEventLogArray[i1].loop == true) loops++;
                from = $57e66c5a34f265b4$var$gEventLogArray[i1].f;
                to = $57e66c5a34f265b4$var$gEventLogArray[i1].t;
            }
        }
    }
    if (i1 > 0) {
        let valueToPush3 = {};
        valueToPush3["from"] = from;
        valueToPush3["to"] = to;
        if (loops > 0) valueToPush3["loop"] = true;
        else valueToPush3["loop"] = false;
        valueToPush3["events"] = events;
        valueToPush3["tasks"] = tasks;
        valueToPush3["duration"] = duration;
        valueToPush3["avg_duration"] = duration / events;
        valueToPush3["min_duration"] = min_duration;
        valueToPush3["max_duration"] = max_duration;
        if (events_compliant != events) valueToPush3["compliant"] = false;
        else valueToPush3["compliant"] = true;
        if (events_automated != events) valueToPush3["automated"] = false;
        else valueToPush3["automated"] = true;
        valueToPush3["events_compliant"] = events_compliant;
        valueToPush3["events_automated"] = events_automated;
        valueToPush3["actual_cost"] = actual_cost;
        valueToPush3["forecast_cost"] = forecast_cost;
        if ($57e66c5a34f265b4$var$gEventLogArray[i1 - 1].filtered == 1) valueToPush3["filtered"] = 1;
        else valueToPush3["filtered"] = 0;
        valueToPush3["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
        $57e66c5a34f265b4$var$gStepArray.push(valueToPush3);
    }
    // update ActivityArray
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.t - b.t || a.k.localeCompare(b.k));
    tasks = 0;
    events = 0;
    compliant = 0;
    automated = 0;
    actual_cost = 0;
    forecast_cost = 0;
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if (i2 == 0) {
            tasks++;
            actual_cost = actual_cost + $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost;
            forecast_cost = forecast_cost + $57e66c5a34f265b4$var$gEventLogArray[i2].forecast_cost;
            automated = automated + $57e66c5a34f265b4$var$gEventLogArray[i2].automated;
            compliant = compliant + $57e66c5a34f265b4$var$gEventLogArray[i2].compliant;
        } else if ($57e66c5a34f265b4$var$gEventLogArray[i2 - 1].t != $57e66c5a34f265b4$var$gEventLogArray[i2].t) {
            // update
            for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gActivityArray.length; j3++)if ($57e66c5a34f265b4$var$gActivityArray[j3].id == $57e66c5a34f265b4$var$gEventLogArray[i2 - 1].t) {
                $57e66c5a34f265b4$var$gActivityArray[j3].tasks = tasks;
                $57e66c5a34f265b4$var$gActivityArray[j3].compliant = compliant;
                $57e66c5a34f265b4$var$gActivityArray[j3].automated = automated;
                $57e66c5a34f265b4$var$gActivityArray[j3].actual_cost = actual_cost;
                $57e66c5a34f265b4$var$gActivityArray[j3].forecast_cost = forecast_cost;
                break;
            }
            tasks = 0;
            compliant = 0;
            automated = 0;
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].loop == false && $57e66c5a34f265b4$var$gEventLogArray[i2].duplicate == false) {
                tasks++;
                if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == true) compliant = 1;
                if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true) automated = 1;
            }
            actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost;
            forecast_cost = $57e66c5a34f265b4$var$gEventLogArray[i2].forecast_cost;
        } else {
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].loop == false && $57e66c5a34f265b4$var$gEventLogArray[i2].duplicate == false) {
                tasks++;
                if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == true) compliant++;
                if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true) automated++;
            }
            actual_cost = $57e66c5a34f265b4$var$gEventLogArray[i2].actual_cost + actual_cost;
            forecast_cost = $57e66c5a34f265b4$var$gEventLogArray[i2].forecast_cost + forecast_cost;
        }
    }
    for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gActivityArray.length; j4++)if ($57e66c5a34f265b4$var$gActivityArray[j4].id == $57e66c5a34f265b4$var$gEventLogArray[$57e66c5a34f265b4$var$gEventLogArray.length - 1].t) {
        $57e66c5a34f265b4$var$gActivityArray[j4].tasks = tasks;
        $57e66c5a34f265b4$var$gActivityArray[j4].compliant = compliant;
        $57e66c5a34f265b4$var$gActivityArray[j4].automated = automated;
        $57e66c5a34f265b4$var$gActivityArray[j4].actual_cost = actual_cost;
        $57e66c5a34f265b4$var$gActivityArray[j4].forecast_cost = forecast_cost;
        break;
    }
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gActivityArray.length; i3++){
        $57e66c5a34f265b4$var$gActivityArray[i3].filtered = 1;
        if ($57e66c5a34f265b4$var$gActivityArray[i3].tasks != 0 || $57e66c5a34f265b4$var$gActivityArray[i3].activity == "Start") $57e66c5a34f265b4$var$gActivityArray[i3].filtered = 0;
    }
    // clean up
    $57e66c5a34f265b4$var$gEventsAll = $57e66c5a34f265b4$var$gEventLogArray.length - $57e66c5a34f265b4$var$gTaskArray.length; // don't count end
    $57e66c5a34f265b4$var$gTasksAll = $57e66c5a34f265b4$var$gTaskArray.length;
    $57e66c5a34f265b4$var$gVariantsAll = $57e66c5a34f265b4$var$gVariantArray.length;
    $57e66c5a34f265b4$var$gStepsAll = 0;
    $57e66c5a34f265b4$var$gActivitiesAll = 0;
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gStepArray.length; i4++)if ($57e66c5a34f265b4$var$gStepArray[i4].to != endNode) $57e66c5a34f265b4$var$gStepsAll++;
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gActivityArray.length; i5++)if ($57e66c5a34f265b4$var$gActivityArray[i5].id != startNode && $57e66c5a34f265b4$var$gActivityArray[i5].id != endNode) $57e66c5a34f265b4$var$gActivitiesAll++;
    $57e66c5a34f265b4$var$gEventsFiltered = 0;
    $57e66c5a34f265b4$var$gTasksFiltered = 0;
    $57e66c5a34f265b4$var$gVariantsFiltered = 0;
    $57e66c5a34f265b4$var$gActivitiesFiltered = 0;
    $57e66c5a34f265b4$var$gStepsFiltered = 0;
    let start_time = new Date().getTime();
    for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gEventLogArray.length; i6++)if ($57e66c5a34f265b4$var$gEventLogArray[i6].filtered == 0 && $57e66c5a34f265b4$var$gEventLogArray[i6].t != endNode) $57e66c5a34f265b4$var$gEventsFiltered++;
    for(let i7 = 0; i7 < $57e66c5a34f265b4$var$gTaskArray.length; i7++)if ($57e66c5a34f265b4$var$gTaskArray[i7].filtered == 0) $57e66c5a34f265b4$var$gTasksFiltered++;
    for(let i8 = 0; i8 < $57e66c5a34f265b4$var$gVariantArray.length; i8++)if ($57e66c5a34f265b4$var$gVariantArray[i8].filtered == 0) $57e66c5a34f265b4$var$gVariantsFiltered++;
    for(let i9 = 0; i9 < $57e66c5a34f265b4$var$gStepArray.length; i9++)if ($57e66c5a34f265b4$var$gStepArray[i9].filtered == 0 && $57e66c5a34f265b4$var$gStepArray[i9].to != endNode) $57e66c5a34f265b4$var$gStepsFiltered++;
    for(let i10 = 0; i10 < $57e66c5a34f265b4$var$gActivityArray.length; i10++)if ($57e66c5a34f265b4$var$gActivityArray[i10].filtered == 0 && $57e66c5a34f265b4$var$gActivityArray[i10].id != startNode && $57e66c5a34f265b4$var$gActivityArray[i10].id != endNode) $57e66c5a34f265b4$var$gActivitiesFiltered++;
    let end_time = new Date().getTime();
    duration = end_time - start_time;
    for(let i11 = 0; i11 < $57e66c5a34f265b4$var$gVariantArray.length; i11++)if ($57e66c5a34f265b4$var$gVariantArray[i11].filtered == 0) $57e66c5a34f265b4$var$gVariantArray[i11].sliced = true;
    else $57e66c5a34f265b4$var$gVariantArray[i11].sliced = false;
    if ($57e66c5a34f265b4$var$gSlicerSelectedSteps.length > 0) $57e66c5a34f265b4$export$dd3986409eddbcdc("Steps");
    if ($57e66c5a34f265b4$var$gSlicerSelectedActivities.length > 0) $57e66c5a34f265b4$export$dd3986409eddbcdc("Activities");
    if ($57e66c5a34f265b4$var$gPathPaneVariants.length > 0) $57e66c5a34f265b4$export$dd3986409eddbcdc("Path");
    if ($57e66c5a34f265b4$var$gTaskPaneVariants.length > 0) $57e66c5a34f265b4$export$dd3986409eddbcdc("Tasks");
    $57e66c5a34f265b4$var$gVariants = $57e66c5a34f265b4$var$gVariantArray.length;
    $57e66c5a34f265b4$var$gDiagramPVTasks = 0;
    $57e66c5a34f265b4$var$gDiagramPVEvents = 0;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>b.t - a.t);
    if ($57e66c5a34f265b4$var$gVariantPaneVariants.length == 0 || applyFilters == true || firstBuild == true || $57e66c5a34f265b4$var$gDiagramPVTasks == 0) {
        let selected = 0;
        for(let i12 = 0; i12 < $57e66c5a34f265b4$var$gVariantArray.length; i12++){
            $57e66c5a34f265b4$var$gVariantArray[i12].selected = 0;
            if ($57e66c5a34f265b4$var$gVariantArray[i12].filtered == 0) {
                if (selected < $57e66c5a34f265b4$var$gDefaultVariantsSelected) {
                    $57e66c5a34f265b4$var$gVariantArray[i12].selected = 1;
                    selected++;
                    $57e66c5a34f265b4$var$gDiagramPVTasks = $57e66c5a34f265b4$var$gDiagramPVTasks + $57e66c5a34f265b4$var$gVariantArray[i12].t;
                    $57e66c5a34f265b4$var$gDiagramPVEvents = $57e66c5a34f265b4$var$gDiagramPVEvents + $57e66c5a34f265b4$var$gVariantArray[i12].e;
                }
            }
        }
    }
    //'generateArray - finish: ' + source + ' - ' + (Date.now() - startTime)/1000
    if ($57e66c5a34f265b4$var$gTasksFiltered > 0) {
        // reapply slicers
        let stepsSliced = false;
        let activitiesSliced = false;
        let pathSliced = false;
        let taskSliced = false;
        for(let i13 = 0; i13 < $57e66c5a34f265b4$var$gSlicerConditions.length; i13++){
            if ($57e66c5a34f265b4$var$gSlicerConditions[i13].type == "Steps" && stepsSliced == false) {
                $57e66c5a34f265b4$export$dd3986409eddbcdc("Steps");
                stepsSliced;
            }
            if ($57e66c5a34f265b4$var$gSlicerConditions[i13].type == "Activities" && stepsSliced == false) {
                $57e66c5a34f265b4$export$dd3986409eddbcdc("Activities");
                activitiesSliced;
            }
            if ($57e66c5a34f265b4$var$gSlicerConditions[i13].type == "Path" && stepsSliced == false) {
                $57e66c5a34f265b4$export$dd3986409eddbcdc("Path");
                pathSliced;
            }
            if ($57e66c5a34f265b4$var$gSlicerConditions[i13].type == "Tasks" && stepsSliced == false) {
                $57e66c5a34f265b4$export$dd3986409eddbcdc("Tasks");
                taskSliced;
            }
        }
        $57e66c5a34f265b4$export$29e7d345ec013547();
        $57e66c5a34f265b4$var$updateAttributes();
        $57e66c5a34f265b4$export$cf491150aa61915d("TaskDuration");
        $57e66c5a34f265b4$var$generateTaskAnalyticsArray();
        $57e66c5a34f265b4$var$generateEventAnalyticsArray();
    }
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $1caefedac34ca9dc$export$c0abe4076afdf7bd)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$var$generateEventAnalyticsArray() {
    let endActivity = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].en == true) endActivity = $57e66c5a34f265b4$var$gActivityArray[j].a;
    $57e66c5a34f265b4$var$gAnalyticsEventArray = [];
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].t != endActivity && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i].vid].sliced == true) {
            let valueToPush = {};
            valueToPush["Duration"] = $57e66c5a34f265b4$var$gEventLogArray[i].d;
            valueToPush["Resource"] = $57e66c5a34f265b4$var$gEventLogArray[i].u;
            for(let z = 0; z < $57e66c5a34f265b4$var$gEventAttributes.length; z++)if ($57e66c5a34f265b4$var$gEventAttributes[z].field != "Resource") {
                let key = "ea" + z;
                valueToPush[$57e66c5a34f265b4$var$gEventAttributes[z].field] = $57e66c5a34f265b4$var$gEventLogArray[i][key];
            }
            if ($57e66c5a34f265b4$var$gEventLogArray[i].automated == true) valueToPush["Automation"] = 1;
            else valueToPush["Automation"] = 0;
            valueToPush["Events"] = 1;
            valueToPush["Timestamp"] = $57e66c5a34f265b4$var$gEventLogArray[i].ts;
            let year = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].ts.substring(0, 4));
            let month = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].ts.substring(5, 7));
            let day = parseInt($57e66c5a34f265b4$var$gEventLogArray[i].ts.substring(8, 10));
            valueToPush["UTC"] = Date.UTC(year, month - 1, day);
            $57e66c5a34f265b4$var$gAnalyticsEventArray.push(valueToPush);
        }
    }
}
function $57e66c5a34f265b4$export$361dfb4e2f54323d(type, variantPaneVariants, variant, activity, from, to, ruleID) {
    $57e66c5a34f265b4$var$gRCDescription = "";
    let ruleKey = "";
    if (type === "dt" || type === "is" || type === "ia" || type === "diagram") $57e66c5a34f265b4$var$gRCDescription = "All " + $57e66c5a34f265b4$var$gEntityUpper + "s";
    if (type === "step") {
        let fromStr = "";
        let toStr = "";
        for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++){
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt(from)) fromStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt(to)) toStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
        }
        $57e66c5a34f265b4$var$gRCDescription = "From step: " + fromStr + ", To step: " + toStr;
    }
    if (type === "activity") {
        let activityStr = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gActivityArray.length; i1++)if (parseInt($57e66c5a34f265b4$var$gActivityArray[i1].id) === parseInt(activity)) activityStr = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        $57e66c5a34f265b4$var$gRCDescription = "Activity: " + activityStr;
    }
    if (type === "variant") {
        let variantStr = "";
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)if (parseInt($57e66c5a34f265b4$var$gVariantArray[i2].v) === parseInt(variant)) {
            variantStr = $57e66c5a34f265b4$var$gVariantArray[i2].n;
            break;
        }
        $57e66c5a34f265b4$var$gRCDescription = "Variant: " + variantStr;
    }
    if (type === "compliance") {
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gComplianceRules.length; i3++)if ($57e66c5a34f265b4$var$gComplianceRules[i3].ruleID === ruleID) $57e66c5a34f265b4$var$gRCDescription = "Compliance Rule: " + $57e66c5a34f265b4$var$gComplianceRules[i3].rule;
        ruleKey = "cr-" + ruleID;
    }
    if (type === "cost") {
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gCostRules.length; i4++)if ($57e66c5a34f265b4$var$gCostRules[i4].ruleID === ruleID) $57e66c5a34f265b4$var$gRCDescription = "Cost Rule: " + $57e66c5a34f265b4$var$gCostRules[i4].rule;
        ruleKey = "$r-" + ruleID;
    }
    if (type === "automation") {
        for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gAutomationRules.length; i5++)if ($57e66c5a34f265b4$var$gAutomationRules[i5].ruleID === ruleID) $57e66c5a34f265b4$var$gRCDescription = "Automation Rule: " + $57e66c5a34f265b4$var$gAutomationRules[i5].rule;
        ruleKey = "ar-" + ruleID;
    }
    if (type === "performance") {
        for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gPerformanceRules.length; i6++)if ($57e66c5a34f265b4$var$gPerformanceRules[i6].ruleID === ruleID) $57e66c5a34f265b4$var$gRCDescription = "Performance Rule: " + $57e66c5a34f265b4$var$gPerformanceRules[i6].rule;
        ruleKey = "pr-" + ruleID;
    }
    $57e66c5a34f265b4$var$gTaskSlicedArray = [];
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered);
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i7 = 0; i7 < $57e66c5a34f265b4$var$gTaskArray.length; i7++)if ($57e66c5a34f265b4$var$gTaskArray[i7].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i7].vid].sliced == true) {
        let validTask = true;
        if (variantPaneVariants == true) {
            validTask = false;
            for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gTaskArray[i7].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                validTask = true;
                break;
            }
        }
        if (validTask == true) {
            let validTask1 = false;
            if (type == "variant") {
                if ($57e66c5a34f265b4$var$gTaskArray[i7].v == variant) validTask1 = true;
            }
            if (type == "activity") {
                for(let f = $57e66c5a34f265b4$var$gTaskArray[i7].si; f < $57e66c5a34f265b4$var$gTaskArray[i7].fi + 1; f++)if ($57e66c5a34f265b4$var$gEventLogArray[f].t == parseInt(activity)) {
                    validTask1 = true;
                    break;
                }
            }
            if (type == "step") {
                for(let f1 = $57e66c5a34f265b4$var$gTaskArray[i7].si; f1 < $57e66c5a34f265b4$var$gTaskArray[i7].fi + 1; f1++)if ($57e66c5a34f265b4$var$gEventLogArray[f1].f == parseInt(from) && $57e66c5a34f265b4$var$gEventLogArray[f1].t == parseInt(to)) {
                    validTask1 = true;
                    break;
                }
            }
            if (type === "diagram" || type === "is" || type === "dt" || type === "ia") validTask1 = true;
            if (type === "compliance" || type === "cost" || type === "automation" || type === "performance") {
                for(let f2 = $57e66c5a34f265b4$var$gTaskArray[i7].si; f2 < $57e66c5a34f265b4$var$gTaskArray[i7].fi + 1; f2++)if ($57e66c5a34f265b4$var$gEventLogArray[f2][ruleKey] === 1) {
                    validTask1 = true;
                    break;
                }
            }
            if (validTask1 == true) $57e66c5a34f265b4$var$gTaskSlicedArray.push($57e66c5a34f265b4$var$gTaskArray[i7]);
        }
    }
}
function $57e66c5a34f265b4$var$generateTaskAnalyticsArray() {
    $57e66c5a34f265b4$var$gAnalyticsTaskArray = [];
    $57e66c5a34f265b4$var$gTaskArray = $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i = 0; i < $57e66c5a34f265b4$var$gTaskArray.length; i++)if ($57e66c5a34f265b4$var$gTaskArray[i].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].sliced == true) {
        let valueToPush = {};
        for(let z = 0; z < $57e66c5a34f265b4$var$gTaskAttributes.length; z++){
            let key = "ta" + z;
            valueToPush[$57e66c5a34f265b4$var$gTaskAttributes[z].field] = $57e66c5a34f265b4$var$gTaskArray[i][key];
        }
        valueToPush["Duration"] = $57e66c5a34f265b4$var$gTaskArray[i].d;
        valueToPush["Tasks"] = 1;
        valueToPush["Number"] = $57e66c5a34f265b4$var$gTaskArray[i].k;
        valueToPush["Timestamp"] = $57e66c5a34f265b4$var$gTaskArray[i].t1;
        let year = parseInt($57e66c5a34f265b4$var$gTaskArray[i].t1.substring(0, 4));
        let month = parseInt($57e66c5a34f265b4$var$gTaskArray[i].t1.substring(5, 7));
        let day = parseInt($57e66c5a34f265b4$var$gTaskArray[i].t1.substring(8, 10));
        valueToPush["UTC"] = Date.UTC(year, month - 1, day);
        valueToPush["Variant"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].n;
        valueToPush["ActualCost"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].actual_cost / $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].t;
        valueToPush["ForecastCost"] = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].forecast_cost / $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].t;
        if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i].vid].compliant == true) valueToPush["Compliant"] = 1;
        else valueToPush["Compliant"] = 0;
        $57e66c5a34f265b4$var$gAnalyticsTaskArray.push(valueToPush);
    }
}
function $57e66c5a34f265b4$export$5ff20fde29755b6b(metric) {
    $57e66c5a34f265b4$var$gAnalyticsEventArray.sort((a, b)=>a.UTC - b.UTC);
    let rows = [];
    let UTC = null;
    let events = 0;
    if (metric.metric === "events") {
        for(let i = 0; i < $57e66c5a34f265b4$var$gAnalyticsEventArray.length; i++){
            if (i > 0 && $57e66c5a34f265b4$var$gAnalyticsEventArray[i].UTC != $57e66c5a34f265b4$var$gAnalyticsEventArray[i - 1].UTC) {
                rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsEventArray[i].UTC,
                    events
                ]);
                events = 0;
            }
            events++;
            UTC = $57e66c5a34f265b4$var$gAnalyticsEventArray[i].UTC;
        }
        rows.push([
            UTC,
            events
        ]);
    }
    if (metric.metric === "perc_automation") {
        let automation1 = 0;
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gAnalyticsEventArray.length; i1++){
            if (i1 > 0 && $57e66c5a34f265b4$var$gAnalyticsEventArray[i1].UTC != $57e66c5a34f265b4$var$gAnalyticsEventArray[i1 - 1].UTC) {
                rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsEventArray[i1 - 1].UTC,
                    automation1 / events * 100
                ]);
                events = 0;
                automation1 = 0;
            }
            automation1 = automation1 + $57e66c5a34f265b4$var$gAnalyticsEventArray[i1].Automation;
            events = events + $57e66c5a34f265b4$var$gAnalyticsEventArray[i1].Events;
            UTC = $57e66c5a34f265b4$var$gAnalyticsEventArray[i1].UTC;
        }
        rows.push([
            UTC,
            automation1 / events * 100
        ]);
    }
    return rows;
}
function $57e66c5a34f265b4$export$e6b539ad095b1347() {
    let rows = [];
    if ($57e66c5a34f265b4$var$gTaskAttributes.length == 0) return rows;
    if ($57e66c5a34f265b4$var$gAnalyticsTaskAttribute == "") $57e66c5a34f265b4$var$gAnalyticsTaskAttribute = $57e66c5a34f265b4$var$gTaskAttributes[0].field;
    if ($57e66c5a34f265b4$var$gAnalyticsTaskAttribute != "") {
        $57e66c5a34f265b4$var$gAnalyticsTaskArray = $57e66c5a34f265b4$var$gAnalyticsTaskArray.sort((a, b)=>a[$57e66c5a34f265b4$var$gAnalyticsTaskAttribute].localeCompare(b[$57e66c5a34f265b4$var$gAnalyticsTaskAttribute]));
        let attributeLabel = null;
        let tasks = 0;
        let duration = 0;
        let compliant = 0;
        let actualCost = 0;
        let forecastCost = 0;
        for(let i = 0; i < $57e66c5a34f265b4$var$gAnalyticsTaskArray.length; i++){
            if (i > 0 && $57e66c5a34f265b4$var$gAnalyticsTaskArray[i][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute] != $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute]) {
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 1) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    tasks
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 2) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    duration / tasks / 60
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 3) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    duration / tasks / 3600
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 4) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    duration / tasks / 62400
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 5) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    compliant / tasks * 100
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 6) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    actualCost
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 7) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    forecastCost
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 8) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    actualCost - forecastCost
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 9) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    actualCost / tasks
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 10) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    forecastCost / tasks
                ]);
                if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 11) rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute],
                    (actualCost - forecastCost) / tasks
                ]);
                tasks = 0;
                duration = 0;
                compliant = 0;
                actualCost = 0;
                forecastCost = 0;
            }
            tasks++;
            duration = duration + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].Duration;
            compliant = compliant + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].Compliant;
            actualCost = actualCost + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].ActualCost;
            forecastCost = forecastCost + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].ForecastCost;
            attributeLabel = $57e66c5a34f265b4$var$gAnalyticsTaskArray[i][$57e66c5a34f265b4$var$gAnalyticsTaskAttribute];
        }
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 1) rows.push([
            attributeLabel,
            tasks
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 2) rows.push([
            attributeLabel,
            duration / tasks / 60
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 3) rows.push([
            attributeLabel,
            duration / tasks / 3600
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 4) rows.push([
            attributeLabel,
            duration / tasks / 62400
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 5) rows.push([
            attributeLabel,
            compliant / tasks * 100
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 6) rows.push([
            attributeLabel,
            actualCost
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 7) rows.push([
            attributeLabel,
            forecastCost
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 8) rows.push([
            attributeLabel,
            actualCost - forecastCost
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 9) rows.push([
            attributeLabel,
            actualCost / tasks
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 10) rows.push([
            attributeLabel,
            forecastCost / tasks
        ]);
        if ($57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric == 11) rows.push([
            attributeLabel,
            (actualCost - forecastCost) / tasks
        ]);
    }
    return rows;
}
function $57e66c5a34f265b4$export$b12f53a00119e86() {
    $57e66c5a34f265b4$var$gAnalyticsTaskArray.sort((a, b)=>a.UTC - b.UTC);
    let rows = [];
    let UTC = null;
    let tasks = 0;
    let duration = 0;
    let compliant = 0;
    let actualCost = 0;
    let forecastCost = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gAnalyticsTaskArray.length; i++){
        if (i > 0 && $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].UTC != $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC) {
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 1) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                tasks
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 2) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                duration / tasks / 60
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 3) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                duration / tasks / 3600
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 4) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                duration / tasks / 62400
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 5) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                compliant / tasks * 100
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 6) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                actualCost
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 7) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                forecastCost
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 8) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                actualCost - forecastCost
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 9) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                actualCost / tasks
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 10) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                forecastCost / tasks
            ]);
            if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 11) rows.push([
                $57e66c5a34f265b4$var$gAnalyticsTaskArray[i - 1].UTC,
                (actualCost - forecastCost) / tasks
            ]);
            tasks = 0;
            duration = 0;
            compliant = 0;
            actualCost = 0;
            forecastCost = 0;
        }
        tasks++;
        duration = duration + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].Duration;
        compliant = compliant + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].Compliant;
        actualCost = actualCost + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].ActualCost;
        forecastCost = forecastCost + $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].ForecastCost;
        UTC = $57e66c5a34f265b4$var$gAnalyticsTaskArray[i].UTC;
    }
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 1) rows.push([
        UTC,
        tasks
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 2) rows.push([
        UTC,
        duration / tasks / 60
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 3) rows.push([
        UTC,
        duration / tasks / 3600
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 4) rows.push([
        UTC,
        duration / tasks / 62400
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 5) rows.push([
        UTC,
        compliant / tasks * 100
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 6) rows.push([
        UTC,
        actualCost
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 7) rows.push([
        UTC,
        forecastCost
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 8) rows.push([
        UTC,
        actualCost - forecastCost
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 9) rows.push([
        UTC,
        actualCost / tasks
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 10) rows.push([
        UTC,
        forecastCost / tasks
    ]);
    if ($57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric == 11) rows.push([
        UTC,
        (actualCost - forecastCost) / tasks
    ]);
    return rows;
}
function $57e66c5a34f265b4$export$5541061dade0f39a(metric) {
    let rows = [];
    if ($57e66c5a34f265b4$var$gEventAttributes.length == 0) return rows;
    if ($57e66c5a34f265b4$var$gAnalyticsEventAttribute == "") $57e66c5a34f265b4$var$gAnalyticsEventAttribute = $57e66c5a34f265b4$var$gEventAttributes[0].field;
    if ($57e66c5a34f265b4$var$gAnalyticsEventAttribute != "") {
        $57e66c5a34f265b4$var$gAnalyticsEventArray = $57e66c5a34f265b4$var$gAnalyticsEventArray.sort((a, b)=>a[$57e66c5a34f265b4$var$gAnalyticsEventAttribute].localeCompare(b[$57e66c5a34f265b4$var$gAnalyticsEventAttribute]));
        let attributeLabel = null;
        let events = 0;
        let automation1 = 0;
        for(let i = 0; i < $57e66c5a34f265b4$var$gAnalyticsEventArray.length; i++){
            if (i > 0 && $57e66c5a34f265b4$var$gAnalyticsEventArray[i][$57e66c5a34f265b4$var$gAnalyticsEventAttribute] != $57e66c5a34f265b4$var$gAnalyticsEventArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsEventAttribute]) {
                if (metric.metric === "events") rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsEventArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsEventAttribute],
                    events
                ]);
                if (metric.metric === "perc_automation") rows.push([
                    $57e66c5a34f265b4$var$gAnalyticsEventArray[i - 1][$57e66c5a34f265b4$var$gAnalyticsEventAttribute],
                    automation1 / events * 100
                ]);
                events = 0;
                automation1 = 0;
            }
            automation1 = automation1 + $57e66c5a34f265b4$var$gAnalyticsEventArray[i].Automation;
            events = events + $57e66c5a34f265b4$var$gAnalyticsEventArray[i].Events;
            attributeLabel = $57e66c5a34f265b4$var$gAnalyticsEventArray[i][$57e66c5a34f265b4$var$gAnalyticsEventAttribute];
        }
        if (metric.metric === "events") rows.push([
            attributeLabel,
            events
        ]);
        if (metric.metric === "perc_automation") rows.push([
            attributeLabel,
            automation1 / events * 100
        ]);
    }
    return rows;
}
function $57e66c5a34f265b4$var$updateAttributes() {
    let endActivity = 0;
    let startActivity = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].activity == "Start") startActivity = $57e66c5a34f265b4$var$gActivityArray[j].id;
        if ($57e66c5a34f265b4$var$gActivityArray[j].activity == "End") endActivity = $57e66c5a34f265b4$var$gActivityArray[j].id;
    }
    $57e66c5a34f265b4$var$gAttributeArray.length = 0;
    $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
    let resourceExists = false;
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventAttributes.length; i++)if ($57e66c5a34f265b4$var$gEventAttributes[i].field == "Resource") resourceExists = true;
    let k = 0;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(k = 0; k < $57e66c5a34f265b4$var$gEventAttributes.length; k++)if ($57e66c5a34f265b4$var$gEventAttributes[k].field != "Resource") {
        let key = "ea" + k;
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a[key].localeCompare(b[key]) || a.k.localeCompare(b.k));
        let attribute = null;
        let task = "";
        let sdArray = [];
        let tasks = 0;
        let events = 0;
        let compliantTasks = 0;
        let compliantEvents = 0;
        let automatedTasks = 0;
        let automatedEvents = 0;
        let duration = 0;
        let i1 = 0;
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
            let validRec = true;
            if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
                if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2].vid].sliced === false) validRec = false;
            }
            if (validRec === true) {
                if ($57e66c5a34f265b4$var$gEventLogArray[i2].t != endActivity) {
                    if (attribute != $57e66c5a34f265b4$var$gEventLogArray[i2][key] && i2 > 0) {
                        let valueToPush = {};
                        valueToPush["type"] = "Event";
                        valueToPush["field"] = $57e66c5a34f265b4$var$gEventAttributes[k].field;
                        valueToPush["value"] = attribute;
                        valueToPush["selected"] = false;
                        valueToPush["tasks"] = tasks;
                        valueToPush["events"] = events;
                        valueToPush["compliant_tasks"] = compliantTasks;
                        valueToPush["compliant_events"] = compliantEvents;
                        valueToPush["automated_tasks"] = automatedTasks;
                        valueToPush["automated_events"] = automatedEvents;
                        valueToPush["avg_duration"] = duration / tasks;
                        valueToPush["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
                        $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush);
                        tasks = 1;
                        events = 1;
                        if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2].tid].compliant == true) compliantTasks = 1;
                        if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2].tid].automated == true) automatedTasks = 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == true) compliantEvents = 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true) automatedEvents = 1;
                        sdArray.length = 0;
                        sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i2].d));
                        duration = parseInt($57e66c5a34f265b4$var$gEventLogArray[i2].d);
                    } else {
                        if (task != $57e66c5a34f265b4$var$gEventLogArray[i2].k) {
                            tasks++;
                            if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2].tid].compliant == true) compliantTasks++;
                            if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i2].tid].automated == true) automatedTasks++;
                        }
                        if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == true) compliantEvents++;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true) automatedEvents++;
                        events++;
                        duration = duration + parseInt($57e66c5a34f265b4$var$gEventLogArray[i2].d);
                        sdArray.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i2].d));
                    }
                }
                task = $57e66c5a34f265b4$var$gEventLogArray[i2].k;
                attribute = $57e66c5a34f265b4$var$gEventLogArray[i2][key];
            }
        }
        if (i1 > 0) {
            let validRec1 = true;
            if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
                if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i1 - 1].vid].sliced === false) validRec1 = false;
            }
            if (validRec1 === true) {
                let valueToPush1 = {};
                valueToPush1["type"] = "Event";
                valueToPush1["field"] = $57e66c5a34f265b4$var$gEventAttributes[k].field;
                valueToPush1["value"] = $57e66c5a34f265b4$var$gEventLogArray[i1 - 1][key];
                valueToPush1["selected"] = false;
                valueToPush1["tasks"] = tasks;
                valueToPush1["events"] = events;
                valueToPush1["compliant_tasks"] = compliantTasks;
                valueToPush1["compliant_events"] = compliantEvents;
                valueToPush1["automated_tasks"] = automatedTasks;
                valueToPush1["automated_events"] = automatedEvents;
                valueToPush1["avg_duration"] = duration / tasks;
                valueToPush1["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray);
                $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush1);
            }
        }
    }
    if (resourceExists == true) {
        let user = "";
        let task1 = "";
        let sdArray1 = [];
        let tasks1 = 0;
        let events1 = 0;
        let compliantTasks1 = 0;
        let compliantEvents1 = 0;
        let automatedTasks1 = 0;
        let automatedEvents1 = 0;
        let duration1 = 0;
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.u.localeCompare(b.u) || a.k.localeCompare(b.k));
        let i3 = 0;
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gEventLogArray.length; i4++){
            if ($57e66c5a34f265b4$var$gEventLogArray[i4].filtered == 1) break;
            if ($57e66c5a34f265b4$var$gEventLogArray[i4].t != endActivity) {
                let validRec2 = true;
                if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
                    if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i4].vid].sliced === false) validRec2 = false;
                }
                if (validRec2 === true) {
                    if (user != $57e66c5a34f265b4$var$gEventLogArray[i4].u && i4 > 0) {
                        let valueToPush2 = {};
                        valueToPush2["type"] = "Event";
                        valueToPush2["field"] = "Resource";
                        valueToPush2["value"] = user;
                        valueToPush2["selected"] = false;
                        valueToPush2["tasks"] = tasks1;
                        valueToPush2["events"] = events1;
                        valueToPush2["compliant_tasks"] = compliantTasks1;
                        valueToPush2["compliant_events"] = compliantEvents1;
                        valueToPush2["automated_tasks"] = automatedTasks1;
                        valueToPush2["automated_events"] = automatedEvents1;
                        valueToPush2["avg_duration"] = duration1 / tasks1;
                        valueToPush2["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray1);
                        $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush2);
                        tasks1 = 1;
                        events1 = 1;
                        if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4].tid].compliant == true) compliantTasks1 = 1;
                        if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4].tid].automated == true) automatedTasks1 = 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i4].compliant == true) compliantEvents1 = 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i4].automated == true) automatedEvents1 = 1;
                        sdArray1.length = 0;
                        sdArray1.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i4].d));
                        duration1 = parseInt($57e66c5a34f265b4$var$gEventLogArray[i4].d);
                    } else {
                        if (task1 != $57e66c5a34f265b4$var$gEventLogArray[i4].k) {
                            tasks1++;
                            if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4].tid].compliant == true) compliantTasks1++;
                            if ($57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gEventLogArray[i4].tid].automated == true) automatedTasks1++;
                        }
                        if ($57e66c5a34f265b4$var$gEventLogArray[i4].compliant == true) compliantEvents1++;
                        if ($57e66c5a34f265b4$var$gEventLogArray[i4].automated == true) automatedEvents1++;
                        events1++;
                        duration1 = duration1 + parseInt($57e66c5a34f265b4$var$gEventLogArray[i4].d);
                        sdArray1.push(parseInt($57e66c5a34f265b4$var$gEventLogArray[i4].d));
                    }
                }
                user = $57e66c5a34f265b4$var$gEventLogArray[i4].u;
                task1 = $57e66c5a34f265b4$var$gEventLogArray[i4].k;
            }
        }
        if (i3 > 0) {
            let validRec3 = true;
            if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
                if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i3 - 1].vid].sliced === false) validRec3 = false;
            }
            if (validRec3 === true) {
                let valueToPush3 = {};
                valueToPush3["type"] = "Event";
                valueToPush3["field"] = "Resource";
                valueToPush3["value"] = user;
                valueToPush3["selected"] = false;
                valueToPush3["tasks"] = tasks1;
                valueToPush3["events"] = events1;
                valueToPush3["compliant_tasks"] = compliantTasks1;
                valueToPush3["compliant_events"] = compliantEvents1;
                valueToPush3["automated_tasks"] = automatedTasks1;
                valueToPush3["automated_events"] = automatedEvents1;
                valueToPush3["avg_duration"] = duration1 / tasks1;
                valueToPush3["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray1);
                $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush3);
            }
        }
    }
    // task attributes
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.eid - b.eid);
    for(let k1 = 0; k1 < $57e66c5a34f265b4$var$gTaskAttributes.length; k1++){
        let key1 = "ta" + k1;
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered || a[key1].localeCompare(b[key1]) || a.k.localeCompare(b.k));
        let attribute1 = null;
        let task2 = null;
        let tasks2 = 0;
        let events2 = 0;
        let compliantEvents2 = 0;
        let automatedEvents2 = 0;
        let compliantTasks2 = 0;
        let automatedTasks2 = 0;
        let duration2 = 0;
        let actualCost = 0;
        let forecastCost = 0;
        let sdArray2 = [];
        let i5 = 0;
        for(i5 = 0; i5 < $57e66c5a34f265b4$var$gTaskArray.length; i5++){
            if ($57e66c5a34f265b4$var$gTaskArray[i5].filtered == 1) break;
            let validRec4 = true;
            if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
                if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i5].vid].sliced === false) validRec4 = false;
            }
            if (validRec4 === true) {
                if (attribute1 != $57e66c5a34f265b4$var$gTaskArray[i5][key1] && i5 > 0) {
                    // attribute changed
                    let valueToPush4 = {};
                    valueToPush4["type"] = $57e66c5a34f265b4$var$gEntityUpper;
                    valueToPush4["field"] = $57e66c5a34f265b4$var$gTaskAttributes[k1].field;
                    valueToPush4["value"] = $57e66c5a34f265b4$var$gTaskArray[i5 - 1][key1];
                    valueToPush4["selected"] = false;
                    valueToPush4["tasks"] = tasks2;
                    valueToPush4["events"] = events2;
                    valueToPush4["compliant_tasks"] = compliantTasks2;
                    valueToPush4["compliant_events"] = compliantEvents2;
                    valueToPush4["automated_tasks"] = automatedTasks2;
                    valueToPush4["automated_events"] = automatedEvents2;
                    valueToPush4["actual_cost"] = actualCost;
                    valueToPush4["forecast_cost"] = forecastCost;
                    valueToPush4["avg_duration"] = duration2 / tasks2;
                    valueToPush4["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray2);
                    $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush4);
                    sdArray2 = [];
                    tasks2 = 1;
                    events2 = 0;
                    compliantEvents2 = 0;
                    automatedEvents2 = 0;
                    actualCost = $57e66c5a34f265b4$var$gTaskArray[i5].actual_cost;
                    forecastCost = $57e66c5a34f265b4$var$gTaskArray[i5].forecast_cost;
                    if ($57e66c5a34f265b4$var$gTaskArray[i5].compliant == true) compliantTasks2 = 1;
                    else compliantTasks2 = 0;
                    if ($57e66c5a34f265b4$var$gTaskArray[i5].automated == true) automatedTasks2 = 1;
                    else automatedTasks2 = 0;
                    duration2 = parseInt($57e66c5a34f265b4$var$gTaskArray[i5].d);
                    sdArray2.push(parseInt($57e66c5a34f265b4$var$gTaskArray[i5].d));
                    for(let j1 = $57e66c5a34f265b4$var$gTaskArray[i5].si + 1; j1 < $57e66c5a34f265b4$var$gTaskArray[i5].fi + 1; j1++){
                        if ($57e66c5a34f265b4$var$gEventLogArray[j1].compliant == true) compliantEvents2 = compliantEvents2 + 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[j1].automated == true) automatedEvents2 = automatedEvents2 + 1;
                        events2++;
                    }
                } else {
                    actualCost = actualCost + $57e66c5a34f265b4$var$gTaskArray[i5].actual_cost;
                    forecastCost = forecastCost + $57e66c5a34f265b4$var$gTaskArray[i5].forecast_cost;
                    duration2 = duration2 + parseInt($57e66c5a34f265b4$var$gTaskArray[i5].d);
                    sdArray2.push(parseInt($57e66c5a34f265b4$var$gTaskArray[i5].d));
                    tasks2++;
                    if ($57e66c5a34f265b4$var$gTaskArray[i5].compliant == true) compliantTasks2 = compliantTasks2 + 1;
                    if ($57e66c5a34f265b4$var$gTaskArray[i5].automated == true) automatedTasks2 = automatedTasks2 + 1;
                    for(let j2 = $57e66c5a34f265b4$var$gTaskArray[i5].si + 1; j2 < $57e66c5a34f265b4$var$gTaskArray[i5].fi + 1; j2++){
                        if ($57e66c5a34f265b4$var$gEventLogArray[j2].compliant == true) compliantEvents2 = compliantEvents2 + 1;
                        if ($57e66c5a34f265b4$var$gEventLogArray[j2].automated == true) automatedEvents2 = automatedEvents2 + 1;
                        events2++;
                    }
                }
            }
            attribute1 = $57e66c5a34f265b4$var$gTaskArray[i5][key1];
            task2 = $57e66c5a34f265b4$var$gTaskArray[i5].k;
        }
        let validRec5 = true;
        if ($57e66c5a34f265b4$var$gSlicedMetrics === true) {
            if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i5 - 1].vid].sliced === false) validRec5 = false;
        }
        if (validRec5 === true) {
            let valueToPush5 = {};
            valueToPush5["type"] = $57e66c5a34f265b4$var$gEntityUpper;
            valueToPush5["field"] = $57e66c5a34f265b4$var$gTaskAttributes[k1].field;
            valueToPush5["value"] = $57e66c5a34f265b4$var$gTaskArray[i5 - 1][key1];
            valueToPush5["selected"] = false;
            valueToPush5["tasks"] = tasks2;
            valueToPush5["events"] = events2;
            valueToPush5["compliant_tasks"] = compliantTasks2;
            valueToPush5["compliant_events"] = compliantEvents2;
            valueToPush5["automated_tasks"] = automatedTasks2;
            valueToPush5["automated_events"] = automatedEvents2;
            valueToPush5["actual_cost"] = actualCost;
            valueToPush5["forecast_cost"] = forecastCost;
            valueToPush5["avg_duration"] = duration2 / tasks2;
            valueToPush5["std_deviation"] = $57e66c5a34f265b4$var$getStandardDeviation(sdArray2);
            $57e66c5a34f265b4$var$gAttributeArray.push(valueToPush5);
        }
    }
    if ($57e66c5a34f265b4$var$gEventAttributes.length > 0 || $57e66c5a34f265b4$var$gTaskAttributes.length > 0) {
        // task attributes
        $57e66c5a34f265b4$var$gAttributeArray.sort((a, b)=>a.type.localeCompare(b.type) || a.field.localeCompare(b.field));
        let type = "";
        let field = "";
        let tasks3 = 0;
        let events3 = 0;
        for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gAttributeArray.length; i6++){
            if (type != $57e66c5a34f265b4$var$gAttributeArray[i6].type || field != $57e66c5a34f265b4$var$gAttributeArray[i6].field) {
                tasks3 = 0;
                events3 = 0;
                for(k = 0; k < $57e66c5a34f265b4$var$gAttributeArray.length; k++)if ($57e66c5a34f265b4$var$gAttributeArray[k].type == $57e66c5a34f265b4$var$gAttributeArray[i6].type && $57e66c5a34f265b4$var$gAttributeArray[k].field == $57e66c5a34f265b4$var$gAttributeArray[i6].field) {
                    tasks3 = tasks3 + $57e66c5a34f265b4$var$gAttributeArray[k].tasks;
                    events3 = events3 + $57e66c5a34f265b4$var$gAttributeArray[k].events;
                }
            }
            type = $57e66c5a34f265b4$var$gAttributeArray[i6].type;
            field = $57e66c5a34f265b4$var$gAttributeArray[i6].field;
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_total_tasks = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].tasks) / tasks3;
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_total_events = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].events) / events3;
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_compliant_tasks = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].compliant_tasks) / parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].tasks);
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_automated_tasks = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].automated_tasks) / parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].tasks);
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_compliant_events = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].compliant_events) / parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].events);
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_automated_events = parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].automated_events) / parseInt($57e66c5a34f265b4$var$gAttributeArray[i6].events);
            let perc_cost_savings = 0;
            if ($57e66c5a34f265b4$var$gAttributeArray[i6].actual_cost > 0) perc_cost_savings = ($57e66c5a34f265b4$var$gAttributeArray[i6].actual_cost - $57e66c5a34f265b4$var$gAttributeArray[i6].forecast_cost) / $57e66c5a34f265b4$var$gAttributeArray[i6].actual_cost;
            $57e66c5a34f265b4$var$gAttributeArray[i6].perc_cost_savings = perc_cost_savings;
            let avg_task_cost = 0;
            if ($57e66c5a34f265b4$var$gAttributeArray[i6].actual_cost > 0) avg_task_cost = $57e66c5a34f265b4$var$gAttributeArray[i6].actual_cost / $57e66c5a34f265b4$var$gAttributeArray[i6].tasks;
            $57e66c5a34f265b4$var$gAttributeArray[i6].avg_task_cost = avg_task_cost;
        }
    }
}
function $57e66c5a34f265b4$export$c7aee54378586699() {
    if ($57e66c5a34f265b4$var$gTaskArray.length > 0) {
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.t1.localeCompare(b.t1));
        $57e66c5a34f265b4$var$gFromTime = $57e66c5a34f265b4$var$gTaskArray[0].t;
        $57e66c5a34f265b4$var$gToTime = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gTaskArray.length - 1].t;
    }
}
function $57e66c5a34f265b4$var$getStandardDeviation(array) {
    const n = array.length;
    if (n === 0) return 0;
    const mean = array.reduce((a, b)=>a + b) / n;
    return Math.sqrt(array.map((x)=>Math.pow(x - mean, 2)).reduce((a, b)=>a + b) / n);
}
function $57e66c5a34f265b4$var$getMedianDuration(array) {
    const sorted = array.slice().sort((a, b)=>a - b);
    const middle = Math.floor(sorted.length / 2);
    if (sorted.length % 2 === 0) return (sorted[middle - 1] + sorted[middle]) / 2;
    return sorted[middle];
}
function $57e66c5a34f265b4$export$cf491150aa61915d(type) {
    let maxValue;
    if (type == "NumTasksVariant") {
        let maxTasks = 1;
        for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++)if ($57e66c5a34f265b4$var$gVariantArray[i].t > maxTasks) maxTasks = $57e66c5a34f265b4$var$gVariantArray[i].t;
        maxValue = maxTasks;
    }
    if (type == "NumActivitesTask") {
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered);
        let maxActivities = 1;
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++){
            if ($57e66c5a34f265b4$var$gTaskArray[i1].filtered == 1) break;
            if ($57e66c5a34f265b4$var$gTaskArray[i1].a > maxActivities) maxActivities = $57e66c5a34f265b4$var$gTaskArray[i1].a;
        }
        maxValue = maxActivities;
    }
    if (type == "TaskDuration") {
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.filtered - b.filtered);
        let maxDuration = 1;
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gTaskArray.length; i2++){
            if ($57e66c5a34f265b4$var$gTaskArray[i2].filtered == 1) break;
            if ($57e66c5a34f265b4$var$gTaskArray[i2].d / 60 > maxDuration) maxDuration = $57e66c5a34f265b4$var$gTaskArray[i2].d / 60;
        }
        maxValue = parseInt(maxDuration) + 1;
    }
    return maxValue;
}
function $57e66c5a34f265b4$var$updateEventLogArray() {
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.v - b.v || a.k.localeCompare(b.k) || a.s - b.s);
    let tVariantSteps = [];
    let task = "";
    let loop = false;
    let duplicate = false;
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost = 0;
        $57e66c5a34f265b4$var$gEventLogArray[i].forecast_cost = 0;
        $57e66c5a34f265b4$var$gEventLogArray[i].compliant = true;
        $57e66c5a34f265b4$var$gEventLogArray[i].filtered = 0;
        $57e66c5a34f265b4$var$gEventLogArray[i].automated = false;
        if (task != $57e66c5a34f265b4$var$gEventLogArray[i].k && i > 0) tVariantSteps = [];
        task = $57e66c5a34f265b4$var$gEventLogArray[i].k;
        duplicate = false;
        for(let j = 0; j < tVariantSteps.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i].f == tVariantSteps[j].f && $57e66c5a34f265b4$var$gEventLogArray[i].t == tVariantSteps[j].t) {
            duplicate = true;
            break;
        }
        loop = false;
        if (duplicate == false) {
            for(let j1 = 0; j1 < tVariantSteps.length; j1++)if ($57e66c5a34f265b4$var$gEventLogArray[i].t == tVariantSteps[j1].t) {
                let stepExists = false;
                if (stepExists == false) {
                    loop = true;
                    break;
                }
            }
        }
        $57e66c5a34f265b4$var$gEventLogArray[i].loop = loop;
        $57e66c5a34f265b4$var$gEventLogArray[i].duplicate = duplicate;
        let valueToPush = {};
        valueToPush["f"] = $57e66c5a34f265b4$var$gEventLogArray[i].f;
        valueToPush["t"] = $57e66c5a34f265b4$var$gEventLogArray[i].t;
        tVariantSteps.push(valueToPush);
    }
}
function $57e66c5a34f265b4$export$b0c5c2fac8144e54() {
    let tArray = [];
    if ($57e66c5a34f265b4$var$gMetricArray) for(let i = 0; i < $57e66c5a34f265b4$var$gMetricArray.length; i++){
        let valueToPush = {};
        valueToPush["value"] = $57e66c5a34f265b4$var$gMetricArray[i].m;
        valueToPush["label"] = $57e66c5a34f265b4$var$gMetricArray[i].m;
        valueToPush["type"] = $57e66c5a34f265b4$var$gMetricArray[i].t;
        tArray.push(valueToPush);
    }
    return tArray;
}
function $57e66c5a34f265b4$export$5474922de5077d2d(type, row, id) {
    for(let i = 0; i < $57e66c5a34f265b4$var$gRuleSelectedRow.length; i++)if ($57e66c5a34f265b4$var$gRuleSelectedRow[i].type == type) {
        $57e66c5a34f265b4$var$gRuleSelectedRow.splice(i, 1);
        break;
    }
    let valueToPush = {};
    valueToPush["type"] = type;
    valueToPush["row"] = row;
    valueToPush["id"] = id;
    $57e66c5a34f265b4$var$gRuleSelectedRow.push(valueToPush);
}
function $57e66c5a34f265b4$export$cc8a4b0d17d53ffc(row) {
    $57e66c5a34f265b4$var$gFilterSelectedRow = row;
}
function $57e66c5a34f265b4$export$d80cc0328fcc6685() {
    $57e66c5a34f265b4$var$gFilterSets = $57e66c5a34f265b4$var$gFilterSets - 1;
    for(let i = 0; i < $57e66c5a34f265b4$var$gFilterConditions.length; i++)if (i == parseInt($57e66c5a34f265b4$var$gFilterSelectedRow)) {
        $57e66c5a34f265b4$var$gFilterConditions.splice(i, 1);
        i--;
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gFilters.length; i1++)if ($57e66c5a34f265b4$var$gFilters[i1].filter_number == parseInt($57e66c5a34f265b4$var$gFilterSelectedRow) + 1) {
        $57e66c5a34f265b4$var$gFilters.splice(i1, 1);
        i1--;
    }
    $57e66c5a34f265b4$export$59798dda46c3d2b5(true, false, "deleteFilter");
    $57e66c5a34f265b4$export$6e4c85e15f853f95();
}
function $57e66c5a34f265b4$export$223f94993e9d0274(field) {
    $57e66c5a34f265b4$var$gSelectedTransformationMapping = field;
}
function $57e66c5a34f265b4$export$a9937c3598565281() {
    if ($57e66c5a34f265b4$var$gSelectedTransformationMapping === "Activity" || $57e66c5a34f265b4$var$gSelectedTransformationMapping === $57e66c5a34f265b4$var$gEntityUpper + " ID" || $57e66c5a34f265b4$var$gSelectedTransformationMapping === "Timestamp") {
        for(let i = 0; i < $57e66c5a34f265b4$var$gTransformation.length; i++)if ($57e66c5a34f265b4$var$gTransformation[i].mapping == $57e66c5a34f265b4$var$gSelectedTransformationMapping) {
            $57e66c5a34f265b4$var$gTransformation[i].field = "";
            $57e66c5a34f265b4$var$gTransformation[i].status = false;
            if ($57e66c5a34f265b4$var$gSelectedTransformationMapping === $57e66c5a34f265b4$var$gEntityUpper + " ID") $57e66c5a34f265b4$var$gTransformation[i].issue = "Please select the Task ID column";
            if ($57e66c5a34f265b4$var$gSelectedTransformationMapping === "Activity") $57e66c5a34f265b4$var$gTransformation[i].issue = "Please select the Activity column";
            if ($57e66c5a34f265b4$var$gSelectedTransformationMapping === "Timestamp") $57e66c5a34f265b4$var$gTransformation[i].issue = "Please select the Timestamp column";
        }
    } else {
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTransformation.length; i1++)if ($57e66c5a34f265b4$var$gTransformation[i1].mapping == $57e66c5a34f265b4$var$gSelectedTransformationMapping) {
            $57e66c5a34f265b4$var$gTransformation.splice(i1, 1);
            break;
        }
    }
}
function $57e66c5a34f265b4$export$b93c2a0b2c5b5c71() {
    $57e66c5a34f265b4$var$gTransformation = [];
}
function $57e66c5a34f265b4$export$988cba38e738f27d(type, ruleID) {
    if (type == "compliance") {
        for(let i = 0; i < $57e66c5a34f265b4$var$gComplianceRules.length; i++)if ($57e66c5a34f265b4$var$gComplianceRules[i].ruleID == ruleID) {
            $57e66c5a34f265b4$var$gComplianceRules[i].mode = "delete";
            const temp = $57e66c5a34f265b4$var$gComplianceRules[i];
            $57e66c5a34f265b4$export$46a207868612a8fe(temp);
        }
    }
    if (type == "cost") {
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gCostRules.length; i1++)if ($57e66c5a34f265b4$var$gCostRules[i1].ruleID == ruleID) {
            $57e66c5a34f265b4$var$gCostRules[i1].mode = "delete";
            const temp1 = $57e66c5a34f265b4$var$gCostRules[i1];
            $57e66c5a34f265b4$var$gCostRules.splice(i1, 1);
            $57e66c5a34f265b4$export$49e15f373ab56525(temp1);
        }
    }
    if (type == "automation") {
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gAutomationRules.length; i2++)if ($57e66c5a34f265b4$var$gAutomationRules[i2].ruleID == ruleID) {
            $57e66c5a34f265b4$var$gAutomationRules[i2].mode = "delete";
            const temp2 = $57e66c5a34f265b4$var$gAutomationRules[i2];
            $57e66c5a34f265b4$export$451049238f8e339c(temp2);
        }
    }
    if (type == "performance") {
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gPerformanceRules.length; i3++)if ($57e66c5a34f265b4$var$gPerformanceRules[i3].ruleID == ruleID) {
            $57e66c5a34f265b4$var$gPerformanceRules[i3].mode = "delete";
            const temp3 = $57e66c5a34f265b4$var$gPerformanceRules[i3];
            $57e66c5a34f265b4$export$435ccb6e63ccfec4(temp3);
        }
    }
}
function $57e66c5a34f265b4$export$56e87122f905fac0(type, fromActivity, toActivity, fromActivityLabel, toActivityLabel) {
    if (type === "compliance") {
        let rule = "Non compliant: " + fromActivityLabel + " -> " + toActivityLabel;
        (0, $2e988fe81abc0213$export$26b82a75aae6bfed)({
            data: {
                rule: rule,
                fromNode: fromActivity,
                toNode: toActivity,
                fromNodeStr: fromActivityLabel,
                toNodeStr: toActivityLabel,
                filterLoops: false,
                calculateCostImpact: false,
                variantType: "all_variants",
                taskType: "all_tasks",
                durationOperator: "N/A",
                durationActualFrom: 0,
                durationActualTo: 0,
                durationValue: "hrs",
                mode: "new"
            }
        });
    }
    if (type === "automation") {
        let rule1 = "Automation: " + fromActivityLabel + " -> " + toActivityLabel;
        (0, $d2cffb3e3e561271$export$b8eacc044a97fdf9)({
            data: {
                rule: rule1,
                fromNode: fromActivity,
                toNode: toActivity,
                fromNodeStr: fromActivityLabel,
                toNodeStr: toActivityLabel,
                calculateCostImpact: false,
                variantType: "all_variants",
                taskType: "all_tasks",
                mode: "new"
            }
        });
    }
    if (type === "performance") {
        let rule2 = "Performance: " + fromActivityLabel + " -> " + toActivityLabel;
        (0, $1200978695fc35a8$export$9c10e13e2df2501e)({
            data: {
                rule: rule2,
                fromNode: fromActivity,
                toNode: toActivity,
                fromNodeStr: fromActivityLabel,
                toNodeStr: toActivityLabel,
                filterLoops: false,
                calculateCostImpact: false,
                variantType: "all_variants",
                taskType: "all_tasks",
                durationOperator: "N/A",
                durationActualFrom: 0,
                durationActualTo: 0,
                durationValue: "hrs",
                durationReductionType: "N/A",
                durationReductionPercentage: 0,
                durationReductionActual: 0,
                durationReductionValue: "hrs",
                mode: "new"
            }
        });
    }
    if (type === "cost") {
        let rule3 = "Cost: " + fromActivityLabel + " -> " + toActivityLabel;
        (0, $b66f0c13307de446$export$5d3a507e32e0a59b)({
            data: {
                rule: rule3,
                fromNode: fromActivity,
                toNode: toActivity,
                fromNodeStr: fromActivityLabel,
                toNodeStr: toActivityLabel,
                actualCost: 0,
                attribute: "",
                costType: "total",
                variantType: "all_variants",
                taskType: "all_tasks",
                durationOperator: "N/A",
                durationActualFrom: 0,
                durationActualTo: 0,
                durationValue: "hrs",
                mode: "new"
            }
        });
    }
}
function $57e66c5a34f265b4$export$41f8c4ddfb0d5041(type, ruleID) {
    if (type == "compliance") {
        for(let i = 0; i < $57e66c5a34f265b4$var$gComplianceRules.length; i++)if ($57e66c5a34f265b4$var$gComplianceRules[i].ruleID == parseInt(ruleID)) {
            let rule = $57e66c5a34f265b4$var$gComplianceRules[i].rule;
            let variantType = $57e66c5a34f265b4$var$gComplianceRules[i].variantType;
            let taskType = $57e66c5a34f265b4$var$gComplianceRules[i].taskType;
            let calculateCostImpact = $57e66c5a34f265b4$var$gComplianceRules[i].calculateCostImpact;
            let mode = "edit";
            let durationOperator = $57e66c5a34f265b4$var$gComplianceRules[i].durationOperator;
            let durationActualFrom = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualFrom;
            let durationActualTo = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualFrom;
            let durationValue = $57e66c5a34f265b4$var$gComplianceRules[i].durationValue;
            let fromNode = $57e66c5a34f265b4$var$gComplianceRules[i].fromActivity;
            let fromNodeStr = $57e66c5a34f265b4$var$gComplianceRules[i].fromActivityStr;
            let toNode = $57e66c5a34f265b4$var$gComplianceRules[i].toActivity;
            let toNodeStr = $57e66c5a34f265b4$var$gComplianceRules[i].toActivityStr;
            (0, $2e988fe81abc0213$export$26b82a75aae6bfed)({
                data: {
                    rule: rule,
                    fromNode: fromNode,
                    fromNodeStr: fromNodeStr,
                    toNode: toNode,
                    toNodeStr: toNodeStr,
                    filterLoops: false,
                    calculateCostImpact: calculateCostImpact,
                    variantType: variantType,
                    taskType: taskType,
                    durationOperator: durationOperator,
                    durationActualFrom: durationActualFrom,
                    durationActualTo: durationActualTo,
                    durationValue: durationValue,
                    mode: mode,
                    ruleID: ruleID
                }
            });
        }
    }
    if (type == "cost") {
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gCostRules.length; i1++)if ($57e66c5a34f265b4$var$gCostRules[i1].ruleID == ruleID) {
            let rule1 = $57e66c5a34f265b4$var$gCostRules[i1].rule;
            let costType = $57e66c5a34f265b4$var$gCostRules[i1].costType;
            let variantType1 = $57e66c5a34f265b4$var$gCostRules[i1].variantType;
            let taskType1 = $57e66c5a34f265b4$var$gCostRules[i1].taskType;
            let actualCost = $57e66c5a34f265b4$var$gCostRules[i1].actualCost;
            let attribute = $57e66c5a34f265b4$var$gCostRules[i1].attribute;
            let mode1 = "edit";
            let fromNode1 = $57e66c5a34f265b4$var$gCostRules[i1].fromActivity;
            let fromNodeStr1 = $57e66c5a34f265b4$var$gCostRules[i1].fromActivityStr;
            let toNode1 = $57e66c5a34f265b4$var$gCostRules[i1].toActivity;
            let toNodeStr1 = $57e66c5a34f265b4$var$gCostRules[i1].toActivityStr;
            (0, $b66f0c13307de446$export$5d3a507e32e0a59b)({
                data: {
                    rule: rule1,
                    fromNode: fromNode1,
                    fromNodeStr: fromNodeStr1,
                    toNode: toNode1,
                    toNodeStr: toNodeStr1,
                    actualCost: actualCost,
                    attribute: attribute,
                    costType: costType,
                    variantType: variantType1,
                    taskType: taskType1,
                    mode: mode1,
                    ruleID: ruleID
                }
            });
        }
    }
    if (type == "automation") {
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gAutomationRules.length; i2++)if ($57e66c5a34f265b4$var$gAutomationRules[i2].ruleID == ruleID) {
            let rule2 = $57e66c5a34f265b4$var$gAutomationRules[i2].rule;
            let variantType2 = $57e66c5a34f265b4$var$gAutomationRules[i2].variantType;
            let taskType2 = $57e66c5a34f265b4$var$gAutomationRules[i2].taskType;
            let durationOperator1 = $57e66c5a34f265b4$var$gAutomationRules[i2].durationOperator;
            let durationActualFrom1 = $57e66c5a34f265b4$var$gAutomationRules[i2].durationActualFrom;
            let durationActualTo1 = $57e66c5a34f265b4$var$gAutomationRules[i2].durationActualFrom;
            let durationValue1 = $57e66c5a34f265b4$var$gAutomationRules[i2].durationValue;
            let calculateCostImpact1 = $57e66c5a34f265b4$var$gAutomationRules[i2].calculateCostImpact;
            let mode2 = "edit";
            let fromNode2 = $57e66c5a34f265b4$var$gAutomationRules[i2].fromActivity;
            let fromNodeStr2 = $57e66c5a34f265b4$var$gAutomationRules[i2].fromActivityStr;
            let toNode2 = $57e66c5a34f265b4$var$gAutomationRules[i2].toActivity;
            let toNodeStr2 = $57e66c5a34f265b4$var$gAutomationRules[i2].toActivityStr;
            (0, $d2cffb3e3e561271$export$b8eacc044a97fdf9)({
                data: {
                    rule: rule2,
                    fromNode: fromNode2,
                    fromNodeStr: fromNodeStr2,
                    toNode: toNode2,
                    toNodeStr: toNodeStr2,
                    calculateCostImpact: calculateCostImpact1,
                    variantType: variantType2,
                    taskType: taskType2,
                    durationOperator: durationOperator1,
                    durationActualFrom: durationActualFrom1,
                    durationActualTo: durationActualTo1,
                    durationValue: durationValue1,
                    mode: mode2,
                    ruleID: ruleID
                }
            });
        }
    }
    if (type == "performance") {
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gPerformanceRules.length; i3++)if ($57e66c5a34f265b4$var$gPerformanceRules[i3].ruleID == ruleID) {
            let rule3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].rule;
            let variantType3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].variantType;
            let taskType3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].taskType;
            let calculateCostImpact2 = $57e66c5a34f265b4$var$gPerformanceRules[i3].calculateCostImpact;
            let durationOperator2 = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationOperator;
            let durationActualFrom2 = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationActualFrom;
            let durationActualTo2 = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationActualFrom;
            let durationValue2 = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationValue;
            let durationReductionType = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationReductionType;
            let durationReductionPercentage = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationReductionPercentage;
            let durationReductionActual = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationReductionActual;
            let durationReductionValue = $57e66c5a34f265b4$var$gPerformanceRules[i3].durationReductionValue;
            let mode3 = "edit";
            let fromNode3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].fromActivity;
            let fromNodeStr3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].fromActivityStr;
            let toNode3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].toActivity;
            let toNodeStr3 = $57e66c5a34f265b4$var$gPerformanceRules[i3].toActivityStr;
            (0, $1200978695fc35a8$export$9c10e13e2df2501e)({
                data: {
                    rule: rule3,
                    fromNode: fromNode3,
                    fromNodeStr: fromNodeStr3,
                    toNode: toNode3,
                    toNodeStr: toNodeStr3,
                    filterLoops: false,
                    calculateCostImpact: calculateCostImpact2,
                    variantType: variantType3,
                    taskType: taskType3,
                    durationOperator: durationOperator2,
                    durationActualFrom: durationActualFrom2,
                    durationActualTo: durationActualTo2,
                    durationValue: durationValue2,
                    durationReductionType: durationReductionType,
                    durationReductionPercentage: durationReductionPercentage,
                    durationReductionActual: durationReductionActual,
                    durationReductionValue: durationReductionValue,
                    mode: mode3,
                    ruleID: ruleID
                }
            });
        }
    }
}
function $57e66c5a34f265b4$export$eaaa0335bea12670(pane) {
    if (pane == "Steps" || pane == "StepsDiagram") {
        let textStr = "Include variants containing steps: ";
        if ($57e66c5a34f265b4$var$gStepSelectRetention == "exclude") textStr = "Exclude variants containing steps: ";
        for(let i = 0; i < $57e66c5a34f265b4$var$gSlicerSelectedSteps.length; i++){
            textStr = textStr + $57e66c5a34f265b4$var$gSlicerSelectedSteps[i].from_activity_name + " -> " + $57e66c5a34f265b4$var$gSlicerSelectedSteps[i].to_activity_name;
            if (i != $57e66c5a34f265b4$var$gSlicerSelectedSteps.length - 1) {
                if ($57e66c5a34f265b4$var$gStepSelectOperator == "or") textStr = textStr + " OR ";
                if ($57e66c5a34f265b4$var$gStepSelectOperator == "and") textStr = textStr + " AND ";
            }
        }
        const valueToPush = {};
        valueToPush["type"] = "Steps";
        valueToPush["description"] = textStr;
        valueToPush["operator"] = $57e66c5a34f265b4$var$gStepSelectOperator;
        valueToPush["retention"] = $57e66c5a34f265b4$var$gStepSelectRetention;
        valueToPush["steps"] = $57e66c5a34f265b4$var$gSlicerSelectedSteps;
        valueToPush["variants"] = $57e66c5a34f265b4$var$gStepPaneVariants;
        $57e66c5a34f265b4$var$gSlicerConditions.push(valueToPush);
    }
    if (pane == "Activities" || pane == "ActivitiesDiagram") {
        let textStr1 = "Include variants containing activities: ";
        if ($57e66c5a34f265b4$var$gActivitySelectRetention == "exclude") textStr1 = "Exclude variants containing activities: ";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gSlicerSelectedActivities.length; i1++){
            textStr1 = textStr1 + $57e66c5a34f265b4$var$gSlicerSelectedActivities[i1].activity_name;
            if (i1 != $57e66c5a34f265b4$var$gSlicerSelectedActivities.length - 1) {
                if ($57e66c5a34f265b4$var$gActivitySelectOperator == "or") textStr1 = textStr1 + " OR ";
                if ($57e66c5a34f265b4$var$gActivitySelectOperator == "and") textStr1 = textStr1 + " AND ";
            }
        }
        const valueToPush1 = {};
        valueToPush1["type"] = "Activities";
        valueToPush1["description"] = textStr1;
        valueToPush1["operator"] = $57e66c5a34f265b4$var$gStepSelectOperator;
        valueToPush1["retention"] = $57e66c5a34f265b4$var$gStepSelectRetention;
        valueToPush1["activities"] = $57e66c5a34f265b4$var$gSlicerSelectedActivities;
        valueToPush1["variants"] = $57e66c5a34f265b4$var$gActivityPaneVariants;
        $57e66c5a34f265b4$var$gSlicerConditions.push(valueToPush1);
    }
    if (pane == "Path") {
        let textStr2 = "Include variants containing activities ";
        if ($57e66c5a34f265b4$var$gStepSelectRetention == "exclude") textStr2 = "Exclude variants containing activities ";
        let fromStr = "";
        let toStr = "";
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gPathFrom.length; i2++){
            fromStr = fromStr + $57e66c5a34f265b4$var$gPathFrom[i2].n;
            if (i2 < $57e66c5a34f265b4$var$gPathFrom.length - 1) fromStr = fromStr + ", ";
        }
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gPathTo.length; i3++){
            toStr = toStr + $57e66c5a34f265b4$var$gPathTo[i3].n;
            if (i3 < $57e66c5a34f265b4$var$gPathTo.length - 1) toStr = toStr + ", ";
        }
        textStr2 = textStr2 + "(" + fromStr + ") " + $57e66c5a34f265b4$var$gPathAttribute.toLowerCase() + " by (" + toStr + ")";
        const valueToPush2 = {};
        valueToPush2["type"] = "Path";
        valueToPush2["description"] = textStr2;
        valueToPush2["retention"] = $57e66c5a34f265b4$var$gStepSelectRetention;
        valueToPush2["predicate"] = $57e66c5a34f265b4$var$gPathAttribute;
        valueToPush2["path_from"] = $57e66c5a34f265b4$var$gPathFrom;
        valueToPush2["path_to"] = $57e66c5a34f265b4$var$gPathTo;
        valueToPush2["variants"] = $57e66c5a34f265b4$var$gPathPaneVariants;
        $57e66c5a34f265b4$var$gSlicerConditions.push(valueToPush2);
    }
    if (pane == "Tasks") {
        let textStr3 = "Include variants containing tasks: ";
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gSlicerSelectedTasks.length; i4++){
            textStr3 = textStr3 + $57e66c5a34f265b4$var$gSlicerSelectedTasks[i4].task;
            if (i4 != $57e66c5a34f265b4$var$gSlicerSelectedTasks.length - 1) textStr3 = textStr3 + ", ";
        }
        const valueToPush3 = {};
        valueToPush3["type"] = "Tasks";
        valueToPush3["description"] = textStr3;
        valueToPush3["tasks"] = $57e66c5a34f265b4$var$gSlicerSelectedTasks;
        valueToPush3["variants"] = $57e66c5a34f265b4$var$gTaskPaneVariants;
        $57e66c5a34f265b4$var$gSlicerConditions.push(valueToPush3);
    }
}
function $57e66c5a34f265b4$export$dd3986409eddbcdc(pane) {
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.filtered - b.filtered);
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        if ($57e66c5a34f265b4$var$gVariantArray[i].filtered == 1) break;
        if ((pane == "Steps" || pane == "StepsDiagram") && $57e66c5a34f265b4$var$gVariantArray[i].sliced == true) {
            let sliced1 = false;
            for(let j = 0; j < $57e66c5a34f265b4$var$gStepPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gStepPaneVariants[j].v == $57e66c5a34f265b4$var$gVariantArray[i].v) {
                sliced1 = true;
                break;
            }
            $57e66c5a34f265b4$var$gVariantArray[i].sliced = sliced1;
        }
        if ((pane == "Activities" || pane == "ActivitiesDiagram") && $57e66c5a34f265b4$var$gVariantArray[i].sliced == true) {
            let sliced2 = false;
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gActivityPaneVariants[j1].v == $57e66c5a34f265b4$var$gVariantArray[i].v) {
                sliced2 = true;
                break;
            }
            $57e66c5a34f265b4$var$gVariantArray[i].sliced = sliced2;
        }
        if (pane == "Path" && $57e66c5a34f265b4$var$gVariantArray[i].sliced == true) {
            let sliced3 = false;
            for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gPathPaneVariants.length; j2++)if ($57e66c5a34f265b4$var$gPathPaneVariants[j2].v == $57e66c5a34f265b4$var$gVariantArray[i].v) {
                sliced3 = true;
                break;
            }
            $57e66c5a34f265b4$var$gVariantArray[i].sliced = sliced3;
        }
    }
    // update variant tasks sliced
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>b.t - a.t);
    let selected = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        if ($57e66c5a34f265b4$var$gVariantArray[i1].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gVariantArray[i1].sliced == true && selected < $57e66c5a34f265b4$var$gDefaultVariantsSelected) {
            $57e66c5a34f265b4$var$gVariantArray[i1].selected = 1;
            selected++;
        } else $57e66c5a34f265b4$var$gVariantArray[i1].selected = 0;
    }
    $57e66c5a34f265b4$export$f39f7d9ecc34d6d6(pane);
    $57e66c5a34f265b4$export$29e7d345ec013547();
    $57e66c5a34f265b4$var$generateTaskAnalyticsArray("apply slicer");
    $57e66c5a34f265b4$var$generateEventAnalyticsArray();
}
const $57e66c5a34f265b4$export$173c36ecb0f12905 = (attribute)=>{
    $57e66c5a34f265b4$var$gPathPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gPathAttribute = attribute;
    if ($57e66c5a34f265b4$var$gPathFrom.length == 0 || $57e66c5a34f265b4$var$gPathTo.length == 0) return;
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant - b.variant || a.sort_key - b.sort_key);
    let variant = "";
    let valid_from = false;
    let valid_to = false;
    let slicerSelectedPath = [];
    $57e66c5a34f265b4$var$gPathPaneVariants.length = 0;
    $57e66c5a34f265b4$var$gPathAttribute = attribute;
    if ($57e66c5a34f265b4$var$gPathSelectOperator == "or") {
        if ($57e66c5a34f265b4$var$gPathAttribute == "Eventually Followed" || $57e66c5a34f265b4$var$gPathAttribute == "Not Eventually Followed") {
            for(let i = 0; i < $57e66c5a34f265b4$var$gLinkArray.length; i++){
                if ($57e66c5a34f265b4$var$gLinkArray[i].variant != variant && $57e66c5a34f265b4$var$gLinkArray[i].duplicate === false) {
                    if (i > 0) {
                        if (valid_from == true && valid_to == true) {
                            let exists = false;
                            for(let j = 0; j < $57e66c5a34f265b4$var$gPathPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gPathPaneVariants[j].v == variant) {
                                exists = true;
                                break;
                            }
                            if (exists == false) {
                                const valueToPush = {};
                                valueToPush["v"] = variant;
                                $57e66c5a34f265b4$var$gPathPaneVariants.push(valueToPush);
                            }
                        }
                        variant = $57e66c5a34f265b4$var$gLinkArray[i].variant;
                        valid_from = false;
                        if ($57e66c5a34f265b4$var$gPathAttribute == "Eventually Followed") valid_to = false;
                        if ($57e66c5a34f265b4$var$gPathAttribute == "Not Eventually Followed") valid_to = true;
                    }
                }
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gPathFrom.length; j1++)if ($57e66c5a34f265b4$var$gPathFrom[j1].a == $57e66c5a34f265b4$var$gLinkArray[i].from && $57e66c5a34f265b4$var$gLinkArray[i].duplicate === false) {
                    valid_from = true;
                    break;
                }
                for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gPathTo.length; j2++){
                    if ($57e66c5a34f265b4$var$gPathAttribute == "Eventually Followed") {
                        if ($57e66c5a34f265b4$var$gPathTo[j2].a == $57e66c5a34f265b4$var$gLinkArray[i].to && valid_from == true && $57e66c5a34f265b4$var$gLinkArray[i].duplicate === false) {
                            valid_to = true;
                            break;
                        }
                    }
                    if ($57e66c5a34f265b4$var$gPathAttribute == "Not Eventually Followed") {
                        if ($57e66c5a34f265b4$var$gPathTo[j2].a == $57e66c5a34f265b4$var$gLinkArray[i].to && valid_from == true && $57e66c5a34f265b4$var$gLinkArray[i].duplicate === false) {
                            valid_to = false;
                            break;
                        }
                    }
                }
            }
            if (valid_from == true && valid_to == true) {
                let exists1 = false;
                for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gPathPaneVariants.length; j3++)if ($57e66c5a34f265b4$var$gPathPaneVariants[j3].v == variant) {
                    exists1 = true;
                    break;
                }
                if (exists1 == false) {
                    const valueToPush1 = {};
                    valueToPush1["v"] = variant;
                    $57e66c5a34f265b4$var$gPathPaneVariants.push(valueToPush1);
                }
            }
        }
        if ($57e66c5a34f265b4$var$gPathAttribute == "Directly Followed") {
            for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gLinkArray.length; i1++){
                let valid_link = 0;
                for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gPathFrom.length; j4++)if ($57e66c5a34f265b4$var$gPathFrom[j4].a == $57e66c5a34f265b4$var$gLinkArray[i1].from && $57e66c5a34f265b4$var$gLinkArray[i1].duplicate === false) {
                    for(let k = 0; k < $57e66c5a34f265b4$var$gPathTo.length; k++)if ($57e66c5a34f265b4$var$gPathTo[k].a == $57e66c5a34f265b4$var$gLinkArray[i1].to) {
                        valid_link = 1;
                        break;
                    }
                }
                // check to see if it exists in slicerSelectedPath
                if (valid_link == 1) {
                    let exists2 = false;
                    for(let k1 = 0; k1 < slicerSelectedPath.length; k1++)if (slicerSelectedPath[k1].from_activity == $57e66c5a34f265b4$var$gLinkArray[i1].from && slicerSelectedPath[k1].to_activity == $57e66c5a34f265b4$var$gLinkArray[i1].to) {
                        exists2 = true;
                        break;
                    }
                    if (exists2 == false) {
                        const valueToPush2 = {};
                        valueToPush2["from_activity"] = $57e66c5a34f265b4$var$gLinkArray[i1].from;
                        valueToPush2["to_activity"] = $57e66c5a34f265b4$var$gLinkArray[i1].to;
                        slicerSelectedPath.push(valueToPush2);
                    }
                }
            }
            for(let j5 = 0; j5 < $57e66c5a34f265b4$var$gLinkArray.length; j5++){
                for(let k2 = 0; k2 < slicerSelectedPath.length; k2++)if ($57e66c5a34f265b4$var$gLinkArray[j5].from == slicerSelectedPath[k2].from_activity && $57e66c5a34f265b4$var$gLinkArray[j5].to == slicerSelectedPath[k2].to_activity && $57e66c5a34f265b4$var$gLinkArray[j5].duplicate === false) {
                    let exists3 = false;
                    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gPathPaneVariants.length; i2++)if ($57e66c5a34f265b4$var$gPathPaneVariants[i2].v == $57e66c5a34f265b4$var$gLinkArray[j5].variant) {
                        exists3 = true;
                        break;
                    }
                    if (exists3 == false) {
                        const valueToPush3 = {};
                        valueToPush3["v"] = $57e66c5a34f265b4$var$gLinkArray[j5].variant;
                        $57e66c5a34f265b4$var$gPathPaneVariants.push(valueToPush3);
                    }
                }
            }
        }
        if ($57e66c5a34f265b4$var$gPathAttribute == "Not Directly Followed") for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gVariantArray.length; i3++){
            let validVariant = true;
            for(let j6 = 0; j6 < $57e66c5a34f265b4$var$gLinkArray.length; j6++)if ($57e66c5a34f265b4$var$gLinkArray[j6].variant == $57e66c5a34f265b4$var$gVariantArray[i3].v && $57e66c5a34f265b4$var$gLinkArray[i3].duplicate === false) {
                for(let k3 = 0; k3 < $57e66c5a34f265b4$var$gPathFrom.length; k3++)if ($57e66c5a34f265b4$var$gPathFrom[k3].a == $57e66c5a34f265b4$var$gLinkArray[j6].from) {
                    for(let l = 0; l < $57e66c5a34f265b4$var$gPathTo.length; l++)if ($57e66c5a34f265b4$var$gPathTo[l].a == $57e66c5a34f265b4$var$gLinkArray[j6].to) {
                        validVariant = false;
                        break;
                    }
                }
                if (validVariant == false) break;
            }
            if (validVariant == true) {
                const valueToPush4 = {};
                valueToPush4["v"] = $57e66c5a34f265b4$var$gVariantArray[i3].v;
                $57e66c5a34f265b4$var$gPathPaneVariants.push(valueToPush4);
            }
        }
    }
    if ($57e66c5a34f265b4$var$gPathSelectRetention == "exclude") {
        let tempArray = [];
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gVariantArray.length; i4++){
            let exists4 = false;
            for(let k4 = 0; k4 < $57e66c5a34f265b4$var$gPathPaneVariants.length; k4++)if ($57e66c5a34f265b4$var$gPathPaneVariants[k4].v == $57e66c5a34f265b4$var$gVariantArray[i4].v) {
                exists4 = true;
                break;
            }
            if (exists4 == false) {
                const valueToPush5 = {};
                valueToPush5["v"] = $57e66c5a34f265b4$var$gVariantArray[i4].v;
                tempArray.push(valueToPush5);
            }
        }
        $57e66c5a34f265b4$var$gPathPaneVariants = tempArray;
    }
};
function $57e66c5a34f265b4$export$29e7d345ec013547() {
    let startNode = 0;
    let endNode = 0;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].start_node == true) startNode = $57e66c5a34f265b4$var$gActivityArray[j].a;
        if ($57e66c5a34f265b4$var$gActivityArray[j].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j].a;
    }
    $57e66c5a34f265b4$var$gVariantsSliced = 0;
    $57e66c5a34f265b4$var$gNonCompliantVariants = 0;
    $57e66c5a34f265b4$var$gNonCompliantTasks = 0;
    $57e66c5a34f265b4$var$gNonCompliantEvents = 0;
    $57e66c5a34f265b4$var$gAutomatedVariants = 0;
    $57e66c5a34f265b4$var$gAutomatedTasks = 0;
    $57e66c5a34f265b4$var$gAutomatedEvents = 0;
    $57e66c5a34f265b4$var$gActualCost = 0;
    $57e66c5a34f265b4$var$gForecastCost = 0;
    $57e66c5a34f265b4$var$gVariantEventsSliced = 0;
    $57e66c5a34f265b4$var$gVariantTasksSliced = 0;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.filtered - b.filtered);
    for(let i = 0; i < $57e66c5a34f265b4$var$gVariantArray.length; i++){
        if ($57e66c5a34f265b4$var$gVariantArray[i].filtered == true) break;
        if ($57e66c5a34f265b4$var$gVariantArray[i].sliced == true) {
            $57e66c5a34f265b4$var$gVariantsSliced++;
            if ($57e66c5a34f265b4$var$gVariantArray[i].automated == true) $57e66c5a34f265b4$var$gAutomatedVariants++;
            if ($57e66c5a34f265b4$var$gVariantArray[i].compliant == false) $57e66c5a34f265b4$var$gNonCompliantVariants++;
            $57e66c5a34f265b4$var$gActualCost = $57e66c5a34f265b4$var$gActualCost + $57e66c5a34f265b4$var$gVariantArray[i].actual_cost;
            $57e66c5a34f265b4$var$gForecastCost = $57e66c5a34f265b4$var$gForecastCost + $57e66c5a34f265b4$var$gVariantArray[i].forecast_cost;
            $57e66c5a34f265b4$var$gVariantEventsSliced = $57e66c5a34f265b4$var$gVariantEventsSliced + $57e66c5a34f265b4$var$gVariantArray[i].e;
            $57e66c5a34f265b4$var$gVariantTasksSliced = $57e66c5a34f265b4$var$gVariantTasksSliced + $57e66c5a34f265b4$var$gVariantArray[i].t;
        }
    }
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskArray.length; i1++)if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i1].vid].sliced == true) {
        if ($57e66c5a34f265b4$var$gTaskArray[i1].automated == true) $57e66c5a34f265b4$var$gAutomatedTasks++;
        if ($57e66c5a34f265b4$var$gTaskArray[i1].compliant == false) $57e66c5a34f265b4$var$gNonCompliantTasks++;
    }
    $57e66c5a34f265b4$var$gEventLogArray = $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.filtered - b.filtered || a.v - b.v);
    $57e66c5a34f265b4$var$gVariantArray = $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    let i2 = 0;
    for(i2 = 0; i2 < $57e66c5a34f265b4$var$gEventLogArray.length; i2++){
        if ($57e66c5a34f265b4$var$gEventLogArray[i2].filtered == 1) break;
        if ($57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i2].vid].sliced == true) {
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].automated == true) $57e66c5a34f265b4$var$gAutomatedEvents++;
            if ($57e66c5a34f265b4$var$gEventLogArray[i2].compliant == false) $57e66c5a34f265b4$var$gNonCompliantEvents++;
        }
    }
    // need to check if there is a rule that updates forecast cost before setting gPercCostSaving
    let costRuleExists = false;
    for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gComplianceRules.length; i3++)if ($57e66c5a34f265b4$var$gComplianceRules[i3].calculateCostImpact === true) costRuleExists = true;
    for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gPerformanceRules.length; i4++)if ($57e66c5a34f265b4$var$gPerformanceRules[i4].calculateCostImpact === true) costRuleExists = true;
    for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gAutomationRules.length; i5++)if ($57e66c5a34f265b4$var$gAutomationRules[i5].calculateCostImpact === true) costRuleExists = true;
    if ($57e66c5a34f265b4$var$gActualCost != 0 && costRuleExists === true) $57e66c5a34f265b4$var$gPercCostSaving = ($57e66c5a34f265b4$var$gActualCost - $57e66c5a34f265b4$var$gForecastCost) / $57e66c5a34f265b4$var$gActualCost * 100;
    else $57e66c5a34f265b4$var$gPercCostSaving = 0;
    $57e66c5a34f265b4$var$gCostSaving = $57e66c5a34f265b4$var$gActualCost - $57e66c5a34f265b4$var$gForecastCost;
    let selectedActivities = [];
    for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gLinkArray.length; j1++)if ($57e66c5a34f265b4$var$gLinkArray[j1].duplicate === false) {
        let sliced1 = false;
        for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gVariantArray.length; i6++)if ($57e66c5a34f265b4$var$gLinkArray[j1].variant == $57e66c5a34f265b4$var$gVariantArray[i6].v && $57e66c5a34f265b4$var$gVariantArray[i6].sliced == true && $57e66c5a34f265b4$var$gVariantArray[i6].filtered == 0) {
            sliced1 = true;
            break;
        }
        if (sliced1 == true) {
            let exists = false;
            for(let k = 0; k < selectedActivities.length; k++)if ($57e66c5a34f265b4$var$gLinkArray[j1].from == selectedActivities[k].a) {
                exists = true;
                break;
            }
            if (exists == false && $57e66c5a34f265b4$var$gLinkArray[j1].from != startNode) {
                const valueToPush = [];
                valueToPush["a"] = $57e66c5a34f265b4$var$gLinkArray[j1].from;
                selectedActivities.push(valueToPush);
            }
            exists = false;
            for(let k1 = 0; k1 < selectedActivities.length; k1++)if ($57e66c5a34f265b4$var$gLinkArray[j1].to == selectedActivities[k1].a) {
                exists = true;
                break;
            }
            if (exists == false && $57e66c5a34f265b4$var$gLinkArray[j1].to != endNode) {
                const valueToPush1 = [];
                valueToPush1["a"] = $57e66c5a34f265b4$var$gLinkArray[j1].to;
                selectedActivities.push(valueToPush1);
            }
        }
    }
    $57e66c5a34f265b4$var$gVariantActivitiesSliced = selectedActivities.length - 2; // don't count start and end
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant - b.variant || a.from - b.from || a.to - b.to);
    let selectedSteps = [];
    for(let i7 = 0; i7 < $57e66c5a34f265b4$var$gLinkArray.length; i7++)if ($57e66c5a34f265b4$var$gLinkArray[i7].duplicate === false) {
        for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gVariantArray.length; j2++)if ($57e66c5a34f265b4$var$gVariantArray[j2].v == $57e66c5a34f265b4$var$gLinkArray[i7].variant && $57e66c5a34f265b4$var$gVariantArray[j2].sliced == true) {
            let exists1 = false;
            for(let k2 = 0; k2 < selectedSteps.length; k2++)if (selectedSteps[k2].f == $57e66c5a34f265b4$var$gLinkArray[i7].from && selectedSteps[k2].t == $57e66c5a34f265b4$var$gLinkArray[i7].to) {
                exists1 = true;
                break;
            }
            if (exists1 == false && $57e66c5a34f265b4$var$gLinkArray[i7].end_node == false) {
                const valueToPush2 = [];
                valueToPush2["f"] = $57e66c5a34f265b4$var$gLinkArray[i7].from;
                valueToPush2["t"] = $57e66c5a34f265b4$var$gLinkArray[i7].to;
                selectedSteps.push(valueToPush2);
            }
        }
    }
    $57e66c5a34f265b4$var$gVariantStepsSliced = selectedSteps.length;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.s - b.s);
    $57e66c5a34f265b4$var$gAnimateVariant = 0;
    $57e66c5a34f265b4$var$gLifecycleVariant = 0;
}
const $57e66c5a34f265b4$export$abce13b877a5437d = (selection)=>{
    if (selection == "") {
        if ($57e66c5a34f265b4$var$gStepSlicerSelection.length > 0) selection = $57e66c5a34f265b4$var$gStepSlicerSelection;
        else return;
    } else {
        if (selection.length == 0) return;
    }
    $57e66c5a34f265b4$var$gStepSlicerSelection = selection;
    $57e66c5a34f265b4$var$gSlicerSelectedSteps = [];
    for(let i = 0; i < selection.length; i++){
        let from_activity = "";
        let to_activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].from_activity) from_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
            if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].to_activity) to_activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
        }
        const valueToPush = {};
        valueToPush["from_activity"] = from_activity;
        valueToPush["to_activity"] = to_activity;
        valueToPush["from_activity_name"] = selection[i].from_activity;
        valueToPush["to_activity_name"] = selection[i].to_activity;
        $57e66c5a34f265b4$var$gSlicerSelectedSteps.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gStepPaneVariants.length = [];
    let validVariant = false;
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant - b.variant);
    if ($57e66c5a34f265b4$var$gStepSelectOperator == "or") for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        validVariant = false;
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gLinkArray.length; j1++){
            if ($57e66c5a34f265b4$var$gLinkArray[j1].variant == $57e66c5a34f265b4$var$gVariantArray[i1].v && $57e66c5a34f265b4$var$gLinkArray[j1].duplicate === false) {
                for(let k = 0; k < $57e66c5a34f265b4$var$gSlicerSelectedSteps.length; k++)if ($57e66c5a34f265b4$var$gLinkArray[j1].from == $57e66c5a34f265b4$var$gSlicerSelectedSteps[k].from_activity && $57e66c5a34f265b4$var$gLinkArray[j1].to == $57e66c5a34f265b4$var$gSlicerSelectedSteps[k].to_activity) {
                    validVariant = true;
                    break;
                }
            }
            if (validVariant == true) break;
        }
        if (validVariant == true) {
            const valueToPush1 = {};
            valueToPush1["v"] = $57e66c5a34f265b4$var$gVariantArray[i1].v;
            $57e66c5a34f265b4$var$gStepPaneVariants.push(valueToPush1);
        }
    }
    if ($57e66c5a34f265b4$var$gStepSelectOperator == "and") for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++){
        validVariant = true;
        for(let k1 = 0; k1 < $57e66c5a34f265b4$var$gSlicerSelectedSteps.length; k1++){
            let stepExists = false;
            for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gLinkArray.length; j2++)if ($57e66c5a34f265b4$var$gLinkArray[j2].from == $57e66c5a34f265b4$var$gSlicerSelectedSteps[k1].from_activity && $57e66c5a34f265b4$var$gLinkArray[j2].to == $57e66c5a34f265b4$var$gSlicerSelectedSteps[k1].to_activity && $57e66c5a34f265b4$var$gVariantArray[i2].v == $57e66c5a34f265b4$var$gLinkArray[j2].variant && $57e66c5a34f265b4$var$gLinkArray[j2].duplicate === false) {
                stepExists = true;
                break;
            }
            if (stepExists == false) {
                validVariant = false;
                break;
            }
        }
        if (validVariant == true) {
            const valueToPush2 = {};
            valueToPush2["v"] = $57e66c5a34f265b4$var$gVariantArray[i2].v;
            $57e66c5a34f265b4$var$gStepPaneVariants.push(valueToPush2);
        }
    }
    if ($57e66c5a34f265b4$var$gStepSelectRetention == "exclude") {
        let tempArray = [];
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gVariantArray.length; i3++){
            let exists = false;
            for(let k2 = 0; k2 < $57e66c5a34f265b4$var$gStepPaneVariants.length; k2++)if ($57e66c5a34f265b4$var$gStepPaneVariants[k2].v == $57e66c5a34f265b4$var$gVariantArray[i3].v) {
                exists = true;
                break;
            }
            if (exists == false) {
                const valueToPush3 = {};
                valueToPush3["v"] = $57e66c5a34f265b4$var$gVariantArray[i3].v;
                tempArray.push(valueToPush3);
            }
        }
        $57e66c5a34f265b4$var$gStepPaneVariants = tempArray;
    }
};
const $57e66c5a34f265b4$export$96c37a8461240523 = (selection)=>{
    $57e66c5a34f265b4$var$gDetailTaskVariantsSelected = [];
    $57e66c5a34f265b4$var$gDetailTaskTasksSelected = [];
    let valueToPush = {};
    for(let i = 0; i < selection.length; i++){
        var exists = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gDetailTaskVariantsSelected.length; j++)if ($57e66c5a34f265b4$var$gDetailTaskVariantsSelected[j].vid === selection[i].vid) {
            exists = true;
            break;
        }
        if (exists === false) {
            valueToPush = {};
            valueToPush["vid"] = selection[i].vid;
            $57e66c5a34f265b4$var$gDetailTaskVariantsSelected.push(valueToPush);
        }
        valueToPush = {};
        valueToPush["id"] = selection[i].id;
        valueToPush["k"] = selection[i].k;
        $57e66c5a34f265b4$var$gDetailTaskTasksSelected.push(valueToPush);
    }
};
const $57e66c5a34f265b4$export$a7535bd1ac565e5e = (selection)=>{
    if (selection == "") {
        if ($57e66c5a34f265b4$var$gTaskSlicerSelection.length > 0) selection = $57e66c5a34f265b4$var$gTaskSlicerSelection;
        else return;
    } else {
        if (selection.length == 0) return;
    }
    $57e66c5a34f265b4$var$gTaskSlicerSelection = selection;
    $57e66c5a34f265b4$var$gSlicerSelectedTasks = [];
    for(let i = 0; i < selection.length; i++){
        const valueToPush = {};
        valueToPush["task"] = selection[i].task;
        valueToPush["vid"] = selection[i].variant_id;
        $57e66c5a34f265b4$var$gSlicerSelectedTasks.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gTaskPaneVariants.length = [];
    let variantExists = false;
    $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gSlicerSelectedTasks.length; i1++){
        let variant = $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gSlicerSelectedTasks[i1].vid].v;
        variantExists = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gTaskPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gTaskPaneVariants[j].v == variant) {
            variantExists = true;
            break;
        }
        if (variantExists == false) {
            const valueToPush1 = {};
            valueToPush1["v"] = variant;
            $57e66c5a34f265b4$var$gTaskPaneVariants.push(valueToPush1);
        }
    }
};
const $57e66c5a34f265b4$export$f1b23d69b077eb32 = (selection)=>{
    if (selection == "") {
        if ($57e66c5a34f265b4$var$gActivitieSlicerSelection.length > 0) selection = $57e66c5a34f265b4$var$gActivitieSlicerSelection;
        else return;
    } else {
        if (selection.length == 0) return;
    }
    $57e66c5a34f265b4$var$gActivitieSlicerSelection = selection;
    $57e66c5a34f265b4$var$gSlicerSelectedActivities = [];
    for(let i = 0; i < selection.length; i++){
        let activity = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].activity) activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
        const valueToPush = {};
        valueToPush["activity"] = activity;
        valueToPush["activity_name"] = selection[i].activity;
        $57e66c5a34f265b4$var$gSlicerSelectedActivities.push(valueToPush);
    }
    $57e66c5a34f265b4$var$gActivityPaneVariants.length = [];
    let validVariant = false;
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant - b.variant);
    if ($57e66c5a34f265b4$var$gActivitySelectOperator == "or") for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gVariantArray.length; i1++){
        validVariant = false;
        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gLinkArray.length; j1++){
            if ($57e66c5a34f265b4$var$gLinkArray[j1].variant == $57e66c5a34f265b4$var$gVariantArray[i1].v && $57e66c5a34f265b4$var$gLinkArray[j1].duplicate === false) {
                for(let k = 0; k < $57e66c5a34f265b4$var$gSlicerSelectedActivities.length; k++)if ($57e66c5a34f265b4$var$gLinkArray[j1].to == $57e66c5a34f265b4$var$gSlicerSelectedActivities[k].activity) {
                    validVariant = true;
                    break;
                }
            }
            if (validVariant == true) break;
        }
        if (validVariant == true) {
            const valueToPush1 = {};
            valueToPush1["v"] = $57e66c5a34f265b4$var$gVariantArray[i1].v;
            $57e66c5a34f265b4$var$gActivityPaneVariants.push(valueToPush1);
        }
    }
    if ($57e66c5a34f265b4$var$gActivitySelectOperator == "and") for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++){
        validVariant = true;
        for(let k1 = 0; k1 < $57e66c5a34f265b4$var$gSlicerSelectedActivities.length; k1++){
            let ActivityExists = false;
            for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gLinkArray.length; j2++)if ($57e66c5a34f265b4$var$gLinkArray[j2].to == $57e66c5a34f265b4$var$gSlicerSelectedActivities[k1].activity && $57e66c5a34f265b4$var$gVariantArray[i2].v == $57e66c5a34f265b4$var$gLinkArray[j2].variant) {
                ActivityExists = true;
                break;
            }
            if (ActivityExists == false) {
                validVariant = false;
                break;
            }
        }
        if (validVariant == true) {
            const valueToPush2 = {};
            valueToPush2["v"] = $57e66c5a34f265b4$var$gVariantArray[i2].v;
            $57e66c5a34f265b4$var$gActivityPaneVariants.push(valueToPush2);
        }
    }
    if ($57e66c5a34f265b4$var$gActivitySelectRetention == "exclude") {
        let tempArray = [];
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gVariantArray.length; i3++){
            let exists = false;
            for(let k2 = 0; k2 < $57e66c5a34f265b4$var$gActivityPaneVariants.length; k2++)if ($57e66c5a34f265b4$var$gActivityPaneVariants[k2].v == $57e66c5a34f265b4$var$gVariantArray[i3].v) {
                exists = true;
                break;
            }
            if (exists == false) {
                const valueToPush3 = {};
                valueToPush3["v"] = $57e66c5a34f265b4$var$gVariantArray[i3].v;
                tempArray.push(valueToPush3);
            }
        }
        $57e66c5a34f265b4$var$gActivityPaneVariants = tempArray;
    }
};
const $57e66c5a34f265b4$export$506d0bd6276167fc = (selection, type)=>{
    let activity;
    if (type == "from") {
        $57e66c5a34f265b4$var$gPathFrom.length = 0;
        for(let i = 0; i < selection.length; i++){
            for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++)if ($57e66c5a34f265b4$var$gActivityArray[j].activity == selection[i].activity) {
                activity = $57e66c5a34f265b4$var$gActivityArray[j].id;
                break;
            }
            let valueToPush = {};
            valueToPush["a"] = activity;
            valueToPush["n"] = selection[i].activity;
            $57e66c5a34f265b4$var$gPathFrom.push(valueToPush);
        }
    }
    if (type == "to") {
        $57e66c5a34f265b4$var$gPathTo.length = 0;
        for(let i1 = 0; i1 < selection.length; i1++){
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].activity == selection[i1].activity) {
                activity = $57e66c5a34f265b4$var$gActivityArray[j1].id;
                break;
            }
            let valueToPush1 = {};
            valueToPush1["a"] = activity;
            valueToPush1["n"] = selection[i1].activity;
            $57e66c5a34f265b4$var$gPathTo.push(valueToPush1);
        }
    }
};
function $57e66c5a34f265b4$export$ce51aec31be8dc1a(field, type) {
    let fieldExists = false;
    let index = null;
    for(let i = 0; i < $57e66c5a34f265b4$var$gTransformation.length; i++)if ($57e66c5a34f265b4$var$gTransformation[i].field === field) {
        fieldExists = true;
        index = i;
    }
    let status = true;
    let issue = "";
    if (index != null) {
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === $57e66c5a34f265b4$var$gEntityUpper + " ID" && type != "Text") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " ID must be mapped to data type text";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === "Activity" && type != "Text") {
            status = false;
            issue = "Activity must be mapped to data type text";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === "Timestamp" && type != "Datetime") {
            status = false;
            issue = "Timestamp must be mapped to data type datetime";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === "Resource" && type != "Text") {
            status = false;
            issue = "Resource must be mapped to data type text";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === $57e66c5a34f265b4$var$gEntityUpper + " Create Time" && type != "Datetime") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " Create Time must be mapped to data type datetime";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === $57e66c5a34f265b4$var$gEntityUpper + " Closed Time" && type != "Datetime") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " Close Time must be mapped to data type datetime";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].dataType === "") {
            status = false;
            issue = "Please choose a data mapping";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].mapping === "") {
            status = false;
            issue = "Please choose a column mapping";
        }
    }
    // number
    // datetime
    if (type === "Number") {
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gUploadFileArray.length; i1++)if (isNaN($57e66c5a34f265b4$var$gUploadFileArray[i1][field])) {
            status = false;
            issue = "Field is not a number";
            break;
        }
    }
    if (type === "Datetime") {
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gUploadFileArray.length; i2++)if (isNaN(Date.parse($57e66c5a34f265b4$var$gUploadFileArray[i2][field]))) {
            status = false;
            issue = "Field is not a datetime";
            break;
        }
    }
    if (fieldExists === true) {
        $57e66c5a34f265b4$var$gTransformation[index].status = false;
        $57e66c5a34f265b4$var$gTransformation[index].dataType = type;
        $57e66c5a34f265b4$var$gTransformation[index].field = field;
        $57e66c5a34f265b4$var$gTransformation[index].status = status;
        $57e66c5a34f265b4$var$gTransformation[index].issue = issue;
    } else {
        let valueToPush = {};
        valueToPush["field"] = field;
        valueToPush["dataType"] = type;
        valueToPush["mapping"] = "";
        valueToPush["status"] = status;
        valueToPush["issue"] = issue;
        $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
    }
}
function $57e66c5a34f265b4$export$f74994b6a62d0315(field, mapping) {
    let mappingExists = false;
    let fieldExists = false;
    let index = null;
    let allowMultipleMappings = true;
    if (mapping === $57e66c5a34f265b4$var$gEntityUpper + " ID" || mapping === "Activity" || mapping === "Timestamp" || mapping === "Resource" || mapping === $57e66c5a34f265b4$var$gEntityUpper + " Create Time" || mapping === $57e66c5a34f265b4$var$gEntityUpper + " Close Time") allowMultipleMappings = false;
    for(let i = 0; i < $57e66c5a34f265b4$var$gTransformation.length; i++){
        if ($57e66c5a34f265b4$var$gTransformation[i].field === field && fieldExists == false) {
            fieldExists = true;
            index = i;
        }
        if ($57e66c5a34f265b4$var$gTransformation[i].mapping === mapping && allowMultipleMappings === false) mappingExists = true;
        if ($57e66c5a34f265b4$var$gTransformation[i].mapping === mapping && $57e66c5a34f265b4$var$gTransformation[i].status === false) {
            mappingExists = true;
            index = i;
        }
    }
    let status = true;
    let issue = "";
    if (index != null) {
        if (mapping === $57e66c5a34f265b4$var$gEntityUpper + " ID" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Text") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " ID must be mapped to data type text";
        }
        if (mapping === "Activity" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Text") {
            status = false;
            issue = "Activity must be mapped to data type text";
        }
        if (mapping === "Timestamp" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Datetime") {
            status = false;
            issue = "Timestamp must be mapped to data type datetime";
        }
        if (mapping === "Resource" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Text") {
            status = false;
            issue = "Resource must be mapped to data type text";
        }
        if (mapping === $57e66c5a34f265b4$var$gEntityUpper + " Create Time" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Datetime") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " Create Time must be mapped to data type datetime";
        }
        if (mapping === $57e66c5a34f265b4$var$gEntityUpper + " Closed Time" && $57e66c5a34f265b4$var$gTransformation[index].dataType != "Datetime") {
            status = false;
            issue = $57e66c5a34f265b4$var$gEntityUpper + " Close Time must be mapped to data type datetime";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].dataType === "") {
            status = false;
            issue = "Please choose a data mapping";
        }
        if (mapping === "") {
            status = false;
            issue = "Please choose a column mapping";
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].dataType === "Number") {
            for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gUploadFileArray.length; i1++)if (isNaN($57e66c5a34f265b4$var$gUploadFileArray[i1][field])) {
                status = false;
                issue = "Field is not a number";
                break;
            }
        }
        if ($57e66c5a34f265b4$var$gTransformation[index].dataType === "Datetime") {
            for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gUploadFileArray.length; i2++)if (isNaN(Date.parse($57e66c5a34f265b4$var$gUploadFileArray[i2][field]))) {
                status = false;
                issue = "Field is not a datetime";
                break;
            }
        }
    }
    if (mappingExists === false && fieldExists === false) {
        let valueToPush = {};
        valueToPush["field"] = field;
        valueToPush["status"] = false;
        valueToPush["dataType"] = "Text"; // default to text
        if (mapping == "Timestamp") valueToPush["dataType"] = "Datetime";
        if (mapping == $57e66c5a34f265b4$var$gEntityUpper + " Create Time") valueToPush["dataType"] = "Datetime";
        if (mapping == $57e66c5a34f265b4$var$gEntityUpper + " Close Time") valueToPush["dataType"] = "Datetime";
        if (mapping == $57e66c5a34f265b4$var$gEntityUpper + " Close Time") valueToPush["dataType"] = "Datetime";
        if (mapping == "Metric - True/False") valueToPush["dataType"] = "Text";
        if (mapping == "Metric - Duration") valueToPush["dataType"] = "Number";
        if (mapping == "Metric - Amount") valueToPush["dataType"] = "Number";
        valueToPush["mapping"] = mapping;
        valueToPush["status"] = status;
        valueToPush["issue"] = issue;
        $57e66c5a34f265b4$var$gTransformation.push(valueToPush);
    }
    if (mappingExists === false && fieldExists === true) {
        $57e66c5a34f265b4$var$gTransformation[index].mapping = mapping;
        $57e66c5a34f265b4$var$gTransformation[index].status = status;
        $57e66c5a34f265b4$var$gTransformation[index].issue = issue;
    }
    if (mappingExists === true && fieldExists === false) {
        $57e66c5a34f265b4$var$gTransformation[index].field = field;
        $57e66c5a34f265b4$var$gTransformation[index].status = status;
        $57e66c5a34f265b4$var$gTransformation[index].issue = issue;
    }
}
function $57e66c5a34f265b4$export$305acd9e21770406() {
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gTransformation.length; i++)rows.push({
        field: $57e66c5a34f265b4$var$gTransformation[i].field,
        mapping: $57e66c5a34f265b4$var$gTransformation[i].mapping,
        datatype: $57e66c5a34f265b4$var$gTransformation[i].dataType,
        status: $57e66c5a34f265b4$var$gTransformation[i].status,
        issue: $57e66c5a34f265b4$var$gTransformation[i].issue
    });
    return rows;
}
function $57e66c5a34f265b4$export$1270cc982a054587() {
    let endNode = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++)if ($57e66c5a34f265b4$var$gActivityArray[i].activity == "End") endNode = parseInt($57e66c5a34f265b4$var$gActivityArray[i].id);
    let tempArray = $57e66c5a34f265b4$var$gEventLogArray.filter(function(event) {
        return event.t != endNode;
    });
    tempArray = tempArray.sort((a, b)=>a.ufa_id - b.ufa_id);
    let fieldTypes = [];
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gUploadFileHeader.length; i1++){
        let valueToPush = {};
        valueToPush["index"] = i1;
        valueToPush["type"] = "unknown";
        for(let j = 0; j < $57e66c5a34f265b4$var$gTransformation.length; j++)if ($57e66c5a34f265b4$var$gUploadFileHeader[i1].headerName === $57e66c5a34f265b4$var$gTransformation[j].field) valueToPush["type"] = $57e66c5a34f265b4$var$gTransformation[j].dataType;
        fieldTypes.push(valueToPush);
    }
    let csv = "";
    let csvLine = "";
    if ($57e66c5a34f265b4$var$gDataLoadType === "DB") for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gCSV.data.length - 1; i2++){
        let outputEvent = true;
        if (i2 > 0 && $57e66c5a34f265b4$var$gSaveFilteredOnly == true && tempArray[i2 - 1].filtered == 1) outputEvent = false;
        if (outputEvent == true) {
            csvLine = "";
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gUploadFileHeader.length; j1++){
                if (csvLine != "") csvLine = csvLine + ",";
                let data = $57e66c5a34f265b4$var$gCSV.data[i2][j1];
                if (fieldTypes[j1].type === "Text" && i2 > 0) data = '"' + data + '"';
                csvLine = csvLine + data;
            }
            csv = csv + csvLine + "\r\n";
        }
    }
    else for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gCSV.length - 1; i3++){
        csvLine = "";
        for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gUploadFileHeader.length; j2++)if (fieldTypes[j2].type != "unknown") {
            if (csvLine != "") csvLine = csvLine + ",";
            let data1 = $57e66c5a34f265b4$var$gCSV[i3].data[j2];
            if (fieldTypes[j2].type === "Text" && i3 > 0) data1 = '"' + data1 + '"';
            csvLine = csvLine + data1;
        }
        csv = csv + csvLine + "\r\n";
    }
    return csv;
}
function $57e66c5a34f265b4$export$cb61761473b99c0a() {
    if ($57e66c5a34f265b4$var$gSaveFilteredOnly == false) return $57e66c5a34f265b4$var$gTasksAll;
    else return $57e66c5a34f265b4$var$gTasksFiltered;
}
function $57e66c5a34f265b4$export$47e13dd22d8af58c() {
    if ($57e66c5a34f265b4$var$gSaveFilteredOnly == false) return $57e66c5a34f265b4$var$gEventsAll;
    else return $57e66c5a34f265b4$var$gEventsFiltered;
}
function $57e66c5a34f265b4$export$da5d76e3c34141f6() {
    let validTransformation = false;
    let validTask = false;
    let validActivity = false;
    let validTimestamp = false;
    let validOther = true;
    for(let i = 0; i < $57e66c5a34f265b4$var$gTransformation.length; i++){
        if ($57e66c5a34f265b4$var$gTransformation[i].status == true && $57e66c5a34f265b4$var$gTransformation[i].mapping == $57e66c5a34f265b4$var$gEntityUpper + " ID") validTask = true;
        if ($57e66c5a34f265b4$var$gTransformation[i].status == true && $57e66c5a34f265b4$var$gTransformation[i].mapping == "Activity") validActivity = true;
        if ($57e66c5a34f265b4$var$gTransformation[i].status == true && $57e66c5a34f265b4$var$gTransformation[i].mapping == "Timestamp") validTimestamp = true;
        if ($57e66c5a34f265b4$var$gTransformation[i].status == false && $57e66c5a34f265b4$var$gTransformation[i].mapping != $57e66c5a34f265b4$var$gEntityUpper + " ID" && $57e66c5a34f265b4$var$gTransformation[i].mapping != "Activity" && $57e66c5a34f265b4$var$gTransformation[i].mapping != "Timestamp") validOther = false;
    }
    if (validTask == true && validActivity == true && validTimestamp == true && validOther == true) validTransformation = true;
    return validTransformation;
}
function $57e66c5a34f265b4$export$bef586f3e3b697c5(importedTransformation) {
    let tempArray;
    try {
        tempArray = JSON.parse(importedTransformation);
    } catch (e) {
        (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid rules file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "compliance_rules"
        });
        return;
    }
    $57e66c5a34f265b4$var$gTransformation = tempArray;
}
function $57e66c5a34f265b4$export$616f2a8c4250fea0() {
    const rows = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gComments.length; i++){
        let fromNodeStr = "";
        let toNodeStr = "";
        let activityStr = "";
        for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length - 1; j++){
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gComments[i].fromNode) fromNodeStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gComments[i].toNode) toNodeStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j].id == $57e66c5a34f265b4$var$gComments[i].activity) activityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
        }
        rows.push({
            fromNode: fromNodeStr,
            toNode: toNodeStr,
            activity: activityStr,
            comments: $57e66c5a34f265b4$var$gComments[i].comments
        });
    }
    return rows;
}
function $57e66c5a34f265b4$export$5dbad88f90a47691() {
    const jsonContent = JSON.stringify($57e66c5a34f265b4$var$gComments);
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_comments.json";
    let fileToSave = new Blob([
        jsonContent
    ], {
        type: "application/json",
        name: fileName
    });
    (0, $lR8r2$filesaver.saveAs)(fileToSave, fileName);
}
function $57e66c5a34f265b4$export$2f7e4fbf4e0dafbf(data) {
    let valueToPush = [];
    valueToPush = {};
    valueToPush["fromNode"] = parseInt(data.fromNode);
    valueToPush["toNode"] = parseInt(data.toNode);
    valueToPush["activity"] = parseInt(data.activity);
    let activityStr = "";
    let fromNodeStr = "";
    let toNodeStr = "";
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(data.activity)) activityStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
        if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(data.fromNode)) fromNodeStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
        if ($57e66c5a34f265b4$var$gActivityArray[j].id == parseInt(data.toNode)) toNodeStr = $57e66c5a34f265b4$var$gActivityArray[j].activity;
    }
    valueToPush["activityStr"] = activityStr;
    valueToPush["fromNodeStr"] = fromNodeStr;
    valueToPush["toNodeStr"] = toNodeStr;
    valueToPush["comments"] = data.comments;
    valueToPush["type"] = "step";
    valueToPush["mode"] = data.mode;
    $57e66c5a34f265b4$var$gComments.push(valueToPush);
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8d2dbf50e6cfba57$export$2f7e4fbf4e0dafbf)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$2eb7d5ee9a22cf67() {
    $57e66c5a34f265b4$var$gComments = [];
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8d2dbf50e6cfba57$export$2f7e4fbf4e0dafbf)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$9197a2d66aec3dd2(importedComments) {
    let tempArray;
    try {
        tempArray = JSON.parse(importedComments);
    } catch (e) {
        (0, $73069f16c491914f$export$88a8e14f5b48311)({
            eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
            message: "Invalid comment file",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "comments"
        });
        return;
    }
    for(let i = 0; i < tempArray.length; i++)for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].activity == tempArray[i].fromNodeStr) tempArray[i].fromNode = $57e66c5a34f265b4$var$gActivityArray[j].a;
        if ($57e66c5a34f265b4$var$gActivityArray[j].activity == tempArray[i].toNodeStr) tempArray[i].toNode = $57e66c5a34f265b4$var$gActivityArray[j].a;
        if ($57e66c5a34f265b4$var$gActivityArray[j].activity == tempArray[i].activityStr) tempArray[i].activity = $57e66c5a34f265b4$var$gActivityArray[j].a;
    }
    $57e66c5a34f265b4$var$gComments = tempArray;
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8d2dbf50e6cfba57$export$2f7e4fbf4e0dafbf)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
function $57e66c5a34f265b4$export$6a7ec9ee0d0ba1df(row) {
    $57e66c5a34f265b4$var$gCommentSelectedRow = row;
}
function $57e66c5a34f265b4$export$2e6e3ad634e3776() {
    $57e66c5a34f265b4$var$gComments.splice($57e66c5a34f265b4$var$gCommentSelectedRow, 1);
    if ($57e66c5a34f265b4$var$gEventEmitter) (0, $8d2dbf50e6cfba57$export$2f7e4fbf4e0dafbf)({
        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
    });
}
// comments functions - end
function $57e66c5a34f265b4$var$convertToCSV(objArray) {
    let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";
    for(let i = 0; i < array.length; i++){
        let line = "";
        for(let index in array[i]){
            if (line != "") line += ",";
            line += array[i][index];
        }
        str += line + "\r\n";
    }
    return str;
}
function $57e66c5a34f265b4$export$8d8c1a8ab106d86() {
    let tempArray = [];
    let vtp = {};
    vtp["Event ID"] = "Event ID";
    vtp[$57e66c5a34f265b4$var$gEntityUpper + " ID"] = $57e66c5a34f265b4$var$gEntityUpper + " ID";
    vtp["From Activity"] = "From Activity";
    vtp["To Activity"] = "To Activity";
    vtp["Variant ID"] = "Variant ID";
    vtp["Variant"] = "Variant";
    vtp["Resource"] = "Resource";
    vtp["Timestamp"] = "Timestamp";
    vtp["Duration"] = "Duration";
    vtp[$57e66c5a34f265b4$var$gEntityUpper] = $57e66c5a34f265b4$var$gEntityUpper;
    vtp["Actual Cost"] = "Actual Cost";
    vtp["Forecast Cost"] = "Forecast Cost";
    vtp["Compliant"] = "Compliant";
    vtp["Automated"] = "Automated";
    vtp["Loop"] = "Loop";
    vtp["Filtered"] = "Filtered";
    for(let j = 0; j < $57e66c5a34f265b4$var$gTaskAttributes.length; j++)vtp[$57e66c5a34f265b4$var$gTaskAttributes[j].field] = $57e66c5a34f265b4$var$gTaskAttributes[j].field;
    for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gEventAttributes.length; j1++)if ($57e66c5a34f265b4$var$gEventAttributes[j1].field != "Resource") vtp[$57e66c5a34f265b4$var$gEventAttributes[j1].field] = $57e66c5a34f265b4$var$gEventAttributes[j1].field;
    tempArray.push(vtp);
    for(let i = 0; i < $57e66c5a34f265b4$var$gEventLogArray.length; i++){
        vtp = {};
        vtp["Event ID"] = $57e66c5a34f265b4$var$gEventLogArray[i].elid;
        vtp[$57e66c5a34f265b4$var$gEntityUpper + " ID"] = $57e66c5a34f265b4$var$gEventLogArray[i].tid;
        vtp["From Activity"] = "";
        vtp["To Activity"] = "";
        for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gActivityArray.length; j2++){
            if ($57e66c5a34f265b4$var$gActivityArray[j2].id === $57e66c5a34f265b4$var$gEventLogArray[i].f && vtp["From Activity"] === "") vtp["From Activity"] = $57e66c5a34f265b4$var$gActivityArray[j2].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[j2].id === $57e66c5a34f265b4$var$gEventLogArray[i].t && vtp["To Activity"] === "") vtp["To Activity"] = $57e66c5a34f265b4$var$gActivityArray[j2].activity;
            if (vtp["From Activity"] != "" && vtp["To Activity"] != "") break;
        }
        for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gVariantArray.length; j3++)if ($57e66c5a34f265b4$var$gVariantArray[j3].v == $57e66c5a34f265b4$var$gEventLogArray[i].v) {
            vtp["Variant ID"] = $57e66c5a34f265b4$var$gVariantArray[j3].id;
            vtp["Variant"] = $57e66c5a34f265b4$var$gVariantArray[j3].n;
            break;
        }
        vtp["Resource"] = $57e66c5a34f265b4$var$gEventLogArray[i].u;
        vtp["Timestamp"] = $57e66c5a34f265b4$var$gEventLogArray[i].ts;
        vtp["Duration"] = $57e66c5a34f265b4$var$gEventLogArray[i].d;
        vtp[$57e66c5a34f265b4$var$gEntityUpper] = $57e66c5a34f265b4$var$gEventLogArray[i].k;
        vtp["Actual Cost"] = $57e66c5a34f265b4$var$gEventLogArray[i].actual_cost;
        vtp["Forecast Cost"] = $57e66c5a34f265b4$var$gEventLogArray[i].forecast_cost;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].compliant === true) vtp["Compliant"] = 1;
        else vtp["Compliant"] = 0;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].automated === true) vtp["Automated"] = 1;
        else vtp["Automated"] = 0;
        if ($57e66c5a34f265b4$var$gEventLogArray[i].loop === true) vtp["Loop"] = 1;
        else vtp["Loop"] = 0;
        vtp["Filtered"] = $57e66c5a34f265b4$var$gEventLogArray[i].filtered;
        for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gTaskAttributes.length; j4++){
            let key = "ta" + j4;
            vtp[$57e66c5a34f265b4$var$gTaskAttributes[j4].field] = $57e66c5a34f265b4$var$gEventLogArray[i][key];
        }
        for(let j5 = 0; j5 < $57e66c5a34f265b4$var$gEventAttributes.length; j5++)if ($57e66c5a34f265b4$var$gEventAttributes[j5].field != "Resource") {
            let key1 = "ea" + j5;
            vtp[$57e66c5a34f265b4$var$gEventAttributes[j5].field] = $57e66c5a34f265b4$var$gEventLogArray[i][key1];
        }
        if (vtp["To Activity"] != "End") tempArray.push(vtp);
    }
    let fileName = $57e66c5a34f265b4$var$gModelFileName + "_eventLog.csv";
    let fileToSave = new Blob([
        $57e66c5a34f265b4$var$convertToCSV(tempArray)
    ], {
        type: "application/csv",
        name: fileName
    });
//saveAs(fileToSave,fileName)
}
function $57e66c5a34f265b4$export$4d431da9ce735d8f() {
    return $57e66c5a34f265b4$var$gSlicerConditions;
}
function $57e66c5a34f265b4$export$ebbcf3fd1cb264f9() {
    return $57e66c5a34f265b4$var$gFilterConditions;
}
function $57e66c5a34f265b4$export$884992b7524a64b2() {
    return $57e66c5a34f265b4$var$gComments;
}
function $57e66c5a34f265b4$export$767281e50fd1e8cc() {
    return $57e66c5a34f265b4$var$gTasksFiltered;
}
function $57e66c5a34f265b4$export$1f65e40c175c5f8c() {
    return $57e66c5a34f265b4$var$gEventsFiltered;
}
function $57e66c5a34f265b4$export$bfbb553888b70478() {
    return $57e66c5a34f265b4$var$gVariantTasksSliced;
}
function $57e66c5a34f265b4$export$36ba1d746e48434f() {
    return $57e66c5a34f265b4$var$gVariantEventsSliced;
}
function $57e66c5a34f265b4$export$116a37ce50dea616() {
    return $57e66c5a34f265b4$var$gComplianceRules;
}
function $57e66c5a34f265b4$export$fe6d9574d7d9d606() {
    return $57e66c5a34f265b4$var$gAutomationRules;
}
function $57e66c5a34f265b4$export$5dcc6304899afccc() {
    return $57e66c5a34f265b4$var$gPerformanceRules;
}
function $57e66c5a34f265b4$export$1f61ebc34c954fce() {
    return $57e66c5a34f265b4$var$gCostRules;
}
function $57e66c5a34f265b4$export$9de5e87c9735228e() {
    return $57e66c5a34f265b4$var$gEventLogID;
}
function $57e66c5a34f265b4$export$c3fea13d5dadbaba() {
    let tempArray = [];
    let valueToPush = {};
    valueToPush["ProcessFlowDirection"] = $57e66c5a34f265b4$var$gProcessFlowDirection;
    valueToPush["ShowLinkTasks"] = $57e66c5a34f265b4$var$gShowLinkTasks;
    valueToPush["ShowLinkAvgDuration"] = $57e66c5a34f265b4$var$gShowLinkAvgDuration;
    valueToPush["ShowLinkMedDuration"] = $57e66c5a34f265b4$var$gShowLinkMedDuration;
    valueToPush["ShowLinkMinDuration"] = $57e66c5a34f265b4$var$gShowLinkMinDuration;
    valueToPush["ShowLinkMaxDuration"] = $57e66c5a34f265b4$var$gShowLinkMaxDuration;
    valueToPush["ShowLinkAvgCost"] = $57e66c5a34f265b4$var$gShowLinkAvgCost;
    valueToPush["ShowLinkPercTotal"] = $57e66c5a34f265b4$var$gShowLinkPercTotal;
    valueToPush["ShowLinkDeviation"] = $57e66c5a34f265b4$var$gShowLinkDeviation;
    valueToPush["ShowLinkPercCompliant"] = $57e66c5a34f265b4$var$gShowLinkPercCompliant;
    valueToPush["ShowLinkPercAutomated"] = $57e66c5a34f265b4$var$gShowLinkPercAutomated;
    valueToPush["ShowStartLabel"] = $57e66c5a34f265b4$var$gShowStartLabel;
    valueToPush["ShowEndLabel"] = $57e66c5a34f265b4$var$gShowEndLabel;
    valueToPush["ShowStartNode"] = $57e66c5a34f265b4$var$gShowStartNode;
    valueToPush["ShowEndNode"] = $57e66c5a34f265b4$var$gShowEndNode;
    valueToPush["StepLabelFontSize"] = $57e66c5a34f265b4$var$gStepLabelFontSize;
    valueToPush["ShowNodeTasks"] = $57e66c5a34f265b4$var$gShowNodeTasks;
    valueToPush["ShowNodePercTotal"] = $57e66c5a34f265b4$var$gShowNodePercTotal;
    valueToPush["NodeLabelFontSize"] = $57e66c5a34f265b4$var$gNodeLabelFontSize;
    valueToPush["ShowDurationDays"] = $57e66c5a34f265b4$var$gShowDurationDays;
    valueToPush["ShowDurationHours"] = $57e66c5a34f265b4$var$gShowDurationHours;
    valueToPush["ShowDurationMinutes"] = $57e66c5a34f265b4$var$gShowDurationMinutes;
    valueToPush["ShowDurationSeconds"] = $57e66c5a34f265b4$var$gShowDurationSeconds;
    valueToPush["StepWidthTasks"] = $57e66c5a34f265b4$var$gStepWidthTasks;
    valueToPush["StepWidthDuration"] = $57e66c5a34f265b4$var$gStepWidthDuration;
    valueToPush["StepWidthStdDeviation"] = $57e66c5a34f265b4$var$gStepWidthStdDeviation;
    valueToPush["ColorStartNode"] = $57e66c5a34f265b4$var$gColorStartNode;
    valueToPush["ColorEndNode"] = $57e66c5a34f265b4$var$gColorEndNode;
    valueToPush["ColorActivityText"] = $57e66c5a34f265b4$var$gColorActivityText;
    valueToPush["ColorActivityFill"] = $57e66c5a34f265b4$var$gColorActivityFill;
    valueToPush["ColorActivitySelect"] = $57e66c5a34f265b4$var$gColorActivitySelect;
    valueToPush["ColorLink"] = $57e66c5a34f265b4$var$gColorLink;
    valueToPush["ColorLinkSelect"] = $57e66c5a34f265b4$var$gColorLinkSelect;
    valueToPush["AnimateColor"] = $57e66c5a34f265b4$var$gAnimateColor;
    valueToPush["LoopColor"] = $57e66c5a34f265b4$var$gLoopColor;
    valueToPush["NonCompliantColor"] = $57e66c5a34f265b4$var$gNonCompliantColor;
    valueToPush["PartialNonCompliantColor"] = $57e66c5a34f265b4$var$gPartialNonCompliantColor;
    valueToPush["AutomationColor"] = $57e66c5a34f265b4$var$gAutomationColor;
    valueToPush["PartialAutomationColor"] = $57e66c5a34f265b4$var$gPartialAutomationColor;
    valueToPush["VisualizerBackgroundColor"] = $57e66c5a34f265b4$var$gVisualizerBackgroundColor;
    valueToPush["SpacingColumn"] = $57e66c5a34f265b4$var$gSpacingColumn;
    valueToPush["SpacingLayer"] = $57e66c5a34f265b4$var$gSpacingLayer;
    valueToPush["ZoomToFit"] = $57e66c5a34f265b4$var$gZoomToFit;
    tempArray.push(valueToPush);
    return tempArray;
}
function $57e66c5a34f265b4$export$172fd1b17aba58d3() {
    let metricsExists = false;
    if ($57e66c5a34f265b4$var$gMetricArray.length > 0) metricsExists = true;
    return $57e66c5a34f265b4$export$172fd1b17aba58d3;
}
function $57e66c5a34f265b4$export$71a5e433e89cee55() {
    $57e66c5a34f265b4$var$gProcessFlowDirection = 90;
    $57e66c5a34f265b4$var$gShowLinkTasks = true;
    $57e66c5a34f265b4$var$gShowLinkAvgDuration = true;
    $57e66c5a34f265b4$var$gShowLinkMedDuration = false;
    $57e66c5a34f265b4$var$gShowLinkMinDuration = false;
    $57e66c5a34f265b4$var$gShowLinkMaxDuration = false;
    $57e66c5a34f265b4$var$gShowLinkAvgCost = false;
    $57e66c5a34f265b4$var$gShowLinkPercTotal = true;
    $57e66c5a34f265b4$var$gShowLinkDeviation = false;
    $57e66c5a34f265b4$var$gShowLinkPercCompliant = false;
    $57e66c5a34f265b4$var$gShowLinkPercAutomated = false;
    $57e66c5a34f265b4$var$gZoomToFit = false;
    $57e66c5a34f265b4$var$gShowStartLabel = true;
    $57e66c5a34f265b4$var$gShowEndLabel = false;
    $57e66c5a34f265b4$var$gShowStartNode = true;
    $57e66c5a34f265b4$var$gShowEndNode = true;
    $57e66c5a34f265b4$var$gStepLabelFontSize = "6pt";
    $57e66c5a34f265b4$var$gShowNodeTasks = true;
    $57e66c5a34f265b4$var$gShowNodePercTotal = false;
    $57e66c5a34f265b4$var$gNodeLabelFontSize = "7pt";
    $57e66c5a34f265b4$var$gShowDurationDays = true;
    $57e66c5a34f265b4$var$gShowDurationHours = true;
    $57e66c5a34f265b4$var$gShowDurationMinutes = true;
    $57e66c5a34f265b4$var$gShowDurationSeconds = false;
    $57e66c5a34f265b4$var$gStepWidthTasks = false;
    $57e66c5a34f265b4$var$gStepWidthDuration = true;
    $57e66c5a34f265b4$var$gStepWidthStdDeviation = false;
    $57e66c5a34f265b4$var$gHighlightLoops = false;
    $57e66c5a34f265b4$var$gHighlightNonCompliance = true;
    $57e66c5a34f265b4$var$gHighlightAutomation = true;
    $57e66c5a34f265b4$var$gStepColourVolume = false;
    $57e66c5a34f265b4$var$gStepColourCost = false;
    $57e66c5a34f265b4$var$gStepColourDuration = true;
    $57e66c5a34f265b4$var$gStepColourStdDeviation = false;
    $57e66c5a34f265b4$var$gAnalyticsModeFiltered = false;
    $57e66c5a34f265b4$var$gAnalyticsModeSliced = true;
    $57e66c5a34f265b4$var$gAnalyticsModeSelected = false;
    $57e66c5a34f265b4$var$gAnalyticsTaskAttribute = "";
    $57e66c5a34f265b4$var$gAnalyticsTaskHistoryMetric = 1;
    $57e66c5a34f265b4$var$gAnalyticsTaskAttributeMetric = 1;
    $57e66c5a34f265b4$var$gAnalyticsEventAttribute = "";
    $57e66c5a34f265b4$var$gColorActivityText = "#FFFFFF";
    $57e66c5a34f265b4$var$gColorActivityFill = "#187BCD";
    $57e66c5a34f265b4$var$gColorActivitySelect = "#727171";
    $57e66c5a34f265b4$var$gColorLink = "#FDC819";
    $57e66c5a34f265b4$var$gColorLinkSelect = "#727171";
    $57e66c5a34f265b4$var$gAnimateColor = "#6EB720";
    $57e66c5a34f265b4$var$gLoopColor = "#0C78F6";
    $57e66c5a34f265b4$var$gNonCompliantColor = "#FF4848";
    $57e66c5a34f265b4$var$gPartialNonCompliantColor = "#FD6B6B";
    $57e66c5a34f265b4$var$gAutomationColor = "#417505";
    $57e66c5a34f265b4$var$gPartialAutomationColor = "#7ED321";
    $57e66c5a34f265b4$var$gVisualizerBackgroundColor = "#E7E7E7";
    $57e66c5a34f265b4$var$gColorStartNode = "#A09E9E";
    $57e66c5a34f265b4$var$gColorEndNode = "#A09E9E";
    $57e66c5a34f265b4$var$gSpacingColumn = 40;
    $57e66c5a34f265b4$var$gSpacingLayer = 30;
}
function $57e66c5a34f265b4$var$expandDecompositionTreeNode(node) {
    let diagram = node.diagram;
    diagram.startTransaction("CollapseExpandTree");
    let data = node.data;
    diagram.model.setDataProperty(data, "everExpanded", true);
    if (node.isTreeExpanded) diagram.commandHandler.collapseTree(node);
    else {
        $57e66c5a34f265b4$var$createDecompositionTreeSubTree(data);
        diagram.commandHandler.expandTree(node);
    }
    diagram.commitTransaction("CollapseExpandTree");
    let it = diagram.nodes;
    while(it.next()){
        let node1 = it.value;
        node1.findObject("TREEBUTTON").visible = true;
    }
}
function $57e66c5a34f265b4$var$createDecompositionTreeSubTree(parentdata) {
    //if (gTaskAttributes.length = 0) return
    let attribute = $57e66c5a34f265b4$var$gDecompositionTreeAttribute;
    if (attribute == "") {
        attribute = "ta0";
        $57e66c5a34f265b4$var$gDecompositionTreeAttribute = $57e66c5a34f265b4$var$gTaskAttributes[0].field;
    } else {
        for(let i = 0; i < $57e66c5a34f265b4$var$gTaskAttributes.length; i++)if ($57e66c5a34f265b4$var$gTaskAttributes[i].field === attribute) attribute = $57e66c5a34f265b4$var$gTaskAttributes[i].id;
    }
    let model = $57e66c5a34f265b4$var$gDiagramDecompositionTree.model;
    let parent = $57e66c5a34f265b4$var$gDiagramDecompositionTree.findNodeForData(parentdata);
    let attributeTree = [];
    let grandparent = parent.findTreeParentNode();
    while(grandparent){
        let vtp = [];
        vtp["attribute"] = grandparent.data.attribute;
        vtp["value"] = grandparent.data.label;
        vtp["field"] = grandparent.data.field;
        vtp["rootDistance"] = grandparent.data.rootdistance;
        attributeTree.push(vtp);
        grandparent = grandparent.findTreeParentNode();
    }
    let vtp1 = [];
    vtp1["attribute"] = parent.data.attribute;
    vtp1["value"] = parent.data.label;
    vtp1["field"] = parent.data.field;
    vtp1["rootDistance"] = parent.data.rootdistance;
    attributeTree.push(vtp1);
    let rows = $57e66c5a34f265b4$var$analyticsTaskAttributesDecompositionTree(attributeTree, attribute);
    if ($57e66c5a34f265b4$var$gDecompositionTreeValueType == "high") rows.sort((a, b)=>b.value - a.value);
    else rows.sort((a, b)=>a.value - b.value);
    let numChildren = rows.length;
    if (rows.length > 10) numChildren = 10;
    // parent is the node that has been clicked, we need to delete any existing children
    // need recursive iteration
    let p = parent.findTreeChildrenNodes();
    while(p.next()){
        let child1 = p.value;
        let c1 = child1.findTreeChildrenNodes();
        while(c1.next()){
            let child2 = c1.value;
            let c2 = child2.findTreeChildrenNodes();
            while(c2.next()){
                let child3 = c2.value;
                let c3 = child3.findTreeChildrenNodes();
                while(c3.next()){
                    let child4 = c3.value;
                    let c4 = child4.findTreeChildrenNodes();
                    while(c4.next()){
                        let child5 = c4.value;
                        $57e66c5a34f265b4$var$gDiagramDecompositionTree.remove(child5);
                    }
                    $57e66c5a34f265b4$var$gDiagramDecompositionTree.remove(child4);
                }
                $57e66c5a34f265b4$var$gDiagramDecompositionTree.remove(child3);
            }
            $57e66c5a34f265b4$var$gDiagramDecompositionTree.remove(child2);
        }
        $57e66c5a34f265b4$var$gDiagramDecompositionTree.remove(child1);
    }
    let degrees = 1;
    grandparent = parent.findTreeParentNode();
    while(grandparent){
        degrees++;
        grandparent = grandparent.findTreeParentNode();
    }
    for(let i1 = 0; i1 < numChildren; i1++){
        let width = 1;
        if (rows[i1].percMax > 0.01) width = parseInt(rows[i1].percMax * 185);
        let toolTip = "Attribute: " + $57e66c5a34f265b4$var$gDecompositionTreeAttribute + "\r\n" + "Value: " + rows[i1].attribute + "\r\n" + "Metric: " + rows[i1].metric + "\r\n";
        toolTip = toolTip + $57e66c5a34f265b4$var$gEntityUpper + "s:" + rows[i1].tasks + "\r\n" + " % Total " + $57e66c5a34f265b4$var$gEntityUpper + "s: " + (rows[i1].percTotal * 100).toFixed(1) + "%" + "\r\n";
        toolTip = toolTip + "% Maximum: " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(rows[i1].percMax, 1);
        let tasks_label = "";
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric != 1) tasks_label = $57e66c5a34f265b4$var$gEntityUpper + "s:" + rows[i1].tasks;
        let vtp2 = [];
        let filter = [];
        vtp2["attribute"] = $57e66c5a34f265b4$var$gDecompositionTreeAttribute;
        vtp2["field"] = $57e66c5a34f265b4$var$gDecompositionTreeAttribute;
        vtp2["value"] = rows[i1].attribute;
        vtp2["rootDistance"] = -1;
        filter.push(vtp2);
        let displayValue = rows[i1].metric;
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5 || $57e66c5a34f265b4$var$gDecompositionTreeMetric == 6 || $57e66c5a34f265b4$var$gDecompositionTreeMetric == 7) displayValue = $57e66c5a34f265b4$export$bdd804b47f20d359(rows[i1].metric);
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8) displayValue = $57e66c5a34f265b4$export$3e1eee59f5dc52be(rows[i1].metric, 1);
        let childdata = {
            key: rows[i1].attribute + "\r\n" + rows[i1].metric,
            label: rows[i1].attribute,
            attribute: attribute,
            value: displayValue,
            field: $57e66c5a34f265b4$var$gDecompositionTreeAttribute,
            tasks_label: tasks_label,
            width: width,
            tooltip: toolTip,
            parent: parentdata.key,
            rootdistance: degrees,
            taskArray: rows[i1].taskArray,
            filterArray: attributeTree.concat(filter)
        };
        // add to model.nodeDataArray and create a Node
        model.addNodeData(childdata);
        // position the new child node close to the parent
        let child = $57e66c5a34f265b4$var$gDiagramDecompositionTree.findNodeForData(childdata);
        child.location = parent.location;
    }
    return numChildren;
}
function $57e66c5a34f265b4$var$analyticsTaskAttributesDecompositionTree(attributeTree, attribute) {
    if ($57e66c5a34f265b4$var$gTaskAttributes.length == 0) return [];
    attributeTree.sort((a, b)=>a.rootDistance - b.rootDistance);
    if (attributeTree.length == 1) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 2) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 3) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 4) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 5) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) || a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 6) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) || a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) || a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 7) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) || a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) || a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) || a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 8) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[7].attribute].localeCompare(b[attributeTree[7].attribute]) || a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) || a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) || a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) || a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    if (attributeTree.length == 9) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a[attributeTree[8].attribute].localeCompare(b[attributeTree[8].attribute]) || a[attributeTree[7].attribute].localeCompare(b[attributeTree[7].attribute]) || a[attributeTree[6].attribute].localeCompare(b[attributeTree[6].attribute]) || a[attributeTree[5].attribute].localeCompare(b[attributeTree[5].attribute]) || a[attributeTree[4].attribute].localeCompare(b[attributeTree[4].attribute]) || a[attributeTree[3].attribute].localeCompare(b[attributeTree[3].attribute]) || a[attributeTree[2].attribute].localeCompare(b[attributeTree[2].attribute]) || a[attributeTree[1].attribute].localeCompare(b[attributeTree[1].attribute]) || a[attribute].localeCompare(b[attribute]));
    attributeTree.sort((a, b)=>a.rootDistance - b.rootDistance);
    let tasks = 0;
    let maxTasks = 0;
    let maxDuration = 0;
    let maxCompliant = 0;
    let maxAvgCost = 0;
    let maxActualCost = 0;
    let maxAvgCostSaving = 0;
    let actualCost = 0;
    let forecastCost = 0;
    let compliant = 0;
    let totalTasks = 0;
    let duration = 0;
    let validRec = false;
    let attributeLabel = null;
    let i = 0;
    for(i = 0; i < $57e66c5a34f265b4$var$gTaskSlicedArray.length; i++){
        validRec = true;
        for(let j = 0; j < attributeTree.length; j++){
            if (parseInt(attributeTree[j].rootDistance) != 0) {
                if ($57e66c5a34f265b4$var$gTaskSlicedArray[i][attributeTree[j].attribute] != attributeTree[j].value) {
                    validRec = false;
                    break;
                } // something wrong here
            }
        }
        if (validRec == true) {
            // check min/max
            if (i > 0 && $57e66c5a34f265b4$var$gTaskSlicedArray[i][attribute] != $57e66c5a34f265b4$var$gTaskSlicedArray[i - 1][attribute]) {
                validRec = false;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1 && tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2 && duration / tasks / 60 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 60 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3 && duration / tasks / 3600 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 3600 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4 && duration / tasks / 62400 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 62400 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5 && actualCost < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6 && actualCost / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7 && (actualCost - forecastCost) / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && (actualCost - forecastCost) / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8 && compliant / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && compliant / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if (tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks || tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMinTasks) validRec = false;
                if (validRec == true) {
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1) {
                        if (tasks > maxTasks) maxTasks = tasks;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2) {
                        if (duration / tasks / 60 > maxDuration) maxDuration = duration / tasks / 60;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3) {
                        if (duration / tasks / 3600 > maxDuration) maxDuration = duration / tasks / 3600;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4) {
                        if (duration / tasks / 62400 > maxDuration) maxDuration = duration / tasks / 62400;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5) {
                        if (actualCost > maxActualCost) maxActualCost = actualCost;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6) {
                        if (actualCost / tasks > maxAvgCost) maxAvgCost = actualCost / tasks;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7) {
                        if ((actualCost - forecastCost) / tasks > maxAvgCostSaving) maxAvgCostSaving = (actualCost - forecastCost) / tasks;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8) {
                        if (compliant / tasks > maxCompliant) maxCompliant = compliant / tasks;
                    }
                }
                tasks = 0;
                compliant = 0;
                duration = 0;
                actualCost = 0;
                forecastCost = 0;
            }
            totalTasks++;
            tasks++;
            if ($57e66c5a34f265b4$var$gTaskSlicedArray[i].compliant == true) compliant++;
            duration = duration + $57e66c5a34f265b4$var$gTaskSlicedArray[i].d;
            actualCost = actualCost + $57e66c5a34f265b4$var$gTaskSlicedArray[i].actual_cost;
            forecastCost = forecastCost + $57e66c5a34f265b4$var$gTaskSlicedArray[i].forecast_cost;
        }
    }
    validRec = false;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1 && tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2 && duration / tasks / 60 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 60 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3 && duration / tasks / 3600 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 3600 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4 && duration / tasks / 62400 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 62400 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5 && actualCost < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6 && actualCost / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7 && (actualCost - forecastCost) / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && (actualCost - forecastCost) / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8 && compliant / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric / 100 && compliant / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric / 100) validRec = true;
    if (validRec == true) {
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1) {
            if (tasks > maxTasks) maxTasks = tasks;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2) {
            if (duration / tasks / 60 > maxDuration) maxDuration = duration / tasks / 60;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3) {
            if (duration / tasks / 3600 > maxDuration) maxDuration = duration / tasks / 3600;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4) {
            if (duration / tasks / 62400 > maxDuration) maxDuration = duration / tasks / 62400;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5) {
            if (actualCost > maxActualCost) maxActualCost = actualCost;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6) {
            if (actualCost / tasks > maxAvgCost) maxAvgCost = actualCost / tasks;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7) {
            if ((actualCost - forecastCost) / tasks > maxAvgCostSaving) maxAvgCostSaving = (actualCost - forecastCost) / tasks;
        }
        if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8) {
            if (compliant / tasks > maxCompliant) maxCompliant = compliant / tasks;
        }
    }
    let vtp = [];
    let tempTaskArray = [];
    let rows = [];
    tasks = 0;
    duration = 0;
    compliant = 0;
    actualCost = 0;
    forecastCost = 0;
    i = 0;
    for(i = 0; i < $57e66c5a34f265b4$var$gTaskSlicedArray.length; i++){
        validRec = true;
        for(let j1 = 0; j1 < attributeTree.length; j1++){
            if (parseInt(attributeTree[j1].rootDistance) != 0) {
                if ($57e66c5a34f265b4$var$gTaskSlicedArray[i][attributeTree[j1].attribute] != attributeTree[j1].value) {
                    validRec = false;
                    break;
                }
            }
        }
        if (validRec == true) {
            if (i > 0 && $57e66c5a34f265b4$var$gTaskSlicedArray[i][attribute] != $57e66c5a34f265b4$var$gTaskSlicedArray[i - 1][attribute] && tasks > 0) {
                validRec = false;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1 && tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2 && duration / tasks / 60 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 60 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3 && duration / tasks / 3600 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 3600 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4 && duration / tasks / 62400 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 62400 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5 && actualCost < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6 && actualCost / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7 && (actualCost - forecastCost) / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && (actualCost - forecastCost) / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8 && compliant / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric / 100 && compliant / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric / 100) validRec = true;
                if (tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks || tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMinTasks) validRec = false;
                if (validRec == true) {
                    vtp = {};
                    vtp["attribute"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i - 1][attribute];
                    vtp["tasks"] = $57e66c5a34f265b4$export$a2db1876938cd11d(tasks);
                    vtp["percTotal"] = tasks / totalTasks;
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1) {
                        vtp["metric"] = $57e66c5a34f265b4$export$a2db1876938cd11d(tasks);
                        vtp["value"] = tasks;
                        vtp["percMax"] = tasks / maxTasks;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2) {
                        vtp["metric"] = (duration / tasks / 60).toFixed(2);
                        vtp["value"] = duration / tasks / 60;
                        vtp["percMax"] = duration / tasks / 60 / maxDuration;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3) {
                        vtp["metric"] = (duration / tasks / 3600).toFixed(2);
                        vtp["value"] = duration / tasks / 3660;
                        vtp["percMax"] = duration / tasks / 3600 / maxDuration;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4) {
                        vtp["metric"] = (duration / tasks / 62400).toFixed(2);
                        vtp["value"] = duration / tasks / 62400;
                        vtp["percMax"] = duration / tasks / 62400 / maxDuration;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5) {
                        vtp["metric"] = actualCost;
                        vtp["value"] = actualCost;
                        vtp["percMax"] = actualCost / maxActualCost;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6) {
                        vtp["metric"] = actualCost / tasks;
                        vtp["value"] = actualCost / tasks;
                        vtp["percMax"] = actualCost / tasks / maxAvgCost;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7) {
                        vtp["metric"] = (actualCost - forecastCost) / tasks;
                        vtp["value"] = (actualCost - forecastCost) / tasks;
                        vtp["percMax"] = (actualCost - forecastCost) / tasks / maxAvgCostSaving;
                    }
                    if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8) {
                        vtp["metric"] = compliant / tasks;
                        vtp["value"] = compliant / tasks;
                        vtp["percMax"] = compliant / tasks / maxCompliant;
                    }
                    vtp["taskArray"] = tempTaskArray;
                    rows.push(vtp);
                }
                tempTaskArray = [];
                tasks = 0;
                compliant = 0;
                duration = 0;
                actualCost = 0;
                forecastCost = 0;
            }
            tasks++;
            if ($57e66c5a34f265b4$var$gTaskSlicedArray[i].compliant == true) compliant++;
            duration = duration + $57e66c5a34f265b4$var$gTaskSlicedArray[i].d;
            actualCost = actualCost + $57e66c5a34f265b4$var$gTaskSlicedArray[i].actual_cost;
            forecastCost = forecastCost + $57e66c5a34f265b4$var$gTaskSlicedArray[i].forecast_cost;
            attributeLabel = $57e66c5a34f265b4$var$gTaskSlicedArray[i][attribute];
            tempTaskArray.push($57e66c5a34f265b4$var$gTaskSlicedArray[i]);
        }
    }
    for(let j2 = 0; j2 < attributeTree.length; j2++){
        validRec = true;
        if (attributeTree[j2].rootDistance == 0) validRec;
        if (attributeTree[j2].rootDistance != 0) {
            if ($57e66c5a34f265b4$var$gTaskSlicedArray[i - 1][attributeTree[j2].attribute] != attributeTree[j2].value) {
                validRec = false;
                break;
            } else {
                for(let i1 = 0; i1 < rows.length; i1++)if (rows[i1].attribute === attributeTree[j2].value) {
                    validRec = false;
                    break;
                }
            }
        }
        if (validRec == true) {
            validRec = false;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1 && tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2 && duration / tasks / 60 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 60 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3 && duration / tasks / 3600 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 3600 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4 && duration / tasks / 62400 < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && duration / tasks / 62400 > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5 && actualCost < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6 && actualCost / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && actualCost / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7 && (actualCost - forecastCost) / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric && (actualCost - forecastCost) / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric) validRec = true;
            if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8 && compliant / tasks < $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric / 100 && compliant / tasks > $57e66c5a34f265b4$var$gDecompositionTreeMinMetric / 100) validRec = true;
            if (tasks >= $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks || tasks <= $57e66c5a34f265b4$var$gDecompositionTreeMinTasks) validRec = false;
            if (validRec == true) {
                vtp = {};
                vtp["attribute"] = attributeLabel;
                vtp["tasks"] = $57e66c5a34f265b4$export$a2db1876938cd11d(tasks);
                vtp["percTotal"] = tasks / totalTasks;
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 1) {
                    vtp["metric"] = $57e66c5a34f265b4$export$a2db1876938cd11d(tasks);
                    vtp["value"] = tasks;
                    vtp["percMax"] = tasks / maxTasks;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 2) {
                    vtp["metric"] = (duration / tasks / 60).toFixed(2);
                    vtp["value"] = duration / tasks / 60;
                    vtp["percMax"] = duration / tasks / 60 / maxDuration;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 3) {
                    vtp["metric"] = (duration / tasks / 3600).toFixed(2);
                    vtp["value"] = duration / tasks / 3660;
                    vtp["percMax"] = duration / tasks / 3600 / maxDuration;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 4) {
                    vtp["metric"] = (duration / tasks / 62400).toFixed(2);
                    vtp["value"] = duration / tasks / 62400;
                    vtp["percMax"] = duration / tasks / 62400 / maxDuration;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 5) {
                    vtp["metric"] = actualCost;
                    vtp["value"] = actualCost;
                    vtp["percMax"] = actualCost / maxActualCost;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 6) {
                    vtp["metric"] = actualCost / tasks;
                    vtp["value"] = actualCost / tasks;
                    vtp["percMax"] = actualCost / tasks / maxAvgCost;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 7) {
                    vtp["metric"] = (actualCost - forecastCost) / tasks;
                    vtp["value"] = (actualCost - forecastCost) / tasks;
                    vtp["percMax"] = (actualCost - forecastCost) / tasks / maxAvgCostSaving;
                }
                if ($57e66c5a34f265b4$var$gDecompositionTreeMetric == 8) {
                    vtp["metric"] = compliant / tasks;
                    vtp["value"] = compliant / tasks;
                    vtp["percMax"] = compliant / tasks / maxCompliant;
                }
                vtp["taskArray"] = tempTaskArray;
                rows.push(vtp);
            }
        }
    }
    rows.sort((a, b)=>b.Metric > a.Metric ? 1 : -1);
    return rows;
}
function $57e66c5a34f265b4$export$876783770c364846() {
    return $57e66c5a34f265b4$var$gCurrentDiagram;
}
function $57e66c5a34f265b4$var$loadDiagramDecompositionTree() {
    let $ = $lR8r2$gojs.GraphObject.make;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree = $($lR8r2$gojs.Diagram, {
        layout: $($lR8r2$gojs.TreeLayout),
        initialScale: 1
    });
    let lay = $57e66c5a34f265b4$var$gDiagramDecompositionTree.layout;
    lay.nodeSpacing = 10;
    lay.layerSpacing = 55;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.contentAlignment = $lR8r2$gojs.Spot.TopLeft;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.toolManager.mouseWheelBehavior = $lR8r2$gojs.ToolManager.WheelZoom;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.toolManager.toolTipDuration = 10000;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.padding.left = 32;
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.div = "gDiagramDivDT";
    const getNodeContextMenuOptions = ({ data: { key: key , taskArray: taskArray , filterArray: filterArray  }  })=>{
        if (key < 2) return;
        return [
            {
                text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + " Lifecycle",
                event: ()=>{
                    $57e66c5a34f265b4$var$gTasksVisualizationSource = "dt_node";
                    $57e66c5a34f265b4$var$gDecompositionTreeTaskArray = taskArray;
                    $57e66c5a34f265b4$export$51b3a147a1d97c17();
                    $57e66c5a34f265b4$export$63db7e18015c9f49();
                    (0, $7a9d81ef95270803$export$2c7243b488bf9a8f)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "dt_node";
                            $57e66c5a34f265b4$var$gDecompositionTreeTaskArray = taskArray;
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "dt_node";
                            $57e66c5a34f265b4$var$gDecompositionTreeTaskArray = taskArray;
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Filter",
                event: ()=>{
                    if ($57e66c5a34f265b4$var$gFilters.length > 0) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("decompositionTree");
                    for(let i = 1; i < filterArray.length; i++){
                        $57e66c5a34f265b4$var$gAttribute = filterArray[i].field;
                        $57e66c5a34f265b4$var$gAttributeType = "Task";
                        let vtp = [];
                        vtp["value"] = filterArray[i].value;
                        $57e66c5a34f265b4$var$gSelectedAttributes = [];
                        $57e66c5a34f265b4$var$gSelectedAttributes.push(vtp);
                        $57e66c5a34f265b4$export$3067f357aa66b5c2($57e66c5a34f265b4$var$gAttribute, $57e66c5a34f265b4$var$gAttributeType);
                    }
                    (0, $aecab291b608cebe$export$24e90a7f4e401128)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                    $57e66c5a34f265b4$export$eaf358d737cb394b();
                    (0, $4418db1243d61fd1$export$17b3808e0ffc259c)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            }, 
        ];
    };
    let contextMenuObj = null;
    const contextMenuDecompositionTree = $($lR8r2$gojs.HTMLInfo, {
        show: (obj, diagram)=>{
            const { x: x , y: y  } = diagram.lastInput.viewPoint;
            const options = obj.part instanceof $lR8r2$gojs.Node ? getNodeContextMenuOptions(obj) : "";
            diagram.toolManager.hideToolTip();
            contextMenuObj = obj;
            if (options) (0, $a88d26ee1331adae$export$565dd6bf3240914a)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                x: x,
                y: y,
                options: options
            });
        },
        hide: (diagram)=>{
            contextMenuObj = null;
            (0, $a88d26ee1331adae$export$a70b79ee19e88cfe)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter
            });
        }
    });
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.nodeTemplate = $($lR8r2$gojs.Node, "Spot", {
        isShadowed: true,
        selectionObjectName: "PANEL",
        selectionAdorned: false,
        isTreeExpanded: false,
        isTreeLeaf: false,
        contextMenu: contextMenuDecompositionTree
    }, {
        toolTip: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: "white",
            stroke: "gray",
            strokeWidth: 1
        }), $($lR8r2$gojs.TextBlock, {
            margin: 4,
            font: "9pt helvetica, arial, sans-serif"
        }, new $lR8r2$gojs.Binding("text", "tooltip")))
    }, $($lR8r2$gojs.Shape, "Border", {
        fill: "whitesmoke",
        stroke: "white",
        strokeWidth: 0,
        width: 200,
        height: 50
    }), // the expand/collapse button, at the top-right corner
    $("TreeExpanderButton", {
        name: "TREEBUTTON",
        width: 20,
        height: 20,
        visible: true,
        alignment: $lR8r2$gojs.Spot.TopRight,
        alignmentFocus: $lR8r2$gojs.Spot.Center,
        click: (e, obj)=>{
            // OBJ is the Button
            let node = obj.part; // get the Node containing this Button
            if (node === null) return;
            e.handled = true;
            $57e66c5a34f265b4$var$expandDecompositionTreeNode(node);
        }
    }), $($lR8r2$gojs.Panel, "Table", {
        defaultAlignment: $lR8r2$gojs.Spot.Left
    }, $($lR8r2$gojs.Shape, "Rectangle", {
        row: 0,
        column: 0,
        fill: "#197BCD",
        strokeWidth: 0,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 5),
        height: 15,
        columnSpan: 2
    }, new $lR8r2$gojs.Binding("width", "width")), $($lR8r2$gojs.TextBlock, {
        row: 1,
        column: 0,
        font: "9pt Helvetica",
        spacingAbove: 5,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 5),
        stretch: $lR8r2$gojs.GraphObject.Horizontal,
        wrap: $lR8r2$gojs.TextBlock.None,
        overflow: $lR8r2$gojs.TextBlock.OverflowEllipsis,
        width: 195,
        columnSpan: 2
    }, new $lR8r2$gojs.Binding("text", "label")), $($lR8r2$gojs.TextBlock, {
        row: 2,
        column: 0,
        font: "9pt Helvetica",
        spacingAbove: 5,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 5),
        wrap: false,
        width: 95
    }, new $lR8r2$gojs.Binding("text", "value")), $($lR8r2$gojs.TextBlock, {
        row: 2,
        column: 1,
        font: "8pt Helvetica",
        spacingAbove: 5,
        wrap: false,
        width: 95
    }, new $lR8r2$gojs.Binding("text", "tasks_label")))); // end Node
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.linkTemplate = $($lR8r2$gojs.Link, {
        curve: $lR8r2$gojs.Link.Bezier
    }, $($lR8r2$gojs.Shape, {
        strokeWidth: 1,
        stroke: "#197BCD"
    }) // the link shape, with the default black stroke
    );
    // create the model with a root node data
    $57e66c5a34f265b4$var$gDiagramDecompositionTree.model = new $lR8r2$gojs.TreeModel([
        {
            key: 1,
            label: $57e66c5a34f265b4$var$gEntityUpper + "s",
            value: 0,
            perc: "100%",
            tooltip: "",
            attribute: "parentNode",
            everExpanded: false,
            width: 185,
            rootdistance: 0
        }, 
    ]);
}
function $57e66c5a34f265b4$var$loadDiagramInsights() {
    const $ = $lR8r2$gojs.GraphObject.make; // for conciseness in defining templates
    $57e66c5a34f265b4$var$gDiagramInsights = $($lR8r2$gojs.Diagram, {
        layout: $($lR8r2$gojs.LayeredDigraphLayout, {
            direction: 90
        }),
        scrollMode: $lR8r2$gojs.Diagram.InfiniteScroll,
        initialPosition: new $lR8r2$gojs.Point(-35, -10)
    });
    $57e66c5a34f265b4$var$gDiagramInsights.layout.layerSpacing = 10;
    $57e66c5a34f265b4$var$gDiagramInsights.div = "gDiagramDivIS";
    // define the Node template
    const getNodeContextMenuOptions = ({ data: { task_str: task_str , attributeArray: attributeArray  }  })=>{
        return [
            {
                text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + " Lifecycle",
                event: ()=>{
                    $57e66c5a34f265b4$var$gTasksVisualizationSource = "is_node";
                    $57e66c5a34f265b4$var$gInsightsAttributeArray = attributeArray;
                    $57e66c5a34f265b4$var$gTaskStr = task_str;
                    $57e66c5a34f265b4$export$51b3a147a1d97c17();
                    $57e66c5a34f265b4$export$63db7e18015c9f49();
                    (0, $7a9d81ef95270803$export$2c7243b488bf9a8f)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "is_node";
                            $57e66c5a34f265b4$var$gInsightsAttributeArray = attributeArray;
                            $57e66c5a34f265b4$var$gTaskStr = task_str;
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "is_node";
                            $57e66c5a34f265b4$var$gInsightsAttributeArray = attributeArray;
                            $57e66c5a34f265b4$var$gTaskStr = task_str;
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Filter",
                event: ()=>{
                    if ($57e66c5a34f265b4$var$gFilters.length > 0) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("insights");
                    for(let i = 0; i < attributeArray.length; i++){
                        $57e66c5a34f265b4$var$gAttribute = attributeArray[i].attribute;
                        $57e66c5a34f265b4$var$gAttributeType = "Task";
                        let vtp = [];
                        vtp["value"] = attributeArray[i].value;
                        $57e66c5a34f265b4$var$gSelectedAttributes = [];
                        $57e66c5a34f265b4$var$gSelectedAttributes.push(vtp);
                        $57e66c5a34f265b4$export$3067f357aa66b5c2($57e66c5a34f265b4$var$gAttribute, $57e66c5a34f265b4$var$gAttributeType);
                    }
                    (0, $aecab291b608cebe$export$24e90a7f4e401128)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                    $57e66c5a34f265b4$export$eaf358d737cb394b();
                    (0, $4418db1243d61fd1$export$17b3808e0ffc259c)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            }, 
        ];
    };
    let contextMenuObj = null;
    const contextMenuInsights = $($lR8r2$gojs.HTMLInfo, {
        show: (obj, diagram)=>{
            const { x: x , y: y  } = diagram.lastInput.viewPoint;
            const options = obj.part instanceof $lR8r2$gojs.Node ? getNodeContextMenuOptions(obj) : "";
            contextMenuObj = obj;
            (0, $a88d26ee1331adae$export$565dd6bf3240914a)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                x: x,
                y: y,
                options: options
            });
        },
        hide: (diagram)=>{
            contextMenuObj = null;
            (0, $a88d26ee1331adae$export$a70b79ee19e88cfe)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter
            });
        }
    });
    $57e66c5a34f265b4$var$gDiagramInsights.nodeTemplate = $($lR8r2$gojs.Node, "Auto", {
        locationSpot: $lR8r2$gojs.Spot.Top,
        isShadowed: true,
        contextMenu: contextMenuInsights
    }, new $lR8r2$gojs.Binding("text", "text"), new $lR8r2$gojs.Binding("visible", "visible"), $($lR8r2$gojs.Shape, "Border", {
        fill: "whitesmoke",
        stroke: "white",
        strokeWidth: 0,
        width: 380
    }), $($lR8r2$gojs.Panel, "Table", {
        defaultAlignment: $lR8r2$gojs.Spot.Left
    }, $($lR8r2$gojs.TextBlock, {
        row: 0,
        column: 0,
        font: "bold 9pt Helvetica",
        spacingAbove: 5,
        width: 125,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 20),
        overflow: $lR8r2$gojs.TextBlock.OverflowEllipsis
    }, new $lR8r2$gojs.Binding("text", "metric")), $($lR8r2$gojs.TextBlock, {
        row: 0,
        column: 1,
        width: 245,
        font: "9pt Helvetica",
        height: 20,
        text: "verticalAlignment: Center",
        verticalAlignment: $lR8r2$gojs.Spot.Center
    }, new $lR8r2$gojs.Binding("width", "width"), new $lR8r2$gojs.Binding("background", "fill"), new $lR8r2$gojs.Binding("text", "text")), $($lR8r2$gojs.TextBlock, {
        row: 1,
        column: 0,
        font: "9pt Helvetica",
        spacingAbove: 5,
        width: 120,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 20),
        overflow: $lR8r2$gojs.TextBlock.OverflowEllipsis
    }, new $lR8r2$gojs.Binding("text", "attributes")), $($lR8r2$gojs.TextBlock, {
        row: 1,
        column: 1,
        font: "9pt Helvetica",
        spacingAbove: 5,
        width: 230,
        margin: new $lR8r2$gojs.Margin(0, 0, 0, 5),
        overflow: $lR8r2$gojs.TextBlock.OverflowEllipsis
    }, new $lR8r2$gojs.Binding("text", "values"))));
    // define the Link template
    $57e66c5a34f265b4$var$gDiagramInsights.linkTemplate = $($lR8r2$gojs.Link, {
        routing: $lR8r2$gojs.Link.Orthogonal,
        selectable: false
    }, $($lR8r2$gojs.Shape, {
        strokeWidth: 0
    }));
}
function $57e66c5a34f265b4$var$loadDiagramInfluenceAnalysis() {
    let $ = $lR8r2$gojs.GraphObject.make;
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis = $($lR8r2$gojs.Diagram, {
        "undoManager.isEnabled": true,
        scrollMode: $lR8r2$gojs.Diagram.InfiniteScroll,
        initialPosition: new $lR8r2$gojs.Point(-385, -25)
    });
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.div = "gDiagramDivIA";
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.contentAlignment = $lR8r2$gojs.Spot.TopLeft;
    const getNodeContextMenuOptions = ({ data: { task_str: task_str , attribute_array: attribute_array  }  })=>{
        return [
            {
                text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + " Lifecycle",
                event: ()=>{
                    $57e66c5a34f265b4$var$gTasksVisualizationSource = "ia_node";
                    $57e66c5a34f265b4$var$gInsightsAttributeArray = attribute_array;
                    $57e66c5a34f265b4$var$gTaskStr = task_str;
                    $57e66c5a34f265b4$export$51b3a147a1d97c17();
                    $57e66c5a34f265b4$export$63db7e18015c9f49();
                    (0, $7a9d81ef95270803$export$2c7243b488bf9a8f)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            },
            {
                text: "Detail",
                subMenuOptions: [
                    {
                        text: $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "ia_node";
                            for(let i = 0; i < attribute_array.length; i++)attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                            $57e66c5a34f265b4$var$gInsightsAttributeArray = attribute_array;
                            $57e66c5a34f265b4$var$gTaskStr = task_str;
                            (0, $b70023f2441d4f07$export$33d15ee0e1e0ff27)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    },
                    {
                        text: "Events",
                        event: ()=>{
                            $57e66c5a34f265b4$var$gDetailSource = "ia_node";
                            for(let i = 0; i < attribute_array.length; i++)attribute_array[i].id = attribute_array[i].id1; // bug in Go.JS storage of array in node
                            $57e66c5a34f265b4$var$gInsightsAttributeArray = attribute_array;
                            $57e66c5a34f265b4$var$gTaskStr = task_str;
                            (0, $8d0feb082b641fa1$export$7e15445a09500fa0)({
                                eventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                                activePane: $57e66c5a34f265b4$var$activePane
                            });
                        }
                    }, 
                ]
            },
            {
                text: "Filter",
                event: ()=>{
                    if ($57e66c5a34f265b4$var$gFilters.length > 0) $57e66c5a34f265b4$export$8da0d8f55c4b51d0("influence");
                    for(let i = 0; i < attribute_array.length; i++){
                        $57e66c5a34f265b4$var$gAttribute = attribute_array[i].field;
                        $57e66c5a34f265b4$var$gAttributeType = "Task";
                        let vtp = [];
                        vtp["value"] = attribute_array[i].value;
                        $57e66c5a34f265b4$var$gSelectedAttributes = [];
                        $57e66c5a34f265b4$var$gSelectedAttributes.push(vtp);
                        $57e66c5a34f265b4$export$3067f357aa66b5c2($57e66c5a34f265b4$var$gAttribute, $57e66c5a34f265b4$var$gAttributeType);
                    }
                    (0, $aecab291b608cebe$export$24e90a7f4e401128)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                    $57e66c5a34f265b4$export$eaf358d737cb394b();
                    (0, $4418db1243d61fd1$export$17b3808e0ffc259c)({
                        eventEmitter: $57e66c5a34f265b4$var$gEventEmitter
                    });
                }
            }, 
        ];
    };
    let contextMenuObj = null;
    const contextMenuInfluenceAnalysis = $($lR8r2$gojs.HTMLInfo, {
        show: (obj, diagram)=>{
            const { x: x , y: y  } = diagram.lastInput.viewPoint;
            const options = obj.part instanceof $lR8r2$gojs.Node ? getNodeContextMenuOptions(obj) : "";
            contextMenuObj = obj;
            (0, $a88d26ee1331adae$export$565dd6bf3240914a)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter,
                x: x,
                y: y,
                options: options
            });
        },
        hide: (diagram)=>{
            contextMenuObj = null;
            (0, $a88d26ee1331adae$export$a70b79ee19e88cfe)({
                gEventEmitter: $57e66c5a34f265b4$var$gEventEmitter
            });
        }
    });
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.nodeTemplate = $($lR8r2$gojs.Node, "Auto", {
        isShadowed: true,
        contextMenu: contextMenuInfluenceAnalysis
    }, new $lR8r2$gojs.Binding("location", "loc", $lR8r2$gojs.Point.parse).makeTwoWay($lR8r2$gojs.Point.stringify), $($lR8r2$gojs.Shape, {
        stroke: "lightgray",
        strokeWidth: 1
    }, new $lR8r2$gojs.Binding("figure", "fig"), new $lR8r2$gojs.Binding("width", "width"), new $lR8r2$gojs.Binding("height", "height"), new $lR8r2$gojs.Binding("fill", "color")), $($lR8r2$gojs.Panel, "Vertical", {
        alignment: $lR8r2$gojs.Spot.LeftCenter
    }, $($lR8r2$gojs.TextBlock, {
        margin: 2,
        font: "9pt Helvetica",
        maxSize: new $lR8r2$gojs.Size(320, NaN)
    }, new $lR8r2$gojs.Binding("stroke", "stroke"), new $lR8r2$gojs.Binding("text", "text"))));
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.linkTemplate = $("Link", $("Shape", {
        stroke: "#197BCD",
        strokeWidth: 2
    }), $("Shape", {
        fill: "#197BCD",
        stroke: null,
        toArrow: "Triangle"
    }));
}
function $57e66c5a34f265b4$export$b693c597fa907dbc() {
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisAttributes.length == 0) {
        for(let i = 0; i < $57e66c5a34f265b4$var$gTaskAttributes.length; i++)if (i < 5) $57e66c5a34f265b4$var$gInfluenceAnalysisAttributes.push($57e66c5a34f265b4$var$gTaskAttributes[i].field);
    }
    let influenceNodes = 20;
    let duration_mins = 0;
    let duration_hrs = 0;
    let duration_days = 0;
    let cost_savings = 0;
    let actual_cost = 0;
    let actual_cost_savings = 0;
    let compliant = 0;
    // compliance and automation
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskSlicedArray.length; i1++){
        duration_mins = duration_mins + $57e66c5a34f265b4$var$gTaskSlicedArray[i1].d / 60;
        duration_hrs = duration_hrs + $57e66c5a34f265b4$var$gTaskSlicedArray[i1].d / 3600;
        duration_days = duration_days + $57e66c5a34f265b4$var$gTaskSlicedArray[i1].d / 86400;
        cost_savings = cost_savings + ($57e66c5a34f265b4$var$gTaskSlicedArray[i1].actual_cost - $57e66c5a34f265b4$var$gTaskSlicedArray[i1].forecast_cost);
        actual_cost = actual_cost + $57e66c5a34f265b4$var$gTaskSlicedArray[i1].actual_cost;
        actual_cost_savings = actual_cost_savings + ($57e66c5a34f265b4$var$gTaskSlicedArray[i1].actual_cost - $57e66c5a34f265b4$var$gTaskSlicedArray[i1].forecast_cost);
        if ($57e66c5a34f265b4$var$gTaskSlicedArray[i1].compliant === true) compliant++;
    }
    let avg_duration_mins = duration_mins / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    let avg_duration_hrs = duration_hrs / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    let avg_duration_days = duration_days / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    let avg_cost = actual_cost / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    let avg_cost_savings = actual_cost_savings / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    let avg_compliance = compliant / $57e66c5a34f265b4$var$gTaskSlicedArray.length;
    const f = (A, i = 0)=>i == A.length ? [
            []
        ] : f(A, i + 1).flatMap((x)=>[
                x,
                [
                    A[i]
                ].concat(x)
            ]);
    let attributeCombinations = f($57e66c5a34f265b4$var$gInfluenceAnalysisAttributes);
    let attributeInfluencers = [];
    attributeInfluencers = [];
    let tempArray = [];
    let vtp = [];
    let i2 = 1;
    for(i2 = 1; i2 < attributeCombinations.length; i2++){
        tempArray = $57e66c5a34f265b4$var$TaskAttributeAnalysis(attributeCombinations[i2], $57e66c5a34f265b4$var$gInsightsMetric);
        for(let j = 0; j < tempArray.length; j++){
            vtp = {};
            vtp["attribute_str"] = tempArray[j].attribute_str;
            vtp["attribute_array"] = tempArray[j].attribute_array;
            vtp["attributes"] = tempArray[j].attributes;
            vtp["tasks"] = tempArray[j].tasks;
            vtp["task_str"] = tempArray[j].taskID;
            //vtp['task_str'] = "abcdef^asdasd"
            vtp["duration"] = tempArray[j].duration;
            vtp["compliant"] = tempArray[j].compliant;
            vtp["actual_cost"] = tempArray[j].actual_cost;
            vtp["forecast_cost"] = tempArray[j].forecast_cost;
            vtp["avg_duration_mins"] = tempArray[j].duration / tempArray[j].tasks / 60;
            vtp["avg_duration_hrs"] = tempArray[j].duration / tempArray[j].tasks / 3600;
            vtp["avg_duration_days"] = tempArray[j].duration / tempArray[j].tasks / 86400;
            vtp["total_cost"] = tempArray[j].actual_cost;
            vtp["avg_cost"] = tempArray[j].actual_cost / tempArray[j].tasks;
            vtp["avg_cost_savings"] = (tempArray[j].actual_cost - tempArray[j].forecast_cost) / tempArray[j].tasks;
            vtp["avg_compliance"] = tempArray[j].compliant / tempArray[j].tasks;
            attributeInfluencers.push(vtp);
        }
    }
    // remove duplicate combinations
    attributeInfluencers.sort((a, b)=>a.task_str.localeCompare(b.task_str) || a.attributes - b.attributes);
    let task_str = "";
    for(let i3 = 0; i3 < attributeInfluencers.length; i3++){
        if (i3 > 0 && task_str == attributeInfluencers[i3].task_str) {
            attributeInfluencers.splice(i3, 1);
            i3--;
        }
        task_str = attributeInfluencers[i3].task_str;
    }
    if (i2 > 0 && task_str == attributeInfluencers[attributeInfluencers.length - 1].task_str) attributeInfluencers.splice(i2, 1);
    let influenceResults = [];
    vtp = [];
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 2) {
        // Duration (mins)
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_duration_mins - a.avg_duration_mins);
        else attributeInfluencers.sort((a, b)=>a.avg_duration_mins - b.avg_duration_mins);
        for(let i4 = 0; i4 < attributeInfluencers.length; i4++)if (attributeInfluencers[i4].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i4].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i4].avg_duration_mins >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric && attributeInfluencers[i4].avg_duration_mins <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i4].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i4].attribute_array;
            vtp["value"] = attributeInfluencers[i4].avg_duration_mins;
            vtp["average"] = avg_duration_mins;
            vtp["tasks"] = attributeInfluencers[i4].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i4].task_str;
            vtp["difference"] = attributeInfluencers[i4].avg_duration_mins - avg_duration_mins;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 3) {
        // Duration (hrs)
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_duration_hrs - a.avg_duration_hrs);
        else attributeInfluencers.sort((a, b)=>a.avg_duration_hrs - b.avg_duration_hrs);
        for(let i5 = 0; i5 < attributeInfluencers.length; i5++)if (attributeInfluencers[i5].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i5].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i5].avg_duration_hrs >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric && attributeInfluencers[i5].avg_duration_hrs <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i5].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i5].attribute_array;
            vtp["value"] = attributeInfluencers[i5].avg_duration_hrs;
            vtp["average"] = avg_duration_hrs;
            vtp["tasks"] = attributeInfluencers[i5].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i5].task_str;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 4) {
        // Duration (days)
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_duration_days - a.avg_duration_days);
        else attributeInfluencers.sort((a, b)=>a.avg_duration_days - b.avg_duration_days);
        for(let i6 = 0; i6 < attributeInfluencers.length; i6++)if (attributeInfluencers[i6].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i6].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i6].avg_duration_days >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric && attributeInfluencers[i6].avg_duration_days <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i6].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i6].attribute_array;
            vtp["value"] = attributeInfluencers[i6].avg_duration_days;
            vtp["average"] = avg_duration_days;
            vtp["tasks"] = attributeInfluencers[i6].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i6].task_str;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 6) {
        // avg cost
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_cost - a.avg_cost);
        else attributeInfluencers.sort((a, b)=>a.avg_cost - b.avg_cost);
        for(let i7 = 0; i7 < attributeInfluencers.length; i7++)if (attributeInfluencers[i7].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i7].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i7].avg_cost >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric && attributeInfluencers[i7].avg_cost <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i7].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i7].attribute_array;
            vtp["value"] = attributeInfluencers[i7].avg_cost;
            vtp["average"] = avg_cost;
            vtp["tasks"] = attributeInfluencers[i7].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i7].task_str;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 7) {
        // avg cost savings
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_cost - a.avg_cost);
        else attributeInfluencers.sort((a, b)=>a.avg_cost - b.avg_cost);
        for(let i8 = 0; i8 < attributeInfluencers.length; i8++)if (attributeInfluencers[i8].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i8].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i8].avg_cost_savings >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric && attributeInfluencers[i8].avg_cost_savings <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i8].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i8].attribute_array;
            vtp["value"] = attributeInfluencers[i8].avg_cost_savings;
            vtp["average"] = avg_cost_savings;
            vtp["tasks"] = attributeInfluencers[i8].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i8].task_str;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 8) {
        // compliance
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") attributeInfluencers.sort((a, b)=>b.avg_compliance - a.avg_compliance);
        else attributeInfluencers.sort((a, b)=>a.avg_compliance - b.avg_compliance);
        for(let i9 = 0; i9 < attributeInfluencers.length; i9++)if (attributeInfluencers[i9].tasks >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks && attributeInfluencers[i9].tasks <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks && attributeInfluencers[i9].avg_compliance >= $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric / 100 && attributeInfluencers[i9].avg_compliance <= $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric / 100) {
            vtp = [];
            vtp["attribute_str"] = attributeInfluencers[i9].attribute_str;
            vtp["attribute_array"] = attributeInfluencers[i9].attribute_array;
            vtp["value"] = attributeInfluencers[i9].avg_compliance;
            vtp["average"] = avg_compliance;
            vtp["tasks"] = attributeInfluencers[i9].tasks;
            vtp["total_tasks"] = $57e66c5a34f265b4$var$gTaskSlicedArray.length;
            vtp["task_str"] = attributeInfluencers[i9].task_str;
            influenceResults.push(vtp);
        }
    }
    if ($57e66c5a34f265b4$var$gInfluenceAnalysisInfluence == "increase") influenceResults.sort((a, b)=>b.value - a.value);
    else influenceResults.sort((a, b)=>a.value - b.value);
    let influenceRows = [];
    for(let i10 = 0; i10 < influenceNodes; i10++)if (i10 < influenceResults.length) influenceRows.push(influenceResults[i10]);
    $57e66c5a34f265b4$var$influenceDiagram(influenceRows);
}
function $57e66c5a34f265b4$var$influenceDiagram(influenceRows) {
    const greenArr = new $57e66c5a34f265b4$var$Gradient().setColorGradient("#1C8B2F", "94F793").setMidpoint(influenceRows.length).getColors();
    let metric = $57e66c5a34f265b4$var$metricStr($57e66c5a34f265b4$var$gInfluenceAnalysisMetric);
    let nodeDataArray = [];
    let linkDataArray = [];
    let spacingStart = 0;
    let spacing = 80;
    let locXAttribute = -350;
    let locXValueMax = 300;
    let maxValue = 0;
    let minValue = 999999999;
    let key = 1;
    for(let j = 0; j < influenceRows.length; j++){
        if (influenceRows[j].value > maxValue) maxValue = influenceRows[j].value;
        if (influenceRows[j].value < minValue) minValue = influenceRows[j].value;
        let loc = locXAttribute + " " + (spacingStart + j * spacing);
        let vtp = [];
        vtp["key"] = key;
        vtp["color"] = "white";
        vtp["loc"] = loc;
        vtp["stroke"] = "#000000";
        vtp["fig"] = "Border";
        vtp["width"] = 330;
        vtp["height"] = 50;
        vtp["text"] = influenceRows[j].attribute_str;
        vtp["attribute_array"] = influenceRows[j].attribute_array;
        vtp["fill"] = greenArr[j];
        vtp["task_str"] = influenceRows[j].task_str;
        nodeDataArray.push(vtp);
        vtp = [];
        vtp["from"] = key;
        vtp["to"] = key + 1;
        linkDataArray.push(vtp);
        key = key + 2;
    }
    key = 2;
    for(let j1 = 0; j1 < influenceRows.length; j1++){
        let value = "";
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 2 || $57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 3 || $57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 4) value = $57e66c5a34f265b4$export$845857f28dc08744(influenceRows[j1].value, 2);
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 6 || $57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 7) value = $57e66c5a34f265b4$export$bdd804b47f20d359(influenceRows[j1].value);
        if ($57e66c5a34f265b4$var$gInfluenceAnalysisMetric == 8) value = $57e66c5a34f265b4$export$3e1eee59f5dc52be(influenceRows[j1].value);
        let ratio = locXValueMax - (maxValue - influenceRows[j1].value) / (maxValue - minValue) * locXValueMax;
        if (!ratio && ratio != 0) ratio = locXValueMax;
        let loc1 = ratio + " " + (spacingStart + j1 * spacing);
        let average = 0;
        if (influenceRows[j1].value != 0) average = (influenceRows[j1].value - influenceRows[j1].average) / influenceRows[j1].value;
        let directionText = " above average";
        if (average < 0) directionText = " below average";
        let nodeText = metric + ": " + value + "\r\n" + $57e66c5a34f265b4$export$3e1eee59f5dc52be(average, 1) + directionText + "\r\n" + $57e66c5a34f265b4$export$a2db1876938cd11d(influenceRows[j1].tasks) + " - " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(influenceRows[j1].tasks / influenceRows[j1].total_tasks, 1) + " of " + $57e66c5a34f265b4$var$gEntityLower + "s";
        let vtp1 = [];
        vtp1["key"] = key;
        vtp1["color"] = "#197BCD";
        vtp1["loc"] = loc1;
        vtp1["fig"] = "RoundedRectangle";
        vtp1["stroke"] = "white";
        vtp1["width"] = 150;
        vtp1["height"] = 50;
        vtp1["text"] = nodeText;
        vtp1["fill"] = greenArr[j1];
        vtp1["attribute_array"] = influenceRows[j1].attribute_array;
        vtp1["task_str"] = influenceRows[j1].task_str;
        nodeDataArray.push(vtp1);
        key = key + 2;
    }
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.model.nodeDataArray = nodeDataArray;
    $57e66c5a34f265b4$var$gDiagramInfluenceAnalysis.model.linkDataArray = linkDataArray;
}
function $57e66c5a34f265b4$var$TaskAttributeAnalysis(attributes, metricID) {
    // needs to return an array of the tasks associated with each row
    let InsightsAttributes = [];
    for(let i = 0; i < attributes.length; i++){
        for(let j = 0; j < $57e66c5a34f265b4$var$gTaskAttributes.length; j++)if ($57e66c5a34f265b4$var$gTaskAttributes[j].field == attributes[i]) InsightsAttributes.push($57e66c5a34f265b4$var$gTaskAttributes[j]);
    }
    let metric = $57e66c5a34f265b4$var$metricStr(metricID);
    let vtp = [];
    let tempTasks = [];
    let index = 0;
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gTaskSlicedArray.length; i1++){
        vtp = [];
        let attributeStr = "";
        for(let j1 = 0; j1 < InsightsAttributes.length; j1++){
            index = InsightsAttributes[j1].id;
            vtp[index] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1][index];
            if (j1 > 0) attributeStr = attributeStr + ", ";
            attributeStr = attributeStr + InsightsAttributes[j1].field + " is '" + $57e66c5a34f265b4$var$gTaskSlicedArray[i1][index] + "'";
        }
        vtp["attribute_str"] = attributeStr;
        vtp["task"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1].k;
        vtp["taskID"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1].id.toString();
        vtp["tasks"] = 1;
        vtp["duration"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1].d;
        vtp["actual_cost"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1].actual_cost;
        vtp["forecast_cost"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i1].forecast_cost;
        if ($57e66c5a34f265b4$var$gTaskSlicedArray[i1].compliant == true) vtp["compliant"] = 1;
        else vtp["compliant"] = 0;
        tempTasks.push(vtp);
    }
    const arr = tempTasks;
    let helper = {};
    let result = arr.reduce(function(r, o) {
        const key = o.ta0 + "-" + o.ta0 + "-" + o.ta1 + "-" + o.ta2 + "-" + o.ta3 + "-" + o.ta5 + "-" + o.ta6 + "-" + o.ta7 + "-" + o.ta8 + "-" + o.ta9 + "-";
        o.ta00, o.ta01, o.ta02, o.ta03, o.ta04, o.ta05, o.ta06, o.ta07, o.ta08, o.ta09;
        if (!helper[key]) {
            helper[key] = Object.assign({}, o);
            helper[key]["attributes"] = attributes.length;
            r.push(helper[key]);
        } else {
            helper[key]["tasks"] += o["tasks"];
            helper[key]["duration"] += o["duration"];
            helper[key]["actual_cost"] += o["actual_cost"];
            helper[key]["forecast_cost"] += o["forecast_cost"];
            helper[key]["compliant"] += o["compliant"];
            helper[key]["taskID"] = helper[key]["taskID"] + "^" + o["taskID"];
        }
        return r;
    }, []);
    let attributeArray = [];
    vtp = [];
    for(let i2 = 0; i2 < result.length; i2++){
        attributeArray = [];
        for(let j2 = 0; j2 < InsightsAttributes.length; j2++){
            vtp = [];
            vtp["id"] = InsightsAttributes[j2].id;
            vtp["field"] = InsightsAttributes[j2].field;
            vtp["value"] = result[i2][InsightsAttributes[j2].id];
            vtp["id1"] = InsightsAttributes[j2].id;
            attributeArray.push(vtp);
        }
        result[i2].attribute_array = attributeArray;
    }
    return result;
}
function $57e66c5a34f265b4$var$metricStr(metricNumber) {
    let metric = "";
    if (metricNumber == 1) metric = $57e66c5a34f265b4$var$gEntityUpper + "s";
    if (metricNumber == 2) metric = "Duration (mins)";
    if (metricNumber == 3) metric = "Duration (hrs)";
    if (metricNumber == 4) metric = "Duration (days)";
    if (metricNumber == 5) metric = "Total Cost";
    if (metricNumber == 6) metric = "Avg Cost";
    if (metricNumber == 7) metric = "Avg Cost Savings";
    if (metricNumber == 8) metric = "% Compliance";
    if (metricNumber == 9) metric = "% Automation";
    return metric;
}
function $57e66c5a34f265b4$export$e22f012476996d14() {
    let result = $57e66c5a34f265b4$var$TaskAttributeAnalysis($57e66c5a34f265b4$var$gInsightsAttributes, $57e66c5a34f265b4$var$gInsightsMetric);
    let attributes = $57e66c5a34f265b4$var$gInsightsAttributes;
    let InsightsAttributes = [];
    for(let i = 0; i < attributes.length; i++){
        for(let j = 0; j < $57e66c5a34f265b4$var$gTaskAttributes.length; j++)if ($57e66c5a34f265b4$var$gTaskAttributes[j].field == attributes[i]) InsightsAttributes.push($57e66c5a34f265b4$var$gTaskAttributes[j]);
    }
    let total_tasks = 0;
    for(let i1 = 0; i1 < result.length; i1++)total_tasks = total_tasks + result[i1].tasks;
    let metric = $57e66c5a34f265b4$var$metricStr($57e66c5a34f265b4$var$gInsightsMetric);
    let rows = $57e66c5a34f265b4$var$gInsightsRows;
    let minMetric = $57e66c5a34f265b4$var$gInsightsMinMetric;
    let maxMetric = $57e66c5a34f265b4$var$gInsightsMaxMetric;
    if ($57e66c5a34f265b4$var$gInsightsMetric === 8) {
        minMetric = minMetric / 100;
        maxMetric = maxMetric / 100;
    }
    for(let i2 = 0; i2 < result.length; i2++){
        result[i2][$57e66c5a34f265b4$var$gEntityUpper + "s"] = result[i2].tasks;
        result[i2]["Duration (mins)"] = result[i2].duration / 60 / result[i2].tasks;
        result[i2]["Duration (hrs)"] = result[i2].duration / 3600 / result[i2].tasks;
        result[i2]["Duration (days)"] = result[i2].duration / 86400 / result[i2].tasks;
        result[i2]["Total Cost"] = result[i2].actual_cost;
        result[i2]["Avg Cost"] = result[i2].actual_cost / result[i2].tasks;
        result[i2]["Avg Cost Savings"] = (result[i2].actual_cost - result[i2].forecast_cost) / result[i2].tasks;
        result[i2]["% Compliance"] = result[i2].compliant / result[i2].tasks;
        let splice = false;
        if (result[i2][metric] < minMetric) {
            result.splice(i2, 1);
            splice = true;
            i2--;
        } else if (result[i2][metric] > maxMetric) {
            result.splice(i2, 1);
            splice = true;
            i2--;
        }
        if (splice === false) {
            if (result[i2].tasks < $57e66c5a34f265b4$var$gInsightsMinTasks) {
                result.splice(i2, 1);
                splice = true;
                i2--;
            } else if (result[i2].tasks > $57e66c5a34f265b4$var$gInsightsMaxTasks) {
                result.splice(i2, 1);
                splice = true;
                i2--;
            }
        }
    }
    const redArr = new $57e66c5a34f265b4$var$Gradient().setColorGradient("#E24944", "#EFB7BA").setMidpoint(rows).getColors();
    const greenArr = new $57e66c5a34f265b4$var$Gradient().setColorGradient("#1C8B2F", "94F793").setMidpoint(rows).getColors();
    if ($57e66c5a34f265b4$var$gInsightsValueType === "high") result.sort((a, b)=>b[metric] - a[metric]);
    else result.sort((a, b)=>a[metric] - b[metric]);
    let tempArray = result.slice(0, rows);
    let nodeDataArray = [
        {
            key: 0,
            visible: false,
            name: ""
        }
    ];
    let key = 1;
    for(let j1 = 0; j1 < tempArray.length; j1++){
        let vtp = [];
        vtp["key"] = key;
        vtp["visible"] = true;
        if (j1 > 0) vtp["parent"] = key - 1;
        else vtp["parent"] = 0;
        let value = "";
        if ($57e66c5a34f265b4$var$gInsightsMetric == 1) value = $57e66c5a34f265b4$export$a2db1876938cd11d(tempArray[j1][metric]);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 2 || $57e66c5a34f265b4$var$gInsightsMetric == 3 || $57e66c5a34f265b4$var$gInsightsMetric == 4) value = tempArray[j1][metric].toFixed(2);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 5 || $57e66c5a34f265b4$var$gInsightsMetric == 6 || $57e66c5a34f265b4$var$gInsightsMetric == 7) value = $57e66c5a34f265b4$export$bdd804b47f20d359(tempArray[j1][metric]);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 8) value = $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j1][metric], 1);
        vtp["metric"] = metric + " - " + value;
        let attributesStr = "";
        let valuesStr = "";
        let index = 0;
        let attributeArray = [];
        for(let i3 = 0; i3 < InsightsAttributes.length; i3++){
            index = InsightsAttributes[i3].id;
            if (i3 > 0) {
                valuesStr = valuesStr + "\r\n";
                attributesStr = attributesStr + "\r\n";
            }
            attributesStr = attributesStr + InsightsAttributes[i3].field;
            valuesStr = valuesStr + tempArray[j1][index];
            let vtp1 = [];
            vtp1["attribute"] = InsightsAttributes[i3].field;
            vtp1["value"] = tempArray[j1][index];
            attributeArray.push(vtp1);
        }
        if ($57e66c5a34f265b4$var$gInsightsMetric == 1) vtp["text"] = "% Total: " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j1].tasks / total_tasks, 1);
        else vtp["text"] = $57e66c5a34f265b4$var$gEntityUpper + "s: " + $57e66c5a34f265b4$export$a2db1876938cd11d(tempArray[j1].tasks) + " ,% total: " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j1].tasks / total_tasks, 1);
        vtp["attributes"] = attributesStr;
        vtp["attributeArray"] = attributeArray;
        vtp["values"] = valuesStr;
        vtp["fill"] = greenArr[j1];
        vtp["task_str"] = tempArray[j1].taskID;
        nodeDataArray.push(vtp);
        key++;
    }
    if ($57e66c5a34f265b4$var$gInsightsValueType === "high") result.sort((a, b)=>a[metric] - b[metric]);
    else result.sort((a, b)=>b[metric] - a[metric]);
    tempArray = result.slice(0, rows);
    for(let j2 = 0; j2 < tempArray.length; j2++){
        let vtp2 = [];
        vtp2["key"] = key;
        vtp2["visible"] = true;
        if (j2 > 0) vtp2["parent"] = key - 1;
        else vtp2["parent"] = 0;
        let value1 = "";
        if ($57e66c5a34f265b4$var$gInsightsMetric == 1) value1 = $57e66c5a34f265b4$export$a2db1876938cd11d(tempArray[j2][metric]);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 2 || $57e66c5a34f265b4$var$gInsightsMetric == 3 || $57e66c5a34f265b4$var$gInsightsMetric == 4) value1 = tempArray[j2][metric].toFixed(2);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 5 || $57e66c5a34f265b4$var$gInsightsMetric == 6 || $57e66c5a34f265b4$var$gInsightsMetric == 7) value1 = $57e66c5a34f265b4$export$bdd804b47f20d359(tempArray[j2][metric]);
        if ($57e66c5a34f265b4$var$gInsightsMetric == 8) value1 = $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j2][metric], 1);
        vtp2["metric"] = metric + " - " + value1;
        let attributesStr1 = "";
        let valuesStr1 = "";
        let index1 = 0;
        let attributeArray1 = [];
        for(let i4 = 0; i4 < InsightsAttributes.length; i4++){
            index1 = InsightsAttributes[i4].id;
            if (i4 > 0) {
                valuesStr1 = valuesStr1 + "\r\n";
                attributesStr1 = attributesStr1 + "\r\n";
            }
            attributesStr1 = attributesStr1 + InsightsAttributes[i4].field;
            valuesStr1 = valuesStr1 + tempArray[j2][index1];
            let vtp3 = [];
            vtp3["attribute"] = InsightsAttributes[i4].field;
            vtp3["value"] = tempArray[j2][index1];
            attributeArray1.push(vtp3);
        }
        if ($57e66c5a34f265b4$var$gInsightsMetric == 1) vtp2["text"] = "% Total: " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j2].tasks / total_tasks, 1);
        else vtp2["text"] = $57e66c5a34f265b4$var$gEntityUpper + "s: " + $57e66c5a34f265b4$export$a2db1876938cd11d(tempArray[j2].tasks) + " ,% total: " + $57e66c5a34f265b4$export$3e1eee59f5dc52be(tempArray[j2].tasks / total_tasks, 1);
        vtp2["attributes"] = attributesStr1;
        vtp2["attributeArray"] = attributeArray1;
        vtp2["values"] = valuesStr1;
        vtp2["fill"] = redArr[j2];
        vtp2["task_str"] = tempArray[j2].taskID;
        nodeDataArray.push(vtp2);
        key++;
    }
    if ($57e66c5a34f265b4$var$gInsightsAttributes.length == 0) nodeDataArray = [];
    $57e66c5a34f265b4$var$gDiagramInsights.model = new $lR8r2$gojs.TreeModel(nodeDataArray);
}
function $57e66c5a34f265b4$export$29285b430bd23922(filter) {
    $57e66c5a34f265b4$var$gDecompositionTreeMetric = filter;
}
function $57e66c5a34f265b4$export$cdcd56b925cbb9af(filter) {
    $57e66c5a34f265b4$var$gInfluenceAnalysisMetric = filter;
}
function $57e66c5a34f265b4$export$f66e2aa810437141(filter) {
    $57e66c5a34f265b4$var$gDecompositionTreeValueType = filter;
}
function $57e66c5a34f265b4$export$ec00a85a719b1d0c() {
    return $57e66c5a34f265b4$var$gDecompositionTreeValueType;
}
function $57e66c5a34f265b4$export$3ee3329ee09145f9() {
    return $57e66c5a34f265b4$var$gInsightsValueType;
}
function $57e66c5a34f265b4$export$99bc2dbdccda51fe() {
    return $57e66c5a34f265b4$var$gInfluenceAnalysisInfluence;
}
function $57e66c5a34f265b4$export$48d41720ed9da60c(filter) {
    $57e66c5a34f265b4$var$gInsightsValueType = filter;
}
function $57e66c5a34f265b4$export$d0e0079ab3401e29(filter) {
    $57e66c5a34f265b4$var$gInfluenceAnalysisInfluence = filter;
}
function $57e66c5a34f265b4$export$3679b0d160d98153(attributes) {
    $57e66c5a34f265b4$var$gInsightsAttributes = attributes;
}
function $57e66c5a34f265b4$export$b648d1998753e9cc(attributes) {
    $57e66c5a34f265b4$var$gInfluenceAnalysisAttributes = attributes;
}
function $57e66c5a34f265b4$export$8bf16dc518529ab6() {
    return $57e66c5a34f265b4$var$gInsightsAttributes;
}
function $57e66c5a34f265b4$export$a53625ad464e5f8d() {
    return $57e66c5a34f265b4$var$gInfluenceAnalysisAttributes;
}
const $57e66c5a34f265b4$export$e8e945c125804cad = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gInsightsMinMetric = min ?? $57e66c5a34f265b4$var$gInsightsMinMetric;
    $57e66c5a34f265b4$var$gInsightsMaxMetric = max ?? $57e66c5a34f265b4$var$gInsightsMaxMetric;
};
const $57e66c5a34f265b4$export$ded4bd5df3f4cb5 = ()=>({
        min: $57e66c5a34f265b4$var$gInsightsMinMetric,
        max: $57e66c5a34f265b4$var$gInsightsMaxMetric
    });
const $57e66c5a34f265b4$export$20cb68fc0815ec0a = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gInsightsMinTasks = min ?? $57e66c5a34f265b4$var$gInsightsMinTasks;
    $57e66c5a34f265b4$var$gInsightsMaxTasks = max ?? $57e66c5a34f265b4$var$gInsightsMaxTasks;
};
const $57e66c5a34f265b4$export$c0e100bd56502100 = ()=>({
        min: $57e66c5a34f265b4$var$gInsightsMinTasks,
        max: $57e66c5a34f265b4$var$gInsightsMaxTasks
    });
const $57e66c5a34f265b4$export$597324953872718f = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric = min ?? $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric;
    $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric = max ?? $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric;
};
const $57e66c5a34f265b4$export$4a3d5d394131832f = ()=>({
        min: $57e66c5a34f265b4$var$gInfluenceAnalysisMinMetric,
        max: $57e66c5a34f265b4$var$gInfluenceAnalysisMaxMetric
    });
const $57e66c5a34f265b4$export$effa016fa1d36624 = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks = min ?? $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks;
    $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks = max ?? $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks;
};
const $57e66c5a34f265b4$export$5d691418b299f6dd = ()=>({
        min: $57e66c5a34f265b4$var$gInfluenceAnalysisMinTasks,
        max: $57e66c5a34f265b4$var$gInfluenceAnalysisMaxTasks
    });
const $57e66c5a34f265b4$export$6348777ed6ef7a89 = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gDecompositionTreeMinTasks = min ?? $57e66c5a34f265b4$var$gDecompositionTreeMinTasks;
    $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks = max ?? $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks;
};
const $57e66c5a34f265b4$export$983be1ad9d9ef4ec = ()=>({
        min: $57e66c5a34f265b4$var$gDecompositionTreeMinTasks,
        max: $57e66c5a34f265b4$var$gDecompositionTreeMaxTasks
    });
const $57e66c5a34f265b4$export$96303173843f664 = ({ min: min , max: max  })=>{
    $57e66c5a34f265b4$var$gDecompositionTreeMinMetric = min ?? $57e66c5a34f265b4$var$gDecompositionTreeMinMetric;
    $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric = max ?? $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric;
};
const $57e66c5a34f265b4$export$6fe6cb07c1abafe8 = ({ min: min  })=>{
    $57e66c5a34f265b4$var$gASAMinTasks = min ?? $57e66c5a34f265b4$var$gASAMinTasks;
};
const $57e66c5a34f265b4$export$f189dbef1e8a7829 = ()=>({
        min: $57e66c5a34f265b4$var$gDecompositionTreeMinMetric,
        max: $57e66c5a34f265b4$var$gDecompositionTreeMaxMetric
    });
function $57e66c5a34f265b4$export$eb4c55b185c3e94f(filter) {
    $57e66c5a34f265b4$var$gDecompositionTreeAttribute = filter;
}
function $57e66c5a34f265b4$export$a5e7df8db49f4c1c(filter) {
    $57e66c5a34f265b4$var$gInsightsMetric = filter;
}
function $57e66c5a34f265b4$export$193059be6213590c() {
    return $57e66c5a34f265b4$var$gInsightsMetric;
}
function $57e66c5a34f265b4$export$1f7203123d16eeea() {
    return $57e66c5a34f265b4$var$gDecompositionTreeMetric;
}
function $57e66c5a34f265b4$export$446e61525b7f9551() {
    return $57e66c5a34f265b4$var$gInfluenceAnalysisMetric;
}
class $57e66c5a34f265b4$var$GradientColor {
    constructor(startColor = "", endColor = "", minNum = 0, maxNum = 10){
        this.setColorGradient = (colorStart, colorEnd)=>{
            startColor = getHexColor(colorStart);
            endColor = getHexColor(colorEnd);
        };
        this.setMidpoint = (minNumber, maxNumber)=>{
            minNum = minNumber;
            maxNum = maxNumber;
        };
        this.getColor = (numberValue)=>{
            if (numberValue) return "#" + generateHex(numberValue, startColor.substring(0, 2), endColor.substring(0, 2)) + generateHex(numberValue, startColor.substring(2, 4), endColor.substring(2, 4)) + generateHex(numberValue, startColor.substring(4, 6), endColor.substring(4, 6));
        };
        const generateHex = (number, start, end)=>{
            if (number < minNum) number = minNum;
            else if (number > maxNum) number = maxNum;
            const midPoint = maxNum - minNum;
            const startBase = parseInt(start, 16);
            const endBase = parseInt(end, 16);
            const average = (endBase - startBase) / midPoint;
            const finalBase = Math.round(average * (number - minNum) + startBase);
            const balancedFinalBase = finalBase < 16 ? "0" + finalBase.toString(16) : finalBase.toString(16);
            return balancedFinalBase;
        };
        const getHexColor = (color)=>{
            return color.substring(color.length - 6, color.length);
        };
    }
}
class $57e66c5a34f265b4$var$Gradient {
    constructor(colorGradients = "", maxNum = 10, colors = [
        "",
        ""
    ], intervals = []){
        const setColorGradient = (gradientColors)=>{
            if (gradientColors.length < 2) throw new Error(`setColorGradient should have more than ${gradientColors.length} color`);
            else {
                const increment = maxNum / (gradientColors.length - 1);
                const firstColorGradient = new $57e66c5a34f265b4$var$GradientColor();
                const lower = 0;
                const upper = 0 + increment;
                firstColorGradient.setColorGradient(gradientColors[0], gradientColors[1]);
                firstColorGradient.setMidpoint(lower, upper);
                colorGradients = [
                    firstColorGradient
                ];
                intervals = [
                    {
                        lower: lower,
                        upper: upper
                    }, 
                ];
                for(let i = 1; i < gradientColors.length - 1; i++){
                    const gradientColor = new $57e66c5a34f265b4$var$GradientColor();
                    const lower1 = 0 + increment * i;
                    const upper1 = 0 + increment * (i + 1);
                    gradientColor.setColorGradient(gradientColors[i], gradientColors[i + 1]);
                    gradientColor.setMidpoint(lower1, upper1);
                    colorGradients[i] = gradientColor;
                    intervals[i] = {
                        lower: lower1,
                        upper: upper1
                    };
                }
                colors = gradientColors;
            }
        };
        this.setColorGradient = (...gradientColors)=>{
            setColorGradient(gradientColors);
            return this;
        };
        this.getColors = ()=>{
            const gradientColorsArray = [];
            for(let j = 0; j < intervals.length; j++){
                const interval = intervals[j];
                const start = interval.lower === 0 ? 1 : Math.ceil(interval.lower);
                const end = interval.upper === maxNum ? interval.upper + 1 : Math.ceil(interval.upper);
                for(let i = start; i < end; i++)gradientColorsArray.push(colorGradients[j].getColor(i));
            }
            return gradientColorsArray;
        };
        this.getColor = (numberValue)=>{
            if (isNaN(numberValue)) throw new TypeError(`getColor should be a number`);
            else if (numberValue <= 0) throw new TypeError(`getColor should be greater than ${numberValue}`);
            else {
                const toInsert = numberValue + 1;
                const segment = (maxNum - 0) / colorGradients.length;
                const index = Math.min(Math.floor((Math.max(numberValue, 0) - 0) / segment), colorGradients.length - 1);
                return colorGradients[index].getColor(toInsert);
            }
        };
        this.setMidpoint = (maxNumber)=>{
            if (!isNaN(maxNumber) && maxNumber >= 0) {
                maxNum = maxNumber;
                setColorGradient(colors);
            } else if (maxNumber <= 0) throw new RangeError(`midPoint should be greater than ${maxNumber}`);
            else throw new RangeError("midPoint should be a number");
            return this;
        };
    }
}
function $57e66c5a34f265b4$export$16704ae9db23c1bc() {
    return $57e66c5a34f265b4$var$gMinDiagramWidth;
}
function $57e66c5a34f265b4$export$70bb6a904ba4a0b3(columnState) {
    $57e66c5a34f265b4$var$gProcessRulesGridState = columnState;
}
function $57e66c5a34f265b4$export$bd54d9375752e708(columnState) {
    $57e66c5a34f265b4$var$gCostRulesGridState = columnState;
}
function $57e66c5a34f265b4$export$7e127858a7c44ce7() {
    return $57e66c5a34f265b4$var$gProcessRulesGridState;
}
function $57e66c5a34f265b4$export$e2c23903a127ac2a() {
    return $57e66c5a34f265b4$var$gCostRulesGridState;
}
function $57e66c5a34f265b4$export$b9c3f76fecc63a87(columnState) {
    $57e66c5a34f265b4$var$gVariantSlicerGridState = columnState;
}
function $57e66c5a34f265b4$export$22a2ae93901e0fa2() {
    return $57e66c5a34f265b4$var$gVariantSlicerGridState;
}
function $57e66c5a34f265b4$export$e86a830c06565001(columnState) {
    $57e66c5a34f265b4$var$gStepSlicerGridState = columnState;
}
function $57e66c5a34f265b4$export$20d2d8a98c167857() {
    return $57e66c5a34f265b4$var$gStepSlicerGridState;
}
function $57e66c5a34f265b4$export$d7e6a4b42b6c1682(columnState) {
    $57e66c5a34f265b4$var$gActivitySlicerGridState = columnState;
}
function $57e66c5a34f265b4$export$d8e7fd3126fc941() {
    return $57e66c5a34f265b4$var$gActivitySlicerGridState;
}
function $57e66c5a34f265b4$export$87ab4c26e4a61b0e(columnState) {
    $57e66c5a34f265b4$var$gTaskSlicerGridState = columnState;
}
function $57e66c5a34f265b4$export$3e10a0e23c835e88() {
    return $57e66c5a34f265b4$var$gTaskSlicerGridState;
}
function $57e66c5a34f265b4$export$f327bcbfdbb117dd(columnState) {
    $57e66c5a34f265b4$var$gTaskAttributeFilterGridState = columnState;
}
function $57e66c5a34f265b4$export$59374f58d7451f33() {
    return $57e66c5a34f265b4$var$gTaskAttributeFilterGridState;
}
function $57e66c5a34f265b4$export$d843f33999dbf8ff(columnState) {
    $57e66c5a34f265b4$var$gEventAttributeFilterGridState = columnState;
}
function $57e66c5a34f265b4$export$9e893cbd5c8fd175() {
    return $57e66c5a34f265b4$var$gEventAttributeFilterGridState;
}
const $57e66c5a34f265b4$export$a13dbf3c34277ef8 = ()=>{
    return $57e66c5a34f265b4$var$gRCDescription;
};
function $57e66c5a34f265b4$var$loadDiagramASA() {
    let $ = $lR8r2$gojs.GraphObject.make;
    $57e66c5a34f265b4$var$gDiagramASA = $($lR8r2$gojs.Diagram, {
        layout: $($lR8r2$gojs.LayeredDigraphLayout, {
            direction: 0
        }),
        defaultScale: 1.2,
        initialAutoScale: $lR8r2$gojs.Diagram.Uniform,
        contentAlignment: $lR8r2$gojs.Spot.Center
    });
    $57e66c5a34f265b4$var$gDiagramASA.div = "gDiagramDivASA";
    $57e66c5a34f265b4$var$gDiagramASA.toolManager.mouseWheelBehavior = $lR8r2$gojs.ToolManager.WheelZoom;
    $57e66c5a34f265b4$var$gDiagramASA.toolManager.hoverDelay = 500;
    $57e66c5a34f265b4$var$gDiagramASA.toolManager.toolTipDuration = 10000;
    $57e66c5a34f265b4$var$gDiagramASA.nodeTemplate = $($lR8r2$gojs.Node, "Auto", {
        locationSpot: $lR8r2$gojs.Spot.Center,
        isShadowed: true
    }, $($lR8r2$gojs.Shape, new $lR8r2$gojs.Binding("figure", "figure"), {
        stroke: "lightgray"
    }, new $lR8r2$gojs.Binding("fill", "fill_color"), new $lR8r2$gojs.Binding("border", "text_color")), {
        toolTip: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: "white",
            stroke: "gray",
            strokeWidth: 1
        }), $($lR8r2$gojs.TextBlock, {
            margin: 4,
            font: "9pt helvetica, arial, sans-serif"
        }, new $lR8r2$gojs.Binding("text", "tooltip")), new $lR8r2$gojs.Binding("visible", "disableTooltip", (disableTooltip)=>!disableTooltip))
    }, $($lR8r2$gojs.TextBlock, new $lR8r2$gojs.Binding("font", "font"), {
        textAlign: "center",
        margin: 3
    }, new $lR8r2$gojs.Binding("text"), new $lR8r2$gojs.Binding("stroke", "text_color"), new $lR8r2$gojs.Binding("visible", "visible")), {
        selectionAdornmentTemplate: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: null
        }, new $lR8r2$gojs.Binding("stroke", "highlight_color"), new $lR8r2$gojs.Binding("strokeWidth", "highlight_width")), $($lR8r2$gojs.Placeholder))
    });
    $57e66c5a34f265b4$var$gDiagramASA.linkTemplate = $($lR8r2$gojs.Link, {
        curve: $lR8r2$gojs.Link.Bezier,
        reshapable: true,
        adjusting: $lR8r2$gojs.Link.Stretch
    }, $($lR8r2$gojs.Shape, new $lR8r2$gojs.Binding("stroke", "link_color"), new $lR8r2$gojs.Binding("strokeWidth", "width"), new $lR8r2$gojs.Binding("visible", "visible"), new $lR8r2$gojs.Binding("strokeDashArray", "dashes", function(l) {
        return l ? [
            3,
            2
        ] : null;
    })), $($lR8r2$gojs.Shape, {
        toArrow: "standard",
        strokeWidth: 0
    }, new $lR8r2$gojs.Binding("fill", "link_color")), {
        toolTip: $($lR8r2$gojs.Adornment, "Auto", $($lR8r2$gojs.Shape, "RoundedRectangle", {
            fill: "white",
            stroke: "gray",
            strokeWidth: 1
        }), $($lR8r2$gojs.TextBlock, {
            margin: 4,
            font: "9pt helvetica, arial, sans-serif"
        }, new $lR8r2$gojs.Binding("text", "tooltip")), new $lR8r2$gojs.Binding("visible", "disableTooltip", (disableTooltip)=>!disableTooltip))
    }, $($lR8r2$gojs.Panel, "Auto", $($lR8r2$gojs.Shape, {
        fill: $($lR8r2$gojs.Brush, "Radial", {
            0: "rgb(240, 240, 240)",
            0.3: "rgb(240, 240, 240)",
            1: "rgba(240, 240, 240, 0)"
        }),
        stroke: null
    }), $($lR8r2$gojs.TextBlock, {
        textAlign: "center",
        margin: 8
    }, new $lR8r2$gojs.Binding("font", "font"), new $lR8r2$gojs.Binding("visible", "label_visible"), new $lR8r2$gojs.Binding("text", "link_label"))));
}
function $57e66c5a34f265b4$export$3d216efdc8774939() {
    $57e66c5a34f265b4$var$loadDiagramASA();
    $57e66c5a34f265b4$export$5f738a2c36cfbd91();
}
function $57e66c5a34f265b4$export$5f738a2c36cfbd91() {
    const tempLinks = [
        ...$57e66c5a34f265b4$var$gASALinks
    ];
    const tempNodes = [
        ...$57e66c5a34f265b4$var$gASANodes
    ];
    for(let i = 0; i < tempNodes.length; i++){
        tempNodes[i].visible = true;
        if (tempNodes[i].perc_total <= $57e66c5a34f265b4$var$gASAMinTasks && tempNodes[i].selected_activity === false || tempNodes[i].tasks === 0) {
            for(let j = 0; j < tempLinks.length; j++){
                if ($57e66c5a34f265b4$var$gASAType === "Inbound") {
                    if (parseInt(tempLinks[j].from) === parseInt(tempNodes[i].key)) {
                        tempLinks.splice(j, 1);
                        j--;
                    }
                }
                if ($57e66c5a34f265b4$var$gASAType === "Outbound") {
                    if (parseInt(tempLinks[j].to) === parseInt(tempNodes[i].key)) {
                        tempLinks.splice(j, 1);
                        j--;
                    }
                }
            }
            tempNodes.splice(i, 1);
            i--;
        }
        if (tempNodes[i].start_node === true) {
            // check that a link exists with start key = 1
            let startLinkExists = false;
            for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gASALinks.length; j1++)if (parseInt($57e66c5a34f265b4$var$gASALinks[j1].from) === 1) startLinkExists = true;
            if (startLinkExists === false) tempNodes[i].visible = false;
        }
        if (tempNodes[i].end_node === true) tempNodes[i].visible = false;
    }
    for(let i1 = 0; i1 < tempNodes.length; i1++)if (tempNodes[i1].visible === false) {
        tempNodes.splice(i1, 1);
        i1--;
    }
    $57e66c5a34f265b4$var$gDiagramASA.model.linkDataArray = tempLinks;
    $57e66c5a34f265b4$var$gDiagramASA.model.nodeDataArray = tempNodes;
    $57e66c5a34f265b4$var$gDiagramASA.layout.layerSpacing = 80;
    $57e66c5a34f265b4$var$gDiagramASA.layout.rowSpacing = 30;
    $57e66c5a34f265b4$var$gDiagramASA.zoomToFit();
}
function $57e66c5a34f265b4$export$6d6957ed193f48f9() {
    let valueToPush = [];
    let processRulesArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gComplianceRules.length; i++){
        valueToPush = [];
        valueToPush["category"] = "Compliance";
        valueToPush["ruleType"] = "compliance";
        valueToPush["ruleID"] = $57e66c5a34f265b4$var$gComplianceRules[i].ruleID;
        valueToPush["detail"] = "";
        valueToPush["rule"] = $57e66c5a34f265b4$var$gComplianceRules[i].rule;
        valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gComplianceRules[i].calculateCostImpact;
        valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gComplianceRules[i].fromActivityStr;
        valueToPush["toActivity"] = $57e66c5a34f265b4$var$gComplianceRules[i].toActivityStr;
        valueToPush["conditions"] = $57e66c5a34f265b4$var$gComplianceRules[i].conditionsArray;
        valueToPush["events"] = $57e66c5a34f265b4$var$gComplianceRules[i].events;
        valueToPush["tasks"] = $57e66c5a34f265b4$var$gComplianceRules[i].tasks;
        valueToPush["avgImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gComplianceRules[i].impactDuration / $57e66c5a34f265b4$var$gComplianceRules[i].tasks);
        valueToPush["totalImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gComplianceRules[i].impactDuration);
        valueToPush["sort"] = "1";
        valueToPush["actualCost"] = $57e66c5a34f265b4$var$gComplianceRules[i].actualCost;
        if ($57e66c5a34f265b4$var$gComplianceRules[i].actualCost != null) {
            valueToPush["forecastCost"] = $57e66c5a34f265b4$var$gComplianceRules[i].forecastCost;
            valueToPush["costSavings"] = $57e66c5a34f265b4$var$gComplianceRules[i].actualCost - $57e66c5a34f265b4$var$gComplianceRules[i].forecastCost;
            valueToPush["percCostSaving"] = ($57e66c5a34f265b4$var$gComplianceRules[i].actualCost - $57e66c5a34f265b4$var$gComplianceRules[i].forecastCost) / $57e66c5a34f265b4$var$gComplianceRules[i].actualCost;
            valueToPush["actualCostTask"] = $57e66c5a34f265b4$var$gComplianceRules[i].actualCost / $57e66c5a34f265b4$var$gComplianceRules[i].tasks;
            valueToPush["forecastCostTask"] = $57e66c5a34f265b4$var$gComplianceRules[i].forecastCost / $57e66c5a34f265b4$var$gComplianceRules[i].tasks;
            valueToPush["costSavingsTask"] = ($57e66c5a34f265b4$var$gComplianceRules[i].actualCost - $57e66c5a34f265b4$var$gComplianceRules[i].forecastCost) / $57e66c5a34f265b4$var$gComplianceRules[i].tasks;
        } else {
            valueToPush["forecastCost"] = null;
            valueToPush["costSavings"] = null;
            valueToPush["percCostSaving"] = null;
            valueToPush["actualCostTask"] = null;
            valueToPush["forecastCostTask"] = null;
            valueToPush["costSavingsTask"] = null;
        }
        valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationOperator;
        valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualFrom;
        valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationActualTo;
        valueToPush["durationValue"] = $57e66c5a34f265b4$var$gComplianceRules[i].durationValue;
        processRulesArray.push(valueToPush);
    }
    for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gPerformanceRules.length; i1++){
        valueToPush = [];
        valueToPush["category"] = "Performance";
        valueToPush["ruleType"] = "performance";
        valueToPush["ruleID"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].ruleID;
        valueToPush["detail"] = "";
        valueToPush["rule"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].rule;
        valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].calculateCostImpact;
        valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].fromActivityStr;
        valueToPush["toActivity"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].toActivityStr;
        valueToPush["conditions"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].conditionsArray;
        valueToPush["events"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].events;
        valueToPush["tasks"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].tasks;
        valueToPush["actualCost"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost;
        valueToPush["avgImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gPerformanceRules[i1].impactDuration / $57e66c5a34f265b4$var$gPerformanceRules[i1].tasks);
        valueToPush["totalImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gPerformanceRules[i1].impactDuration);
        valueToPush["sort"] = "2";
        if ($57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost != null) {
            valueToPush["forecastCost"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].forecastCost;
            valueToPush["costSavings"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost - $57e66c5a34f265b4$var$gPerformanceRules[i1].forecastCost;
            valueToPush["percCostSaving"] = ($57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost - $57e66c5a34f265b4$var$gPerformanceRules[i1].forecastCost) / $57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost;
            valueToPush["actualCostTask"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost / $57e66c5a34f265b4$var$gPerformanceRules[i1].tasks;
            valueToPush["forecastCostTask"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].forecastCost / $57e66c5a34f265b4$var$gPerformanceRules[i1].tasks;
            valueToPush["costSavingsTask"] = ($57e66c5a34f265b4$var$gPerformanceRules[i1].actualCost - $57e66c5a34f265b4$var$gPerformanceRules[i1].forecastCost) / $57e66c5a34f265b4$var$gPerformanceRules[i1].tasks;
        } else {
            valueToPush["forecastCost"] = null;
            valueToPush["costSavings"] = null;
            valueToPush["percCostSaving"] = null;
            valueToPush["actualCostTask"] = null;
            valueToPush["forecastCostTask"] = null;
            valueToPush["costSavingsTask"] = null;
        }
        valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].durationOperator;
        valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].durationActualFrom;
        valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].durationActualTo;
        valueToPush["durationValue"] = $57e66c5a34f265b4$var$gPerformanceRules[i1].durationValue;
        processRulesArray.push(valueToPush);
    }
    for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gAutomationRules.length; i2++){
        valueToPush = [];
        valueToPush["category"] = "Automation";
        valueToPush["ruleType"] = "automation";
        valueToPush["ruleID"] = $57e66c5a34f265b4$var$gAutomationRules[i2].ruleID;
        valueToPush["detail"] = "";
        valueToPush["rule"] = $57e66c5a34f265b4$var$gAutomationRules[i2].rule;
        valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gAutomationRules[i2].calculateCostImpact;
        valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gAutomationRules[i2].fromActivityStr;
        valueToPush["toActivity"] = $57e66c5a34f265b4$var$gAutomationRules[i2].toActivityStr;
        valueToPush["conditions"] = $57e66c5a34f265b4$var$gAutomationRules[i2].conditionsArray;
        valueToPush["events"] = $57e66c5a34f265b4$var$gAutomationRules[i2].events;
        valueToPush["tasks"] = $57e66c5a34f265b4$var$gAutomationRules[i2].tasks;
        valueToPush["avgImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gAutomationRules[i2].impactDuration / $57e66c5a34f265b4$var$gAutomationRules[i2].tasks);
        valueToPush["totalImpactDuration"] = $57e66c5a34f265b4$export$17c1ae3dc9ebba7a($57e66c5a34f265b4$var$gAutomationRules[i2].impactDuration);
        valueToPush["sort"] = "3";
        valueToPush["actualCost"] = $57e66c5a34f265b4$var$gAutomationRules[i2].actualCost;
        if ($57e66c5a34f265b4$var$gAutomationRules[i2].actualCost != null) {
            valueToPush["forecastCost"] = $57e66c5a34f265b4$var$gAutomationRules[i2].forecastCost;
            valueToPush["costSavings"] = $57e66c5a34f265b4$var$gAutomationRules[i2].actualCost - $57e66c5a34f265b4$var$gAutomationRules[i2].forecastCost;
            valueToPush["percCostSaving"] = ($57e66c5a34f265b4$var$gAutomationRules[i2].actualCost - $57e66c5a34f265b4$var$gAutomationRules[i2].forecastCost) / $57e66c5a34f265b4$var$gAutomationRules[i2].actualCost;
            valueToPush["actualCostTask"] = $57e66c5a34f265b4$var$gAutomationRules[i2].actualCost / $57e66c5a34f265b4$var$gAutomationRules[i2].tasks;
            valueToPush["forecastCostTask"] = $57e66c5a34f265b4$var$gAutomationRules[i2].forecastCost / $57e66c5a34f265b4$var$gAutomationRules[i2].tasks;
            valueToPush["costSavingsTask"] = ($57e66c5a34f265b4$var$gAutomationRules[i2].actualCost - $57e66c5a34f265b4$var$gAutomationRules[i2].forecastCost) / $57e66c5a34f265b4$var$gAutomationRules[i2].tasks;
        } else {
            valueToPush["forecastCost"] = null;
            valueToPush["costSavings"] = null;
            valueToPush["percCostSaving"] = null;
            valueToPush["actualCostTask"] = null;
            valueToPush["forecastCostTask"] = null;
            valueToPush["costSavingsTask"] = null;
        }
        valueToPush["durationOperator"] = $57e66c5a34f265b4$var$gAutomationRules[i2].durationOperator;
        valueToPush["durationActualFrom"] = $57e66c5a34f265b4$var$gAutomationRules[i2].durationActualFrom;
        valueToPush["durationActualTo"] = $57e66c5a34f265b4$var$gAutomationRules[i2].durationActualTo;
        valueToPush["durationValue"] = $57e66c5a34f265b4$var$gAutomationRules[i2].durationValue;
        processRulesArray.push(valueToPush);
    }
    processRulesArray.sort((a, b)=>a.sort.localeCompare(b.sort) || a.rule.localeCompare(b.rule));
    return processRulesArray;
}
function $57e66c5a34f265b4$export$6d5ef0b15f2841ab() {
    let valueToPush = [];
    let costRulesArray = [];
    for(let i = 0; i < $57e66c5a34f265b4$var$gCostRules.length; i++){
        valueToPush = [];
        valueToPush["category"] = "Cost";
        valueToPush["ruleType"] = "cost";
        valueToPush["ruleID"] = $57e66c5a34f265b4$var$gCostRules[i].ruleID;
        valueToPush["rule"] = $57e66c5a34f265b4$var$gCostRules[i].rule;
        valueToPush["calculateCostImpact"] = $57e66c5a34f265b4$var$gCostRules[i].calculateCostImpact;
        valueToPush["fromActivity"] = $57e66c5a34f265b4$var$gCostRules[i].fromActivityStr;
        valueToPush["toActivity"] = $57e66c5a34f265b4$var$gCostRules[i].toActivityStr;
        valueToPush["conditions"] = $57e66c5a34f265b4$var$gCostRules[i].conditionsArray;
        valueToPush["events"] = $57e66c5a34f265b4$var$gCostRules[i].events;
        valueToPush["tasks"] = $57e66c5a34f265b4$var$gCostRules[i].tasks;
        if ($57e66c5a34f265b4$var$gCostRules[i].costType === "total") valueToPush["type"] = "Total";
        if ($57e66c5a34f265b4$var$gCostRules[i].costType === "perday") valueToPush["type"] = "Per day";
        if ($57e66c5a34f265b4$var$gCostRules[i].costType === "perhour") valueToPush["type"] = "Per hour";
        if ($57e66c5a34f265b4$var$gCostRules[i].costType === "perminute") valueToPush["type"] = "Per minute";
        valueToPush["actualCost"] = $57e66c5a34f265b4$var$gCostRules[i].actualCost;
        costRulesArray.push(valueToPush);
    }
    costRulesArray.sort((a, b)=>a.rule.localeCompare(b.rule));
    return costRulesArray;
}
const $57e66c5a34f265b4$export$b52de6745c1a27a5 = (graphType)=>{
    $57e66c5a34f265b4$var$gVariantsVisualizationGraphType = graphType;
};
const $57e66c5a34f265b4$export$e6b60d9360e18c1d = (metric)=>{
    $57e66c5a34f265b4$var$gVariantsVisualizationMetric = metric;
};
function $57e66c5a34f265b4$export$3a67d80d8f3ff092() {
    let type = $57e66c5a34f265b4$var$gVariantsVisualizationGraphType;
    let metric = $57e66c5a34f265b4$var$gVariantsVisualizationMetric;
    $57e66c5a34f265b4$var$gLinkArray.sort((a, b)=>a.variant_sequence - b.variant_sequence || a.sort_key - b.sort_key);
    let v = -1;
    let variantCtr = 0;
    let seriesData = [];
    let categoryData = [];
    let lastActivityAddedIndex = 0;
    for(let i = 0; i < $57e66c5a34f265b4$var$gLinkArray.length; i++){
        let variantSequence = "";
        let validVariant = false;
        for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gLinkArray[i].variant === $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
            validVariant = true;
            break;
        }
        if (validVariant === true) {
            if ($57e66c5a34f265b4$var$gLinkArray[i].end_node === false && $57e66c5a34f265b4$var$gLinkArray[i].start_node === false) {
                if (v != $57e66c5a34f265b4$var$gLinkArray[i].variant_id) {
                    let variantTasks = 0;
                    let variant = "";
                    for(let p = 0; p < $57e66c5a34f265b4$var$gVariantArray.length; p++)if ($57e66c5a34f265b4$var$gVariantArray[p].v === parseInt($57e66c5a34f265b4$var$gLinkArray[i].variant)) {
                        variantSequence = $57e66c5a34f265b4$var$gVariantArray[p].s;
                        variantTasks = $57e66c5a34f265b4$var$gVariantArray[p].t;
                        variant = $57e66c5a34f265b4$var$gVariantArray[p].n;
                        break;
                    }
                    if (v != -1) {
                        let maxData = 0;
                        for(let m = 0; m < seriesData.length; m++)if (seriesData[m].data.length > maxData) maxData = seriesData[m].data.length;
                        for(let m1 = 0; m1 < seriesData.length; m1++){
                            let toAdd = maxData - seriesData[m1].data.length;
                            if (toAdd > 0) for(let n = 0; n < toAdd; n++)seriesData[m1].data.push(0);
                        }
                    }
                    variantCtr = variantCtr + 1;
                    if (variantSequence < 10) variantSequence = "  " + variantSequence;
                    else if (variantSequence < 100) variantSequence = " " + variantSequence;
                    //categoryData.push('Variant ID: ' + variantSequence + '<br/>Variant:' + variant + '<br/>Tasks: ' + Number(variantTasks).toLocaleString())
                    categoryData.push("Variant ID: " + variantSequence + "<br/>Tasks: " + Number(variantTasks).toLocaleString());
                }
                v = $57e66c5a34f265b4$var$gLinkArray[i].variant_id;
                // check if activity exists, if not, then add
                let activityExists = false;
                let j1 = 0;
                for(j1 = 0; j1 < seriesData.length; j1++)if (seriesData[j1].name === $57e66c5a34f265b4$var$gLinkArray[i].from_label) {
                    activityExists = true;
                    for(let l = 0; l < seriesData[j1].variants.length + 1; l++)if (seriesData[j1].variants[l] === $57e66c5a34f265b4$var$gLinkArray[i].variant_id) {
                        activityExists = false; // loop
                        break;
                    }
                    if (activityExists == true && j1 < lastActivityAddedIndex) activityExists = false;
                    break;
                }
                if (activityExists === false) {
                    // find out if it's the first instance of the activity
                    let firstInstance = true;
                    for(let l1 = 0; l1 < seriesData.length; l1++)if (seriesData[l1].name === $57e66c5a34f265b4$var$gLinkArray[i].from_label) {
                        firstInstance = false;
                        break;
                    }
                    let tempData = [];
                    for(let k = 1; k < variantCtr; k++)tempData.push(0);
                    if (type === 1) {
                        let value = 0;
                        if (metric === 0) value = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 60;
                        if (metric === 1) value = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 3600;
                        if (metric === 2) value = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 86400;
                        if (metric === 3) value = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost;
                        if (metric === 4) value = $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost;
                        if (metric === 5) value = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost - $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost;
                        if (metric === 6) value = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 7) value = $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 8) value = ($57e66c5a34f265b4$var$gLinkArray[i].actual_cost - $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost) / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 9) value = $57e66c5a34f265b4$var$gLinkArray[i].compliant / $57e66c5a34f265b4$var$gLinkArray[i].tasks * 100;
                        tempData.push(Number(value.toPrecision(2)));
                    } else tempData.push(1);
                    let variants = [];
                    variants.push($57e66c5a34f265b4$var$gLinkArray[i].variant_id);
                    let vtp = {};
                    vtp["name"] = $57e66c5a34f265b4$var$gLinkArray[i].from_label;
                    vtp["data"] = tempData;
                    vtp["sort"] = i;
                    if (firstInstance === false) vtp["linkedTo"] = ":previous";
                    vtp["variants"] = variants; // stores which variants are attached to this activity in the series
                    seriesData.push(vtp);
                    lastActivityAddedIndex = seriesData.length;
                }
                if (activityExists === true) {
                    if (type === 1) {
                        let value1 = 0;
                        if (metric === 0) value1 = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 60;
                        if (metric === 1) value1 = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 3600;
                        if (metric === 2) value1 = $57e66c5a34f265b4$var$gLinkArray[i].duration / $57e66c5a34f265b4$var$gLinkArray[i].tasks / 86400;
                        if (metric === 3) value1 = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost;
                        if (metric === 4) value1 = $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost;
                        if (metric === 5) value1 = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost - $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost;
                        if (metric === 6) value1 = $57e66c5a34f265b4$var$gLinkArray[i].actual_cost / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 7) value1 = $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 8) value1 = ($57e66c5a34f265b4$var$gLinkArray[i].actual_cost - $57e66c5a34f265b4$var$gLinkArray[i].forecast_cost) / $57e66c5a34f265b4$var$gLinkArray[i].tasks;
                        if (metric === 9) value1 = $57e66c5a34f265b4$var$gLinkArray[i].compliant / $57e66c5a34f265b4$var$gLinkArray[i].tasks * 100;
                        seriesData[j1].data.push(Number(value1.toPrecision(2)));
                    } else seriesData[j1].data.push(1);
                }
            }
        }
    }
    if (v != -1) {
        let maxData1 = 0;
        for(let m2 = 0; m2 < seriesData.length; m2++)if (seriesData[m2].data.length > maxData1) maxData1 = seriesData[m2].data.length;
        for(let m3 = 0; m3 < seriesData.length; m3++){
            let toAdd1 = maxData1 - seriesData[m3].data.length;
            if (toAdd1 > 0) for(let n1 = 0; n1 < toAdd1; n1++)seriesData[m3].data.push(0);
        }
    }
    var activities = [];
    var activityID = 0;
    for(let i1 = 0; i1 < seriesData.length; i1++){
        var activityFound = false;
        for(let j2 = 0; j2 < activities.length; j2++)if (activities[j2].activity === seriesData[i1].name) {
            var activityFound = true;
            break;
        }
        if (activityFound === false) {
            let vtp1 = [];
            vtp1["activity"] = seriesData[i1].name;
            vtp1["id"] = activityID;
            activities.push(vtp1);
            activityID++;
        }
    }
    const colors = [
        "#7cb5ec",
        "#434348",
        "#90ed7d",
        "#f7a35c",
        "#8085e9",
        "#f15c80",
        "#e4d354",
        "#2b908f",
        "#f45b5b",
        "#91e8e1",
        "#2f7ed8",
        "#0d233a",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a",
        "#4572A7",
        "#AA4643",
        "#89A54E",
        "#80699B",
        "#3D96AE",
        "#DB843D",
        "#92A8CD",
        "#A47D7C",
        "#B5CA92", 
    ];
    for(let i2 = 0; i2 < seriesData.length; i2++){
        for(let j3 = 0; j3 < activities.length; j3++)if (activities[j3].activity === seriesData[i2].name) {
            if (seriesData[i2].name === "Start") seriesData[i2].showInLegend = false;
            else {
                if (seriesData[i2].linkedTo === ":previous") seriesData[i2].showInLegend = false;
                else {
                    seriesData[i2].showInLegend = true;
                    seriesData[i2].legendIndex = activities[j3].id;
                }
                seriesData[i2].color = colors[activities[j3].id];
            }
            break;
        }
    }
    $57e66c5a34f265b4$var$gHistogramSeries = [
        ...seriesData
    ];
    $57e66c5a34f265b4$var$gHistogramCategory = [
        ...categoryData
    ];
}
function $57e66c5a34f265b4$export$63db7e18015c9f49() {
    let start = new Date().getTime();
    let startNode = 0;
    let endNode = 0;
    $57e66c5a34f265b4$var$gTasksVisualizationNumTasks = 30;
    for(let j = 0; j < $57e66c5a34f265b4$var$gActivityArray.length; j++){
        if ($57e66c5a34f265b4$var$gActivityArray[j].start_node == true) startNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
        if ($57e66c5a34f265b4$var$gActivityArray[j].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j].id;
    }
    let eventArray = [];
    $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.id - b.id);
    if ($57e66c5a34f265b4$var$gTasksVisualizationSource === "step" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "activity" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "variant" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "dt_node" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "is_node" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "ia_node" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "cost" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "compliance" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "automation" || $57e66c5a34f265b4$var$gTasksVisualizationSource === "performance") {
        if ($57e66c5a34f265b4$var$gTasksVisualizationFilter === 0) {
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 0) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.d - a.d);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 1) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.d - a.d);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 2) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a.k.localeCompare(b.k));
        }
        if ($57e66c5a34f265b4$var$gTasksVisualizationFilter === 1) {
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 0) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.actual_cost - a.actual_cost);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 1) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.actual_cost - a.actual_cost);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 2) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a.k.localeCompare(b.k));
        }
        if ($57e66c5a34f265b4$var$gTasksVisualizationFilter === 2) {
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 0) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.forecast_cost - a.forecast_cost);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 1) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.forecast_cost - a.forecast_cost);
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 2) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a.k.localeCompare(b.k));
        }
        if ($57e66c5a34f265b4$var$gTasksVisualizationFilter === 3) {
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 0) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>b.actual_cost - b.forecast_cost - (a.actual_cost - a.forecast_cost));
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 1) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a.actual_cost - a.forecast_cost - (b.actual_cost - b.forecast_cost));
            if ($57e66c5a34f265b4$var$gTasksVisualizationSort === 2) $57e66c5a34f265b4$var$gTaskSlicedArray.sort((a, b)=>a.k.localeCompare(b.k));
        }
        for(let i = 0; i < $57e66c5a34f265b4$var$gTaskSlicedArray.length; i++){
            for(let f = $57e66c5a34f265b4$var$gTaskSlicedArray[i].fi; f > $57e66c5a34f265b4$var$gTaskSlicedArray[i].si; f--)if ($57e66c5a34f265b4$var$gEventLogArray[f].f != startNode && $57e66c5a34f265b4$var$gEventLogArray[f].t != endNode) {
                let vtp = [];
                for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gActivityArray.length; j1++)if ($57e66c5a34f265b4$var$gActivityArray[j1].id == $57e66c5a34f265b4$var$gEventLogArray[f].f) {
                    vtp["fromNode"] = $57e66c5a34f265b4$var$gActivityArray[j1].activity;
                    break;
                }
                vtp["d"] = $57e66c5a34f265b4$var$gEventLogArray[f].d;
                vtp["actual_cost"] = $57e66c5a34f265b4$var$gEventLogArray[f].actual_cost;
                vtp["forecast_cost"] = $57e66c5a34f265b4$var$gEventLogArray[f].forecast_cost;
                vtp["sort"] = $57e66c5a34f265b4$var$gEventLogArray[f].s;
                if ($57e66c5a34f265b4$var$gEventLogArray[f].compliant === true) vtp["compliant"] = 1;
                else vtp["compliant"] = 0;
                vtp["k"] = $57e66c5a34f265b4$var$gTaskSlicedArray[i].k;
                eventArray.push(vtp);
            }
            if (i > $57e66c5a34f265b4$var$gTasksVisualizationNumTasks) break;
        }
    }
    if ($57e66c5a34f265b4$var$gTasksVisualizationSource === "detail") {
        $57e66c5a34f265b4$var$gTaskArray.sort((a, b)=>a.id - b.id);
        let vtp1 = [];
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gDetailTaskTasksSelected.length; i1++){
            for(let f1 = $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gDetailTaskTasksSelected[i1].id].fi; f1 > $57e66c5a34f265b4$var$gTaskArray[$57e66c5a34f265b4$var$gDetailTaskTasksSelected[i1].id].si; f1--)if ($57e66c5a34f265b4$var$gEventLogArray[f1].f != startNode && $57e66c5a34f265b4$var$gEventLogArray[f1].t != endNode) {
                vtp1 = [];
                for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gActivityArray.length; j2++)if ($57e66c5a34f265b4$var$gActivityArray[j2].id == $57e66c5a34f265b4$var$gEventLogArray[f1].f) {
                    vtp1["fromNode"] = $57e66c5a34f265b4$var$gActivityArray[j2].activity;
                    break;
                }
                vtp1["d"] = $57e66c5a34f265b4$var$gEventLogArray[f1].d;
                vtp1["actual_cost"] = $57e66c5a34f265b4$var$gEventLogArray[f1].actual_cost;
                vtp1["forecast_cost"] = $57e66c5a34f265b4$var$gEventLogArray[f1].forecast_cost;
                vtp1["sort"] = $57e66c5a34f265b4$var$gEventLogArray[f1].s;
                if ($57e66c5a34f265b4$var$gEventLogArray[f1].compliant === true) vtp1["compliant"] = 1;
                else vtp1["compliant"] = 0;
                vtp1["k"] = $57e66c5a34f265b4$var$gEventLogArray[f1].k;
                eventArray.push(vtp1);
            }
        }
    }
    let k = "";
    let taskCtr = 0;
    let seriesData = [];
    let categoryData = [];
    let lastActivityAddedIndex = 0;
    eventArray.sort((a, b)=>a.k.localeCompare(b.k) || a.sort - b.sort);
    for(let i2 = 0; i2 < eventArray.length; i2++){
        if (k != eventArray[i2].k) {
            if (k != "") {
                let maxData = 0;
                for(let m = 0; m < seriesData.length; m++)if (seriesData[m].data.length > maxData) maxData = seriesData[m].data.length;
                for(let m1 = 0; m1 < seriesData.length; m1++){
                    let toAdd = maxData - seriesData[m1].data.length;
                    if (toAdd > 0) for(let n = 0; n < toAdd; n++)seriesData[m1].data.push(0);
                }
                taskCtr = taskCtr + 1;
                categoryData.push(k);
            }
        }
        k = eventArray[i2].k;
        // check if activity exists, if not, then add
        let activityExists = false;
        let j3 = 0;
        for(j3 = 0; j3 < seriesData.length; j3++)if (seriesData[j3].name === eventArray[i2].fromNode) {
            activityExists = true;
            for(let l = 0; l < seriesData[j3].tasks.length + 1; l++)if (seriesData[j3].tasks[l] === eventArray[i2].fromNode) {
                activityExists = false; // loop
                break;
            }
            if (activityExists == true && j3 < lastActivityAddedIndex) activityExists = false;
            break;
        }
        if (activityExists === false) {
            let firstInstance = true;
            for(let l1 = 0; l1 < seriesData.length; l1++)if (seriesData[l1].name === eventArray[i2].fromNode) {
                firstInstance = false;
                break;
            }
            let tempData = [];
            for(let k1 = 0; k1 < taskCtr; k1++)tempData.push(0);
            if ($57e66c5a34f265b4$var$gTasksVisualizationGraphType === 1) {
                let value = 0;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 0) value = eventArray[i2].d / 60;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 1) value = eventArray[i2].d / 3600;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 2) value = eventArray[i2].d / 86400;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 3) value = eventArray[i2].actual_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 4) value = eventArray[i2].forecast_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 5) value = eventArray[i2].actual_cost - eventArray[i2].forecast_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 6) value = eventArray[i2].compliant / eventArray[i2].tasks * 100;
                tempData.push(Number(value.toPrecision(2)));
            } else tempData.push(1);
            let tasks = [];
            tasks.push(eventArray[i2].k);
            let vtp2 = {};
            vtp2["name"] = eventArray[i2].fromNode;
            vtp2["data"] = tempData;
            vtp2["sort"] = i2;
            if (firstInstance === false) vtp2["linkedTo"] = ":previous";
            vtp2["tasks"] = tasks; // stores which variants are attached to this activity in the series
            seriesData.push(vtp2);
            lastActivityAddedIndex = seriesData.length;
        }
        if (activityExists === true) {
            if ($57e66c5a34f265b4$var$gTasksVisualizationGraphType === 1) {
                let value1 = 0;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 0) value1 = eventArray[i2].d / 60;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 1) value1 = eventArray[i2].d / 3600;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 2) value1 = eventArray[i2].d / 86400;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 3) value1 = eventArray[i2].actual_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 4) value1 = eventArray[i2].forecast_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 5) value1 = eventArray[i2].actual_cost - eventArray[i2].forecast_cost;
                if ($57e66c5a34f265b4$var$gTasksVisualizationMetric === 6) value1 = eventArray[i2].compliant / eventArray[i2].tasks * 100;
                seriesData[j3].data.push(Number(value1.toPrecision(2)));
            } else seriesData[j3].data.push(1);
            seriesData[j3].tasks.push(eventArray[i2].k);
        }
    }
    if (k != "") {
        let maxData1 = 0;
        for(let m2 = 0; m2 < seriesData.length; m2++)if (seriesData[m2].data.length > maxData1) maxData1 = seriesData[m2].data.length;
        for(let m3 = 0; m3 < seriesData.length; m3++){
            let toAdd1 = maxData1 - seriesData[m3].data.length;
            if (toAdd1 > 0) for(let n1 = 0; n1 < toAdd1; n1++)seriesData[m3].data.push(0);
        }
    }
    categoryData.push(k);
    var activities = [];
    var activityID = 0;
    for(let i3 = 0; i3 < seriesData.length; i3++){
        var activityFound = false;
        for(let j4 = 0; j4 < activities.length; j4++)if (activities[j4].activity === seriesData[i3].name) {
            var activityFound = true;
            break;
        }
        if (activityFound === false) {
            let vtp3 = [];
            vtp3["activity"] = seriesData[i3].name;
            vtp3["id"] = activityID;
            activities.push(vtp3);
            activityID++;
        }
    }
    const colors = [
        "#7cb5ec",
        "#434348",
        "#90ed7d",
        "#f7a35c",
        "#8085e9",
        "#f15c80",
        "#e4d354",
        "#2b908f",
        "#f45b5b",
        "#91e8e1",
        "#2f7ed8",
        "#0d233a",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a",
        "#4572A7",
        "#AA4643",
        "#89A54E",
        "#80699B",
        "#3D96AE",
        "#DB843D",
        "#92A8CD",
        "#A47D7C",
        "#B5CA92", 
    ];
    for(let i4 = 0; i4 < seriesData.length; i4++){
        for(let j5 = 0; j5 < activities.length; j5++)if (activities[j5].activity === seriesData[i4].name) {
            if (seriesData[i4].linkedTo === ":previous") seriesData[i4].showInLegend = false;
            else {
                seriesData[i4].showInLegend = true;
                seriesData[i4].legendIndex = activities[j5].id;
            }
            seriesData[i4].color = colors[activities[j5].id];
        }
    }
    $57e66c5a34f265b4$var$gHistogramSeries = [
        ...seriesData
    ];
    $57e66c5a34f265b4$var$gHistogramCategory = [
        ...categoryData
    ];
}
function $57e66c5a34f265b4$export$6cca92ac29f346ec() {
    return $57e66c5a34f265b4$var$gHistogramArray;
}
function $57e66c5a34f265b4$export$1c350cff0d97be6() {
    return $57e66c5a34f265b4$var$gDetailDescription;
}
function $57e66c5a34f265b4$export$bbe62bd73435d1b7() {
    return $57e66c5a34f265b4$var$gActiveAction;
}
function $57e66c5a34f265b4$export$5aafeb6db603ac7a(action) {
    $57e66c5a34f265b4$var$gActiveAction = action;
}
const $57e66c5a34f265b4$export$b73036cb160b9040 = (graphType)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationGraphType = graphType;
};
const $57e66c5a34f265b4$export$cb7cf428bffb1059 = (metric)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationMetric = metric;
};
const $57e66c5a34f265b4$export$418ef504d869fc9a = (numTasks)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationNumTasks = numTasks;
};
const $57e66c5a34f265b4$export$bfd35fca27553ffc = (filter)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationFilter = filter;
};
const $57e66c5a34f265b4$export$78e1557c7600222c = (source)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationSource = source;
};
const $57e66c5a34f265b4$export$3d03a212c61bceaa = (sort)=>{
    $57e66c5a34f265b4$var$gTasksVisualizationSort = sort;
};
function $57e66c5a34f265b4$export$70569108c74b0b00(type, variantPaneVariants, variant, activity, from, to) {
    // mount issue when already displaying - Synergy
    // splice disappears when changing duration
    // fix formatting of histogram - x-axis more values, etc
    // statistics and formatting (tasks/events issue)
    $57e66c5a34f265b4$var$gHistogramArray = [];
    $57e66c5a34f265b4$var$gHistogramDescription = "";
    $57e66c5a34f265b4$var$gHistogramTotal = "";
    if (type === "step-events" || type === "step-tasks") {
        let fromStr = "";
        let toStr = "";
        for(let i = 0; i < $57e66c5a34f265b4$var$gActivityArray.length; i++){
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt(from)) fromStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
            if ($57e66c5a34f265b4$var$gActivityArray[i].id === parseInt(to)) toStr = $57e66c5a34f265b4$var$gActivityArray[i].activity;
        }
        if (type === "step-events") $57e66c5a34f265b4$var$gHistogramDescription = " Event Duration Histogram (^^^) for Step = " + fromStr + ", to Step = " + toStr;
        if (type === "step-tasks") $57e66c5a34f265b4$var$gHistogramDescription = " Task Duration Histogram (^^^) for Step = " + fromStr + ", to Step = " + toStr;
    }
    if (type === "activity-events" || type === "activity-tasks") {
        let activityStr = "";
        for(let i1 = 0; i1 < $57e66c5a34f265b4$var$gActivityArray.length; i1++)if ($57e66c5a34f265b4$var$gActivityArray[i1].id === parseInt(activity)) activityStr = $57e66c5a34f265b4$var$gActivityArray[i1].activity;
        if (type === "activity-events") $57e66c5a34f265b4$var$gHistogramDescription = " Event Duration Histogram ^^^ for Activity = " + activityStr;
        if (type === "activity-tasks") $57e66c5a34f265b4$var$gHistogramDescription = " Task Duration Histogram ^^^ for Activity = " + activityStr;
    }
    if (type === "variant-events" || type === "variant-tasks") {
        let variantStr = "";
        for(let i2 = 0; i2 < $57e66c5a34f265b4$var$gVariantArray.length; i2++)if (parseInt($57e66c5a34f265b4$var$gVariantArray[i2].v) === parseInt(variant)) {
            variantStr = $57e66c5a34f265b4$var$gVariantArray[i2].n;
            break;
        }
        if (type === "variant-events") $57e66c5a34f265b4$var$gHistogramDescription = " Event Duration Histogram ^^^ for Variant = " + variantStr;
        if (type === "variant-tasks") $57e66c5a34f265b4$var$gHistogramDescription = " Task Duration Histogram ^^^ for Variant = " + variantStr;
    }
    if (type === "diagram-events") $57e66c5a34f265b4$var$gHistogramDescription = " Event Duration Histogram ^^^ for selected variants";
    if (type === "diagram-tasks") $57e66c5a34f265b4$var$gHistogramDescription = " Task Duration Histogram ^^^ for selected variants";
    if (type === "step-events") {
        $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
        for(let i3 = 0; i3 < $57e66c5a34f265b4$var$gEventLogArray.length; i3++){
            if ($57e66c5a34f265b4$var$gEventLogArray[i3].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i3].vid].sliced == true) {
                if ($57e66c5a34f265b4$var$gEventLogArray[i3].f == parseInt(from) && $57e66c5a34f265b4$var$gEventLogArray[i3].t == parseInt(to)) {
                    let validEvent = true;
                    if (variantPaneVariants == true) {
                        validEvent = false;
                        for(let j = 0; j < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j++)if ($57e66c5a34f265b4$var$gEventLogArray[i3].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j].v) {
                            validEvent = true;
                            break;
                        }
                    }
                    if (validEvent === true) {
                        let vtp = [];
                        vtp.secs = parseFloat($57e66c5a34f265b4$var$gEventLogArray[i3].d.toFixed(2));
                        vtp.mins = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i3].d / 60).toFixed(2));
                        vtp.hrs = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i3].d / 3600).toFixed(2));
                        vtp.days = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i3].d / 86400).toFixed(2));
                        $57e66c5a34f265b4$var$gHistogramArray.push(vtp);
                    }
                }
            }
        }
    }
    if (type === "activity-events") {
        $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
        for(let i4 = 0; i4 < $57e66c5a34f265b4$var$gEventLogArray.length; i4++){
            if ($57e66c5a34f265b4$var$gEventLogArray[i4].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i4].vid].sliced == true) {
                if ($57e66c5a34f265b4$var$gEventLogArray[i4].t == parseInt(activity)) {
                    let validEvent1 = true;
                    if (variantPaneVariants == true) {
                        validEvent1 = false;
                        for(let j1 = 0; j1 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j1++)if ($57e66c5a34f265b4$var$gEventLogArray[i4].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j1].v) {
                            validEvent1 = true;
                            break;
                        }
                    }
                    if (validEvent1 === true) {
                        let vtp1 = [];
                        vtp1.secs = parseFloat($57e66c5a34f265b4$var$gEventLogArray[i4].d.toFixed(2));
                        vtp1.mins = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i4].d / 60).toFixed(2));
                        vtp1.hrs = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i4].d / 3600).toFixed(2));
                        vtp1.days = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i4].d / 86400).toFixed(2));
                        $57e66c5a34f265b4$var$gHistogramArray.push(vtp1);
                    }
                }
            }
        }
    }
    let endNode = 0;
    for(let j2 = 0; j2 < $57e66c5a34f265b4$var$gActivityArray.length; j2++)if ($57e66c5a34f265b4$var$gActivityArray[j2].end_node == true) endNode = $57e66c5a34f265b4$var$gActivityArray[j2].id;
    if (type === "variant-events") {
        $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
        for(let i5 = 0; i5 < $57e66c5a34f265b4$var$gEventLogArray.length; i5++){
            if ($57e66c5a34f265b4$var$gEventLogArray[i5].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i5].vid].sliced == true) {
                if ($57e66c5a34f265b4$var$gEventLogArray[i5].v == parseInt(variant) && $57e66c5a34f265b4$var$gEventLogArray[i5].t != endNode) {
                    let vtp2 = [];
                    vtp2.secs = parseFloat($57e66c5a34f265b4$var$gEventLogArray[i5].d.toFixed(2));
                    vtp2.mins = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i5].d / 60).toFixed(2));
                    vtp2.hrs = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i5].d / 3600).toFixed(2));
                    vtp2.days = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i5].d / 86400).toFixed(2));
                    $57e66c5a34f265b4$var$gHistogramArray.push(vtp2);
                }
            }
        }
    }
    if (type === "diagram-events") {
        $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
        for(let i6 = 0; i6 < $57e66c5a34f265b4$var$gEventLogArray.length; i6++)if ($57e66c5a34f265b4$var$gEventLogArray[i6].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gEventLogArray[i6].vid].sliced == true && $57e66c5a34f265b4$var$gEventLogArray[i6].t != endNode) {
            let validEvent2 = true;
            if (variantPaneVariants == true) {
                validEvent2 = false;
                for(let j3 = 0; j3 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j3++)if ($57e66c5a34f265b4$var$gEventLogArray[i6].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j3].v) {
                    validEvent2 = true;
                    break;
                }
            }
            if (validEvent2 === true) {
                let vtp3 = [];
                vtp3.secs = parseFloat($57e66c5a34f265b4$var$gEventLogArray[i6].d.toFixed(2));
                vtp3.mins = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i6].d / 60).toFixed(2));
                vtp3.hrs = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i6].d / 3600).toFixed(2));
                vtp3.days = parseFloat(($57e66c5a34f265b4$var$gEventLogArray[i6].d / 86400).toFixed(2));
                $57e66c5a34f265b4$var$gHistogramArray.push(vtp3);
            }
        }
    }
    if (type === "step-tasks" || type === "activity-tasks" || type === "variant-tasks" || type === "diagram-tasks") {
        $57e66c5a34f265b4$var$gVariantArray.sort((a, b)=>a.id - b.id);
        $57e66c5a34f265b4$var$gEventLogArray.sort((a, b)=>a.elid - b.elid);
        for(let i7 = 0; i7 < $57e66c5a34f265b4$var$gTaskArray.length; i7++)if ($57e66c5a34f265b4$var$gTaskArray[i7].filtered != 1 && $57e66c5a34f265b4$var$gVariantArray[$57e66c5a34f265b4$var$gTaskArray[i7].vid].sliced == true) {
            let validTask = true;
            if (variantPaneVariants == true) {
                validTask = false;
                for(let j4 = 0; j4 < $57e66c5a34f265b4$var$gVariantPaneVariants.length; j4++)if ($57e66c5a34f265b4$var$gTaskArray[i7].v == $57e66c5a34f265b4$var$gVariantPaneVariants[j4].v) {
                    validTask = true;
                    break;
                }
            }
            if (validTask == true) {
                if (type != "diagram-tasks") validTask = false;
                if (type == "variant-tasks") {
                    if ($57e66c5a34f265b4$var$gTaskArray[i7].v == variant) validTask = true;
                }
                if (type == "activity-tasks") {
                    for(let f = $57e66c5a34f265b4$var$gTaskArray[i7].si; f < $57e66c5a34f265b4$var$gTaskArray[i7].fi + 1; f++)if ($57e66c5a34f265b4$var$gEventLogArray[f].t == parseInt(activity)) {
                        validTask = true;
                        break;
                    }
                }
                if (type == "step-tasks") {
                    for(let f1 = $57e66c5a34f265b4$var$gTaskArray[i7].si; f1 < $57e66c5a34f265b4$var$gTaskArray[i7].fi + 1; f1++)if ($57e66c5a34f265b4$var$gEventLogArray[f1].f == parseInt(from) && $57e66c5a34f265b4$var$gEventLogArray[f1].t == parseInt(to)) {
                        validTask = true;
                        break;
                    }
                }
                if (validTask == true) {
                    let vtp4 = [];
                    vtp4.secs = parseFloat($57e66c5a34f265b4$var$gTaskArray[i7].d.toFixed(2));
                    vtp4.mins = parseFloat(($57e66c5a34f265b4$var$gTaskArray[i7].d / 60).toFixed(2));
                    vtp4.hrs = parseFloat(($57e66c5a34f265b4$var$gTaskArray[i7].d / 3600).toFixed(2));
                    vtp4.days = parseFloat(($57e66c5a34f265b4$var$gTaskArray[i7].d / 86400).toFixed(2));
                    $57e66c5a34f265b4$var$gHistogramArray.push(vtp4);
                }
            }
        }
    }
    if (type.includes("event") === true) {
        $57e66c5a34f265b4$var$gHistogramTotal = "Total Events: " + $57e66c5a34f265b4$var$gHistogramArray.length;
        $57e66c5a34f265b4$var$gHistogramType = "Events";
    }
    if (type.includes("task") === true) {
        $57e66c5a34f265b4$var$gHistogramTotal = "Total Tasks: " + $57e66c5a34f265b4$var$gHistogramArray.length;
        $57e66c5a34f265b4$var$gHistogramType = $57e66c5a34f265b4$export$7bca99abddcf9a72() + "s";
    }
}
function $57e66c5a34f265b4$export$eca9b2c455d0fce3() {
    return $57e66c5a34f265b4$var$gHistogramDescription;
}
function $57e66c5a34f265b4$export$1315927c299f8faf() {
    return $57e66c5a34f265b4$var$gHistogramTotal;
}
function $57e66c5a34f265b4$export$7804c5fe550f3770() {
    return $57e66c5a34f265b4$var$gTaskAttributes.length;
}
function $57e66c5a34f265b4$export$1a79e676222326af() {
    return $57e66c5a34f265b4$var$gHistogramType;
}
function $57e66c5a34f265b4$export$66e96b3bda7387a1() {
    return $57e66c5a34f265b4$var$gHistogramSeries.sort((a, b)=>b.sort - a.sort);
}
function $57e66c5a34f265b4$export$d059fbf4ed140fc2() {
    return $57e66c5a34f265b4$var$gHistogramCategory;
}
function $57e66c5a34f265b4$export$57570b1603cf6adb() {
    return $57e66c5a34f265b4$var$gEnvironment;
}
function $57e66c5a34f265b4$export$ca432a243c6c77f7() {
    return $57e66c5a34f265b4$var$gDev;
}
function $57e66c5a34f265b4$export$1d2f0dc727063c01() {
    return $57e66c5a34f265b4$var$urlHost;
}
function $57e66c5a34f265b4$export$d9e6ddf3245c7faa() {
    return $57e66c5a34f265b4$var$modelID;
}
function $57e66c5a34f265b4$export$9dce03151d073bb8() {
    return $57e66c5a34f265b4$var$gLoadingStatus;
}
function $57e66c5a34f265b4$export$f8bda234a8554be() {
    return $57e66c5a34f265b4$var$userSessionToken;
}
const $57e66c5a34f265b4$export$b638c5c2e01b79c8 = ({ setting: setting  })=>{
    $57e66c5a34f265b4$var$gSaveSlicers = setting ?? $57e66c5a34f265b4$var$gSaveSlicers;
};
function $57e66c5a34f265b4$var$checkStepDuration(durationOperator, durationActualFrom, durationActualTo, durationValue, duration) {
    let validEvent = false;
    let durationFrom = durationActualFrom;
    if (durationValue === "mins") durationFrom = durationActualFrom * 60;
    if (durationValue === "hrs") durationFrom = durationActualFrom * 3600;
    if (durationValue === "days") durationFrom = durationActualFrom * 86400;
    let durationTo = durationActualTo;
    if (durationOperator === "between" || durationOperator === "between or is" || durationOperator === "outside" || durationOperator === "outside or is") {
        if (durationValue === "mins") durationTo = durationActualTo * 60;
        if (durationValue === "hrs") durationTo = durationActualTo * 3600;
        if (durationValue === "days") durationTo = durationActualTo * 86400;
    }
    if (durationOperator === "greater than") {
        if (duration > durationFrom) validEvent = true;
    }
    if (durationOperator === "greater than or is") {
        if (duration >= durationFrom) validEvent = true;
    }
    if (durationOperator === "less than") {
        if (duration < durationFrom) validEvent = true;
    }
    if (durationOperator === "less than or is") {
        if (duration <= durationFrom) validEvent = true;
    }
    if (durationOperator === "equal to") {
        if (duration === durationFrom) validEvent = true;
    }
    if (durationOperator === "not equal to") {
        if (duration !== durationFrom) validEvent = true;
    }
    if (durationOperator === "between") {
        if (duration > durationFrom && duration < durationTo) validEvent = true;
    }
    if (durationOperator === "between or is") {
        if (duration >= durationFrom && duration <= durationTo) validEvent = true;
    }
    if (durationOperator === "outside") {
        if (duration < durationFrom && duration > durationTo) validEvent = true;
    }
    if (durationOperator === "outside or is") {
        if (duration <= durationFrom && duration >= durationTo) validEvent = true;
    }
    return validEvent;
}















const $4fdd51d9e9f82b56$export$3067f357aa66b5c2 = ({ attribute: attribute , attributeType: attributeType , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$3067f357aa66b5c2)(attribute, attributeType);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({
        eventEmitter: eventEmitter
    });
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};





const $1848795815c689d0$export$e5dbdcbe8d57d390 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$e5dbdcbe8d57d390)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({
        eventEmitter: eventEmitter
    });
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};




const $cf01f395c32ca758$export$d7af1f47ccac45e4 = ({ fromTime: fromTime , toTime: toTime , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$d7af1f47ccac45e4)(fromTime, toTime);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
    apiProvider.setAction_ProcessVisualizer({
        eventEmitter: eventEmitter
    });
    apiProvider.setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};





const $511d84a927ce9089$export$1968c4d10f8059c8 = ({ metricFilter: metricFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$1968c4d10f8059c8)(metricFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive);
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({
        eventEmitter: eventEmitter
    });
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};



const $d62010623c72786c$export$15a7855b158af2b2 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetAttributeFilter);
};




const $4f02902e2d2ffb9e$export$434a715c23827d7e = ({ eventEmitter: eventEmitter  })=>{
    const resetValues = (0, $57e66c5a34f265b4$export$8b362cc2cfd64eb3)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, resetValues);
};




const $9037dbbe8439ace5$export$a3af08e85d4cf2c6 = ({ eventEmitter: eventEmitter  })=>{
    const values = (0, $57e66c5a34f265b4$export$a3af08e85d4cf2c6)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, values);
};



const $f3c1958dd82bac5b$export$20d953f08d854d08 = ({ selection: selection  })=>{
    (0, $57e66c5a34f265b4$export$4e88a88b150e6235)(selection);
};



const $3f12aed98de5edd6$export$bc98d6fbac005943 = ({ attribute: attribute , attributeType: attributeType  })=>(0, $57e66c5a34f265b4$export$bc98d6fbac005943)(attribute, attributeType);



const $184ebea7606ad285$export$ac6d06e7706e3b10 = ()=>(0, $57e66c5a34f265b4$export$ac6d06e7706e3b10)();



const $bef5488ff778c2dd$export$cfe2815244b4d4f2 = ({ readOnly: readOnly , checked: checked , indeterminate: indeterminate ,  })=>{
    (0, $57e66c5a34f265b4$export$f18a29131e55bbd0)(readOnly, checked, indeterminate);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("variantFilterCompliant");
};



const $8978f8d8a60b537d$export$f7d76861870f698c = ({ readOnly: readOnly , checked: checked , indeterminate: indeterminate ,  })=>{
    (0, $57e66c5a34f265b4$export$55a2cec46aa3249f)(readOnly, checked, indeterminate);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("variantFilterAutomate");
};



const $4928230d762cb1dd$export$6fa4f4e2c46c44cc = ({ readOnly: readOnly , checked: checked , indeterminate: indeterminate ,  })=>{
    (0, $57e66c5a34f265b4$export$292af01450da17dd)(readOnly, checked, indeterminate);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("variantFilterLoops");
};



const $59b2af3643fa7509$export$3f66ecfa32892985 = ({})=>(0, $57e66c5a34f265b4$export$3f66ecfa32892985)();



const $4347e5672073f3b7$export$ecf224330435bd6e = ({})=>(0, $57e66c5a34f265b4$export$ecf224330435bd6e)();



const $c23064c90cb3b2ec$export$b05f54e556e2eadb = ({})=>(0, $57e66c5a34f265b4$export$b05f54e556e2eadb)();



const $042dc098ac08118e$export$b0c5c2fac8144e54 = ({})=>(0, $57e66c5a34f265b4$export$b0c5c2fac8144e54)();



const $ad7307a6f914494b$export$b5db2815d25965f1 = ({ row: row  })=>{
    (0, $57e66c5a34f265b4$export$cc8a4b0d17d53ffc)(row);
};




const $aefb66f51e577e5c$export$d80cc0328fcc6685 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$d80cc0328fcc6685)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};




const $9cdb14f6b89d445e$export$f327bcbfdbb117dd = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$f327bcbfdbb117dd)(columnState);
};



const $05be4558e0472b95$export$d843f33999dbf8ff = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$d843f33999dbf8ff)(columnState);
};




const $165bf53ca33e0035$export$e7f77cd8774d671d = ({ sliced_metrics: sliced_metrics , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$1976c9b4d38be365)({
        sliced_metrics: sliced_metrics
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes);
};
const $165bf53ca33e0035$export$4e0992c2b6acfdee = ()=>(0, $57e66c5a34f265b4$export$dafa60d37bf5af3c)();



const $15cc0575c2f37eac$export$1a9ef722d19f9a5c = {
    applyAttributesFilter: $4fdd51d9e9f82b56$export$3067f357aa66b5c2,
    applyTasksFilter: $1848795815c689d0$export$e5dbdcbe8d57d390,
    applyTimeFilter: $cf01f395c32ca758$export$d7af1f47ccac45e4,
    applyMetricFilter: $511d84a927ce9089$export$1968c4d10f8059c8,
    resetAttributesFilterDefaults: $d62010623c72786c$export$15a7855b158af2b2,
    resetTasksFilterDefaults: $4f02902e2d2ffb9e$export$434a715c23827d7e,
    resetTimeFilterDefaults: $9037dbbe8439ace5$export$a3af08e85d4cf2c6,
    setAttributeFilter: $f3c1958dd82bac5b$export$20d953f08d854d08,
    processAttributesTable: $3f12aed98de5edd6$export$bc98d6fbac005943,
    defaultMinMaxTime: $184ebea7606ad285$export$ac6d06e7706e3b10,
    updateVariantFilterCompliant: $bef5488ff778c2dd$export$cfe2815244b4d4f2,
    updateVariantFilterAutomate: $8978f8d8a60b537d$export$f7d76861870f698c,
    updateVariantFilterLoops: $4928230d762cb1dd$export$6fa4f4e2c46c44cc,
    taskAttributes: $59b2af3643fa7509$export$3f66ecfa32892985,
    taskEventAttributes: $4347e5672073f3b7$export$ecf224330435bd6e,
    eventAttributes: $c23064c90cb3b2ec$export$b05f54e556e2eadb,
    metrics: $042dc098ac08118e$export$b0c5c2fac8144e54,
    setFilterDeleteRow: $ad7307a6f914494b$export$b5db2815d25965f1,
    deleteFilter: $aefb66f51e577e5c$export$d80cc0328fcc6685,
    applyFilterEvents: $aecab291b608cebe$export$24e90a7f4e401128,
    saveTaskAttributeFilterGridState: $9cdb14f6b89d445e$export$f327bcbfdbb117dd,
    saveEventAttributeFilterGridState: $05be4558e0472b95$export$d843f33999dbf8ff,
    changeSlicedMetrics: $165bf53ca33e0035$export$e7f77cd8774d671d,
    getSlicedMetrics: $165bf53ca33e0035$export$4e0992c2b6acfdee
};



const $818df859e53658c0$export$1a41ed0800f87471 = ({ attribute: attribute  })=>(0, $57e66c5a34f265b4$export$2b9a1516268aa73c)({
        attribute: attribute
    });



const $db2d3845f0e48940$export$686416c8d612e32b = ({ metric: metric  })=>(0, $57e66c5a34f265b4$export$64c62229ad9721a1)({
        metric: metric
    });



const $ee6ff8fe5a9e36a5$export$82efe1ca702d828c = ({ metric: metric  })=>(0, $57e66c5a34f265b4$export$e4379db2f2834a75)({
        metric: metric
    });



const $05294a85d7397552$export$a5708f6316fda36b = ({ attribute: attribute  })=>(0, $57e66c5a34f265b4$export$767ef34006ed97d4)({
        attribute: attribute
    });



const $c634ff952b2c5fc7$export$a61946b7bc04cb6c = ()=>(0, $57e66c5a34f265b4$export$a61946b7bc04cb6c)();



const $0c9a204756fd07fe$export$d85a3e7a1562bc36 = ()=>(0, $57e66c5a34f265b4$export$d85a3e7a1562bc36)();



const $35d649ec068718da$export$b7aa2fef3714f316 = ()=>(0, $57e66c5a34f265b4$export$b7aa2fef3714f316)();





const $1ea707301ca659d4$export$147fb9713d1eb4f7 = ()=>(0, $57e66c5a34f265b4$export$147fb9713d1eb4f7)();



const $dbac6501432be546$export$792658a286bad179 = ()=>(0, $57e66c5a34f265b4$export$792658a286bad179)();



const $fc471d469e094666$export$351ee4d47c01e3a9 = ({ attribute: attribute  })=>(0, $57e66c5a34f265b4$export$d24f3fa9f662da0b)({
        attribute: attribute
    });



const $1d6a18d9fe771c0d$export$544fcebf2fe4d2f8 = ({ type: type  })=>(0, $57e66c5a34f265b4$export$544fcebf2fe4d2f8)({
        type: type
    });



const $351ed50a406542bf$export$ca4ff241d7524911 = ()=>(0, $57e66c5a34f265b4$export$ca4ff241d7524911)();



const $a8b5e47768854ade$export$97bdb1620f40b75f = ({ attribute: attribute  })=>(0, $57e66c5a34f265b4$export$311ade8512c0085d)({
        attribute: attribute
    });



const $2a84d52e238795b5$export$f5a3a372e085fbca = ({ type: type  })=>(0, $57e66c5a34f265b4$export$f5a3a372e085fbca)({
        type: type
    });



const $48c24d9d4df9d306$export$5ff20fde29755b6b = ({ metric: metric  })=>(0, $57e66c5a34f265b4$export$5ff20fde29755b6b)({
        metric: metric
    });



const $7978a93f19b8456e$export$5541061dade0f39a = ({ metric: metric  })=>(0, $57e66c5a34f265b4$export$5541061dade0f39a)({
        metric: metric
    });


const $9e8044757f30ab71$export$975888427d5f0833 = {
    getAnalyticsTaskAttributeMetric: $0c9a204756fd07fe$export$d85a3e7a1562bc36,
    getAnalyticsTaskHistoryMetric: $35d649ec068718da$export$b7aa2fef3714f316,
    changeAnalyticsTaskAttributeMetric: $db2d3845f0e48940$export$686416c8d612e32b,
    changeAnalyticsTaskAttribute: $818df859e53658c0$export$1a41ed0800f87471,
    changeAnalyticsEventAttribute: $05294a85d7397552$export$a5708f6316fda36b,
    getAnalyticsTaskAttribute: $c634ff952b2c5fc7$export$a61946b7bc04cb6c,
    updateTaskDetail: $b70023f2441d4f07$export$33d15ee0e1e0ff27,
    updateEventDetail: $8d0feb082b641fa1$export$7e15445a09500fa0,
    getTaskTable: $1ea707301ca659d4$export$147fb9713d1eb4f7,
    getDetailTaskSummaryAttribute: $dbac6501432be546$export$792658a286bad179,
    changeDetailTaskSummaryAttribute: $fc471d469e094666$export$351ee4d47c01e3a9,
    setTaskDetailExtract: $1d6a18d9fe771c0d$export$544fcebf2fe4d2f8,
    setEventDetailExtract: $2a84d52e238795b5$export$f5a3a372e085fbca,
    changeDetailEventSummaryAttribute: $a8b5e47768854ade$export$97bdb1620f40b75f,
    getDetailEventSummaryAttribute: $351ed50a406542bf$export$ca4ff241d7524911,
    analyticsEventHistory: $48c24d9d4df9d306$export$5ff20fde29755b6b,
    analyticsEventAttributes: $7978a93f19b8456e$export$5541061dade0f39a,
    changeAnalyticsTaskHistoryMetric: $ee6ff8fe5a9e36a5$export$82efe1ca702d828c
};





let $3ab8b408b87b781e$var$prevSlicerPane = (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab;
const $3ab8b408b87b781e$export$110f12dbda7147dc = ({ pane: pane , diagram: diagram , eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).changeActivePane, pane);
    (0, $57e66c5a34f265b4$export$110f12dbda7147dc)(pane);
    $3ab8b408b87b781e$var$prevSlicerPane = pane;
};



const $122b7eb3471d4ffd$export$57932fe53097eea7 = ({ sf: sf , eventEmitter: eventEmitter  })=>{
    if (sf === "slicer") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setSlicerExpanded);
    if (sf === "filter") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setFilterExpanded);
};



const $35aa3b860615ceea$export$e0693167a761cda6 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setVariantPane);
};





const $96b0a38eedc5b0ce$export$b0b99259121d228a = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openSettings);
};



const $4809f3683f0ca401$export$d40ac2fc3eb10133 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).openAnalytics);
};







const $3b1de5105fc64882$export$a19e774d56f6265e = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Detail);
};




const $79675d5519e40127$export$9ee1b70cbe451d08 = ({ eventEmitter: eventEmitter  })=>{
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActiveAction({
        action: "performance_analytics"
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_PerformanceAnalytics);
};




const $61388f1a201e5082$export$f624e4359503f764 = ({ eventEmitter: eventEmitter  })=>{
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActiveAction({
        action: "cost_rules"
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_CostRules);
};




const $e6d1e18b30ef9f98$export$6f9300bb47b0400c = ({ eventEmitter: eventEmitter  })=>{
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActiveAction({
        action: "process_rules"
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessRules);
};




const $3ebec2fcebaaf6f1$export$30e506e7a12b9b01 = ({ eventEmitter: eventEmitter  })=>{
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActiveAction({
        action: "variant_lifecycle"
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_VariantLifeCycle);
};




const $cfecea87791c8860$export$3dd5045cf4c73d70 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskLifeCycle);
};



const $a89dab6e3582a067$export$5349e0ec48dc75fd = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskHistogram);
};




const $74a19221fa2cf294$export$7758fa40e0a5d226 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCompliance);
};



const $4dd6896152cf08ec$export$f333c4daed2f2775 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeAutomation);
};



const $e05971d71ceba588$export$cd9e823c601e4c12 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCost);
};



const $85fc5d5a89116444$export$5eb427f1f115608c = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugePerformance);
};


const $e63024439717feee$export$80a4585e16d8b863 = {
    changeActivePane: $3ab8b408b87b781e$export$110f12dbda7147dc,
    setSlicerFilter: $122b7eb3471d4ffd$export$57932fe53097eea7,
    setVariantPane: $35aa3b860615ceea$export$e0693167a761cda6,
    setFilterIcon: $d2f53bbeaa179f7b$export$75243dbf83fd9c73,
    setSlicerIcon: $1b66a047d967ee84$export$8a2275d15ee60ada,
    openSettings: $96b0a38eedc5b0ce$export$b0b99259121d228a,
    openAnalytics: $4809f3683f0ca401$export$d40ac2fc3eb10133,
    setAction_ProcessVisualizer: $4418db1243d61fd1$export$17b3808e0ffc259c,
    setAction_PerformanceAnalytics: $79675d5519e40127$export$9ee1b70cbe451d08,
    setAction_CostRules: $61388f1a201e5082$export$f624e4359503f764,
    setAction_ProcessRules: $e6d1e18b30ef9f98$export$6f9300bb47b0400c,
    setAction_VariantLifeCycle: $3ebec2fcebaaf6f1$export$30e506e7a12b9b01,
    setAction_TaskLifeCycle: $7a9d81ef95270803$export$2c7243b488bf9a8f,
    setAction_Insights: $6618f47ab26c0e61$export$4410bdeeb8d80944,
    setAction_DecompositionTree: $2943124c9da1a68a$export$27ecb0c54ca94007,
    setAction_InfluenceAnalysis: $298c7561664e4490$export$ade6891da9d6ea5c,
    setAction_Detail: $3b1de5105fc64882$export$a19e774d56f6265e,
    updateTaskLifeCycle: $cfecea87791c8860$export$3dd5045cf4c73d70,
    updateTaskHistogram: $a89dab6e3582a067$export$5349e0ec48dc75fd,
    setAction_Histogram: $d3bbc7b58d319491$export$4be85c05a5dbddd8,
    updateGaugeAutomation: $4dd6896152cf08ec$export$f333c4daed2f2775,
    updateGaugeCompliance: $74a19221fa2cf294$export$7758fa40e0a5d226,
    updateGaugeCost: $e05971d71ceba588$export$cd9e823c601e4c12,
    updateGaugePerformance: $85fc5d5a89116444$export$5eb427f1f115608c
};



const $109fc86842b6ff7c$export$943be974f3083bda = ({ activityTextColor: activityTextColor , activityFillColor: activityFillColor , linkColor: linkColor , startNodeColor: startNodeColor , endNodeColor: endNodeColor , selectActivityColor: selectActivityColor , selectLinkColor: selectLinkColor , animateColor: animateColor , loopColor: loopColor , nonCompliantColor: nonCompliantColor , automationColor: automationColor , partialNonCompliantColor: partialNonCompliantColor , partialAutomationColor: partialAutomationColor , visualizerBackgroundColor: visualizerBackgroundColor  })=>(0, $57e66c5a34f265b4$export$fbbbb5ea899679e)({
        activityTextColor: activityTextColor,
        activityFillColor: activityFillColor,
        linkColor: linkColor,
        startNodeColor: startNodeColor,
        endNodeColor: endNodeColor,
        selectActivityColor: selectActivityColor,
        selectLinkColor: selectLinkColor,
        animateColor: animateColor,
        loopColor: loopColor,
        nonCompliantColor: nonCompliantColor,
        automationColor: automationColor,
        partialNonCompliantColor: partialNonCompliantColor,
        partialAutomationColor: partialAutomationColor,
        visualizerBackgroundColor: visualizerBackgroundColor
    });
const $109fc86842b6ff7c$export$6cee60e8aa85e528 = ()=>(0, $57e66c5a34f265b4$export$a4d0cd2e1e326d4a)();



const $123361d0c42edefb$export$5b3b16c1ca25f87e = ({ loopDashes: loopDashes  })=>(0, $57e66c5a34f265b4$export$c2681d0c0637e2a6)({
        loopDashes: loopDashes
    });
const $123361d0c42edefb$export$2375742403a80cc4 = ()=>(0, $57e66c5a34f265b4$export$db20b0d2e19d5655)();



const $ac4663c95fbb27b4$export$28036dc2a66b24e8 = ()=>(0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)();



const $a25ed4e202ae0a0a$export$bfe4fb3cd4f6f97f = ({ font_size: font_size  })=>{
    (0, $57e66c5a34f265b4$export$1eef6df022485250)({
        font_size: font_size
    });
};
const $a25ed4e202ae0a0a$export$c9d60308a4fdcf57 = ()=>(0, $57e66c5a34f265b4$export$3538b5b4f12d08d3)();



const $c1aae40041b5e619$export$ddeaf220ae824494 = ({ font_size: font_size  })=>{
    (0, $57e66c5a34f265b4$export$c88cdda728134614)({
        font_size: font_size
    });
};
const $c1aae40041b5e619$export$7e48a4b19d398af2 = ()=>(0, $57e66c5a34f265b4$export$4523324998d71e10)();



const $ee1bdd8a27f5e790$export$330e5c4f8f302efb = ({ start: start , end: end  })=>(0, $57e66c5a34f265b4$export$7f0f8748b5d9c08d)({
        start: start,
        end: end
    });
const $ee1bdd8a27f5e790$export$f1a3252f4cd0f1af = ()=>(0, $57e66c5a34f265b4$export$4392c525644d42a8)();



const $2c0406be1f364f2e$export$4d9a5ecb83767618 = ({})=>{
    (0, $57e66c5a34f265b4$export$4d9a5ecb83767618)();
};




const $77b1097340a8e0bd$export$a23812855239994f = ({ visualizerSettings: visualizerSettings , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$a23812855239994f)(visualizerSettings);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("importVisualizerSettings");
};



const $b0af32a9af286742$export$4972be645ca8b458 = ({ tasks: tasks , avg_duration: avg_duration , med_duration: med_duration , min_duration: min_duration , max_duration: max_duration , avg_cost: avg_cost , total: total , deviation: deviation , compliant: compliant , automated: automated  })=>(0, $57e66c5a34f265b4$export$4d02125160691cb6)({
        tasks: tasks,
        avg_duration: avg_duration,
        med_duration: med_duration,
        min_duration: min_duration,
        max_duration: max_duration,
        avg_cost: avg_cost,
        total: total,
        deviation: deviation,
        compliant: compliant,
        automated: automated
    });
const $b0af32a9af286742$export$5c6d202316fe2f0d = ()=>(0, $57e66c5a34f265b4$export$1bfd0b0186011b14)();




const $7eb82c1b454c538d$export$a534f34ab114e6c6 = ({ days: days , hours: hours , minutes: minutes , seconds: seconds , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$fe9b305965c7267e)({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    });
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDurationColumns);
};
const $7eb82c1b454c538d$export$82f5a452095c5d5 = ()=>(0, $57e66c5a34f265b4$export$5dda410f8d16b60)();



const $7bb7978131271a61$export$3c0d5aec4a9c3ac6 = ({ tasks: tasks , perc_total: perc_total  })=>(0, $57e66c5a34f265b4$export$4ead7e3c9375adc6)({
        tasks: tasks,
        perc_total: perc_total
    });
const $7bb7978131271a61$export$b7c95d2e2838d044 = ()=>(0, $57e66c5a34f265b4$export$456f29721d57a025)();




const $4c3a8c5f0fb724cf$export$343e016d816ec91c = ({ visible: visible  })=>(0, $57e66c5a34f265b4$export$bc1920fcc182c42a)({
        visible: visible
    });
const $4c3a8c5f0fb724cf$export$7cf087ca6aecb317 = ({ visible: visible  })=>(0, $57e66c5a34f265b4$export$d18aebd3caa51ec)({
        visible: visible
    });
const $4c3a8c5f0fb724cf$export$fc4371075acc52ef = ()=>(0, $57e66c5a34f265b4$export$5a006a3542673c67)();
const $4c3a8c5f0fb724cf$export$dbca535160352ac = ()=>(0, $57e66c5a34f265b4$export$2bd545cb1b8cf814)();




const $109111b610e384c5$export$ca466a8cd10aeba8 = ({ tasks: tasks , duration: duration , std_deviation: std_deviation  })=>(0, $57e66c5a34f265b4$export$41331b6fe80e0b4)({
        tasks: tasks,
        duration: duration,
        std_deviation: std_deviation
    });
const $109111b610e384c5$export$3b45c208608d598e = ()=>(0, $57e66c5a34f265b4$export$e556b7713d767210)();




const $3cee3682588e5c8f$export$62dae538e2c74504 = ({ filtered: filtered , sliced: sliced , selected: selected , eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).changeAnalyticsMode);
};
const $3cee3682588e5c8f$export$109e88eee8248bce = ()=>(0, $57e66c5a34f265b4$export$8a7cbcf486e12eab)();




const $2e661b5bbca497eb$export$e7448f1506c10f8f = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$4ebf054df69593a9)({
        gauge: gauge
    });
const $2e661b5bbca497eb$export$27ce3c0155c611aa = ()=>(0, $57e66c5a34f265b4$export$aed76e416d275a7b)();



const $e8f9bf2069157e7f$export$d6afff045efac7ba = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$c6e9fb4ee86660de)({
        gauge: gauge
    });
const $e8f9bf2069157e7f$export$ddf30c9e1c284ca8 = ()=>(0, $57e66c5a34f265b4$export$f3a08f846c274f14)();



const $2233ab92ef4e12ac$export$24c184ce48b31880 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$e3e3d4ca4e184ba4)({
        gauge: gauge
    });
const $2233ab92ef4e12ac$export$ee2d96ac5d059cce = ()=>(0, $57e66c5a34f265b4$export$785dab341e0b3b61)();



const $4af1da665c4e3e58$export$3d613aa79fecce30 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$5261a7bc1fb52020)({
        gauge: gauge
    });
const $4af1da665c4e3e58$export$627d025d414018a1 = ()=>(0, $57e66c5a34f265b4$export$d5525fb7331ba621)();



const $bfebcc30f93ce7b3$export$f7e2512e87271e2c = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$744d5287a7b86f4b)({
        gauge: gauge
    });
const $bfebcc30f93ce7b3$export$f9dac9883953a951 = ()=>(0, $57e66c5a34f265b4$export$aeb424a503795d7e)();



const $37731c843776e162$export$87396e9b524ffa = ({ direction: direction , diagram: diagram  })=>{
    diagram.layout.direction = direction;
    (0, $57e66c5a34f265b4$export$eced9bc8d6c4c244)({
        direction: direction
    });
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("updateDiagramProcessFlowDirection");
};
const $37731c843776e162$export$365b69259952d7b1 = ()=>(0, $57e66c5a34f265b4$export$3a2fa35f695d3a04)();



const $128a4f2d4eba36e3$export$808a30bcae9985c6 = ({ visible: visible  })=>(0, $57e66c5a34f265b4$export$bd90d4da7b5fc617)({
        visible: visible
    });
const $128a4f2d4eba36e3$export$eafb3861e0267d1c = ()=>(0, $57e66c5a34f265b4$export$7d3de2c8b90bf180)();



const $446fc8fa1b784c6c$export$1f26e71394ae913e = ({ diagram: diagram , column: column , layer: layer  })=>{
    diagram.layout.layerSpacing = layer;
    diagram.layout.columnSpacing = column;
    (0, $57e66c5a34f265b4$export$3725d6261377d1c2)({
        layer: layer,
        column: column
    });
};
const $446fc8fa1b784c6c$export$b202da40c04a47a5 = ()=>(0, $57e66c5a34f265b4$export$b2f4e09a8320117f)();




const $08a3e401edb8c549$export$8ec7581a9069f54c = ({ node_shape: node_shape  })=>{
    (0, $57e66c5a34f265b4$export$66c5add88d363b49)({
        node_shape: node_shape
    });
};
const $08a3e401edb8c549$export$a40f542e572050eb = ()=>(0, $57e66c5a34f265b4$export$a828337504705d1a)();



const $fa1482d22a41d3f7$export$9d9021aeae710bc1 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$df595889fe2175c3)({
        gauge: gauge
    });
const $fa1482d22a41d3f7$export$e8afe999345608da = ()=>(0, $57e66c5a34f265b4$export$2a6f911dd09fbd3e)();



const $bd3a7de3e2e6fab7$export$1601eb0a84c25d3b = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$70748fea90c726da)({
        gauge: gauge
    });
const $bd3a7de3e2e6fab7$export$36fad45e5acbe78f = ()=>(0, $57e66c5a34f265b4$export$ec06c676c7f3243a)();



const $6cbed0b0fbbfbd95$export$36a43ffd33b334b8 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$b9492d4a384d05f9)({
        gauge: gauge
    });
const $6cbed0b0fbbfbd95$export$8e026cddd239d1c9 = ()=>(0, $57e66c5a34f265b4$export$acff22db679860b1)();



const $fb58427741b524dd$export$5603d64e1ce8d469 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$f96f453b3f88a603)({
        gauge: gauge
    });
const $fb58427741b524dd$export$ba3d800dea4a792e = ()=>(0, $57e66c5a34f265b4$export$f7b852e8db4c293e)();



const $f1c16122cdcea15c$export$ce39717a18d2cc6a = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$7609d6994e133280)({
        gauge: gauge
    });
const $f1c16122cdcea15c$export$7ad4b00367c0542c = ()=>(0, $57e66c5a34f265b4$export$73e99b5ac58bcc1f)();



const $30b0d934b9cfa1fb$export$6f84f6a3434c70ed = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$f586fd861aa7782d)({
        gauge: gauge
    });
const $30b0d934b9cfa1fb$export$23780e36179db761 = ()=>(0, $57e66c5a34f265b4$export$86fb353a83664a15)();



const $1540854ae537cb3e$export$2bed3447e4f63e62 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$370b3580166d392)({
        gauge: gauge
    });
const $1540854ae537cb3e$export$55746074b107c1c1 = ()=>(0, $57e66c5a34f265b4$export$fc055efb78bb4cec)();



const $4c77affd98df67e0$export$f4d0340a5f645c32 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$f3d6e8f9a6d1c2b5)({
        gauge: gauge
    });
const $4c77affd98df67e0$export$68276225f213cf4b = ()=>(0, $57e66c5a34f265b4$export$f700bd9aba24c550)();



const $6a94f424e5e9d2f4$export$9fa38bd0539f018 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$3fe6d12fd3f1fb25)({
        gauge: gauge
    });
const $6a94f424e5e9d2f4$export$d43773aaf7902c8e = ()=>(0, $57e66c5a34f265b4$export$57c71e5bf336392c)();



const $eea9bafa11c3a7f8$export$be48123929bdad6e = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$f688feab8ae9a655)({
        gauge: gauge
    });
const $eea9bafa11c3a7f8$export$6ac3b0a2dcf0f2f0 = ()=>(0, $57e66c5a34f265b4$export$8a9bd9de3fed2c65)();



const $41dafc3d5a8a3ea5$export$b3ff436362bbb1c4 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$7f256c279294fab0)({
        gauge: gauge
    });
const $41dafc3d5a8a3ea5$export$200681ff0fcaf956 = ()=>(0, $57e66c5a34f265b4$export$db41e9afcc8a0036)();



const $8eba7faf7e5e6ce1$export$61f9cb315a9a3c20 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$b624022150958216)({
        gauge: gauge
    });
const $8eba7faf7e5e6ce1$export$4db5ec57fb59680b = ()=>(0, $57e66c5a34f265b4$export$d9b86491a57ac02)();



const $c1294d3d5ad7626d$export$dfca8fb915c3b075 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$16b8233068ca20dd)({
        gauge: gauge
    });
const $c1294d3d5ad7626d$export$c565c606e4794b9e = ()=>(0, $57e66c5a34f265b4$export$8860da07045d3683)();



const $c6f5c0cb6f08c5d0$export$2595227f97477377 = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$db714c7de7057486)({
        gauge: gauge
    });
const $c6f5c0cb6f08c5d0$export$667e2e96769026fc = ()=>(0, $57e66c5a34f265b4$export$5c241b790e8d035d)();



const $d01b61cdf92e6574$export$a9ae666a1a0b067a = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$9f76759309ebe595)({
        gauge: gauge
    });
const $d01b61cdf92e6574$export$4c2c45b75be2d052 = ()=>(0, $57e66c5a34f265b4$export$4b901973f3f68186)();



const $8dcf75bf5cec9e34$export$505e3a28a2c4e25e = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$ab6360033d00c31a)({
        gauge: gauge
    });
const $8dcf75bf5cec9e34$export$136e4adae11b3703 = ()=>(0, $57e66c5a34f265b4$export$f2ef5f0d17195c29)();



const $cdbc90664524fdb0$export$cd4e2ab32308cead = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$bdc1bf8100519c0a)({
        gauge: gauge
    });
const $cdbc90664524fdb0$export$35f47ccf9c614c38 = ()=>(0, $57e66c5a34f265b4$export$c97ae5ed47187ebb)();



const $1292c747cd134e8f$export$f77efab1baf3d11a = ({ gauge: gauge  })=>(0, $57e66c5a34f265b4$export$eb2e8b181070f7f8)({
        gauge: gauge
    });
const $1292c747cd134e8f$export$22770fea5b26583b = ()=>(0, $57e66c5a34f265b4$export$3afff736166cdd82)();




const $1470337cf2c5ad58$export$de1d5aedff00c394 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("importVisualizerSettings");
};


const $de1ed0fc3b8f9bd1$export$3a8174bb16d1f3c0 = {
    importVisualizerSettings: $77b1097340a8e0bd$export$a23812855239994f,
    saveVisualizerSettings: $2c0406be1f364f2e$export$4d9a5ecb83767618,
    changeNodeLabelFontSize: $c1aae40041b5e619$export$ddeaf220ae824494,
    getNodeLabelFontSize: $c1aae40041b5e619$export$7e48a4b19d398af2,
    getStepLabelFontSize: $a25ed4e202ae0a0a$export$c9d60308a4fdcf57,
    changeStepLabelFontSize: $a25ed4e202ae0a0a$export$bfe4fb3cd4f6f97f,
    changeStartLabel: $4c3a8c5f0fb724cf$export$343e016d816ec91c,
    getStartLabel: $4c3a8c5f0fb724cf$export$fc4371075acc52ef,
    changeEndLabel: $4c3a8c5f0fb724cf$export$7cf087ca6aecb317,
    getEndLabel: $4c3a8c5f0fb724cf$export$dbca535160352ac,
    changeDurationFormat: $7eb82c1b454c538d$export$a534f34ab114e6c6,
    getDurationFormat: $7eb82c1b454c538d$export$82f5a452095c5d5,
    changeColors: $109fc86842b6ff7c$export$943be974f3083bda,
    getColors: $109fc86842b6ff7c$export$6cee60e8aa85e528,
    changeLoopDashes: $123361d0c42edefb$export$5b3b16c1ca25f87e,
    getLoopDashes: $123361d0c42edefb$export$2375742403a80cc4,
    changeShowNodes: $ee1bdd8a27f5e790$export$330e5c4f8f302efb,
    getShowNodes: $ee1bdd8a27f5e790$export$f1a3252f4cd0f1af,
    changeStepLabels: $b0af32a9af286742$export$4972be645ca8b458,
    changeHighlight: $48e9aeeeef1ff0fd$export$4925121cdc737410,
    getStepLabels: $b0af32a9af286742$export$5c6d202316fe2f0d,
    setSpacings: $446fc8fa1b784c6c$export$1f26e71394ae913e,
    getSpacings: $446fc8fa1b784c6c$export$b202da40c04a47a5,
    setProcessFlowDirection: $37731c843776e162$export$87396e9b524ffa,
    getProcessFlowDirection: $37731c843776e162$export$365b69259952d7b1,
    getHighlight: $48e9aeeeef1ff0fd$export$fc8f758be6991169,
    changeStepWidth: $109111b610e384c5$export$ca466a8cd10aeba8,
    getStepWidth: $109111b610e384c5$export$3b45c208608d598e,
    changeAnalyticsMode: $3cee3682588e5c8f$export$62dae538e2c74504,
    getAnalyticsMode: $3cee3682588e5c8f$export$109e88eee8248bce,
    changeNodeLabels: $7bb7978131271a61$export$3c0d5aec4a9c3ac6,
    getNodeLabels: $7bb7978131271a61$export$b7c95d2e2838d044,
    changePercOfEvents: $2e661b5bbca497eb$export$e7448f1506c10f8f,
    changePercOfTasks: $bfebcc30f93ce7b3$export$f7e2512e87271e2c,
    getPercOfEvents: $2e661b5bbca497eb$export$27ce3c0155c611aa,
    getPercOfTasks: $bfebcc30f93ce7b3$export$f9dac9883953a951,
    changeXofYVariants: $e8f9bf2069157e7f$export$d6afff045efac7ba,
    getXofYVariants: $e8f9bf2069157e7f$export$ddf30c9e1c284ca8,
    changeXofYSteps: $2233ab92ef4e12ac$export$24c184ce48b31880,
    getXofYSteps: $2233ab92ef4e12ac$export$ee2d96ac5d059cce,
    changeXofYActivities: $4af1da665c4e3e58$export$3d613aa79fecce30,
    getXofYActivities: $4af1da665c4e3e58$export$627d025d414018a1,
    changePercVariantsCompliant: $fa1482d22a41d3f7$export$9d9021aeae710bc1,
    getPercVariantsCompliant: $fa1482d22a41d3f7$export$e8afe999345608da,
    changePercTasksCompliant: $bd3a7de3e2e6fab7$export$1601eb0a84c25d3b,
    getPercTasksCompliant: $bd3a7de3e2e6fab7$export$36fad45e5acbe78f,
    changePercEventsCompliant: $6cbed0b0fbbfbd95$export$36a43ffd33b334b8,
    getPercEventsCompliant: $6cbed0b0fbbfbd95$export$8e026cddd239d1c9,
    changePercVariantsAutomated: $fb58427741b524dd$export$5603d64e1ce8d469,
    getPercVariantsAutomated: $fb58427741b524dd$export$ba3d800dea4a792e,
    changePercTasksAutomated: $f1c16122cdcea15c$export$ce39717a18d2cc6a,
    getPercTasksAutomated: $f1c16122cdcea15c$export$7ad4b00367c0542c,
    changePercEventsAutomated: $30b0d934b9cfa1fb$export$6f84f6a3434c70ed,
    getPercEventsAutomated: $30b0d934b9cfa1fb$export$23780e36179db761,
    changeXofYVariantsCompliant: $1540854ae537cb3e$export$2bed3447e4f63e62,
    getXofYVariantsCompliant: $1540854ae537cb3e$export$55746074b107c1c1,
    changeXofYTasksCompliant: $4c77affd98df67e0$export$f4d0340a5f645c32,
    getXofYTasksCompliant: $4c77affd98df67e0$export$68276225f213cf4b,
    changeXofYEventsCompliant: $6a94f424e5e9d2f4$export$9fa38bd0539f018,
    getXofYEventsCompliant: $6a94f424e5e9d2f4$export$d43773aaf7902c8e,
    changeXofYVariantsAutomated: $eea9bafa11c3a7f8$export$be48123929bdad6e,
    getXofYVariantsAutomated: $eea9bafa11c3a7f8$export$6ac3b0a2dcf0f2f0,
    changeXofYTasksAutomated: $41dafc3d5a8a3ea5$export$b3ff436362bbb1c4,
    getXofYTasksAutomated: $41dafc3d5a8a3ea5$export$200681ff0fcaf956,
    changeXofYEventsAutomated: $8eba7faf7e5e6ce1$export$61f9cb315a9a3c20,
    getXofYEventsAutomated: $8eba7faf7e5e6ce1$export$4db5ec57fb59680b,
    changePercCostSaving: $c1294d3d5ad7626d$export$dfca8fb915c3b075,
    getPercCostSaving: $c1294d3d5ad7626d$export$c565c606e4794b9e,
    changeAvgCostSavingPerTask: $c6f5c0cb6f08c5d0$export$2595227f97477377,
    getAvgCostSavingPerTask: $c6f5c0cb6f08c5d0$export$667e2e96769026fc,
    changeAvgCostPerTask: $d01b61cdf92e6574$export$a9ae666a1a0b067a,
    getAvgCostPerTask: $d01b61cdf92e6574$export$4c2c45b75be2d052,
    changeCostSaving: $8dcf75bf5cec9e34$export$505e3a28a2c4e25e,
    getCostSaving: $8dcf75bf5cec9e34$export$136e4adae11b3703,
    changeActualCost: $cdbc90664524fdb0$export$cd4e2ab32308cead,
    getActualCost: $cdbc90664524fdb0$export$35f47ccf9c614c38,
    changeForecastCost: $1292c747cd134e8f$export$f77efab1baf3d11a,
    getForecastCost: $1292c747cd134e8f$export$22770fea5b26583b,
    getVisualizerBackgroundColor: $ac4663c95fbb27b4$export$28036dc2a66b24e8,
    changeZoomToFit: $128a4f2d4eba36e3$export$808a30bcae9985c6,
    getZoomToFit: $128a4f2d4eba36e3$export$eafb3861e0267d1c,
    loadVisualizerSettings: $1470337cf2c5ad58$export$de1d5aedff00c394,
    changeNodeShape: $08a3e401edb8c549$export$8ec7581a9069f54c,
    getNodeShape: $08a3e401edb8c549$export$a40f542e572050eb
};



const $405129fd008fe6ec$export$fc454795148b8b12 = ({ isolate: isolate , animate: animate , lifecycle: lifecycle  })=>{
    (0, $57e66c5a34f265b4$export$c81a9e74e00bb8e6)({
        isolate: isolate,
        animate: animate,
        lifecycle: lifecycle
    });
//    rebuildPVDiagram('updateDiagramHighlight');
};
const $405129fd008fe6ec$export$fe99af8a13e04665 = ()=>(0, $57e66c5a34f265b4$export$a4bbb6b3b39ca5bb)();






const $bc54b1c339c6ce8c$export$4ca2e78d5d0601b1 = ({ eventEmitter: eventEmitter  })=>{
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};


const $d542beec91f54818$export$aa650333665e2b55 = ({ eventEmitter: eventEmitter , pane: pane , variant: variant  })=>{
    if (pane === (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab) (0, $bc54b1c339c6ce8c$export$4ca2e78d5d0601b1)({
        eventEmitter: eventEmitter
    });
    (0, $57e66c5a34f265b4$export$ccb89cea349286f3)(variant);
};



const $1cb58efd6bde5dc1$export$26f7132da175ff2b = ({ selection: selection  })=>{
    (0, $57e66c5a34f265b4$export$abce13b877a5437d)(selection);
};



const $13378686aa488429$export$c969d3b710aac2fe = ({ selection: selection  })=>{
    (0, $57e66c5a34f265b4$export$a7535bd1ac565e5e)(selection);
};



const $f19637fa97741cb1$export$be44573a7a4faa78 = ({ selection: selection , type: type  })=>{
    (0, $57e66c5a34f265b4$export$506d0bd6276167fc)(selection, type);
};





const $5399a38080680536$export$57dfa740d03fd9ef = ({ eventEmitter: eventEmitter  })=>{
    const props = (0, $57e66c5a34f265b4$export$57dfa740d03fd9ef)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantSlicerVariantChart, props);
};





const $71252544191a89a1$export$3dafdce8ebb3f0f7 = ({ selection: selection , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$90ea4ab1b8b43ea5)(selection);
    (0, $5399a38080680536$export$57dfa740d03fd9ef)({
        eventEmitter: eventEmitter
    });
    if ((0, $57e66c5a34f265b4$export$bbe62bd73435d1b7)() === "process_visualizer") (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("selectVariantSlicerGridData");
    if ((0, $57e66c5a34f265b4$export$bbe62bd73435d1b7)() === "variant_lifecycle") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantLifecycle);
    if ((0, $57e66c5a34f265b4$export$bbe62bd73435d1b7)() === "task_lifecycle") eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskLifeCycle);
    if ((0, $57e66c5a34f265b4$export$bbe62bd73435d1b7)() === "histogram") {
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
            variantPaneVariants: false,
            type: "diagram-tasks",
            variant: 0,
            activity: 0,
            from: 0,
            to: 0
        });
        eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateHistogram);
    }
    (0, $bc54b1c339c6ce8c$export$4ca2e78d5d0601b1)({
        eventEmitter: eventEmitter
    });
};



const $474c3ba1a28c3ec8$export$1868dcfc770c57fe = ({ selection: selection  })=>{
    (0, $57e66c5a34f265b4$export$f1b23d69b077eb32)(selection);
};



const $232d64f3bc28b379$export$96c37a8461240523 = ({ selection: selection , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$96c37a8461240523)(selection);
};





const $0cd0fb7d5ebe5708$export$faf98b1a97cbdaf5 = ({ type: type , min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$1417083d8f7520f9)(type, min, max);
};



const $13d20b4ada0d1bca$export$173c36ecb0f12905 = ({ attribute: attribute , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$173c36ecb0f12905)(attribute);
};





const $0166d85fe4b54cf6$export$dd3986409eddbcdc = ({ pane: pane , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$eaaa0335bea12670)(pane); // updates the condition array used to display active slicers
    (0, $57e66c5a34f265b4$export$dd3986409eddbcdc)(pane); // updates gVariantArray, removing variants that do not meet slicer condition
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer) // updates variant grid
    ;
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).sliceIconActive);
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};



const $397c009108fae121$export$535c8022bada01af = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$535c8022bada01af)({
        mode: mode
    });
    (0, $57e66c5a34f265b4$export$abce13b877a5437d)("");
};



const $d248fb9bd73907dd$export$cdac68c0cdb4145c = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$cdac68c0cdb4145c)({
        mode: mode
    });
    (0, $57e66c5a34f265b4$export$abce13b877a5437d)("");
};



const $8ff311ca2bf8b77c$export$f3be45955df991b7 = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$f3be45955df991b7)({
        mode: mode
    });
    (0, $57e66c5a34f265b4$export$f1b23d69b077eb32)("");
};



const $b7a76e56f44c5dc0$export$69e6f0dddeefe4e9 = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$69e6f0dddeefe4e9)({
        mode: mode
    });
    (0, $57e66c5a34f265b4$export$f1b23d69b077eb32)("");
};



const $94d1233ac396b322$export$dfcd6d810b937c1b = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$dfcd6d810b937c1b)({
        mode: mode
    });
};



const $15e90a470c25e68d$export$609412ee29f27d56 = ({ mode: mode  })=>{
    (0, $57e66c5a34f265b4$export$609412ee29f27d56)({
        mode: mode
    });
};



const $e8f1abebca911017$export$acbc4025900e3670 = ({ includeStart: includeStart  })=>(0, $57e66c5a34f265b4$export$4c54b99a8d9b7d34)({
        includeStart: includeStart
    });



const $d37ec1d471e1a339$export$595363a85ad141f8 = ({ state: state  })=>{
    return (0, $57e66c5a34f265b4$export$6e4c85e15f853f95)();
};



const $80bc5cd88dcacb12$export$361dfb4e2f54323d = ({ type: type , variantPaneVariants: variantPaneVariants , activity: activity , variant: variant , from: from , to: to , ruleID: ruleID , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$361dfb4e2f54323d)(type, variantPaneVariants, variant, activity, from, to, ruleID);
};



const $400ffb66868920e5$export$b9c3f76fecc63a87 = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$b9c3f76fecc63a87)(columnState);
};



const $3ab666ff2957bcd0$export$e86a830c06565001 = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$e86a830c06565001)(columnState);
};



const $9d3ef302d5366d5d$export$d7e6a4b42b6c1682 = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$d7e6a4b42b6c1682)(columnState);
};



const $4d0bbdb972d32553$export$87ab4c26e4a61b0e = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$87ab4c26e4a61b0e)(columnState);
};





const $904cae76b1ea8521$export$d14cfd1ec8d005d3 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$a5d14cad26556b17)();
    (0, $5399a38080680536$export$57dfa740d03fd9ef)({
        eventEmitter: eventEmitter
    });
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("selectVariantSlicerGridData");
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
};



const $4ad0ce8d09347e69$export$5c565cad4215a4e4 = ({ from: from , to: to  })=>(0, $57e66c5a34f265b4$export$5c565cad4215a4e4)({
        from: from,
        to: to
    });



const $3c7e5583e7e9fbe2$export$15f660b5dd618e63 = ({ activity: activity  })=>(0, $57e66c5a34f265b4$export$15f660b5dd618e63)({
        activity: activity
    });



const $411b82ecfd9c48aa$export$ddb305b908ec73e7 = ({ variant: variant  })=>(0, $57e66c5a34f265b4$export$ddb305b908ec73e7)({
        variant: variant
    });



const $54c1a1a478c0d204$export$bd6a338554715444 = ({ taskID: taskID  })=>(0, $57e66c5a34f265b4$export$bd6a338554715444)({
        taskID: taskID
    });


const $2665a647d0606861$export$eb34776e9fed881c = {
    changeSelectAction: $405129fd008fe6ec$export$fc454795148b8b12,
    getSelectAction: $405129fd008fe6ec$export$fe99af8a13e04665,
    selectVariant: $d542beec91f54818$export$aa650333665e2b55,
    setStepSlicerSelectedData: $1cb58efd6bde5dc1$export$26f7132da175ff2b,
    setTaskSlicerSelectedData: $13378686aa488429$export$c969d3b710aac2fe,
    setPathSlicerSelectedData: $f19637fa97741cb1$export$be44573a7a4faa78,
    setVariantSlicerSelectedData: $71252544191a89a1$export$3dafdce8ebb3f0f7,
    setActivitySlicerSelectedData: $474c3ba1a28c3ec8$export$1868dcfc770c57fe,
    updateVariantSlicerVariantChart: $5399a38080680536$export$57dfa740d03fd9ef,
    updateGauges: $bc54b1c339c6ce8c$export$4ca2e78d5d0601b1,
    applyPathSlicer: $13d20b4ada0d1bca$export$173c36ecb0f12905,
    applySlicer: $0166d85fe4b54cf6$export$dd3986409eddbcdc,
    updateTasksSlicerVariables: $0cd0fb7d5ebe5708$export$faf98b1a97cbdaf5,
    changeStepSelectRetention: $397c009108fae121$export$535c8022bada01af,
    changeActivitySelectRetention: $8ff311ca2bf8b77c$export$f3be45955df991b7,
    changeStepSelectOperator: $d248fb9bd73907dd$export$cdac68c0cdb4145c,
    changeActivitySelectOperator: $b7a76e56f44c5dc0$export$69e6f0dddeefe4e9,
    changePathSelectRetention: $94d1233ac396b322$export$dfcd6d810b937c1b,
    changePathSelectOperator: $15e90a470c25e68d$export$609412ee29f27d56,
    changeIncludeStart: $e8f1abebca911017$export$acbc4025900e3670,
    variantsTable: $d37ec1d471e1a339$export$595363a85ad141f8,
    generateSlicedTaskArray: $80bc5cd88dcacb12$export$361dfb4e2f54323d,
    saveVariantSlicerGridState: $400ffb66868920e5$export$b9c3f76fecc63a87,
    saveStepSlicerGridState: $3ab666ff2957bcd0$export$e86a830c06565001,
    saveActivitySlicerGridState: $9d3ef302d5366d5d$export$d7e6a4b42b6c1682,
    saveTaskSlicerGridState: $4d0bbdb972d32553$export$87ab4c26e4a61b0e,
    setTaskDetailSelectedData: $232d64f3bc28b379$export$96c37a8461240523,
    showDetailVariants: $904cae76b1ea8521$export$d14cfd1ec8d005d3,
    setStepDetailProps: $4ad0ce8d09347e69$export$5c565cad4215a4e4,
    setActivityDetailProps: $3c7e5583e7e9fbe2$export$15f660b5dd618e63,
    setVariantDetailProps: $411b82ecfd9c48aa$export$ddb305b908ec73e7,
    setTaskID: $54c1a1a478c0d204$export$bd6a338554715444
};



const $2efb7663b44ca34e$export$bc733b0c5cbb3e8a = ({ seconds: seconds  })=>(0, $57e66c5a34f265b4$export$bc733b0c5cbb3e8a)(seconds);



const $e131ff346d6c1cc0$export$3e1eee59f5dc52be = ({ perc: perc , decimals: decimals  })=>(0, $57e66c5a34f265b4$export$3e1eee59f5dc52be)(perc, decimals);



const $41b2f2afec0c6d11$export$ba3cd16e91ec14da = ({ minutes: minutes  })=>(0, $57e66c5a34f265b4$export$ba3cd16e91ec14da)(minutes);



const $9e13cadadd498d60$export$f5dd818bff069720 = ({ count: count  })=>(0, $57e66c5a34f265b4$export$a2db1876938cd11d)(count);



const $efc85dc3fdd58dba$export$e370a7ddaa2f579a = ({ cost: cost  })=>(0, $57e66c5a34f265b4$export$e370a7ddaa2f579a)(cost);



const $e643437eef13ade6$export$bdd804b47f20d359 = ({ cost: cost  })=>(0, $57e66c5a34f265b4$export$bdd804b47f20d359)(cost);




const $5a70b5d74db73981$export$d39e8e215d987785 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$75fdae28716ade6d)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer);
};




const $d2b81a7c4c08f834$export$8da0d8f55c4b51d0 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$8da0d8f55c4b51d0)("resetFilters API - reset Filters"); // resets the filter active variables
    const values = (0, $57e66c5a34f265b4$export$a3af08e85d4cf2c6)();
    const resetValues = (0, $57e66c5a34f265b4$export$8b362cc2cfd64eb3)();
    (0, $57e66c5a34f265b4$export$c7e705c07d100697)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, values);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, resetValues);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
};




const $e05d3159772b656f$export$77c5dcb67398492b = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$77c5dcb67398492b)();
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("resetEventLog");
    const values = (0, $57e66c5a34f265b4$export$a3af08e85d4cf2c6)();
    const resetValues = (0, $57e66c5a34f265b4$export$8b362cc2cfd64eb3)();
    //reGenerateArrays();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, values);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, resetValues);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetEventLog); // updates sidebar
// how to update diagram and metrics ?
};





const $c342df0a4932aaef$export$daa57dff65460f7c = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$daa57dff65460f7c)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance);
};



const $ac67a94b2e61a5f7$export$6ceaafaaa031ea4f = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).saveCompliance);
};



const $f673d6d2c33ccadb$export$2ff5de46d769d306 = ({})=>{
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("rebuildPVDiagramShared");
};



const $0ae83b3e77346455$export$5aafeb6db603ac7a = ({ action: action , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5aafeb6db603ac7a)(action);
//    eventEmitter.emit(Event.applyInsightsMetricFilter);
};



const $2656939e53f3cffc$export$cee0859ea5446349 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings);
};






const $51086f0ef40342d3$export$50ac3e8044276aa7 = ({ message: message , showAlert: showAlert , eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).complianceDialogAlert, message, showAlert);
};





const $2cf9ed2a0df3c235$export$968755832058d426 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).displayProcessVisualizer);
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({
        eventEmitter: eventEmitter
    });
    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    const props = (0, $57e66c5a34f265b4$export$aa53ae1ab6407f1e)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, props);
};



const $ec9dd232e25a1e0e$export$7aacd66c827edfc2 = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskAttributes);
};



const $707b348106a1d502$export$70bb6a904ba4a0b3 = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$70bb6a904ba4a0b3)(columnState);
};



const $c8e71be61172691f$export$bd54d9375752e708 = ({ columnState: columnState  })=>{
    (0, $57e66c5a34f265b4$export$bd54d9375752e708)(columnState);
};


const $c0bf3d0ebd6822e3$export$196e99c03c1a2430 = {
    formatNumber: $9e13cadadd498d60$export$f5dd818bff069720,
    formatCost: $efc85dc3fdd58dba$export$e370a7ddaa2f579a,
    formatCostDecimal: $e643437eef13ade6$export$bdd804b47f20d359,
    formatDuration: $2efb7663b44ca34e$export$bc733b0c5cbb3e8a,
    rebuildPVDiagram: $f673d6d2c33ccadb$export$2ff5de46d769d306,
    resetSlicers: $5a70b5d74db73981$export$d39e8e215d987785,
    resetFilters: $d2b81a7c4c08f834$export$8da0d8f55c4b51d0,
    formatDurationMinutes: $41b2f2afec0c6d11$export$ba3cd16e91ec14da,
    formatPercentage: $e131ff346d6c1cc0$export$3e1eee59f5dc52be,
    resetCompliance: $c342df0a4932aaef$export$daa57dff65460f7c,
    saveCompliance: $ac67a94b2e61a5f7$export$6ceaafaaa031ea4f,
    showContextMenu: $a88d26ee1331adae$export$565dd6bf3240914a,
    hideContextMenu: $a88d26ee1331adae$export$a70b79ee19e88cfe,
    updateGauges: $25932cd9e0940c69$export$4ca2e78d5d0601b1,
    alertMessage: $73069f16c491914f$export$88a8e14f5b48311,
    alertDialog: $51086f0ef40342d3$export$50ac3e8044276aa7,
    dataImportComplete: $73396f25d03f3d4e$export$68b36b6fd6d0f5b2,
    resetEventLog: $e05d3159772b656f$export$77c5dcb67398492b,
    displayProcessVisualizer: $2cf9ed2a0df3c235$export$968755832058d426,
    updateTaskAttributes: $ec9dd232e25a1e0e$export$7aacd66c827edfc2,
    setActiveAction: $0ae83b3e77346455$export$5aafeb6db603ac7a,
    updateMetricSettings: $2656939e53f3cffc$export$cee0859ea5446349,
    saveProcessRulesGridState: $707b348106a1d502$export$70bb6a904ba4a0b3,
    saveCostRulesGridState: $c8e71be61172691f$export$bd54d9375752e708
};



const $4a444a93570efd66$export$cd46715b94531cfc = {
    getVariantArray: $57e66c5a34f265b4$export$4ad6a18860f0a250,
    processEventLogUpload: $57e66c5a34f265b4$export$15d7fa8f2890fc1a,
    processEventLogHeaderUpload: $57e66c5a34f265b4$export$e31d351d197e2f2b,
    processStepsTable: $57e66c5a34f265b4$export$480663dacd820796,
    processStepsTableTemp: $57e66c5a34f265b4$export$c6150266ad4a5635,
    processVariantsTable: $57e66c5a34f265b4$export$6e4c85e15f853f95,
    processActivitiesTable: $57e66c5a34f265b4$export$2399ecb8bbf4c658,
    processTasksTable: $57e66c5a34f265b4$export$6fc0a7275b17948c,
    processDetailVariants: $57e66c5a34f265b4$export$bb8cd829555465cc,
    processDetailEventSummary: $57e66c5a34f265b4$export$7558155638e6d8a1,
    processDetailTaskSummary: $57e66c5a34f265b4$export$a26c3f1d60196b1a,
    analyticsTaskHistory: $57e66c5a34f265b4$export$b12f53a00119e86,
    analyticsEventHistory: $57e66c5a34f265b4$export$5ff20fde29755b6b,
    analyticsTaskAttributes: $57e66c5a34f265b4$export$e6b539ad095b1347,
    modelInfo: $57e66c5a34f265b4$export$3e8f7c388b06760b,
    comments: $57e66c5a34f265b4$export$616f2a8c4250fea0,
    filterConditionsExport: $57e66c5a34f265b4$export$70a78b5e857e75e5,
    slicerConditionsExport: $57e66c5a34f265b4$export$13e559b3ccbff946,
    validateDataTransformation: $57e66c5a34f265b4$export$da5d76e3c34141f6,
    retrieveDataTransformation: $57e66c5a34f265b4$export$305acd9e21770406,
    retrievePlanTier: $57e66c5a34f265b4$export$347ff2119a6127ca,
    retrieveEventLogCSV: $57e66c5a34f265b4$export$1270cc982a054587,
    taskCount: $57e66c5a34f265b4$export$cb61761473b99c0a,
    eventCount: $57e66c5a34f265b4$export$47e13dd22d8af58c,
    retrieveFilters: $57e66c5a34f265b4$export$ebbcf3fd1cb264f9,
    retrieveSlicers: $57e66c5a34f265b4$export$4d431da9ce735d8f,
    retrieveVisualizerSettings: $57e66c5a34f265b4$export$c3fea13d5dadbaba,
    retrieveComplianceRules: $57e66c5a34f265b4$export$116a37ce50dea616,
    retrieveAutomationRules: $57e66c5a34f265b4$export$fe6d9574d7d9d606,
    retrievePerformanceRules: $57e66c5a34f265b4$export$5dcc6304899afccc,
    retrieveCostRules: $57e66c5a34f265b4$export$1f61ebc34c954fce,
    retrieveEventLogID: $57e66c5a34f265b4$export$9de5e87c9735228e,
    retrieveComments: $57e66c5a34f265b4$export$884992b7524a64b2,
    filteredTasksCount: $57e66c5a34f265b4$export$767281e50fd1e8cc,
    filteredEventsCount: $57e66c5a34f265b4$export$1f65e40c175c5f8c,
    slicedTasksCount: $57e66c5a34f265b4$export$bfbb553888b70478,
    slicedEventsCount: $57e66c5a34f265b4$export$36ba1d746e48434f,
    resetEventLog: $57e66c5a34f265b4$export$77c5dcb67398492b,
    gaugesDisplayed: $57e66c5a34f265b4$export$8eb7811c9b2b6f81,
    getInitialLoad: $57e66c5a34f265b4$export$a9290b2001080ed9,
    metricsExist: $57e66c5a34f265b4$export$172fd1b17aba58d3,
    resetGauges: $57e66c5a34f265b4$export$a9dc28b9b3f2f426,
    resetModel: $57e66c5a34f265b4$export$8834b66a455822a0,
    eventLogName: $57e66c5a34f265b4$export$29ff4b1920b337e7,
    updateEventLogFlag: $57e66c5a34f265b4$export$f666a8ccd1a91163,
    resetVisualizerSettings: $57e66c5a34f265b4$export$71a5e433e89cee55,
    setDiagramProcessVisualizer: $57e66c5a34f265b4$export$eaf358d737cb394b,
    getCurrentDiagram: $57e66c5a34f265b4$export$876783770c364846,
    getEventEmitter: $57e66c5a34f265b4$export$42e0d87b3bb491d0,
    getDetailSource: $57e66c5a34f265b4$export$179cb5aa0c08ab1b,
    getDecompositionTreeValueFilter: $57e66c5a34f265b4$export$ec00a85a719b1d0c,
    getInsightsValueFilter: $57e66c5a34f265b4$export$3ee3329ee09145f9,
    getInfluenceAnalysisValueFilter: $57e66c5a34f265b4$export$99bc2dbdccda51fe,
    getDecompositionTreeMetricFilter: $57e66c5a34f265b4$export$1f7203123d16eeea,
    getInsightsMetricFilter: $57e66c5a34f265b4$export$193059be6213590c,
    getInfluenceAnalysisMetricFilter: $57e66c5a34f265b4$export$446e61525b7f9551,
    getMinDiagramWidth: $57e66c5a34f265b4$export$16704ae9db23c1bc,
    getVariantSlicerGridState: $57e66c5a34f265b4$export$22a2ae93901e0fa2,
    getStepSlicerGridState: $57e66c5a34f265b4$export$20d2d8a98c167857,
    getActivitySlicerGridState: $57e66c5a34f265b4$export$d8e7fd3126fc941,
    getTaskSlicerGridState: $57e66c5a34f265b4$export$3e10a0e23c835e88,
    getTaskAttributeFilterGridState: $57e66c5a34f265b4$export$59374f58d7451f33,
    getEventAttributeFilterGridState: $57e66c5a34f265b4$export$9e893cbd5c8fd175,
    getRCDescription: $57e66c5a34f265b4$export$a13dbf3c34277ef8,
    getHistogramDescription: $57e66c5a34f265b4$export$eca9b2c455d0fce3,
    rebuildASA: $57e66c5a34f265b4$export$3d216efdc8774939,
    getEntityUpper: $57e66c5a34f265b4$export$7bca99abddcf9a72,
    getEntityLower: $57e66c5a34f265b4$export$a166054545426636,
    processEventLog_File: $57e66c5a34f265b4$export$f178bc9f64f29a9b,
    costRulesSummary: $57e66c5a34f265b4$export$6d5ef0b15f2841ab,
    processRulesSummary: $57e66c5a34f265b4$export$6d6957ed193f48f9,
    getActiveAction: $57e66c5a34f265b4$export$bbe62bd73435d1b7,
    variantsVisualization: $57e66c5a34f265b4$export$3a67d80d8f3ff092,
    tasksVisualization: $57e66c5a34f265b4$export$63db7e18015c9f49,
    getHistogramArray: $57e66c5a34f265b4$export$6cca92ac29f346ec,
    getActivePane: $57e66c5a34f265b4$export$99a20415dbcb29df,
    getDetailDescription: $57e66c5a34f265b4$export$1c350cff0d97be6,
    getHistogramTotal: $57e66c5a34f265b4$export$1315927c299f8faf,
    getHistogramType: $57e66c5a34f265b4$export$1a79e676222326af,
    getEnvironment: $57e66c5a34f265b4$export$57570b1603cf6adb,
    getDev: $57e66c5a34f265b4$export$ca432a243c6c77f7,
    getURLHost: $57e66c5a34f265b4$export$1d2f0dc727063c01,
    getUserSessionToken: $57e66c5a34f265b4$export$f8bda234a8554be,
    getModelID: $57e66c5a34f265b4$export$d9e6ddf3245c7faa,
    getHistogramSeries: $57e66c5a34f265b4$export$66e96b3bda7387a1,
    getHistogramCategory: $57e66c5a34f265b4$export$d059fbf4ed140fc2,
    getProcessRulesGridState: $57e66c5a34f265b4$export$7e127858a7c44ce7,
    getCostRulesGridState: $57e66c5a34f265b4$export$e2c23903a127ac2a
};







const $99aca3cabb044c59$export$49e15f373ab56525 = ({ rule: rule , ruleID: ruleID , costType: costType , variantType: variantType , taskType: taskType , fromNode: fromNode , toNode: toNode , mode: mode , type: type , actualCost: actualCost , attribute: attribute  })=>(0, $57e66c5a34f265b4$export$49e15f373ab56525)({
        rule: rule,
        ruleID: ruleID,
        costType: costType,
        variantType: variantType,
        taskType: taskType,
        fromNode: fromNode,
        toNode: toNode,
        mode: mode,
        type: type,
        actualCost: actualCost,
        attribute: attribute
    });



const $84d63c1eac2080a1$export$451049238f8e339c = ({ rule: rule , ruleID: ruleID , fromNode: fromNode , toNode: toNode , calculateCostImpact: calculateCostImpact , variantType: variantType , taskType: taskType , mode: mode , type: type , durationOperator: durationOperator , durationActualFrom: durationActualFrom , durationActualTo: durationActualTo , durationValue: durationValue  })=>(0, $57e66c5a34f265b4$export$451049238f8e339c)({
        rule: rule,
        ruleID: ruleID,
        fromNode: fromNode,
        toNode: toNode,
        calculateCostImpact: calculateCostImpact,
        variantType: variantType,
        taskType: taskType,
        mode: mode,
        type: type,
        durationOperator: durationOperator,
        durationActualFrom: durationActualFrom,
        durationActualTo: durationActualTo,
        durationValue: durationValue
    });



const $7e75df08173a2728$export$46a207868612a8fe = ({ rule: rule , ruleID: ruleID , fromNode: fromNode , toNode: toNode , variantType: variantType , taskType: taskType , mode: mode , type: type , filterLoops: filterLoops , calculateCostImpact: calculateCostImpact , durationOperator: durationOperator , durationActualFrom: durationActualFrom , durationActualTo: durationActualTo , durationValue: durationValue  })=>(0, $57e66c5a34f265b4$export$46a207868612a8fe)({
        rule: rule,
        ruleID: ruleID,
        fromNode: fromNode,
        toNode: toNode,
        variantType: variantType,
        taskType: taskType,
        mode: mode,
        type: type,
        filterLoops: filterLoops,
        calculateCostImpact: calculateCostImpact,
        durationOperator: durationOperator,
        durationActualFrom: durationActualFrom,
        durationActualTo: durationActualTo,
        durationValue: durationValue
    });



const $eff75a7a41a1f4d4$export$435ccb6e63ccfec4 = ({ rule: rule , ruleID: ruleID , fromNode: fromNode , toNode: toNode , variantType: variantType , taskType: taskType , mode: mode , type: type , filterLoops: filterLoops , calculateCostImpact: calculateCostImpact , durationOperator: durationOperator , durationActualFrom: durationActualFrom , durationActualTo: durationActualTo , durationValue: durationValue , durationReductionType: durationReductionType , durationReductionPercentage: durationReductionPercentage , durationReductionActual: durationReductionActual , durationReductionValue: durationReductionValue  })=>(0, $57e66c5a34f265b4$export$435ccb6e63ccfec4)({
        rule: rule,
        ruleID: ruleID,
        fromNode: fromNode,
        toNode: toNode,
        variantType: variantType,
        taskType: taskType,
        mode: mode,
        type: type,
        filterLoops: filterLoops,
        calculateCostImpact: calculateCostImpact,
        durationOperator: durationOperator,
        durationActualFrom: durationActualFrom,
        durationActualTo: durationActualTo,
        durationValue: durationValue,
        durationReductionType: durationReductionType,
        durationReductionPercentage: durationReductionPercentage,
        durationReductionActual: durationReductionActual,
        durationReductionValue: durationReductionValue
    });



const $18171b78ef68452d$export$e21818526febe06d = ({ comments: comments , activity: activity , action: action , type: type  })=>(0, $57e66c5a34f265b4$export$2f7e4fbf4e0dafbf)({
        comments: comments,
        activity: activity,
        action: action,
        type: type
    });



const $85c617c3292d97a6$export$630405654607937f = ({ comments: comments , fromNode: fromNode , toNode: toNode , action: action , type: type  })=>(0, $57e66c5a34f265b4$export$2f7e4fbf4e0dafbf)({
        comments: comments,
        fromNode: fromNode,
        toNode: toNode,
        action: action,
        type: type
    });



const $cde7abf2a4a379b9$export$6fe6cb07c1abafe8 = ({ min: min  })=>{
    (0, $57e66c5a34f265b4$export$6fe6cb07c1abafe8)({
        min: min
    });
    (0, $57e66c5a34f265b4$export$5f738a2c36cfbd91)();
};


const $34b93ca27d027206$export$bfe913bc3fd3bbb = {
    openStepComplianceModal: $2e988fe81abc0213$export$26b82a75aae6bfed,
    openStepPerformanceModal: $1200978695fc35a8$export$9c10e13e2df2501e,
    openStepAutomationModal: $d2cffb3e3e561271$export$b8eacc044a97fdf9,
    openStepCostModal: $b66f0c13307de446$export$5d3a507e32e0a59b,
    updateStepCost: $99aca3cabb044c59$export$49e15f373ab56525,
    updateActivityComments: $18171b78ef68452d$export$e21818526febe06d,
    updateStepComments: $85c617c3292d97a6$export$630405654607937f,
    updateStepAutomation: $84d63c1eac2080a1$export$451049238f8e339c,
    updateStepCompliance: $7e75df08173a2728$export$46a207868612a8fe,
    setMinPercTasks: $cde7abf2a4a379b9$export$6fe6cb07c1abafe8,
    updateStepPerformance: $eff75a7a41a1f4d4$export$435ccb6e63ccfec4
};



const $c93d9f7d5c5cb27c$export$4e7e6a46e1c0c8ad = ({ entity: entity , initial: initial  })=>(0, $57e66c5a34f265b4$export$4e7e6a46e1c0c8ad)({
        entity: entity,
        initial: initial
    });


const $68a6c5dfbe9314b7$export$447e5625df442cb2 = {
    setEntity: $c93d9f7d5c5cb27c$export$4e7e6a46e1c0c8ad
};



const $756493d0780c5414$export$e6c64bce9238e979 = ({ type: type , row: row , id: id  })=>{
    (0, $57e66c5a34f265b4$export$5474922de5077d2d)(type, row, id);
};



const $6659681b617b532a$export$6a7ec9ee0d0ba1df = ({ row: row  })=>{
    (0, $57e66c5a34f265b4$export$6a7ec9ee0d0ba1df)(row);
};




const $6f50dfdfd0ece6ea$export$988cba38e738f27d = ({ type: type , ruleID: ruleID , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$988cba38e738f27d)(type, ruleID);
    (0, $57e66c5a34f265b4$export$2ff5de46d769d306)("deleteRule");
    (0, $bc54b1c339c6ce8c$export$4ca2e78d5d0601b1)({
        eventEmitter: eventEmitter
    });
};



const $50ce412b4ed27707$export$41f8c4ddfb0d5041 = ({ type: type , ruleID: ruleID  })=>{
    (0, $57e66c5a34f265b4$export$41f8c4ddfb0d5041)(type, ruleID);
};



const $00f41b5cbf7a4159$export$56e87122f905fac0 = ({ type: type , fromActivity: fromActivity , toActivity: toActivity , fromActivityStr: fromActivityStr , toActivityStr: toActivityStr  })=>{
    (0, $57e66c5a34f265b4$export$56e87122f905fac0)(type, fromActivity, toActivity, fromActivityStr, toActivityStr);
};



const $34d3258af9c31895$export$2e6e3ad634e3776 = ({})=>{
    (0, $57e66c5a34f265b4$export$2e6e3ad634e3776)();
};




const $1d94f4b2492021d0$export$bef586f3e3b697c5 = ({ importedTransformation: importedTransformation , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$bef586f3e3b697c5)(importedTransformation);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};



const $bd7daeaf9a1711f3$export$9197a2d66aec3dd2 = ({ importedComments: importedComments  })=>{
    (0, $57e66c5a34f265b4$export$9197a2d66aec3dd2)(importedComments);
};



const $8b7dfb681077cb79$export$5dbad88f90a47691 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$5dbad88f90a47691)();
};




const $0236e3f22c6c01ca$export$2eb7d5ee9a22cf67 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$2eb7d5ee9a22cf67)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetComments);
};




const $5905078c0bf64e6a$export$a9937c3598565281 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$a9937c3598565281)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};




const $cfedea3e550c0413$export$b93c2a0b2c5b5c71 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$b93c2a0b2c5b5c71)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};



const $e739a7a33ca534bf$export$223f94993e9d0274 = ({ mapping: mapping  })=>{
    (0, $57e66c5a34f265b4$export$223f94993e9d0274)(mapping);
};



const $849fc58aa3b7ddbc$export$57519af9bc3c1880 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$57519af9bc3c1880)();
};



const $7bff2a0c1f47ae5f$export$3a8d4ca9f8e52c91 = ({ eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$3a8d4ca9f8e52c91)();
};




const $837cfe3ed1ce7dd8$export$4283b00eae4a6956 = ({ importedFilters: importedFilters , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$4283b00eae4a6956)(importedFilters);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
};




const $6a5eb00ee499048d$export$318ec447bc49311f = ({ importedSlicers: importedSlicers , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$318ec447bc49311f)(importedSlicers);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer);
};



const $5c9b92070ad688b4$export$8bff22599dab80fc = ({ eventEmitter: eventEmitter  })=>{
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer);
};


const $77ab2efd0eca57e0$export$a4c0c8140f746e12 = {
    setRuleDeleteRow: $756493d0780c5414$export$e6c64bce9238e979,
    deleteRule: $6f50dfdfd0ece6ea$export$988cba38e738f27d,
    editRule: $50ce412b4ed27707$export$41f8c4ddfb0d5041,
    createRule: $00f41b5cbf7a4159$export$56e87122f905fac0,
    importTransformation: $1d94f4b2492021d0$export$bef586f3e3b697c5,
    importComments: $bd7daeaf9a1711f3$export$9197a2d66aec3dd2,
    saveComments: $8b7dfb681077cb79$export$5dbad88f90a47691,
    resetComments: $0236e3f22c6c01ca$export$2eb7d5ee9a22cf67,
    deleteComment: $34d3258af9c31895$export$2e6e3ad634e3776,
    setCommentDeleteRow: $6659681b617b532a$export$6a7ec9ee0d0ba1df,
    deleteTransformationRow: $5905078c0bf64e6a$export$a9937c3598565281,
    setDeleteTransformationRow: $e739a7a33ca534bf$export$223f94993e9d0274,
    resetTransformation: $cfedea3e550c0413$export$b93c2a0b2c5b5c71,
    saveSlicerSettings: $849fc58aa3b7ddbc$export$57519af9bc3c1880,
    saveFilterSettings: $7bff2a0c1f47ae5f$export$3a8d4ca9f8e52c91,
    importFilters: $837cfe3ed1ce7dd8$export$4283b00eae4a6956,
    importSlicers: $6a5eb00ee499048d$export$318ec447bc49311f,
    resetIcons: $5c9b92070ad688b4$export$8bff22599dab80fc
};



const $e9ddf5ef3c8c08b1$export$2ae80658c4c02420 = ({})=>(0, $57e66c5a34f265b4$export$2ae80658c4c02420)();



const $859ebbe57ee4d089$export$d2e5d507adb5caad = ({ csv: csv , filename: filename  })=>{
    (0, $57e66c5a34f265b4$export$84b3bd6959e2b5c4)(csv, filename);
};




const $98432ddb3eec3cc0$export$ce51aec31be8dc1a = ({ field: field , type: type , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$ce51aec31be8dc1a)(field, type);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};




const $feeaee3524064efd$export$f74994b6a62d0315 = ({ field: field , mapping: mapping , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$f74994b6a62d0315)(field, mapping);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation);
};



const $9cb40ab83f7004d8$export$8d8c1a8ab106d86 = ({})=>{
    (0, $57e66c5a34f265b4$export$8d8c1a8ab106d86)();
};




const $236af74dd9298bec$export$278bb844373faf01 = ({ event_log_id: event_log_id  })=>{
    (0, $57e66c5a34f265b4$export$278bb844373faf01)(event_log_id);
};



const $08dcd784e4703717$export$212a51c55a0edc9 = ({ filteredOnly: filteredOnly  })=>(0, $57e66c5a34f265b4$export$6377d97db4c4732f)({
        filteredOnly: filteredOnly
    });



const $d0d6e242565d192f$export$394587e309590754 = {
    processCSV: $e9ddf5ef3c8c08b1$export$2ae80658c4c02420,
    uploadEventLog: $859ebbe57ee4d089$export$d2e5d507adb5caad,
    setDataType: $98432ddb3eec3cc0$export$ce51aec31be8dc1a,
    setDataMapping: $feeaee3524064efd$export$f74994b6a62d0315,
    exportEventLog: $9cb40ab83f7004d8$export$8d8c1a8ab106d86,
    updateDataTransformation: $991b261412ea11a7$export$492241ebb0cf08ee,
    setEventLogID: $236af74dd9298bec$export$278bb844373faf01,
    saveFilteredOnly: $08dcd784e4703717$export$212a51c55a0edc9,
    updateLoadingStatus: $ee9d85e7e6e93318$export$c2ca0ce95834e88b
};




const $9b03cf2aadd7de7b$export$63e35c5b675fe11f = ({ metricFilter: metricFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$29285b430bd23922)(metricFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyDecompositionTreeMetricFilter);
};




const $92e2f2635c30d8c1$export$8c79bfcc5706dfd6 = ({ attributeFilter: attributeFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$eb4c55b185c3e94f)(attributeFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
};




const $ddcaf1c01a3ed7b0$export$6422d51cbb8e9b96 = ({ valueFilter: valueFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$f66e2aa810437141)(valueFilter);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
};




const $f7a55b373de44b37$export$e72c0f9a78feacad = ({ source: source , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$e72c0f9a78feacad)(source);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramDecompositionTree);
};



const $637d268eaf747ed7$export$6348777ed6ef7a89 = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$6348777ed6ef7a89)({
        min: min,
        max: max
    });
};
const $637d268eaf747ed7$export$983be1ad9d9ef4ec = ()=>(0, $57e66c5a34f265b4$export$983be1ad9d9ef4ec)();




const $f9f0f5fa53633a80$export$96303173843f664 = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$96303173843f664)({
        min: min,
        max: max
    });
};
const $f9f0f5fa53633a80$export$f189dbef1e8a7829 = ()=>(0, $57e66c5a34f265b4$export$f189dbef1e8a7829)();



const $dffe6afba0b2d4c3$export$3ee2eb0d8c4a6b60 = {
    applyDecompositionTreeMetricFilter: $9b03cf2aadd7de7b$export$63e35c5b675fe11f,
    applyAttributeFilter: $92e2f2635c30d8c1$export$8c79bfcc5706dfd6,
    applyDecompositionTreeValueFilter: $ddcaf1c01a3ed7b0$export$6422d51cbb8e9b96,
    setDiagramDecompositionTree: $f7a55b373de44b37$export$e72c0f9a78feacad,
    setDecompositionTreeMinMaxMetric: $f9f0f5fa53633a80$export$96303173843f664,
    getDecompositionTreeMinMaxMetric: $f9f0f5fa53633a80$export$f189dbef1e8a7829,
    setDecompositionTreeMinMaxTasks: $637d268eaf747ed7$export$6348777ed6ef7a89,
    getDecompositionTreeMinMaxTasks: $637d268eaf747ed7$export$983be1ad9d9ef4ec
};




const $b513ad5da0327fe2$export$e2106fbab9ef3521 = ({ metricFilter: metricFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$a5e7df8db49f4c1c)(metricFilter);
    (0, $57e66c5a34f265b4$export$e22f012476996d14)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyInsightsMetricFilter);
};



const $a4659a2263d1c906$export$3679b0d160d98153 = ({ attributes: attributes , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$3679b0d160d98153)(attributes);
    (0, $57e66c5a34f265b4$export$e22f012476996d14)();
//    eventEmitter.emit(Event.applyInsightsMetricFilter);
};
const $a4659a2263d1c906$export$8bf16dc518529ab6 = ()=>(0, $57e66c5a34f265b4$export$8bf16dc518529ab6)();




const $04716830aea0fd73$export$8bc6e9612f7875cf = ({ valueFilter: valueFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$48d41720ed9da60c)(valueFilter);
    (0, $57e66c5a34f265b4$export$e22f012476996d14)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
};




const $1b7c87e2fa4c4cca$export$a5b1f71afbc1817b = ({ source: source , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$a5b1f71afbc1817b)(source);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInsights);
};



const $0fac7bbabc15ae83$export$e8e945c125804cad = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$e8e945c125804cad)({
        min: min,
        max: max
    });
    (0, $57e66c5a34f265b4$export$e22f012476996d14)();
};
const $0fac7bbabc15ae83$export$ded4bd5df3f4cb5 = ()=>(0, $57e66c5a34f265b4$export$ded4bd5df3f4cb5)();




const $634fbdd22e3593d1$export$20cb68fc0815ec0a = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$20cb68fc0815ec0a)({
        min: min,
        max: max
    });
    (0, $57e66c5a34f265b4$export$e22f012476996d14)();
};
const $634fbdd22e3593d1$export$c0e100bd56502100 = ()=>(0, $57e66c5a34f265b4$export$c0e100bd56502100)();



const $d5e9f37659b08bba$export$40f3090e2ee9fc3d = {
    applyInsightsMetricFilter: $b513ad5da0327fe2$export$e2106fbab9ef3521,
    setInsightsAttributes: $a4659a2263d1c906$export$3679b0d160d98153,
    setDiagramInsights: $1b7c87e2fa4c4cca$export$a5b1f71afbc1817b,
    applyInsightsValueFilter: $04716830aea0fd73$export$8bc6e9612f7875cf,
    setInsightsMinMaxMetric: $0fac7bbabc15ae83$export$e8e945c125804cad,
    getInsightsMinMaxMetric: $0fac7bbabc15ae83$export$ded4bd5df3f4cb5,
    setInsightsMinMaxTasks: $634fbdd22e3593d1$export$20cb68fc0815ec0a,
    getInsightsMinMaxTasks: $634fbdd22e3593d1$export$c0e100bd56502100
};




const $3eb93b6dbc9a852e$export$c2eaf7e38d3dcd36 = ({ metricFilter: metricFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$cdcd56b925cbb9af)(metricFilter);
    (0, $57e66c5a34f265b4$export$b693c597fa907dbc)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyInfluenceAnalysisMetricFilter);
};




const $01fccca23f5d6d59$export$af63db901586cc00 = ({ source: source , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$af63db901586cc00)(source);
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInfluenceAnalysis);
};



const $309358111035821f$export$b648d1998753e9cc = ({ attributes: attributes , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$b648d1998753e9cc)(attributes);
    (0, $57e66c5a34f265b4$export$b693c597fa907dbc)();
//    eventEmitter.emit(Event.applyInfluenceAnalysisMetricFilter);
};
const $309358111035821f$export$a53625ad464e5f8d = ()=>(0, $57e66c5a34f265b4$export$a53625ad464e5f8d)();




const $606fd7810a7e6a46$export$64521f4e56f56682 = ({ valueFilter: valueFilter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$d0e0079ab3401e29)(valueFilter);
    (0, $57e66c5a34f265b4$export$b693c597fa907dbc)();
    eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter);
};



const $9770951e6a50ede7$export$597324953872718f = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$597324953872718f)({
        min: min,
        max: max
    });
    (0, $57e66c5a34f265b4$export$b693c597fa907dbc)();
};
const $9770951e6a50ede7$export$4a3d5d394131832f = ()=>(0, $57e66c5a34f265b4$export$4a3d5d394131832f)();




const $e502ea700d3bb974$export$effa016fa1d36624 = ({ min: min , max: max  })=>{
    (0, $57e66c5a34f265b4$export$effa016fa1d36624)({
        min: min,
        max: max
    });
    (0, $57e66c5a34f265b4$export$b693c597fa907dbc)();
};
const $e502ea700d3bb974$export$5d691418b299f6dd = ()=>(0, $57e66c5a34f265b4$export$5d691418b299f6dd)();



const $50f00b8ea9087a20$export$54b8674cb616ae51 = {
    applyInfluenceAnalysisMetricFilter: $3eb93b6dbc9a852e$export$c2eaf7e38d3dcd36,
    setInfluenceAnalysisAttributes: $309358111035821f$export$b648d1998753e9cc,
    setDiagramInfluenceAnalysis: $01fccca23f5d6d59$export$af63db901586cc00,
    applyInfluenceAnalysisValueFilter: $606fd7810a7e6a46$export$64521f4e56f56682,
    setInfluenceAnalysisMinMaxMetric: $9770951e6a50ede7$export$597324953872718f,
    getInfluenceAnalysisMinMaxMetric: $9770951e6a50ede7$export$4a3d5d394131832f,
    setInfluenceAnalysisMinMaxTasks: $e502ea700d3bb974$export$effa016fa1d36624,
    getInfluenceAnalysisMinMaxTasks: $e502ea700d3bb974$export$5d691418b299f6dd
};



const $69b25eaa60ebbeff$export$b52de6745c1a27a5 = ({ type: type , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$b52de6745c1a27a5)(type);
};



const $cef9012123337205$export$e6b60d9360e18c1d = ({ metric: metric , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$e6b60d9360e18c1d)(metric);
};



const $017b4d6dbea44226$export$b73036cb160b9040 = ({ type: type , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$b73036cb160b9040)(type);
};



const $e1e17f2d8ca4d9fd$export$cb7cf428bffb1059 = ({ metric: metric , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$cb7cf428bffb1059)(metric);
};



const $e0c53471ecf22f89$export$bfd35fca27553ffc = ({ filter: filter , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$bfd35fca27553ffc)(filter);
};



const $7eb8c0cc6263d14e$export$418ef504d869fc9a = ({ NumTasks: NumTasks , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$418ef504d869fc9a)(NumTasks);
};



const $83cb668ba3fbe0e0$export$78e1557c7600222c = ({ source: source , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$78e1557c7600222c)(source);
};



const $e8a2f33bec74f4a5$export$3d03a212c61bceaa = ({ sort: sort , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$3d03a212c61bceaa)(sort);
};


const $fd058b389696c265$export$201ba907878ba51a = {
    setVariantsVisualizationGraphType: $69b25eaa60ebbeff$export$b52de6745c1a27a5,
    setVariantsVisualizationMetric: $cef9012123337205$export$e6b60d9360e18c1d,
    setTasksVisualizationGraphType: $017b4d6dbea44226$export$b73036cb160b9040,
    setTasksVisualizationMetric: $e1e17f2d8ca4d9fd$export$cb7cf428bffb1059,
    setTasksVisualizationNumTasks: $7eb8c0cc6263d14e$export$418ef504d869fc9a,
    setTasksVisualizationSort: $e8a2f33bec74f4a5$export$3d03a212c61bceaa,
    setTasksVisualizationFilter: $e0c53471ecf22f89$export$bfd35fca27553ffc,
    setTasksVisualizationSource: $83cb668ba3fbe0e0$export$78e1557c7600222c
};



const $ab83dfe4ccfa2bf9$export$1523bcbf52c800e = ({ duration: duration  })=>{
    (0, $57e66c5a34f265b4$export$bc15c77749bbb18f)({
        duration: duration
    });
};
const $ab83dfe4ccfa2bf9$export$bdef90392239c746 = ()=>(0, $57e66c5a34f265b4$export$bdef90392239c746)();




const $ce334bcc8f8aaad8$export$70569108c74b0b00 = ({ type: type , variantPaneVariants: variantPaneVariants , activity: activity , variant: variant , from: from , to: to , eventEmitter: eventEmitter  })=>{
    (0, $57e66c5a34f265b4$export$70569108c74b0b00)(type, variantPaneVariants, variant, activity, from, to);
};


const $33a735a4b7703ea7$export$4f82506950b9385 = {
    changeDurationLabel: $ab83dfe4ccfa2bf9$export$1523bcbf52c800e,
    getDurationLabel: $ab83dfe4ccfa2bf9$export$bdef90392239c746,
    generateHistogramArray: $ce334bcc8f8aaad8$export$70569108c74b0b00
};


const $e039a361404653d2$export$e13b82b2b0368a6a = {
    ...(0, $15cc0575c2f37eac$export$1a9ef722d19f9a5c),
    ...(0, $e63024439717feee$export$80a4585e16d8b863),
    ...(0, $de1ed0fc3b8f9bd1$export$3a8174bb16d1f3c0),
    ...(0, $2665a647d0606861$export$eb34776e9fed881c),
    ...(0, $c0bf3d0ebd6822e3$export$196e99c03c1a2430),
    ...(0, $4a444a93570efd66$export$cd46715b94531cfc),
    ...(0, $9e8044757f30ab71$export$975888427d5f0833),
    ...(0, $34b93ca27d027206$export$bfe913bc3fd3bbb),
    ...(0, $68a6c5dfbe9314b7$export$447e5625df442cb2),
    ...(0, $77ab2efd0eca57e0$export$a4c0c8140f746e12),
    ...(0, $d0d6e242565d192f$export$394587e309590754),
    ...(0, $dffe6afba0b2d4c3$export$3ee2eb0d8c4a6b60),
    ...(0, $d5e9f37659b08bba$export$40f3090e2ee9fc3d),
    ...(0, $50f00b8ea9087a20$export$54b8674cb616ae51),
    ...(0, $fd058b389696c265$export$201ba907878ba51a),
    ...(0, $33a735a4b7703ea7$export$4f82506950b9385)
};




function $c4f6534b2e1264fe$export$affefed35765a709() {
    const eventEmitter = new (0, $lR8r2$events.EventEmitter)();
    eventEmitter.setMaxListeners(100);
    (0, $57e66c5a34f265b4$export$affefed35765a709)(eventEmitter);
}


const $69a728bfd4f3e5d1$export$5f0d58c189d5640f = (()=>{
    (0, $c4f6534b2e1264fe$export$affefed35765a709)();
    let eventEmitter = (0, $57e66c5a34f265b4$export$42e0d87b3bb491d0)();
    let diagram;
    const setDiagram = (diagramInstance)=>{
        diagram = diagramInstance;
        window.diagram = diagram;
    };
    const getDiagram = ()=>diagram;
    const getMethods = ()=>$lR8r2$lodashfp.flowRight($lR8r2$lodashfp.reduce((allMethods, methodName)=>({
                ...allMethods,
                [methodName]: (props)=>diagram && (0, $e039a361404653d2$export$e13b82b2b0368a6a)[methodName]({
                        diagram: diagram,
                        eventEmitter: eventEmitter,
                        ...props
                    })
            }), {}), $lR8r2$lodashfp.keys)((0, $e039a361404653d2$export$e13b82b2b0368a6a));
    const api = getMethods();
    return {
        setDiagram: setDiagram,
        getDiagram: getDiagram,
        on: (name, listener)=>eventEmitter.on(name, listener),
        off: (name, listener)=>eventEmitter.off(name, listener),
        eventEmitter: eventEmitter,
        init: ()=>(0, $57e66c5a34f265b4$export$2cd8252107eb640b)(),
        ...api
    };
})();







const $c7729d040ce393f6$export$81992de11aadc815 = (event, listener, params = [])=>{
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on(event, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off(event, listener);
        };
    }, [
        ...params,
        listener,
        event
    ]);
};












const $957db110bbfa53b5$var$Select = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Select))`
    border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
    border-radius: 8px;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    margin-right: 10px;
    padding: 5px 5px;
    width: 100%;

    .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
        padding: 3px 3px;
    }

    & .MuiMenu-paper {
        border-radius: 10px;
        margin-top: 10px;
        box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("menu")};
        border: .5px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")};
    }

    & .MuiMenuItem-root {
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
        padding: 3px 5px;
        display: flex;
        justify-content: space-between;
    }

    & .Mui-selected img {
        display: block;
    }

    & legend {
        width: 0 !important;
        border-bottom: none !important;
    }
`;
const $957db110bbfa53b5$var$Check = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).img`
    width: 10px;
    height: 10px;
    display: none;
`;
const $957db110bbfa53b5$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 15px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
`;
const $957db110bbfa53b5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    max-width: 100%;
`;
const $957db110bbfa53b5$export$931cbfb6bfb85fc = ({ options: options , value: value , onChange: onChange , className: className , label: label ,  })=>{
    const handleOnChange = (event)=>{
        onChange(event.target.value);
    };
    const isProperValue = ()=>$lR8r2$lodashfp.some((option)=>option.value === value)(options);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($957db110bbfa53b5$var$Wrapper, null, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($957db110bbfa53b5$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.FormControl), {
        className: className,
        variant: "outlined"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($957db110bbfa53b5$var$Select, {
        MenuProps: {
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left"
            },
            disablePortal: true
        },
        value: isProperValue() ? value : "",
        onChange: handleOnChange
    }, $lR8r2$lodashfp.map(({ value: optionValue , label: label  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.MenuItem), {
            key: optionValue,
            value: optionValue
        }, label, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($957db110bbfa53b5$var$Check, {
            src: "https://metricuspm.blob.core.windows.net/processminer/CheckIcon.svg",
            alt: "check"
        })))(options))));
};


const $95ecc1624cd86d2e$var$options = [
    {
        value: 1,
        label: "Tasks"
    },
    {
        value: 2,
        label: "Duration (mins)"
    },
    {
        value: 3,
        label: "Duration (hrs)"
    },
    {
        value: 4,
        label: "Duration (days)"
    },
    {
        value: 6,
        label: "Avg Cost"
    },
    {
        value: 7,
        label: "Avg Cost Savings"
    },
    {
        value: 8,
        label: "% Compliance"
    }, 
];
const $95ecc1624cd86d2e$export$ed9166ec0f465b5e = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyDecompositionTreeMetricFilter({
            metricFilter: value
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDecompositionTreeMetricFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $95ecc1624cd86d2e$var$options,
        onChange: onChange,
        value: value
    });
};









const $5f35df8c276256ce$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $5f35df8c276256ce$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 10px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $5f35df8c276256ce$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $5f35df8c276256ce$export$29ba8ed117cdbb9d = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("high");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyDecompositionTreeValueFilter({
            valueFilter: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDecompositionTreeValueFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f35df8c276256ce$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f35df8c276256ce$var$StyledFormControlLabel, {
        value: "high",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f35df8c276256ce$var$RadioComponent, null),
        label: "Desc"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f35df8c276256ce$var$StyledFormControlLabel, {
        value: "low",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f35df8c276256ce$var$RadioComponent, null),
        label: "Asc"
    })));
};





let $f60762aeebc39f6b$var$options = [
    {
        value: "",
        label: ""
    }
];
const $f60762aeebc39f6b$export$c415debe62efa829 = ()=>{
    const [attribute, setAttribute] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const onAttributeChange = (attribute)=>{
        setAttribute(attribute);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyAttributeFilter({
            attributeFilter: attribute
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        $f60762aeebc39f6b$var$options = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        if ($f60762aeebc39f6b$var$options.length > 0) {
            setAttribute($f60762aeebc39f6b$var$options[0].value);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyAttributeFilter({
                attributeFilter: attribute
            });
        }
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $f60762aeebc39f6b$var$options,
        onChange: onAttributeChange,
        value: attribute
    });
};












const $54d265e55b9d4a6b$export$111e140b0af40b4e = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.TextField))`
    width: 71px;

    & .MuiInputBase-root {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        border-radius: 8px;

        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }
    }

    & .MuiInputBase-root.Mui-disabled {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightGray")};

        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        }
    }

    & input {
        text-align: center;
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("input")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        padding: 5px;
    }
    & fieldset,
    & fieldset:hover {
        border: none;
    }
    & legend {
        border-bottom: none !important;
    }
`;


const $4bd5e76dbb51a527$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 5px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    border-bottom: none !important;
`;
const $4bd5e76dbb51a527$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    padding: 3px 0;
`;
const $4bd5e76dbb51a527$export$6bf0cd3a219bbade = ({ value: value , onChange: onChange = $lR8r2$lodashfp.noop , onBlur: onBlur = $lR8r2$lodashfp.noop , className: className , label: label , min: min , max: max , disabled: disabled ,  })=>{
    const handleOnChange = (event)=>{
        if (event.target.value >= 0) onChange(event.target.value);
    };
    const handleOnBlur = (event)=>{
        const finalValue = Number(event.target.value);
        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }
        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }
        onBlur(finalValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4bd5e76dbb51a527$var$Wrapper, {
        className: className
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4bd5e76dbb51a527$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $54d265e55b9d4a6b$export$111e140b0af40b4e), {
        disabled: disabled,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        value: value,
        variant: "outlined",
        type: "number"
    }));
};



const $aedc91d28845b344$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $aedc91d28845b344$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $4bd5e76dbb51a527$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $aedc91d28845b344$export$3e6a1bb6c0ea280d = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDecompositionTreeMinMaxMetric(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDecompositionTreeMinMaxMetric());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($aedc91d28845b344$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($aedc91d28845b344$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $4bd5e76dbb51a527$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};







const $84cf78dc704d1d30$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $84cf78dc704d1d30$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $4bd5e76dbb51a527$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $84cf78dc704d1d30$export$f58353c5a13ae604 = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDecompositionTreeMinMaxTasks(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDecompositionTreeMinMaxTasks());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($84cf78dc704d1d30$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($84cf78dc704d1d30$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $4bd5e76dbb51a527$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};





const $8fabba464b7a998b$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    background-color: white;
    width: 800px;
    margin-left: 35px;
    margin-top: 17px;
    padding: 5px;
`;
const $8fabba464b7a998b$var$Row1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 50px 150px 65px 400px;
  padding-bottom: 5px;
`;
const $8fabba464b7a998b$var$Row2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 70px 130px 40px 220px 40px 220px;
  padding-bottom: 5px;
`;
const $8fabba464b7a998b$var$MetricLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 1 / 1 ;
`;
const $8fabba464b7a998b$var$MetricValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 2 / 2 ;
`;
const $8fabba464b7a998b$var$AttributeLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 3 / 3 ;
`;
const $8fabba464b7a998b$var$AttributeValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 4 / 4 ;
`;
const $8fabba464b7a998b$var$ValuesLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 1 / 1 ;
`;
const $8fabba464b7a998b$var$ValuesValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 2 / 2 ;
`;
const $8fabba464b7a998b$var$TasksMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 3 / 3 ;
`;
const $8fabba464b7a998b$var$TasksMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 4 / 4 ;
`;
const $8fabba464b7a998b$var$MetricMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 5 / 5 ;
`;
const $8fabba464b7a998b$var$MetricMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 6 / 6 ;
`;
const $8fabba464b7a998b$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $8fabba464b7a998b$var$Row3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: auto;
  padding-bottom: 10px;
  padding-bottom: 5px;
`;
const $8fabba464b7a998b$export$34c40c9f58844e01 = ()=>{
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramDecompositionTree, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramDecompositionTree, listener);
        };
    }, []);
    const label = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s:";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Row1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$MetricLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Label, null, "Metrics:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$MetricValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $95ecc1624cd86d2e$export$ed9166ec0f465b5e), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$AttributeLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Label, null, "Attributes:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$AttributeValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f60762aeebc39f6b$export$c415debe62efa829), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Row2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$ValuesLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Label, null, "Metric sort:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$ValuesValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5f35df8c276256ce$export$29ba8ed117cdbb9d), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$TasksMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Label, null, label)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$TasksMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $84cf78dc704d1d30$export$f58353c5a13ae604), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$MetricMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Label, null, "Metric:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$MetricMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aedc91d28845b344$export$3e6a1bb6c0ea280d), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8fabba464b7a998b$var$Row3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description)));
};








const $da2608fd79c1ca9e$var$options = [
    {
        value: 1,
        label: "Tasks"
    },
    {
        value: 2,
        label: "Duration (mins)"
    },
    {
        value: 3,
        label: "Duration (hrs)"
    },
    {
        value: 4,
        label: "Duration (days)"
    },
    {
        value: 6,
        label: "Avg Cost"
    },
    {
        value: 7,
        label: "Avg Cost Savings"
    },
    {
        value: 8,
        label: "% Compliance"
    }, 
];
const $da2608fd79c1ca9e$export$ed9166ec0f465b5e = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyInsightsMetricFilter({
            metricFilter: value
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInsightsMetricFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $da2608fd79c1ca9e$var$options,
        onChange: onChange,
        value: value
    });
};









const $0d53fd80ab327e91$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $0d53fd80ab327e91$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 10px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $0d53fd80ab327e91$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $0d53fd80ab327e91$export$29ba8ed117cdbb9d = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("high");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyInsightsValueFilter({
            valueFilter: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInsightsValueFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0d53fd80ab327e91$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0d53fd80ab327e91$var$StyledFormControlLabel, {
        value: "high",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0d53fd80ab327e91$var$RadioComponent, null),
        label: "Desc"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0d53fd80ab327e91$var$StyledFormControlLabel, {
        value: "low",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0d53fd80ab327e91$var$RadioComponent, null),
        label: "Asc"
    })));
};













const $18685cb16f0b8e4e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $18685cb16f0b8e4e$var$a;
const $18685cb16f0b8e4e$var$useStyles = (0, $lR8r2$materialuistyles.makeStyles)((theme)=>({
        formControl: {
            width: 300,
            margin: 0
        },
        listItemText: {
            fontSize: "12px"
        },
        menuItem: {
            height: "30px"
        },
        indeterminateColor: {
            color: "#f50057"
        },
        selectAllText: {
            fontWeight: 500,
            fontSize: "12px"
        },
        selectedAll: {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)"
            }
        }
    }));
const $18685cb16f0b8e4e$var$ITEM_HEIGHT = 40;
const $18685cb16f0b8e4e$var$ITEM_PADDING_TOP = 2;
const $18685cb16f0b8e4e$var$MenuProps = {
    PaperProps: {
        style: {
            maxHeight: $18685cb16f0b8e4e$var$ITEM_HEIGHT * 4.5 + $18685cb16f0b8e4e$var$ITEM_PADDING_TOP,
            width: 250
        }
    },
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};
function $18685cb16f0b8e4e$export$c4089a988083a878() {
    const classes = $18685cb16f0b8e4e$var$useStyles();
    const [selected, setSelected] = (0, $lR8r2$react.useState)([]);
    const [options, setOptions] = (0, $lR8r2$react.useState)([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        let attributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        for(var i = 0; i < tOptions.length; i++)attributes.push(tOptions[i].label);
        setOptions(attributes);
        var temp = [];
        temp.push(attributes[0]);
        setSelected(temp);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInsightsAttributes({
            attributes: temp
        });
    }, []);
    const handleChange = (event)=>{
        const value = event.target.value;
        setSelected(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInsightsAttributes({
            attributes: value
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControl))), {
        sx: {
            m: 1,
            minWidth: 200,
            height: "30px",
            margin: "0px"
        },
        size: "small"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreSelect))), {
        labelId: "mutiple-select-label",
        multiple: true,
        value: selected,
        onChange: handleChange,
        renderValue: (selected)=>selected.join(", "),
        style: {
            fontSize: "12px",
            height: "50px"
        },
        MenuProps: $18685cb16f0b8e4e$var$MenuProps
    }, options.map((option)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
            key: option,
            value: option,
            style: {
                height: "20px",
                minHeight: "30px"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreListItemIcon))), {
            style: {
                width: ".7em"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreCheckbox))), {
            checked: selected.indexOf(option) > -1
        })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreListItemText))), {
            classes: {
                primary: classes.listItemText
            },
            primary: option
        })))));
}










const $774a983002c910b4$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 5px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $774a983002c910b4$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    padding: 3px 0;
`;
const $774a983002c910b4$export$6bf0cd3a219bbade = ({ value: value , onChange: onChange = $lR8r2$lodashfp.noop , onBlur: onBlur = $lR8r2$lodashfp.noop , className: className , label: label , min: min , max: max , disabled: disabled ,  })=>{
    const handleOnChange = (event)=>{
        if (event.target.value >= 0) onChange(event.target.value);
    };
    const handleOnBlur = (event)=>{
        const finalValue = Number(event.target.value);
        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }
        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }
        onBlur(finalValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($774a983002c910b4$var$Wrapper, {
        className: className
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($774a983002c910b4$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $54d265e55b9d4a6b$export$111e140b0af40b4e), {
        disabled: disabled,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        value: value,
        variant: "outlined",
        type: "number"
    }));
};



const $73f4380fb3a64fd9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $73f4380fb3a64fd9$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $774a983002c910b4$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $73f4380fb3a64fd9$export$3e6a1bb6c0ea280d = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInsightsMinMaxMetric(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInsightsMinMaxMetric());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($73f4380fb3a64fd9$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($73f4380fb3a64fd9$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $774a983002c910b4$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};







const $7510f5f8d577fc59$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $7510f5f8d577fc59$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $774a983002c910b4$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $7510f5f8d577fc59$export$f58353c5a13ae604 = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInsightsMinMaxTasks(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInsightsMinMaxTasks());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($7510f5f8d577fc59$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($7510f5f8d577fc59$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $774a983002c910b4$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};





const $ca0209cf56bb55d6$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    background-color: white;
    width: 800px;
    margin-left: 35px;
    margin-top: 17px;
    padding: 5px;
`;
const $ca0209cf56bb55d6$var$Row1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 50px 150px 65px 400px;
  padding-bottom: 5px;
`;
const $ca0209cf56bb55d6$var$Row2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 70px 130px 40px 220px 40px 220px;
  padding-bottom: 5px;
`;
const $ca0209cf56bb55d6$var$MetricLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 1 / 1 ;
`;
const $ca0209cf56bb55d6$var$MetricValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 2 / 2 ;
`;
const $ca0209cf56bb55d6$var$AttributeLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 3 / 3 ;
`;
const $ca0209cf56bb55d6$var$AttributeValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 4 / 4 ;
`;
const $ca0209cf56bb55d6$var$ValuesLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 1 / 1 ;
`;
const $ca0209cf56bb55d6$var$ValuesValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 2 / 2 ;
`;
const $ca0209cf56bb55d6$var$TasksMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 3 / 3 ;
`;
const $ca0209cf56bb55d6$var$TasksMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 4 / 4 ;
`;
const $ca0209cf56bb55d6$var$MetricMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 5 / 5 ;
`;
const $ca0209cf56bb55d6$var$MetricMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 6 / 6 ;
`;
const $ca0209cf56bb55d6$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $ca0209cf56bb55d6$var$Row3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: auto;
  padding-bottom: 10px;
  padding-bottom: 5px;
`;
const $ca0209cf56bb55d6$export$9c79a7affb242496 = ()=>{
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInsights, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInsights, listener);
        };
    }, []);
    const label = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s:";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Row1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$MetricLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Label, null, "Metrics:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$MetricValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $da2608fd79c1ca9e$export$ed9166ec0f465b5e), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$AttributeLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Label, null, "Attributes:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$AttributeValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $18685cb16f0b8e4e$export$c4089a988083a878), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Row2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$ValuesLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Label, null, "Metric sort:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$ValuesValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $0d53fd80ab327e91$export$29ba8ed117cdbb9d), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$TasksMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Label, null, label)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$TasksMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $7510f5f8d577fc59$export$f58353c5a13ae604), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$MetricMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Label, null, "Metric:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$MetricMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $73f4380fb3a64fd9$export$3e6a1bb6c0ea280d), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca0209cf56bb55d6$var$Row3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description)));
};








const $b5c82283badda80b$var$options = [
    {
        value: 2,
        label: "Duration (mins)"
    },
    {
        value: 3,
        label: "Duration (hrs)"
    },
    {
        value: 4,
        label: "Duration (days)"
    },
    {
        value: 6,
        label: "Avg Cost"
    },
    {
        value: 7,
        label: "Avg Cost Savings"
    },
    {
        value: 8,
        label: "% Compliance"
    }, 
];
const $b5c82283badda80b$export$ed9166ec0f465b5e = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(3);
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyInfluenceAnalysisMetricFilter({
            metricFilter: value
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInfluenceAnalysisMetricFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $b5c82283badda80b$var$options,
        onChange: onChange,
        value: value
    });
};









const $c610643b7c746b62$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $c610643b7c746b62$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 10px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $c610643b7c746b62$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $c610643b7c746b62$export$29ba8ed117cdbb9d = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("increase");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyInfluenceAnalysisValueFilter({
            valueFilter: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInfluenceAnalysisValueFilter());
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c610643b7c746b62$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c610643b7c746b62$var$StyledFormControlLabel, {
        value: "increase",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c610643b7c746b62$var$RadioComponent, null),
        label: "Asc"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c610643b7c746b62$var$StyledFormControlLabel, {
        value: "decrease",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c610643b7c746b62$var$RadioComponent, null),
        label: "Desc"
    })));
};













const $071c72893bfe2b2c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $071c72893bfe2b2c$var$a;
const $071c72893bfe2b2c$var$useStyles = (0, $lR8r2$materialuistyles.makeStyles)((theme)=>({
        formControl: {
            width: 300
        },
        listItemText: {
            fontSize: "12px"
        },
        menuItem: {
            height: "30px"
        },
        indeterminateColor: {
            color: "#f50057"
        },
        selectAllText: {
            fontWeight: 500,
            fontSize: "12px"
        },
        selectedAll: {
            backgroundColor: "rgba(0, 0, 0, 0.08)",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.08)"
            }
        }
    }));
const $071c72893bfe2b2c$var$ITEM_HEIGHT = 40;
const $071c72893bfe2b2c$var$ITEM_PADDING_TOP = 2;
const $071c72893bfe2b2c$var$MenuProps = {
    PaperProps: {
        style: {
            maxHeight: $071c72893bfe2b2c$var$ITEM_HEIGHT * 4.5 + $071c72893bfe2b2c$var$ITEM_PADDING_TOP,
            width: 250
        }
    },
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};
function $071c72893bfe2b2c$export$c4089a988083a878() {
    const classes = $071c72893bfe2b2c$var$useStyles();
    const [selected, setSelected] = (0, $lR8r2$react.useState)([]);
    const [options, setOptions] = (0, $lR8r2$react.useState)([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        let attributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        for(var i = 0; i < tOptions.length; i++)attributes.push(tOptions[i].label);
        setOptions(attributes);
        var temp = [];
        temp.push(attributes[0]);
        setSelected(temp);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInfluenceAnalysisAttributes({
            attributes: temp
        });
    }, []);
    const handleChange = (event)=>{
        const value = event.target.value;
        setSelected(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInfluenceAnalysisAttributes({
            attributes: value
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControl))), {
        sx: {
            m: 1,
            minWidth: 200,
            height: "30px"
        },
        size: "small"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreSelect))), {
        labelId: "mutiple-select-label",
        multiple: true,
        value: selected,
        onChange: handleChange,
        renderValue: (selected)=>selected.join(", "),
        style: {
            fontSize: "12px",
            height: "50px"
        },
        MenuProps: $071c72893bfe2b2c$var$MenuProps
    }, options.map((option)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
            key: option,
            value: option,
            style: {
                height: "20px",
                minHeight: "30px"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreListItemIcon))), {
            style: {
                width: ".7em"
            }
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreCheckbox))), {
            checked: selected.indexOf(option) > -1
        })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreListItemText))), {
            classes: {
                primary: classes.listItemText
            },
            primary: option
        })))));
}










const $0e42818d867d0728$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 5px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $0e42818d867d0728$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    padding: 3px 0;
`;
const $0e42818d867d0728$export$6bf0cd3a219bbade = ({ value: value , onChange: onChange = $lR8r2$lodashfp.noop , onBlur: onBlur = $lR8r2$lodashfp.noop , className: className , label: label , min: min , max: max , disabled: disabled ,  })=>{
    const handleOnChange = (event)=>{
        if (event.target.value >= 0) onChange(event.target.value);
    };
    const handleOnBlur = (event)=>{
        onChange(event.target.value);
        const finalValue = Number(event.target.value);
        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }
        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }
        onBlur(finalValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0e42818d867d0728$var$Wrapper, {
        className: className
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0e42818d867d0728$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $54d265e55b9d4a6b$export$111e140b0af40b4e), {
        disabled: disabled,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        value: value,
        variant: "outlined",
        type: "number"
    }));
};



const $971292c4625f4206$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $971292c4625f4206$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $0e42818d867d0728$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $971292c4625f4206$export$3e6a1bb6c0ea280d = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInfluenceAnalysisMinMaxMetric(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInfluenceAnalysisMinMaxMetric());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($971292c4625f4206$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($971292c4625f4206$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $0e42818d867d0728$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};







const $32bc4f8ac90f6bc4$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $32bc4f8ac90f6bc4$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $0e42818d867d0728$export$6bf0cd3a219bbade))`
    margin-right: 10px;
`;
const $32bc4f8ac90f6bc4$export$f58353c5a13ae604 = ()=>{
    let [minmax, setMinMax] = $lR8r2$react.useState({
        min: 0,
        max: 999999999
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...minmax,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setInfluenceAnalysisMinMaxTasks(minmax);
    });
    $lR8r2$react.useEffect(()=>{
        setMinMax((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInfluenceAnalysisMinMaxTasks());
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($32bc4f8ac90f6bc4$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($32bc4f8ac90f6bc4$var$StyledNumberInput, {
        label: "Min",
        value: minmax.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $0e42818d867d0728$export$6bf0cd3a219bbade), {
        label: "Max",
        value: minmax.max,
        onChange: onChange("max"),
        onBlur: onBlur("min")
    }));
};





const $8f21c138fe0b1154$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    background-color: white;
    width: 800px;
    margin-left: 35px;
    margin-top: 17px;
    padding: 5px;
`;
const $8f21c138fe0b1154$var$Row1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 50px 150px 65px 400px;
  padding-bottom: 5px;
`;
const $8f21c138fe0b1154$var$Row2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: 70px 130px 40px 220px 40px 220px;
  padding-bottom: 5px;
`;
const $8f21c138fe0b1154$var$MetricLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 1 / 1 ;
`;
const $8f21c138fe0b1154$var$MetricValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 2 / 2 ;
`;
const $8f21c138fe0b1154$var$AttributeLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 3 / 3 ;
`;
const $8f21c138fe0b1154$var$AttributeValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 1 ;
    grid-column: 4 / 4 ;
`;
const $8f21c138fe0b1154$var$ValuesLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 1 / 1 ;
`;
const $8f21c138fe0b1154$var$ValuesValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 2 / 2 ;
`;
const $8f21c138fe0b1154$var$TasksMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 3 / 3 ;
`;
const $8f21c138fe0b1154$var$TasksMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 4 / 4 ;
`;
const $8f21c138fe0b1154$var$MetricMinMaxLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 5 / 5 ;
`;
const $8f21c138fe0b1154$var$MetricMinMaxValue = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 2 ;
    grid-column: 6 / 6 ;
`;
const $8f21c138fe0b1154$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $8f21c138fe0b1154$var$Row3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
  display: grid;
  align-items: center;
  grid-template-rows: auto;
  grid-template-columns: auto;
  padding-bottom: 10px;
  padding-bottom: 5px;
`;
const $8f21c138fe0b1154$export$ef3558726c249ee = ()=>{
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getRCDescription());
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInfluenceAnalysis, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setDiagramInfluenceAnalysis, listener);
        };
    }, []);
    const label = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s:";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Row1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$MetricLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Label, null, "Metrics:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$MetricValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b5c82283badda80b$export$ed9166ec0f465b5e), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$AttributeLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Label, null, "Attributes:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$AttributeValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $071c72893bfe2b2c$export$c4089a988083a878), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Row2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$ValuesLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Label, null, "Metric sort:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$ValuesValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c610643b7c746b62$export$29ba8ed117cdbb9d), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$TasksMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Label, null, label)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$TasksMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $32bc4f8ac90f6bc4$export$f58353c5a13ae604), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$MetricMinMaxLabel, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Label, null, "Metric:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$MetricMinMaxValue, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $971292c4625f4206$export$3e6a1bb6c0ea280d), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8f21c138fe0b1154$var$Row3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description)));
};















const $68cac76d685755e6$var$Image = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).img`
    width: 7px;
    height: 7px;
    margin: auto;
`;
const $68cac76d685755e6$export$560b0277c649ed6b = ({ value: value  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($68cac76d685755e6$var$Image, {
        src: `${value ? "https://metricuspm.blob.core.windows.net/processminer/CheckIcon.svg" : "https://metricuspm.blob.core.windows.net/processminer/UncheckIcon.svg"}`,
        alt: "icon"
    });



const $c9c42953555bee80$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    margin-bottom: 5px;
    padding: 20px;
`;
const $c9c42953555bee80$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , type: type  })=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const processContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Delete",
                action: function() {
                    setProps({
                        functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteRule({
                                type: params.node.data.ruleType,
                                ruleID: params.node.data.ruleID
                            })
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/delete.png" />'
            },
            {
                name: "Edit",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).editRule({
                        type: params.node.data.ruleType,
                        ruleID: params.node.data.ruleID
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/edit.png" />'
            },
            "separator",
            {
                name: "Decompose",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/decompose.png" />'
            },
            {
                name: "Insights",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/insights.png" />'
            },
            {
                name: "Influencers",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/influencer.png" />'
            },
            "separator",
            "export", 
        ];
        return result;
    }, []);
    const costContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Delete",
                action: function() {
                    setProps({
                        functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteRule({
                                type: params.node.data.ruleType,
                                ruleID: params.node.data.ruleID
                            })
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/delete.png" />'
            },
            {
                name: "Edit",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).editRule({
                        type: params.node.data.ruleType,
                        ruleID: params.node.data.ruleID
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/edit.png" />'
            },
            "separator",
            "export", 
        ];
        return result;
    }, []);
    let getContextMenuItems;
    let showTotals = false;
    if (type === "cost") getContextMenuItems = costContextMenuItems;
    if (type === "process") {
        getContextMenuItems = processContextMenuItems;
        showTotals = true;
    }
    const [savestate, setSavestate] = (0, $lR8r2$react.useState)(false);
    const onSaveGridColumnState = (params)=>{
        if (savestate === true) {
            let columnState = params.columnApi.getColumnState();
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveCostRulesGridState({
                columnState: columnState
            });
        }
        setSavestate(true);
    };
    const onFirstDataRendered = (params)=>{
        params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCostRulesGridState());
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setSavestate(false);
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c9c42953555bee80$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-rules",
        style: {
            height: "100%",
            minHeight: "300px",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        onFirstDataRendered: onFirstDataRendered,
        onFilterChanged: onSaveGridColumnState,
        onColumnVisible: onSaveGridColumnState,
        onColumnResized: onSaveGridColumnState,
        onSortChanged: onSaveGridColumnState,
        masterDetail: true,
        rowSelection: "single",
        columnDefs: columns,
        groupIncludeTotalFooter: showTotals,
        suppressPropertyNamesCheck: true,
        getContextMenuItems: getContextMenuItems,
        domLayout: "autoHeight",
        detailRowAutoHeight: true,
        overlayNoRowsTemplate: "No rules exist",
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true,
            suppressMenu: true
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        detailCellRendererParams: {
            detailGridOptions: {
                pagination: true,
                paginationAutoPageSize: true,
                suppressRowClickSelection: true,
                headerHeight: 0,
                columnDefs: [
                    {
                        field: "header",
                        headerName: "header",
                        hide: true
                    },
                    {
                        field: "text",
                        headerName: "text"
                    }, 
                ],
                defaultColDef: {
                    flex: 1,
                    sortable: true,
                    filter: true,
                    resizable: true,
                    wrapText: true,
                    autoHeight: true
                },
                rowClassRules: {
                    "rules-header": function(params) {
                        return params.data.header === 1;
                    }
                }
            },
            getDetailRowData: (params)=>{
                params.successCallback(params.data.conditions);
            }
        },
        rowData: rows
    })));
};




const $466b0bcfa7db17c8$export$74011a969e67d1ed = ()=>[
        {
            field: "rule",
            headerName: "Rule",
            cellRenderer: "agGroupCellRenderer",
            wrapText: true,
            width: 300
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agNumberColumnFilter",
            width: 80,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "events",
            headerName: "Events",
            filter: "agNumberColumnFilter",
            width: 80,
            hide: false,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "actualCost",
            headerName: "Cost per event",
            hide: false,
            width: 90,
            aggFunc: "sum",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                })
        },
        {
            field: "type",
            headerName: "Type",
            wrapText: true,
            width: 100
        },
        {
            field: "toActivity",
            headerName: "To Activity",
            hide: true
        },
        {
            field: "fromActivity",
            headerName: "From Activity",
            hide: true
        },
        {
            field: "ruleID",
            headerName: "ID",
            hide: true,
            suppressToolPanel: true
        }, 
    ];


const $65410ffa5b76053c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $65410ffa5b76053c$export$b201652d403c08e3 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).costRulesSummary());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).costRulesSummary());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updatePerformance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updatePerformance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($65410ffa5b76053c$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c9c42953555bee80$export$c8dd51eb24f71762), {
        rows: rows,
        type: "cost",
        columns: (0, $466b0bcfa7db17c8$export$74011a969e67d1ed)()
    }));
};










const $4fc4d8fc73eeccd0$var$activeTextColor = (0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor");
const $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Tab))`
    text-transform: none;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("black")};
    font-weight: ${(0, $d18c0fc16613166e$export$16eeca46eca75f64)("normal")};
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    height: 30px;
    min-height: 0;
    border-right: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")};

    &:last-child {
        border-right: none;
    }

    &.Mui-selected {
        color: ${$4fc4d8fc73eeccd0$var$activeTextColor};
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightGray")};
    }

    &:focus {
        color: ${$4fc4d8fc73eeccd0$var$activeTextColor};
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightGray")};
    }
`;





const $fbad933ec7f2cab8$export$594ebcebca054019 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Tabs))`
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")};
    min-height: 0;

    & .MuiTabs-indicator {
        width: 100%;
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    }
`;



const $2ca8c64860b973f1$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    min-height: 30px;
    margin-bottom: 5px;
`;
const $2ca8c64860b973f1$export$38a748e73493e9da = ({ onChange: onChange , activeTab: activeTab  })=>{
    const handleChange = (__, newValue)=>onChange(newValue);
    const taskHistoryLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " History";
    const taskAttributesLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attributes";
    const costAttributesLabel = "Cost " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attributes";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2ca8c64860b973f1$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $fbad933ec7f2cab8$export$594ebcebca054019), {
        value: activeTab,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Task History",
        label: taskHistoryLabel
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Task Attributes",
        label: taskAttributesLabel
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Event History",
        label: "Event History"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Event Attributes",
        label: "Event Attributes"
    })));
};




const $1a8dfcfd10c19ff0$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    visibility: ${({ show: show  })=>show ? "visible" : "hidden"};
    height: ${({ show: show , height: height  })=>show ? height : "0"};
    overflow: ${({ show: show , showScroll: showScroll  })=>show && showScroll ? "auto" : "hidden"};
    width: 100%;
`;
const $1a8dfcfd10c19ff0$export$3d96ec278d3efce4 = ({ activeTab: activeTab , tab: tab , children: children , className: className , showScroll: showScroll = true , height: height = "100%" ,  })=>{
    const [show, setShow] = (0, ($parcel$interopDefault($lR8r2$react))).useState(activeTab === tab);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const shouldShow = activeTab === tab;
        setShow(shouldShow);
    }, [
        activeTab,
        tab
    ]);
    if (!show) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1a8dfcfd10c19ff0$var$Wrapper, {
        className: className,
        height: height,
        showScroll: showScroll,
        show: show
    }, children);
};













$lR8r2$highchartsmodulesexporting($lR8r2$highchartshighstock);

$lR8r2$highchartsmodulesexportdata($lR8r2$highchartshighstock);
const $e75920b94abc1947$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $e75920b94abc1947$export$c2e30eeee87f25ff = ({ ...props })=>{
    const wrapperRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const [width, setWidth] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const updateWidth = ()=>{
        setWidth(wrapperRef.current?.getBoundingClientRect().width || 0);
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).resizeSidebar, updateWidth);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (wrapperRef.current) updateWidth();
    }, [
        wrapperRef
    ]);
    const getSeriesLength = (singleSeries)=>"data" in singleSeries ? singleSeries.data.length : 0;
    const series = props.options.series.map((singleSeries)=>({
            ...singleSeries,
            turboThreshold: getSeriesLength(singleSeries)
        }));
    const chartKey = `${width}@${series.map(getSeriesLength).join("@")}`;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($e75920b94abc1947$var$Wrapper, {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$highchartsreactofficial))), {
        key: chartKey,
        ...props,
        options: {
            ...props.options,
            series: series
        },
        highcharts: $lR8r2$highchartshighstock,
        containerProps: {
            style: {
                height: "calc(100vh - 240px)",
                width: "100%"
            }
        }
    }));
};






const $36db6c9343738e53$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 8px
`;
const $36db6c9343738e53$var$Title = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-bottom: 5px;
    margin-left: 5px;
    align-items: center;
`;
const $36db6c9343738e53$export$6e2c8f0811a474ce = ({ title: title ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($36db6c9343738e53$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($36db6c9343738e53$var$Title, null, title));






const $2311f6544dcf3569$var$getBorder = $lR8r2$lodashfp.curry((propName, props)=>props[propName] ? `1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")(props)}` : "none");
const $2311f6544dcf3569$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: left;
    align-items: ${({ align: align  })=>align || "flex-start"};
    flex-direction: column;
    width: ${({ width: width  })=>width || "100%"};
    border-left: ${$2311f6544dcf3569$var$getBorder("borderLeft")};
    border-bottom: ${$2311f6544dcf3569$var$getBorder("borderBottom")};
    border-top: ${$2311f6544dcf3569$var$getBorder("borderTop")};
    border-right: ${$2311f6544dcf3569$var$getBorder("borderRight")};
    padding-top: ${({ paddingTop: paddingTop  })=>paddingTop || "2px"};
    padding-right: 2px;
    padding-bottom: 2px;
    position: relative;
    margin-left: ${$2311f6544dcf3569$var$getBorder("marginLeft")};
`;
const $2311f6544dcf3569$export$851f9125c323a8f6 = ({ children: children , ...props })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2311f6544dcf3569$var$Wrapper, props, children);


const $a2b1a029d8a33475$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $a2b1a029d8a33475$export$aac0c89bcadf6dea = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Tasks");
    const [metric, setMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const optionsMetrics = [
        {
            value: 1,
            label: "Volume"
        },
        {
            value: 2,
            label: "Avg Duration (mins)"
        },
        {
            value: 3,
            label: "Avg Duration (hrs)"
        },
        {
            value: 4,
            label: "Avg Duration (days)"
        },
        {
            value: 5,
            label: "% Compliance"
        },
        {
            value: 6,
            label: "Actual Cost"
        },
        {
            value: 7,
            label: "Forecast Cost"
        },
        {
            value: 8,
            label: "Cost Saving"
        },
        {
            value: 9,
            label: "Avg Actual Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 10,
            label: "Avg Forecast Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 11,
            label: "Avg Cost Saving per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        }, 
    ];
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setMetric(1);
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskHistory());
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " History (" + optionsMetrics[metric - 1].label + ")");
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskHistory());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTasks, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTasks, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const onMetricChange = (metricSelected)=>{
        setMetric(metricSelected);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAnalyticsTaskHistoryMetric({
            metric: metricSelected
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskHistory());
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " History (" + optionsMetrics[metricSelected - 1].label + ")");
    };
    const seriesName = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    const options = {
        chart: {
            style: {
                fontFamily: "Helvetica"
            },
            borderWidth: 2,
            borderColor: "#E0E0E0"
        },
        title: {
            text: title,
            style: {
                fontSize: "14px",
                fontWeight: "bold"
            }
        },
        plotOptions: {
            line: {
                dataGrouping: {
                    approximation: "average",
                    units: [
                        [
                            "month",
                            [
                                1
                            ]
                        ], 
                    ]
                }
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: seriesName,
                type: "spline",
                color: "#69B34C",
                data: data,
                tooltip: {
                    valueDecimals: 0
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a2b1a029d8a33475$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsMetrics,
        onChange: onMetricChange,
        value: metric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "50%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e75920b94abc1947$export$c2e30eeee87f25ff), {
        options: options,
        constructorType: "stockChart"
    }));
};












const $4818f7f3ea1cd296$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $4818f7f3ea1cd296$var$optionsAttributes = [];
const $4818f7f3ea1cd296$export$c415debe62efa829 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s by Volume");
    const [chartTypeStr, setChartTypeStr] = (0, ($parcel$interopDefault($lR8r2$react))).useState("bar");
    const [metric, setMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [attribute, setAttribute] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [chartType, setChartType] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const optionsMetrics = [
        {
            value: 1,
            label: "Volume"
        },
        {
            value: 2,
            label: "Avg Duration (mins)"
        },
        {
            value: 3,
            label: "Avg Duration (hrs)"
        },
        {
            value: 4,
            label: "Avg Duration (days)"
        },
        {
            value: 5,
            label: "% Compliance"
        },
        {
            value: 6,
            label: "Actual Cost"
        },
        {
            value: 7,
            label: "Forecast Cost"
        },
        {
            value: 8,
            label: "Cost Saving"
        },
        {
            value: 9,
            label: "Avg Actual Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 10,
            label: "Avg Forecast Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 11,
            label: "Avg Cost Saving per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        }, 
    ];
    const chartTypeOptions = [
        {
            value: 1,
            label: "Bar"
        },
        {
            value: 2,
            label: "Column"
        }, 
    ];
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setChartTypeStr("bar");
        setChartType(1);
        setMetric(1);
        taskAttributes();
        const temp = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getAnalyticsTaskAttribute();
        if (temp["attribute"] != "") setAttribute(temp["attribute"]);
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s by " + attribute + " (" + optionsMetrics[metric - 1].label + ")");
    }, []);
    const onAttributeChange = (attributeSelected)=>{
        setAttribute(attributeSelected);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAnalyticsTaskAttribute({
            attribute: attributeSelected
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskAttributes());
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s by " + attributeSelected + " (" + optionsMetrics[metric - 1].label + ")");
    };
    const onMetricChange = (metricSelected)=>{
        setMetric(metricSelected);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAnalyticsTaskAttributeMetric({
            metric: metricSelected
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskAttributes());
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s by " + attribute + " (" + optionsMetrics[metricSelected - 1].label + ")");
    };
    const onChartTypeChange = (chartTypeSelected)=>{
        setChartType(chartTypeSelected);
        if (chartTypeSelected == 1) setChartTypeStr("bar");
        if (chartTypeSelected == 2) setChartTypeStr("column");
    };
    const taskAttributes = ()=>{
        $4818f7f3ea1cd296$var$optionsAttributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        for (const each of tOptions){
            const valueToPush = {
                value: each.value,
                label: each.label
            };
            $4818f7f3ea1cd296$var$optionsAttributes.push(valueToPush);
        }
        if ($4818f7f3ea1cd296$var$optionsAttributes.length > 0) setAttribute($4818f7f3ea1cd296$var$optionsAttributes[0].value);
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskAttributes, ()=>taskAttributes());
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskAttributes());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).changeAnalyticsMode, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTasks, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).changeAnalyticsMode, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTasks, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const barColumnOptions = {
        chart: {
            //           renderTo: 'container',
            type: chartTypeStr,
            style: {
                fontFamily: "Helvetica"
            },
            borderWidth: 2,
            borderColor: "#E0E0E0"
        },
        title: {
            text: title,
            style: {
                fontSize: "14px",
                fontWeight: "bold"
            }
        },
        xAxis: {
            type: "category",
            title: {
                text: null
            },
            min: 0,
            max: Math.min(data.length - 1, 20),
            scrollbar: {
                enabled: true
            },
            tickLength: 0
        },
        tooltip: {
            formatter () {
                if (metric == 1) return $lR8r2$highcharts.numberFormat(this.y, null, null, ",");
                if (metric == 2 || metric == 3 || metric == 4) return Number(this.y.toFixed(1)).toLocaleString();
                if (metric == 5) return this.y.toFixed(1) + "%";
                if (metric == 6 || metric == 7 || metric == 8 || metric == 9 || metric == 10 || metric == 11) return "$" + Number(this.y.toFixed(0)).toLocaleString();
            }
        },
        yAxis: {
            title: {
                text: ""
            }
        },
        legend: {
            enabled: true
        },
        plotOptions: {
            series: {
                shadow: true,
                dataLabels: {
                    enabled: true,
                    formatter () {
                        if (metric == 1) return $lR8r2$highcharts.numberFormat(this.y, null, null, ",");
                        if (metric == 2 || metric == 3 || metric == 4) return Number(this.y.toFixed(1)).toLocaleString();
                        if (metric == 5) return this.y.toFixed(1) + "%";
                        if (metric == 6 || metric == 7 || metric == 8 || metric == 9 || metric == 10 || metric == 11) return "$" + Number(this.y.toFixed(0)).toLocaleString();
                    },
                    style: {
                        fontWeight: "normal"
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                type: "column",
                color: "#69B34C",
                dataSorting: {
                    enabled: true,
                    sortKey: "y"
                },
                data: data,
                name: "Task"
            }, 
        ]
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4818f7f3ea1cd296$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Group by:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $4818f7f3ea1cd296$var$optionsAttributes,
        onChange: onAttributeChange,
        value: attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsMetrics,
        onChange: onMetricChange,
        value: metric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Chart Type:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: chartTypeOptions,
        onChange: onChartTypeChange,
        value: chartType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e75920b94abc1947$export$c2e30eeee87f25ff), {
        options: barColumnOptions
    }));
};










const $3518e4d8252796ba$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $3518e4d8252796ba$export$e484fe7426599bf2 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [metric, setMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState("events");
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Events Created");
    const [label, setLabel] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Events");
    const optionsMetrics = [
        {
            value: "events",
            label: "Events"
        },
        {
            value: "perc_automation",
            label: "% Automation"
        }, 
    ];
    const onMetricChange = (metric)=>{
        setMetric(metric);
        if (metric === "events") {
            setTitle("Events Created");
            setLabel("Events");
        }
        if (metric === "perc_automation") {
            setTitle("% Events Automated");
            setLabel("% Automation");
        }
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventHistory({
            metric: metric
        }));
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setMetric("events");
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventHistory({
            metric: metric
        }));
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventHistory({
                metric: metric
            }));
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const options = {
        chart: {
            style: {
                fontFamily: "Helvetica"
            },
            borderWidth: 2,
            borderColor: "#E0E0E0"
        },
        title: {
            text: title,
            style: {
                fontSize: "14px",
                fontWeight: "bold"
            }
        },
        plotOptions: {
            line: {
                dataGrouping: {
                    approximation: "average",
                    units: [
                        [
                            "month",
                            [
                                1
                            ]
                        ], 
                    ]
                }
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        series: [
            {
                name: label,
                type: "spline",
                color: "#69B34C",
                data: data,
                tooltip: {
                    valueDecimals: 0
                }
            }, 
        ]
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3518e4d8252796ba$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsMetrics,
        onChange: onMetricChange,
        value: metric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "70%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e75920b94abc1947$export$c2e30eeee87f25ff), {
        options: options,
        constructorType: "stockChart"
    }));
};

















const $8d06d62a0b2196a7$var$StyledMaterialButton = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Button))`
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
    border-radius: 8px;
    text-transform: none;
    padding: 3px 3px;
    font-weight: 550;
    font-size: 11px;
    & span {
        text-align: center;
        text-transform: none;
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("input")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("smaller")};
        padding: 3px;
    }
    &:hover {
        border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    }
    &:disabled {
        & .MuiButton-label {
            color: #A6A6A6;
        }
        background-color: #E0E0E0;
    }
`;
const $8d06d62a0b2196a7$export$353f5b6fc5456de1 = ({ label: label , onClick: onClick = $lR8r2$lodashfp.noop , disabled: disabled  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8d06d62a0b2196a7$var$StyledMaterialButton, {
        onClick: onClick,
        disabled: disabled
    }, label);


const $e7228a1e3c18a6c7$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $e7228a1e3c18a6c7$var$attribute = "";
let $e7228a1e3c18a6c7$var$optionsAttributes = [];
const $e7228a1e3c18a6c7$var$optionsChartType = [
    {
        value: 1,
        label: "Bar"
    },
    {
        value: 2,
        label: "Column"
    }, 
];
let $e7228a1e3c18a6c7$var$chartType = 1;
const $e7228a1e3c18a6c7$export$6fcf4486b4f1f399 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [fullData, setFullData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const initialSize = 100;
    const [size, setSize] = (0, ($parcel$interopDefault($lR8r2$react))).useState(initialSize);
    const [chartTypeStr, setChartTypeStr] = (0, ($parcel$interopDefault($lR8r2$react))).useState("bar");
    const [metric, setMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState("events");
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Events Created");
    const [label, setLabel] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Events");
    const optionsMetrics = [
        {
            value: "events",
            label: "Events"
        },
        {
            value: "perc_automation",
            label: "% Automation"
        }, 
    ];
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setMetric("events");
        eventAttributes();
        const listener = ()=>{
            setFullData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventAttributes({
                metric: metric
            }));
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>eventAttributes();
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEvents, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const onAttributeChange = (attributeSelected)=>{
        $e7228a1e3c18a6c7$var$attribute = attributeSelected;
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAnalyticsEventAttribute({
            attribute: $e7228a1e3c18a6c7$var$attribute
        });
        setFullData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventAttributes({
            metric: metric
        }));
    };
    const eventAttributes = ()=>{
        $e7228a1e3c18a6c7$var$optionsAttributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
        for (const each of tOptions){
            const valueToPush = {
                value: each.value,
                label: each.label
            };
            $e7228a1e3c18a6c7$var$optionsAttributes.push(valueToPush);
        }
        if ($e7228a1e3c18a6c7$var$optionsAttributes.length > 0) $e7228a1e3c18a6c7$var$attribute = $e7228a1e3c18a6c7$var$optionsAttributes[0].value;
    };
    const onMetricChange = (metric)=>{
        setMetric(metric);
        if (metric === "events") {
            setTitle("Events Created");
            setLabel("Events");
        }
        if (metric === "perc_automation") {
            setTitle("% Events Automated");
            setLabel("% Automation");
        }
        setFullData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsEventAttributes({
            metric: metric
        }));
    };
    const onChartTypeChange = (chartTypeSelected)=>{
        $e7228a1e3c18a6c7$var$chartType = chartTypeSelected;
        if (chartTypeSelected == 1) setChartTypeStr("bar");
        if (chartTypeSelected == 2) setChartTypeStr("column");
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData($lR8r2$lodashfp.flowRight($lR8r2$lodashfp.reverse, $lR8r2$lodashfp.sortBy((obj)=>obj[1]))(fullData).slice(0, size));
    }, [
        fullData,
        size
    ]);
    const options = {
        chart: {
            //           renderTo: 'container',
            type: chartTypeStr,
            style: {
                fontFamily: "Helvetica"
            },
            borderWidth: 2,
            borderColor: "#E0E0E0"
        },
        title: {
            text: title,
            style: {
                fontSize: "14px",
                fontWeight: "bold"
            }
        },
        xAxis: {
            type: "category",
            title: {
                text: null
            },
            min: 0,
            max: Math.min(data.length - 1, 20),
            scrollbar: {
                enabled: true
            },
            tickLength: 0
        },
        yAxis: {
            title: {
                text: ""
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    formatter () {
                        if (metric == "events") return $lR8r2$highcharts.numberFormat(this.y, null, null, ",");
                        if (metric == "perc_automation") return this.y.toFixed(1) + "%";
                    },
                    style: {
                        fontWeight: "normal"
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                type: "column",
                color: "#69B34C",
                dataSorting: {
                    enabled: true,
                    sortKey: "y"
                },
                data: data,
                name: label
            }, 
        ]
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($e7228a1e3c18a6c7$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Group by:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $e7228a1e3c18a6c7$var$optionsAttributes,
        onChange: onAttributeChange,
        value: $e7228a1e3c18a6c7$var$attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsMetrics,
        onChange: onMetricChange,
        value: metric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Chart Type:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $e7228a1e3c18a6c7$var$optionsChartType,
        onChange: onChartTypeChange,
        value: $e7228a1e3c18a6c7$var$chartType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e75920b94abc1947$export$c2e30eeee87f25ff), {
        options: options
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        disabled: !fullData.length || fullData.length === size,
        label: "Show more",
        onClick: ()=>setSize(size + initialSize)
    }));
};



let $db5e9a16908bd468$export$de0e43d9dc3faac8;
(function(PerformanceAnalyticsTabs) {
    PerformanceAnalyticsTabs["taskHistoryTab"] = "Task History";
    PerformanceAnalyticsTabs["taskAttributesTab"] = "Task Attributes";
    PerformanceAnalyticsTabs["eventHistoryTab"] = "Event History";
    PerformanceAnalyticsTabs["eventAttributesTab"] = "Event Attributes";
})($db5e9a16908bd468$export$de0e43d9dc3faac8 || ($db5e9a16908bd468$export$de0e43d9dc3faac8 = {}));
const $db5e9a16908bd468$export$a5c237538a511b3d = $lR8r2$lodashfp.values($db5e9a16908bd468$export$de0e43d9dc3faac8);




const $30a74b40ae137960$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 20px;
    margin-left: 10px; 
    margin-right: 10px;
`;
const $30a74b40ae137960$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 15px;
    margin-left: -4px;
    overflow: auto;
    background-color: white
`;
const $30a74b40ae137960$var$Navigation = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: center;
`;
const $30a74b40ae137960$export$ec3c3b39c046a620 = ()=>{
    const [activeSidebarTab, setActiveSidebarTab] = (0, ($parcel$interopDefault($lR8r2$react))).useState((0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).taskHistoryTab));
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setActiveSidebarTab((0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).taskHistoryTab));
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setPerformanceAnalyticsTab, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setPerformanceAnalyticsTab, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($30a74b40ae137960$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($30a74b40ae137960$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($30a74b40ae137960$var$Navigation, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2ca8c64860b973f1$export$38a748e73493e9da), {
        onChange: setActiveSidebarTab,
        activeTab: activeSidebarTab
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).taskHistoryTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a2b1a029d8a33475$export$aac0c89bcadf6dea), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).taskAttributesTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4818f7f3ea1cd296$export$c415debe62efa829), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).eventHistoryTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3518e4d8252796ba$export$e484fe7426599bf2), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $db5e9a16908bd468$export$a5c237538a511b3d).indexOf((0, $db5e9a16908bd468$export$de0e43d9dc3faac8).eventAttributesTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e7228a1e3c18a6c7$export$6fcf4486b4f1f399), null))));
};















const $e326c77108241fab$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    margin-bottom: 5px;
    padding: 20px;
`;
const $e326c77108241fab$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , type: type  })=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const grid = (0, $lR8r2$react.useRef)(null);
    const processContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Delete",
                action: function() {
                    setProps({
                        functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteRule({
                                type: params.node.data.ruleType,
                                ruleID: params.node.data.ruleID
                            })
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/delete.png" />'
            },
            {
                name: "Edit",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).editRule({
                        type: params.node.data.ruleType,
                        ruleID: params.node.data.ruleID
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/edit.png" />'
            },
            "separator",
            {
                name: "Decompose",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/decompose.png" />'
            },
            {
                name: "Insights",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/insights.png" />'
            },
            {
                name: "Influencers",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: params.node.data.ruleType,
                        variant: 0,
                        activity: 0,
                        from: 0,
                        to: 0,
                        ruleID: params.node.data.ruleID
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({
                        source: "rule"
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/influencer.png" />'
            },
            "separator",
            "export", 
        ];
        return result;
    }, []);
    const costContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Delete",
                action: function() {
                    setProps({
                        functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteRule({
                                type: params.node.data.ruleType,
                                ruleID: params.node.data.ruleID
                            })
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/delete.png" />'
            },
            {
                name: "Edit",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).editRule({
                        type: params.node.data.ruleType,
                        ruleID: params.node.data.ruleID
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/edit.png" />'
            },
            "separator",
            "export", 
        ];
        return result;
    }, []);
    let getContextMenuItems;
    if (type === "cost") getContextMenuItems = costContextMenuItems;
    if (type === "process") getContextMenuItems = processContextMenuItems;
    const onRowDataChanged = (params)=>{
        let actualCost = 0;
        let forecastCost = 0;
        let costSavings = 0;
        params.api.forEachNode((rowNode, index)=>{
            actualCost = actualCost + rowNode.data.actualCost;
            forecastCost = forecastCost + rowNode.data.forecastCost;
            costSavings = costSavings + rowNode.data.costSavings;
        });
        let percCostSaving = (actualCost - forecastCost) / actualCost;
        const footerTotal = [];
        footerTotal.push({
            actualCost: actualCost,
            forecastCost: forecastCost,
            costSavings: costSavings,
            percCostSaving: percCostSaving,
            rule: "Totals:",
            tasks: -1,
            events: -1
        });
    //grid.current.api.setPinnedBottomRowData(footerTotal);
    };
    const [gridApi, setGridApi] = (0, $lR8r2$react.useState)(null);
    const [savestate, setSavestate] = (0, $lR8r2$react.useState)(false);
    const onGridReady = (params)=>{
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
    };
    const onSaveGridColumnState = (params)=>{
        if (savestate === true) {
            let columnState = params.columnApi.getColumnState();
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveProcessRulesGridState({
                columnState: columnState
            });
        }
        setSavestate(true);
    };
    const onFirstDataRendered = (params)=>{
        params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getProcessRulesGridState());
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setSavestate(false);
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($e326c77108241fab$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-rules",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        ref: grid,
        onFirstDataRendered: onFirstDataRendered,
        onFilterChanged: onSaveGridColumnState,
        onColumnVisible: onSaveGridColumnState,
        onColumnResized: onSaveGridColumnState,
        onSortChanged: onSaveGridColumnState,
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        masterDetail: true,
        rowSelection: "single",
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        onRowDataChanged: onRowDataChanged,
        onGridReady: onGridReady,
        getContextMenuItems: getContextMenuItems,
        domLayout: "autoHeight",
        detailRowAutoHeight: true,
        overlayNoRowsTemplate: "No rules exist",
        defaultColDef: {
            filter: true,
            resizable: true,
            sortable: true,
            wrapText: true,
            autoHeight: true,
            suppressMenu: true
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        detailCellRendererParams: {
            detailGridOptions: {
                pagination: true,
                paginationAutoPageSize: true,
                suppressRowClickSelection: true,
                headerHeight: 0,
                columnDefs: [
                    {
                        field: "header",
                        headerName: "header",
                        hide: true
                    },
                    {
                        field: "text",
                        headerName: "text"
                    }, 
                ],
                defaultColDef: {
                    flex: 1,
                    sortable: true,
                    filter: true,
                    resizable: true,
                    wrapText: true,
                    autoHeight: true
                },
                rowClassRules: {
                    "rules-header": function(params) {
                        return params.data.header === 1;
                    }
                }
            },
            getDetailRowData: (params)=>{
                params.successCallback(params.data.conditions);
            }
        },
        rowData: rows
    })));
};




const $4f93b4c114dba52f$export$936bcd5d98cb4346 = ()=>[
        {
            field: "category",
            headerName: "Category",
            resizable: true,
            wrapText: true,
            autoHeight: true,
            width: 110
        },
        {
            field: "rule",
            headerName: "Rule",
            resizable: true,
            wrapText: true,
            autoHeight: true,
            cellRenderer: "agGroupCellRenderer",
            pinnedRowCellRenderer: function(params) {
                return "<strong>" + params.data.rule + "</strong>";
            }
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agNumberColumnFilter",
            width: 70,
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$export$a2db1876938cd11d(value)
        },
        {
            field: "events",
            headerName: "Events",
            filter: "agNumberColumnFilter",
            width: 70,
            hide: true,
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$export$a2db1876938cd11d(value)
        },
        {
            field: "avgImpactDuration",
            headerName: "Avg Impact Duration",
            hide: false,
            width: 105
        },
        {
            field: "totalImpactDuration",
            headerName: "Total Impact Duration",
            hide: true,
            width: 90
        },
        {
            field: "actualCost",
            headerName: "Actual Cost",
            hide: false,
            width: 110,
            pinnedRowCellRenderer: function(params) {
                return "<strong>" + $4f93b4c114dba52f$var$formatCost({
                    cost: params.data.actualCost
                }) + "</strong>";
            },
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "forecastCost",
            headerName: "Forecast Cost",
            width: 110,
            hide: false,
            pinnedRowCellRenderer: function(params) {
                return "<strong>" + $4f93b4c114dba52f$var$formatCost({
                    cost: params.data.forecastCost
                }) + "</strong>";
            },
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "costSavings",
            headerName: "Cost Saving",
            width: 110,
            hide: false,
            pinnedRowCellRenderer: function(params) {
                return "<strong>" + $4f93b4c114dba52f$var$formatCost({
                    cost: params.data.costSavings
                }) + "</strong>";
            },
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "percCostSaving",
            headerName: "% Cost Saving",
            hide: false,
            width: 100,
            pinnedRowCellRenderer: function(params) {
                return "<strong>" + $4f93b4c114dba52f$var$formatPercentage(params.data.percCostSaving) + "</strong>";
            },
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatPercentage(value)
        },
        {
            field: "actualCostTask",
            headerName: "Task Actual Cost",
            hide: true,
            width: 110,
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "forecastCostTask",
            headerName: "Task Forecast Cost",
            hide: true,
            width: 110,
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "costSavingsTask",
            headerName: "Task Cost Saving",
            hide: true,
            width: 110,
            valueFormatter: ({ value: value  })=>$4f93b4c114dba52f$var$formatCost({
                    cost: value
                })
        },
        {
            field: "toActivity",
            headerName: "To Activity",
            hide: true
        },
        {
            field: "fromActivity",
            headerName: "From Activity",
            hide: true
        },
        {
            field: "ruleID",
            headerName: "ID",
            hide: true,
            suppressToolPanel: true
        },
        {
            field: "ruleType",
            headerName: "ruleType",
            hide: true,
            suppressToolPanel: true
        }, 
    ];
function $4f93b4c114dba52f$export$a2db1876938cd11d(x) {
    if (x === -1) return "";
    return Number(x).toLocaleString();
}
function $4f93b4c114dba52f$var$formatPercentage(value) {
    if (value === null) return "";
    if (value != -1) {
        let retVal = (value * 100).toFixed(0) + "%";
        if (retVal === "NaN%") retVal = "";
        return retVal;
    } else return "";
}
function $4f93b4c114dba52f$var$formatCost(cost) {
    if (cost.cost === null) return "";
    if (cost.cost != -1) return "$" + Number(cost.cost.toFixed(0)).toLocaleString();
    else return "";
}


const $ea33983d46ba6df0$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $ea33983d46ba6df0$export$9ea6f6a25ada844 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processRulesSummary());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processRulesSummary());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updatePerformance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updatePerformance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ea33983d46ba6df0$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e326c77108241fab$export$c8dd51eb24f71762), {
        rows: rows,
        type: "process",
        columns: (0, $4f93b4c114dba52f$export$936bcd5d98cb4346)()
    }));
};













$lR8r2$highchartsmoduleshistogrambellcurve((0, ($parcel$interopDefault($lR8r2$highcharts))));

$lR8r2$highchartsmodulesnodatatodisplay((0, ($parcel$interopDefault($lR8r2$highcharts))));
const $967d36c815d52417$var$GraphWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: auto;
 `;
const $967d36c815d52417$var$Graph = (props)=>{
    const chartComponent = (0, $lR8r2$react.useRef)(null);
    const chartOptions = {
        chart: {
            type: "bar",
            style: {
                fontFamily: "Helvetica"
            },
            borderWidth: 2,
            borderColor: "#E0E0E0"
        },
        title: {
            text: props.title,
            style: {
                fontSize: "14px",
                fontWeight: "bold"
            }
        },
        credits: {
            enabled: false
        },
        lang: {
            noData: "Please select a source for the lifecycle data"
        },
        legend: {
            reversed: false,
            enabled: true,
            layout: "vertical",
            align: "right",
            verticalAlign: "middle"
        },
        xAxis: {
            categories: props.categoryData,
            labels: {
                style: {
                    fontSize: "12px"
                }
            },
            scrollbar: {
                enabled: true
            }
        },
        tooltip: {
            formatter () {
                let toolTip = this.x + "<br/>Activity: " + this.series.name;
                if (props.graphType === 1 && props.stepMetric === 0) toolTip = toolTip + "<br/>Duration: " + Number(this.y.toFixed(2)).toLocaleString() + " mins";
                if (props.graphType === 1 && props.stepMetric === 1) toolTip = toolTip + "<br/>Duration: " + Number(this.y.toFixed(2)).toLocaleString() + " hrs";
                if (props.graphType === 1 && props.stepMetric === 2) toolTip = toolTip + "<br/>Duration: " + Number(this.y.toFixed(2)).toLocaleString() + " days";
                if (props.graphType === 1 && (props.stepMetric === 3 || props.stepMetric === 4 || props.stepMetric === 5)) toolTip = toolTip + "<br/>Cost: " + "$" + Number(this.y.toFixed(0)).toLocaleString();
                if (props.graphType === 1 && props.stepMetric === 6) toolTip = toolTip + "<br/>% Compliant: " + this.y.toFixed(decimals) + "%";
                return toolTip;
            }
        },
        yAxis: {
            visible: props.showYAxis,
            title: {
                text: props.yAxisTitle
            }
        },
        plotOptions: {
            series: {
                stacking: "normal"
            }
        },
        series: props.seriesData
    };
    if (chartComponent.current) chartComponent.current.chart.redraw();
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($967d36c815d52417$var$GraphWrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e75920b94abc1947$export$c2e30eeee87f25ff), {
        options: chartOptions
    }));
};
var $967d36c815d52417$export$2e2bcd8739ae039 = $967d36c815d52417$var$Graph;




const $de2148164ca4f843$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 20px;
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white
`;
const $de2148164ca4f843$var$Options = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-top: 15px;
    padding-left: 30px; 
    display: flex;
    justify-content: center;
`;
function $de2148164ca4f843$export$13ad114172d90ee5() {
    const optionsStepMetric = [
        {
            value: 0,
            label: "Avg Duration (mins)"
        },
        {
            value: 1,
            label: "Avg Duration (hrs)"
        },
        {
            value: 2,
            label: "Avg Duration (days)"
        },
        {
            value: 3,
            label: "Actual Cost"
        },
        {
            value: 4,
            label: "Forecast Cost"
        },
        {
            value: 5,
            label: "Cost Saving"
        },
        {
            value: 6,
            label: "Avg Actual Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 7,
            label: "Avg Forecast Cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 8,
            label: "Avg Cost Saving per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()
        },
        {
            value: 9,
            label: "% Compliance"
        }, 
    ];
    const optionsGraphType = [
        {
            value: 1,
            label: "Metric"
        },
        {
            value: 2,
            label: "Fixed"
        }, 
    ];
    const [graphType, setGraphType] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [stepMetric, setStepMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [seriesData, setSeriesData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [categoryData, setCategoryData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [showYAxis, setShowYAxis] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [yAxisTitle, setyAxisTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState(optionsStepMetric[1].label);
    const onChangeGraphType = (value)=>{
        setGraphType(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantsVisualizationGraphType({
            type: value
        });
        if (value === 2) setShowYAxis(false);
        else setShowYAxis(true);
        updateGraph();
    };
    const onChangeStepMetric = (value)=>{
        setStepMetric(value);
        setyAxisTitle(optionsStepMetric[value].label);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantsVisualizationMetric({
            metric: value
        });
        updateGraph();
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            updateGraph();
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantLifecycle, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantLifecycle, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setGraphType(1);
        setStepMetric(1);
        setyAxisTitle(optionsStepMetric[1].label);
        setShowYAxis(true);
        updateGraph();
    }, []);
    function updateGraph() {
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).variantsVisualization();
        let tSeriesData = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramSeries().sort((a, b)=>b.sort - a.sort);
        let tCategoryData = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramCategory().sort();
        setCategoryData(tCategoryData);
        setSeriesData(tSeriesData);
        setTitle("Variant Lifecycle");
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($de2148164ca4f843$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($de2148164ca4f843$var$Options, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Width:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsGraphType,
        onChange: onChangeGraphType,
        value: graphType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsStepMetric,
        onChange: onChangeStepMetric,
        value: stepMetric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $967d36c815d52417$export$2e2bcd8739ae039), {
        title: title,
        categoryData: categoryData,
        graphType: graphType,
        stepMetric: stepMetric,
        showYAxis: showYAxis,
        yAxisTitle: yAxisTitle,
        seriesData: seriesData
    }));
}











const $c6f6283d55407ae5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 20px;
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white
`;
const $c6f6283d55407ae5$var$Options = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-top: 15px;
    padding-left: 30px; 
    display: flex;
    justify-content: center;
`;
function $c6f6283d55407ae5$export$89bf9f99c3e6549d() {
    const optionsStepMetric = [
        {
            value: 0,
            label: "Avg Duration (mins)"
        },
        {
            value: 1,
            label: "Avg Duration (hrs)"
        },
        {
            value: 2,
            label: "Avg Duration (days)"
        },
        {
            value: 3,
            label: "Actual Cost"
        },
        {
            value: 4,
            label: "Forecast Cost"
        },
        {
            value: 5,
            label: "Cost Saving"
        },
        {
            value: 6,
            label: "% Compliance"
        }, 
    ];
    const optionsGraphType = [
        {
            value: 1,
            label: "Metric"
        },
        {
            value: 2,
            label: "Fixed"
        }, 
    ];
    const optionsSort = [
        {
            value: 0,
            label: "Desc"
        },
        {
            value: 1,
            label: "Asc"
        },
        {
            value: 2,
            label: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " #"
        }, 
    ];
    const optionsFilterMetric = [
        {
            value: 0,
            label: "Duration"
        },
        {
            value: 1,
            label: "Actual Cost"
        },
        {
            value: 2,
            label: "Forecast Cost"
        },
        {
            value: 3,
            label: "Cost Saving"
        }, 
    ];
    const [graphType, setGraphType] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [stepMetric, setStepMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [seriesData, setSeriesData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [categoryData, setCategoryData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [showYAxis, setShowYAxis] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [title, setTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [yAxisTitle, setyAxisTitle] = (0, ($parcel$interopDefault($lR8r2$react))).useState(optionsStepMetric[1].label);
    const onChangeGraphType = (value)=>{
        setGraphType(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationGraphType({
            type: value
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
        if (value === 2) setShowYAxis(false);
        else setShowYAxis(true);
        updateGraph();
    };
    const onChangeStepMetric = (value)=>{
        setStepMetric(value);
        setyAxisTitle(optionsStepMetric[value].label);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationMetric({
            metric: value
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
        updateGraph();
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            updateGraph();
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskLifeCycle, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskLifeCycle, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setGraphType(1);
        setStepMetric(1);
        setyAxisTitle(optionsStepMetric[1].label);
        setShowYAxis(true);
        updateGraph();
    }, []);
    function updateGraph() {
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
        let tSeriesData = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramSeries().sort((a, b)=>b.sort - a.sort);
        let tCategoryData = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramCategory().sort();
        setCategoryData(tCategoryData);
        setSeriesData(tSeriesData);
        setTitle((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Lifecycle");
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c6f6283d55407ae5$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c6f6283d55407ae5$var$Options, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Width:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsGraphType,
        onChange: onChangeGraphType,
        value: graphType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Metric:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: optionsStepMetric,
        onChange: onChangeStepMetric,
        value: stepMetric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $967d36c815d52417$export$2e2bcd8739ae039), {
        title: title,
        categoryData: categoryData,
        graphType: graphType,
        stepMetric: stepMetric,
        showYAxis: showYAxis,
        yAxisTitle: yAxisTitle,
        seriesData: seriesData
    }));
}











$lR8r2$highchartsmoduleshistogrambellcurve((0, ($parcel$interopDefault($lR8r2$highcharts))));
const $6b3ac85d702b32d5$var$Graph = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-top: 10px;
    padding-left: 10px;
    padding-right: 10px;
    overflow: auto;
`;
const $6b3ac85d702b32d5$var$Chart = (props)=>{
    let chartComponentRef = (0, $lR8r2$react.useRef)();
    let axisTitle = props.axisTitle;
    let numItems = props.chartData.length;
    let chartOptions = {
        chart: {
            alignTicks: false
        },
        title: {
            text: ""
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        xAxis: [
            {
                title: {
                    text: ""
                },
                opposite: true,
                alignTicks: false,
                visible: false
            },
            {
                title: {
                    text: axisTitle
                },
                alignTicks: false,
                opposite: false
            },
            {
                linkedTo: 1,
                visible: false
            }
        ],
        yAxis: [
            {
                title: {
                    text: ""
                },
                opposite: true,
                visible: false
            },
            {
                title: {
                    text: "% Total"
                },
                endOnTick: false,
                opposite: false,
                labels: {
                    formatter: function() {
                        var number = this.value / numItems * 100;
                        return (0, ($parcel$interopDefault($lR8r2$highcharts))).numberFormat(number, 1) + "%";
                    }
                }
            }
        ],
        lang: {
            noData: "Please select a source for the histogram data"
        },
        series: [
            {
                name: "Histogram",
                type: "histogram",
                id: "h1",
                xAxis: 1,
                yAxis: 1,
                baseSeries: "s1",
                zIndex: -1,
                tooltip: {
                    pointFormatter: function() {
                        var number = this.y / numItems * 100;
                        return (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramType() + ": <b>" + this.y + "</b><br/>% Total: <b>" + (0, ($parcel$interopDefault($lR8r2$highcharts))).numberFormat(number, 1) + " %</b><br/>Range: <b>" + (0, ($parcel$interopDefault($lR8r2$highcharts))).numberFormat(this.x, 2) + " - " + (0, ($parcel$interopDefault($lR8r2$highcharts))).numberFormat(this.x2, 2) + " </b>";
                    }
                }
            },
            {
                name: "Data",
                type: "scatter",
                data: props.chartData,
                id: "s1",
                enableMouseTracking: false,
                marker: {
                    radius: 0
                }
            }
        ]
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($6b3ac85d702b32d5$var$Graph, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$highchartsreactofficial))), {
        highcharts: (0, ($parcel$interopDefault($lR8r2$highcharts))),
        options: chartOptions,
        ref: chartComponentRef,
        oneToOne: true,
        containerProps: {
            style: {
                height: "calc(100vh - 240px)",
                width: "100%"
            }
        }
    }));
};
var $6b3ac85d702b32d5$export$2e2bcd8739ae039 = $6b3ac85d702b32d5$var$Chart;








const $87251fa764e5789f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 20px;
    margin-left: 10px; 
    margin-right: 10px;
    background-color: white
`;
const $87251fa764e5789f$var$Options = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-top: 15px;
    padding-left: 30px; 
    display: flex;
    justify-content: center;
`;
const $87251fa764e5789f$export$8166dc6475613235 = (props)=>{
    const [duration, setDuration] = (0, ($parcel$interopDefault($lR8r2$react))).useState("hrs");
    let data = deriveHistogramArray((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramArray(), duration);
    let description = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramDescription().replace("^^^", duration);
    let totalDesc = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramTotal();
    function handleChange(e) {
        setDuration(e.target.value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeDurationLabel({
            duration: e.target.value
        });
        data = deriveHistogramArray((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramArray(), e.target.value);
        description = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramDescription().replace("^^^", e.target.value);
    }
    (0, $lR8r2$react.useEffect)(()=>{
        const listener = ()=>{
            data = deriveHistogramArray((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramArray(), duration);
            description = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramDescription().replace("^^^", duration);
            totalDesc = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramTotal();
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on(Event.updateHistogram, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off(Event.updateHistogram, listener);
        };
    }, []);
    //based on this.state.duration,
    function deriveHistogramArray(array, duration) {
        let tempArray = [];
        for(let i = 0; i < array.length; i++){
            if (duration === "secs") tempArray.push(array[i].secs);
            if (duration === "mins") tempArray.push(array[i].mins);
            if (duration === "hrs") tempArray.push(array[i].hrs);
            if (duration === "days") tempArray.push(array[i].days);
        }
        return tempArray;
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($87251fa764e5789f$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($87251fa764e5789f$var$Options, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "85%",
        align: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            paddingTop: 1,
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            paddingTop: 1,
            fontFamily: "Helvetica"
        },
        component: "div"
    }, totalDesc)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "15%"
    }, data.length > 0 ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControl))), {
        sx: {
            m: 1,
            minWidth: 100
        },
        size: "small"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreSelect))), {
        id: "demo-select-small",
        value: duration,
        sx: {
            fontSize: "12px"
        },
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
        sx: {
            fontSize: "12px"
        },
        value: "secs"
    }, "secs"), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
        sx: {
            fontSize: "12px"
        },
        value: "mins"
    }, "mins"), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
        sx: {
            fontSize: "12px"
        },
        value: "hrs"
    }, "hrs"), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreMenuItem))), {
        sx: {
            fontSize: "12px"
        },
        value: "days"
    }, "days"))) : "")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6b3ac85d702b32d5$export$2e2bcd8739ae039), {
        chartData: data,
        axisTitle: "Duration (" + duration + ")"
    })));
};


const $bf849ab6e916ed21$var$Diagram = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    background-color: ${({ color: color  })=>color};
    width: auto;
    height: 100%;
    border: hidden;
    display: ${({ visible: visible  })=>visible ? "block" : "none"};    
    canvas {
        outline: 0 none !important; 
        -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    };
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("diagram")};
`;
const $bf849ab6e916ed21$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $bf849ab6e916ed21$var$Grid = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-rows: ${({ height: height  })=>height} 1fr;
`;
const $bf849ab6e916ed21$var$TopWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 1 / 3 ;
    grid-column: 1 / 1;
    background-color: ${({ color: color  })=>color};
`;
const $bf849ab6e916ed21$var$BottomWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-row: 2 / 3 ;
    grid-column: 1 / 1;
`;
const $bf849ab6e916ed21$export$5b6cb3855aed9ca7 = ({ visible: visible , action: action  })=>{
    const [component, setComponent] = (0, ($parcel$interopDefault($lR8r2$react))).useState("PV");
    const [histogramCtr, setHistogramCtr] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    const [topWrapperHeight, setTopWrapperHeight] = (0, ($parcel$interopDefault($lR8r2$react))).useState("0px");
    const [visiblePV, setVisiblePV] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [visibleDT, setVisibleDT] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleIS, setVisibleIS] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleIA, setVisibleIA] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visiblePerformanceAnalytics, setVisiblePerformanceAnalytics] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleCostRules, setVisibleCostRules] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleProcessRules, setVisibleProcessRules] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleVariantLifeCycle, setVisibleVariantLifeCycle] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleTaskLifeCycle, setVisibleTaskLifeCycle] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [visibleHistogram, setVisibleHistogram] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [VisualizerBackground, setVisualizerBackground] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setVisualizerBackground((0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)());
        const { diagram: diagram  } = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).init();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagram(diagram);
        setVisiblePV(true);
    /*
        const { diagram, zoomSlider } = apiProvider.init();
        apiProvider.setDiagram(diagram);
        return () => zoomSlider.remove();
*/ }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setVisualizerBackground((0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor, listener);
        };
    }, []);
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessVisualizer, ()=>{
        setTopWrapperHeight("0");
        setVisiblePV(true);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("PV");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_DecompositionTree, ()=>{
        setTopWrapperHeight("135px");
        setVisiblePV(false);
        setVisibleDT(true);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("DT");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Insights, ()=>{
        setTopWrapperHeight("135px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(true);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("IS");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_InfluenceAnalysis, ()=>{
        setTopWrapperHeight("135px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(true);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("IA");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessRules, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(true);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("ProcessRules");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_VariantLifeCycle, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(true);
        setVisibleTaskLifeCycle(false);
        setComponent("VariantLifeCycle");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Histogram, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(true);
        setHistogramCtr(histogramCtr + 1);
        setComponent("Histogram");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_TaskLifeCycle, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(true);
        setVisibleHistogram(false);
        setComponent("TaskLifeCycle");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_PerformanceAnalytics, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(true);
        setVisibleCostRules(false);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("PerformanceAnalytics");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_CostRules, ()=>{
        setTopWrapperHeight("0px");
        setVisiblePV(false);
        setVisibleDT(false);
        setVisibleIS(false);
        setVisibleIA(false);
        setVisiblePerformanceAnalytics(false);
        setVisibleCostRules(true);
        setVisibleProcessRules(false);
        setVisibleVariantLifeCycle(false);
        setVisibleTaskLifeCycle(false);
        setVisibleHistogram(false);
        setComponent("CostRules");
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Grid, {
        height: topWrapperHeight
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$TopWrapper, {
        color: VisualizerBackground
    }, component === "DT" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8fabba464b7a998b$export$34c40c9f58844e01), null), component === "IS" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ca0209cf56bb55d6$export$9c79a7affb242496), null), component === "IA" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8f21c138fe0b1154$export$ef3558726c249ee), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$BottomWrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Diagram, {
        id: "gDiagramDivPV",
        color: VisualizerBackground,
        visible: visiblePV
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Diagram, {
        id: "gDiagramDivDT",
        color: VisualizerBackground,
        visible: visibleDT
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Diagram, {
        id: "gDiagramDivIS",
        color: VisualizerBackground,
        visible: visibleIS
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf849ab6e916ed21$var$Diagram, {
        id: "gDiagramDivIA",
        color: VisualizerBackground,
        visible: visibleIA
    }), component === "ProcessRules" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ea33983d46ba6df0$export$9ea6f6a25ada844), null), component === "CostRules" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65410ffa5b76053c$export$b201652d403c08e3), null), component === "PerformanceAnalytics" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $30a74b40ae137960$export$ec3c3b39c046a620), {
        width: 100
    }), component === "VariantLifeCycle" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $de2148164ca4f843$export$13ad114172d90ee5), null), component === "TaskLifeCycle" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c6f6283d55407ae5$export$89bf9f99c3e6549d), null), component === "Histogram" && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $87251fa764e5789f$export$8166dc6475613235), {
        renderCtr: histogramCtr
    }))));
};















const $1425a2da6c58fa32$export$a61a941c0d68dcb1 = {
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab]: "Variants",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).slicersTab]: "Slicers",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).filtersTab]: "Filters",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).detailTab]: "Detail",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).modelTab]: "Model",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).eventLogTab]: "Events",
    [(0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).settingsTab]: "Settings"
};


const $db5e95fcac547b08$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    position: relative;
    transform: translateX(${({ isActive: isActive  })=>isActive ? 0 : -4}px);
    padding: 9px 12px 9px ${({ isActive: isActive  })=>isActive ? 12 : 16}px;
    z-index: ${({ isActive: isActive  })=>(0, $d18c0fc16613166e$export$9b544f58430fc883)(isActive ? "activeTab" : "tab")};
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    cursor: pointer;
    transition: .2s;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("tab")};
    width: ${(0, $d18c0fc16613166e$export$3c49c185de0c2bfc)("tab")}px;
    visibility: ${({ visible: visible  })=>visible ? "visible" : "hidden"};
    &:last-child {
        border-bottom-right-radius: 10px;
    }

    &:hover {
        transform: translateX(0);
        z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("activeTab")};
    }
`;
const $db5e95fcac547b08$var$Text = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).span`
    writing-mode: vertical-lr;
    font-size: 13px;
    font-weight: bold;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")}
`;
const $db5e95fcac547b08$export$3e41faf802a29e71 = ({ tab: tab , activeTab: activeTab , visible: visible , onClick: onClick  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($db5e95fcac547b08$var$Wrapper, {
        onClick: ()=>onClick(tab),
        isActive: activeTab === tab,
        visible: visible
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($db5e95fcac547b08$var$Text, null, (0, $1425a2da6c58fa32$export$a61a941c0d68dcb1)[tab].toUpperCase()));



const $48013a1ebe627584$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    position: absolute;
    transform-origin: top right;
    display: flex;
    flex-direction: column;
    right: 0;
`;
const $48013a1ebe627584$export$b2539bed5023c21c = ({ activeTab: activeTab , onChange: onChange , initialLoad: initialLoad , showDetail: showDetail  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($48013a1ebe627584$var$Wrapper, null, initialLoad ? "" : $lR8r2$lodashfp.map((tab)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $db5e95fcac547b08$export$3e41faf802a29e71), {
            key: tab,
            onClick: onChange,
            tab: tab,
            visible: true,
            activeTab: activeTab
        }))((0, $f199f4f4b1b09c24$export$f2701d7fe1f1d354)));









const $1cf61241b06f2a39$var$CheckboxComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Checkbox))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
    margin-top: -2px;

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $1cf61241b06f2a39$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.FormControlLabel))`
    margin-right: 15px;
    margin-left: 0px;
    margin-top: 5px;

    & .css-1jwbes-MuiButtonBase-root-MuiCheckbox-root {
        padding:3px;
    }


    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $1cf61241b06f2a39$export$48513f6b9f8ce62d = ({ label: label , checked: checked , handleOnChange: handleOnChange , indeterminate: indeterminate = false ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1cf61241b06f2a39$var$StyledFormControlLabel, {
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1cf61241b06f2a39$var$CheckboxComponent, {
            color: "default",
            checked: checked,
            onChange: handleOnChange,
            indeterminate: indeterminate
        }),
        label: label
    });


const $e17399a075c78f8d$export$b8db7ef5daf95498 = ({ checked: checked , indeterminate: indeterminate  })=>{
    if (!checked && indeterminate) return {
        checked: true,
        indeterminate: false
    };
    if (checked && !indeterminate) return {
        checked: false,
        indeterminate: false
    };
    return {
        checked: false,
        indeterminate: true
    };
};


const $92c71181f5ddd1f0$export$811609789330a031 = ({ label: label , update: update  })=>{
    const [checked, setChecked] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [indeterminate, setIndeterminate] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const handleOnChange = ()=>{
        const { checked: newChecked , indeterminate: newIndeterminate ,  } = (0, $e17399a075c78f8d$export$b8db7ef5daf95498)({
            checked: checked,
            indeterminate: indeterminate
        });
        setChecked(newChecked);
        setIndeterminate(newIndeterminate);
        update({
            readOnly: false,
            checked: checked,
            indeterminate: indeterminate
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: label,
        checked: checked,
        indeterminate: indeterminate,
        handleOnChange: handleOnChange
    });
};











const $47cd9fcb6d803cf0$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $47cd9fcb6d803cf0$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height ,  })=>{
    const grid = (0, $lR8r2$react.useRef)(null);
    const onRowClicked = (params)=>{
        if (params.api.getSelectedRows().length > 50) (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "A maximum of 50 variants can be selected",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "variant_slicer"
        });
        else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantSlicerSelectedData({
            selection: params.api.getSelectedRows()
        });
    };
    const onFirstDataRendered = (params)=>{
        params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getVariantSlicerGridState());
        params.api.forEachNode((rowNode, index)=>{
            if (rowNode.data.selected == 1) rowNode.setSelected(true);
            else rowNode.setSelected(false);
        });
        if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getInitialLoad() === true) (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantSlicerSelectedData({
            selection: params.api.getSelectedRows()
        });
    };
    const onDragStopped = (params)=>{
        if (params.api.getCellRanges().length === 0) return;
        if (params.api.getCellRanges()[0].startRow.rowIndex - params.api.getCellRanges()[0].endRow.rowIndex > 50 || params.api.getCellRanges()[0].endRow.rowIndex - params.api.getCellRanges()[0].startRow.rowIndex > 50) (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "A maximum of 50 variants can be selected",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "variant_slicer"
        });
        else {
            const draggedRange = params.api.getCellRanges();
            if (draggedRange.length > 0) {
                params.api.forEachNode((rowNode, index)=>{
                    rowNode.setSelected(false);
                });
                params.api.forEachNode((rowNode, index)=>{
                    for(let i = 0; i < draggedRange.length; i++)if (rowNode.rowIndex != null) {
                        if (draggedRange[i].endRow.rowIndex >= draggedRange[i].startRow.rowIndex) {
                            if (rowNode.rowIndex >= draggedRange[i].startRow.rowIndex && rowNode.rowIndex <= draggedRange[i].endRow.rowIndex) rowNode.setSelected(true);
                        }
                        if (draggedRange[i].endRow.rowIndex < draggedRange[i].startRow.rowIndex) {
                            if (rowNode.rowIndex <= draggedRange[i].startRow.rowIndex && rowNode.rowIndex >= draggedRange[i].endRow.rowIndex) rowNode.setSelected(true);
                        }
                    }
                });
                (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantSlicerSelectedData({
                    selection: params.api.getSelectedRows()
                });
            }
        }
    };
    const onRowDataChanged = (params)=>{
        if (params.api.getDisplayedRowAtIndex(0)) {
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "sequence",
                        sort: "asc"
                    },
                    {
                        colId: "tasks",
                        sort: "desc"
                    }
                ]
            });
            params.api.forEachNode((rowNode, index)=>{
                if (rowNode.data.selected === 1) rowNode.setSelected(true);
                else rowNode.setSelected(false);
            });
        }
    };
    const onSaveGridColumnState = (params)=>{
        let columnState = params.columnApi.getColumnState();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveVariantSlicerGridState({
            columnState: columnState
        });
    };
    const getContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Analyze",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/AnalyticsIcon.png" />',
                subMenu: [
                    {
                        // custom item
                        name: "Decompose",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "variant",
                                variant: params.node.data.variant_id,
                                activity: 0,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({
                                source: "variant"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/decompose.png" />'
                    },
                    {
                        // custom item
                        name: "Insights",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "variant",
                                variant: params.node.data.variant_id,
                                activity: 0,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({
                                source: "variant"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/insights.png" />'
                    },
                    {
                        // custom item
                        name: "Influencers",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "variant",
                                variant: params.node.data.variant_id,
                                activity: 0,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({
                                source: "variant"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/influencer.png" />'
                    }, 
                ]
            },
            {
                name: "Histogram",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/HistogramIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "variant-tasks",
                                variant: params.node.data.variant_id,
                                activity: 0,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "variant-events",
                                variant: params.node.data.variant_id,
                                activity: 0,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    }, 
                ]
            },
            {
                name: "Detail",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/DetailIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantDetailProps({
                                variant: params.node.data.variant_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setVariantDetailProps({
                                variant: params.node.data.variant_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateEventDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    }, 
                ]
            },
            {
                name: "Task LifeCycle",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: "variant",
                        variant: params.node.data.variant_id,
                        activity: 0,
                        from: 0,
                        to: 0
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationSource({
                        source: "variant"
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
                    if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActiveAction() === "task_lifecycle") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
                    else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskLifecycleIcon.png" />'
            },
            "separator",
            "export",
            "resetColumns", 
        ];
        return result;
    }, []);
    const getRowHeight = ()=>25;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($47cd9fcb6d803cf0$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        rowSelection: "multiple",
        onFirstDataRendered: onFirstDataRendered,
        onRowClicked: onRowClicked,
        onDragStopped: onDragStopped,
        onRowDataChanged: onRowDataChanged,
        getRowHeight: getRowHeight,
        getContextMenuItems: getContextMenuItems,
        onFilterChanged: onSaveGridColumnState,
        onColumnVisible: onSaveGridColumnState,
        onColumnResized: onSaveGridColumnState,
        onSortChanged: onSaveGridColumnState,
        ref: grid,
        columnDefs: columns,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        enableCharts: true,
        chartThemes: [
            "ag-solar",
            "ag-pastel",
            "ag-material-dark",
            "ag-vivid-dark", 
        ],
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        animateRows: true,
        rowData: rows,
        enableRangeSelection: true,
        suppressPropertyNamesCheck: true
    })));
};



const $eca5fb98277efc84$export$4c9cb0702b229ee9 = ()=>[
        {
            field: "sequence",
            headerName: "ID",
            width: 75,
            sort: "asc",
            suppressMenu: true
        },
        {
            field: "variant",
            headerName: "Variant",
            hide: true,
            suppressMenu: true
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            width: 95,
            filter: "agNumberColumnFilter",
            sort: "desc",
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "events",
            headerName: "Events",
            width: 90,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true
        },
        {
            field: "steps",
            headerName: "Steps",
            width: 90,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true
        },
        {
            field: "perc_total_tasks",
            headerName: "% Total Tasks",
            width: 95,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "avg_duration",
            headerName: "Avg Duration",
            width: 95,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: false
        },
        {
            field: "std_deviation",
            headerName: "Std Deviation",
            width: 95,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: false
        },
        {
            field: "loop",
            headerName: "Loops",
            width: 80,
            suppressMenu: true,
            cellRenderer: "tableIcon",
            hide: false
        },
        {
            field: "min_duration",
            headerName: "Min Duration",
            width: 100,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "max_duration",
            headerName: "Max Duration",
            width: 100,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "compliant",
            headerName: "Compliant",
            width: 95,
            suppressMenu: true,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "automated",
            headerName: "Automated",
            width: 95,
            suppressMenu: true,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "task_actual_cost",
            headerName: "Avg Actual Cost",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "task_forecast_cost",
            headerName: "Avg forecast Cost",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "task_cost_savings",
            headerName: "Avg Cost Savings",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "variant_actual_cost",
            headerName: "Actual Cost",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "variant_forecast_cost",
            headerName: "Forecast Cost",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "variant_cost_savings",
            headerName: "Cost Savings",
            width: 110,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "perc_total_events",
            headerName: "% Total Events",
            width: 115,
            suppressMenu: true,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true
        },
        {
            field: "avg_duration_days",
            headerName: "Avg Duration (days)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "std_deviation_days",
            headerName: "Std Deviation (days)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "avg_duration_hrs",
            headerName: "Avg Duration (hours)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "std_deviation_hrs",
            headerName: "Std Deviation (hours)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "variant_id",
            headerName: "ID",
            hide: true,
            suppressMenu: true
        },
        {
            field: "selected",
            headerName: "Selected",
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_tasks_compliant",
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Compliant",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_tasks_automated",
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Automated",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_events_compliant",
            headerName: "% Events Compliant",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_events_automated",
            headerName: "% Events Automated",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "events_compliant",
            headerName: "Events Compliant",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "tasks_compliant",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Compliant",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "events_automated",
            headerName: "Events Automated",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "tasks_automated",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Automated",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        }, 
    ];



const $eceec5d0773825e1$export$2c45b5af39eaa979 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        // need to retain the state
        //if (apiProvider.initialLoad() === true) {
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).variantsTable({}));
    //}
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).variantsTable({}));
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicerContext, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDurationColumns, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicerContext, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDurationColumns, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $47cd9fcb6d803cf0$export$c8dd51eb24f71762), {
        rows: rows,
        columns: (0, $eca5fb98277efc84$export$4c9cb0702b229ee9)(),
        height: "347px"
    });
};











const $214aba81455ac9eb$export$84712d0562a614b8 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    text-align: center;
    height: 100%;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("input")};
    line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
`;









$lR8r2$highchartsmodulesexporting($lR8r2$highchartshighstock);

$lR8r2$highchartsmodulesexportdata($lR8r2$highchartshighstock);
const $72771489cf9f6777$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $72771489cf9f6777$export$c2e30eeee87f25ff = ({ ...props })=>{
    const wrapperRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const [width, setWidth] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const updateWidth = ()=>{
        setWidth(wrapperRef.current?.getBoundingClientRect().width || 0);
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).resizeSidebar, updateWidth);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (wrapperRef.current) updateWidth();
    }, [
        wrapperRef
    ]);
    const getSeriesLength = (singleSeries)=>"data" in singleSeries ? singleSeries.data.length : 0;
    const series = props.options.series.map((singleSeries)=>({
            ...singleSeries,
            turboThreshold: getSeriesLength(singleSeries)
        }));
    const chartKey = `${width}@${series.map(getSeriesLength).join("@")}`;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($72771489cf9f6777$var$Wrapper, {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$highchartsreactofficial))), {
        key: chartKey,
        ...props,
        options: {
            ...props.options,
            series: series
        },
        highcharts: $lR8r2$highchartshighstock,
        containerProps: {
            style: {
                width: "100%"
            }
        }
    }));
};


const $b85537fc6abd5d2f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`;
const $b85537fc6abd5d2f$export$a6a10dd922582f86 = /*#__PURE__*/ $lR8r2$react.memo(()=>{
    const [data, setData] = $lR8r2$react.useState([]);
    $lR8r2$react.useEffect(()=>{
        const applySlicerListener = ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateVariantSlicerVariantChart({});
        const listener = (props)=>{
            const temp = [];
            for(let i = 0; i < props.length; i++){
                const valueToPush = {};
                valueToPush["name"] = props[i].s;
                valueToPush["y"] = props[i].t;
                valueToPush["variant"] = props[i].n;
                temp.push(valueToPush);
            }
            setData(temp);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantSlicerVariantChart, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessVisualizer, applySlicerListener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, applySlicerListener);
        setTimeout(()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateVariantSlicerVariantChart({}));
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantSlicerVariantChart, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessVisualizer, applySlicerListener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, applySlicerListener);
        };
    }, []);
    const options = {
        chart: {
            height: 300,
            type: "bar",
            style: {
                fontFamily: "Helvetica"
            }
        },
        title: {
            text: ""
        },
        exporting: {
            enabled: false
        },
        xAxis: {
            type: "category",
            title: {
                text: null
            },
            min: 0,
            max: Math.min(data.length - 1, 9),
            scrollbar: {
                enabled: true
            },
            tickLength: 0
        },
        tooltip: {
            pointFormat: "{point.variant}"
        },
        yAxis: {
            title: {
                text: ""
            }
        },
        legend: {
            enabled: false
        },
        plotOptions: {
            series: {
                shadow: true,
                dataLabels: {
                    enabled: true,
                    formatter () {
                        return $lR8r2$highcharts.numberFormat(this.y, null, null, ",");
                    },
                    style: {
                        fontWeight: "normal"
                    }
                }
            }
        },
        credits: {
            enabled: false
        },
        series: [
            {
                type: "column",
                color: "#187bcd",
                pointWidth: 18,
                dataSorting: {
                    enabled: true,
                    sortKey: "s"
                },
                data: data,
                name: "Variant",
                cursor: "pointer",
                point: {
                    events: {
                        click: function() {
                            const variant = parseInt(this.name);
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).selectVariant({
                                pane: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab,
                                variant: variant
                            });
                        }
                    }
                }
            }, 
        ]
    };
    if ($lR8r2$lodashfp.isEmpty(data)) return /*#__PURE__*/ $lR8r2$react.createElement($b85537fc6abd5d2f$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $214aba81455ac9eb$export$84712d0562a614b8), null, "Select one or more variants"));
    return /*#__PURE__*/ $lR8r2$react.createElement($b85537fc6abd5d2f$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $72771489cf9f6777$export$c2e30eeee87f25ff), {
        options: options
    }));
});






const $8c5ceafe21f732a1$var$getBorder = $lR8r2$lodashfp.curry((propName, props)=>props[propName] ? `1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")(props)}` : "none");
const $8c5ceafe21f732a1$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    flex-direction: column;
    width: ${({ width: width  })=>width || "100%"};
    border-left: ${$8c5ceafe21f732a1$var$getBorder("borderLeft")};
    border-bottom: ${$8c5ceafe21f732a1$var$getBorder("borderBottom")};
    border-top: ${$8c5ceafe21f732a1$var$getBorder("borderTop")};
    border-right: ${$8c5ceafe21f732a1$var$getBorder("borderRight")};
    padding-left: 5px;
    position: relative;
    margin-left: ${$8c5ceafe21f732a1$var$getBorder("marginLeft")};
`;
const $8c5ceafe21f732a1$export$851f9125c323a8f6 = ({ children: children , ...props })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($8c5ceafe21f732a1$var$Wrapper, props, children);







const $e524a471ad4753b2$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 6px
`;
const $e524a471ad4753b2$var$Title = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-bottom: 5px;
    align-items: center;
`;
const $e524a471ad4753b2$export$6e2c8f0811a474ce = ({ title: title ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($e524a471ad4753b2$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($e524a471ad4753b2$var$Title, null, title));










const $9361467332309be7$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $9361467332309be7$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $9361467332309be7$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`

`;
const $9361467332309be7$export$5bbbff55268c0248 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("duration");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepWidth({
            tasks: selectAction === "tasks",
            duration: selectAction === "duration",
            std_deviation: selectAction === "std_deviation"
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            const settings = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepWidth();
            if (settings.tasks === true) setValue("tasks");
            if (settings.duration === true) setValue("duration");
            if (settings.std_deviation === true) setValue("std_deviation");
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    const label = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$StyledFormControlLabel, {
        value: "tasks",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$RadioComponent, null),
        label: label
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$StyledFormControlLabel, {
        value: "duration",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$RadioComponent, null),
        label: "Avg Duration"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$StyledFormControlLabel, {
        value: "std_deviation",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9361467332309be7$var$RadioComponent, null),
        label: "Std Deviation"
    })));
};









const $61f603777d6b2f44$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $61f603777d6b2f44$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 15px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $61f603777d6b2f44$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`

`;
const $61f603777d6b2f44$export$eec95bf181e3c5f9 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("animate");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeSelectAction({
            isolate: selectAction === "isolate",
            animate: selectAction === "animate",
            lifecycle: selectAction === "lifecycle"
        });
    //        apiProvider.rebuildPVDiagram({});
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$StyledFormControlLabel, {
        value: "animate",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$RadioComponent, null),
        label: "Animate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$StyledFormControlLabel, {
        value: "isolate",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$RadioComponent, null),
        label: "Isolate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$StyledFormControlLabel, {
        value: "lifecycle",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61f603777d6b2f44$var$RadioComponent, null),
        label: "Lifecycle"
    })));
};










const $adceb68c1ad70bb9$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $adceb68c1ad70bb9$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 15px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        
    }
`;
const $adceb68c1ad70bb9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`

`;
const $adceb68c1ad70bb9$export$39dbc3f558091353 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("duration");
    const handleChange = (event)=>{
        const highlight = event.target.value;
        setValue(highlight);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeHighlight({
            highlightLoops: highlight === "loops",
            highlightNonCompliance: highlight === "compliance",
            highlightAutomation: highlight === "automation",
            stepColourVolume: highlight === "volume",
            stepColourDuration: highlight === "duration",
            stepColourStdDeviation: highlight === "std_deviation",
            stepColourCost: highlight === "cost"
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setValue("compliance");
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCompliance, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCompliance, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setValue("automation");
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeAutomation, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setValue("cost");
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCost, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeCost, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "highlight",
        name: "highlight",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "duration",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Duration"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "volume",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Volume"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "std_deviation",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Std Deviation"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "cost",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Cost"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "loops",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Loops"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "compliance",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Non Compliant"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$StyledFormControlLabel, {
        value: "automation",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adceb68c1ad70bb9$var$RadioComponent, null),
        label: "Automated"
    })));
};










const $970aa6d663a61cbd$export$8ebcecbecdb22732 = ()=>{
    const [open, setOpen] = $lR8r2$react.useState(false);
    const [message, setMessage] = $lR8r2$react.useState();
    const [severity, setSeverity] = $lR8r2$react.useState();
    $lR8r2$react.useEffect(()=>{
        const listener = (props1, props2, props3, props4)=>{
            setMessage(props1);
            setSeverity(props2);
            setOpen(props3);
            if (props4 == true) setTimeout(()=>{
                setOpen(false);
            }, 3000);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).variantSlicerAlert, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).variantSlicerAlert, listener);
        };
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Box), {
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Collapse), {
        in: open
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Alert), {
        severity: severity,
        action: /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.IconButton), {
            "aria-label": "close",
            color: "inherit",
            size: "small",
            onClick: ()=>{
                setOpen(false);
            }
        }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuiicons.Close), {
            fontSize: "inherit"
        })),
        sx: {
            mb: 2
        }
    }, message)));
};


const $5f65df87b089c6f8$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $5f65df87b089c6f8$var$WrapperCB = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: row;
`;
const $5f65df87b089c6f8$var$SingleBlockRow = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $8c5ceafe21f732a1$export$851f9125c323a8f6))`
    flex-direction: row
`;
const $5f65df87b089c6f8$export$c36b7feb8a4cf8b4 = /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).memo(()=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f65df87b089c6f8$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        borderBottom: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $eceec5d0773825e1$export$2c45b5af39eaa979), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        borderBottom: true
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b85537fc6abd5d2f$export$a6a10dd922582f86), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e524a471ad4753b2$export$6e2c8f0811a474ce), {
        title: "Select Action"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f65df87b089c6f8$var$SingleBlockRow, {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61f603777d6b2f44$export$eec95bf181e3c5f9), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e524a471ad4753b2$export$6e2c8f0811a474ce), {
        title: "Highlight Steps"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $adceb68c1ad70bb9$export$39dbc3f558091353), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e524a471ad4753b2$export$6e2c8f0811a474ce), {
        title: "Step Width"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9361467332309be7$export$5bbbff55268c0248), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "19%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e524a471ad4753b2$export$6e2c8f0811a474ce), {
        title: "Filter"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c5ceafe21f732a1$export$851f9125c323a8f6), {
        width: "81%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f65df87b089c6f8$var$WrapperCB, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $92c71181f5ddd1f0$export$811609789330a031), {
        label: "Loops",
        update: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateVariantFilterLoops
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $92c71181f5ddd1f0$export$811609789330a031), {
        label: "Compliant",
        update: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateVariantFilterCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $92c71181f5ddd1f0$export$811609789330a031), {
        label: "Automated",
        update: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateVariantFilterAutomate
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $970aa6d663a61cbd$export$8ebcecbecdb22732), null)));








const $3cdfb5db925e1c66$var$Icon = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 0;
    height: 0;
    border-top: 7px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("black")};
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-radius: 5px;
`;
const $3cdfb5db925e1c66$export$fcdb0af0473ee9e4 = ()=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3cdfb5db925e1c66$var$Icon, null);



const $65647e376bb3e0a7$var$StyledAccordion = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Accordion))`
    box-shadow: none;
    border-bottom: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightestGray")};
    font-size: 15px;
    &.Mui-expanded {
        margin: 0;
    }

    &:last-child {
        border-bottom: none;
    }

    &:before {
        display: none;
    }
`;
const $65647e376bb3e0a7$var$StyledAccordionSummary = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.AccordionSummary))`
    min-height: 30px;
    padding: 0 4px;
`;
const $65647e376bb3e0a7$var$StyledAccordionDetails = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.AccordionDetails))`
    padding: 0 0 16px;
`;
const $65647e376bb3e0a7$export$40e646e38e6ed100 = /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).memo(({ title: title , children: children , expanded: expanded = false , disabled: disabled = false  })=>{
    const [stateExpanded, setStateExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(expanded);
    const [stateDisabled, setStateVisible] = (0, ($parcel$interopDefault($lR8r2$react))).useState(disabled);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setStateExpanded(expanded);
    }, [
        expanded
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($65647e376bb3e0a7$var$StyledAccordion, {
        onChange: ()=>setStateExpanded(!stateExpanded),
        disableGutters: true,
        disabled: stateDisabled,
        expanded: stateExpanded
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($65647e376bb3e0a7$var$StyledAccordionSummary, {
        expandIcon: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3cdfb5db925e1c66$export$fcdb0af0473ee9e4), null)
    }, title), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($65647e376bb3e0a7$var$StyledAccordionDetails, null, children));
});















const $f52223a639b46b22$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $f52223a639b46b22$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setApplyEnabled: setApplyEnabled ,  })=>{
    const grid = (0, $lR8r2$react.useRef)(null);
    const getContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Process Rules",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/RulesIcon.png" />',
                subMenu: [
                    {
                        name: "Compliance...",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).createRule({
                                type: "compliance",
                                fromActivity: params.node.data.from_activity_id,
                                toActivity: params.node.data.to_activity_id,
                                fromActivityStr: params.node.data.from_activity,
                                toActivityStr: params.node.data.to_activity
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/ComplianceIcon.png" />'
                    },
                    {
                        name: "Automation...",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).createRule({
                                type: "automation",
                                fromActivity: params.node.data.from_activity_id,
                                toActivity: params.node.data.to_activity_id,
                                fromActivityStr: params.node.data.from_activity,
                                toActivityStr: params.node.data.to_activity
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/AutomateIcon.png" />'
                    },
                    {
                        name: "Performance...",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).createRule({
                                type: "performance",
                                fromActivity: params.node.data.from_activity_id,
                                toActivity: params.node.data.to_activity_id,
                                fromActivityStr: params.node.data.from_activity,
                                toActivityStr: params.node.data.to_activity
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/PerformanceIcon.png" />'
                    }, 
                ]
            },
            {
                name: "Cost Rules",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).createRule({
                        type: "cost",
                        fromActivity: params.node.data.from_activity_id,
                        toActivity: params.node.data.to_activity_id,
                        fromActivityStr: params.node.data.from_activity,
                        toActivityStr: params.node.data.to_activity
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/CostIcon.png" />'
            },
            {
                name: "Analyze",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/AnalyticsIcon.png" />',
                subMenu: [
                    {
                        name: "Decompose",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "step",
                                variant: 0,
                                activity: 0,
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({
                                source: "step"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/decompose.png" />'
                    },
                    {
                        name: "Insights",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "step",
                                variant: 0,
                                activity: 0,
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({
                                source: "step"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/insights.png" />'
                    },
                    {
                        name: "Influencers",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "step",
                                variant: 0,
                                activity: 0,
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({
                                source: "step"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/influencer.png" />'
                    }, 
                ]
            },
            {
                name: "Histogram",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/HistogramIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "step-tasks",
                                variant: 0,
                                activity: 0,
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "step-events",
                                variant: 0,
                                activity: 0,
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    }, 
                ]
            },
            {
                name: "Detail",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/DetailIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setStepDetailProps({
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setStepDetailProps({
                                from: params.node.data.from_activity_id,
                                to: params.node.data.to_activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateEventDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    }, 
                ]
            },
            {
                // custom item
                name: "Task LifeCycle",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: "step",
                        variant: 0,
                        activity: 0,
                        from: params.node.data.from_activity_id,
                        to: params.node.data.to_activity_id
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationSource({
                        source: "step"
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
                    if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActiveAction() === "task_lifecycle") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
                    else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskLifecycleIcon.png" />'
            },
            "separator",
            "export",
            "resetColumns", 
        ];
        return result;
    }, []);
    const onSelectionChanged = (params)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setStepSlicerSelectedData({
            selection: params.api.getSelectedRows()
        });
        setApplyEnabled(false);
    };
    const onFirstDataRendered = (params)=>{
        params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepSlicerGridState());
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            if (grid != null) grid.current.api.forEachNode((rowNode)=>{
                rowNode.setSelected(false);
            });
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const onSaveGridColumnState = (params)=>{
        let columnState = params.columnApi.getColumnState();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveStepSlicerGridState({
            columnState: columnState
        });
    };
    const onFilterChanged = (params)=>{
        onSaveGridColumnState(params);
    };
    const onColumnVisible = (params)=>{
        onSaveGridColumnState(params);
    };
    const onColumnResized = (params)=>{
        onSaveGridColumnState(params);
    };
    const onSortChanged = (params)=>{
        onSaveGridColumnState(params);
    };
    const getRowHeight = ()=>25;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f52223a639b46b22$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        rowSelection: "multiple",
        onSelectionChanged: onSelectionChanged,
        onFirstDataRendered: onFirstDataRendered,
        getRowHeight: getRowHeight,
        onFilterChanged: onFilterChanged,
        onColumnVisible: onColumnVisible,
        onColumnResized: onColumnResized,
        onSortChanged: onSortChanged,
        columnDefs: columns,
        getContextMenuItems: getContextMenuItems,
        ref: grid,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        enableCharts: true,
        rowData: rows,
        chartThemes: [
            "ag-solar",
            "ag-pastel",
            "ag-material-dark",
            "ag-vivid-dark", 
        ],
        animateRows: true,
        suppressPropertyNamesCheck: true
    })));
};



const $c27b2d74d6a45d5b$export$90bcc42dcfef0f45 = ()=>[
        {
            field: "from_activity",
            headerName: "From Activity",
            width: 120,
            suppressMenu: true
        },
        {
            field: "to_activity",
            headerName: "To Activity",
            width: 120,
            suppressMenu: true
        },
        {
            field: "from_activity_id",
            headerName: "From Activity ID",
            hide: true,
            suppressMenu: true
        },
        {
            field: "to_activity_id",
            headerName: "To Activity ID",
            hide: true,
            suppressMenu: true
        },
        {
            field: "step",
            headerName: "Step",
            hide: true,
            width: 180,
            suppressMenu: true
        },
        {
            field: "events",
            headerName: "Events",
            filter: "agTextColumnFilter",
            width: 95,
            sort: "desc",
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agTextColumnFilter",
            width: 95,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true
        },
        {
            field: "perc_total_events",
            headerName: "% Total Events",
            filter: "agNumberColumnFilter",
            width: 98,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "avg_duration",
            headerName: "Avg Duration",
            width: 100,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                })
        },
        {
            field: "std_deviation",
            headerName: "Std Deviation",
            width: 100,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: false
        },
        {
            field: "loop",
            headerName: "Loop",
            width: 78,
            suppressMenu: true,
            cellRenderer: "tableIcon"
        },
        {
            field: "compliant",
            headerName: "Compliant",
            width: 95,
            suppressMenu: true,
            cellRenderer: "tableIcon"
        },
        {
            field: "event_cost_savings",
            headerName: "Avg Cost Savings",
            filter: "agNumberColumnFilter",
            width: 110,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                })
        },
        {
            field: "automated",
            headerName: "Automated",
            width: 95,
            suppressMenu: true,
            cellRenderer: "tableIcon"
        },
        {
            field: "max_duration",
            headerName: "Max Duration",
            width: 100,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "min_duration",
            headerName: "Min Duration",
            width: 100,
            suppressMenu: true,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "avg_duration_days",
            headerName: "Avg Duration (days)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "std_deviation_days",
            headerName: "Std Deviation (days)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "avg_duration_hrs",
            headerName: "Avg Duration (hours)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "std_deviation_hrs",
            headerName: "Std Deviation (hours)",
            filter: "agNumberColumnFilter",
            hide: true,
            suppressMenu: true
        },
        {
            field: "event_actual_cost",
            headerName: "Avg Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "event_forecast_cost",
            headerName: "Avg forecast Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "step_actual_cost",
            headerName: "Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "step_forecast_cost",
            headerName: "Forecast Cost",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "step_cost_savings",
            headerName: "Cost Savings",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_events_compliant",
            headerName: "% Events Compliant",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "perc_events_automated",
            headerName: "% Events Automated",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "events_compliant",
            headerName: "Events Compliant",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        },
        {
            field: "events_automated",
            headerName: "Events Automated",
            width: 90,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true,
            suppressMenu: true
        }, 
    ];



const $a752818d041511bd$export$78f0ff27683b02d4 = ({ setApplyEnabled: setApplyEnabled  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processStepsTable());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processStepsTable());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDurationColumns, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDurationColumns, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f52223a639b46b22$export$c8dd51eb24f71762), {
        rows: rows,
        columns: (0, $c27b2d74d6a45d5b$export$90bcc42dcfef0f45)(),
        setApplyEnabled: setApplyEnabled,
        height: "400px"
    });
};






const $531448afb0ccc7e1$var$getBorder = $lR8r2$lodashfp.curry((propName, props)=>props[propName] ? `1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")(props)}` : "none");
const $531448afb0ccc7e1$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    flex-direction: column;
    width: ${({ width: width  })=>width || "100%"};
    border-left: ${$531448afb0ccc7e1$var$getBorder("borderLeft")};
    border-bottom: ${$531448afb0ccc7e1$var$getBorder("borderBottom")};
    border-top: ${$531448afb0ccc7e1$var$getBorder("borderTop")};
    border-right: ${$531448afb0ccc7e1$var$getBorder("borderRight")};
    padding-left: 5px;
    position: relative;
    margin-left: ${$531448afb0ccc7e1$var$getBorder("marginLeft")};
`;
const $531448afb0ccc7e1$export$851f9125c323a8f6 = ({ children: children , ...props })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($531448afb0ccc7e1$var$Wrapper, props, children);





const $aa3e4d10f6c817ff$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 10px
`;
const $aa3e4d10f6c817ff$var$Title = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-bottom: 5px;
    margin-left: 5px;
    align-items: center;
`;
const $aa3e4d10f6c817ff$export$6e2c8f0811a474ce = ({ title: title ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($aa3e4d10f6c817ff$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($aa3e4d10f6c817ff$var$Title, null, title));












const $71ea65a19093f3cf$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $71ea65a19093f3cf$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $71ea65a19093f3cf$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $71ea65a19093f3cf$export$1c36c7b8d1d051c0 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("include");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepSelectRetention({
            mode: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("include");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepSelectRetention({
            mode: "include"
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71ea65a19093f3cf$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71ea65a19093f3cf$var$StyledFormControlLabel, {
        value: "include",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71ea65a19093f3cf$var$RadioComponent, null),
        label: "Include"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71ea65a19093f3cf$var$StyledFormControlLabel, {
        value: "exclude",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71ea65a19093f3cf$var$RadioComponent, null),
        label: "Exclude"
    })));
};









const $c1b580f4a5eb7bc9$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $c1b580f4a5eb7bc9$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $c1b580f4a5eb7bc9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $c1b580f4a5eb7bc9$export$b635b07d7fe5943f = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("or");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepSelectOperator({
            mode: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("or");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepSelectOperator({
            mode: "or"
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c1b580f4a5eb7bc9$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c1b580f4a5eb7bc9$var$StyledFormControlLabel, {
        value: "or",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c1b580f4a5eb7bc9$var$RadioComponent, null),
        label: "Or"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c1b580f4a5eb7bc9$var$StyledFormControlLabel, {
        value: "and",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c1b580f4a5eb7bc9$var$RadioComponent, null),
        label: "And"
    })));
};


const $d5407916d348ef2e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    padding-bottom: 5px;
`;
const $d5407916d348ef2e$export$e83a629ed8043d44 = ()=>{
    const [applyEnabled, setApplyEnabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const pane = "Steps";
    const onApply = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applySlicer({
            pane: pane
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d5407916d348ef2e$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a752818d041511bd$export$78f0ff27683b02d4), {
        setApplyEnabled: setApplyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aa3e4d10f6c817ff$export$6e2c8f0811a474ce), {
        title: "Retention"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $71ea65a19093f3cf$export$1c36c7b8d1d051c0), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aa3e4d10f6c817ff$export$6e2c8f0811a474ce), {
        title: "Operator"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c1b580f4a5eb7bc9$export$b635b07d7fe5943f), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }));
};















const $f7a5925bcad796da$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $f7a5925bcad796da$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setApplyEnabled: setApplyEnabled ,  })=>{
    const grid = (0, $lR8r2$react.useRef)(null);
    const getContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [
            {
                name: "Analyze",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/AnalyticsIcon.png" />',
                subMenu: [
                    {
                        // custom item
                        name: "Decompose",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "activity",
                                variant: 0,
                                activity: params.node.data.activity_id,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({
                                source: "activity"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/decompose.png" />'
                    },
                    {
                        // custom item
                        name: "Insights",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "activity",
                                variant: 0,
                                activity: params.node.data.activity_id,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({
                                source: "activity"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/insights.png" />'
                    },
                    {
                        // custom item
                        name: "Influencers",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                                variantPaneVariants: false,
                                type: "activity",
                                variant: 0,
                                activity: params.node.data.activity_id,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({
                                source: "activity"
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/influencer.png" />'
                    }, 
                ]
            },
            {
                name: "Histogram",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "activity-tasks",
                                variant: 0,
                                activity: params.node.data.activity_id,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
                                variantPaneVariants: false,
                                type: "activity-events",
                                variant: 0,
                                activity: params.node.data.activity_id,
                                from: 0,
                                to: 0
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/ComplianceIcon.png" />'
                    }, 
                ]
            },
            {
                name: "Detail",
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/DetailIcon.png" />',
                subMenu: [
                    {
                        name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActivityDetailProps({
                                activity: params.node.data.activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskIcon.png" />'
                    },
                    {
                        name: "Events",
                        action: function() {
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActivityDetailProps({
                                activity: params.node.data.activity_id
                            });
                            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateEventDetail({
                                activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                            });
                        },
                        icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
                    }, 
                ]
            },
            {
                // custom item
                name: "Task LifeCycle",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateSlicedTaskArray({
                        variantPaneVariants: false,
                        type: "activity",
                        variant: 0,
                        activity: params.node.data.activity_id,
                        from: 0,
                        to: 0
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationSource({
                        source: "activity"
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
                    if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActiveAction() === "task_lifecycle") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
                    else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskLifecycleIcon.png" />'
            },
            "separator",
            "export",
            "resetColumns", 
        ];
        return result;
    }, []);
    const onFirstDataRendered = (params)=>{
        params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivitySlicerGridState());
    };
    const onSelectionChanged = (params)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setActivitySlicerSelectedData({
            selection: params.api.getSelectedRows()
        });
        setApplyEnabled(false);
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            if (grid != null) grid.current.api.forEachNode((rowNode)=>{
                rowNode.setSelected(false);
            });
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const onSaveGridColumnState = (params)=>{
        let columnState = params.columnApi.getColumnState();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveActivitySlicerGridState({
            columnState: columnState
        });
    };
    const getRowHeight = ()=>25;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f7a5925bcad796da$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        rowSelection: "multiple",
        onSelectionChanged: onSelectionChanged,
        onFirstDataRendered: onFirstDataRendered,
        getContextMenuItems: getContextMenuItems,
        getRowHeight: getRowHeight,
        onFilterChanged: onSaveGridColumnState,
        onColumnVisible: onSaveGridColumnState,
        onColumnResized: onSaveGridColumnState,
        onSortChanged: onSaveGridColumnState,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        ref: grid,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        enableCharts: true,
        chartThemes: [
            "ag-solar",
            "ag-pastel",
            "ag-material-dark",
            "ag-vivid-dark", 
        ],
        animateRows: true,
        rowData: rows
    })));
};



const $0f94b432f075e4d9$export$9353012faee7188b = ()=>[
        {
            field: "activity",
            headerName: "Activity",
            suppressMenu: true
        },
        {
            field: "activity_id",
            headerName: "Activity ID",
            suppressMenu: true,
            hide: true
        },
        {
            field: "tasks",
            suppressMenu: true,
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            width: 95,
            filter: "agNumberColumnFilter",
            sort: "desc",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "perc_total",
            suppressMenu: true,
            headerName: "% Total " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agNumberColumnFilter",
            width: 98,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "compliant",
            suppressMenu: true,
            headerName: "Compliant " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agNumberColumnFilter",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true
        },
        {
            field: "automated",
            suppressMenu: true,
            headerName: "Automated " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agNumberColumnFilter",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            hide: true
        },
        {
            field: "perc_tasks_compliant",
            suppressMenu: true,
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Compliant",
            filter: "agNumberColumnFilter",
            width: 115,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        },
        {
            field: "perc_tasks_automated",
            suppressMenu: true,
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s Automated",
            filter: "agNumberColumnFilter",
            width: 120,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        },
        {
            field: "task_actual_cost",
            suppressMenu: true,
            headerName: "Avg Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "task_forecast_cost",
            suppressMenu: true,
            headerName: "Avg forecast Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "task_cost_savings",
            suppressMenu: true,
            headerName: "Avg Cost Savings",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: false
        },
        {
            field: "activity_actual_cost",
            suppressMenu: true,
            headerName: "Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "activity_forecast_cost",
            suppressMenu: true,
            headerName: "Forecast Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "activity_cost_savings",
            suppressMenu: true,
            headerName: "Cost Savings",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        }, 
    ];



const $fae1e06533e4d8b0$export$d38870f1bebb1977 = ({ setApplyEnabled: setApplyEnabled  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processActivitiesTable());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeIncludeStart({
                includeStart: false
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processActivitiesTable());
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f7a5925bcad796da$export$c8dd51eb24f71762), {
        rows: rows,
        columns: (0, $0f94b432f075e4d9$export$9353012faee7188b)(),
        setApplyEnabled: setApplyEnabled,
        height: "400px"
    });
};














const $96ad2e3f49212ad5$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 15px;
        height: 15px;
    }
`;
const $96ad2e3f49212ad5$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $96ad2e3f49212ad5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $96ad2e3f49212ad5$export$1c36c7b8d1d051c0 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("include");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivitySelectRetention({
            mode: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("include");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivitySelectRetention({
            mode: "include"
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($96ad2e3f49212ad5$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($96ad2e3f49212ad5$var$StyledFormControlLabel, {
        value: "include",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($96ad2e3f49212ad5$var$RadioComponent, null),
        label: "Include"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($96ad2e3f49212ad5$var$StyledFormControlLabel, {
        value: "exclude",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($96ad2e3f49212ad5$var$RadioComponent, null),
        label: "Exclude"
    })));
};









const $129eca1b7253deae$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 15px;
        height: 15px;
    }
`;
const $129eca1b7253deae$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $129eca1b7253deae$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $129eca1b7253deae$export$b635b07d7fe5943f = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("or");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivitySelectOperator({
            mode: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("or");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivitySelectOperator({
            mode: "or"
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($129eca1b7253deae$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($129eca1b7253deae$var$StyledFormControlLabel, {
        value: "or",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($129eca1b7253deae$var$RadioComponent, null),
        label: "Or"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($129eca1b7253deae$var$StyledFormControlLabel, {
        value: "and",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($129eca1b7253deae$var$RadioComponent, null),
        label: "And"
    })));
};


const $4442682514ef1e3c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    padding-bottom: 5px;
`;
const $4442682514ef1e3c$export$93d907250fe7d3ea = ()=>{
    const [applyEnabled, setApplyEnabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const pane = "Activities";
    const onApply = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applySlicer({
            pane: pane
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4442682514ef1e3c$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $fae1e06533e4d8b0$export$d38870f1bebb1977), {
        setApplyEnabled: setApplyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aa3e4d10f6c817ff$export$6e2c8f0811a474ce), {
        title: "Retention"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $96ad2e3f49212ad5$export$1c36c7b8d1d051c0), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aa3e4d10f6c817ff$export$6e2c8f0811a474ce), {
        title: "Operator"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $129eca1b7253deae$export$b635b07d7fe5943f), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $531448afb0ccc7e1$export$851f9125c323a8f6), {
        width: "40%"
    }));
};

















const $036e53d0237daf90$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $036e53d0237daf90$export$c8dd51eb24f71762 = ({ type: type , rows: rows , columns: columns , height: height , setApplyEnabled: setApplyEnabled ,  })=>{
    const grid = (0, $lR8r2$react.useRef)(null);
    const onSelectionChanged = (params)=>{
        const selection = params.api.getSelectedRows();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setPathSlicerSelectedData({
            selection: selection,
            type: type
        });
        setApplyEnabled(!!selection.length);
    };
    const onFirstDataRendered = (params)=>{
        const allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            if (grid != null) grid.current.api.forEachNode((rowNode)=>{
                rowNode.setSelected(false);
            });
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const getRowHeight = (params)=>params.node.group ? 24 : 24;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($036e53d0237daf90$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        rowSelection: "multiple",
        onSelectionChanged: onSelectionChanged,
        onFirstDataRendered: onFirstDataRendered,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        rowData: rows,
        ref: grid,
        getRowHeight: getRowHeight
    })));
};



const $e844c56639048b0e$export$9353012faee7188b = ()=>[
        {
            field: "activity",
            headerName: "Activity",
            sortable: true,
            filter: true,
            flex: 3,
            resizable: true,
            wrapText: true,
            autoHeight: true,
            suppressMenu: true
        }
    ];
const $e844c56639048b0e$export$bc37194040019de2 = ({ type: type , attribute: attribute , setApplyEnabled: setApplyEnabled ,  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeIncludeStart({
                includeStart: true
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processActivitiesTable());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $036e53d0237daf90$export$c8dd51eb24f71762), {
        type: type,
        attribute: attribute,
        rows: rows,
        columns: $e844c56639048b0e$export$9353012faee7188b(),
        setApplyEnabled: setApplyEnabled,
        height: "280px"
    });
};













const $847902092ff08d3d$var$RadioComponent = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreRadio))))`
    color: ${({ checked: checked  })=>checked ? (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBlue") : (0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};

    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;
const $847902092ff08d3d$var$StyledFormControlLabel = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreFormControlLabel))))`
    margin-right: 30px;

    & .MuiFormControlLabel-label {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("small")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const $847902092ff08d3d$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $847902092ff08d3d$export$1c36c7b8d1d051c0 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("include");
    const handleChange = (event)=>{
        const selectAction = event.target.value;
        setValue(selectAction);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePathSelectRetention({
            mode: selectAction
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("include");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivitySelectRetention({
            mode: "include"
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($847902092ff08d3d$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreRadioGroup))), {
        row: true,
        "aria-label": "selectAction",
        name: "selectAction",
        value: value,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($847902092ff08d3d$var$StyledFormControlLabel, {
        value: "include",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($847902092ff08d3d$var$RadioComponent, null),
        label: "Include"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($847902092ff08d3d$var$StyledFormControlLabel, {
        value: "exclude",
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($847902092ff08d3d$var$RadioComponent, null),
        label: "Exclude"
    })));
};


const $3bd492f6d33b653e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $3bd492f6d33b653e$var$optionsPath = [
    {
        value: "Directly Followed",
        label: "Directly Followed"
    },
    {
        value: "Eventually Followed",
        label: "Eventually Followed"
    },
    {
        value: "Not Directly Followed",
        label: "Not Directly Followed"
    },
    {
        value: "Not Eventually Followed",
        label: "Not Eventually Followed"
    }, 
];
const $3bd492f6d33b653e$export$ddcd1e3bb49f927a = ()=>{
    const [applyEnabled, setApplyEnabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        from: false,
        to: false
    });
    const [attribute, setPath] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Directly Followed");
    const onPathChange = (attribute)=>{
        setPath(attribute);
    };
    const pane = "Path";
    const onApply = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyPathSlicer({
            attribute: attribute
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applySlicer({
            pane: pane
        });
    };
    const setApplyEnabledHandler = $lR8r2$lodashfp.curry((key, value)=>setApplyEnabled((prevState)=>({
                ...prevState,
                [key]: value
            })));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3bd492f6d33b653e$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "35%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e844c56639048b0e$export$bc37194040019de2), {
        type: "from",
        setApplyEnabled: setApplyEnabledHandler("from"),
        attribute: attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $3bd492f6d33b653e$var$optionsPath,
        onChange: onPathChange,
        value: attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "35%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e844c56639048b0e$export$bc37194040019de2), {
        type: "to",
        setApplyEnabled: setApplyEnabledHandler("to"),
        attribute: attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aa3e4d10f6c817ff$export$6e2c8f0811a474ce), {
        title: "Retention"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $847902092ff08d3d$export$1c36c7b8d1d051c0), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "45%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: !(applyEnabled.from && applyEnabled.to)
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }));
};










const $7a78441bfebc1b49$var$StyledSwitch = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Switch))`
    & .MuiSwitch-colorSecondary.Mui-checked {
        color: blue;
    }

    & .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
        background-color: gray;
    }
`;
const $7a78441bfebc1b49$export$b5d5cf8927ab7262 = ({ label: label , checked: checked , onChange: onChange , className: className ,  })=>{
    const handleOnChange = (event)=>{
        onChange(event.target.checked);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.FormControlLabel), {
        className: className,
        labelPlacement: "start",
        label: label,
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7a78441bfebc1b49$var$StyledSwitch, {
            checked: checked,
            onChange: handleOnChange
        })
    });
};


const $61fba9e53b79c6ff$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;
const $61fba9e53b79c6ff$var$Title = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-bottom: 5px;
`;
const $61fba9e53b79c6ff$var$StyledSwitch = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $7a78441bfebc1b49$export$b5d5cf8927ab7262))`
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-left: 0;

    & .MuiFormControlLabel-label {
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    }
`;
const $61fba9e53b79c6ff$var$Content = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 3px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")}
`;
const $61fba9e53b79c6ff$export$6e2c8f0811a474ce = ({ children: children , title: title , switchProps: switchProps ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61fba9e53b79c6ff$var$Wrapper, null, switchProps ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61fba9e53b79c6ff$var$StyledSwitch, {
        label: title,
        ...switchProps
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61fba9e53b79c6ff$var$Title, null, title), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($61fba9e53b79c6ff$var$Content, null, children));













const $f2b2fcde5ca04bfa$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $f2b2fcde5ca04bfa$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , attributeType: attributeType , setApplyEnabled: setApplyEnabled ,  })=>{
    const onSelectionChanged = (params)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAttributeFilter({
            selection: params.api.getSelectedRows()
        });
        setApplyEnabled(false);
    };
    const onRowDataChanged = (params)=>{
        if (attributeType === "Event") {
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "avg_duration",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "avg_task_cost",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "events",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_total_tasks",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_total_events",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_compliant_tasks",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_compliant_events",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_automated_tasks",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_automated_events",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_cost_savings",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "std_deviation",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "tasks",
                        hide: false
                    }
                ]
            });
            params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEventAttributeFilterGridState());
        }
        if (attributeType === "Task") {
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "avg_duration",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "avg_task_cost",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "events",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_total_tasks",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_total_events",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_compliant_tasks",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_compliant_events",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_automated_tasks",
                        hide: false
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_automated_events",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "perc_cost_savings",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "std_deviation",
                        hide: true
                    }
                ]
            });
            params.columnApi.applyColumnState({
                state: [
                    {
                        colId: "tasks",
                        hide: false
                    }
                ]
            });
            params.columnApi.setColumnState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getTaskAttributeFilterGridState());
        }
    };
    const onSaveGridColumnState = (params)=>{
        let columnState = params.columnApi.getColumnState();
        if (attributeType === "Event") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveEventAttributeFilterGridState({
            columnState: columnState
        });
        else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveTaskAttributeFilterGridState({
            columnState: columnState
        });
    };
    const onFilterChanged = (params)=>{
        onSaveGridColumnState(params);
    };
    const onColumnVisible = (params)=>{
        onSaveGridColumnState(params);
    };
    const onColumnResized = (params)=>{
        onSaveGridColumnState(params);
    };
    const onSortChanged = (params)=>{
        onSaveGridColumnState(params);
    };
    const enableCharts = true;
    const getRowHeight = ()=>25;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f2b2fcde5ca04bfa$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        rowSelection: "multiple",
        onSelectionChanged: onSelectionChanged,
        onRowDataChanged: onRowDataChanged,
        getRowHeight: getRowHeight,
        onFilterChanged: onFilterChanged,
        onColumnVisible: onColumnVisible,
        onColumnResized: onColumnResized,
        onSortChanged: onSortChanged,
        columnDefs: columns,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            autoHeight: true,
            wrapText: true
        },
        rowData: rows,
        suppressPropertyNamesCheck: true,
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        enableCharts: enableCharts,
        chartThemes: [
            "ag-solar",
            "ag-pastel",
            "ag-material-dark",
            "ag-vivid-dark", 
        ]
    })));
};



const $80d8673da8cb159b$export$da1d4b97dca0f603 = ()=>[
        {
            field: "value",
            headerName: "Value",
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            width: 95,
            hide: false,
            sort: "desc",
            wrapText: true,
            autoHeight: true
        },
        {
            field: "events",
            headerName: "Events",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                }),
            width: 100,
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_total_tasks",
            headerName: "% Total " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            width: 115,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_total_events",
            headerName: "% Total Events",
            width: 115,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "perc_compliant_tasks",
            headerName: "% Compliant " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            width: 115,
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_compliant_events",
            headerName: "% Compliant Events",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            width: 115,
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_automated_tasks",
            headerName: "% Automated " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            width: 115,
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_automated_events",
            headerName: "% Automated Events",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            width: 115,
            hide: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "avg_duration",
            headerName: "Avg Duration (" + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + ")",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            width: 115,
            hide: false,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "std_deviation",
            headerName: "Std Deviation (" + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + ")",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            width: 115,
            hide: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "perc_cost_savings",
            headerName: "% Cost Savings",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            width: 115,
            hide: true,
            wrapText: true,
            autoHeight: true
        },
        {
            field: "avg_task_cost",
            headerName: "Avg (" + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + ") Cost",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCostDecimal({
                    cost: value
                }),
            width: 115,
            hide: true,
            wrapText: true,
            autoHeight: true
        }, 
    ];



const $7a324624c484800f$export$343c8fa533c1a52f = ({ attribute: attribute , attributeType: attributeType , setApplyEnabled: setApplyEnabled ,  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const processAttributesTableData = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processAttributesTable({
            attribute: attribute,
            attributeType: attributeType
        });
        setData(processAttributesTableData);
    }, [
        attribute,
        attributeType
    ]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processAttributesTable({
                attribute: attribute,
                attributeType: attributeType
            }));
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).dataImportComplete, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateFilterAttributes, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).dataImportComplete, listener);
        };
    }, [
        attribute,
        attributeType
    ]);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f2b2fcde5ca04bfa$export$c8dd51eb24f71762), {
        height: "500px",
        rows: rows,
        setApplyEnabled: setApplyEnabled,
        attributeType: attributeType,
        columns: (0, $80d8673da8cb159b$export$da1d4b97dca0f603)()
    });
};







const $1e3a31557dd99081$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
let $1e3a31557dd99081$var$optionsAttributeTypes = [];
let $1e3a31557dd99081$var$optionsAttributes = [];
const $1e3a31557dd99081$export$c4dedd76188cef5b = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [attributeType, setAttributeType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [attribute, setAttribute] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [applyEnabled, setApplyEnabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const onAttributeTypeChange = (attributeType)=>setAttributeType(attributeType);
    const onAttributeChange = (attribute)=>setAttribute(attribute);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        $1e3a31557dd99081$var$optionsAttributes = [];
        if (attributeType === (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper()) $1e3a31557dd99081$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        else $1e3a31557dd99081$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
        if ($1e3a31557dd99081$var$optionsAttributes.length > 0) setAttribute($1e3a31557dd99081$var$optionsAttributes[0].value);
    }, [
        attributeType
    ]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            let taskAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
            let eventAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
            $1e3a31557dd99081$var$optionsAttributes = [];
            $1e3a31557dd99081$var$optionsAttributeTypes = [];
            if (eventAttributes.length > 0) {
                var vtp = {};
                vtp["value"] = "Event";
                vtp["label"] = "Event";
                $1e3a31557dd99081$var$optionsAttributeTypes.push(vtp);
                setAttributeType("Event");
            }
            if (taskAttributes.length > 0) {
                var vtp = {};
                vtp["value"] = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper();
                vtp["label"] = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper();
                $1e3a31557dd99081$var$optionsAttributeTypes.push(vtp);
                setAttributeType((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper());
            }
            if (eventAttributes.length > 0) $1e3a31557dd99081$var$optionsAttributes = eventAttributes;
            else $1e3a31557dd99081$var$optionsAttributes = taskAttributes;
            if ($1e3a31557dd99081$var$optionsAttributes.length > 0) setAttribute($1e3a31557dd99081$var$optionsAttributes[0].value);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        };
    }, []);
    const onApply = ()=>{
        const tasksFilter = {
            ...attribute ? {
                attribute: attribute
            } : {},
            ...attributeType ? {
                attributeType: attributeType
            } : {}
        };
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyAttributesFilter(tasksFilter)
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1e3a31557dd99081$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "50%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Attribute Type"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "50%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Values"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "50%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $1e3a31557dd99081$var$optionsAttributeTypes,
        onChange: onAttributeTypeChange,
        value: attributeType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "50%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $1e3a31557dd99081$var$optionsAttributes,
        onChange: onAttributeChange,
        value: attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $7a324624c484800f$export$343c8fa533c1a52f), {
        attribute: attribute,
        setApplyEnabled: setApplyEnabled,
        attributeType: attributeType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }));
};
















const $9d28124c6326106c$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 15px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
`;
const $9d28124c6326106c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    padding: 5px 0;
`;
const $9d28124c6326106c$export$6bf0cd3a219bbade = ({ value: value , onChange: onChange = $lR8r2$lodashfp.noop , onBlur: onBlur = $lR8r2$lodashfp.noop , className: className , label: label , min: min , max: max , disabled: disabled ,  })=>{
    const handleOnChange = (event)=>{
        if (event.target.value >= 0) onChange(event.target.value);
    };
    const handleOnBlur = (event)=>{
        const finalValue = Number(event.target.value);
        if ((min || min === 0) && finalValue < Number(min)) {
            onChange(min);
            return onBlur(min);
        }
        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }
        onBlur(finalValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9d28124c6326106c$var$Wrapper, {
        className: className
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9d28124c6326106c$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $54d265e55b9d4a6b$export$111e140b0af40b4e), {
        disabled: disabled,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        value: value,
        variant: "outlined",
        type: "number"
    }));
};


const $780c8de1b6457fd9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $780c8de1b6457fd9$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $9d28124c6326106c$export$6bf0cd3a219bbade))`
    margin-right: 30px;
`;
const $780c8de1b6457fd9$export$3383c5983d17be59 = ({ type: type , disabled: disabled , minValue: minValue , maxValue: maxValue , values: values , setValues: setValues ,  })=>{
    const onMinChange = (value)=>setValues([
            Number(value),
            values[1]
        ]);
    const onMaxChange = (value)=>setValues([
            values[0],
            Number(value)
        ]);
    const onBlur = ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTasksSlicerVariables({
            type: type,
            min: values[0],
            max: values[1]
        });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($780c8de1b6457fd9$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($780c8de1b6457fd9$var$StyledNumberInput, {
        label: "Min.",
        value: values[0],
        min: minValue,
        max: maxValue,
        disabled: disabled,
        onChange: onMinChange,
        onBlur: onBlur
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($780c8de1b6457fd9$var$StyledNumberInput, {
        label: "Max.",
        value: values[1],
        min: minValue,
        max: maxValue,
        disabled: disabled,
        onChange: onMaxChange,
        onBlur: onBlur
    }));
};





const $5103c3389655ef1b$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $5103c3389655ef1b$export$db82907bf1592d10 = ()=>{
    const { setProps: setProps  } = $lR8r2$react.useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [values1, setValues1] = $lR8r2$react.useState([
        1,
        10
    ]);
    const [minValue1, setMinValue1] = $lR8r2$react.useState(1);
    const [maxValue1, setMaxValue1] = $lR8r2$react.useState(10);
    const [values2, setValues2] = $lR8r2$react.useState([
        1,
        200
    ]);
    const [minValue2, setMinValue2] = $lR8r2$react.useState(1);
    const [maxValue2, setMaxValue2] = $lR8r2$react.useState(200);
    const [values3, setValues3] = $lR8r2$react.useState([
        0,
        400
    ]);
    const [minValue3, setMinValue3] = $lR8r2$react.useState(0);
    const [maxValue3, setMaxValue3] = $lR8r2$react.useState(400);
    const [variantsOptionsEnabled, setVariantsOptionsEnabled, ] = $lR8r2$react.useState(false);
    const [taskActivitiesEnabled, setTaskActivitiesEnabled, ] = $lR8r2$react.useState(false);
    const [taskDurationEnabled, setTaskDurationEnabled, ] = $lR8r2$react.useState(false);
    $lR8r2$react.useEffect(()=>{
        const listener = (resetValues)=>{
            setValues1([
                resetValues.minVariantTasks,
                resetValues.maxVariantTasks, 
            ]);
            setMinValue1(resetValues.minVariantTasks);
            setMaxValue1(resetValues.maxVariantTasks);
            setValues2([
                resetValues.taskActivitiesFrom,
                resetValues.taskActivitiesTo, 
            ]);
            setMinValue2(resetValues.taskActivitiesFrom);
            setMaxValue2(resetValues.taskActivitiesTo);
            setValues3([
                resetValues.taskDurationFrom,
                resetValues.taskDurationTo, 
            ]);
            setMinValue3(resetValues.taskDurationFrom);
            setMaxValue3(resetValues.taskDurationTo);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetTasksFilterDefaults({});
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTasksFilter, listener);
        };
    }, []);
    const onApply = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyTasksFilter({})
        });
    };
    const applyDisabled = ()=>variantsOptionsEnabled === false && taskActivitiesEnabled === false && taskDurationEnabled === false;
    const title1 = "# " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s in Variants";
    const title2 = "# Activities in a " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper();
    const title3 = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Duration (mins)";
    return /*#__PURE__*/ $lR8r2$react.createElement($5103c3389655ef1b$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), null, /*#__PURE__*/ $lR8r2$react.createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        switchProps: {
            checked: variantsOptionsEnabled,
            onChange: setVariantsOptionsEnabled
        },
        title: title1
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $780c8de1b6457fd9$export$3383c5983d17be59), {
        type: "NumTasksVariant",
        disabled: !variantsOptionsEnabled,
        minValue: minValue1,
        maxValue: maxValue1,
        values: values1,
        setValues: setValues1
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "100%"
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        switchProps: {
            checked: taskActivitiesEnabled,
            onChange: setTaskActivitiesEnabled
        },
        title: title2
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $780c8de1b6457fd9$export$3383c5983d17be59), {
        type: "NumActivitesTask",
        disabled: !taskActivitiesEnabled,
        minValue: minValue2,
        maxValue: maxValue2,
        values: values2,
        setValues: setValues2
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "100%"
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        switchProps: {
            checked: taskDurationEnabled,
            onChange: setTaskDurationEnabled
        },
        title: title3
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $780c8de1b6457fd9$export$3383c5983d17be59), {
        type: "TaskDuration",
        disabled: !taskDurationEnabled,
        minValue: minValue3,
        maxValue: maxValue3,
        values: values3,
        setValues: setValues3
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: applyDisabled()
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }));
};

















const $becd81aa5b100a9f$var$StyledDateRangePickerDay = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuilab.DateRangePickerDay))`
    && {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};

        &.Mui-selected {
            background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }

        &.MuiDateRangePickerDay-rangeIntervalDayHighlight .MuiDateRangePickerDay-day {
            background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
            color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")}
        }
    }
`;
const $becd81aa5b100a9f$export$5c20dcd640d30b8b = (props)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($becd81aa5b100a9f$var$StyledDateRangePickerDay, props);


const $4d0bd1b2d7b61ede$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-top: 5px;
    width: 100%;

    &>div {
        width: 100%;
    }
`;
const $4d0bd1b2d7b61ede$var$Inputs = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: baseline;
`;
const $4d0bd1b2d7b61ede$var$Input = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $54d265e55b9d4a6b$export$111e140b0af40b4e))`
    width: 32%;
    margin: 0 10px;
`;
const $4d0bd1b2d7b61ede$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).span`
    margin: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    text-align: right;
`;
const $4d0bd1b2d7b61ede$export$17334619f3ac2224 = ({ startText: startText , endText: endText , onChange: onChange , value: value ,  })=>/*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuilab.DateRangePicker), {
        calendars: 1,
        startText: startText,
        endText: endText,
        mask: "____/__/__",
        inputFormat: "YYYY/MM/DD",
        onChange: onChange,
        value: value,
        renderDay: (_, dateRangePickerDayProps)=>/*#__PURE__*/ $lR8r2$react.createElement((0, $becd81aa5b100a9f$export$5c20dcd640d30b8b), dateRangePickerDayProps),
        renderInput: ({ label: startLabel , ...startProps }, { label: endLabel , ...endProps })=>/*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Inputs, null, /*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Label, {
                title: startLabel
            }, startLabel), /*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Input, {
                variant: "outlined",
                ...startProps
            }), /*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Label, {
                title: startLabel
            }, endLabel), /*#__PURE__*/ $lR8r2$react.createElement($4d0bd1b2d7b61ede$var$Input, {
                variant: "outlined",
                ...endProps
            }))
    }));





const $9b5f552be6daf818$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $9b5f552be6daf818$export$b5207967a5eb8f18 = ()=>{
    const { setProps: setProps  } = $lR8r2$react.useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [time, setTime] = $lR8r2$react.useState([
        null,
        null
    ]);
    $lR8r2$react.useEffect(()=>{
        // defaults = apiProvider.defaultMinMaxTime();
        const listener = (values)=>{
            setTime(values.map((date)=>(0, ($parcel$interopDefault($lR8r2$moment)))(date)));
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetTimeFilter, listener);
        };
    }, []);
    const onApply = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyTimeFilter({
                    fromTime: time[0].toDate(),
                    toTime: time[1].toDate()
                })
        });
    };
    return /*#__PURE__*/ $lR8r2$react.createElement($9b5f552be6daf818$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "100%"
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $4d0bd1b2d7b61ede$export$17334619f3ac2224), {
        startText: "From",
        endText: "To",
        onChange: setTime,
        value: time
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: false
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "40%"
    }));
};













const $89abee30978c827c$export$efdd3e096bc27746 = ({ metric: metric , onMetricChange: onMetricChange ,  })=>{
    const metricOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).metrics({});
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Metric"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: metricOptions,
        onChange: onMetricChange,
        value: metric
    }));
};







const $3baedbf76c98a6a2$export$cab15d988c74456d = [
    {
        value: "is",
        label: "is"
    },
    {
        value: "is not",
        label: "is not"
    },
    {
        value: "greater than",
        label: "greater than"
    },
    {
        value: "greater than or is",
        label: "greater than or is"
    },
    {
        value: "less than",
        label: "less than"
    },
    {
        value: "less than or is",
        label: "less than or is"
    }, 
];
const $3baedbf76c98a6a2$var$StyledDropdown = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $957db110bbfa53b5$export$931cbfb6bfb85fc))`
    width: 100%;
`;
const $3baedbf76c98a6a2$export$fa5f90bfb4dbdbcd = ({ type: type , operator: operator , onOperatorChange: onOperatorChange ,  })=>{
    const options = type === "true_false" ? [
        $lR8r2$lodashfp.head($3baedbf76c98a6a2$export$cab15d988c74456d)
    ] : $3baedbf76c98a6a2$export$cab15d988c74456d;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Operator"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3baedbf76c98a6a2$var$StyledDropdown, {
        options: options,
        onChange: onOperatorChange,
        value: operator
    }));
};






const $6e4a8d0e6f1cc730$export$4c8d1a57a761ef94 = ({ type: type , checkboxValue: checkboxValue , onCheckboxChange: onCheckboxChange , numberValue: numberValue , onNumberChange: onNumberChange ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Value"
    }), type === "true_false" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: checkboxValue,
        handleOnChange: ()=>onCheckboxChange(!checkboxValue)
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9d28124c6326106c$export$6bf0cd3a219bbade), {
        value: numberValue,
        onChange: onNumberChange
    }));







const $09182b257156ba82$export$ecfd1f7ef9928246 = [
    {
        value: "seconds",
        label: "seconds"
    },
    {
        value: "minutes",
        label: "minutes"
    },
    {
        value: "hours",
        label: "hours"
    },
    {
        value: "days",
        label: "days"
    }, 
];
const $09182b257156ba82$var$StyledDropdown = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $957db110bbfa53b5$export$931cbfb6bfb85fc))`
    width: 100%;
`;
const $09182b257156ba82$export$d9e59215631231e3 = ({ type: type , timeUnit: timeUnit , onTimeUnitChange: onTimeUnitChange ,  })=>{
    if ($lR8r2$lodashfp.includes(type)([
        "true_false",
        "amount"
    ])) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $61fba9e53b79c6ff$export$6e2c8f0811a474ce), {
        title: "Time Unit"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($09182b257156ba82$var$StyledDropdown, {
        options: $09182b257156ba82$export$ecfd1f7ef9928246,
        onChange: onTimeUnitChange,
        value: timeUnit
    }));
};




const $cd16956d66541e93$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $cd16956d66541e93$var$StyledSingleBlock = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    flex-direction: row;
    justify-content: center;
`;
const $cd16956d66541e93$export$37b5e50641693fa1 = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const metricValues = (0, $042dc098ac08118e$export$b0c5c2fac8144e54)({});
    if ($lR8r2$lodashfp.isEmpty(metricValues)) {
        const valueToPush = {
            value: "n/a",
            label: "n/a",
            type: ""
        };
        metricValues.push(valueToPush);
    }
    const [metric, setMetric] = (0, ($parcel$interopDefault($lR8r2$react))).useState(metricValues[0].value);
    const [metricType, setMetricType] = (0, ($parcel$interopDefault($lR8r2$react))).useState(metricValues[0].type);
    const [operator, setOperator] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [timeUnit, setTimeUnit] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [checkboxValue, setCheckboxValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [numberValue, setNumberValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        // determine the metric type
        for (const each of metricValues)if (each.label === metric) setMetricType(each.type);
        if (metricType === "true_false") setOperator((0, $3baedbf76c98a6a2$export$cab15d988c74456d)[0].value);
        else setOperator("");
        setTimeUnit("");
        setCheckboxValue(false);
        setNumberValue(0);
    }, [
        metric
    ]);
    const onApply = ()=>{
        const metricFilter = {
            metric: metric,
            operator: operator,
            timeUnit: timeUnit,
            checkboxValue: checkboxValue,
            numberValue: numberValue
        };
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).applyMetricFilter({
                    metricFilter: metricFilter
                })
        });
    };
    const shouldBeDisabled = ()=>!metricType || !operator || metricType === "duration" && !timeUnit;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($cd16956d66541e93$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $89abee30978c827c$export$efdd3e096bc27746), {
        metric: metric,
        onMetricChange: setMetric
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3baedbf76c98a6a2$export$fa5f90bfb4dbdbcd), {
        type: metricType,
        operator: operator,
        onOperatorChange: setOperator
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6e4a8d0e6f1cc730$export$4c8d1a57a761ef94), {
        checkboxValue: checkboxValue,
        onCheckboxChange: setCheckboxValue,
        numberValue: numberValue,
        onNumberChange: setNumberValue,
        type: metricType
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $09182b257156ba82$export$d9e59215631231e3), {
        type: metricType,
        timeUnit: timeUnit,
        onTimeUnitChange: setTimeUnit
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($cd16956d66541e93$var$StyledSingleBlock, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Apply",
        onClick: onApply,
        disabled: shouldBeDisabled()
    })));
};










const $582eec5555718ed0$export$111e140b0af40b4e = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.TextField))`
    width: 65px;

    & .MuiInputBase-root {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        border-radius: 8px;

        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }
    }

    & .MuiInputBase-root.Mui-disabled {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightGray")};

        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        }
    }

    & input {
        text-align: center;
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("input")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
        padding: 5px;
    }
    & fieldset,
    & fieldset:hover {
        border: none;
    }
`;


const $638592d049634d15$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    padding: 5px 0;
`;
const $638592d049634d15$export$6bf0cd3a219bbade = ({ value: value ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($638592d049634d15$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $582eec5555718ed0$export$111e140b0af40b4e), {
        value: value,
        variant: "outlined",
        type: "string"
    }));








const $7753972cda8d4930$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    align-items: center;
`;
const $7753972cda8d4930$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $7753972cda8d4930$var$LabelRight = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-top: 12px;
    text-align: right;
    width: 100%;
`;
const $7753972cda8d4930$var$LabelCenter = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("black")};
    margin-top: 12px;
    text-align: center;
    width: 100%;
`;
const $7753972cda8d4930$export$bac3506438e44f8d = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).modelInfo());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).modelInfo());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantSlicerVariantChart, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateVariantSlicerVariantChart, listener);
        };
    }, []);
    const resetModel = ()=>{
        setProps({
            functionToLoad: ()=>reset()
        });
    };
    function reset() {
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetModel();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetFilters({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetGauges();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateMetricSettings({});
    }
    if ($lR8r2$lodashfp.isEmpty(data)) return null;
    const entityLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, "")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, "Events")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, entityLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, "Variants")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, "Steps")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelCenter, null, "Activities")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelRight, null, "Total:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[0].events
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[0].tasks
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[0].variants
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[0].steps
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[0].activities
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelRight, null, "Filtered:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[1].events
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[1].tasks
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[1].variants
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[1].steps
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[1].activities
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelRight, null, "Sliced:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[2].events
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[2].tasks
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[2].variants
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[2].steps
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[2].activities
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "15%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$var$LabelRight, null, "Selected:")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[3].events
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[3].tasks
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[3].variants
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[3].steps
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "17%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $638592d049634d15$export$6bf0cd3a219bbade), {
        value: data[3].activities
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "20%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Selection, Slicers, Filters and Rules",
        onClick: resetModel
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7753972cda8d4930$export$851f9125c323a8f6, {
        width: "20%"
    }));
};



















const $0b2870a2b726d03f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
`;
const $0b2870a2b726d03f$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setResetDisabled: setResetDisabled , setDeleteDisabled: setDeleteDisabled ,  })=>{
    const onSelectionChanged = (params)=>{
        const selectedNodes = params.api.getSelectedNodes();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setCommentDeleteRow({
            row: selectedNodes[0].id
        });
        setDeleteDisabled(false);
    };
    const onModelUpdated = (params)=>{
        const allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function(column) {
            if (column.colId != "comments") allColumnIds.push(column.colId);
        });
        //params.columnApi.autoSizeAllColumns();
        if (params.api.getDisplayedRowCount() > 0) {
            setResetDisabled(false);
            setDeleteDisabled(true);
        } else {
            setResetDisabled(true);
            setDeleteDisabled(true);
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0b2870a2b726d03f$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        rowSelection: "single",
        onSelectionChanged: onSelectionChanged,
        onModelUpdated: onModelUpdated,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true
        },
        rowData: rows
    })));
};



const $2121b1de08cbd030$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $2121b1de08cbd030$export$6e59ba0b4c4aa21a = ()=>[
        {
            field: "activity",
            wrapText: true,
            autoHeight: true,
            headerName: "Activity"
        },
        {
            field: "fromNode",
            wrapText: true,
            autoHeight: true,
            headerName: "From Activity"
        },
        {
            field: "toNode",
            wrapText: true,
            autoHeight: true,
            headerName: "To Activity"
        },
        {
            field: "comments",
            wrapText: true,
            autoHeight: true,
            headerName: "Comments"
        }, 
    ];
const $2121b1de08cbd030$export$f313ba4dae90ccd0 = ({ setDeleteDisabled: setDeleteDisabled , setResetDisabled: setResetDisabled  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).comments());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateComments, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateComments, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $0b2870a2b726d03f$export$c8dd51eb24f71762), {
        rows: rows,
        columns: $2121b1de08cbd030$export$6e59ba0b4c4aa21a(),
        setDeleteDisabled: setDeleteDisabled,
        setResetDisabled: setResetDisabled,
        height: "400px"
    });
};




const $7278d24ccf9bd280$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    align-items: center;
`;
const $7278d24ccf9bd280$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
function $7278d24ccf9bd280$var$fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = ()=>{
        callback(reader.result);
    };
}
const $7278d24ccf9bd280$export$434c217d363ea16 = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [deleteDisabled, setDeleteDisabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [saveDisabled, setResetDisabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const onDeleteComment = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteComment({});
    };
    const resetComments = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetComments({})
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Comments reset",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "comments"
        });
    };
    const saveComments = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveComments({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Comments saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "comments"
        });
    };
    const loadComments = ()=>{
        const inputFile = document.createElement("input");
        inputFile.type = "file";
        inputFile.click();
        inputFile.addEventListener("change", ()=>{
            const file = inputFile.files[0];
            $7278d24ccf9bd280$var$fileToText(file, (text)=>{
                setProps({
                    functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).importComments({
                            importedComments: text
                        })
                });
            });
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$export$851f9125c323a8f6, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2121b1de08cbd030$export$f313ba4dae90ccd0), {
        setDeleteDisabled: setDeleteDisabled,
        setResetDisabled: setResetDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Delete Comment",
        onClick: onDeleteComment,
        disabled: deleteDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Comments",
        onClick: resetComments,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save Comments",
        onClick: saveComments,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($7278d24ccf9bd280$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Load Comments",
        onClick: loadComments,
        disabled: false
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $970aa6d663a61cbd$export$8ebcecbecdb22732), null));
};
















const $36cd606bd2f41f49$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    margin-bottom: 5px;
`;
const $36cd606bd2f41f49$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setApplyEnabled: setApplyEnabled , setDeleteDisabled: setDeleteDisabled ,  })=>{
    const onSelectionChanged = (params)=>{
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map((node)=>node.data);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setFilterDeleteRow({
            row: selectedNodes[0].id
        });
        setDeleteDisabled(false);
    };
    const onFirstDataRendered = (params)=>{
        const allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });
        params.columnApi.autoSizeColumns();
    };
    const onModelUpdated = (params)=>{
        if (params.api.getDisplayedRowCount() > 0) setApplyEnabled(false);
        else setApplyEnabled(true);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($36cd606bd2f41f49$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        onModelUpdated: onModelUpdated,
        onFirstDataRendered: onFirstDataRendered,
        rowSelection: "single",
        onSelectionChanged: onSelectionChanged,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        domLayout: "autoHeight",
        detailRowHeight: 300,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        rowData: rows
    })));
};



const $e580629844670098$export$21f21af592ac9623 = ()=>[
        {
            field: "filter",
            headerName: "Filter",
            flex: 3
        }, 
    ];
const $e580629844670098$export$4723b08395f999c6 = ({ setApplyEnabled: setApplyEnabled , setDeleteDisabled: setDeleteDisabled ,  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).filterConditionsExport());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCurrentFilters, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applyFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCurrentFilters, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36cd606bd2f41f49$export$c8dd51eb24f71762), {
        rows: rows,
        columns: $e580629844670098$export$21f21af592ac9623(),
        setDeleteDisabled: setDeleteDisabled,
        setApplyEnabled: setApplyEnabled,
        height: "250px"
    });
};



const $22dc033591fc01d1$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    align-items: center;
`;
const $22dc033591fc01d1$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
function $22dc033591fc01d1$var$fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = ()=>{
        callback(reader.result);
    };
}
const $22dc033591fc01d1$export$92a576f896a9bf72 = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [applyEnabled, setApplyEnabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [deleteDisabled, setDeleteDisabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const resetFilters = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetFilters({})
        });
    };
    const onDeleteFilter = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteFilter({});
    };
    const saveFilters = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveFilterSettings({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Filter settings saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "filter_status"
        });
    };
    const loadFilters = ()=>{
        const inputFile = document.createElement("input");
        inputFile.type = "file";
        inputFile.click();
        inputFile.addEventListener("change", ()=>{
            const file = inputFile.files[0];
            $22dc033591fc01d1$var$fileToText(file, (text)=>{
                setProps({
                    functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).importFilters({
                            importedFilters: text
                        })
                });
            });
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$export$851f9125c323a8f6, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $e580629844670098$export$4723b08395f999c6), {
        setApplyEnabled: setApplyEnabled,
        setDeleteDisabled: setDeleteDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Delete Filter",
        onClick: onDeleteFilter,
        disabled: deleteDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Filters",
        onClick: resetFilters,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save Filters",
        onClick: saveFilters,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($22dc033591fc01d1$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Load Filters",
        onClick: loadFilters
    })));
};















const $d8424b1985766635$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    margin-bottom: 5px;
`;
const $d8424b1985766635$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setApplyEnabled: setApplyEnabled ,  })=>{
    const onFirstDataRendered = (params)=>{
        const allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });
        params.columnApi.autoSizeColumns();
    };
    const onModelUpdated = (params)=>{
        if (params.api.getDisplayedRowCount() > 0) setApplyEnabled(false);
        else setApplyEnabled(true);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d8424b1985766635$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        onFirstDataRendered: onFirstDataRendered,
        onModelUpdated: onModelUpdated,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        domLayout: "autoHeight",
        detailRowHeight: 300,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        rowData: rows
    })));
};



const $4b4106a3f93903a8$export$9d485b7eab63b009 = ()=>[
        {
            field: "slicer",
            headerName: "Slicer",
            flex: 3
        }, 
    ];
const $4b4106a3f93903a8$export$f7d2e4ec75445680 = ({ setApplyEnabled: setApplyEnabled ,  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).slicerConditionsExport());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d8424b1985766635$export$c8dd51eb24f71762), {
        rows: rows,
        columns: $4b4106a3f93903a8$export$9d485b7eab63b009(),
        setApplyEnabled: setApplyEnabled,
        height: "250px"
    });
};



const $71fd4ce80b940ebd$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    align-items: center;
`;
const $71fd4ce80b940ebd$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
function $71fd4ce80b940ebd$var$fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = ()=>{
        callback(reader.result);
    };
}
const $71fd4ce80b940ebd$export$afa61e435478c964 = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [applyEnabled, setApplyEnabled, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const resetSlicers = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetSlicers({})
        });
    };
    const saveSlicers = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveSlicerSettings({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Slicer settings saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "slicer_status"
        });
    };
    const loadSlicers = ()=>{
        const inputFile = document.createElement("input");
        inputFile.type = "file";
        inputFile.click();
        inputFile.addEventListener("change", ()=>{
            const file = inputFile.files[0];
            $71fd4ce80b940ebd$var$fileToText(file, (text)=>{
                setProps({
                    functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).importSlicers({
                            importedSlicers: text
                        })
                });
            });
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71fd4ce80b940ebd$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71fd4ce80b940ebd$export$851f9125c323a8f6, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4b4106a3f93903a8$export$f7d2e4ec75445680), {
        setApplyEnabled: setApplyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71fd4ce80b940ebd$export$851f9125c323a8f6, {
        width: "33%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Slicers",
        onClick: resetSlicers,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71fd4ce80b940ebd$export$851f9125c323a8f6, {
        width: "33%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save Slicers",
        onClick: saveSlicers,
        disabled: applyEnabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($71fd4ce80b940ebd$export$851f9125c323a8f6, {
        width: "33%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Load Slicers",
        onClick: loadSlicers
    })));
};













const $aec6afd803bc499f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $aec6afd803bc499f$export$3b2855f9143078eb = ()=>{
    const [stepLabels, setStepLabels] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newStepLabels = {
            ...stepLabels,
            [key]: e.target.checked
        };
        setStepLabels(newStepLabels);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepLabels(newStepLabels);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setStepLabels((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepLabels());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setStepLabels((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepLabels());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    const label = "# " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($aec6afd803bc499f$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: label,
        checked: !!stepLabels.tasks,
        handleOnChange: onChange("tasks")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "% total",
        checked: !!stepLabels.total,
        handleOnChange: onChange("total")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "average duration",
        checked: !!stepLabels.avg_duration,
        handleOnChange: onChange("avg_duration")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "median duration",
        checked: !!stepLabels.med_duration,
        handleOnChange: onChange("med_duration")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "min duration",
        checked: !!stepLabels.min_duration,
        handleOnChange: onChange("min_duration")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "max duration",
        checked: !!stepLabels.max_duration,
        handleOnChange: onChange("max_duration")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "avg cost",
        checked: !!stepLabels.avg_cost,
        handleOnChange: onChange("avg_cost")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "std deviation",
        checked: !!stepLabels.deviation,
        handleOnChange: onChange("deviation")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "% compliant",
        checked: !!stepLabels.compliant,
        handleOnChange: onChange("compliant")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "% automated",
        checked: !!stepLabels.automated,
        handleOnChange: onChange("automated")
    }));
};






const $3a2bee71c627b6e5$var$options = [
    {
        value: "4pt",
        label: "Very Small"
    },
    {
        value: "5pt",
        label: "Small"
    },
    {
        value: "6pt",
        label: "Normal"
    },
    {
        value: "7pt",
        label: "Large"
    },
    {
        value: "8pt",
        label: "Very Large"
    }, 
];
const $3a2bee71c627b6e5$export$d0378b18c03eb5bc = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("6pt");
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStepLabelFontSize({
            font_size: value
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepLabelFontSize().font_size);
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            const settings = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStepLabelFontSize();
            setValue(settings.font_size);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $3a2bee71c627b6e5$var$options,
        onChange: onChange,
        value: value
    });
};






const $f65047d151ba8c0b$var$options = [
    {
        value: "5pt",
        label: "Very Small"
    },
    {
        value: "6pt",
        label: "Small"
    },
    {
        value: "7pt",
        label: "Normal"
    },
    {
        value: "8pt",
        label: "Large"
    },
    {
        value: "9pt",
        label: "Very Large"
    }, 
];
const $f65047d151ba8c0b$export$6573d433abd4d43 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("6pt");
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeNodeLabelFontSize({
            font_size: value
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getNodeLabelFontSize().font_size);
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            const settings = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getNodeLabelFontSize();
            setValue(settings.font_size);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $f65047d151ba8c0b$var$options,
        onChange: onChange,
        value: value
    });
};








const $d34e0eabfee47884$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $d34e0eabfee47884$export$b507fa6ea968572c = ()=>{
    const [DurationFormat, setDurationFormat] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newDurationFormat = {
            ...DurationFormat,
            [key]: e.target.checked
        };
        setDurationFormat(newDurationFormat);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeDurationFormat(newDurationFormat);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setDurationFormat((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDurationFormat());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setDurationFormat((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDurationFormat());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d34e0eabfee47884$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "days",
        checked: !!DurationFormat.days,
        handleOnChange: onChange("days")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "hours",
        checked: !!DurationFormat.hours,
        handleOnChange: onChange("hours")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "minutes",
        checked: !!DurationFormat.minutes,
        handleOnChange: onChange("minutes")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "seconds",
        checked: !!DurationFormat.seconds,
        handleOnChange: onChange("seconds")
    }));
};








const $4851e80d822c5494$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $4851e80d822c5494$export$4fa6285ff33f2bd5 = ()=>{
    const [NodeLabels, setNodeLabels] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newNodeLabels = {
            ...NodeLabels,
            [key]: e.target.checked
        };
        setNodeLabels(newNodeLabels);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeNodeLabels(newNodeLabels);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setNodeLabels((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getNodeLabels());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setNodeLabels((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getNodeLabels());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    const label = "# " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4851e80d822c5494$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: label,
        checked: !!NodeLabels.tasks,
        handleOnChange: onChange("tasks")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "% total",
        checked: !!NodeLabels.perc_total,
        handleOnChange: onChange("perc_total")
    }));
};










const $811d5d6f1f68ac4b$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
`;
const $811d5d6f1f68ac4b$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
`;
const $811d5d6f1f68ac4b$var$Preview = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    cursor: pointer;
    background-color: ${({ color: color  })=>color};
    margin: 5px;
    border-radius: 2px;
    width: 16px;
    height: 16px;
`;
const $811d5d6f1f68ac4b$export$5a1d7ca0a925d9c2 = ({ id: id , onColorChange: onColorChange , label: label , color: color , className: className , onClose: onClose ,  })=>{
    const inputRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const { props: props , setProps: setProps ,  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $d86a247d67d6d1e1$export$cfac98503b32f6d6));
    const [stateColor, setStateColor] = (0, ($parcel$interopDefault($lR8r2$react))).useState(color);
    const handleOnClick = (e)=>{
        const { x: x , y: y  } = inputRef.current.getBoundingClientRect();
        setProps({
            x: x,
            y: y,
            show: true,
            color: stateColor,
            id: id,
            onClose: onClose
        });
        e.stopPropagation();
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (props.id === id && props.color !== stateColor) {
            setStateColor(props.color);
            onColorChange(props.color);
        }
    }, [
        id,
        onColorChange,
        props,
        stateColor
    ]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setStateColor(color);
    }, [
        color
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($811d5d6f1f68ac4b$var$Wrapper, {
        ref: inputRef,
        className: className,
        onClick: handleOnClick
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($811d5d6f1f68ac4b$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($811d5d6f1f68ac4b$var$Preview, {
        color: stateColor
    }));
};




const $313fbb3f26b3d6d5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
`;
const $313fbb3f26b3d6d5$var$StyledColorInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $811d5d6f1f68ac4b$export$5a1d7ca0a925d9c2))`
    margin-right: 30px;

    &:last-child {
        margin: 0
    }
`;
const $313fbb3f26b3d6d5$export$c537fa0d021d010b = ()=>{
    const [initialColors, setInitialColors, ] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    let currentKey = "";
    const changeColor = $lR8r2$lodashfp.curry((key, color)=>{
        currentKey = key;
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeColors({
            [key]: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(color).toRgbString()
        });
    });
    const onClose = ()=>{
        if (currentKey !== "visualizerBackgroundColor") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
        else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor);
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setInitialColors((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getColors());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setInitialColors((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getColors());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "activity_text",
        onClose: onClose,
        onColorChange: changeColor("activityTextColor"),
        label: "Activity Text",
        color: initialColors.activityTextColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "activity_fill",
        onClose: onClose,
        onColorChange: changeColor("activityFillColor"),
        label: "Activity Fill",
        color: initialColors.activityFillColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "step",
        onClose: onClose,
        onColorChange: changeColor("linkColor"),
        label: "Step",
        color: initialColors.linkColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "selectActivity",
        onClose: onClose,
        onColorChange: changeColor("selectActivityColor"),
        label: "Activity Select",
        color: initialColors.selectActivityColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "selectLink",
        onClose: onClose,
        onColorChange: changeColor("selectLinkColor"),
        label: "Link Select",
        color: initialColors.selectLinkColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "animate",
        onClose: onClose,
        onColorChange: changeColor("animateColor"),
        label: "Animate",
        color: initialColors.animateColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "loop",
        onClose: onClose,
        onColorChange: changeColor("loopColor"),
        label: "Step Loops",
        color: initialColors.loopColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "compliance",
        onClose: onClose,
        onColorChange: changeColor("nonCompliantColor"),
        label: "Non Compliant Steps",
        color: initialColors.nonCompliantColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "partial_compliance",
        onClose: onClose,
        onColorChange: changeColor("partialNonCompliantColor"),
        label: "Partial Non Compliant Steps",
        color: initialColors.partialNonCompliantColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "automation",
        onClose: onClose,
        onColorChange: changeColor("automationColor"),
        label: "Automated Steps",
        color: initialColors.automationColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "partial_automation",
        onClose: onClose,
        onColorChange: changeColor("partialAutomationColor"),
        label: "Partial Automated Steps",
        color: initialColors.partialAutomationColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "visualizerbackground",
        onClose: onClose,
        onColorChange: changeColor("visualizerBackgroundColor"),
        label: "Visualizer Background",
        color: initialColors.visualizerBackgroundColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "startnode",
        onClose: onClose,
        onColorChange: changeColor("startNodeColor"),
        label: "Start Node",
        color: initialColors.startNodeColor
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($313fbb3f26b3d6d5$var$StyledColorInput, {
        id: "endnode",
        onClose: onClose,
        onColorChange: changeColor("endNodeColor"),
        label: "End Node",
        color: initialColors.endNodeColor
    }));
};








const $178041dec98d964e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $178041dec98d964e$export$6d0fbe263f752478 = ()=>{
    const [StartLabel, setStartLabel] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newStartLabel = {
            ...StartLabel,
            [key]: e.target.checked
        };
        setStartLabel(newStartLabel);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeStartLabel(newStartLabel);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setStartLabel((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStartLabel());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setStartLabel((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getStartLabel());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($178041dec98d964e$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!StartLabel.visible,
        handleOnChange: onChange("visible")
    }));
};








const $3aa0ee97f5363cc7$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $3aa0ee97f5363cc7$export$1dfc7cd36e288043 = ()=>{
    const [EndLabel, setEndLabel] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newEndLabel = {
            ...EndLabel,
            [key]: e.target.checked
        };
        setEndLabel(newEndLabel);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeEndLabel(newEndLabel);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setEndLabel((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEndLabel());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setEndLabel((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEndLabel());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aa0ee97f5363cc7$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!EndLabel.visible,
        handleOnChange: onChange("visible")
    }));
};








const $46b8b2d154a6dd8b$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $46b8b2d154a6dd8b$export$dd0831c4963b4170 = ()=>{
    const [showNodes, setShowNodes] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newShowNodes = {
            ...showNodes,
            [key]: e.target.checked
        };
        setShowNodes(newShowNodes);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeShowNodes(newShowNodes);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setShowNodes((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getShowNodes());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setShowNodes((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getShowNodes());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($46b8b2d154a6dd8b$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "show start",
        checked: !!showNodes.start,
        handleOnChange: onChange("start")
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "show end",
        checked: !!showNodes.end,
        handleOnChange: onChange("end")
    }));
};








const $2d5857a7f9c469bf$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $2d5857a7f9c469bf$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $9d28124c6326106c$export$6bf0cd3a219bbade))`
    margin-right: 30px;
`;
const $2d5857a7f9c469bf$export$a39947a896defee6 = ()=>{
    let [spacings, setSpacings] = $lR8r2$react.useState({
        layer: 0,
        column: 0
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setSpacings({
            ...spacings,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setSpacings(spacings);
    });
    $lR8r2$react.useEffect(()=>{
        setSpacings((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getSpacings());
    }, []);
    $lR8r2$react.useEffect(()=>{
        const listener = ()=>{
            const values = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getSpacings();
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setSpacings(values);
            setSpacings(values);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($2d5857a7f9c469bf$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($2d5857a7f9c469bf$var$StyledNumberInput, {
        label: "Column",
        value: spacings.column,
        onChange: onChange("column"),
        onBlur: onBlur("column")
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $9d28124c6326106c$export$6bf0cd3a219bbade), {
        label: "Layer",
        value: spacings.layer,
        onChange: onChange("layer"),
        onBlur: onBlur("layer")
    }));
};








const $57f5aee26bf65c5d$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $57f5aee26bf65c5d$export$11c7196c4815858a = ()=>{
    const [ZoomToFit, setZoomToFit] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newZoomToFit = {
            ...ZoomToFit,
            [key]: e.target.checked
        };
        setZoomToFit(newZoomToFit);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeZoomToFit(newZoomToFit);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildPVDiagram({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setZoomToFit((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getZoomToFit());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setZoomToFit((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getZoomToFit());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($57f5aee26bf65c5d$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!ZoomToFit.visible,
        handleOnChange: onChange("visible")
    }));
};







const $8c16cbbce2c79428$var$options = [
    {
        value: 0,
        label: "Left to right"
    },
    {
        value: 90,
        label: "Top to bottom"
    },
    {
        value: 180,
        label: "Right to left"
    },
    {
        value: 270,
        label: "Bottom to top"
    }, 
];
const $8c16cbbce2c79428$export$b00fda0502cf61f7 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(90);
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setProcessFlowDirection({
            direction: value
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            const direction = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getProcessFlowDirection();
            setValue(direction.direction);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).loadVisualizerSettings, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $8c16cbbce2c79428$var$options,
        onChange: onChange,
        value: value
    });
};











const $2248b9778141441e$export$8ebcecbecdb22732 = ()=>{
    const [open, setOpen] = $lR8r2$react.useState(false);
    const [message, setMessage] = $lR8r2$react.useState();
    const [severity, setSeverity] = $lR8r2$react.useState();
    $lR8r2$react.useEffect(()=>{
        const listener = (props1, props2, props3, props4)=>{
            setMessage(props1);
            setSeverity(props2);
            setOpen(props3);
            if (props4 == true) setTimeout(()=>{
                setOpen(false);
            }, 3000);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).visualizerSettingsAlert, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).visualizerSettingsAlert, listener);
        };
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Box), {
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Collapse), {
        in: open
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Alert), {
        severity: severity,
        action: /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.IconButton), {
            "aria-label": "close",
            color: "inherit",
            size: "small",
            onClick: ()=>{
                setOpen(false);
            }
        }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuiicons.Close), {
            fontSize: "inherit"
        })),
        sx: {
            mb: 2
        }
    }, message)));
};



const $5e616ed76f8d24ff$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
function $5e616ed76f8d24ff$var$fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = ()=>{
        callback(reader.result);
    };
}
const $5e616ed76f8d24ff$export$f2a2e50ddb11f394 = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const saveVisualizerSettings = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveVisualizerSettings({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Visualizer settings saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "settings_visualizer"
        });
    };
    const resetVisualizerSettings = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetVisualizerSettings();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).loadVisualizerSettings({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setProcessFlowDirection({
            direction: 90
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Visualizer settings reset",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "settings_visualizer"
        });
    };
    const loadVisualizerSettings = ()=>{
        const inputFile = document.createElement("input");
        inputFile.type = "file";
        inputFile.click();
        inputFile.addEventListener("change", ()=>{
            const file = inputFile.files[0];
            $5e616ed76f8d24ff$var$fileToText(file, (text)=>{
                setProps({
                    functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).importVisualizerSettings({
                            visualizerSettings: text
                        })
                });
            });
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5e616ed76f8d24ff$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Flow Direction"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8c16cbbce2c79428$export$b00fda0502cf61f7), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Spacing"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2d5857a7f9c469bf$export$a39947a896defee6), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Labels"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $aec6afd803bc499f$export$3b2855f9143078eb), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Show Start Label"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $178041dec98d964e$export$6d0fbe263f752478), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Show End Label"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3aa0ee97f5363cc7$export$1dfc7cd36e288043), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Step Label Font Size"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3a2bee71c627b6e5$export$d0378b18c03eb5bc), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Nodes"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $46b8b2d154a6dd8b$export$dd0831c4963b4170), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Node Labels"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4851e80d822c5494$export$4fa6285ff33f2bd5), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Node Label Font Size"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f65047d151ba8c0b$export$6573d433abd4d43), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Duration Format"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d34e0eabfee47884$export$b507fa6ea968572c), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Colors"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $313fbb3f26b3d6d5$export$c537fa0d021d010b), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Zoom to fit"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $57f5aee26bf65c5d$export$11c7196c4815858a), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save Settings",
        onClick: saveVisualizerSettings
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Load Settings",
        onClick: loadVisualizerSettings
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Settings",
        onClick: resetVisualizerSettings
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2248b9778141441e$export$8ebcecbecdb22732), null));
};








const $a028dbfa5dc2b69f$var$getBorder = $lR8r2$lodashfp.curry((propName, props)=>props[propName] ? `1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")(props)}` : "none");
const $a028dbfa5dc2b69f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    flex-direction: column;
    width: ${({ width: width  })=>width || "100%"};
    border-left: ${$a028dbfa5dc2b69f$var$getBorder("borderLeft")};
    border-bottom: ${$a028dbfa5dc2b69f$var$getBorder("borderBottom")};
    border-top: ${$a028dbfa5dc2b69f$var$getBorder("borderTop")};
    border-right: ${$a028dbfa5dc2b69f$var$getBorder("borderRight")};
    padding-left: 5px;
    position: relative;
    margin-left: ${$a028dbfa5dc2b69f$var$getBorder("marginLeft")};
`;
const $a028dbfa5dc2b69f$export$851f9125c323a8f6 = ({ children: children , ...props })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a028dbfa5dc2b69f$var$Wrapper, props, children);











const $a2a4dbd3d12bf98d$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $a2a4dbd3d12bf98d$export$29f277292576b452 = ()=>{
    const [PercOfEvents, setPercOfEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercOfEvents = {
            ...PercOfEvents,
            [key]: e.target.checked
        };
        setPercOfEvents(newPercOfEvents);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercOfEvents(newPercOfEvents);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercOfEvents((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercOfEvents());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercOfEvents((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercOfEvents());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a2a4dbd3d12bf98d$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercOfEvents.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $c5e6c95a0ae8eedc$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $c5e6c95a0ae8eedc$export$c75592a6e6ef0690 = ()=>{
    const [XofYVariants, setXofYVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYVariants = {
            ...XofYVariants,
            [key]: e.target.checked
        };
        setXofYVariants(newXofYVariants);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariants(newXofYVariants);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYVariants((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariants());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYVariants((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariants());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c5e6c95a0ae8eedc$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYVariants.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $703f0df94fc2f57e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $703f0df94fc2f57e$export$887666119d95551e = ()=>{
    const [XofYSteps, setXofYSteps] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYSteps = {
            ...XofYSteps,
            [key]: e.target.checked
        };
        setXofYSteps(newXofYSteps);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYSteps(newXofYSteps);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYSteps((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYSteps());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYSteps((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYSteps());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($703f0df94fc2f57e$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYSteps.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $a2c631890dbf3bf3$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $a2c631890dbf3bf3$export$f6c7302f8e4dc295 = ()=>{
    const [XofYActivities, setXofYActivities] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYActivities = {
            ...XofYActivities,
            [key]: e.target.checked
        };
        setXofYActivities(newXofYActivities);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYActivities(newXofYActivities);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYActivities((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYActivities());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYActivities((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYActivities());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a2c631890dbf3bf3$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYActivities.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $4065385a4e89255a$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $4065385a4e89255a$export$5b3c0f8d697414e9 = ()=>{
    const [PercOfTasks, setPercOfTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercOfTasks = {
            ...PercOfTasks,
            [key]: e.target.checked
        };
        setPercOfTasks(newPercOfTasks);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercOfTasks(newPercOfTasks);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercOfTasks((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercOfTasks());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercOfTasks((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercOfTasks());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4065385a4e89255a$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercOfTasks.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $9cccfa666c8ee18a$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $9cccfa666c8ee18a$export$4f8024900d2a732e = ()=>{
    const [XofYVariantsCompliant, setXofYVariantsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYVariantsCompliant = {
            ...XofYVariantsCompliant,
            [key]: e.target.checked
        };
        setXofYVariantsCompliant(newXofYVariantsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsCompliant(newXofYVariantsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYVariantsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariantsCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYVariantsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariantsCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9cccfa666c8ee18a$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYVariantsCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $f2cb13096f723aca$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $f2cb13096f723aca$export$6706db205acae624 = ()=>{
    const [XofYTasksCompliant, setXofYTasksCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYTasksCompliant = {
            ...XofYTasksCompliant,
            [key]: e.target.checked
        };
        setXofYTasksCompliant(newXofYTasksCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksCompliant(newXofYTasksCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYTasksCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYTasksCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYTasksCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYTasksCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f2cb13096f723aca$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYTasksCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $0722d8bf5cb1ddc5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $0722d8bf5cb1ddc5$export$7c73ac2ad0a78b59 = ()=>{
    const [XofYEventsCompliant, setXofYEventsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYEventsCompliant = {
            ...XofYEventsCompliant,
            [key]: e.target.checked
        };
        setXofYEventsCompliant(newXofYEventsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsCompliant(newXofYEventsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYEventsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYEventsCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYEventsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYEventsCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0722d8bf5cb1ddc5$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYEventsCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $ca6385e4ee8b99c1$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $ca6385e4ee8b99c1$export$ad45023598cdfdb1 = ()=>{
    const [PercVariantsCompliant, setPercVariantsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercVariantsCompliant = {
            ...PercVariantsCompliant,
            [key]: e.target.checked
        };
        setPercVariantsCompliant(newPercVariantsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsCompliant(newPercVariantsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercVariantsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercVariantsCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercVariantsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercVariantsCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca6385e4ee8b99c1$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercVariantsCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $1b1af08c7a202775$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $1b1af08c7a202775$export$2cfa8516ab7bdde2 = ()=>{
    const [PercTasksCompliant, setPercTasksCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercTasksCompliant = {
            ...PercTasksCompliant,
            [key]: e.target.checked
        };
        setPercTasksCompliant(newPercTasksCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksCompliant(newPercTasksCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercTasksCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercTasksCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercTasksCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercTasksCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1b1af08c7a202775$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercTasksCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $bc17e7608e5d41d3$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $bc17e7608e5d41d3$export$68045c16a1f31d6 = ()=>{
    const [PercEventsCompliant, setPercEventsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercEventsCompliant = {
            ...PercEventsCompliant,
            [key]: e.target.checked
        };
        setPercEventsCompliant(newPercEventsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsCompliant(newPercEventsCompliant);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercEventsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercEventsCompliant());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercEventsCompliant((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercEventsCompliant());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bc17e7608e5d41d3$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercEventsCompliant.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $f8eba5b7c93bc178$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $f8eba5b7c93bc178$export$36c11af6c0f214dc = ()=>{
    const [XofYVariantsAutomated, setXofYVariantsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYVariantsAutomated = {
            ...XofYVariantsAutomated,
            [key]: e.target.checked
        };
        setXofYVariantsAutomated(newXofYVariantsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsAutomated(newXofYVariantsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYVariantsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariantsAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYVariantsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYVariantsAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f8eba5b7c93bc178$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYVariantsAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $c9947ec4d19fee0c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $c9947ec4d19fee0c$export$3711a63065a6f278 = ()=>{
    const [XofYTasksAutomated, setXofYTasksAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYTasksAutomated = {
            ...XofYTasksAutomated,
            [key]: e.target.checked
        };
        setXofYTasksAutomated(newXofYTasksAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksAutomated(newXofYTasksAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYTasksAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYTasksAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYTasksAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYTasksAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c9947ec4d19fee0c$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYTasksAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $48779e221749d1b4$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $48779e221749d1b4$export$14410631da7e6f56 = ()=>{
    const [XofYEventsAutomated, setXofYEventsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newXofYEventsAutomated = {
            ...XofYEventsAutomated,
            [key]: e.target.checked
        };
        setXofYEventsAutomated(newXofYEventsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsAutomated(newXofYEventsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setXofYEventsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYEventsAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setXofYEventsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getXofYEventsAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($48779e221749d1b4$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!XofYEventsAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $ca26ac4edfc4a702$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $ca26ac4edfc4a702$export$2315bdd781b2578a = ()=>{
    const [PercVariantsAutomated, setPercVariantsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercVariantsAutomated = {
            ...PercVariantsAutomated,
            [key]: e.target.checked
        };
        setPercVariantsAutomated(newPercVariantsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsAutomated(newPercVariantsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercVariantsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercVariantsAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercVariantsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercVariantsAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ca26ac4edfc4a702$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercVariantsAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $34d49f67d33e7b9d$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $34d49f67d33e7b9d$export$93b40be4e49cf16b = ()=>{
    const [PercTasksAutomated, setPercTasksAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercTasksAutomated = {
            ...PercTasksAutomated,
            [key]: e.target.checked
        };
        setPercTasksAutomated(newPercTasksAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksAutomated(newPercTasksAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercTasksAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercTasksAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercTasksAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercTasksAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($34d49f67d33e7b9d$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercTasksAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $adf65542329f4ee6$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $adf65542329f4ee6$export$7f50bef9533fd4ca = ()=>{
    const [PercEventsAutomated, setPercEventsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercEventsAutomated = {
            ...PercEventsAutomated,
            [key]: e.target.checked
        };
        setPercEventsAutomated(newPercEventsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsAutomated(newPercEventsAutomated);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercEventsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercEventsAutomated());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercEventsAutomated((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercEventsAutomated());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($adf65542329f4ee6$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercEventsAutomated.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $4c1cf115de1a3f01$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $4c1cf115de1a3f01$export$b72049501f106c00 = ()=>{
    const [PercCostSaving, setPercCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newPercCostSaving = {
            ...PercCostSaving,
            [key]: e.target.checked
        };
        setPercCostSaving(newPercCostSaving);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercCostSaving(newPercCostSaving);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setPercCostSaving((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercCostSaving());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setPercCostSaving((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getPercCostSaving());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4c1cf115de1a3f01$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!PercCostSaving.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $c6490400267edf68$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $c6490400267edf68$export$94a91592e82e7faf = ()=>{
    const [AvgCostSavingPerTask, setAvgCostSavingPerTask] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newAvgCostSavingPerTask = {
            ...AvgCostSavingPerTask,
            [key]: e.target.checked
        };
        setAvgCostSavingPerTask(newAvgCostSavingPerTask);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostSavingPerTask(newAvgCostSavingPerTask);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setAvgCostSavingPerTask((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getAvgCostSavingPerTask());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setAvgCostSavingPerTask((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getAvgCostSavingPerTask());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($c6490400267edf68$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!AvgCostSavingPerTask.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $2fa6b492029baf56$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $2fa6b492029baf56$export$149d9d230fc36c43 = ()=>{
    const [AvgCostPerTask, setAvgCostPerTask] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newAvgCostPerTask = {
            ...AvgCostPerTask,
            [key]: e.target.checked
        };
        setAvgCostPerTask(newAvgCostPerTask);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostPerTask(newAvgCostPerTask);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setAvgCostPerTask((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getAvgCostPerTask());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setAvgCostPerTask((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getAvgCostPerTask());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2fa6b492029baf56$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!AvgCostPerTask.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $41ba2db14562d8d2$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $41ba2db14562d8d2$export$29d8a324743c0b93 = ()=>{
    const [CostSaving, setCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newCostSaving = {
            ...CostSaving,
            [key]: e.target.checked
        };
        setCostSaving(newCostSaving);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeCostSaving(newCostSaving);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setCostSaving((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCostSaving());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setCostSaving((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCostSaving());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($41ba2db14562d8d2$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!CostSaving.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $4a655e70b5abb3bc$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $4a655e70b5abb3bc$export$9e1e9245dca96bbf = ()=>{
    const [ActualCost, setActualCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newActualCost = {
            ...ActualCost,
            [key]: e.target.checked
        };
        setActualCost(newActualCost);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActualCost(newActualCost);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setActualCost((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActualCost());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setActualCost((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActualCost());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4a655e70b5abb3bc$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!ActualCost.gauge,
        handleOnChange: onChange("gauge")
    }));
};








const $db96480a6d197d9f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
`;
const $db96480a6d197d9f$export$1928aa2d7268bf02 = ()=>{
    const [ForecastCost, setForecastCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState({});
    const onChange = $lR8r2$lodashfp.curry((key, e)=>{
        const newForecastCost = {
            ...ForecastCost,
            [key]: e.target.checked
        };
        setForecastCost(newForecastCost);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeForecastCost(newForecastCost);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
    });
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setForecastCost((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getForecastCost());
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setForecastCost((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getForecastCost());
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateMetricSettings, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($db96480a6d197d9f$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!ForecastCost.gauge,
        handleOnChange: onChange("gauge")
    }));
};



const $55c6e781c503a3af$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $55c6e781c503a3af$export$6fad391fa497c4f2 = ()=>{
    const resetGauges = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetGauges();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({
            rule: "reset"
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateMetricSettings({});
    };
    const title1 = "% of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s";
    const title2 = "x of total " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s compliant";
    const title3 = "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s compliant";
    const title4 = "x of total " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s automated";
    const title5 = "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s automated";
    const title6 = "avg cost saving per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower();
    const title7 = "avg cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower();
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($55c6e781c503a3af$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% of events"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a2a4dbd3d12bf98d$export$29f277292576b452), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title1
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4065385a4e89255a$export$5b3c0f8d697414e9), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total variants"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c5e6c95a0ae8eedc$export$c75592a6e6ef0690), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total steps"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $703f0df94fc2f57e$export$887666119d95551e), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total activites"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a2c631890dbf3bf3$export$f6c7302f8e4dc295), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total variants compliant"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9cccfa666c8ee18a$export$4f8024900d2a732e), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title2
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f2cb13096f723aca$export$6706db205acae624), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total events compliant"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $0722d8bf5cb1ddc5$export$7c73ac2ad0a78b59), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% variants compliant"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ca6385e4ee8b99c1$export$ad45023598cdfdb1), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title3
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1b1af08c7a202775$export$2cfa8516ab7bdde2), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% events compliant"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $bc17e7608e5d41d3$export$68045c16a1f31d6), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total variants automated"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f8eba5b7c93bc178$export$36c11af6c0f214dc), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title4
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c9947ec4d19fee0c$export$3711a63065a6f278), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "x of total events automated"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $48779e221749d1b4$export$14410631da7e6f56), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% variants automated"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ca26ac4edfc4a702$export$2315bdd781b2578a), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title5
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $34d49f67d33e7b9d$export$93b40be4e49cf16b), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% events automated"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $adf65542329f4ee6$export$7f50bef9533fd4ca), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "% cost saving"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4c1cf115de1a3f01$export$b72049501f106c00), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title6
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c6490400267edf68$export$94a91592e82e7faf), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: title7
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2fa6b492029baf56$export$149d9d230fc36c43), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "actual cost"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4a655e70b5abb3bc$export$9e1e9245dca96bbf), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "forecast cost"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $db96480a6d197d9f$export$1928aa2d7268bf02), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "40%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "cost saving"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "60%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $41ba2db14562d8d2$export$29d8a324743c0b93), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "45%"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset",
        onClick: resetGauges
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a028dbfa5dc2b69f$export$851f9125c323a8f6), {
        width: "45%"
    }));
};






const $3e4454f54df3bf6f$var$Header = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("normal")};
    font-weight: ${(0, $d18c0fc16613166e$export$16eeca46eca75f64)("bold")};
    margin-bottom: 5px;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")}
`;
/*
const Panel = styled.div<{ isActive: boolean }>`
    visibility: ${({ isActive }) => isActive ? 'visible' : 'hidden'};
    overflow: hidden;
    ${({ isActive }) => isActive ? '' : 'height: 0'};
    width: 100%;
`;
*/ const $3e4454f54df3bf6f$var$Panel = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: ${({ isActive: isActive  })=>isActive ? "block" : "none"};
    width: 100%;
`;
const $3e4454f54df3bf6f$export$ab245654d3c5ee0c = ({ activeTab: activeTab , tab: tab , title: title , children: children  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3e4454f54df3bf6f$var$Panel, {
        isActive: activeTab === tab
    }, title ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3e4454f54df3bf6f$var$Header, null, title) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3e4454f54df3bf6f$var$Header, null, (0, $1425a2da6c58fa32$export$a61a941c0d68dcb1)[tab]), activeTab === tab && children);
























const $a4b53365d9989ed4$export$8ebcecbecdb22732 = ()=>{
    const [open, setOpen] = $lR8r2$react.useState(false);
    const [message, setMessage] = $lR8r2$react.useState();
    const [severity, setSeverity] = $lR8r2$react.useState();
    $lR8r2$react.useEffect(()=>{
        const listener = (props1, props2, props3, props4)=>{
            setMessage(props1);
            setSeverity(props2);
            setOpen(props3);
            if (props4 == true) setTimeout(()=>{
                setOpen(false);
            }, 3000);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).uploadFileAlert, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).uploadFileAlert, listener);
        };
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Box), {
        sx: {
            width: "100%"
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Collapse), {
        in: open
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.Alert), {
        severity: severity,
        action: /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuicore.IconButton), {
            "aria-label": "close",
            color: "inherit",
            size: "small",
            onClick: ()=>{
                setOpen(false);
            }
        }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$materialuiicons.Close), {
            fontSize: "inherit"
        })),
        sx: {
            mb: 2
        }
    }, message)));
};





const $37545eaebff611bb$var$options = [
    {
        value: "Task",
        label: "Task"
    },
    {
        value: "Case",
        label: "Case"
    },
    {
        value: "Invoice",
        label: "Invoice"
    }, 
];
const $37545eaebff611bb$export$50f02d20b9547443 = ()=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const onChange = (value)=>{
        setValue(value);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEntity({
            entity: value,
            initial: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processEventLog_File();
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setValue("Task");
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEntity({
            entity: "Task",
            initial: true
        });
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $37545eaebff611bb$var$options,
        onChange: onChange,
        value: value
    });
};




const $1b19fe9c4ea38162$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 15px;
`;
const $1b19fe9c4ea38162$var$SingleBlockCSV = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    margin-top: 15px;
    margin-left: 15px;
`;
const $1b19fe9c4ea38162$var$SingleBlockEntities = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    margin-top: 25px;
    margin-bottom: 10px;
    margin-left: 15px;
`;
const $1b19fe9c4ea38162$export$a76b9081bf1aface = ({ nextDisabled: nextDisabled  })=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const handleOnDrop = (data, file)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).uploadEventLog({
            csv: data,
            filename: file.name
        });
        //        setProps({
        //            functionToLoad: () => apiProvider.uploadEventLog({ csv: data, filename: file.name }),
        //        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "CSV file uploaded",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "upload_file"
        });
        nextDisabled(false);
    };
    const handleOnError = ()=>{
        nextDisabled(false);
    };
    const handleOnRemoveFile = ()=>{
        nextDisabled(true);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1b19fe9c4ea38162$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1b19fe9c4ea38162$var$SingleBlockCSV, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reactpapaparse.CSVReader), {
        onDrop: handleOnDrop,
        onError: handleOnError,
        addRemoveButton: true,
        removeButtonColor: "#659cef",
        onRemoveFile: handleOnRemoveFile
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("span", null, "Drop your Event Log CSV file here or click to upload"))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1b19fe9c4ea38162$var$SingleBlockEntities, {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Process Entity:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($1b19fe9c4ea38162$var$SingleBlockEntities, {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $37545eaebff611bb$export$50f02d20b9547443), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a4b53365d9989ed4$export$8ebcecbecdb22732), null));
};













const $307e3393b5ed37f5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $307e3393b5ed37f5$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height ,  })=>{
    const grid = (0, $lR8r2$react.useRef)(null);
    const onModelUpdated = (params)=>{
        params.columnApi.autoSizeAllColumns();
    };
    const statusBar = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            }
        ]
    };
    const getMainMenuItems = (params)=>{
        const DefaultMenuItems = params.defaultItems.slice(0);
        const NewMenuItems = [];
        NewMenuItems.push({
            name: "Map column",
            subMenu: [
                {
                    name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " ID",
                    action: ()=>{
                        params.column.colDef.mapping = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " ID";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " ID"
                },
                {
                    name: "Activity",
                    action: ()=>{
                        params.column.colDef.mapping = "Activity";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Activity"
                },
                {
                    name: "Timestamp",
                    action: ()=>{
                        params.column.colDef.mapping = "Timestamp";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Timestamp"
                },
                {
                    name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Create Time",
                    action: ()=>{
                        params.column.colDef.mapping = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Create Time";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Create Time"
                },
                {
                    name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Close Time",
                    action: ()=>{
                        params.column.colDef.mapping = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Close Time";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Close Time"
                },
                {
                    name: "Resource",
                    action: ()=>{
                        params.column.colDef.mapping = "Resource";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Resource"
                },
                {
                    name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attribute",
                    action: ()=>{
                        params.column.colDef.mapping = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attribute";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attribute"
                },
                {
                    name: "Event Attribute",
                    action: ()=>{
                        params.column.colDef.mapping = "Event Attribute";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Event Attribute"
                },
                {
                    name: "Metric - True/False",
                    action: ()=>{
                        params.column.colDef.mapping = "Metric - True/False";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Metric - True/False"
                },
                {
                    name: "Metric - Duration",
                    action: ()=>{
                        params.column.colDef.mapping = "Metric - Duration";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Metric - Duration"
                },
                {
                    name: "Metric - Amount",
                    action: ()=>{
                        params.column.colDef.mapping = "Metric - Amount";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataMapping({
                            field: params.column.colDef.headerName,
                            mapping: params.column.colDef.mapping
                        });
                    },
                    checked: params.column.colDef.mapping === "Metric - Amount"
                }, 
            ]
        });
        NewMenuItems.push({
            name: "Data Type",
            subMenu: [
                {
                    name: "Text",
                    action: ()=>{
                        params.column.colDef.dataType = "Text";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataType({
                            field: params.column.colDef.headerName,
                            type: params.column.colDef.dataType
                        });
                    },
                    checked: params.column.colDef.dataType === "Text"
                },
                {
                    name: "Number",
                    action: ()=>{
                        params.column.colDef.dataType = "Number";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataType({
                            field: params.column.colDef.headerName,
                            type: params.column.colDef.dataType
                        });
                    },
                    checked: params.column.colDef.dataType === "Number"
                },
                {
                    name: "DateTime",
                    action: ()=>{
                        params.column.colDef.dataType = "Datetime";
                        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDataType({
                            field: params.column.colDef.headerName,
                            type: params.column.colDef.dataType
                        });
                    },
                    checked: params.column.colDef.dataType === "Datetime"
                }, 
            ]
        });
        NewMenuItems.push(DefaultMenuItems[1]);
        NewMenuItems.push(DefaultMenuItems[2]);
        NewMenuItems.push(DefaultMenuItems[3]);
        NewMenuItems.push(DefaultMenuItems[4]);
        return NewMenuItems;
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($307e3393b5ed37f5$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        statusBar: statusBar,
        columnDefs: columns,
        suppressMenuHide: true,
        getMainMenuItems: getMainMenuItems,
        onModelUpdated: onModelUpdated,
        ref: grid,
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        defaultColDef: {
            editable: false,
            sortable: true,
            flex: 1,
            minWidth: 100,
            filter: true,
            resizable: true,
            menuTabs: [
                "generalMenuTab",
                "filterMenuTab"
            ]
        },
        rowData: rows
    })));
};


const $ecc62b57d8b63ba0$export$37fba7a98002e069 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [columns, setColumns] = (0, ($parcel$interopDefault($lR8r2$react))).useState(null);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setColumns((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processEventLogHeaderUpload());
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processEventLogUpload());
    });
    let rows = [];
    if (data) rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $307e3393b5ed37f5$export$c8dd51eb24f71762), {
        rows: rows,
        columns: columns,
        height: "300px"
    });
};













const $3566ddd186830648$var$Image = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).img`
    width: 13px;
    height: 13px;
`;
const $3566ddd186830648$export$b131c49b26d3f427 = ({ value: value  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3566ddd186830648$var$Image, {
        src: `${value ? "https://metricuspm.blob.core.windows.net/processminer/TrueIcon.svg" : "https://metricuspm.blob.core.windows.net/processminer/FalseIcon.svg"}`,
        alt: "icon"
    });


const $685badce3aef053c$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
`;
const $685badce3aef053c$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , height: height , setSaveDisabled: setSaveDisabled , setNextDisabled: setNextDisabled , setDeleteDisabled: setDeleteDisabled , step: step ,  })=>{
    const onModelUpdated = (params)=>{
        // this should only be triggered if the EventLog component is active, not the UploadFile component
        if (step !== 0) {
            if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).validateDataTransformation() === true) setNextDisabled(false);
            else setNextDisabled(true);
        }
        if (params.api.getDisplayedRowCount() > 0) setSaveDisabled(false);
        else setSaveDisabled(true);
        params.columnApi.autoSizeAllColumns();
    };
    const onSelectionChanged = (params)=>{
        const selectedNodes = params.api.getSelectedNodes();
        const selectedData = selectedNodes.map((node)=>node.data);
        setDeleteDisabled(false);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDeleteTransformationRow({
            mapping: selectedData[0].mapping
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($685badce3aef053c$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $3566ddd186830648$export$b131c49b26d3f427)
        },
        onModelUpdated: onModelUpdated,
        rowSelection: "single",
        onSelectionChanged: onSelectionChanged,
        columnDefs: columns,
        suppressPropertyNamesCheck: true,
        defaultColDef: {
            sortable: true,
            filter: true,
            flex: 1,
            minWidth: 100,
            resizable: true
        },
        rowData: rows
    })));
};




const $1306e5efbee1392e$var$columnDefs = [
    {
        headerName: "Field",
        field: "field",
        sortable: false,
        minWidth: 80
    },
    {
        headerName: "Mapping",
        field: "mapping",
        sortable: false,
        minWidth: 80
    },
    {
        headerName: "Data Type",
        field: "datatype",
        sortable: false,
        minWidth: 80
    },
    {
        headerName: "Status",
        field: "status",
        cellRenderer: "tableIcon",
        sortable: false,
        minWidth: 40
    },
    {
        headerName: "Issue",
        field: "issue",
        sortable: false,
        minWidth: 200
    }, 
];
const $1306e5efbee1392e$export$61c7b8324777e025 = ({ setNextDisabled: setNextDisabled , setSaveDisabled: setSaveDisabled , setDeleteDisabled: setDeleteDisabled , step: step ,  })=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveDataTransformation());
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateDataTransformation, listener);
        };
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $685badce3aef053c$export$c8dd51eb24f71762), {
        rows: data,
        columns: $1306e5efbee1392e$var$columnDefs,
        step: step,
        setNextDisabled: setNextDisabled,
        setSaveDisabled: setSaveDisabled,
        setDeleteDisabled: setDeleteDisabled,
        height: "250px"
    });
};







const $85251188401ceda9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    margin-top: 15px;
`;
const $85251188401ceda9$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("small")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    margin-top: 12px;
    text-align: left;
    width: 100%;
`;
function $85251188401ceda9$var$fileToText(file, callback) {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = ()=>{
        callback(reader.result);
    };
}
const $85251188401ceda9$export$f8203d08df5cd081 = ({ nextDisabled: nextDisabled , step: step ,  })=>{
    const [saveDisabled, setSaveDisabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [deleteDisabled, setDeleteDisabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const loadTransformation = ()=>{
        const inputFile = document.createElement("input");
        inputFile.type = "file";
        inputFile.click();
        inputFile.addEventListener("change", ()=>{
            const file = inputFile.files[0];
            $85251188401ceda9$var$fileToText(file, (text)=>{
                setProps({
                    functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).importTransformation({
                            importedTransformation: text
                        })
                });
            });
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Transformation loaded",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "event_log_transformation"
        });
    };
    const saveTransformation = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveTransformation({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Transformation saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "event_log_transformation"
        });
    };
    const resetTransformation = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetTransformation({});
        setDeleteDisabled(true);
        setSaveDisabled(true);
    };
    const deleteTransformation = ()=>{
        setDeleteDisabled(true);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).deleteTransformationRow({});
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($85251188401ceda9$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($85251188401ceda9$var$Label, null, "Click ☰ to map a column and select the data type")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ecc62b57d8b63ba0$export$37fba7a98002e069), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1306e5efbee1392e$export$61c7b8324777e025), {
        step: step,
        setSaveDisabled: setSaveDisabled,
        setDeleteDisabled: setDeleteDisabled,
        setNextDisabled: nextDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Delete Transformation",
        onClick: deleteTransformation,
        disabled: deleteDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Reset Transformation",
        onClick: resetTransformation,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save Transformation",
        onClick: saveTransformation,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Load Transformation",
        onClick: loadTransformation
    })));
};





const $46820f204b69ffcd$var$steps = [
    "Upload event log",
    "Assign data types and map columns"
];
const $46820f204b69ffcd$var$StepVisibilityWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: ${({ visible: visible  })=>visible ? "block" : "none"};
`;
function $46820f204b69ffcd$export$56f2894cea2a586c() {
    const [activeStep, setActiveStep] = $lR8r2$react.useState(0);
    const [nextDisabled, setNextDisabled] = $lR8r2$react.useState(true);
    const [activateAPI, setActivateAPI] = $lR8r2$react.useState(false);
    const { setProps: setProps  } = $lR8r2$react.useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const loadData = async ()=>{
        await (0, $57e66c5a34f265b4$export$24e59b9226009be5)();
    };
    const handleNext = ()=>{
        if (activeStep === $46820f204b69ffcd$var$steps.length - 1) {
            // display topbar, processvisualizer and sidebar
            loadData();
            //            setProps({
            //                functionToLoad: () => loadData(),
            //            });
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).displayProcessVisualizer({});
        } else setActiveStep((prevActiveStep)=>prevActiveStep + 1);
    };
    const handleBack = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
    };
    $lR8r2$react.useEffect(()=>{
        // check so see if ProcessVisualizer already exists i.e. api has been initialised
        if (!(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDiagram()) setActivateAPI(true);
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        display: "flex",
        flexDirection: "column",
        sx: {
            bgcolor: "white",
            width: "100%",
            pt: 5,
            pr: 20
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreStepper))), {
        activeStep: activeStep
    }, $46820f204b69ffcd$var$steps.map((label)=>{
        const stepProps = {};
        const labelProps = {};
        return /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreStep))), {
            key: label,
            ...stepProps
        }, /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreStepLabel))), labelProps, label));
    })), /*#__PURE__*/ $lR8r2$react.createElement($lR8r2$react.Fragment, null, /*#__PURE__*/ $lR8r2$react.createElement($46820f204b69ffcd$var$StepVisibilityWrapper, {
        visible: activeStep === 0
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $1b19fe9c4ea38162$export$a76b9081bf1aface), {
        nextDisabled: setNextDisabled
    })), /*#__PURE__*/ $lR8r2$react.createElement($46820f204b69ffcd$var$StepVisibilityWrapper, {
        visible: activeStep === 1
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $85251188401ceda9$export$f8203d08df5cd081), {
        step: activeStep,
        nextDisabled: setNextDisabled
    })), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        sx: {
            display: "flex",
            flexDirection: "row",
            pt: 2
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreButton))), {
        color: "inherit",
        disabled: activeStep === 0,
        onClick: handleBack,
        sx: {
            mr: 1
        }
    }, "Back"), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        sx: {
            flex: "1 1 auto"
        }
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreButton))), {
        onClick: handleNext,
        disabled: nextDisabled
    }, activeStep === $46820f204b69ffcd$var$steps.length - 1 ? "Generate Process Model" : "Next"))), activateAPI ? /*#__PURE__*/ $lR8r2$react.createElement((0, $bf849ab6e916ed21$export$5b6cb3855aed9ca7), {
        visible: false
    }) : "");
}















var $3aee697a99c0b80f$require$Buffer = $lR8r2$buffer.Buffer;
const $3aee697a99c0b80f$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    padding: 0px 0px 15px 0px;  
`;
const $3aee697a99c0b80f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;

var $3aee697a99c0b80f$require$uuidv4 = $lR8r2$uuid.v4;

const $3aee697a99c0b80f$export$1f50821d82779d15 = ()=>{
    const [category, setCategory] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [saveDisabled, setSaveDisabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [saveFilteredOnly, setSaveFilteredOnly] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const handleChangeCategory = (event)=>{
        setCategory(event.target.value);
    };
    const handleChangeDescription = (event)=>{
        const text = event.target.value;
        setDescription(text);
    };
    const handleChangeName = (event)=>{
        const text = event.target.value;
        setName(text);
    };
    const filterSwitch = (event)=>{
        setSaveFilteredOnly(event.target.checked);
    };
    (0, $lR8r2$react.useEffect)(()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).saveFilteredOnly({
            filteredOnly: saveFilteredOnly
        });
    }, [
        saveFilteredOnly
    ]);
    (0, $lR8r2$react.useEffect)(()=>{
        if (category !== "" && name !== "") setSaveDisabled(false);
        else setSaveDisabled(true);
    }, [
        name
    ]);
    (0, $lR8r2$react.useEffect)(()=>{
        if (category !== "" && name !== "") setSaveDisabled(false);
        else setSaveDisabled(true);
    }, [
        category
    ]);
    (0, $lR8r2$react.useEffect)(()=>{}, [
        description
    ]);
    const onSave = ()=>{
        SaveEventLog(category, name, description);
    };
    async function SaveEventLog(category, name, description) {
        const pako = $lR8r2$pako;
        const id = $3aee697a99c0b80f$require$uuidv4();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEventLogID({
            event_log_id: id
        });
        const data_transformation = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveDataTransformation());
        const event_log_csv = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveEventLogCSV();
        const tasks = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskCount();
        const entity = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper();
        const events = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventCount();
        const event_log = pako.deflate(event_log_csv, {
            to: "string"
        });
        var b64 = $3aee697a99c0b80f$require$Buffer.from(event_log).toString("base64");
        let bytes = new TextEncoder().encode(b64).length;
        const data = {
            id: id,
            name: name,
            category: category,
            description: description,
            event_log: b64,
            data_transformation: data_transformation,
            tasks: tasks,
            events: events,
            entity: entity
        };
        let res = await (0, ($parcel$interopDefault($lR8r2$axios)))({
            method: "POST",
            url: `/api/eventlog/create`,
            data: data
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Event Log Saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "upload_file"
        });
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        label: "Category",
        fullWidth: true,
        required: true,
        value: category,
        onChange: handleChangeCategory
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        label: "Name",
        fullWidth: true,
        required: true,
        value: name,
        onChange: handleChangeName
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        fullWidth: true,
        multiline: true,
        label: "Description",
        InputProps: {
            inputComponent: (0, ($parcel$interopDefault($lR8r2$materialuicoreTextareaAutosize)))
        },
        value: description,
        onChange: handleChangeDescription
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.FormControlLabel), {
        control: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Switch), {
            onChange: filterSwitch,
            value: saveFilteredOnly
        }),
        labelPlacement: "start",
        label: "Save only filtered events"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3aee697a99c0b80f$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save",
        onClick: onSave,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a4b53365d9989ed4$export$8ebcecbecdb22732), null));
};














const $0ea78dd273a6a846$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    padding: 0px 0px 15px 0px;  
`;
const $0ea78dd273a6a846$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
let $0ea78dd273a6a846$var$eventLogID = "";
const $0ea78dd273a6a846$export$7ef911e3d06dd7cf = ()=>{
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [eventLogs, setEventLogs] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [inputValue, setInputValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [eventLog, setEventLog] = (0, ($parcel$interopDefault($lR8r2$react))).useState((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventLogName());
    (0, $lR8r2$react.useEffect)(()=>{
        const currentEventLog = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventLogName();
        (0, ($parcel$interopDefault($lR8r2$axios))).get("/api/eventlog/retrieve_all").then((response)=>{
            setEventLogs(response.data.data.eventLogs);
            let temp = [];
            for(var i = 0; i < response.data.data.eventLogs.length; i++){
                var vtp = {};
                vtp["value"] = response.data.data.eventLogs[i].id;
                vtp["label"] = response.data.data.eventLogs[i].name;
                temp.push(vtp);
            }
            setEventLogs(temp);
            setEventLog(currentEventLog);
        });
    }, []);
    const onUpdate = ()=>{
        $0ea78dd273a6a846$var$eventLogID = "";
        for(var i = 0; i < eventLogs.length; i++)if (eventLogs[i].label == inputValue) $0ea78dd273a6a846$var$eventLogID = eventLogs[i].value;
        setProps({
            functionToLoad: ()=>updateEventLog()
        });
    };
    const updateEventLog = async ()=>{
        if ($0ea78dd273a6a846$var$eventLogID != undefined && $0ea78dd273a6a846$var$eventLogID !== "") {
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateEventLogFlag();
            await (0, $57e66c5a34f265b4$export$e665410dcc0a290)($0ea78dd273a6a846$var$eventLogID, true);
        }
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0ea78dd273a6a846$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0ea78dd273a6a846$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreAutocomplete))), {
        disablePortal: true,
        disableClearable: true,
        id: "event_log",
        inputValue: inputValue,
        defaultValue: eventLog,
        isOptionEqualToValue: (option, value)=>option.value === value.value,
        onInputChange: (event, newInputValue)=>{
            setInputValue(newInputValue);
        },
        options: eventLogs,
        sx: {
            width: 400
        },
        renderInput: (params)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
                ...params,
                label: "Event Log"
            })
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($0ea78dd273a6a846$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Update",
        onClick: onUpdate,
        disabled: false
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a4b53365d9989ed4$export$8ebcecbecdb22732), null));
};












const $f94c049637fffd39$export$851f9125c323a8f6 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $2311f6544dcf3569$export$851f9125c323a8f6))`
    padding: 0px 0px 15px 0px;  
`;
const $f94c049637fffd39$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $f94c049637fffd39$export$167015fae0896f16 = ()=>{
    const [category, setCategory] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [eventLogID, setEventLogID] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [saveDisabled, setSaveDisabled] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const handleChangeCategory = (event)=>{
        setCategory(event.target.value);
    };
    const handleChangeName = (event)=>{
        setName(event.target.value);
    };
    const handleChangeDescription = (event)=>{
        const text = event.target.value;
        setDescription(text);
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setEventLogID((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveEventLogID());
    }, []);
    (0, $lR8r2$react.useEffect)(()=>{
        if (name !== "" && description !== "" && category !== "") setSaveDisabled(false);
        else setSaveDisabled(true);
    }, [
        category
    ]);
    (0, $lR8r2$react.useEffect)(()=>{
        if (name !== "" && description !== "" && category !== "") setSaveDisabled(false);
        else setSaveDisabled(true);
    }, [
        name
    ]);
    (0, $lR8r2$react.useEffect)(()=>{
        if (name !== "" && description !== "" && category !== "") setSaveDisabled(false);
        else setSaveDisabled(true);
    }, [
        description
    ]);
    const onSave = ()=>{
        SaveModel(category, name, description);
    };
    async function SaveModel(category, name, description) {
        const modelInfo = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).modelInfo();
        const filters = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveFilters());
        const slicers = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveSlicers());
        const comments = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveComments());
        const visualizer_settings = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveVisualizerSettings());
        const compliance_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveComplianceRules());
        const automation_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveAutomationRules());
        const performance_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrievePerformanceRules());
        const cost_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveCostRules());
        const events = parseInt(modelInfo[0].events);
        const tasks = parseInt(modelInfo[0].tasks);
        const tasks_filtered = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).filteredTasksCount();
        const events_filtered = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).filteredEventsCount();
        const tasks_sliced = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).slicedTasksCount();
        const events_sliced = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).slicedEventsCount();
        const gauges = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).gaugesDisplayed());
        // event_log must be saved before a model can be saved
        const event_log_id = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveEventLogID();
        const data = {
            category: category,
            name: name,
            description: description,
            events: events,
            tasks: tasks,
            gauges: gauges,
            filters: filters,
            slicers: slicers,
            comments: comments,
            visualizer_settings: visualizer_settings,
            compliance_rules: compliance_rules,
            automation_rules: automation_rules,
            performance_rules: performance_rules,
            cost_rules: cost_rules,
            event_log_id: event_log_id,
            tasks_filtered: tasks_filtered,
            events_filtered: events_filtered,
            tasks_sliced: tasks_sliced,
            events_sliced: events_sliced
        };
        if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEnvironment() === "SaaS") {
            let res = await (0, ($parcel$interopDefault($lR8r2$axios)))({
                method: "POST",
                url: `/api/model/create`,
                data: data
            });
        }
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Model Saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "upload_file"
        });
    }
    if (eventLogID === "") return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$var$Wrapper, null, "Event log must be saved before a model can be saved");
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        label: "Model Category",
        required: true,
        value: category,
        onChange: handleChangeCategory
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        label: "Model Name",
        required: true,
        value: name,
        onChange: handleChangeName
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$export$851f9125c323a8f6, {
        width: "100%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTextField))), {
        fullWidth: true,
        multiline: true,
        required: true,
        label: "Model Description",
        InputProps: {
            inputComponent: (0, ($parcel$interopDefault($lR8r2$materialuicoreTextareaAutosize)))
        },
        value: description,
        onChange: handleChangeDescription
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($f94c049637fffd39$export$851f9125c323a8f6, {
        width: "25%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save",
        onClick: onSave,
        disabled: saveDisabled
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a4b53365d9989ed4$export$8ebcecbecdb22732), null));
};












const $d36cd80be0f197a3$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 10px 10px 10px 10px;
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $d36cd80be0f197a3$export$eabde9361b4315f0 = ()=>{
    const [SaveSlicer, setSaveSlicer] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveFilter, setSaveFilter] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveCompliant, setSaveCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SavePerformance, setSavePerformance] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveAutomation, setSaveAutomation] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveCost, setSaveCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveSettings, setSaveSettings] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveGauge, setSaveGauge] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const [SaveComment, setSaveComment] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        setting: true
    });
    const onChangeSlicer = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveSlicer = {
            ...SaveSlicer,
            [key]: e.target.checked
        };
        setSaveSlicer(newSaveSlicer);
    });
    const onChangeFilter = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveFilter = {
            ...SaveFilter,
            [key]: e.target.checked
        };
        setSaveFilter(newSaveFilter);
    });
    const onChangeCompliant = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveCompliant = {
            ...SaveCompliant,
            [key]: e.target.checked
        };
        setSaveCompliant(newSaveCompliant);
    });
    const onChangePerformance = $lR8r2$lodashfp.curry((key, e)=>{
        const newSavePerformance = {
            ...SavePerformance,
            [key]: e.target.checked
        };
        setSavePerformance(newSavePerformance);
    });
    const onChangeAutomation = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveAutomation = {
            ...SaveAutomation,
            [key]: e.target.checked
        };
        setSaveAutomation(newSaveAutomation);
    });
    const onChangeCost = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveCost = {
            ...SaveCost,
            [key]: e.target.checked
        };
        setSaveCost(newSaveCost);
    });
    const onChangeSettings = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveSettings = {
            ...SaveSettings,
            [key]: e.target.checked
        };
        setSaveSettings(newSaveSettings);
    });
    const onChangeComment = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveComment = {
            ...SaveComment,
            [key]: e.target.checked
        };
        setSaveSettings(newSaveComment);
    });
    const onChangeGauge = $lR8r2$lodashfp.curry((key, e)=>{
        const newSaveGauge = {
            ...SaveGauge,
            [key]: e.target.checked
        };
        setSaveSettings(newSaveGauge);
    });
    const onSave = ()=>{
        SaveModel();
    };
    async function SaveModel() {
        const filters = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveFilters()).replace(/"/g, '\\"');
        const slicers = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveSlicers()).replace(/"/g, '\\"');
        const visualizer_settings = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveVisualizerSettings()).replace(/"/g, '\\"');
        const compliance_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveComplianceRules()).replace(/"/g, '\\"');
        const automation_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveAutomationRules()).replace(/"/g, '\\"');
        const performance_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrievePerformanceRules()).replace(/"/g, '\\"');
        const cost_rules = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveCostRules()).replace(/"/g, '\\"');
        const gauges = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).gaugesDisplayed()).replace(/"/g, '\\"');
        const comments = JSON.stringify((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveComments()).replace(/"/g, '\\"');
        // event_log must be saved before a model can be saved
        const event_log_id = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).retrieveEventLogID();
        if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEnvironment() === "ServiceNow") {
            let urlHost = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getURLHost();
            if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDev() === true) urlHost = "https://metricus.service-now.com";
            const url = urlHost + "/api/now/table/x_metl3_pme_model/" + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getModelID();
            var client = new XMLHttpRequest();
            client.open("put", url, false);
            client.setRequestHeader("Accept", "application/json");
            client.setRequestHeader("Content-Type", "application/json");
            client.setRequestHeader("Authorization", "Basic " + btoa("admin:Titliest123!@#"));
            if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDev() === true) client.setRequestHeader("Authorization", "Basic " + btoa("admin:Titliest123!@#"));
            else client.setRequestHeader("X-UserToken", (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getUserSessionToken());
            //var requestBody = "{\"slicers\":\"" + slicers + "\",\"filters\":\"" + filters + "\",\"settings\":\"" + visualizer_settings + "\",\"comments\":\"" + comments + "\",\"gauges\":\"" + gauges + "\",\"compliant_rules\":\"" + compliance_rules + "\",\"performance_rules\":\"" + performance_rules + "\",\"automation_rules\":\"" + automation_rules + "\",\"cost_rules\":\"" + cost_rules + "\"}"; 
            var requestBody = '{"slicers":"' + slicers + '","filters":"' + filters + '","settings":"' + visualizer_settings + '","compliant_rules":"' + compliance_rules + '","performance_rules":"' + performance_rules + '","automation_rules":"' + automation_rules + '","cost_rules":"' + cost_rules + '","gauges":"' + gauges + '","comments":"' + comments + '"}';
            client.onreadystatechange = function() {
                this.readyState, this.DONE;
            };
            client.send(requestBody);
        }
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "Model Saved",
            severity: "success",
            showAlert: true,
            timeOutActive: true,
            component: "upload_file"
        });
    }
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d36cd80be0f197a3$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Slicers"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveSlicer.setting,
        handleOnChange: onChangeSlicer("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Filters"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveFilter.setting,
        handleOnChange: onChangeFilter("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Compliance Rules"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveCompliant.setting,
        handleOnChange: onChangeCompliant("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Performance Rules"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SavePerformance.setting,
        handleOnChange: onChangePerformance("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Automation Rules"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveAutomation.setting,
        handleOnChange: onChangeAutomation("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Cost Rules"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveCost.setting,
        handleOnChange: onChangeCost("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Settings"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveSettings.setting,
        handleOnChange: onChangeSettings("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Comments"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "30%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveComment.setting,
        handleOnChange: onChangeComment("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "20%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Gauges"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "80%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: !!SaveGauge.setting,
        handleOnChange: onChangeGauge("setting")
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "100%",
        align: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Save",
        onClick: onSave
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a4b53365d9989ed4$export$8ebcecbecdb22732), null));
};







const $5d71a022305dbf08$var$animateLoader = (0, $lR8r2$styledcomponents.keyframes)`
    100% {
        opacity: 1;
    }
`;
const $5d71a022305dbf08$var$StyledWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    opacity: 0;
    background-color: rgba(145, 145, 145, 0.3);
    animation: ${$5d71a022305dbf08$var$animateLoader} 10ms 0.3s linear forwards;
`;
const $5d71a022305dbf08$var$animateCircle = (0, $lR8r2$styledcomponents.keyframes)`
    100% {
        transform: translate(-50%, -50%) rotate(360deg)
    }
`;
const $5d71a022305dbf08$var$CircularProgress = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 60px;
    height: 60px;
    border-radius: 50px;

    border: 10px;
    border-style: solid;
    border-color: transparent;
    border-top-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    border-right-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    border-bottom-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};

    position: absolute;
    animation: ${$5d71a022305dbf08$var$animateCircle} 0.8s linear infinite;

    transform: translate(-50%, -50%);
    aspect-ratio: 1;
    transform-origin: center;
`;
const $5d71a022305dbf08$var$promiseGenerator = (functionToLoad)=>new Promise((resolve)=>{
        functionToLoad();
        resolve(null);
    });
const $5d71a022305dbf08$export$6348cafef1df8e77 = ()=>{
    const { props: props , setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const wrapperRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const showLoader = (callback)=>{
        wrapperRef.current.style.display = "flex";
        setProps({
            functionToLoad: null
        });
        window.requestAnimationFrame(callback);
    };
    const hideLoader = ()=>{
        wrapperRef.current.style.display = "none";
        setProps({
            functionToLoad: null
        });
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (props.functionToLoad) showLoader(()=>setTimeout(()=>{
                $5d71a022305dbf08$var$promiseGenerator(props.functionToLoad).then(()=>{
                    hideLoader();
                });
            }));
    }, [
        props.functionToLoad
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5d71a022305dbf08$var$StyledWrapper, {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5d71a022305dbf08$var$CircularProgress, null));
};










const $dee921ac3ef55309$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    min-height: 30px;
    margin-bottom: 10px;
`;
const $dee921ac3ef55309$export$38a748e73493e9da = ({ onChange: onChange , activeTab: activeTab  })=>{
    const handleChange = (__, newValue)=>onChange(newValue);
    const taskSummaryLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Summary";
    const taskLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dee921ac3ef55309$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $fbad933ec7f2cab8$export$594ebcebca054019), {
        value: activeTab,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Tasks",
        label: taskLabel
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Task Summary",
        label: taskSummaryLabel
    })));
};


















const $d2981630998338b9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: ${({ height: height  })=>height};
    width: 100%;
    margin-bottom: 5px;
`;
const $d2981630998338b9$export$c8dd51eb24f71762 = ({ rows: rows , columns: columns , type: type , height: height ,  })=>{
    const onGridReady = (params)=>{
        params.columnApi.applyColumnState({
            state: [
                {
                    colId: "tasks",
                    sort: "desc"
                }
            ]
        });
    };
    const onRowClicked = (params)=>{
        if (params.api.getSelectedRows().length > 50) // test this
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "A maximum of 50 tasks can be selected",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "task_detail"
        });
        else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskDetailSelectedData({
            selection: params.api.getSelectedRows()
        });
    };
    const onDragStopped = (params)=>{
        if (params.api.getCellRanges()[0].startRow.rowIndex - params.api.getCellRanges()[0].endRow.rowIndex > 50 || params.api.getCellRanges()[0].endRow.rowIndex - params.api.getCellRanges()[0].startRow.rowIndex > 50) (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).alertMessage({
            message: "A maximum of 50 tasks can be selected",
            severity: "error",
            showAlert: true,
            timeOutActive: true,
            component: "task_detail"
        });
        else {
            const draggedRange = params.api.getCellRanges();
            if (draggedRange.length > 0) {
                params.api.forEachNode((rowNode, index)=>{
                    rowNode.setSelected(false);
                });
                params.api.forEachNode((rowNode, index)=>{
                    for(let i = 0; i < draggedRange.length; i++)if (rowNode.rowIndex != null) {
                        if (draggedRange[i].endRow.rowIndex >= draggedRange[i].startRow.rowIndex) {
                            if (rowNode.rowIndex >= draggedRange[i].startRow.rowIndex && rowNode.rowIndex <= draggedRange[i].endRow.rowIndex) rowNode.setSelected(true);
                        }
                        if (draggedRange[i].endRow.rowIndex < draggedRange[i].startRow.rowIndex) {
                            if (rowNode.rowIndex <= draggedRange[i].startRow.rowIndex && rowNode.rowIndex >= draggedRange[i].endRow.rowIndex) rowNode.setSelected(true);
                        }
                    }
                });
                (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskDetailSelectedData({
                    selection: params.api.getSelectedRows()
                });
                (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
            }
        }
    };
    const onFirstDataRendered = (params)=>{
        const allColumnIds = [];
        params.columnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.colId);
        });
        params.columnApi.autoSizeAllColumns();
    };
    const enableCharts = true;
    const enableRangeSelection = true;
    const getRowHeight = ()=>25;
    const ContextMenuItems = (0, $lR8r2$react.useCallback)((params)=>{
        var result = [];
        if (type === "event-detail") result = [
            {
                // custom item
                name: "Show Variants - Visualizer",
                action: function() {
                    // gDetailTaskVariantsSelected
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).showDetailVariants({});
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/VisualizerIcon.png" />'
            },
            {
                // custom item
                name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " LifeCycle",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationSource({
                        source: "detail"
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
                    if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActiveAction() === "task_lifecycle") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
                    else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskLifecycleIcon.png" />'
            },
            "separator",
            "copy",
            "export", 
        ];
        if (type === "task-detail") result = [
            {
                // custom item
                name: "Show Variants - Visualizer",
                action: function() {
                    // gDetailTaskVariantsSelected
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).showDetailVariants({});
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/VisualizerIcon.png" />'
            },
            {
                name: "Events",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskID({
                        taskID: params.node.data.k
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateEventDetail({
                        activePane: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActivePane()
                    });
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/EventIcon.png" />'
            },
            {
                // custom item
                name: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " LifeCycle",
                action: function() {
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTasksVisualizationSource({
                        source: "detail"
                    });
                    (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).tasksVisualization();
                    if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getActiveAction() === "task_lifecycle") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateTaskLifeCycle({});
                    else (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
                },
                icon: '<img src="https://metricuspm.blob.core.windows.net/processminer/TaskLifecycleIcon.png" />'
            },
            "separator",
            "copy",
            "export", 
        ];
        if (type != "event-detail" && type != "task-detail") result = [
            "export", 
        ];
        return result;
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($d2981630998338b9$var$Wrapper, {
        height: height
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        className: "ag-theme-balham",
        style: {
            height: "100%",
            width: "100%",
            fontSize: "12px",
            fontFamily: "Helvetica"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$aggridreact.AgGridReact), {
        frameworkComponents: {
            tableIcon: (0, $68cac76d685755e6$export$560b0277c649ed6b)
        },
        rowSelection: "multiple",
        onGridReady: onGridReady,
        onFirstDataRendered: onFirstDataRendered,
        getRowHeight: getRowHeight,
        getContextMenuItems: ContextMenuItems,
        onRowClicked: onRowClicked,
        onDragStopped: onDragStopped,
        overlayNoRowsTemplate: "Please select a source for the detail data",
        columnDefs: columns,
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            wrapText: true,
            autoHeight: true
        },
        rowData: rows,
        suppressPropertyNamesCheck: true,
        sideBar: {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                    toolPanelParams: {
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivotMode: true
                    }
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel"
                }, 
            ],
            hiddenByDefault: false,
            defaultToolPanel: ""
        },
        enableCharts: enableCharts,
        chartThemes: [
            "ag-solar",
            "ag-pastel",
            "ag-material-dark",
            "ag-vivid-dark", 
        ],
        enableRangeSelection: enableRangeSelection
    })));
};



const $35136c235799c318$export$a11bc26648701b86 = ()=>[
        {
            field: "attribute",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Attribute",
            width: 120
        },
        {
            field: "tasks",
            headerName: (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s",
            filter: "agTextColumnFilter",
            width: 95,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "perc_total_tasks",
            headerName: "% Total " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s",
            filter: "agNumberColumnFilter",
            width: 98,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "avg_duration",
            headerName: "Avg Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                })
        },
        {
            field: "min_duration",
            headerName: "Min Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "max_duration",
            headerName: "Max Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "avg_duration_days",
            headerName: "Avg Duration (days)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "avg_duration_hrs",
            headerName: "Avg Duration (hours)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "task_actual_cost",
            headerName: "Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "std_deviation",
            headerName: "Std Deviation",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: false
        },
        {
            field: "std_deviation_days",
            headerName: "Std Deviation (days)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "std_deviation_hrs",
            headerName: "Std Deviation (hours)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "task_forecast_cost",
            headerName: "Forecast Cost",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "task_cost_savings",
            headerName: "Cost Savings",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: false
        },
        {
            field: "compliant",
            headerName: "Compliant",
            width: 95,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "automated",
            headerName: "Automated",
            width: 95,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "perc_tasks_compliant",
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper + "s Compliant",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        },
        {
            field: "perc_tasks_automated",
            headerName: "% " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper + "s Automated",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        }, 
    ];



const $91544e04caef60db$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $91544e04caef60db$var$attribute = "";
let $91544e04caef60db$var$optionsAttributes = [];
const $91544e04caef60db$export$dadcaf9ae9b3af78 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTasks, ()=>setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).analyticsTaskAttributes()));
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskAttributes, ()=>taskAttributes());
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskDetailExtract({
                type: "summary"
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailTaskSummary());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        taskAttributes();
        const temp = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDetailTaskSummaryAttribute();
        if (temp["attribute"] != "") $91544e04caef60db$var$attribute = temp["attribute"];
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskDetailExtract({
            type: "summary"
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailTaskSummary());
    }, []);
    const onAttributeChange = (attributeSelected)=>{
        $91544e04caef60db$var$attribute = attributeSelected;
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeDetailTaskSummaryAttribute({
            attribute: $91544e04caef60db$var$attribute
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailTaskSummary());
    };
    const taskAttributes = ()=>{
        $91544e04caef60db$var$optionsAttributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        for (const each of tOptions){
            const valueToPush = {
                value: each.value,
                label: each.label
            };
            $91544e04caef60db$var$optionsAttributes.push(valueToPush);
        }
        if ($91544e04caef60db$var$optionsAttributes.length > 0) $91544e04caef60db$var$attribute = $91544e04caef60db$var$optionsAttributes[0].value;
    };
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($91544e04caef60db$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Group by:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "90%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $91544e04caef60db$var$optionsAttributes,
        onChange: onAttributeChange,
        value: $91544e04caef60db$var$attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d2981630998338b9$export$c8dd51eb24f71762), {
        rows: rows,
        columns: (0, $35136c235799c318$export$a11bc26648701b86)(),
        type: "summary",
        height: "600px"
    }));
};









const $e471e432e3289635$export$772250eae3f41f94 = (rows)=>$e471e432e3289635$var$columnDefs(rows);
function $e471e432e3289635$var$columnDefs(rows) {
    let tempColumnDefs = [];
    rows.map((object)=>{
        Object.keys(object).map((key)=>{
            const mappedColumn = {
                headerName: key,
                field: key
            };
            tempColumnDefs.push(mappedColumn);
        });
    });
    tempColumnDefs = tempColumnDefs.filter((column, index, self)=>index === self.findIndex((colAtIndex)=>colAtIndex.field === column.field));
    const columnDefs = [];
    const durationVF = ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDurationMinutes({
            minutes: value
        });
    const taskTable = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getTaskTable();
    var urlHost = window.location.protocol + "//" + window.location.host;
    if (urlHost == "http://localhost:8080") urlHost = "https://metricus.service-now.com";
    for (const each of tempColumnDefs)if (each.headerName !== "id") {
        let hide = false;
        let valueFormatter = null;
        let cellRenderer = null;
        let width = null;
        if (each.headerName === "Actual Cost" || each.headerName === "Forecast Cost") {
            valueFormatter = ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                });
            width = 100;
        }
        if (each.headerName === "Compliant" || each.headerName === "Automated") {
            cellRenderer = "tableIcon";
            width = 95;
        }
        if (each.headerName === "Duration") valueFormatter = durationVF;
        if (each.headerName === "Task #" && taskTable.taskTable != null) columnDefs.push({
            headerName: each.headerName,
            field: each.field,
            hide: hide,
            valueFormatter: valueFormatter,
            pivot: false,
            cellRenderer: function(params) {
                return '<a href="' + urlHost + "/" + taskTable.taskTable + ".do?sysparm_query=number=" + params.value + '" target="_blank">' + params.value + "</a>";
            }
        });
        else columnDefs.push({
            headerName: each.headerName,
            field: each.field,
            hide: hide,
            valueFormatter: valueFormatter,
            pivot: true
        });
    }
    return columnDefs;
}


let $9388c032971157fc$var$columns = [];
const $9388c032971157fc$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $9388c032971157fc$export$400c0ed6420a3073 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setTaskDetailExtract({
                type: "detail"
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailTaskSummary());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    if ($lR8r2$lodashfp.isEmpty($9388c032971157fc$var$columns)) $9388c032971157fc$var$columns = (0, $e471e432e3289635$export$772250eae3f41f94)(rows);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9388c032971157fc$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d2981630998338b9$export$c8dd51eb24f71762), {
        rows: rows,
        columns: $9388c032971157fc$var$columns,
        type: "task-detail",
        height: "600px"
    }));
};



let $86e1824044fa7fda$export$ea939521428abbad;
(function(DetailTabsList) {
    DetailTabsList["tasksTab"] = "Tasks";
    DetailTabsList["taskSummaryTab"] = "Task Summary";
})($86e1824044fa7fda$export$ea939521428abbad || ($86e1824044fa7fda$export$ea939521428abbad = {}));
const $86e1824044fa7fda$export$811d5045dac21045 = $lR8r2$lodashfp.values($86e1824044fa7fda$export$ea939521428abbad);





const $eb2f30d73a626070$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $eb2f30d73a626070$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 15px;
    margin-left: -4px;
    overflow: auto;
`;
const $eb2f30d73a626070$var$Navigation = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: center;
`;
const $eb2f30d73a626070$export$ec13b95940b54c9d = ()=>{
    const [activeSidebarTab, setActiveSidebarTab] = (0, ($parcel$interopDefault($lR8r2$react))).useState((0, $86e1824044fa7fda$export$811d5045dac21045).indexOf((0, $86e1824044fa7fda$export$ea939521428abbad).tasksTab));
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDetailDescription());
            setActiveSidebarTab((0, $86e1824044fa7fda$export$811d5045dac21045).indexOf((0, $86e1824044fa7fda$export$ea939521428abbad).tasksTab));
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setDetailTab, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setDetailTab, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDetailDescription());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($eb2f30d73a626070$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($eb2f30d73a626070$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            pb: "10px",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($eb2f30d73a626070$var$Navigation, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $dee921ac3ef55309$export$38a748e73493e9da), {
        onChange: setActiveSidebarTab,
        activeTab: activeSidebarTab
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $86e1824044fa7fda$export$811d5045dac21045).indexOf((0, $86e1824044fa7fda$export$ea939521428abbad).taskSummaryTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $91544e04caef60db$export$dadcaf9ae9b3af78), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $86e1824044fa7fda$export$811d5045dac21045).indexOf((0, $86e1824044fa7fda$export$ea939521428abbad).tasksTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9388c032971157fc$export$400c0ed6420a3073), null))));
};










const $5f74740526ec50ed$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    min-height: 30px;
    margin-bottom: 10px;
`;
const $5f74740526ec50ed$export$38a748e73493e9da = ({ onChange: onChange , activeTab: activeTab  })=>{
    const handleChange = (__, newValue)=>onChange(newValue);
    const taskSummaryLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + " Summary";
    const taskLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($5f74740526ec50ed$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $fbad933ec7f2cab8$export$594ebcebca054019), {
        value: activeTab,
        onChange: handleChange
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Event",
        label: "Events"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4fc4d8fc73eeccd0$export$f43fc23d58ee4c2), {
        key: "Event Summary",
        label: "Event Summary"
    })));
};












const $dc1357c4fc691ad9$export$c92a8364338afce9 = ()=>[
        {
            field: "attribute",
            headerName: "Event Attribute",
            width: 120
        },
        {
            field: "events",
            headerName: "Events",
            filter: "agTextColumnFilter",
            width: 95,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
                    count: value
                })
        },
        {
            field: "perc_total_events",
            headerName: "% Total events",
            filter: "agNumberColumnFilter",
            width: 98,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                })
        },
        {
            field: "avg_duration",
            headerName: "Avg Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                })
        },
        {
            field: "min_duration",
            headerName: "Min Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "max_duration",
            headerName: "Max Duration",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: true
        },
        {
            field: "avg_duration_days",
            headerName: "Avg Duration (days)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "avg_duration_hrs",
            headerName: "Avg Duration (hours)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "event_actual_cost",
            headerName: "Actual Cost",
            width: 110,
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "std_deviation",
            headerName: "Std Deviation",
            width: 100,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDuration({
                    seconds: value
                }),
            hide: false
        },
        {
            field: "std_deviation_days",
            headerName: "Std Deviation (days)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "std_deviation_hrs",
            headerName: "Std Deviation (hours)",
            filter: "agNumberColumnFilter",
            hide: true
        },
        {
            field: "event_forecast_cost",
            headerName: "Forecast Cost",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: true
        },
        {
            field: "event_cost_savings",
            headerName: "Cost Savings",
            filter: "agNumberColumnFilter",
            width: 110,
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                }),
            hide: false
        },
        {
            field: "compliant",
            headerName: "Compliant",
            width: 95,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "automated",
            headerName: "Automated",
            width: 95,
            cellRenderer: "tableIcon",
            hide: true
        },
        {
            field: "perc_events_compliant",
            headerName: "% Events Compliant",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        },
        {
            field: "perc_events_automated",
            headerName: "% Events Automated",
            filter: "agNumberColumnFilter",
            valueFormatter: ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatPercentage({
                    perc: value,
                    decimals: 1
                }),
            hide: false
        }, 
    ];


const $a556db320d3edcf0$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let $a556db320d3edcf0$var$attribute = "";
let $a556db320d3edcf0$var$optionsAttributes = [];
const $a556db320d3edcf0$export$aefe8611a92c48b9 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEventDetailExtract({
                type: "summary"
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailEventSummary());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        eventAttributes();
        const temp = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDetailEventSummaryAttribute();
        if (temp["attribute"] != "") $a556db320d3edcf0$var$attribute = temp["attribute"];
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEventDetailExtract({
            type: "summary"
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailEventSummary());
    }, []);
    const onAttributeChange = (attributeSelected)=>{
        $a556db320d3edcf0$var$attribute = attributeSelected;
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeDetailEventSummaryAttribute({
            attribute: $a556db320d3edcf0$var$attribute
        });
        setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailEventSummary());
    };
    const eventAttributes = ()=>{
        $a556db320d3edcf0$var$optionsAttributes = [];
        const tOptions = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
        for (const each of tOptions){
            const valueToPush = {
                value: each.value,
                label: each.label
            };
            $a556db320d3edcf0$var$optionsAttributes.push(valueToPush);
        }
        if ($a556db320d3edcf0$var$optionsAttributes.length > 0) $a556db320d3edcf0$var$attribute = $a556db320d3edcf0$var$optionsAttributes[0].value;
    };
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a556db320d3edcf0$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "10%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $36db6c9343738e53$export$6e2c8f0811a474ce), {
        title: "Group by:"
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2311f6544dcf3569$export$851f9125c323a8f6), {
        width: "90%"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $a556db320d3edcf0$var$optionsAttributes,
        onChange: onAttributeChange,
        value: $a556db320d3edcf0$var$attribute
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d2981630998338b9$export$c8dd51eb24f71762), {
        rows: rows,
        columns: (0, $dc1357c4fc691ad9$export$c92a8364338afce9)(),
        type: "summary",
        height: "600px"
    }));
};









const $11cadeaed48263fb$export$3b43c84bef72a273 = (rows)=>$11cadeaed48263fb$var$columnDefs(rows);
function $11cadeaed48263fb$var$columnDefs(rows) {
    let tempColumnDefs = [];
    rows.map((object)=>{
        Object.keys(object).map((key)=>{
            const mappedColumn = {
                headerName: key,
                field: key
            };
            tempColumnDefs.push(mappedColumn);
        });
    });
    tempColumnDefs = tempColumnDefs.filter((column, index, self)=>index === self.findIndex((colAtIndex)=>colAtIndex.field === column.field));
    const columnDefs = [];
    const durationVF = ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatDurationMinutes({
            minutes: value
        });
    for (const each of tempColumnDefs)if (each.headerName !== "id") {
        let hide = false;
        let valueFormatter = null;
        let cellRenderer = null;
        let width = null;
        if (each.headerName === "Actual Cost" || each.headerName === "forecast Cost") {
            valueFormatter = ({ value: value  })=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
                    cost: value
                });
            width = 100;
        }
        if (each.headerName === "Compliant" || each.headerName === "Automated") {
            cellRenderer = "tableIcon";
            width = 95;
        }
        if (each.headerName === "Duration") valueFormatter = durationVF;
        columnDefs.push({
            headerName: each.headerName,
            field: each.field,
            hide: hide,
            width: width,
            valueFormatter: valueFormatter,
            cellRenderer: cellRenderer
        });
    }
    return columnDefs;
}


let $a802ffd4418538c6$var$columns = [];
const $a802ffd4418538c6$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
const $a802ffd4418538c6$export$72c11e150626e82e = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setEventDetailExtract({
                type: "detail"
            });
            setData((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).processDetailEventSummary());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        };
    }, []);
    const rows = data.map((row, id)=>({
            id: id,
            ...row
        }));
    if ($lR8r2$lodashfp.isEmpty($a802ffd4418538c6$var$columns)) $a802ffd4418538c6$var$columns = (0, $11cadeaed48263fb$export$3b43c84bef72a273)(rows);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a802ffd4418538c6$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d2981630998338b9$export$c8dd51eb24f71762), {
        rows: rows,
        columns: $a802ffd4418538c6$var$columns,
        type: "event-detail",
        height: "600px"
    }));
};



let $8342b1d9506d5bcb$export$ea939521428abbad;
(function(DetailTabsList) {
    DetailTabsList["eventsTab"] = "Events";
    DetailTabsList["eventSummaryTab"] = "Event Summary";
})($8342b1d9506d5bcb$export$ea939521428abbad || ($8342b1d9506d5bcb$export$ea939521428abbad = {}));
const $8342b1d9506d5bcb$export$811d5045dac21045 = $lR8r2$lodashfp.values($8342b1d9506d5bcb$export$ea939521428abbad);





const $09d58cc8448812e2$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
`;
const $09d58cc8448812e2$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 15px;
    margin-left: -4px;
    overflow: auto;
`;
const $09d58cc8448812e2$var$Navigation = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: center;
`;
const $09d58cc8448812e2$export$e10a92f7884d111a = ({ width: width , ctr: ctr  })=>{
    const [activeSidebarTab, setActiveSidebarTab] = (0, ($parcel$interopDefault($lR8r2$react))).useState((0, $8342b1d9506d5bcb$export$811d5045dac21045).indexOf((0, $8342b1d9506d5bcb$export$ea939521428abbad).eventsTab));
    const [description, setDescription] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setActiveSidebarTab((0, $8342b1d9506d5bcb$export$811d5045dac21045).indexOf((0, $8342b1d9506d5bcb$export$ea939521428abbad).eventsTab));
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).setDetailTab, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).setDetailTab, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>{
            setDescription((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getDetailDescription());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($09d58cc8448812e2$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($09d58cc8448812e2$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            pb: "10px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, description), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($09d58cc8448812e2$var$Navigation, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5f74740526ec50ed$export$38a748e73493e9da), {
        onChange: setActiveSidebarTab,
        activeTab: activeSidebarTab
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $8342b1d9506d5bcb$export$811d5045dac21045).indexOf((0, $8342b1d9506d5bcb$export$ea939521428abbad).eventSummaryTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a556db320d3edcf0$export$aefe8611a92c48b9), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1a8dfcfd10c19ff0$export$3d96ec278d3efce4), {
        height: "auto",
        activeTab: activeSidebarTab,
        tab: (0, $8342b1d9506d5bcb$export$811d5045dac21045).indexOf((0, $8342b1d9506d5bcb$export$ea939521428abbad).eventsTab)
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a802ffd4418538c6$export$72c11e150626e82e), null))));
};


const $2b3431c69e93c3c3$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-left: -4px;
    position: relative;
`;
const $2b3431c69e93c3c3$var$Content = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: ${({ initialLoad: initialLoad  })=>initialLoad ? "calc(100%);" : "calc(100% - 50px);"};
    padding: 10px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("panel")};
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("panel")};
    position: relative;
`;
const $2b3431c69e93c3c3$export$1ba59dacbcbf90fe = ({ app: app , eventLogID: eventLogID  })=>{
    const [detailExpanded, setDetailExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [initialLoad, setInitialLoad] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [metricsExist, setMetricsExist] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [slicerStepsExpanded, setSlicerStepsExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [slicerActivitiesExpanded, setSlicerActivitiesExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [filterActivitiesExpanded, setFilterActivitiesExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [slicerPathExpanded, setSlicerPathExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [activeTab, setActiveTab] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [filterExpanded, setFilterExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [slicerExpanded, setSlicerExpanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [settingsExpanded, setSettingsExplanded] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [detail, setDetail] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [detailType, setDetailType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("task");
    const entityTitle = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityUpper() + "s";
    const [detailTabs, setDetailTabs] = (0, ($parcel$interopDefault($lR8r2$react))).useState(1);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        setInitialLoad(false);
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab);
        setMetricsExist((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).metricsExist());
        setDetail("");
    }, []);
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).applySlicer, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab);
        setInitialLoad(false);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_VariantLifeCycle, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).dataImportComplete, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab);
        setInitialLoad(false);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setSlicerExpanded, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).slicersTab);
        setSlicerExpanded(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setFilterExpanded, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).filtersTab);
        setFilterExpanded(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setVariantPane, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab);
        setInitialLoad(false);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setDetailTab, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).detailTab);
        setDetailExpanded(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).updateTaskDetail, ()=>{
        setDetailTabs(detailTabs + 1);
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).detailTab);
        setDetailType("task");
        setDetailExpanded(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).updateEventDetail, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).detailTab);
        setDetailType("event");
        setDetailExpanded(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).resetEventLog, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).eventLogTab);
        setInitialLoad(true);
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openSettings, ()=>{
        setActiveTab((0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).settingsTab);
        setSettingsExplanded(true);
    });
    /*
    useApiListener(Event.openAnalytics, () => {
        setActiveTab(SidebarTab.analyticsTab)   
    });
    */ (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActivePane({
            pane: activeTab
        });
    }, [
        activeTab
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2b3431c69e93c3c3$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $48013a1ebe627584$export$b2539bed5023c21c), {
        onChange: setActiveTab,
        initialLoad: initialLoad,
        activeTab: activeTab,
        showDetail: detail
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2b3431c69e93c3c3$var$Content, {
        initialLoad: initialLoad
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).variantsTab
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5f65df87b089c6f8$export$c36b7feb8a4cf8b4), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).slicersTab
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: slicerExpanded,
        title: "Status"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $71fd4ce80b940ebd$export$afa61e435478c964), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: slicerStepsExpanded,
        title: "Steps"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d5407916d348ef2e$export$e83a629ed8043d44), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: slicerActivitiesExpanded,
        title: "Activities"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $4442682514ef1e3c$export$93d907250fe7d3ea), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: slicerPathExpanded,
        title: "Path"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3bd492f6d33b653e$export$ddcd1e3bb49f927a), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).filtersTab
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: filterExpanded,
        title: "Status"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $22dc033591fc01d1$export$92a576f896a9bf72), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Attributes"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1e3a31557dd99081$export$c4dedd76188cef5b), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Time"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9b5f552be6daf818$export$b5207967a5eb8f18), null)), metricsExist ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: false,
        title: "Metrics"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $cd16956d66541e93$export$37b5e50641693fa1), null)) : "", /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: entityTitle
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5103c3389655ef1b$export$db82907bf1592d10), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).detailTab
    }, detailType === "task" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $eb2f30d73a626070$export$ec13b95940b54c9d), {
        width: 100,
        ctr: detailTabs
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $09d58cc8448812e2$export$e10a92f7884d111a), {
        width: 100,
        ctr: detailTabs
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).modelTab
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: true,
        title: "Statistics"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $7753972cda8d4930$export$bac3506438e44f8d), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Comments"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $7278d24ccf9bd280$export$434c217d363ea16), null)), app == "Metricus" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Save"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f94c049637fffd39$export$167015fae0896f16), null)) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Save"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $d36cd80be0f197a3$export$eabde9361b4315f0), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).eventLogTab
    }, initialLoad || app == "ServiceNow" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: true,
        title: "Import"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $46820f204b69ffcd$export$56f2894cea2a586c), null)) : "", initialLoad || app == "ServiceNow" ? "" : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Save"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3aee697a99c0b80f$export$1f50821d82779d15), null)), initialLoad || app == "ServiceNow" ? "" : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Update"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $0ea78dd273a6a846$export$7ef911e3d06dd7cf), null))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $3e4454f54df3bf6f$export$ab245654d3c5ee0c), {
        activeTab: activeTab,
        tab: (0, $f199f4f4b1b09c24$export$5b90c5799027cc4e).settingsTab
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        expanded: settingsExpanded,
        title: "Visualizer"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5e616ed76f8d24ff$export$f2a2e50ddb11f394), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $65647e376bb3e0a7$export$40e646e38e6ed100), {
        title: "Gauges"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $55c6e781c503a3af$export$6fad391fa497c4f2), null)))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $5d71a022305dbf08$export$6348cafef1df8e77), null));
};






const $1c3359dd9a89028d$export$9c71e42adf89270e = 280;
const $1c3359dd9a89028d$export$49b8d29df782c44e = 35;
const $1c3359dd9a89028d$export$31e3c01d071a88d0 = 400;


const $3c57a7dee6df20cd$var$StyledSplit = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$reactsplit))))`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: calc(100vh - ${(0, $d18c0fc16613166e$export$c08559766941f856)("topBar")}px);

    & .gutter {
        background-repeat: no-repeat;
        background-position: 50%;
        background-image: url(${"https://metricuspm.blob.core.windows.net/processminer/SlidingPanelIcon.svg"});
        cursor: col-resize;
        position: relative;
        z-index: 20;
    }
`;
const $3c57a7dee6df20cd$export$7388fd992834fee3 = ({ children: children , onDragEnd: onDragEnd  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($3c57a7dee6df20cd$var$StyledSplit, {
        gutterSize: 10,
        sizes: [
            100 - (0, $1c3359dd9a89028d$export$49b8d29df782c44e),
            (0, $1c3359dd9a89028d$export$49b8d29df782c44e)
        ],
        minSize: [
            (0, $1c3359dd9a89028d$export$31e3c01d071a88d0),
            (0, $1c3359dd9a89028d$export$9c71e42adf89270e)
        ],
        expandToMin: false,
        gutterAlign: "center",
        snapOffset: 30,
        dragInterval: 1,
        direction: "horizontal",
        cursor: "col-resize",
        onDragEnd: onDragEnd
    }, children);
























const $816301e771063576$export$b04be29aa201d4f5 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    text-align: center;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
    font-size: 12px;
    letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("normal")};
    line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("smaller")};
    padding-top: 5px;
`;
const $816301e771063576$var$MetricContainer = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: ${({ visible: visible  })=>visible ? "flex" : "none"};
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100%
`;
//     color: ${getColor('blue')};
const $816301e771063576$var$Gauge = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreCircularProgress))))`
    color: ${({ gaugecolor: gaugecolor  })=>gaugecolor};   
    &.MuiCircularProgress-root .MuiCircularProgress-determinate {
        height: 60px;
        width: 60px;
    }
`;
const $816301e771063576$export$d4767bb5dfaa4713 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    text-align: center;
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
    font-size: 16px;
    font-weight: bold;
    letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("normal")};
    line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("smaller")};
    padding-top: 22px;
    padding-bottom: 17px;
`;
const $816301e771063576$var$GaugeBackground = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, ($parcel$interopDefault($lR8r2$materialuicoreCircularProgress))))`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    color: ${({ gaugebackgroundcolor: gaugebackgroundcolor  })=>gaugebackgroundcolor};  
`;
function $816301e771063576$var$gaugeColor(value, type) {
    let color = "";
    if (type == "min") {
        if (value < 17) color = "#FF0E0D";
        if (value >= 17 && value < 34) color = "#FF4F11";
        if (value >= 34 && value < 51) color = "#FF8E14";
        if (value >= 51 && value < 67) color = "#FAB733";
        if (value >= 67 && value < 84) color = "#ACB334";
        if (value >= 84) color = "#69B34C";
    }
    return color;
}
function $816301e771063576$var$gaugeBackgroundColor(value, type, total) {
    let color = "";
    if (type == "min" && total > 0) {
        if (value == 0) color = "#FF0E0D";
        if (value > 0) color = "#9E9E9E";
    } else color = "#9E9E9E";
    return color;
}
const $816301e771063576$export$9f5a2991816d9c66 = ()=>{
    const [eventsSelected, setEventsSelected] = (0, ($parcel$interopDefault($lR8r2$react))).useState(100);
    const [eventsTotal, setTotalEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [tasksSelected, setTasksSelected] = (0, ($parcel$interopDefault($lR8r2$react))).useState(100);
    const [tasksTotal, setTotalTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [variantsSelected, setVariantsSelected] = (0, ($parcel$interopDefault($lR8r2$react))).useState(100);
    const [variantsTotal, setTotalVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [stepsTotal, setTotalSteps] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [stepsSelected, setStepsSelected] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    let [activitiesTotal, setTotalActivities] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    let [activitiesSelected, setActivitiesSelected] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [nonCompliantVariants, setNonCompliantVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [nonCompliantTasks, setNonCompliantTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [nonCompliantEvents, setNonCompliantEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [automatedVariants, setAutomatedVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [automatedTasks, setAutomatedTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [automatedEvents, setAutomatedEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [percCostSaving, setPercCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [costSavings, setCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [actualCost, setActualCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [forecastCost, setForecastCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState(200);
    const [gaugePercEvents, setGaugePercEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugePercTasks, setGaugePercTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYVariants, setGaugeXofYVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYSteps, setGaugeXofYSteps] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYActivities, setGaugeXofYActivities] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYVariantsCompliant, setGaugeXofYVariantsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYTasksCompliant, setGaugeXofYTasksCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYEventsCompliant, setGaugeXofYEventsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugePercVariantsCompliant, setGaugePercVariantsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugePercTasksCompliant, setGaugePercTasksCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugePercEventsCompliant, setGaugePercEventsCompliant] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYAutomatedVariants, setGaugeXofYAutomatedVariants] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYautomatedTasks, setGaugeXofYautomatedTasks] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeXofYautomatedEvents, setGaugeXofYautomatedEvents] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugepercVariantsAutomated, setGaugePercVariantsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugepercTasksAutomated, setGaugePercTasksAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugepercEventsAutomated, setGaugePercEventsAutomated] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugePercCostSaving, setGaugePercCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeAvgCostSavingPerTask, setGaugeAvgCostSavingPerTask] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeAvgCostPerTask, setGaugeAvgCostPerTask] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeCostSaving, setGaugeCostSaving] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeActualCost, setGaugeActualCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    const [gaugeForecastCost, setGaugeForecastCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState();
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const updateSelectedVariantListener = (props)=>{
            setTotalEvents(props.eventsTotal);
            setEventsSelected(props.events);
            setTasksSelected(props.tasks);
            setTotalTasks(props.tasksTotal);
            setVariantsSelected(props.variants);
            setTotalVariants(props.variantsTotal);
            setStepsSelected(props.steps);
            setTotalSteps(props.stepsTotal);
            setActivitiesSelected(props.activities);
            setTotalActivities(props.activitiesTotal);
            setNonCompliantVariants(props.nonCompliantVariants);
            setNonCompliantTasks(props.nonCompliantTasks);
            setNonCompliantEvents(props.nonCompliantEvents);
            setAutomatedVariants(props.automatedVariants);
            setAutomatedTasks(props.automatedTasks);
            setAutomatedEvents(props.automatedEvents);
            setPercCostSaving(props.percCostSaving);
            setCostSaving(props.costSavings);
            setActualCost(props.actualCost);
            setForecastCost(props.forecastCost);
            setGaugePercTasks(props.gaugePercTasks);
            setGaugePercEvents(props.gaugePercEvents);
            setGaugeXofYVariants(props.gaugeXofYVariants);
            setGaugeXofYSteps(props.gaugeXofYSteps);
            setGaugeXofYActivities(props.gaugeXofYActivities);
            setGaugeXofYVariantsCompliant(props.gaugeXofYVariantsCompliant);
            setGaugeXofYTasksCompliant(props.gaugeXofYTasksCompliant);
            setGaugeXofYEventsCompliant(props.gaugeXofYEventsCompliant);
            setGaugePercVariantsCompliant(props.gaugePercVariantsCompliant);
            setGaugePercTasksCompliant(props.gaugePercTasksCompliant);
            setGaugePercEventsCompliant(props.gaugePercEventsCompliant);
            setGaugeXofYAutomatedVariants(props.gaugeXofYVariantsAutomated);
            setGaugeXofYautomatedTasks(props.gaugeXofYTasksAutomated);
            setGaugeXofYautomatedEvents(props.gaugeXofYEventsAutomated);
            setGaugePercVariantsAutomated(props.gaugePercVariantsAutomated);
            setGaugePercTasksAutomated(props.gaugePercTasksAutomated);
            setGaugePercEventsAutomated(props.gaugePercEventsAutomated);
            setGaugePercCostSaving(props.gaugePercCostSaving);
            setGaugeAvgCostSavingPerTask(props.gaugeAvgCostSavingPerTask);
            setGaugeAvgCostPerTask(props.gaugeAvgCostPerTask);
            setGaugeCostSaving(props.gaugeCostSaving);
            setGaugeActualCost(props.gaugeActualCost);
            setGaugeForecastCost(props.gaugeForecastCost);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, updateSelectedVariantListener);
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({});
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateGaugeMetrics, updateSelectedVariantListener);
        };
    }, []);
    let percVariants = 0;
    let percTasks = 0;
    let percEvents = 0;
    let percEventsAutomated = 0;
    let percEventsCompliant = 0;
    let percTasksAutomated = 0;
    let percTasksCompliant = 0;
    let percVariantsCompliant = 0;
    let percVariantsAutomated = 0;
    let avgCostPerTask = 0;
    let avgCostSavingPerTask = 0;
    if (eventsTotal > 0) {
        percVariants = variantsSelected / variantsTotal * 100;
        percTasks = tasksSelected / tasksTotal * 100;
        percEvents = eventsSelected / eventsTotal * 100;
        percEventsCompliant = Math.floor((eventsTotal - nonCompliantEvents) / eventsTotal * 100);
        percEventsAutomated = Math.floor(automatedEvents / eventsTotal * 100);
    } else {
        activitiesTotal = 0;
        activitiesSelected = 0;
    }
    if (tasksTotal > 0) {
        percTasksCompliant = Math.floor((variantsTotal - nonCompliantVariants) / variantsTotal * 100);
        percTasksAutomated = automatedTasks / tasksTotal * 100;
        percTasksCompliant = Math.floor((tasksTotal - nonCompliantTasks) / tasksTotal * 100);
        avgCostPerTask = actualCost / tasksTotal;
        avgCostSavingPerTask = costSavings / tasksTotal;
    }
    if (variantsTotal > 0) {
        percVariantsCompliant = Math.floor((variantsTotal - nonCompliantVariants) / variantsTotal * 100);
        percVariantsAutomated = Math.floor(automatedVariants / variantsTotal * 100);
    }
    const variantsCompliant = variantsTotal - nonCompliantVariants;
    const tasksCompliant = tasksTotal - nonCompliantTasks;
    const eventsCompliant = eventsTotal - nonCompliantEvents;
    const variantsLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: variantsTotal
    }) + " variants";
    const eventsLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: eventsTotal
    }) + " events";
    const tasksLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: tasksTotal
    }) + " " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s";
    const stepsLabel = "of " + stepsTotal + " steps";
    const activitiesLabel = "of " + activitiesTotal + " activities";
    const variantComplianceLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: variantsTotal
    }) + " variants compliant";
    const taskComplianceLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: tasksTotal
    }) + " " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s compliant";
    const eventComplianceLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: eventsTotal
    }) + " events compliant";
    const variantPercComplianceLabel = "variants compliant";
    const taskPercComplianceLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s compliant";
    const eventPercComplianceLabel = "events compliant";
    const variantAutomatedLabel = "of " + variantsTotal + " variants automated";
    const taskAutomatedLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: tasksTotal
    }) + " " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s automated";
    const eventAutomatedLabel = "of " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: eventsTotal
    }) + " events automated";
    const variantPercAutomatedLabel = "variants automated";
    const taskPercAutomatedLabel = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower() + "s automated";
    const eventPercAutomatedLabel = "events automated";
    const percCostSavingLabel = "cost saving";
    const avgCostSavingPerTaskLabel = "avg saving per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower();
    const avgCostPerTaskLabel = "avg cost per " + (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getEntityLower();
    const actualCostLabel = "actual cost";
    const forecastCostLabel = "forecast cost";
    const costSavingsLabel = "cost saving";
    const defaultGaugeColor = "#187bcd"; // blue
    const defaultGaugeBackgroundColor = "#9E9E9E"; // gray
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYVariants
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: defaultGaugeBackgroundColor,
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: defaultGaugeColor,
        value: percVariants
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(variantsSelected)}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, variantsLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYSteps
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: defaultGaugeBackgroundColor,
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: defaultGaugeColor,
        value: percTasks
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(stepsSelected)}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, stepsLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYActivities
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: defaultGaugeBackgroundColor,
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: defaultGaugeColor,
        value: percTasks
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(activitiesSelected)}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, activitiesLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercTasks
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: defaultGaugeBackgroundColor,
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: defaultGaugeColor,
        value: percTasks
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percTasks)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, tasksLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercEvents
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: defaultGaugeBackgroundColor,
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: defaultGaugeColor,
        variant: "determinate",
        value: percEvents
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percEvents)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, eventsLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYVariantsCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percVariantsCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percVariantsCompliant, "min"),
        variant: "determinate",
        value: percVariantsCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(variantsCompliant)}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, variantComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYTasksCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percTasksCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: $816301e771063576$var$gaugeColor(percTasksCompliant, "min"),
        value: percTasksCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: tasksCompliant
    })}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, taskComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYEventsCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percEventsCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        variant: "determinate",
        gaugecolor: $816301e771063576$var$gaugeColor(percEventsCompliant, "min"),
        value: percEventsCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: eventsCompliant
    })}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, eventComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercVariantsCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percVariantsCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percVariantsCompliant, "min"),
        variant: "determinate",
        value: percVariantsCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percVariantsCompliant)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, variantPercComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercTasksCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percTasksCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percTasksCompliant, "min"),
        variant: "determinate",
        value: percTasksCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percTasksCompliant)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, taskPercComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercEventsCompliant
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percEventsCompliant, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percEventsCompliant, "min"),
        variant: "determinate",
        value: percEventsCompliant
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percEventsCompliant)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, eventPercComplianceLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugepercVariantsAutomated
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percVariantsAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percVariantsAutomated, "min"),
        variant: "determinate",
        value: percVariantsAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percVariantsAutomated)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, variantPercAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugepercTasksAutomated
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percTasksAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percTasksAutomated, "min"),
        variant: "determinate",
        value: percTasksAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percTasksAutomated)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, taskPercAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugepercEventsAutomated
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percEventsAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percEventsAutomated, "min"),
        variant: "determinate",
        value: percEventsAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percEventsAutomated)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, eventPercAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYAutomatedVariants
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percVariantsAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percVariantsAutomated, "min"),
        variant: "determinate",
        value: percVariantsAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(automatedVariants)}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, variantAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYautomatedTasks
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percTasksAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percTasksAutomated, "min"),
        variant: "determinate",
        value: percTasksAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: automatedTasks
    })}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, taskAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeXofYautomatedEvents
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percEventsAutomated, "min", variantsTotal),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: $816301e771063576$var$gaugeColor(percEventsAutomated, "min"),
        variant: "determinate",
        value: percEventsAutomated
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatNumber({
        count: automatedEvents
    })}`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, eventAutomatedLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugePercCostSaving
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$GaugeBackground, {
        size: 50,
        value: 100,
        gaugebackgroundcolor: $816301e771063576$var$gaugeBackgroundColor(percCostSaving, "min", percCostSaving),
        variant: "determinate"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$Gauge, {
        size: 50,
        gaugecolor: defaultGaugeColor,
        variant: "determinate",
        value: percCostSaving
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTypography))), {
        variant: "caption",
        component: "div",
        fontSize: "12px",
        color: "textSecondary"
    }, `${Math.round(percCostSaving)}%`))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, percCostSavingLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeAvgCostSavingPerTask
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$d4767bb5dfaa4713, null, (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCostDecimal({
        cost: avgCostSavingPerTask
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, avgCostSavingPerTaskLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeAvgCostPerTask
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$d4767bb5dfaa4713, null, (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCostDecimal({
        cost: avgCostPerTask
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, avgCostPerTaskLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeActualCost
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$d4767bb5dfaa4713, null, (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
        cost: actualCost
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, actualCostLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeForecastCost
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$d4767bb5dfaa4713, null, (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
        cost: forecastCost
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, forecastCostLabel)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$var$MetricContainer, {
        visible: gaugeCostSaving
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        position: "relative",
        display: "inline-flex"
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$d4767bb5dfaa4713, null, (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).formatCost({
        cost: costSavings
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($816301e771063576$export$b04be29aa201d4f5, null, costSavingsLabel)));
};


const $b64085167b544271$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr 360px;
`;
const $b64085167b544271$var$GaugesWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 1 / 2;
    grid-row: 1 / 1 ;
    display: flex;
    align-items: center;
    padding: 3px 25px 0 25px;
    gap: 15px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("topBar")}px;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("topBar")};
`;
const $b64085167b544271$var$Actions = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 2 / 2;
    grid-row: 1 / 1 ;
    display: flex;
    align-items: center;
    gap: 15px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("topBar")}px;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("topBar")};
`;
const $b64085167b544271$export$c4e96258f3b6511 = ()=>{
    const [costIconActive, setCostIconActive] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [complianceIconActive, setComplianceIconActive] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [automationIconActive, setAutomationIconActive] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [filterIconActive, setFilterIconActive] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [slicerIconActive, setSlicerIconActive] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const clickCost = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercCostSaving({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostSavingPerTask({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostPerTask({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeCostSaving({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActualCost({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeForecastCost({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeHighlight({
            highlightLoops: false,
            highlightNonCompliance: false,
            highlightAutomation: false,
            stepColourVolume: false,
            stepColourDuration: false,
            stepColourStdDeviation: false,
            stepColourCost: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGaugeCost({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({
            rule: "cost"
        });
    };
    const clickCompliance = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsCompliant({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsAutomated({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercCostSaving({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostSavingPerTask({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostPerTask({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeCostSaving({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActualCost({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeForecastCost({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeHighlight({
            highlightLoops: false,
            highlightNonCompliance: true,
            highlightAutomation: false,
            stepColourVolume: false,
            stepColourDuration: false,
            stepColourStdDeviation: false,
            stepColourCost: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGaugeCompliance({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({
            rule: "compliance"
        });
    };
    const clickAutomate = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercVariantsAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercTasksAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercEventsAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsCompliant({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYVariantsAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYTasksAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeXofYEventsAutomated({
            gauge: true
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changePercCostSaving({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostSavingPerTask({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeAvgCostPerTask({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeCostSaving({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeActualCost({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeForecastCost({
            gauge: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).changeHighlight({
            highlightLoops: false,
            highlightNonCompliance: false,
            highlightAutomation: true,
            stepColourVolume: false,
            stepColourDuration: false,
            stepColourStdDeviation: false,
            stepColourCost: false
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGaugeAutomation({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateGauges({
            rule: "automation"
        });
    };
    const clickSlicer = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setSlicerFilter({
            sf: "slicer"
        });
    };
    const clickFilter = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setSlicerFilter({
            sf: "filter"
        });
    };
    const clickSettings = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).openSettings({});
    };
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setFilterIconActive(true);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).filterIconActive, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setSlicerIconActive(true);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).sliceIconActive, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).sliceIconActive, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setCostIconActive(true);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCost, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setComplianceIconActive(true);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateCompliance, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setAutomationIconActive(true);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateAutomation, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setFilterIconActive(false);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetFilter, listener);
        };
    }, []);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        const listener = ()=>setSlicerIconActive(false);
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).resetSlicer, listener);
        };
    }, []);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b64085167b544271$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b64085167b544271$var$GaugesWrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $816301e771063576$export$9f5a2991816d9c66), null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b64085167b544271$var$Actions, null, slicerIconActive ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Slicers")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdReorder), {
        onClick: clickSlicer
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Slicers")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#898989"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdReorder), {
        onClick: clickSlicer
    })))), filterIconActive ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "16px"
            }
        }, "Filters")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdFilterAlt), {
        onClick: clickFilter
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Filters")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#898989"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdFilterAlt), {
        onClick: clickFilter
    })))), complianceIconActive ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Compliance")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdOutlineCheck), {
        onClick: clickCompliance
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Compliance")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#898989"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdOutlineCheck), {
        onClick: clickCompliance
    })))), automationIconActive ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "16px"
            }
        }, "Automation")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "25px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdBuild), {
        onClick: clickAutomate
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Automation")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#898989"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "25px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdBuild), {
        onClick: clickAutomate
    })))), costIconActive ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Cost")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdAttachMoney), {
        onClick: clickCost
    })))) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Cost")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#898989"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdAttachMoney), {
        onClick: clickCost
    })))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("h1", {
            style: {
                fontSize: "12px",
                height: "15px"
            }
        }, "Settings")
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreFab))), {
        size: "small",
        sx: {
            color: "#197BCD"
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticons.IconContext).Provider, {
        value: {
            style: {
                fontSize: "30px",
                cursor: "pointer"
            }
        }
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reacticonsmd.MdOutlineSettings), {
        onClick: clickSettings
    }))))));
};





const $b0920c880d6705d6$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 85% 15%;
`;
const $b0920c880d6705d6$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding-left: 0.6em;
    font-size: 1.25 em;
    font-weight: 600;
`;
const $b0920c880d6705d6$var$GaugesWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 1 / 2;
    grid-row: 1 / 1 ;
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0 20px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("topBar")}px;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("topBar")};
`;
const $b0920c880d6705d6$var$Actions = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 2 / 2;
    grid-row: 1 / 1 ;
    display: flex;
    align-items: center;
    gap: 15px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("topBar")}px;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("topBar")};
`;
const $b0920c880d6705d6$export$cabd743859ddae78 = ()=>{
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b0920c880d6705d6$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b0920c880d6705d6$var$GaugesWrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b0920c880d6705d6$var$Label, null, "Load Event Log")), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b0920c880d6705d6$var$Actions, null));
};







const $2b2afee430ac5656$export$5175fe2a92c236f0 = (y)=>{
    const maxYPosition = window.innerHeight - (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).height.colorPicker;
    return maxYPosition < y && y > (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).height.colorPicker ? `${y - (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).height.colorPicker - 16}px` : `${y + 16}px`;
};
const $2b2afee430ac5656$export$e482bb2eb9976e8c = (x)=>{
    const maxXPosition = window.innerWidth - (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).width.colorPicker;
    return maxXPosition < x && x > (0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).width.colorPicker ? `${maxXPosition}px` : `${x}px`;
};



const $a19db41a020f8d84$export$1896bab46732d207 = (ref, onClickOutside, shouldAddListener = true)=>{
    const clickOutsidePicker = $lR8r2$react.useCallback((e)=>{
        if (ref && ref.current && !ref.current.contains(e.target)) onClickOutside();
    }, [
        ref,
        onClickOutside
    ]);
    $lR8r2$react.useEffect(()=>{
        if (shouldAddListener) document.addEventListener("click", clickOutsidePicker);
        return ()=>{
            document.removeEventListener("click", clickOutsidePicker);
        };
    }, [
        shouldAddListener,
        clickOutsidePicker
    ]);
};





const $140a1a8528fc6414$export$8f45430ccf837300 = [
    "#D0021B",
    "#F5A623",
    "#F8E71C",
    "#8B572A",
    "#7ED321",
    "#417505",
    "#BD10E0",
    "#9013FE",
    "#4A90E2",
    "#50E3C2",
    "#B8E986",
    "#000000",
    "#4A4A4A",
    "#9B9B9B",
    "#FFFFFF", 
];


const $4b658cb8617a640a$var$Color = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 16px;
    height: 16px;
    border-radius: 3px;
    background-color: ${({ color: color  })=>color};
    cursor: pointer;
    transition: box-shadow .2s;
    display: flex;
    justify-content: center;
    align-items: center;

    &:last-child {
        border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("borderColor")};
    }

    &:hover {
        box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("hover")};
    }
`;
const $4b658cb8617a640a$var$Grid = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 14px;

    ${$4b658cb8617a640a$var$Color} {
        margin-bottom: 9px;
        margin-right: 9px;
    }
`;
const $4b658cb8617a640a$export$68cee262cdd4e0b7 = ({ onColorChange: onColorChange  })=>{
    const onClick = (color)=>()=>{
            onColorChange(color);
        };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4b658cb8617a640a$var$Grid, null, (0, $140a1a8528fc6414$export$8f45430ccf837300).map((color)=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($4b658cb8617a640a$var$Color, {
            onClick: onClick(color),
            key: color,
            color: color
        })));
};










const $e920f60eb89eadcf$export$babb39bad6ae97c3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    cursor: pointer;
    width: 4px;
    border-radius: 1px;
    height: 8px;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("slider")};
    background: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    transform: translate(-2px, 1px);
`;


const $643640213c657133$var$HueContainer = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    height: 10px;
    width: 100%;
    border-radius: 5px;
    position: relative;
`;
const $643640213c657133$export$3e22a96a58989a47 = ({ activeColor: activeColor , onColorChange: onColorChange  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($643640213c657133$var$HueContainer, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reactcolorlibcomponentscommon.Hue), {
        hsl: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(activeColor).toHsl(),
        onChange: ({ h: h , s: s , l: l , a: a  })=>{
            const color = a === 1 ? (0, ($parcel$interopDefault($lR8r2$tinycolor2)))({
                h: h,
                s: s,
                l: l
            }).toHexString() : (0, ($parcel$interopDefault($lR8r2$tinycolor2)))({
                h: h,
                s: s,
                l: l,
                a: a
            }).toHex8String();
            onColorChange(color);
        },
        pointer: (0, $e920f60eb89eadcf$export$babb39bad6ae97c3),
        color: activeColor
    }));







const $a2e7fd28dd4ba10c$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    padding-bottom: 147px;
    border-radius: 3px;
    position: relative;
    overflow: hidden;
`;
const $a2e7fd28dd4ba10c$var$CustomPointer = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    cursor: pointer;
    width: 14px;
    border-radius: 50%;
    height: 14px;
    transform: translate(-7px, -5px);
    border: 2px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
`;
const $a2e7fd28dd4ba10c$export$c4dbe12ffaee3c8e = ({ activeColor: activeColor , onColorChange: onColorChange  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($a2e7fd28dd4ba10c$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reactcolorlibcomponentscommon.Saturation), {
        onChange: ({ h: h , s: s , v: v , a: a  })=>{
            const color = a === 1 ? (0, ($parcel$interopDefault($lR8r2$tinycolor2)))({
                h: h,
                s: s,
                v: v
            }).toHexString() : (0, ($parcel$interopDefault($lR8r2$tinycolor2)))({
                h: h,
                s: s,
                v: v,
                a: a
            }).toHex8String();
            onColorChange(color);
        },
        hsl: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(activeColor).toHsl(),
        hsv: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(activeColor).toHsv(),
        pointer: $a2e7fd28dd4ba10c$var$CustomPointer
    }));






const $c792cacced896c26$var$inputStyles = {
    input: {
        border: `1px solid ${(0, $d18c0fc16613166e$export$bca14c5b3b88a9c9).colors.borderColor}`,
        borderRadius: "4px",
        width: "100%",
        marginTop: "10px",
        padding: "3px",
        height: "24px"
    }
};
const $c792cacced896c26$export$bfb3cbb78d3c298 = ({ activeColor: activeColor , onColorChange: onColorChange ,  })=>{
    const [value, setValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState(activeColor);
    (0, $lR8r2$react.useEffect)(()=>{
        setValue(activeColor);
    }, [
        activeColor
    ]);
    const onChange = (newValue)=>{
        setValue(newValue);
        if ((0, ($parcel$interopDefault($lR8r2$tinycolor2)))(newValue).isValid()) onColorChange(newValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reactcolorlibcomponentscommon.EditableInput), {
        style: $c792cacced896c26$var$inputStyles,
        value: value,
        onChange: onChange
    });
};







const $ea9cd96ab21dbad5$var$AlphaContainer = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-top: 4px;
    height: 10px;
    width: 100%;
    border-radius: 5px;
    position: relative;
`;
const $ea9cd96ab21dbad5$export$b3d0ceb706f8af43 = ({ activeColor: activeColor , onColorChange: onColorChange  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($ea9cd96ab21dbad5$var$AlphaContainer, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$reactcolorlibcomponentscommon.Alpha), {
        hsl: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(activeColor).toHsl(),
        rgb: (0, ($parcel$interopDefault($lR8r2$tinycolor2)))(activeColor).toRgb(),
        onChange: ({ h: h , s: s , l: l , a: a  })=>{
            const color = (0, ($parcel$interopDefault($lR8r2$tinycolor2)))({
                h: h,
                s: s,
                l: l,
                a: a
            }).toHex8String();
            onColorChange(color);
        },
        pointer: (0, $e920f60eb89eadcf$export$babb39bad6ae97c3)
    }));



const $43e9e67a818c563a$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
`;
const $43e9e67a818c563a$var$SlidersWithPreview = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
    margin-top: 4px;
`;
const $43e9e67a818c563a$var$Sliders = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-right: 4px;
`;
const $43e9e67a818c563a$var$Preview = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 24px;
    height: 24px;
    background-color: ${({ color: color  })=>color};
    border-radius: 2px;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("slider")};
`;
const $43e9e67a818c563a$export$dc51ccc22fd63a1f = ({ activeColor: activeColor , onColorChange: onColorChange ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($43e9e67a818c563a$var$Container, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $a2e7fd28dd4ba10c$export$c4dbe12ffaee3c8e), {
        activeColor: activeColor,
        onColorChange: onColorChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($43e9e67a818c563a$var$SlidersWithPreview, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($43e9e67a818c563a$var$Sliders, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $643640213c657133$export$3e22a96a58989a47), {
        activeColor: activeColor,
        onColorChange: onColorChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $ea9cd96ab21dbad5$export$b3d0ceb706f8af43), {
        activeColor: activeColor,
        onColorChange: onColorChange
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($43e9e67a818c563a$var$Preview, {
        color: activeColor
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $c792cacced896c26$export$bfb3cbb78d3c298), {
        activeColor: activeColor,
        onColorChange: onColorChange
    }));


const $ad3c23c99432634d$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: ${(0, $d18c0fc16613166e$export$3c49c185de0c2bfc)("colorPicker")}px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("colorPicker")}px;
    position: absolute;
    top: ${({ top: top  })=>top};
    left: ${({ left: left  })=>left};
    border-radius: 8px;
    padding: 10px 10px 0;
    overflow: hidden;
    z-index: 9999;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("panel")};
    display: ${({ open: open  })=>open ? "block" : "none"};
    transition: .2s;
`;
const $ad3c23c99432634d$export$9feb1bc2e5f1ccb3 = ()=>{
    const { props: props , setProps: setProps ,  } = $lR8r2$react.useContext((0, $d86a247d67d6d1e1$export$cfac98503b32f6d6));
    const [prevOnClose, setPrevOnClose, ] = $lR8r2$react.useState(props.onClose);
    const [prevShow, setPrevShow] = $lR8r2$react.useState(props.show);
    const pickerRef = $lR8r2$react.useRef();
    const { x: x , y: y , show: show , color: color  } = props;
    const hidePicker = ()=>setProps({
            ...props,
            show: false
        });
    (0, $a19db41a020f8d84$export$1896bab46732d207)(pickerRef, hidePicker);
    const onColorChange = (color)=>setProps({
            ...props,
            color: color
        });
    $lR8r2$react.useEffect(()=>{
        if (prevShow) {
            prevOnClose && prevOnClose();
            setPrevOnClose(props.onClose);
        }
    }, [
        props.id
    ]);
    $lR8r2$react.useEffect(()=>{
        if (!props.show) props.onClose && props.onClose();
        setPrevShow(props.show);
    }, [
        props.show
    ]);
    return /*#__PURE__*/ $lR8r2$react.createElement($ad3c23c99432634d$var$Container, {
        ref: pickerRef,
        top: (0, $2b2afee430ac5656$export$5175fe2a92c236f0)(y),
        left: (0, $2b2afee430ac5656$export$e482bb2eb9976e8c)(x),
        open: show
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $43e9e67a818c563a$export$dc51ccc22fd63a1f), {
        onColorChange: onColorChange,
        activeColor: color
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $4b658cb8617a640a$export$68cee262cdd4e0b7), {
        onColorChange: onColorChange
    }));
};






const $72acdb7fe1b25d25$export$3b0d6d7590275603 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
    width: 75vw;
    position: absolute;
`;
const $72acdb7fe1b25d25$export$96e9906d6d93a972 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-family: helvetica;
    font-size: 26px;
    font-weight: bolder;
    color: #197BCD;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
    width: 75vw;
    position: absolute;
`;
const $72acdb7fe1b25d25$export$e6dfd72ab29f8598 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div``;
const $72acdb7fe1b25d25$export$7f7cbe89f1eacd2 = ({ status: status  })=>{
    let [color, setColor] = (0, $lR8r2$react.useState)("#197BCD");
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($72acdb7fe1b25d25$export$e6dfd72ab29f8598, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($72acdb7fe1b25d25$export$3b0d6d7590275603, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$reactspinnersGridLoader))), {
        color: color,
        size: "50px",
        loading: true
    }))), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($72acdb7fe1b25d25$export$96e9906d6d93a972, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", {
        id: "loader-status"
    }, "Initializing")));
};













const $867f32230e71427d$var$getOptionBorder = (isFirst, isLast)=>`${isFirst ? "4px 4px" : "0 0"} ${isLast ? "4px 4px" : "0 0"}`;
const $867f32230e71427d$export$844bee7de236d7ec = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: space-between;
    gap: 5px;
    align-items: center;

    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    padding: 7px 16px;
    height: ${(0, $d18c0fc16613166e$export$c08559766941f856)("contextMenuOption")}px;
    border-radius: ${({ isFirst: isFirst , isLast: isLast  })=>$867f32230e71427d$var$getOptionBorder(isFirst, isLast)};

    transition: .25s;
    cursor: pointer;

    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    font-weight: bold;
    white-space: nowrap;

    &:hover {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightestGray")};
    }
`;
const $867f32230e71427d$export$36d18380658d5d20 = ({ text: text , event: event , isExpandable: isExpandable = false , isFirst: isFirst = false , isLast: isLast = false  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($867f32230e71427d$export$844bee7de236d7ec, {
        isFirst: isFirst,
        isLast: isLast,
        onClick: event
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", null, text), isExpandable && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuiicons.ArrowRight), null));


const $fa7c457b51bf1256$var$StyledWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    position: relative;

    &:hover > div {
        display: flex;
    }
`;
const $fa7c457b51bf1256$var$StyledOptions = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: none;
    flex-direction: column;

    border-radius: 4px;
    padding: 2px 0;
    position: absolute;
    left: 100%;
    top: 0;
`;
const $fa7c457b51bf1256$export$c019608e5b5bb4cb = ({ contextMenuOptions: contextMenuOptions , customKey: customKey , hideContextMenu: hideContextMenu  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, ($parcel$interopDefault($lR8r2$react))).Fragment, null, contextMenuOptions.map((menuOption, idx)=>{
        const newCustomKey = `${customKey}@${menuOption.text.replace(/ /g, "")}`;
        const isFirst = idx === 0;
        const isLast = idx === contextMenuOptions.length - 1;
        if (menuOption.subMenuOptions) return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($fa7c457b51bf1256$var$StyledWrapper, {
            key: newCustomKey
        }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $867f32230e71427d$export$36d18380658d5d20), {
            isFirst: isFirst,
            isLast: isLast,
            isExpandable: true,
            text: menuOption.text
        }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($fa7c457b51bf1256$var$StyledOptions, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($fa7c457b51bf1256$export$c019608e5b5bb4cb, {
            hideContextMenu: hideContextMenu,
            customKey: newCustomKey,
            contextMenuOptions: menuOption.subMenuOptions
        })));
        return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $867f32230e71427d$export$36d18380658d5d20), {
            key: newCustomKey,
            isFirst: isFirst,
            isLast: isLast,
            text: menuOption.text,
            event: ()=>{
                hideContextMenu();
                menuOption.event && menuOption.event();
            }
        });
    }));




const $bf84a6073ca402c9$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;

    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("hover")};
    border-radius: 4px;
    padding: 8px 0;

    position: absolute;
    top: ${({ y: y , isAbove: isAbove , ...props })=>y + (0, $d18c0fc16613166e$export$c08559766941f856)("contextMenuOption")(props) / 2 * (isAbove ? -1 : 1)}px;
    left: ${({ x: x  })=>x}px;
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("contextMenu")};
    transform: translate(-50%, ${({ isAbove: isAbove  })=>isAbove ? "-100%" : 0});
`;
const $bf84a6073ca402c9$export$8dc6765e8be191c7 = ()=>{
    const wrapperRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const [show, setShow] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [coords, setCoords] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        x: 0,
        y: 0
    });
    const [x, setX] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [y, setY] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [options, setOptions] = (0, ($parcel$interopDefault($lR8r2$react))).useState([]);
    const [isAbove, setIsAbove] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const theme = (0, $lR8r2$styledcomponents.useTheme)();
    const showContextMenu = ({ x: x , y: y , options: options  })=>{
        setShow(true);
        setCoords({
            x: x,
            y: y
        });
        setOptions(options);
    };
    const hideContextMenu = ()=>{
        const diagram = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCurrentDiagram();
        diagram.currentTool.stopTool();
        setShow(false);
        diagram.toolManager.hideToolTip();
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).showContextMenu, showContextMenu);
    (0, $a19db41a020f8d84$export$1896bab46732d207)(wrapperRef, hideContextMenu);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        wrapperRef.current?.addEventListener("contextmenu", (e)=>e.preventDefault());
    }, [
        show,
        wrapperRef
    ]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (show) {
            const height = theme.height.contextMenuOption * options.length;
            const diagramHeight = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCurrentDiagram().div.getBoundingClientRect().height;
            setIsAbove(coords.y > diagramHeight / 2 && coords.y + height > diagramHeight);
        }
    }, [
        wrapperRef,
        show,
        coords,
        options,
        theme
    ]);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        if (show) {
            const { top: top , left: left  } = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getCurrentDiagram().div.getBoundingClientRect();
            setX(coords.x + left);
            setY(coords.y + top);
        }
    }, [
        show,
        coords
    ]);
    if (!show) return null;
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bf84a6073ca402c9$var$Wrapper, {
        ref: wrapperRef,
        isAbove: isAbove,
        x: x,
        y: y
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $fa7c457b51bf1256$export$c019608e5b5bb4cb), {
        hideContextMenu: hideContextMenu,
        customKey: "root",
        contextMenuOptions: options
    }));
};












const $85667ac3f1c5a4d5$var$StyledTitle = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("small")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("darkFontColor")};
    text-align: left;
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("lato")};
    margin-bottom: 15px;
    display: inline-block;
`;
const $85667ac3f1c5a4d5$export$f99233281efd08a0 = ({ children: children , className: className  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($85667ac3f1c5a4d5$var$StyledTitle, {
        className: className
    }, children);


const $917f5ffe8055011a$export$1f99da106a398c44 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.Modal))`
    display: flex;
    place-items: center;
    place-content: center;

    & > * {
        outline: none;
    }
`;
const $917f5ffe8055011a$var$modalEntry = (0, $lR8r2$styledcomponents.keyframes)`
    from { margin-top: -200px; opacity: 0 }
    to { margin-top: 0; opacity: 1 }
`;
const $917f5ffe8055011a$export$8863cf9d79cd26ad = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    max-width: 90vw;
    max-height: 90vh;
    border-radius: 5px;
    background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
    box-shadow: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("modal")};
    animation: ${$917f5ffe8055011a$var$modalEntry} .4s cubic-bezier(.4, 0, .2, 1) forwards;
`;
const $917f5ffe8055011a$export$579a1e9bab103f15 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
`;
const $917f5ffe8055011a$export$48331a7adc9a636b = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $85667ac3f1c5a4d5$export$f99233281efd08a0))`
    margin: 0;
    font-weight: ${(0, $d18c0fc16613166e$export$16eeca46eca75f64)("bold")};
`;
const $917f5ffe8055011a$export$7c8f159da0dc916 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuiicons.Clear))`
    cursor: pointer;
`;
const $917f5ffe8055011a$export$204f681c496365e3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    padding: 10px;
    overflow: auto;
`;
const $917f5ffe8055011a$export$61905ae62c7860fb = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 10px;
`;



const $f4387d7f039b34b7$export$2b77a92f1a5ad772 = ({ children: children , open: open , onClose: onClose , onOk: onOk , showCloseIcon: showCloseIcon = true , showButtons: showButtons = true , title: title ,  })=>{
    const modalRef = (0, ($parcel$interopDefault($lR8r2$react))).useRef(null);
    const handleOnOk = ()=>{
        onOk();
        onClose();
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$1f99da106a398c44), {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$8863cf9d79cd26ad), {
        onClick: (e)=>e.stopPropagation(),
        ref: modalRef
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$579a1e9bab103f15), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$48331a7adc9a636b), null, title), showCloseIcon ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$7c8f159da0dc916), {
        onClick: onClose
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$204f681c496365e3), null, children), showButtons && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$61905ae62c7860fb), null, onOk && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "OK",
        onClick: handleOnOk,
        disabled: false
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Cancel",
        onClick: onClose,
        disabled: false
    }))));
};







const $6e028ceabbe946af$export$7b82fd4c6fe9dc17 = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.TextField))`
    width: 300px;
   
    & .MuiInputBase-root {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        border: 1px solid ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        border-radius: 8px;
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")} !important;
        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }
    }

    & .MuiInputBase-root.Mui-disabled {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightGray")};

        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("lightBorderColor")};
        }
    }

    & .MuiInputBase-root.MuiOutlinedInput-root {
        padding: 10px !important;
    }

    & input {
        text-align: left;
        padding: 10px !important;
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")} !important;
        letter-spacing: ${(0, $d18c0fc16613166e$export$56328feeb2119780)("input")};
        line-height: ${(0, $d18c0fc16613166e$export$56204a27a2958a55)("small")};
    }
    & fieldset,
    & fieldset:hover {
        border: none;
    }
`;








const $359dc7efe367ffee$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 8px
`;
const $359dc7efe367ffee$var$Title = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("small")};
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
    color: ${(0, $d18c0fc16613166e$export$16eeca46eca75f64)("bold")};
    margin-bottom: 5px;
    align-items: center;
`;
const $359dc7efe367ffee$export$6e2c8f0811a474ce = ({ title: title ,  })=>/*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($359dc7efe367ffee$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($359dc7efe367ffee$var$Title, null, title));




const $bbc660d653804c8e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 300px;
    grid-gap: 10px;

    padding: 15px 20px 15px 15px;
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
`;
const $bbc660d653804c8e$var$costTypes = [
    {
        value: "total",
        label: "Total"
    },
    {
        value: "perday",
        label: "Per day"
    },
    {
        value: "perhour",
        label: "Per hour"
    },
    {
        value: "perminute",
        label: "Per minute"
    },
    {
        value: "task",
        label: "Task Attribute"
    },
    {
        value: "event",
        label: "Event Attribute"
    }, 
];
const $bbc660d653804c8e$var$taskTypes = [
    {
        value: "all_tasks",
        label: "All"
    },
    {
        value: "filtered_tasks",
        label: "Filtered"
    }, 
];
const $bbc660d653804c8e$var$variantTypes = [
    {
        value: "all_variants",
        label: "All variants"
    },
    {
        value: "selected_variants",
        label: "Selected variants"
    },
    {
        value: "sliced_variants",
        label: "Sliced variants"
    }, 
];
let $bbc660d653804c8e$var$optionsAttributes = [];
const $bbc660d653804c8e$export$e1a03751c30c3c65 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        rule: "",
        fromNode: "",
        toNode: "",
        actualCost: 0,
        costType: "",
        variantType: "",
        taskType: ""
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [actualCost, setActualCost] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [costType, setCostType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("total");
    const [taskType, setTaskType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all");
    const [variantType, setVariantType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all_variants");
    const [rule, setRule] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [typeLabel, setTypeLabel] = (0, ($parcel$interopDefault($lR8r2$react))).useState("Actual cost per event");
    const [type, setType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("direct");
    const [attribute, setAttribute] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [mode, setMode] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [ruleID, setRuleID] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    (0, ($parcel$interopDefault($lR8r2$react))).useEffect(()=>{
        $bbc660d653804c8e$var$optionsAttributes = [];
        if (costType === "task") $bbc660d653804c8e$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        else $bbc660d653804c8e$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
        if ($bbc660d653804c8e$var$optionsAttributes && $bbc660d653804c8e$var$optionsAttributes.length > 0) setAttribute($bbc660d653804c8e$var$optionsAttributes[0].value);
    }, []);
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepCostModal, ({ data: data  })=>{
        setIsOpen(true);
        setName(name);
        setData(data);
        setRule(data.rule);
        setVariantType(data.variantType);
        setTaskType(data.taskType);
        setMode(data.mode);
        setRuleID(data.ruleID);
        setCostType(data.costType);
        setActualCost(data.actualCost);
        setAttribute(data.attribute);
        onCostTypeChange(data.costType);
    });
    const min = 0;
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateStepCost({
                    rule: rule,
                    actualCost: Number(actualCost),
                    costType: costType,
                    variantType: variantType,
                    taskType: taskType,
                    fromNode: data.fromNode,
                    toNode: data.toNode,
                    mode: mode,
                    type: "step",
                    ruleID: ruleID,
                    attribute: attribute
                })
        });
    };
    // need to call a method in diagram.js with the source call, from/to node and results
    const onCostTypeChange = (type)=>{
        setCostType(type);
        setType("direct");
        if (type === "total") setTypeLabel("Actual cost per event");
        if (type === "perday") setTypeLabel("Cost per day");
        if (type === "perhour") setTypeLabel("Cost per hour");
        if (type === "perminute") setTypeLabel("Cost per minute");
        if (type === "task") {
            setTypeLabel("Task Attribute");
            setType("attribute");
            $bbc660d653804c8e$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).taskAttributes({});
        }
        if (type === "event") {
            setTypeLabel("Event Attribute");
            setType("attribute");
            $bbc660d653804c8e$var$optionsAttributes = (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventAttributes({});
        }
        if ($bbc660d653804c8e$var$optionsAttributes.length > 0) setAttribute($bbc660d653804c8e$var$optionsAttributes[0].value);
    };
    const onVariantTypeChange = (type)=>{
        setVariantType(type);
    };
    const onTaskTypeChange = (type)=>{
        setTaskType(type);
    };
    const onRuleChange = (event)=>{
        setRule(event.target.value);
    };
    const onAttributeChange = (attribute)=>setAttribute(attribute);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Step Cost Rule",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($bbc660d653804c8e$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Rule"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6e028ceabbe946af$export$7b82fd4c6fe9dc17), {
        multiline: true,
        maxRows: 5,
        value: rule,
        onChange: onRuleChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Variants"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: variantType,
        onChange: onVariantTypeChange,
        options: $bbc660d653804c8e$var$variantTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Tasks"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: taskType,
        onChange: onTaskTypeChange,
        options: $bbc660d653804c8e$var$taskTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Type"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: costType,
        onChange: onCostTypeChange,
        options: $bbc660d653804c8e$var$costTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: typeLabel
    }), type === "direct" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $9d28124c6326106c$export$6bf0cd3a219bbade), {
        label: "",
        value: actualCost,
        onChange: setActualCost,
        min: min
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        options: $bbc660d653804c8e$var$optionsAttributes,
        onChange: onAttributeChange,
        value: attribute
    })));
};




















const $b80cf60d42adb94f$var$Label = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    margin-right: 10px;
    font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("small")};
    color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
`;
const $b80cf60d42adb94f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
    align-items: center;
`;
const $b80cf60d42adb94f$export$6bf0cd3a219bbade = ({ value: value , onChange: onChange = $lR8r2$lodashfp.noop , onBlur: onBlur = $lR8r2$lodashfp.noop , className: className , label: label , min: min , max: max , disabled: disabled ,  })=>{
    const handleOnChange = (event)=>{
        if (event.target.value >= 0) onChange(event.target.value);
    };
    const handleOnBlur = (event)=>{
        const finalValue = Number(event.target.value);
        if (min && finalValue < min) {
            onChange(min);
            return onBlur(min);
        }
        if (max && finalValue > max) {
            onChange(max);
            return onBlur(max);
        }
        onBlur(finalValue);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b80cf60d42adb94f$var$Wrapper, {
        className: className
    }, label && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($b80cf60d42adb94f$var$Label, null, label), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $54d265e55b9d4a6b$export$111e140b0af40b4e), {
        disabled: disabled,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        value: value,
        variant: "outlined",
        type: "number"
    }));
};




const $2f9f29c22baa5c4e$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: flex;
`;
const $2f9f29c22baa5c4e$var$StyledNumberInput = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade))`
    font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
    margin-right: 10px;
`;
const $2f9f29c22baa5c4e$export$bdecb9b8579f40f8 = ()=>{
    let [min, setMinMax] = $lR8r2$react.useState({
        min: 1
    });
    const onChange = $lR8r2$lodashfp.curry((key, value)=>{
        setMinMax({
            ...min,
            [key]: value
        });
    });
    const onBlur = $lR8r2$lodashfp.curry((key, value)=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setMinPercTasks(min);
    });
    $lR8r2$react.useEffect(()=>{}, []);
    return /*#__PURE__*/ $lR8r2$react.createElement($2f9f29c22baa5c4e$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($2f9f29c22baa5c4e$var$StyledNumberInput, {
        label: "Min % of tasks",
        value: min.min,
        onChange: onChange("min"),
        onBlur: onBlur("min")
    }));
};


const $2dddb25edc884394$var$Diagram = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    background-color: ${({ color: color  })=>color};
    width: 600px;
    height: 600px;
    border: hidden;
    canvas {
        outline: none;
    };
    z-index: ${(0, $d18c0fc16613166e$export$9b544f58430fc883)("diagram")};
`;
const $2dddb25edc884394$export$84344b7bdc0e3e8a = ()=>{
    const ref = (0, $lR8r2$react.useRef)();
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        type: "",
        title: "",
        activity: "",
        occurrence: "",
        max_activity_tasks: ""
    });
    const [open, setOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [showCloseIcon, setShowCloseIcon] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [showButtons, setShowButtons] = (0, ($parcel$interopDefault($lR8r2$react))).useState(true);
    const [VisualizerBackground, setVisualizerBackground] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    function onClose() {
        setOpen(false);
    }
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openActivityStepAnalysisModal, ({ data: data  })=>{
        setOpen(true);
        setData(data);
        setVisualizerBackground((0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)());
        const timer = setTimeout(()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).rebuildASA();
        }, 100);
        return ()=>clearTimeout(timer);
    });
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$1f99da106a398c44), {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$8863cf9d79cd26ad), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$579a1e9bab103f15), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$48331a7adc9a636b), null, data.title), showCloseIcon ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$7c8f159da0dc916), {
        onClick: onClose
    }) : /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement("div", null)), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "18px",
            fontWeight: "700",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, data.activity), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, data.occurrence), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $lR8r2$materialuicore.Typography), {
        variant: "caption",
        align: "center",
        sx: {
            color: "#187bcd",
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: "Helvetica"
        },
        component: "div"
    }, data.max_activity_tasks), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$204f681c496365e3), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2dddb25edc884394$var$Diagram, {
        ref: ref,
        id: "gDiagramDivASA",
        color: VisualizerBackground
    })), showButtons && /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $917f5ffe8055011a$export$61905ae62c7860fb), null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $2f9f29c22baa5c4e$export$bdecb9b8579f40f8), null), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $8d06d62a0b2196a7$export$353f5b6fc5456de1), {
        label: "Close",
        onClick: onClose,
        disabled: false
    }))));
};











const $173de3a8088dd694$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    align-items: center;
    grid-gap: 10px;
    width: 400px;
`;
const $173de3a8088dd694$export$111e140b0af40b4e = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.TextField))`

    & .MuiInputBase-root {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }
    }

    & input {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    }
`;
const $173de3a8088dd694$export$f7b64ba084b271c1 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        fromNode: "",
        toNode: "",
        comments: ""
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [comments, setComments] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepCommentsModal, ({ data: data  })=>{
        setIsOpen(true);
        setData(data);
        setComments(data.comments);
    });
    const min = 0;
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateStepComments({
                    comments: comments,
                    fromNode: data.fromNode,
                    toNode: data.toNode,
                    action: "new",
                    type: "step"
                })
        });
    };
    // need to call a method in diagram.js with the source call, from/to node and results
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Step Comment",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($173de3a8088dd694$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($173de3a8088dd694$export$111e140b0af40b4e, {
        id: "outlined-multiline-static",
        label: "Comment",
        multiline: true,
        fullWidth: true,
        onChange: (e)=>setComments(e.target.value),
        rows: 4
    })));
};











const $2296d65e162b0c2f$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    align-items: center;
    grid-gap: 10px;
    width: 400px;
`;
const $2296d65e162b0c2f$export$111e140b0af40b4e = (0, ($parcel$interopDefault($lR8r2$styledcomponents)))((0, $lR8r2$materialuicore.TextField))`

    & .MuiInputBase-root {
        background-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("white")};
        &:hover {
            border-color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("blue")};
        }
    }

    & input {
        color: ${(0, $d18c0fc16613166e$export$5551a2d24ff40153)("inputTextColor")};
        font-family: ${(0, $d18c0fc16613166e$export$c4930fc256cef44f)("helvetica")};
        font-size: ${(0, $d18c0fc16613166e$export$7d055c252aebca58)("smaller")};
    }
`;
const $2296d65e162b0c2f$export$53562de0d697be24 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        activity: "",
        comments: ""
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [comments, setComments] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openActivityCommentsModal, ({ data: data  })=>{
        setIsOpen(true);
        setData(data);
        setComments(data.comments);
    });
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateActivityComments({
                    comments: comments,
                    activity: data.activity,
                    action: "new",
                    type: "activity"
                })
        });
    };
    // need to call a method in diagram.js with the source call, from/to node and results
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Activity Comment",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2296d65e162b0c2f$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($2296d65e162b0c2f$export$111e140b0af40b4e, {
        id: "outlined-multiline-static",
        label: "Comment",
        multiline: true,
        fullWidth: true,
        onChange: (e)=>setComments(e.target.value),
        rows: 4
    })));
};















const $964bca13b6b88988$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
`;
const $964bca13b6b88988$var$Wrapper1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 390px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $964bca13b6b88988$var$Wrapper2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 140px 50px;
    grid-gap: 10px;
    padding: 0px 20px 0px 15px; 
`;
const $964bca13b6b88988$var$WrapperDuration1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $964bca13b6b88988$var$WrapperDuration2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $964bca13b6b88988$var$Wrapper3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 200px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $964bca13b6b88988$var$variantTypes = [
    {
        value: "all_variants",
        label: "All variants"
    },
    {
        value: "selected_variants",
        label: "Selected variants"
    },
    {
        value: "sliced_variants",
        label: "Sliced variants"
    }, 
];
const $964bca13b6b88988$var$taskTypes = [
    {
        value: "all_tasks",
        label: "All"
    },
    {
        value: "filtered_tasks",
        label: "Filtered"
    }, 
];
const $964bca13b6b88988$var$durationOperators = [
    {
        value: "N/A",
        label: "N/A"
    },
    {
        value: "greater than",
        label: "Greater than"
    },
    {
        value: "greater than or is",
        label: "Greater than or is"
    },
    {
        value: "less than",
        label: "Less than"
    },
    {
        value: "less than or is",
        label: "Less than or is"
    },
    {
        value: "equal to",
        label: "Equal to"
    },
    {
        value: "not equal to",
        label: "Not equal to"
    },
    {
        value: "between",
        label: "Between"
    },
    {
        value: "between or is",
        label: "Between or is"
    },
    {
        value: "outside",
        label: "Outside"
    },
    {
        value: "outside or is",
        label: "Outside or is"
    }, 
];
const $964bca13b6b88988$var$durationValues = [
    {
        value: "secs",
        label: "secs"
    },
    {
        value: "mins",
        label: "mins"
    },
    {
        value: "hrs",
        label: "hrs"
    },
    {
        value: "days",
        label: "days"
    }, 
];
const $964bca13b6b88988$export$68c8bebd16efad58 = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        rule: "",
        fromNode: "",
        toNode: "",
        variantType: "",
        taskType: "",
        filterLoops: false,
        calculateCostImpact: false
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [variantType, setvariantType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all_variants");
    const [taskType, setTaskType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all");
    const [rule, setRule] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [filterLoop, setFilterLoop] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [calculateCostImpact, setcalculateCostImpact] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [mode, setMode] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [ruleID, setRuleID] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationOperator, setDurationOperator] = (0, ($parcel$interopDefault($lR8r2$react))).useState("N/A");
    const [durationActualFrom, setDurationActualFrom] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationActualTo, setDurationActualTo] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationValue, setDurationValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("hrs");
    const onRuleChange = (event)=>{
        setRule(event.target.value);
    };
    const onVariantTypeChange = (type)=>{
        setvariantType(type);
    };
    const onTaskTypeChange = (type)=>{
        setTaskType(type);
    };
    const onChangecalculateCostImpact = (e)=>{
        setcalculateCostImpact(e.target.checked);
    };
    const onDurationOperatorChange = (operator)=>{
        setDurationOperator(operator);
    };
    const onDurationValueChange = (value)=>{
        setDurationValue(value);
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepComplianceModal, ({ data: data  })=>{
        setIsOpen(true);
        setName(name);
        setData(data);
        setRule(data.rule);
        setvariantType(data.variantType);
        setTaskType(data.taskType);
        setFilterLoop(data.filterLoops);
        setcalculateCostImpact(data.calculateCostImpact);
        setMode(data.mode);
        setRuleID(data.ruleID);
        setDurationOperator(data.durationOperator);
        setDurationActualFrom(data.durationActualFrom);
        setDurationActualTo(data.durationActualTo);
        setDurationValue(data.durationValue);
    });
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateStepCompliance({
                    rule: rule,
                    fromNode: data.fromNode,
                    toNode: data.toNode,
                    variantType: variantType,
                    taskType: taskType,
                    mode: mode,
                    type: "step",
                    filterLoops: filterLoop,
                    calculateCostImpact: calculateCostImpact,
                    ruleID: ruleID,
                    durationOperator: durationOperator,
                    durationActualFrom: durationActualFrom,
                    durationActualTo: durationActualTo,
                    durationValue: durationValue
                })
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Step Non-Compliance Rule",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$Wrapper1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Rule"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6e028ceabbe946af$export$7b82fd4c6fe9dc17), {
        multiline: true,
        maxRows: 5,
        value: rule,
        onChange: onRuleChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Variants"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: variantType,
        onChange: onVariantTypeChange,
        options: $964bca13b6b88988$var$variantTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Tasks"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: taskType,
        onChange: onTaskTypeChange,
        options: $964bca13b6b88988$var$taskTypes
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$Wrapper2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Duration"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationOperator,
        onChange: onDurationOperatorChange,
        options: $964bca13b6b88988$var$durationOperators
    }), durationOperator === "greater than" || durationOperator === "greater than or is" || durationOperator === "less than" || durationOperator === "less than or is" || durationOperator === "equal to" || durationOperator === "not equal to" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$WrapperDuration1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $964bca13b6b88988$var$durationValues
    })) : "", durationOperator === "between" || durationOperator === "between or is" || durationOperator === "outside" || durationOperator === "outside or is" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$WrapperDuration2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualTo,
        min: 0,
        onChange: setDurationActualTo
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $964bca13b6b88988$var$durationValues
    })) : ""), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($964bca13b6b88988$var$Wrapper3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Calculate cost impact"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: calculateCostImpact,
        handleOnChange: onChangecalculateCostImpact
    }))));
};















const $9a34c24b412ebab8$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
`;
const $9a34c24b412ebab8$var$Wrapper1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 390px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $9a34c24b412ebab8$var$Wrapper2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 140px 50px;
    grid-gap: 10px;
    padding: 0px 20px 0px 15px; 
`;
const $9a34c24b412ebab8$var$WrapperDuration1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $9a34c24b412ebab8$var$WrapperDuration2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $9a34c24b412ebab8$var$Wrapper3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 200px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $9a34c24b412ebab8$var$taskTypes = [
    {
        value: "all_tasks",
        label: "All"
    },
    {
        value: "filtered_tasks",
        label: "Filtered"
    }, 
];
const $9a34c24b412ebab8$var$variantTypes = [
    {
        value: "all_variants",
        label: "All variants"
    },
    {
        value: "selected_variants",
        label: "Selected variants"
    },
    {
        value: "sliced_variants",
        label: "Sliced variants"
    }, 
];
const $9a34c24b412ebab8$var$durationOperators = [
    {
        value: "N/A",
        label: "N/A"
    },
    {
        value: "greater than",
        label: "Greater than"
    },
    {
        value: "greater than or is",
        label: "Greater than or is"
    },
    {
        value: "less than",
        label: "Less than"
    },
    {
        value: "less than or is",
        label: "Less than or is"
    },
    {
        value: "equal to",
        label: "Equal to"
    },
    {
        value: "not equal to",
        label: "Not equal to"
    },
    {
        value: "between",
        label: "Between"
    },
    {
        value: "between or is",
        label: "Between or is"
    },
    {
        value: "outside",
        label: "Outside"
    },
    {
        value: "outside or is",
        label: "Outside or is"
    }, 
];
const $9a34c24b412ebab8$var$durationValues = [
    {
        value: "secs",
        label: "secs"
    },
    {
        value: "mins",
        label: "mins"
    },
    {
        value: "hrs",
        label: "hrs"
    },
    {
        value: "days",
        label: "days"
    }, 
];
const $9a34c24b412ebab8$export$91afd3ea9a7d419d = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        rule: "",
        fromNode: "",
        toNode: "",
        variantType: "",
        taskType: "",
        calculateCostImpact: false
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [taskType, setTaskType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all");
    const [variantType, setVariantType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all_variants");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [rule, setRule] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [calculateCostImpact, setcalculateCostImpact] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [mode, setMode] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [ruleID, setRuleID] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationOperator, setDurationOperator] = (0, ($parcel$interopDefault($lR8r2$react))).useState("N/A");
    const [durationActualFrom, setDurationActualFrom] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationActualTo, setDurationActualTo] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationValue, setDurationValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("hrs");
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepAutomationModal, ({ data: data  })=>{
        setIsOpen(true);
        setName(name);
        setData(data);
        setcalculateCostImpact(data.calculateCostImpact);
        setRule(data.rule);
        setVariantType(data.variantType);
        setTaskType(data.taskType);
        setMode(data.mode);
        setRuleID(data.ruleID);
        setDurationOperator(data.durationOperator);
        setDurationActualFrom(data.durationActualFrom);
        setDurationActualTo(data.durationActualTo);
        setDurationValue(data.durationValue);
    });
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateStepAutomation({
                    rule: rule,
                    variantType: variantType,
                    taskType: taskType,
                    calculateCostImpact: calculateCostImpact,
                    fromNode: data.fromNode,
                    toNode: data.toNode,
                    mode: mode,
                    type: "step",
                    ruleID: ruleID,
                    durationOperator: durationOperator,
                    durationActualFrom: durationActualFrom,
                    durationActualTo: durationActualTo,
                    durationValue: durationValue
                })
        });
    };
    // need to call a method in diagram.js with the source call, from/to node and results
    const onVariantTypeChange = (type)=>{
        setVariantType(type);
    };
    const onTaskTypeChange = (type)=>{
        setTaskType(type);
    };
    const onRuleChange = (event)=>{
        setRule(event.target.value);
    };
    const onChangecalculateCostImpact = (e)=>{
        setcalculateCostImpact(e.target.checked);
    };
    const onDurationValueChange = (value)=>{
        setDurationValue(value);
    };
    const onDurationOperatorChange = (operator)=>{
        setDurationOperator(operator);
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Step Automation Rule",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$Wrapper1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Rule"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6e028ceabbe946af$export$7b82fd4c6fe9dc17), {
        multiline: true,
        maxRows: 5,
        value: rule,
        onChange: onRuleChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Variants"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: variantType,
        onChange: onVariantTypeChange,
        options: $9a34c24b412ebab8$var$variantTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Tasks"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: taskType,
        onChange: onTaskTypeChange,
        options: $9a34c24b412ebab8$var$taskTypes
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$Wrapper2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Duration"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationOperator,
        onChange: onDurationOperatorChange,
        options: $9a34c24b412ebab8$var$durationOperators
    }), durationOperator === "greater than" || durationOperator === "greater than or is" || durationOperator === "less than" || durationOperator === "less than or is" || durationOperator === "equal to" || durationOperator === "not equal to" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$WrapperDuration1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $9a34c24b412ebab8$var$durationValues
    })) : "", durationOperator === "between" || durationOperator === "between or is" || durationOperator === "outside" || durationOperator === "outside or is" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$WrapperDuration2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualTo,
        min: 0,
        onChange: setDurationActualTo
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $9a34c24b412ebab8$var$durationValues
    })) : ""), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($9a34c24b412ebab8$var$Wrapper3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Calculate cost impact"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: calculateCostImpact,
        handleOnChange: onChangecalculateCostImpact
    }))));
};















const $dbc541ead5701bd5$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    box-shadow: ${(0, $d18c0fc16613166e$export$db93b77dbb14f011)("pane")};
`;
const $dbc541ead5701bd5$var$Wrapper1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 390px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $dbc541ead5701bd5$var$Wrapper2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 140px 50px;
    grid-gap: 10px;
    padding: 0px 20px 0px 15px; 
`;
const $dbc541ead5701bd5$var$WrapperDuration1 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $dbc541ead5701bd5$var$WrapperDuration2 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 80px 80px 80px;
    grid-gap: 10px;
    padding: 0px 0px 0px 0px;
`;
const $dbc541ead5701bd5$var$Wrapper3 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 200px;
    grid-gap: 10px;
    padding: 15px 20px 15px 15px;
`;
const $dbc541ead5701bd5$var$Wrapper4 = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    display: grid;
    align-items: center;
    grid-template-columns: 150px 80px 100px;
    grid-gap: 10px;
    padding: 0px 20px 15px 15px;
`;
const $dbc541ead5701bd5$var$variantTypes = [
    {
        value: "all_variants",
        label: "All variants"
    },
    {
        value: "selected_variants",
        label: "Selected variants"
    },
    {
        value: "sliced_variants",
        label: "Sliced variants"
    }, 
];
const $dbc541ead5701bd5$var$taskTypes = [
    {
        value: "all_tasks",
        label: "All"
    },
    {
        value: "filtered_tasks",
        label: "Filtered"
    }, 
];
const $dbc541ead5701bd5$var$durationOperators = [
    {
        value: "N/A",
        label: "N/A"
    },
    {
        value: "greater than",
        label: "Greater than"
    },
    {
        value: "greater than or is",
        label: "Greater than or is"
    },
    {
        value: "less than",
        label: "Less than"
    },
    {
        value: "less than or is",
        label: "Less than or is"
    },
    {
        value: "equal to",
        label: "Equal to"
    },
    {
        value: "not equal to",
        label: "Not equal to"
    },
    {
        value: "between",
        label: "Between"
    },
    {
        value: "between or is",
        label: "Between or is"
    },
    {
        value: "outside",
        label: "Outside"
    },
    {
        value: "outside or is",
        label: "Outside or is"
    }, 
];
const $dbc541ead5701bd5$var$durationValues = [
    {
        value: "secs",
        label: "secs"
    },
    {
        value: "mins",
        label: "mins"
    },
    {
        value: "hrs",
        label: "hrs"
    },
    {
        value: "days",
        label: "days"
    }, 
];
const $dbc541ead5701bd5$var$durationReductionTypes = [
    {
        value: "N/A",
        label: "N/A"
    },
    {
        value: "actual",
        label: "Actual"
    },
    {
        value: "percentage",
        label: "Percentage"
    }, 
];
const $dbc541ead5701bd5$export$229f2d679619a54d = ()=>{
    const [data, setData] = (0, ($parcel$interopDefault($lR8r2$react))).useState({
        rule: "",
        fromNode: "",
        toNode: "",
        variantType: "",
        filterLoops: false,
        calculateCostImpact: false,
        taskType: "",
        durationOperator: "N/A",
        durationActualFrom: 0,
        durationActualTo: 0,
        durationValue: "hrs",
        durationReductionType: "percentage",
        durationReductionPercentage: 100,
        durationReductionActual: 0
    });
    const { setProps: setProps  } = (0, ($parcel$interopDefault($lR8r2$react))).useContext((0, $5613d3e2f55e099d$export$6084d5b08fe90059));
    const [isOpen, setIsOpen] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [variantType, setvariantType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all_variants");
    const [taskType, setTaskType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("all");
    const [rule, setRule] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [name, setName] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [filterLoop, setFilterLoop] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [calculateCostImpact, setcalculateCostImpact] = (0, ($parcel$interopDefault($lR8r2$react))).useState(false);
    const [mode, setMode] = (0, ($parcel$interopDefault($lR8r2$react))).useState("");
    const [ruleID, setRuleID] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationOperator, setDurationOperator] = (0, ($parcel$interopDefault($lR8r2$react))).useState("N/A");
    const [durationActualFrom, setDurationActualFrom] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationActualTo, setDurationActualTo] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationValue, setDurationValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("hrs");
    const [durationReductionType, setDurationReductionType] = (0, ($parcel$interopDefault($lR8r2$react))).useState("percentage");
    const [durationReductionPercentage, setDurationReductionPercentage] = (0, ($parcel$interopDefault($lR8r2$react))).useState(100);
    const [durationReductionActual, setDurationReductionActual] = (0, ($parcel$interopDefault($lR8r2$react))).useState(0);
    const [durationReductionValue, setDurationReductionValue] = (0, ($parcel$interopDefault($lR8r2$react))).useState("hrs");
    const onRuleChange = (event)=>{
        setRule(event.target.value);
    };
    const onVariantTypeChange = (type)=>{
        setvariantType(type);
    };
    const onTaskTypeChange = (type)=>{
        setTaskType(type);
    };
    const onChangecalculateCostImpact = (e)=>{
        setcalculateCostImpact(e.target.checked);
    };
    const onDurationValueChange = (value)=>{
        setDurationValue(value);
    };
    const onDurationReductionValueChange = (value)=>{
        setDurationReductionValue(value);
    };
    const onDurationReductionTypeChange = (type)=>{
        setDurationReductionType(type);
    };
    const onDurationOperatorChange = (operator)=>{
        setDurationOperator(operator);
    };
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).openStepPerformanceModal, ({ data: data  })=>{
        setIsOpen(true);
        setName(name);
        setData(data);
        setRule(data.rule);
        setvariantType(data.variantType);
        setTaskType(data.taskType);
        setFilterLoop(data.filterLoops);
        setMode(data.mode);
        setRuleID(data.ruleID);
        setcalculateCostImpact(data.calculateCostImpact);
        setDurationOperator(data.durationOperator);
        setDurationActualFrom(data.durationActualFrom);
        setDurationActualTo(data.durationActualTo);
        setDurationValue(data.durationValue);
        setDurationReductionType(data.durationReductionType);
        setDurationReductionPercentage(data.durationReductionPercentage);
        setDurationReductionActual(data.durationReductionActual);
        setDurationReductionValue(data.durationReductionValue);
    });
    const onOk = ()=>{
        setProps({
            functionToLoad: ()=>(0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).updateStepPerformance({
                    rule: rule,
                    fromNode: data.fromNode,
                    toNode: data.toNode,
                    variantType: variantType,
                    taskType: taskType,
                    mode: mode,
                    type: "step",
                    filterLoops: filterLoop,
                    calculateCostImpact: calculateCostImpact,
                    durationOperator: durationOperator,
                    durationActualFrom: durationActualFrom,
                    durationActualTo: durationActualTo,
                    durationValue: durationValue,
                    durationReductionType: durationReductionType,
                    durationReductionPercentage: durationReductionPercentage,
                    durationReductionActual: durationReductionActual,
                    durationReductionValue: durationReductionValue,
                    ruleID: ruleID
                })
        });
    };
    return /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $f4387d7f039b34b7$export$2b77a92f1a5ad772), {
        title: "Step Performance Rule",
        open: isOpen,
        onClose: ()=>setIsOpen(false),
        onOk: onOk
    }, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Rule"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $6e028ceabbe946af$export$7b82fd4c6fe9dc17), {
        multiline: true,
        maxRows: 5,
        value: rule,
        onChange: onRuleChange
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Variants"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: variantType,
        onChange: onVariantTypeChange,
        options: $dbc541ead5701bd5$var$variantTypes
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Tasks"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: taskType,
        onChange: onTaskTypeChange,
        options: $dbc541ead5701bd5$var$taskTypes
    })), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Duration"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationOperator,
        onChange: onDurationOperatorChange,
        options: $dbc541ead5701bd5$var$durationOperators
    }), durationOperator === "greater than" || durationOperator === "greater than or is" || durationOperator === "less than" || durationOperator === "less than or is" || durationOperator === "equal to" || durationOperator === "not equal to" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$WrapperDuration1, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $dbc541ead5701bd5$var$durationValues
    })) : "", durationOperator === "between" || durationOperator === "between or is" || durationOperator === "outside" || durationOperator === "outside or is" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$WrapperDuration2, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualFrom,
        min: 0,
        onChange: setDurationActualFrom
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationActualTo,
        min: 0,
        onChange: setDurationActualTo
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationValue,
        onChange: onDurationValueChange,
        options: $dbc541ead5701bd5$var$durationValues
    })) : ""), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper3, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Calculate cost impact"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $1cf61241b06f2a39$export$48513f6b9f8ce62d), {
        label: "",
        checked: calculateCostImpact,
        handleOnChange: onChangecalculateCostImpact
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Duration Reduction"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationReductionType,
        onChange: onDurationReductionTypeChange,
        options: $dbc541ead5701bd5$var$durationReductionTypes
    })), durationReductionType === "percentage" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper4, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Percentage"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationReductionPercentage,
        min: 0,
        max: 100,
        onChange: setDurationReductionPercentage
    })) : "", durationReductionType === "actual" ? /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement($dbc541ead5701bd5$var$Wrapper4, null, /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $359dc7efe367ffee$export$6e2c8f0811a474ce), {
        title: "Actual"
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $b80cf60d42adb94f$export$6bf0cd3a219bbade), {
        label: "",
        value: durationReductionActual,
        min: 0,
        onChange: setDurationReductionActual
    }), /*#__PURE__*/ (0, ($parcel$interopDefault($lR8r2$react))).createElement((0, $957db110bbfa53b5$export$931cbfb6bfb85fc), {
        label: "",
        value: durationReductionValue,
        onChange: onDurationReductionValueChange,
        options: $dbc541ead5701bd5$var$durationValues
    })) : ""));
};
























const $224f21df40d95074$var$useStyles = (0, $lR8r2$materialuistyles.makeStyles)((theme)=>({
        bg_white: {
            backgroundColor: "white"
        },
        bg_transparent: {
            backgroundColor: "transparent"
        },
        icon_LG: {
            color: "#c0c0c0"
        }
    }));
function $224f21df40d95074$export$88c65d2d98aab183() {
    const [diagram, setDiagram] = $lR8r2$react.useState("ProcessVisualizer");
    const classes = $224f21df40d95074$var$useStyles();
    const [taskAttributes, setTaskAttributes] = $lR8r2$react.useState(0);
    const setProcessVisualizer = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessVisualizer({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramProcessVisualizer();
    };
    const setVariantLifecycle = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_VariantLifeCycle({});
    };
    const setTaskLifecycle = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_TaskLifeCycle({});
    };
    const setDecompositionTree = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_DecompositionTree({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramDecompositionTree({});
        setDiagram("DecompositionTree");
    };
    const setInsights = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Insights({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInsights({});
        setDiagram("Insights");
    };
    const setInfluenceAnalysis = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_InfluenceAnalysis({});
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setDiagramInfluenceAnalysis({});
        setDiagram("InfluenceAnalysis");
    };
    const setPerformanceAnalytics = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_PerformanceAnalytics({});
    };
    const setHistogram = ()=>{
        if ((0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).getHistogramType() === "") (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).generateHistogramArray({
            variantPaneVariants: false,
            type: "diagram-tasks",
            variant: 0,
            activity: 0,
            from: 0,
            to: 0
        });
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_Histogram({});
    };
    const setCostRules = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_CostRules({});
    };
    const setProcessRules = ()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).setAction_ProcessRules({});
    };
    $lR8r2$react.useEffect(()=>{
        setTaskAttributes((0, $57e66c5a34f265b4$export$7804c5fe550f3770)());
    }, []);
    $lR8r2$react.useEffect(()=>{
        console.log(taskAttributes);
    }, [
        taskAttributes
    ]);
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_DecompositionTree, ()=>{
        setDiagram("DecompositionTree");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessVisualizer, ()=>{
        setDiagram("ProcessVisualizer");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Insights, ()=>{
        setDiagram("Insights");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_InfluenceAnalysis, ()=>{
        setDiagram("InfluenceAnalysis");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_PerformanceAnalytics, ()=>{
        setDiagram("Analytics");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_Histogram, ()=>{
        setDiagram("Histogram");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_CostRules, ()=>{
        setDiagram("CostRules");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_ProcessRules, ()=>{
        setDiagram("ProcessRules");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_VariantLifeCycle, ()=>{
        setDiagram("VariantLifeCycle");
    });
    (0, $c7729d040ce393f6$export$81992de11aadc815)((0, $4700b7448b206a95$export$d61e24a684f9e51).setActionBar_TaskLifeCycle, ()=>{
        setDiagram("TaskLifeCycle");
    });
    return /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreBox))), {
        justifyContent: "center",
        sx: {
            "& > :not(style)": {
                ml: 1,
                mr: 1,
                mt: 0.5,
                mb: 0.5
            },
            pl: "5px"
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Process Visualizer"),
        placement: "right"
    }, diagram == "ProcessVisualizer" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setProcessVisualizer,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsbs.BsDiagram3), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setProcessVisualizer,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsbs.BsDiagram3), null))), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Variant Lifecycle"),
        placement: "right"
    }, diagram == "VariantLifeCycle" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setVariantLifecycle,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdAlignHorizontalLeft), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setVariantLifecycle,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdAlignHorizontalLeft), null))), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Task Lifecycle"),
        placement: "right"
    }, diagram == "TaskLifeCycle" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setTaskLifecycle,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdOutlineFormatListBulleted), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setTaskLifecycle,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdOutlineFormatListBulleted), null))), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Histogram"),
        placement: "right"
    }, diagram == "Histogram" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setHistogram,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsgi.GiHistogram), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setHistogram,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsgi.GiHistogram), null))), taskAttributes > 0 ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Decomposition Tree"),
        placement: "right"
    }, diagram == "DecompositionTree" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setDecompositionTree,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsri.RiNodeTree), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setDecompositionTree,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsri.RiNodeTree), null))) : "", taskAttributes > 0 ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Insights"),
        placement: "right"
    }, diagram == "Insights" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setInsights,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdMediation), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setInsights,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdMediation), null))) : "", taskAttributes > 0 ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Influencers"),
        placement: "right"
    }, diagram == "InfluenceAnalysis" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setInfluenceAnalysis,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdInsights), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setInfluenceAnalysis,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdInsights), null))) : "", /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Cost Rules"),
        placement: "right"
    }, diagram == "CostRules" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setCostRules,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdAttachMoney), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setCostRules,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdAttachMoney), null))), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "16px"
            }
        }, "Process Rules"),
        placement: "right"
    }, diagram == "ProcessRules" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setProcessRules,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdRule), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setProcessRules,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdRule), null))), /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreTooltip))), {
        title: /*#__PURE__*/ $lR8r2$react.createElement("header", {
            style: {
                fontSize: "12px",
                height: "30px",
                paddingTop: "8px"
            }
        }, "Analytics"),
        placement: "right"
    }, diagram == "Analytics" ? /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setPerformanceAnalytics,
        color: "primary",
        className: classes.bg_white
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdOutlineAnalytics), null)) : /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuicoreIconButton))), {
        onClick: setPerformanceAnalytics,
        color: "primary",
        className: classes.bg_transparent
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $lR8r2$reacticonsmd.MdOutlineAnalytics), null))));
}




const $8d280f8ee94faffb$var$Container = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: 100vh;
    font-family: Helvetica;
`;
const $8d280f8ee94faffb$var$ContainerEL = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    align-items: center;
    justify-content: center;
    margin-left: 62px;
`;
//background-color: rgb(235,235,235);
const $8d280f8ee94faffb$var$Wrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    width: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 62px 1fr;
`;
const $8d280f8ee94faffb$var$LeftWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 1 / 2;
    grid-row: 1 / 1;
    display: flex;
    background-color: ${({ color: color  })=>color};
`;
const $8d280f8ee94faffb$var$RightWrapper = (0, ($parcel$interopDefault($lR8r2$styledcomponents))).div`
    grid-column: 2 / 2;
    grid-row: 1 / 1;
    display: flex;
    align-items: center;
`;
(0, $lR8r2$aggridenterprise.LicenseManager).setLicenseKey("CompanyName=Metricus Pty Ltd,LicensedApplication=Metricus Process Miner,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-017233,ExpiryDate=10_July_2022_[v2]_MTY1NzQwNzYwMDAwMA==5df1c0ba2e23b8a2505daff64ff9ab9f");
const $8d280f8ee94faffb$export$5436e1af25ff39f4 = ({ app: app , eventLogID: eventLogID , modelID: modelID , planTier: planTier , sample: sample  })=>{
    const [isDataLoaded, setIsDataLoaded] = $lR8r2$react.useState(false);
    const [loadEventLog, setLoadEventLog] = $lR8r2$react.useState(true);
    const [VisualizerBackground, setVisualizerBackground] = $lR8r2$react.useState("");
    const [status, setStatus] = $lR8r2$react.useState("Loading");
    const onDragEnd = ([, secondWidth])=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).eventEmitter.emit((0, $4700b7448b206a95$export$d61e24a684f9e51).resizeSidebar, secondWidth);
        (0, $57e66c5a34f265b4$export$fd2a260f23757750)();
    };
    (0, $57e66c5a34f265b4$export$4785aefe9f2fd046)(planTier);
    (0, $57e66c5a34f265b4$export$872b200e9298d34)(sample);
    const loadData = async ()=>{
        if (app == "Metricus") {
            if (eventLogID != undefined && eventLogID !== "") await (0, $57e66c5a34f265b4$export$e665410dcc0a290)(eventLogID);
            if (modelID != undefined && modelID !== "" && modelID !== null) await (0, $57e66c5a34f265b4$export$11749c0dfe75f29d)(modelID);
        }
        if (app == "ServiceNow") {
            setIsDataLoaded(false);
            await (0, $57e66c5a34f265b4$export$413807ec4362a462)();
            await (0, $57e66c5a34f265b4$export$c21b59e6401e02a4)();
        }
        setIsDataLoaded(true);
    };
    $lR8r2$react.useEffect(()=>{
        setVisualizerBackground((0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)());
        if (app == "ServiceNow" || eventLogID != undefined) loadData();
        else {
            setLoadEventLog(false);
            setIsDataLoaded(true);
        }
    }, []);
    $lR8r2$react.useEffect(()=>{
        const listener = ()=>{
            setVisualizerBackground((0, $57e66c5a34f265b4$export$e00e1f0170bc1f06)());
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).changeVisualizerBackgroundColor, listener);
        };
    }, []);
    $lR8r2$react.useEffect(()=>{
        const listener = ()=>{
            setLoadEventLog(true);
        };
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).displayProcessVisualizer, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).displayProcessVisualizer, listener);
        };
    }, []);
    $lR8r2$react.useEffect(()=>{
        const listener = ()=>{
            const status = (0, $57e66c5a34f265b4$export$9dce03151d073bb8)();
            setStatus(status);
            const loaderStatusDiv = document.getElementById("loader-status");
            if (loaderStatusDiv) loaderStatusDiv.innerText = status;
        };
        listener();
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).on((0, $4700b7448b206a95$export$d61e24a684f9e51).updateLoadingStatus, listener);
        return ()=>{
            (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).off((0, $4700b7448b206a95$export$d61e24a684f9e51).updateLoadingStatus, listener);
        };
    }, []);
    if (!isDataLoaded) return /*#__PURE__*/ $lR8r2$react.createElement((0, $72acdb7fe1b25d25$export$7f7cbe89f1eacd2), {
        status: status
    });
    return /*#__PURE__*/ $lR8r2$react.createElement($8d280f8ee94faffb$var$Container, null, !loadEventLog ? /*#__PURE__*/ $lR8r2$react.createElement((0, $b0920c880d6705d6$export$cabd743859ddae78), null) : /*#__PURE__*/ $lR8r2$react.createElement((0, $b64085167b544271$export$c4e96258f3b6511), null), !loadEventLog ? /*#__PURE__*/ $lR8r2$react.createElement($8d280f8ee94faffb$var$ContainerEL, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $46820f204b69ffcd$export$56f2894cea2a586c), null)) : /*#__PURE__*/ $lR8r2$react.createElement($8d280f8ee94faffb$var$Wrapper, null, /*#__PURE__*/ $lR8r2$react.createElement($8d280f8ee94faffb$var$LeftWrapper, {
        color: VisualizerBackground
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $224f21df40d95074$export$88c65d2d98aab183), null)), /*#__PURE__*/ $lR8r2$react.createElement($8d280f8ee94faffb$var$RightWrapper, null, /*#__PURE__*/ $lR8r2$react.createElement((0, $3c57a7dee6df20cd$export$7388fd992834fee3), {
        onDragEnd: onDragEnd
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $bf849ab6e916ed21$export$5b6cb3855aed9ca7), {
        visible: true
    }), /*#__PURE__*/ $lR8r2$react.createElement((0, $2b3431c69e93c3c3$export$1ba59dacbcbf90fe), {
        eventLogID: eventLogID,
        app: app
    })))), /*#__PURE__*/ $lR8r2$react.createElement((0, $ad3c23c99432634d$export$9feb1bc2e5f1ccb3), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $bf84a6073ca402c9$export$8dc6765e8be191c7), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $bbc660d653804c8e$export$e1a03751c30c3c65), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $173de3a8088dd694$export$f7b64ba084b271c1), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $2296d65e162b0c2f$export$53562de0d697be24), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $2dddb25edc884394$export$84344b7bdc0e3e8a), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $964bca13b6b88988$export$68c8bebd16efad58), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $9a34c24b412ebab8$export$91afd3ea9a7d419d), null), /*#__PURE__*/ $lR8r2$react.createElement((0, $dbc541ead5701bd5$export$229f2d679619a54d), null));
};



const $de399161e5c10eb8$export$b6f069a0502ca9d2 = (0, $lR8r2$react.createContext)({
    eventLogID: ""
});



(0, $lR8r2$materialuixgrid.LicenseInfo).setLicenseKey("d540fdde6e43568be05eb7a09b31b647T1JERVI6MjUzNzIsRVhQSVJZPTE2NTM4MDQ2ODYwMDAsS0VZVkVSU0lPTj0x");
const $0e4df6cdcd965f9e$export$58d85c1084ae5c46 = ({ eventLogID: eventLogID , modelID: modelID , planTier: planTier , sample: sample  })=>{
    $lR8r2$react.useEffect(()=>{
        (0, $69a728bfd4f3e5d1$export$5f0d58c189d5640f).resetEventLog();
    }, []);
    return /*#__PURE__*/ $lR8r2$react.createElement((0, $f0bb0c8f14b77164$export$d8964aec282183a3), null, /*#__PURE__*/ $lR8r2$react.createElement((0, $975fb6aa99889f1d$export$ec1233a4138aa651), null, /*#__PURE__*/ $lR8r2$react.createElement((0, ($parcel$interopDefault($lR8r2$materialuilabLocalizationProvider))), {
        dateAdapter: (0, ($parcel$interopDefault($lR8r2$materialuilabAdapterMoment)))
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $d86a247d67d6d1e1$export$a64bcbaadc0edfa9), null, /*#__PURE__*/ $lR8r2$react.createElement((0, $5613d3e2f55e099d$export$8b8375aa394c2d86), null, /*#__PURE__*/ $lR8r2$react.createElement((0, $de399161e5c10eb8$export$b6f069a0502ca9d2).Provider, {
        value: {
            eventLogID: eventLogID
        }
    }, /*#__PURE__*/ $lR8r2$react.createElement((0, $8d280f8ee94faffb$export$5436e1af25ff39f4), {
        app: "Metricus",
        eventLogID: eventLogID,
        modelID: modelID,
        planTier: planTier,
        sample: sample
    })))))));
};




